import { ArrowForwardIosRounded, ArrowBackIos, KeyboardDoubleArrowRightRounded, Tune, KeyboardDoubleArrowLeftRounded, Clear, Check, Close } from '@mui/icons-material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import CircularProgress from '@mui/material/CircularProgress';
import { createTheme, styled, alpha, useThemeProps, useTheme, ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import React__default, { forwardRef, useContext, useState, useRef, useEffect, Children, useCallback, isValidElement, useLayoutEffect, useMemo, createContext, useReducer, useDebugValue, memo, cloneElement, Fragment as Fragment$1, useImperativeHandle, createRef, Component, createElement } from 'react';
import tokens from '@dnb-uux-design-system/design-tokens';
import Typography from '@mui/material/Typography';
import MuiBadge from '@mui/material/Badge';
import MuiAlert from '@mui/material/Alert';
import { ClickAwayListener, ToggleButton, SvgIcon, tooltipClasses as tooltipClasses$1, generateUtilityClasses as generateUtilityClasses$1, generateUtilityClass as generateUtilityClass$1, unstable_composeClasses, Box, Skeleton, styled as styled$1, CircularProgress as CircularProgress$1 } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import classNames from 'classnames';
import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import MuiButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MuiCard from '@mui/material/Card';
import MuiCardActionArea from '@mui/material/CardActionArea';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Stack from '@mui/material/Stack';
import { useGridApiContext, useGridSelector, gridColumnDefinitionsSelector, gridColumnVisibilityModelSelector, useGridRootProps, gridRowGroupingSanitizedModelSelector, GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD, GridColumnMenuContainer, GridColumnMenuSortItem, gridClasses, GridPanel, GridToolbarContainer, GridPreferencePanelsValue, DataGridPremium } from '@mui/x-data-grid-premium';
import MuiTablePagination from '@mui/material/TablePagination';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import MuiBox from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import MuiDivider from '@mui/material/Divider';
import MuiAutocomplete from '@mui/material/Autocomplete';
import MuiTextField from '@mui/material/TextField';
import MuiInputLabel from '@mui/material/InputLabel';
import { jsx, jsxs } from 'react/jsx-runtime';
import ReactDOM__default, { createPortal } from 'react-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon$1 from '@mui/icons-material/Check';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import MuiCheckbox from '@mui/material/Checkbox';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import MuiFormHelperText from '@mui/material/FormHelperText';
import MuiFormControl from '@mui/material/FormControl';
import MuiFormGroup from '@mui/material/FormGroup';
import MuiFormLabel from '@mui/material/FormLabel';
import MuiRadio from '@mui/material/Radio';
import MuiRadioGroup from '@mui/material/RadioGroup';
import MuiSwitch from '@mui/material/Switch';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ExpandIcon from '@mui/icons-material/Expand';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import MuiCollapse from '@mui/material/Collapse';
import MuiList from '@mui/material/List';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import MuiListItemText from '@mui/material/ListItemText';
import MuiMenuItem from '@mui/material/MenuItem';
import VerticalAlignCenterIcon from '@mui/icons-material/VerticalAlignCenter';
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import Fade from '@mui/material/Fade';
import ButtonBase from '@mui/material/ButtonBase';
import { useForkRef as useForkRef$1, useControlled, createSvgIcon, capitalize, useEventCallback, ownerDocument as ownerDocument$1 } from '@mui/material/utils';
import '@mui/material/Skeleton';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper$1 from '@mui/material/Popper';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Dialog, { dialogClasses } from '@mui/material/Dialog';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useLicenseVerifier, Watermark, LicenseInfo } from '@mui/x-license-pro';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import DialogTitle from '@mui/material/DialogTitle';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import Link from '@mui/material/Link';
import MuiBackdrop from '@mui/material/Backdrop';
import Lottie from 'lottie-react';
import Menu from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import KeyboardDoubleArrowLeftRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftRounded';
import KeyboardDoubleArrowRightRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowRightRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ClickAwayListener$1 from '@mui/material/ClickAwayListener';
import MuiSlider, { SliderThumb } from '@mui/material/Slider';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import MuiErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import MuiStep from '@mui/material/Step';
import MuiStepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import MuiStepContent from '@mui/material/StepContent';
import MuiStepLabel, { stepLabelClasses } from '@mui/material/StepLabel';
import MuiStepper, { stepperClasses } from '@mui/material/Stepper';
import MuiChip from '@mui/material/Chip';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { KeyboardArrowUpRounded, KeyboardArrowDownRounded } from '@mui/icons-material/';
import { TreeView } from '@mui/x-tree-view/TreeView';
import CssBaseline from '@mui/material/CssBaseline';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var TokenTypography = tokens.TokenTypography;
var AvenirCSSFontFaces = "\n/* Avenir Light */\n@font-face {\n    font-family: " + TokenTypography.FontFamilySansSerif + ";\n    font-weight: " + TokenTypography.FontWeightAvenirLight + ";\n\n    src: url(data:application/x-font-woff;base64,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) format('woff');\n}\n\n/* Avenir Roman */\n@font-face {\n    font-family: " + TokenTypography.FontFamilySansSerif + ";\n    font-weight: " + TokenTypography.FontWeightAvenirRoman + ";\n\n    src: url(data:application/x-font-woff;base64,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) format('woff');\n}\n\n/* Avenir Medium */\n@font-face {\n    font-family: " + TokenTypography.FontFamilySansSerif + ";\n    font-weight: " + TokenTypography.FontWeightAvenirMedium + ";\n\n    src: url(data:application/x-font-woff;base64,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) format('woff');\n}\n\n/* Avenir Heavy */\n@font-face {\n    font-family: " + TokenTypography.FontFamilySansSerif + ";\n    font-weight: " + TokenTypography.FontWeightAvenirHeavy + ";\n\n    src: url(data:application/x-font-woff;base64,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) format('woff');\n}\n";

var TokenColors = tokens.TokenColors,
  TokenTypography$1 = tokens.TokenTypography;
var theme = createTheme({
  breakpoints: {
    unit: 'px',
    step: 5,
    values: {
      xs: 0,
      sm: 601,
      md: 1025,
      lg: 1201,
      xl: 1537
    }
  },
  palette: {
    text: {
      primary: TokenColors.ColorGrayPrimary,
      secondary: TokenColors.ColorGraySecondary,
      disabled: TokenColors.ColorGraySecondary
    },
    primary: {
      main: TokenColors.ColorPrimaryBlueInteractive
    },
    secondary: {
      main: TokenColors.ColorSecondaryBlueBrandLight
    },
    info: {
      main: TokenColors.ColorNotificationInfo
    },
    success: {
      main: TokenColors.ColorNotificationSuccess
    },
    error: {
      main: TokenColors.ColorNotificationError
    },
    warning: {
      main: TokenColors.ColorNotificationWarning
    }
  },
  spacing: function spacing(factor) {
    return 0.4 * factor + "rem";
  },
  colors: _extends({}, tokens.TokenColors),
  boxShadows: _extends({}, tokens.TokenShadows),
  borders: _extends({}, tokens.TokenBorders),
  opacity: _extends({}, tokens.TokenOpacity),
  sizing: _extends({}, tokens.TokenSizing),
  typography: _extends({
    fontFamily: TokenTypography$1.FontFamilySansSerif,
    fontSize: 16,
    htmlFontSize: 10,
    fontWeightLight: parseInt(TokenTypography$1.FontWeightAvenirLight),
    fontWeightRegular: parseInt(TokenTypography$1.FontWeightAvenirRoman),
    fontWeightMedium: parseInt(TokenTypography$1.FontWeightAvenirMedium),
    fontWeightBold: parseInt(TokenTypography$1.FontWeightAvenirHeavy),
    body: {
      fontSize: tokens.TokenTypography.FontSizeBody,
      lineHeight: tokens.TokenTypography.FontLineHeightBody,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirRoman),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingBody
    },
    body1: {
      fontSize: tokens.TokenTypography.FontSizeBody,
      lineHeight: tokens.TokenTypography.FontLineHeightBody,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirRoman),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingBody
    },
    body2: {
      fontSize: tokens.TokenTypography.FontSizeCompact,
      lineHeight: tokens.TokenTypography.FontLineHeightCompact,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirRoman),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingCompact
    },
    h1: {
      fontSize: tokens.TokenTypography.FontSizeHeadline1,
      lineHeight: tokens.TokenTypography.FontLineHeightHeadline1,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirMedium),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingHeadline1
    },
    h2: {
      fontSize: tokens.TokenTypography.FontSizeHeadline2,
      lineHeight: tokens.TokenTypography.FontLineHeightHeadline2,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirMedium),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingHeadline2
    },
    h3: {
      fontSize: tokens.TokenTypography.FontSizeHeadline3,
      lineHeight: tokens.TokenTypography.FontLineHeightHeadline3,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirMedium),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingHeadline3
    },
    h4: {
      fontSize: tokens.TokenTypography.FontSizeHeadline4,
      lineHeight: tokens.TokenTypography.FontLineHeightHeadline4,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirMedium),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingHeadline4
    },
    h5: {
      fontSize: tokens.TokenTypography.FontSizeHeadline5,
      lineHeight: tokens.TokenTypography.FontLineHeightHeadline5,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirMedium),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingHeadline5
    },
    h6: {
      fontSize: tokens.TokenTypography.FontSizeHeadline6,
      lineHeight: tokens.TokenTypography.FontLineHeightHeadline6,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirMedium),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingHeadline6
    },
    subtitle1: {
      fontSize: tokens.TokenTypography.FontSizeSubtitle1,
      lineHeight: tokens.TokenTypography.FontLineHeightSubtitle1,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirHeavy),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingSubtitle1
    },
    subtitle2: {
      fontSize: tokens.TokenTypography.FontSizeSubtitle2,
      lineHeight: tokens.TokenTypography.FontLineHeightSubtitle2,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirMedium),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingSubtitle2
    },
    overline: {
      fontSize: tokens.TokenTypography.FontSizeOverline,
      lineHeight: tokens.TokenTypography.FontLineHeightOverline,
      letterSpacing: tokens.TokenTypography.FontLetterSpacingOverline
    },
    caption: {
      fontSize: tokens.TokenTypography.FontSizeCaption,
      lineHeight: tokens.TokenTypography.FontLineHeightCaption,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirRoman),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingCaption
    },
    'body-bold': {
      fontSize: tokens.TokenTypography.FontSizeBody,
      lineHeight: tokens.TokenTypography.FontLineHeightBody,
      fontWeight: parseInt(tokens.TokenTypography.FontWeightAvenirHeavy),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingCompact
    },
    'compact-body': {
      fontSize: tokens.TokenTypography.FontSizeCompact,
      lineHeight: tokens.TokenTypography.FontLineHeightCompact,
      fontWeight: parseInt(TokenTypography$1.FontWeightAvenirRoman),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingCompact
    },
    'compact-bold': {
      fontSize: tokens.TokenTypography.FontSizeCompact,
      lineHeight: tokens.TokenTypography.FontLineHeightCompact,
      fontWeight: parseInt(tokens.TokenTypography.FontWeightAvenirHeavy),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingCompact
    },
    'compact-medium': {
      fontSize: tokens.TokenTypography.FontSizeCompact,
      lineHeight: tokens.TokenTypography.FontLineHeightCompact,
      fontWeight: parseInt(tokens.TokenTypography.FontWeightAvenirMedium),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingCompact
    },
    'caption-bold': {
      fontSize: tokens.TokenTypography.FontSizeCaption,
      lineHeight: tokens.TokenTypography.FontLineHeightCaption,
      fontWeight: parseInt(tokens.TokenTypography.FontWeightAvenirHeavy),
      letterSpacing: tokens.TokenTypography.FontLetterSpacingCaption
    }
  }, tokens.TokenTypography),
  components: {
    MuiCssBaseline: {
      styleOverrides: "\n\t\t\t\t" + AvenirCSSFontFaces + "\n                input, textarea, button { font-family: inherit; font-weight: inherit; }\n\n                html {\n                    font-size: 62.5%; /* 62.5% of 16px = 10px */\n                  }\n\t\t\t"
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiButton: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiButtonGroup: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiFab: {
      defaultProps: {
        disableRipple: true
      }
    }
  }
});

var _excluded = ["children", "variant", "component"];
var variantToMuiMapping = function variantToMuiMapping(dnbVariant) {
  var map = {
    body: {
      muiVariant: 'body1'
    },
    h1: {
      muiVariant: 'h1'
    },
    h2: {
      muiVariant: 'h2'
    },
    h3: {
      muiVariant: 'h3'
    },
    h4: {
      muiVariant: 'h4'
    },
    h5: {
      muiVariant: 'h5'
    },
    h6: {
      muiVariant: 'h6'
    },
    compact: {
      muiVariant: 'body2'
    },
    subtitle1: {
      muiVariant: 'subtitle1'
    },
    subtitle2: {
      muiVariant: 'subtitle2'
    },
    overline: {
      muiVariant: 'overline'
    },
    caption: {
      muiVariant: 'caption'
    },
    'body-bold': {
      muiVariant: 'body-bold',
      component: 'p'
    },
    'compact-body': {
      muiVariant: 'compact-body'
    },
    'compact-bold': {
      muiVariant: 'compact-bold'
    },
    'compact-medium': {
      muiVariant: 'compact-medium'
    },
    'caption-bold': {
      muiVariant: 'caption-bold'
    }
  };
  return map[dnbVariant] || map['body'];
};
var DNBTypography = function DNBTypography(props) {
  var _ref;
  var children = props.children,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'body' : _props$variant,
    component = props.component,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var mappedVariant = variantToMuiMapping(variant);
  return React__default.createElement(Typography, Object.assign({
    variant: mappedVariant.muiVariant,
    component: (_ref = component != null ? component : mappedVariant.component) != null ? _ref : undefined
  }, rest), children);
};

var _excluded$1 = ["children", "iconPosition", "isLoading", "secondaryTitle", "size", "title", "primaryTitle"];
var getSpacing = function getSpacing(size) {
  var _theme$typography$Fon, _theme$typography$Fon2, _theme$typography$Fon3;
  switch (size) {
    case 'large':
      return {
        arrowSize: (_theme$typography$Fon = theme.typography.FontSizeBody) != null ? _theme$typography$Fon : theme.spacing(4),
        iconWrapper: theme.spacing(8),
        left: theme.spacing(5),
        right: theme.spacing(3),
        maxHeight: theme.spacing(15),
        titleVariant: 'h6',
        secondaryTitleVariant: 'body',
        summaryHeight: theme.sizing.SizingComponentXLarge
      };
    case 'compact':
      return {
        arrowSize: (_theme$typography$Fon2 = theme.typography.FontSizeCaption) != null ? _theme$typography$Fon2 : theme.spacing(3),
        iconWrapper: theme.spacing(5),
        left: theme.spacing(3),
        right: theme.spacing(2),
        maxHeight: theme.spacing(15),
        titleVariant: 'compact-medium',
        secondaryTitleVariant: 'compact-body',
        summaryHeight: theme.sizing.SizingComponentCompact
      };
    case 'default':
    default:
      return {
        arrowSize: (_theme$typography$Fon3 = theme.typography.FontSizeCompact) != null ? _theme$typography$Fon3 : theme.spacing(3),
        iconWrapper: theme.spacing(6),
        left: theme.spacing(4),
        right: theme.spacing(3),
        maxHeight: theme.spacing(18),
        titleVariant: 'subtitle2',
        secondaryTitleVariant: 'body',
        summaryHeight: theme.sizing.SizingComponentDefault
      };
  }
};
var StyledMuiAccordion = styled(MuiAccordion)(function (_ref) {
  var theme = _ref.theme;
  return {
    borderTop: theme.borders.BorderThin + " " + theme.palette.divider,
    borderRight: 'none',
    borderBottom: 'none',
    borderLeft: 'none',
    boxShadow: 'none',
    color: theme.colors.ColorGrayPrimary,
    '&:hover': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
    },
    '&:active': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha2
    },
    '&.Mui-disabled': {
      backgroundColor: theme.colors.ColorBackgroundWhite,
      opacity: theme.opacity.OpacityDisabled
    }
  };
});
var StyledMuiAccordionSummary = styled(MuiAccordionSummary, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'iconPosition' && prop !== 'size';
  }
})(function (_ref2) {
  var iconPosition = _ref2.iconPosition,
    size = _ref2.size,
    theme = _ref2.theme;
  return {
    flexDirection: iconPosition === 'left' ? 'row-reverse' : 'row',
    height: getSpacing(size).summaryHeight,
    minHeight: getSpacing(size).summaryHeight,
    paddingLeft: getSpacing(size).left,
    paddingRight: getSpacing(size).right,
    '& .MuiAccordionSummary-expandIconWrapper': {
      height: getSpacing(size).iconWrapper,
      width: getSpacing(size).iconWrapper,
      transform: 'rotate(90deg)',
      '&.Mui-expanded': {
        transform: 'rotate(-90deg)'
      }
    },
    '& .MuiAccordionSummary-content': {
      alignItems: 'center',
      marginLeft: iconPosition === 'left' ? theme.spacing(2) : '0'
    }
  };
});
var StyledMuiAccordionDetails = styled(MuiAccordionDetails, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'iconPosition' && prop !== 'size';
  }
})(function (_ref3) {
  var iconPosition = _ref3.iconPosition,
    size = _ref3.size,
    theme = _ref3.theme;
  return {
    paddingTop: theme.spacing(2),
    paddingLeft: iconPosition === 'left' ? "calc(\n                          " + getSpacing(size).left + " +\n                              " + theme.spacing(2) + " +\n                              " + getSpacing(size).iconWrapper + "\n                      )" : getSpacing(size).left,
    paddingBottom: theme.spacing(6)
  };
});
var StyledDNBTypographyTitle = styled(DNBTypography)(function () {
  return {
    margin: 0,
    flexShrink: 0,
    width: '60%'
  };
});
var StyledDNBTypographySecondaryTitle = styled(DNBTypography)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.colors.ColorGraySecondary
  };
});
var StyledMuiArrowIcon = styled(ArrowForwardIosRounded)(function (_ref5) {
  var size = _ref5.size;
  return {
    fontSize: getSpacing(size).arrowSize,
    margin: 'auto'
  };
});
var DNBAccordion = function DNBAccordion(_ref6) {
  var children = _ref6.children,
    _ref6$iconPosition = _ref6.iconPosition,
    iconPosition = _ref6$iconPosition === void 0 ? 'right' : _ref6$iconPosition,
    _ref6$isLoading = _ref6.isLoading,
    isLoading = _ref6$isLoading === void 0 ? false : _ref6$isLoading,
    secondaryTitle = _ref6.secondaryTitle,
    _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? 'default' : _ref6$size,
    title = _ref6.title,
    _ref6$primaryTitle = _ref6.primaryTitle,
    primaryTitle = _ref6$primaryTitle === void 0 ? title : _ref6$primaryTitle,
    rest = _objectWithoutPropertiesLoose(_ref6, _excluded$1);
  return React__default.createElement(StyledMuiAccordion, Object.assign({
    elevation: 0,
    disableGutters: true,
    square: true,
    title: title
  }, rest), React__default.createElement(StyledMuiAccordionSummary, {
    iconPosition: iconPosition,
    expandIcon: isLoading ? React__default.createElement(CircularProgress, {
      "aria-label": "circular progress bar",
      variant: 'indeterminate',
      size: getSpacing(size).iconWrapper
    }) : React__default.createElement(StyledMuiArrowIcon, {
      size: size
    }),
    size: size
  }, typeof primaryTitle === 'string' ? React__default.createElement(StyledDNBTypographyTitle, {
    variant: getSpacing(size).titleVariant,
    paragraph: true
  }, primaryTitle) : primaryTitle, React__default.createElement(StyledDNBTypographySecondaryTitle, {
    variant: getSpacing(size).secondaryTitleVariant
  }, secondaryTitle)), React__default.createElement(StyledMuiAccordionDetails, {
    iconPosition: iconPosition,
    size: size
  }, children));
};

var _excluded$2 = ["variant", "count", "children", "max"];
var StyledMuiBadge = styled(MuiBadge)(function (_ref) {
  var theme = _ref.theme;
  return {
    '.MuiBadge-colorWarning': {
      backgroundColor: theme.colors.ColorNotificationError,
      fontWeight: 700,
      fontSize: theme.typography.FontSizeCaption
    }
  };
});
var truncateCount = function truncateCount(count) {
  return new Intl.NumberFormat(undefined, {
    notation: 'compact',
    compactDisplay: 'short'
  }).format(count);
};
var countFormatted = function countFormatted(count, max) {
  if (!count) {
    return;
  }
  return count < (max || Infinity) ? truncateCount(count) : count;
};
var DNBBadge = function DNBBadge(props) {
  var variant = props.variant,
    count = props.count,
    children = props.children,
    _props$max = props.max,
    max = _props$max === void 0 ? 10000000 : _props$max,
    rest = _objectWithoutPropertiesLoose(props, _excluded$2);
  return React__default.createElement(StyledMuiBadge, Object.assign({
    variant: variant ? variant : 'standard',
    badgeContent: countFormatted(count, max),
    color: "warning",
    max: max
  }, rest), children);
};

var StyledMuiBanner = styled(MuiAlert)(function (_ref) {
  var theme = _ref.theme;
  return {
    borderRadius: theme.spacing(2),
    color: theme.colors.ColorGrayPrimary,
    '&.MuiAlert-outlinedSuccess': {
      borderColor: theme.colors.ColorNotificationSuccess,
      backgroundColor: theme.colors.ColorNotificationSuccessAlpha1
    },
    '&.MuiAlert-outlinedWarning': {
      borderColor: theme.colors.ColorNotificationWarning,
      backgroundColor: theme.colors.ColorNotificationWarningAlpha1
    },
    '&.MuiAlert-outlinedInfo': {
      borderColor: theme.colors.ColorPrimaryBlue,
      backgroundColor: theme.colors.ColorPrimaryBlueAlpha1
    },
    '&.MuiAlert-outlinedError': {
      borderColor: theme.colors.ColorNotificationError,
      backgroundColor: theme.colors.ColorNotificationErrorAlpha1
    },
    '& .MuiAlert-icon': {
      padding: theme.spacing(1) + " " + theme.spacing(0)
    },
    '& .MuiAlert-message': {
      padding: theme.spacing(1) + " " + theme.spacing(0)
    },
    '& .MuiAlert-action': {
      paddingTop: theme.spacing(0)
    },
    '& .MuiButtonBase-root': {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1)
    }
  };
});
var DNBBanner = function DNBBanner(props) {
  var children = props.children;
  return React__default.createElement(StyledMuiBanner, Object.assign({
    variant: "outlined"
  }, props), children);
};

var _excluded$3 = ["className", "children"],
  _excluded2 = ["children", "content"];
var StyledTooltip = styled(function (_ref) {
  var className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return React__default.createElement(MuiTooltip, Object.assign({}, rest, {
    classes: {
      popper: className
    }
  }), children);
})(function (_ref2) {
  var _ref3;
  var theme = _ref2.theme;
  return _ref3 = {}, _ref3["& ." + tooltipClasses.arrow] = {
    color: theme.colors.ColorGrayPrimary,
    '&::before': {
      boxShadow: theme.boxShadows.ShadowPlus1
    }
  }, _ref3["& ." + tooltipClasses.tooltip] = {
    backgroundColor: theme.colors.ColorGrayPrimary,
    boxShadow: theme.boxShadows.ShadowPlus1,
    borderRadius: theme.borders.BorderRadiusDefault,
    color: theme.colors.ColorBackgroundWhite,
    maxWidth: 216
  }, _ref3;
});
var DNBTooltip = function DNBTooltip(_ref4) {
  var children = _ref4.children,
    content = _ref4.content,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded2);
  return React__default.createElement(StyledTooltip, Object.assign({
    title: content
  }, rest), children);
};

var DNBButtonGroupContext = React__default.createContext({});

var ColorMap = new Map([['prime', 'primary'], ['primary', 'primary'], ['secondary', 'primary'], ['text', 'primary'], ['destructive', 'error']]);
var SizeMap = new Map([['default', 'large'], ['compact', 'medium'], ['small', 'small']]);
var VariantMap = new Map([['prime', 'contained'], ['primary', 'contained'], ['secondary', 'outlined'], ['text', 'text'], ['destructive', 'contained']]);

var _templateObject;
var StyledMuiButton = styled(Button)(function (_ref) {
  var theme = _ref.theme;
  return {
    boxShadow: 'none',
    fontFamily: theme.typography.FontFamilySansSerif,
    fontWeight: theme.typography.FontWeightAvenirMedium,
    textTransform: 'none',
    '&.Mui-disabled': {
      opacity: theme.opacity.OpacityDisabled
    },
    '&:focus': {
      outlineWidth: theme.borders.BorderOutline,
      outlineColor: theme.colors.ColorPrimaryBlue,
      outlineStyle: theme.borders.BorderSolid
    },
    '&.MuiButton': {
      '&-contained': {
        color: theme.colors.ColorBackgroundWhite
      },
      '&-containedPrimary': {
        backgroundColor: theme.colors.ColorPrimaryBlueInteractive,
        '&:hover': {
          backgroundImage: "linear-gradient(0, " + theme.colors.ColorBackgroundWhiteAlpha1 + ", " + theme.colors.ColorBackgroundWhiteAlpha1 + " 100%)"
        },
        '&:active': {
          backgroundImage: "linear-gradient(0, " + theme.colors.ColorBackgroundWhiteAlpha2 + ", " + theme.colors.ColorBackgroundWhiteAlpha2 + " 100%)"
        },
        '&.Mui-disabled': {
          backgroundColor: theme.colors.ColorPrimaryBlueInteractive,
          color: theme.colors.ColorBackgroundWhite
        }
      },
      '&-containedError': {
        '&:hover': {
          backgroundImage: "linear-gradient(0, " + theme.colors.ColorBackgroundWhiteAlpha1 + ", " + theme.colors.ColorBackgroundWhiteAlpha1 + " 100%)"
        },
        '&:active': {
          backgroundImage: "linear-gradient(0, " + theme.colors.ColorBackgroundWhiteAlpha2 + ", " + theme.colors.ColorBackgroundWhiteAlpha2 + " 100%)"
        },
        '&.Mui-disabled': {
          backgroundColor: theme.colors.ColorNotificationError,
          color: theme.colors.ColorBackgroundWhite
        }
      },
      '&-outlined': {
        borderColor: theme.colors.ColorPrimaryBlueInteractive,
        color: theme.colors.ColorPrimaryBlueInteractive,
        '&:hover': {
          backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha1
        },
        '&:active': {
          backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha2
        },
        '&.Mui-disabled': {
          borderColor: theme.colors.ColorPrimaryBlueInteractive,
          color: theme.colors.ColorPrimaryBlueInteractive
        }
      },
      '&-text': {
        color: theme.colors.ColorPrimaryBlueInteractive,
        textDecoration: 'underline',
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha1,
          textDecoration: 'underline'
        },
        '&:active': {
          backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha2
        }
      },
      '&.Mui-disabled': {
        borderColor: theme.colors.ColorPrimaryBlueInteractive,
        color: theme.colors.ColorPrimaryBlueInteractive
      },
      '&-sizeLarge': {
        borderRadius: theme.borders.BorderRadiusDefault,
        height: theme.spacing(11),
        padding: theme.spacing(2) + " " + theme.spacing(4),
        fontSize: theme.typography.FontSizeSubtitle2
      },
      '&-sizeMedium': {
        borderRadius: theme.borders.BorderRadiusCompact,
        height: theme.spacing(9),
        padding: theme.spacing(2) + " " + theme.spacing(3),
        fontSize: theme.typography.FontSizeCompact
      },
      '&-sizeSmall': {
        borderRadius: theme.borders.BorderRadiusSmall,
        height: theme.spacing(8),
        padding: theme.spacing(2) + " " + theme.spacing(2),
        fontSize: theme.typography.FontSizeCompact
      },
      '&-prime': {
        height: theme.spacing(12),
        padding: theme.spacing(2) + " " + theme.spacing(6),
        borderRadius: theme.spacing(6)
      },
      '&-disabled, &-loading': {
        pointerEvents: 'none'
      },
      '&-containedPrimary .MuiCircularProgress-root, &-containedError .MuiCircularProgress-root': {
        color: theme.colors.ColorBackgroundWhite
      }
    },
    '&:hover, &:active': {
      outline: 'none'
    },
    '&:hover': {
      '&.MuiButton-containedPrimary': {
        backgroundColor: theme.colors.ColorPrimaryBlueInteractive
      },
      '&.MuiButton-containedPrimary, &.MuiButton-outlined': {
        boxShadow: theme.boxShadows.ShadowPlus1
      }
    },
    '& .MuiButton-startIcon:only-child, & .MuiButton-endIcon:only-child': {
      margin: 0
    }
  };
});
var StyledSpan = styled('span')(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])));

var _excluded$4 = ["children"],
  _excluded2$1 = ["endIcon", "isLoading", "loadingProgress", "size", "startIcon", "variant"];
var getVariantColor = function getVariantColor(variant) {
  return ColorMap.get(variant);
};
var getVariant = function getVariant(variant) {
  return VariantMap.get(variant);
};
var getSize = function getSize(size) {
  return SizeMap.get(size);
};
var resolveProps = function resolveProps(defaultProps, props) {
  var output = _extends({}, props);
  Object.keys(defaultProps).forEach(function (propName) {
    if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
};
var DNBButton = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var contextProps = useContext(DNBButtonGroupContext);
  var _useState = useState(false),
    showTooltip = _useState[0],
    setShowTooltip = _useState[1];
  var styledSpanRef = useRef(null);
  var resolvedProps = resolveProps(contextProps, props);
  var endIcon = resolvedProps.endIcon,
    _resolvedProps$isLoad = resolvedProps.isLoading,
    isLoading = _resolvedProps$isLoad === void 0 ? false : _resolvedProps$isLoad,
    _resolvedProps$loadin = resolvedProps.loadingProgress,
    loadingProgress = _resolvedProps$loadin === void 0 ? undefined : _resolvedProps$loadin,
    _resolvedProps$size = resolvedProps.size,
    size = _resolvedProps$size === void 0 ? 'default' : _resolvedProps$size,
    startIcon = resolvedProps.startIcon,
    _resolvedProps$varian = resolvedProps.variant,
    variant = _resolvedProps$varian === void 0 ? 'primary' : _resolvedProps$varian,
    rest = _objectWithoutPropertiesLoose(resolvedProps, _excluded2$1);
  var muiColor = getVariantColor(variant);
  var muiVariant = getVariant(variant);
  var muiSize = getSize(size);
  var progressBarVariant = loadingProgress ? 'determinate' : 'indeterminate';
  var progressBarSize = size === 'default' ? theme.spacing(6) : theme.spacing(5);
  var buttonContent = children;
  var className = classNames({
    'MuiButton-prime': variant === 'prime',
    'MuiButton-loading': isLoading
  });
  useEffect(function () {
    var current = styledSpanRef.current;
    var resizeObserver = new ResizeObserver(function () {
      if (current !== null) {
        setShowTooltip(current.scrollWidth > current.clientWidth);
      }
    });
    if (current !== null) {
      resizeObserver.observe(current);
    }
    return function () {
      resizeObserver.disconnect();
    };
  }, []);
  return React__default.createElement(DNBTooltip, {
    arrow: true,
    content: showTooltip && typeof buttonContent === 'string' && React__default.createElement(DNBTypography, {
      variant: "compact-body"
    }, buttonContent)
  }, React__default.createElement("span", null, React__default.createElement(StyledMuiButton, Object.assign({
    className: className,
    color: muiColor,
    ref: ref,
    size: muiSize,
    variant: muiVariant,
    startIcon: isLoading ? React__default.createElement(CircularProgress, {
      "aria-label": "circular progress bar",
      variant: progressBarVariant,
      value: loadingProgress,
      size: progressBarSize
    }) : startIcon,
    endIcon: isLoading ? null : endIcon
  }, rest), !isLoading && buttonContent !== undefined && React__default.createElement(StyledSpan, {
    ref: styledSpanRef
  }, buttonContent))));
});
DNBButton.displayName = 'DNBButton';

var _excluded$5 = ["children", "backLabel"];
var StyledBreadcrumbs = styled(Breadcrumbs)(function (_ref) {
  var theme = _ref.theme;
  return {
    '.MuiBreadcrumbs-ol': {
      flexFlow: 'nowrap'
    },
    '.MuiBreadcrumbs-li > *': {
      whiteSpace: 'nowrap'
    },
    '.MuiBreadcrumbs-separator': {
      marginRight: '8px',
      marginLeft: '8px'
    },
    '.MuiLink-root': {
      textDecoration: 'none',
      cursor: 'pointer',
      color: theme.colors.ColorPrimaryBlueInteractive,
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    'button.collapsed-breadcrumbs': {
      backgroundColor: 'transparent',
      border: 'none',
      color: theme.colors.ColorPrimaryBlueInteractive,
      '&:hover': {
        color: theme.colors.ColorGrayPrimary,
        cursor: 'pointer'
      }
    },
    'div.collapsed-breadcrumbs-menu': {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      marginTop: theme.spacing(2),
      padding: theme.spacing(2),
      borderRadius: theme.borders.BorderRadiusDefault,
      border: "1px solid " + theme.colors.ColorGrayIncidental,
      backgroundColor: theme.palette.background.default
    }
  };
});
var DNBBreadcrumbs = function DNBBreadcrumbs(_ref2) {
  var children = _ref2.children,
    _ref2$backLabel = _ref2.backLabel,
    backLabel = _ref2$backLabel === void 0 ? 'Back' : _ref2$backLabel,
    remainingProps = _objectWithoutPropertiesLoose(_ref2, _excluded$5);
  var items = Children.toArray(children);
  var _useState = useState(),
    parentWidth = _useState[0],
    setParentWidth = _useState[1];
  var _useState2 = useState(),
    myWidth = _useState2[0],
    setMyWidth = _useState2[1];
  var me = useCallback(function (node) {
    if (node !== null) {
      setParentWidth(node.getBoundingClientRect().width);
      setMyWidth(node.scrollWidth);
    }
  }, []);
  var bp = parseInt(tokens.TokenMediaQueries.BreakpointMobilePortrait.slice(0, -2));
  var fragment = items.slice(-2, -1)[0];
  var label = backLabel;
  if (isValidElement(fragment)) {
    label = fragment.props.children;
  }
  if (parentWidth && parentWidth < bp) {
    return React__default.createElement(DNBButton, {
      startIcon: React__default.createElement(ArrowBackIos, {
        sx: {
          width: 16,
          marginRight: '-8px'
        }
      }),
      size: "compact",
      variant: "text"
    }, label);
  }
  if (items && items.length > 5 || myWidth && parentWidth && myWidth > parentWidth) {
    var collapsed = items.slice(1, -2);
    items.splice(1, items.length - 3, React__default.createElement(CollapsedBreadcrumb, {
      key: "cbc",
      expandText: remainingProps.expandText
    }, collapsed));
  }
  return React__default.createElement(StyledBreadcrumbs, Object.assign({
    ref: me,
    separator: "/"
  }, remainingProps), items);
};
var CollapsedBreadcrumb = function CollapsedBreadcrumb(_ref3) {
  var children = _ref3.children,
    _ref3$expandText = _ref3.expandText,
    expandText = _ref3$expandText === void 0 ? 'Show path' : _ref3$expandText;
  var _useState3 = useState(false),
    showMenu = _useState3[0],
    setShowMenu = _useState3[1];
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("button", {
    type: "button",
    className: "collapsed-breadcrumbs",
    "aria-label": expandText,
    onClick: function onClick() {
      return setShowMenu(!showMenu);
    }
  }, "\u2022\u2022\u2022"), showMenu && React__default.createElement(ClickAwayListener, {
    onClickAway: function onClickAway() {
      return setShowMenu(false);
    }
  }, React__default.createElement("div", {
    className: "collapsed-breadcrumbs-menu"
  }, children)));
};

var _excluded$6 = ["borderColor", "children", "size", "variant"];
var getBorderColor = function getBorderColor(variant, theme, borderColor) {
  var _variantToColor$get;
  if (typeof borderColor === 'string') {
    return borderColor;
  }
  var variantToColor = new Map([['prime', theme.colors.ColorBackgroundWhite], ['primary', theme.colors.ColorBackgroundWhite], ['secondary', theme.colors.ColorPrimaryBlueInteractive], ['text', theme.colors.ColorPrimaryBlueInteractive], ['destructive', theme.colors.ColorBackgroundWhite]]);
  return (_variantToColor$get = variantToColor.get(variant)) != null ? _variantToColor$get : theme.colors.ColorBackgroundWhite;
};
var StyledMuiButtonGroup = styled(MuiButtonGroup, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'borderColor' && prop !== 'dnbVariant';
  }
})(function (_ref) {
  var theme = _ref.theme,
    borderColor = _ref.borderColor,
    _ref$dnbVariant = _ref.dnbVariant,
    dnbVariant = _ref$dnbVariant === void 0 ? 'primary' : _ref$dnbVariant;
  return {
    borderRadius: theme.borders.BorderRadiusDefault,
    '& .MuiButtonGroup-grouped': {
      borderColor: borderColor != null ? borderColor : null,
      ':not(:last-of-type)': {
        borderRight: theme.borders.BorderThin,
        borderRightColor: getBorderColor(dnbVariant, theme, borderColor)
      },
      ':not(:first-of-type)': {
        borderLeft: theme.borders.BorderThin,
        borderLeftColor: getBorderColor(dnbVariant, theme, borderColor)
      }
    }
  };
});
var DNBButtonGroup = forwardRef(function (_ref2, ref) {
  var borderColor = _ref2.borderColor,
    children = _ref2.children,
    size = _ref2.size,
    variant = _ref2.variant,
    groupProps = _objectWithoutPropertiesLoose(_ref2, _excluded$6);
  var context = React__default.useMemo(function () {
    return {
      size: size,
      variant: variant
    };
  }, [size, variant]);
  return React__default.createElement(StyledMuiButtonGroup, Object.assign({}, groupProps, {
    borderColor: borderColor,
    dnbVariant: variant,
    ref: ref
  }), React__default.createElement(DNBButtonGroupContext.Provider, {
    value: context
  }, children));
});
DNBButtonGroup.displayName = 'DNBButtonGroup';

var _excluded$7 = ["children", "variant", "size"];
var variantStyles = function variantStyles(theme, variant) {
  switch (variant) {
    case 'primary':
      return {
        background: theme.colors.ColorPrimaryBlueInteractive,
        color: theme.colors.ColorBackgroundWhite,
        '&.Mui-focusVisible': {
          outline: theme.borders.BorderMedium + " " + theme.colors.ColorPrimaryBlue,
          background: "linear-gradient(0deg, " + theme.colors.ColorBackgroundWhiteAlpha1 + ", " + theme.colors.ColorBackgroundWhiteAlpha1 + "), " + theme.colors.ColorPrimaryBlueInteractive
        },
        '&:hover': {
          background: "linear-gradient(0deg, " + theme.colors.ColorBackgroundWhiteAlpha1 + ", " + theme.colors.ColorBackgroundWhiteAlpha1 + "), " + theme.colors.ColorPrimaryBlueInteractive,
          boxShadow: theme.boxShadows.ShadowPlus1
        },
        '&:active': {
          background: "linear-gradient(0deg, " + theme.colors.ColorBackgroundWhiteAlpha2 + ", " + theme.colors.ColorBackgroundWhiteAlpha2 + "), " + theme.colors.ColorPrimaryBlueInteractive,
          boxShadow: theme.boxShadows.ShadowPlus1
        },
        '&.Mui-disabled': {
          color: theme.colors.ColorBackgroundWhite,
          background: theme.colors.ColorBackgroundButtonPrimaryDisabled
        }
      };
    case 'secondary':
      return {
        background: theme.palette.background.default,
        border: theme.borders.BorderThin + " " + theme.colors.ColorPrimaryBlueInteractive,
        color: theme.colors.ColorPrimaryBlueInteractive,
        '&.Mui-focusVisible': {
          outline: theme.borders.BorderThin + " " + theme.colors.ColorPrimaryBlue,
          background: "linear-gradient(0deg, " + theme.colors.ColorPrimaryBlueInteractiveAlpha1 + ", " + theme.colors.ColorPrimaryBlueInteractiveAlpha1 + "), " + theme.colors.ColorBackgroundWhite,
          color: theme.colors.ColorPrimaryBlueInteractive
        },
        '&:hover': {
          background: "linear-gradient(0deg, " + theme.colors.ColorPrimaryBlueInteractiveAlpha1 + ", " + theme.colors.ColorPrimaryBlueInteractiveAlpha1 + "), " + theme.colors.ColorBackgroundWhite,
          boxShadow: theme.boxShadows.ShadowPlus1
        },
        '&:active': {
          background: "linear-gradient(0deg, " + theme.colors.ColorPrimaryBlueInteractiveAlpha2 + ", " + theme.colors.ColorPrimaryBlueInteractiveAlpha2 + "), " + theme.colors.ColorBackgroundWhite,
          boxShadow: theme.boxShadows.ShadowPlus1
        },
        '&.Mui-disabled': {
          color: theme.colors.ColorBackgroundButtonSecondaryDisabled,
          borderColor: theme.colors.ColorBackgroundButtonSecondaryDisabled
        }
      };
    default:
      return {
        color: theme.colors.ColorGraySecondary,
        '&.Mui-focusVisible': {
          outline: theme.borders.BorderMedium + " " + theme.colors.ColorPrimaryBlueInteractive,
          background: theme.colors.ColorGraySecondaryAlpha1,
          color: theme.colors.ColorPrimaryBlueInteractive
        },
        '&:hover': {
          background: theme.colors.ColorGraySecondaryAlpha1
        },
        '&:active': {
          background: theme.colors.ColorGraySecondaryAlpha2
        },
        '&.Mui-disabled': {
          opacity: 0.4
        }
      };
  }
};
var StyledIconButton = styled(IconButton, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'dnbVariant' && prop !== 'dnbSize';
  }
})(function (_ref) {
  var theme = _ref.theme,
    dnbVariant = _ref.dnbVariant,
    dnbSize = _ref.dnbSize;
  return _extends({
    '& svg': {
      width: dnbSize === 'default' ? theme.spacing(6) : theme.spacing(5),
      height: dnbSize === 'default' ? theme.spacing(6) : theme.spacing(5)
    }
  }, variantStyles(theme, dnbVariant));
});
var DNBIconButton = function DNBIconButton(_ref2) {
  var children = _ref2.children,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'default' : _ref2$variant,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'default' : _ref2$size,
    muiButtonProps = _objectWithoutPropertiesLoose(_ref2, _excluded$7);
  return React__default.createElement(StyledIconButton, Object.assign({
    dnbVariant: variant,
    dnbSize: size
  }, muiButtonProps), children);
};

var _excluded$8 = ["children", "disabled", "size"];
var getButtonHeight = function getButtonHeight(size) {
  switch (size) {
    case 'compact':
      return theme.spacing(9);
    case 'small':
      return theme.spacing(8);
    case 'default':
    default:
      return theme.spacing(11);
  }
};
var StyledMuiToggleButtonGroup = styled(MuiToggleButtonGroup)(function (_ref) {
  var theme = _ref.theme,
    size = _ref.size;
  return {
    borderRadius: theme.borders.BorderRadiusDefault,
    height: getButtonHeight(size)
  };
});
var DNBToggleButtonGroup = forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'default' : _ref2$size,
    groupProps = _objectWithoutPropertiesLoose(_ref2, _excluded$8);
  return React__default.createElement(StyledMuiToggleButtonGroup, Object.assign({
    disabled: disabled,
    size: size
  }, groupProps, {
    ref: ref
  }), children);
});
DNBToggleButtonGroup.displayName = 'DNBToggleButtonGroup';

var _excluded$9 = ["children", "size"];
var StyledToggleButton = styled(ToggleButton)(function (_ref) {
  var theme = _ref.theme;
  return {
    boxShadow: 'none',
    border: theme.borders.BorderThin,
    borderColor: theme.colors.ColorGraySecondary,
    color: theme.colors.ColorGraySecondary,
    borderRadius: theme.borders.BorderRadiusDefault,
    fontFamily: theme.typography.FontFamilySansSerif,
    fontWeight: theme.typography.FontWeightAvenirMedium,
    textTransform: 'none',
    '&.Mui-disabled': {
      opacity: theme.opacity.OpacityDisabled
    },
    '&:hover': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1,
      boxShadow: theme.boxShadows.ShadowPlus1
    },
    '&:active': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha2
    },
    '&.Mui-selected': {
      color: theme.colors.ColorBackgroundWhite,
      backgroundColor: theme.colors.ColorPrimaryBlueInteractive
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.colors.ColorPrimaryBlueInteractive
    },
    '&:focus': {
      outlineWidth: theme.borders.BorderOutline,
      outlineColor: theme.colors.ColorPrimaryBlue,
      outlineStyle: theme.borders.BorderSolid,
      zIndex: 1
    },
    '&.MuiToggleButton-sizeDefault,&.MuiToggleButton-sizeMedium': {
      borderRadius: theme.borders.BorderRadiusDefault,
      '&:not(.MuiToggleButtonGroup-grouped)': {
        height: theme.spacing(11)
      },
      padding: theme.spacing(3),
      fontSize: theme.typography.FontSizeSubtitle2,
      svg: {
        maxWidth: theme.spacing(6),
        maxHeight: theme.spacing(6)
      },
      '&:not(:first-child)': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },
    '&.MuiToggleButton-sizeCompact': {
      borderRadius: theme.borders.BorderRadiusCompact,
      '&:not(.MuiToggleButtonGroup-grouped)': {
        height: theme.spacing(9)
      },
      padding: theme.spacing(2) + " " + theme.spacing(3),
      fontSize: theme.typography.FontSizeCompact,
      svg: {
        maxWidth: theme.spacing(5),
        maxHeight: theme.spacing(5)
      },
      '&:not(:first-child)': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },
    '&.MuiToggleButton-sizeSmall': {
      borderRadius: theme.borders.BorderRadiusSmall,
      '&:not(.MuiToggleButtonGroup-grouped)': {
        height: theme.spacing(8)
      },
      padding: theme.spacing(2),
      fontSize: theme.typography.FontSizeCompact,
      svg: {
        maxWidth: theme.spacing(5),
        maxHeight: theme.spacing(5)
      },
      '&:not(:first-child)': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },
    '&.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal:not(.Mui-disabled)': {
      borderLeftColor: theme.colors.ColorGraySecondary
    }
  };
});
var DNBToggleButton = forwardRef(function (props, ref) {
  var children = props.children,
    size = props.size,
    rest = _objectWithoutPropertiesLoose(props, _excluded$9);
  return React__default.createElement(StyledToggleButton, Object.assign({
    ref: ref,
    size: size
  }, rest), children);
});
DNBToggleButton.displayName = 'DNBToggleButton';

var _excluded$a = ["variant", "hasBorder", "cardColor", "selectable", "selected", "children", "sx"];
var getCardColorFromVariant = function getCardColorFromVariant(dnbVariant, dnbCardColor) {
  switch (dnbVariant) {
    case 'gray':
      return 'ColorBackgroundGray';
    case 'color-block':
      return dnbCardColor || 'ColorBackgroundWhite';
    case 'white':
    default:
      return 'ColorBackgroundWhite';
  }
};
var getBorderColorFromHasBorder = function getBorderColorFromHasBorder(dnbHasBorder, dnbVariant, dnbSelected) {
  if (dnbSelected) {
    return 'ColorPrimaryBlueInteractive';
  }
  if (dnbHasBorder && dnbVariant !== 'color-block') {
    return 'ColorGrayIncidental';
  }
  return 'ColorBackgroundWhite';
};
var getBoxShadow = function getBoxShadow(dnbSelected, dnbSelectable) {
  if (dnbSelectable) {
    if (dnbSelected) {
      return '0 0 0 1px #0078a7, 0 2px 4px rgb(22 25 25 / 20%)';
    }
    return function (theme) {
      return theme.boxShadows.ShadowPlus1;
    };
  }
  return 'initial';
};
var StyledMuiCardActionArea = styled(MuiCardActionArea)(function (_ref) {
  var theme = _ref.theme;
  return {
    '> .MuiCardActionArea-focusHighlight': {
      display: 'none'
    },
    '&:hover': {
      backgroundColor: theme.colors.ColorGrayIncidentalAlpha1
    },
    '&:active': {
      backgroundColor: theme.colors.ColorGrayIncidentalAlpha2
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.colors.ColorGrayIncidentalAlpha2
    }
  };
});
var DNBCard = function DNBCard(props) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'white' : _props$variant,
    hasBorder = props.hasBorder,
    cardColor = props.cardColor,
    _props$selectable = props.selectable,
    selectable = _props$selectable === void 0 ? false : _props$selectable,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    children = props.children,
    sx = props.sx,
    rest = _objectWithoutPropertiesLoose(props, _excluded$a);
  var newSx = _extends({}, sx, {
    color: variant === 'color-block' ? 'white' : undefined,
    bgcolor: function bgcolor(theme) {
      return theme.colors[getCardColorFromVariant(variant, cardColor)];
    },
    border: 1,
    borderColor: function borderColor(theme) {
      return theme.colors[getBorderColorFromHasBorder(hasBorder, variant, selected)];
    },
    boxShadow: getBoxShadow(selected, selectable),
    borderRadius: 2,
    transition: selected ? 'none' : 'initial'
  });
  return selectable ? React__default.createElement(MuiCard, Object.assign({}, rest, {
    sx: newSx,
    variant: "outlined"
  }), React__default.createElement(StyledMuiCardActionArea, null, children)) : React__default.createElement(MuiCard, Object.assign({}, rest, {
    sx: newSx,
    variant: "outlined"
  }), children);
};

var _excluded$b = ["labelRowsPerPage", "component"];
var StyledDNBTablePagination = styled(MuiTablePagination)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiTablePagination-actions .MuiIconButton-root': {
      color: theme.colors.ColorGraySecondary,
      '&:hover': {
        background: theme.colors.ColorGraySecondaryAlpha1
      },
      '&:active': {
        background: theme.colors.ColorGraySecondaryAlpha2
      },
      '&:focus-visible': {
        outline: theme.borders.BorderMedium + " " + theme.colors.ColorPrimaryBlueInteractive
      },
      '&.Mui-disabled': {
        opacity: theme.opacity.OpacityDisabled
      }
    },
    '& .MuiSelect-select': {
      '&:focus': {
        background: 'transparent'
      },
      '&:focus-visible': {
        outline: theme.borders.BorderMedium + " " + theme.colors.ColorPrimaryBlueInteractive,
        background: 'transparent'
      }
    }
  };
});
var menuSxProps = {
  '& .MuiMenuItem-root': _extends({}, function (theme) {
    return theme.typography['compact-medium'];
  }, {
    padding: 2,
    borderRadius: function borderRadius(theme) {
      return theme.borders.BorderRadiusCompact;
    },
    '&:last-of-type': {
      borderBottom: 'none'
    },
    minWidth: '80px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      '&::after': {
        marginLeft: 'auto',
        textAlign: 'right',
        content: '"✓"',
        fontFamily: 'BlinkMacSystemFont, Courier, sans-serif',
        color: function color(theme) {
          return theme.colors.ColorPrimaryBlueInteractive;
        }
      },
      '&:focus-visible': {
        background: 'transparent'
      }
    },
    '&:hover, &.Mui-selected:hover': {
      background: function background(theme) {
        return theme.colors.ColorGrayPrimaryAlpha1;
      }
    },
    '&:focus-visible': {
      background: 'transparent',
      outline: function outline(theme) {
        return theme.borders.BorderMedium + " " + theme.colors.ColorPrimaryBlueInteractive;
      }
    },
    '&.MuiFocusVisible': {
      background: 'transparent'
    }
  }),
  '& .MuiList-root': _extends({
    padding: 2,
    margin: 0,
    background: function background(theme) {
      return theme.palette.background.paper;
    },
    border: function border(theme) {
      return theme.borders.BorderThin + " " + theme.colors.ColorGrayIncidental;
    }
  }, function (theme) {
    return theme.typography['compact-medium'];
  }, {
    borderRadius: function borderRadius(theme) {
      return theme.borders.BorderRadiusDefault;
    },
    overflow: 'auto',
    outline: '0px',
    color: function color(theme) {
      return theme.colors.ColorGrayPrimary;
    },
    boxShadow: function boxShadow(theme) {
      return theme.boxShadows.ShadowPlus2;
    }
  })
};
var DNBTablePagination = function DNBTablePagination(_ref2) {
  var _ref2$labelRowsPerPag = _ref2.labelRowsPerPage,
    labelRowsPerPage = _ref2$labelRowsPerPag === void 0 ? 'Items per page: ' : _ref2$labelRowsPerPag,
    _ref2$component = _ref2.component,
    component = _ref2$component === void 0 ? 'div' : _ref2$component,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$b);
  return React__default.createElement(StyledDNBTablePagination, Object.assign({
    component: component,
    SelectProps: {
      MenuProps: {
        sx: menuSxProps
      }
    },
    backIconButtonProps: {
      size: 'small'
    },
    nextIconButtonProps: {
      size: 'small'
    }
  }, rest, {
    labelRowsPerPage: labelRowsPerPage,
    "data-testid": "pagination-test-id"
  }));
};

var _excluded$c = ["variant"];
var StyledDivider = styled(MuiDivider, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'dividerVariant';
  }
})(function (_ref) {
  var dividerVariant = _ref.dividerVariant,
    theme = _ref.theme;
  return _extends({
    backgroundColor: theme.colors.ColorGrayIncidental
  }, dividerVariant === 'incidental' && {
    backgroundColor: theme.colors.ColorGrayIncidental
  }, dividerVariant === 'lightIncidental' && {
    backgroundColor: theme.colors.ColorGrayIncidentalAlpha4
  }, dividerVariant === 'medium' && {
    backgroundColor: theme.colors.ColorGraySecondary
  }, dividerVariant === 'heavy' && {
    backgroundColor: theme.colors.ColorGrayPrimary
  });
});
var DNBDivider = function DNBDivider(props) {
  var variant = props.variant,
    rest = _objectWithoutPropertiesLoose(props, _excluded$c);
  return React__default.createElement(StyledDivider, Object.assign({
    dividerVariant: variant
  }, rest));
};

var _excluded$d = ["InputLabelProps", "InputProps", "loading", "size", "type", "variant"];
var excludedProps = {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'loading' && prop !== 'dnbSize';
  }
};
var getFieldHeight = function getFieldHeight(size) {
  switch (size) {
    case 'compact':
      return theme.spacing(9);
    case 'small':
      return theme.spacing(8);
    case 'default':
    default:
      return theme.spacing(11);
  }
};
var StyledTextField = styled(MuiTextField, excludedProps)(function (_ref) {
  var dnbSize = _ref.dnbSize;
  return {
    input: {
      '&:-webkit-autofill': _extends({}, dnbSize === 'default' ? theme.typography['body1'] : theme.typography['compact-body'], {
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: theme.colors.ColorGrayPrimary,
        '&:hover': {
          WebkitTextFillColor: theme.colors.ColorGrayPrimary
        },
        '&:focus': {
          WebkitTextFillColor: theme.colors.ColorPrimaryBlueInteractive
        }
      })
    },
    '.MuiInputLabel-root': {
      color: theme.colors.ColorGrayPrimary,
      position: 'unset',
      transform: 'unset'
    },
    '.MuiInput-root': {
      marginTop: theme.spacing(1)
    },
    '& .MuiSvgIcon-root': {
      color: theme.colors.ColorGraySecondary
    },
    '& .MuiInputBase-input': {
      border: 'unset',
      boxSizing: 'border-box',
      color: theme.colors.ColorGrayPrimary,
      position: 'relative',
      zIndex: 1,
      '&::placeholder': {
        color: theme.colors.ColorGraySecondary,
        opacity: 1
      }
    },
    '& .MuiInputAdornment-root': {
      zIndex: 1
    },
    '& .Mui-disabled': {
      cursor: 'default',
      opacity: theme.opacity.OpacityDisabled
    },
    '&.DNBTextField': {
      '& .DNBInputBase': {
        boxShadow: "inset " + theme.boxShadows.ShadowMinus1,
        height: getFieldHeight(dnbSize),
        '&-borderless': {
          boxShadow: 'unset',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            borderRadius: 'initial',
            paddingLeft: 0
          }
        }
      },
      '&-sizeDefault': {
        '& .MuiInputLabel-root': _extends({}, theme.typography['subtitle2']),
        '& .DNBInputBase': _extends({
          borderRadius: theme.borders.BorderRadiusDefault
        }, theme.typography['body1'], {
          '& .MuiSvgIcon-root': {
            fontSize: theme.spacing(6)
          }
        })
      },
      '&-sizeCompact': {
        '& .MuiInputLabel-root': _extends({}, theme.typography['compact-medium']),
        '& .DNBInputBase': _extends({
          borderRadius: theme.borders.BorderRadiusCompact
        }, theme.typography['compact-body'], {
          '& .MuiSvgIcon-root': {
            fontSize: theme.spacing(5)
          }
        })
      },
      '&-sizeSmall': {
        '& .MuiInputLabel-root': _extends({}, theme.typography['compact-medium']),
        '& .DNBInputBase': _extends({
          borderRadius: theme.borders.BorderRadiusSmall
        }, theme.typography['compact-body'], {
          '& .MuiSvgIcon-root': {
            fontSize: theme.spacing(5)
          }
        })
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      backgroundColor: theme.colors.ColorBackgroundWhite,
      borderColor: theme.colors.ColorGraySecondary
    },
    '.MuiFormHelperText-root': _extends({
      marginTop: theme.spacing(1),
      marginLeft: 0
    }, theme.typography['caption'])
  };
});
var DNBTextField = forwardRef(function DNBTextField(_ref2, ref) {
  var InputLabelProps = _ref2.InputLabelProps,
    InputProps = _ref2.InputProps,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'default' : _ref2$size,
    type = _ref2.type,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'outlined' : _ref2$variant,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$d);
  var borderlessClassName = variant === 'borderless' ? 'DNBInputBase-borderless' : undefined;
  var getSizeClassName = function getSizeClassName() {
    switch (size) {
      case 'compact':
        return 'sizeCompact';
      case 'small':
        return 'sizeSmall';
      case 'default':
      default:
        return 'sizeDefault';
    }
  };
  var circularProgressSize = size === 'default' ? theme.spacing(6) : theme.spacing(5);
  var endAdornmentElement = loading ? React__default.createElement(InputAdornment, {
    position: "end"
  }, React__default.createElement(CircularProgress, {
    "aria-label": "circular progress bar",
    variant: 'indeterminate',
    size: circularProgressSize
  })) : InputProps === null || InputProps === void 0 ? void 0 : InputProps.endAdornment;
  return React__default.createElement(StyledTextField, Object.assign({}, rest, {
    className: "DNBTextField DNBTextField-" + getSizeClassName(),
    dnbSize: size,
    InputLabelProps: _extends({}, InputLabelProps, {
      shrink: true
    }),
    InputProps: _extends({
      autoComplete: type === 'password' ? 'new-password' : InputProps === null || InputProps === void 0 ? void 0 : InputProps.autoComplete
    }, InputProps, {
      label: undefined,
      className: "DNBInputBase " + borderlessClassName,
      endAdornment: endAdornmentElement,
      notched: false
    }),
    inputRef: ref,
    size: "small",
    type: type,
    variant: 'outlined'
  }));
});

var _excluded$e = ["focused", "fullWidth", "label", "placeholder", "size"];
var StyledMuiAutocomplete = styled(MuiAutocomplete)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiAutocomplete-input': {
      padding: 'initial !important',
      '&:first-of-type': {
        paddingLeft: theme.spacing(2) + " !important"
      }
    },
    '& .MuiAutocomplete-endAdornment': {
      top: 'unset'
    },
    '& .MuiAutocomplete-popupIndicator, .MuiAutocomplete-clearIndicator': {
      padding: theme.spacing(1)
    },
    '& .MuiChip-root,.MuiSvgIcon-root': {
      zIndex: 999
    },
    '& .MuiInputBase-input': {
      width: 'auto'
    },
    '& .MuiFormControl-root .MuiInputBase-root': {
      height: 'auto',
      flexWrap: 'wrap'
    }
  };
});
var DNBAutocomplete = function DNBAutocomplete(_ref2) {
  var _ref2$focused = _ref2.focused,
    focused = _ref2$focused === void 0 ? false : _ref2$focused,
    _ref2$fullWidth = _ref2.fullWidth,
    fullWidth = _ref2$fullWidth === void 0 ? false : _ref2$fullWidth,
    label = _ref2.label,
    placeholder = _ref2.placeholder,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'default' : _ref2$size,
    dnbAutocompleteProps = _objectWithoutPropertiesLoose(_ref2, _excluded$e);
  var dnbTextFieldProps = {
    focused: focused,
    fullWidth: fullWidth,
    label: label,
    placeholder: placeholder,
    size: size
  };
  return React__default.createElement(StyledMuiAutocomplete, Object.assign({}, dnbAutocompleteProps, {
    renderInput: function renderInput(params) {
      return React__default.createElement(DNBTextField, Object.assign({}, params, dnbTextFieldProps));
    }
  }));
};

var _excluded$f = ["children", "size"];
var StyledMuiInputLabel = styled(MuiInputLabel, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'dnbSize';
  }
})(function (_ref) {
  var theme = _ref.theme,
    dnbSize = _ref.dnbSize;
  return _extends({
    color: theme.colors.ColorGrayPrimary
  }, dnbSize === 'default' ? theme.typography.subtitle2 : theme.typography['compact-medium'], {
    '&.Mui-disabled': {
      opacity: theme.opacity.OpacityDisabled
    }
  });
});
var DNBInputLabel = function DNBInputLabel(_ref2) {
  var children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'default' : _ref2$size,
    inputProps = _objectWithoutPropertiesLoose(_ref2, _excluded$f);
  return React__default.createElement(StyledMuiInputLabel, Object.assign({}, inputProps, {
    dnbSize: size
  }), children);
};

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element$1 = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;
var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};
var isConcurrentMode = A;
var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};
var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};
var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};
var isFragment = function isFragment(a) {
  return z(a) === e;
};
var isLazy = function isLazy(a) {
  return z(a) === t;
};
var isMemo = function isMemo(a) {
  return z(a) === r;
};
var isPortal = function isPortal(a) {
  return z(a) === d;
};
var isProfiler = function isProfiler(a) {
  return z(a) === g;
};
var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};
var isSuspense = function isSuspense(a) {
  return z(a) === p;
};
var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs_production_min.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs_production_min;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims();
  }
});

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }
  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  var _extends2;
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }
  return _extends$1({}, propTypes, (_extends2 = {}, _extends2[specialProperty] = function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });
    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: " + unsupportedProps.map(function (prop) {
        return "`" + prop + "`";
      }).join(', ') + ". Please remove them.");
    }
    return null;
  }, _extends2));
}

function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  var propValue = props[propName];
  var safePropName = propFullName || propName;
  if (propValue == null) {
    return null;
  }
  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid " + location + " `" + safePropName + "` supplied to `" + componentName + "`. " + "Expected an HTMLElement.");
  }
  return null;
}

var refType = propTypes.oneOfType([propTypes.func, propTypes.object]);

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

var useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

var globalId = 0;
function useGlobalId(idOverride) {
  var _React$useState = useState(idOverride),
    defaultId = _React$useState[0],
    setDefaultId = _React$useState[1];
  var id = idOverride || defaultId;
  useEffect(function () {
    if (defaultId == null) {
      globalId += 1;
      setDefaultId("mui-" + globalId);
    }
  }, [defaultId]);
  return id;
}
var maybeReactUseId = React['useId'.toString()];
function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    var reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  return useGlobalId(idOverride);
}

function useForkRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return useMemo(function () {
    if (refs.every(function (ref) {
      return ref == null;
    })) {
      return null;
    }
    return function (instance) {
      refs.forEach(function (ref) {
        setRef(ref, instance);
      });
    };
  }, refs);
}

var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
function focusTriggersKeyboardModality(node) {
  var type = node.type,
    tagName = node.tagName;
  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
  var target = event.target;
  try {
    return target.matches(':focus-visible');
  } catch (error) {}
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  var ref = useCallback(function (node) {
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  var isFocusVisibleRef = useRef(false);
  function handleBlurVisible() {
    if (isFocusVisibleRef.current) {
      hadFocusVisibleRecently = true;
      window.clearTimeout(hadFocusVisibleRecentlyTimeout);
      hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
        hadFocusVisibleRecently = false;
      }, 100);
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef: isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: ref
  };
}

function composeClasses(slots, getUtilityClass, classes) {
  if (classes === void 0) {
    classes = undefined;
  }
  var output = {};
  Object.keys(slots).forEach(function (slot) {
    output[slot] = slots[slot].reduce(function (acc, key) {
      if (key) {
        var utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

var defaultGenerator = function defaultGenerator(componentName) {
  return componentName;
};
var createClassNameGenerator = function createClassNameGenerator() {
  var _generate = defaultGenerator;
  return {
    configure: function configure(generator) {
      _generate = generator;
    },
    generate: function generate(componentName) {
      return _generate(componentName);
    },
    reset: function reset() {
      _generate = defaultGenerator;
    }
  };
};
var ClassNameGenerator = createClassNameGenerator();

var globalStateClassesMapping = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix) {
  if (globalStatePrefix === void 0) {
    globalStatePrefix = 'Mui';
  }
  var globalStateClass = globalStateClassesMapping[slot];
  return globalStateClass ? globalStatePrefix + "-" + globalStateClass : ClassNameGenerator.generate(componentName) + "-" + slot;
}

function generateUtilityClasses(componentName, slots, globalStatePrefix) {
  if (globalStatePrefix === void 0) {
    globalStatePrefix = 'Mui';
  }
  var result = {};
  slots.forEach(function (slot) {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}

function getOptionUtilityClass(slot) {
  return generateUtilityClass('MuiOption', slot);
}
var optionClasses = generateUtilityClasses('MuiOption', ['root', 'disabled', 'selected', 'highlighted']);

function isHostComponent(element) {
  return typeof element === 'string';
}

function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === undefined || isHostComponent(elementType)) {
    return otherProps;
  }
  return _extends$1({}, otherProps, {
    ownerState: _extends$1({}, otherProps.ownerState, ownerState)
  });
}

function areArraysEqual(array1, array2, itemComparer) {
  if (itemComparer === void 0) {
    itemComparer = function itemComparer(a, b) {
      return a === b;
    };
  }
  return array1.length === array2.length && array1.every(function (value, index) {
    return itemComparer(value, array2[index]);
  });
}

var defaultContextValue = {
  disableDefaultClasses: false
};
var ClassNameConfiguratorContext = /*#__PURE__*/createContext(defaultContextValue);
function useClassNamesOverride(generateUtilityClass) {
  var _React$useContext = useContext(ClassNameConfiguratorContext),
    disableDefaultClasses = _React$useContext.disableDefaultClasses;
  return function (slot) {
    if (disableDefaultClasses) {
      return '';
    }
    return generateUtilityClass(slot);
  };
}

function extractEventHandlers(object, excludeKeys) {
  if (excludeKeys === void 0) {
    excludeKeys = [];
  }
  if (object === undefined) {
    return {};
  }
  var result = {};
  Object.keys(object).filter(function (prop) {
    return prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop);
  }).forEach(function (prop) {
    result[prop] = object[prop];
  });
  return result;
}

function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}

function r$1(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r$1(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r$1(e)) && (n && (n += " "), n += t);
  return n;
}

function omitEventHandlers(object) {
  if (object === undefined) {
    return {};
  }
  var result = {};
  Object.keys(object).filter(function (prop) {
    return !(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function');
  }).forEach(function (prop) {
    result[prop] = object[prop];
  });
  return result;
}

function mergeSlotProps(parameters) {
  var getSlotProps = parameters.getSlotProps,
    additionalProps = parameters.additionalProps,
    externalSlotProps = parameters.externalSlotProps,
    externalForwardedProps = parameters.externalForwardedProps,
    className = parameters.className;
  if (!getSlotProps) {
    var _joinedClasses = clsx(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
    var _mergedStyle = _extends$1({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    var _props = _extends$1({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (_joinedClasses.length > 0) {
      _props.className = _joinedClasses;
    }
    if (Object.keys(_mergedStyle).length > 0) {
      _props.style = _mergedStyle;
    }
    return {
      props: _props,
      internalRef: undefined
    };
  }
  var eventHandlers = extractEventHandlers(_extends$1({}, externalForwardedProps, externalSlotProps));
  var componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  var otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  var internalSlotProps = getSlotProps(eventHandlers);
  var joinedClasses = clsx(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  var mergedStyle = _extends$1({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  var props = _extends$1({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props: props,
    internalRef: internalSlotProps.ref
  };
}

var _excluded$g = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function useSlotProps(parameters) {
  var _parameters$additiona;
  var elementType = parameters.elementType,
    externalSlotProps = parameters.externalSlotProps,
    ownerState = parameters.ownerState,
    _parameters$skipResol = parameters.skipResolvingSlotProps,
    skipResolvingSlotProps = _parameters$skipResol === void 0 ? false : _parameters$skipResol,
    rest = _objectWithoutPropertiesLoose$1(parameters, _excluded$g);
  var resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
  var _mergeSlotProps = mergeSlotProps(_extends$1({}, rest, {
      externalSlotProps: resolvedComponentsProps
    })),
    mergedProps = _mergeSlotProps.props,
    internalRef = _mergeSlotProps.internalRef;
  var ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  var props = appendOwnerState(elementType, _extends$1({}, mergedProps, {
    ref: ref
  }), ownerState);
  return props;
}

var ListActionTypes = {
  blur: 'list:blur',
  focus: 'list:focus',
  itemClick: 'list:itemClick',
  itemHover: 'list:itemHover',
  itemsChange: 'list:itemsChange',
  keyDown: 'list:keyDown',
  resetHighlight: 'list:resetHighlight',
  textNavigation: 'list:textNavigation'
};

function findValidItemToHighlight(currentIndex, lookupDirection, items, includeDisabledItems, isItemDisabled, wrapAround) {
  if (items.length === 0 || !includeDisabledItems && items.every(function (item, itemIndex) {
    return isItemDisabled(item, itemIndex);
  })) {
    return -1;
  }
  var nextFocus = currentIndex;
  for (;;) {
    if (!wrapAround && lookupDirection === 'next' && nextFocus === items.length || !wrapAround && lookupDirection === 'previous' && nextFocus === -1) {
      return -1;
    }
    var nextFocusDisabled = includeDisabledItems ? false : isItemDisabled(items[nextFocus], nextFocus);
    if (nextFocusDisabled) {
      nextFocus += lookupDirection === 'next' ? 1 : -1;
      if (wrapAround) {
        nextFocus = (nextFocus + items.length) % items.length;
      }
    } else {
      return nextFocus;
    }
  }
}
function moveHighlight(previouslyHighlightedValue, offset, context) {
  var _items$nextIndex;
  var items = context.items,
    isItemDisabled = context.isItemDisabled,
    disableListWrap = context.disableListWrap,
    disabledItemsFocusable = context.disabledItemsFocusable,
    itemComparer = context.itemComparer,
    focusManagement = context.focusManagement;
  var defaultHighlightedIndex = focusManagement === 'DOM' ? 0 : -1;
  var maxIndex = items.length - 1;
  var previouslyHighlightedIndex = previouslyHighlightedValue == null ? -1 : items.findIndex(function (item) {
    return itemComparer(item, previouslyHighlightedValue);
  });
  var nextIndexCandidate;
  var lookupDirection;
  var wrapAround = !disableListWrap;
  switch (offset) {
    case 'reset':
      if (defaultHighlightedIndex === -1) {
        return null;
      }
      nextIndexCandidate = 0;
      lookupDirection = 'next';
      wrapAround = false;
      break;
    case 'start':
      nextIndexCandidate = 0;
      lookupDirection = 'next';
      wrapAround = false;
      break;
    case 'end':
      nextIndexCandidate = maxIndex;
      lookupDirection = 'previous';
      wrapAround = false;
      break;
    default:
      {
        var newIndex = previouslyHighlightedIndex + offset;
        if (newIndex < 0) {
          if (!wrapAround && previouslyHighlightedIndex !== -1 || Math.abs(offset) > 1) {
            nextIndexCandidate = 0;
            lookupDirection = 'next';
          } else {
            nextIndexCandidate = maxIndex;
            lookupDirection = 'previous';
          }
        } else if (newIndex > maxIndex) {
          if (!wrapAround || Math.abs(offset) > 1) {
            nextIndexCandidate = maxIndex;
            lookupDirection = 'previous';
          } else {
            nextIndexCandidate = 0;
            lookupDirection = 'next';
          }
        } else {
          nextIndexCandidate = newIndex;
          lookupDirection = offset >= 0 ? 'next' : 'previous';
        }
      }
  }
  var nextIndex = findValidItemToHighlight(nextIndexCandidate, lookupDirection, items, disabledItemsFocusable, isItemDisabled, wrapAround);
  if (nextIndex === -1 && previouslyHighlightedValue !== null && !isItemDisabled(previouslyHighlightedValue, previouslyHighlightedIndex)) {
    return previouslyHighlightedValue;
  }
  return (_items$nextIndex = items[nextIndex]) != null ? _items$nextIndex : null;
}
function toggleSelection(item, selectedValues, selectionMode, itemComparer) {
  if (selectionMode === 'none') {
    return [];
  }
  if (selectionMode === 'single') {
    if (itemComparer(selectedValues[0], item)) {
      return selectedValues;
    }
    return [item];
  }
  if (selectedValues.some(function (sv) {
    return itemComparer(sv, item);
  })) {
    return selectedValues.filter(function (sv) {
      return !itemComparer(sv, item);
    });
  }
  return [].concat(selectedValues, [item]);
}
function handleItemSelection(item, state, context) {
  var itemComparer = context.itemComparer,
    isItemDisabled = context.isItemDisabled,
    selectionMode = context.selectionMode,
    items = context.items;
  var selectedValues = state.selectedValues;
  var itemIndex = items.findIndex(function (i) {
    return itemComparer(item, i);
  });
  if (isItemDisabled(item, itemIndex)) {
    return state;
  }
  var newSelectedValues = toggleSelection(item, selectedValues, selectionMode, itemComparer);
  return _extends$1({}, state, {
    selectedValues: newSelectedValues,
    highlightedValue: item
  });
}
function handleKeyDown$1(key, state, context) {
  var previouslySelectedValue = state.highlightedValue;
  var orientation = context.orientation,
    pageSize = context.pageSize;
  switch (key) {
    case 'Home':
      return _extends$1({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, 'start', context)
      });
    case 'End':
      return _extends$1({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, 'end', context)
      });
    case 'PageUp':
      return _extends$1({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, -pageSize, context)
      });
    case 'PageDown':
      return _extends$1({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, pageSize, context)
      });
    case 'ArrowUp':
      if (orientation !== 'vertical') {
        break;
      }
      return _extends$1({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, -1, context)
      });
    case 'ArrowDown':
      if (orientation !== 'vertical') {
        break;
      }
      return _extends$1({}, state, {
        highlightedValue: moveHighlight(previouslySelectedValue, 1, context)
      });
    case 'ArrowLeft':
      {
        if (orientation === 'vertical') {
          break;
        }
        var offset = orientation === 'horizontal-ltr' ? -1 : 1;
        return _extends$1({}, state, {
          highlightedValue: moveHighlight(previouslySelectedValue, offset, context)
        });
      }
    case 'ArrowRight':
      {
        if (orientation === 'vertical') {
          break;
        }
        var _offset = orientation === 'horizontal-ltr' ? 1 : -1;
        return _extends$1({}, state, {
          highlightedValue: moveHighlight(previouslySelectedValue, _offset, context)
        });
      }
    case 'Enter':
    case ' ':
      if (state.highlightedValue === null) {
        return state;
      }
      return handleItemSelection(state.highlightedValue, state, context);
  }
  return state;
}
function handleBlur(state, context) {
  if (context.focusManagement === 'DOM') {
    return state;
  }
  return _extends$1({}, state, {
    highlightedValue: null
  });
}
function textCriteriaMatches(nextFocus, searchString, stringifyItem) {
  var _stringifyItem;
  var text = (_stringifyItem = stringifyItem(nextFocus)) == null ? void 0 : _stringifyItem.trim().toLowerCase();
  if (!text || text.length === 0) {
    return false;
  }
  return text.indexOf(searchString) === 0;
}
function handleTextNavigation(state, searchString, context) {
  var items = context.items,
    isItemDisabled = context.isItemDisabled,
    disabledItemsFocusable = context.disabledItemsFocusable,
    getItemAsString = context.getItemAsString;
  var startWithCurrentItem = searchString.length > 1;
  var nextItem = startWithCurrentItem ? state.highlightedValue : moveHighlight(state.highlightedValue, 1, context);
  for (var index = 0; index < items.length; index += 1) {
    if (!nextItem || !startWithCurrentItem && state.highlightedValue === nextItem) {
      return state;
    }
    if (textCriteriaMatches(nextItem, searchString, getItemAsString) && (!isItemDisabled(nextItem, items.indexOf(nextItem)) || disabledItemsFocusable)) {
      return _extends$1({}, state, {
        highlightedValue: nextItem
      });
    }
    nextItem = moveHighlight(nextItem, 1, context);
  }
  return state;
}
function handleItemsChange(items, previousItems, state, context) {
  var _state$selectedValues;
  var itemComparer = context.itemComparer,
    focusManagement = context.focusManagement;
  var newHighlightedValue = null;
  if (state.highlightedValue != null) {
    var _items$find;
    newHighlightedValue = (_items$find = items.find(function (item) {
      return itemComparer(item, state.highlightedValue);
    })) != null ? _items$find : null;
  } else if (focusManagement === 'DOM' && previousItems.length === 0) {
    newHighlightedValue = moveHighlight(null, 'reset', context);
  }
  var selectedValues = (_state$selectedValues = state.selectedValues) != null ? _state$selectedValues : [];
  var newSelectedValues = selectedValues.filter(function (selectedValue) {
    return items.some(function (item) {
      return itemComparer(item, selectedValue);
    });
  });
  return _extends$1({}, state, {
    highlightedValue: newHighlightedValue,
    selectedValues: newSelectedValues
  });
}
function handleResetHighlight(state, context) {
  return _extends$1({}, state, {
    highlightedValue: moveHighlight(null, 'reset', context)
  });
}
function listReducer(state, action) {
  var type = action.type,
    context = action.context;
  switch (type) {
    case ListActionTypes.keyDown:
      return handleKeyDown$1(action.key, state, context);
    case ListActionTypes.itemClick:
      return handleItemSelection(action.item, state, context);
    case ListActionTypes.blur:
      return handleBlur(state, context);
    case ListActionTypes.textNavigation:
      return handleTextNavigation(state, action.searchString, context);
    case ListActionTypes.itemsChange:
      return handleItemsChange(action.items, action.previousItems, state, context);
    case ListActionTypes.resetHighlight:
      return handleResetHighlight(state, context);
    default:
      return state;
  }
}

function createMessageBus() {
  var listeners = new Map();
  function subscribe(topic, callback) {
    var topicListeners = listeners.get(topic);
    if (!topicListeners) {
      topicListeners = new Set([callback]);
      listeners.set(topic, topicListeners);
    } else {
      topicListeners.add(callback);
    }
    return function () {
      topicListeners.delete(callback);
      if (topicListeners.size === 0) {
        listeners.delete(topic);
      }
    };
  }
  function publish(topic) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    var topicListeners = listeners.get(topic);
    if (topicListeners) {
      topicListeners.forEach(function (callback) {
        return callback.apply(void 0, args);
      });
    }
  }
  return {
    subscribe: subscribe,
    publish: publish
  };
}
function useMessageBus() {
  var bus = useRef();
  if (!bus.current) {
    bus.current = createMessageBus();
  }
  return bus.current;
}

var SELECTION_CHANGE_TOPIC = 'select:change-selection';
var HIGHLIGHT_CHANGE_TOPIC = 'select:change-highlight';
function useListChangeNotifiers() {
  var messageBus = useMessageBus();
  var notifySelectionChanged = useCallback(function (newSelectedItems) {
    messageBus.publish(SELECTION_CHANGE_TOPIC, newSelectedItems);
  }, [messageBus]);
  var notifyHighlightChanged = useCallback(function (newHighlightedItem) {
    messageBus.publish(HIGHLIGHT_CHANGE_TOPIC, newHighlightedItem);
  }, [messageBus]);
  var registerSelectionChangeHandler = useCallback(function (handler) {
    return messageBus.subscribe(SELECTION_CHANGE_TOPIC, handler);
  }, [messageBus]);
  var registerHighlightChangeHandler = useCallback(function (handler) {
    return messageBus.subscribe(HIGHLIGHT_CHANGE_TOPIC, handler);
  }, [messageBus]);
  return {
    notifySelectionChanged: notifySelectionChanged,
    notifyHighlightChanged: notifyHighlightChanged,
    registerSelectionChangeHandler: registerSelectionChangeHandler,
    registerHighlightChangeHandler: registerHighlightChangeHandler
  };
}

function areEqual(a, b) {
  return a === b;
}
var EMPTY_OBJECT = {};
var NOOP = function NOOP() {};
function getControlledState(internalState, controlledProps) {
  var augmentedState = _extends$1({}, internalState);
  Object.keys(controlledProps).forEach(function (key) {
    if (controlledProps[key] !== undefined) {
      augmentedState[key] = controlledProps[key];
    }
  });
  return augmentedState;
}
function useStateChangeDetection(parameters) {
  var nextState = parameters.nextState,
    initialState = parameters.initialState,
    stateComparers = parameters.stateComparers,
    onStateChange = parameters.onStateChange,
    controlledProps = parameters.controlledProps,
    lastActionRef = parameters.lastActionRef;
  var internalPreviousStateRef = useRef(initialState);
  useEffect(function () {
    if (lastActionRef.current === null) {
      return;
    }
    var previousState = getControlledState(internalPreviousStateRef.current, controlledProps);
    Object.keys(nextState).forEach(function (key) {
      var _stateComparers$key;
      var stateComparer = (_stateComparers$key = stateComparers[key]) != null ? _stateComparers$key : areEqual;
      var nextStateItem = nextState[key];
      var previousStateItem = previousState[key];
      if (previousStateItem == null && nextStateItem != null || previousStateItem != null && nextStateItem == null || previousStateItem != null && nextStateItem != null && !stateComparer(nextStateItem, previousStateItem)) {
        var _event, _type;
        onStateChange == null || onStateChange((_event = lastActionRef.current.event) != null ? _event : null, key, nextStateItem, (_type = lastActionRef.current.type) != null ? _type : '', nextState);
      }
    });
    internalPreviousStateRef.current = nextState;
    lastActionRef.current = null;
  }, [internalPreviousStateRef, nextState, lastActionRef, onStateChange, stateComparers, controlledProps]);
}
function useControllableReducer(parameters) {
  var lastActionRef = useRef(null);
  var reducer = parameters.reducer,
    initialState = parameters.initialState,
    _parameters$controlle = parameters.controlledProps,
    controlledProps = _parameters$controlle === void 0 ? EMPTY_OBJECT : _parameters$controlle,
    _parameters$stateComp = parameters.stateComparers,
    stateComparers = _parameters$stateComp === void 0 ? EMPTY_OBJECT : _parameters$stateComp,
    _parameters$onStateCh = parameters.onStateChange,
    onStateChange = _parameters$onStateCh === void 0 ? NOOP : _parameters$onStateCh,
    actionContext = parameters.actionContext;
  var reducerWithControlledState = useCallback(function (state, action) {
    lastActionRef.current = action;
    var controlledState = getControlledState(state, controlledProps);
    var newState = reducer(controlledState, action);
    return newState;
  }, [controlledProps, reducer]);
  var _React$useReducer = useReducer(reducerWithControlledState, initialState),
    nextState = _React$useReducer[0],
    dispatch = _React$useReducer[1];
  var dispatchWithContext = useCallback(function (action) {
    dispatch(_extends$1({}, action, {
      context: actionContext
    }));
  }, [actionContext]);
  useStateChangeDetection({
    nextState: nextState,
    initialState: initialState,
    stateComparers: stateComparers != null ? stateComparers : EMPTY_OBJECT,
    onStateChange: onStateChange != null ? onStateChange : NOOP,
    controlledProps: controlledProps,
    lastActionRef: lastActionRef
  });
  return [getControlledState(nextState, controlledProps), dispatchWithContext];
}

function useLatest(value, deps) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, deps != null ? deps : [value]);
  return ref;
}

var TEXT_NAVIGATION_RESET_TIMEOUT = 500;
function useTextNavigation(callback) {
  var textCriteriaRef = useRef({
    searchString: '',
    lastTime: null
  });
  return useCallback(function (event) {
    if (event.key.length === 1 && event.key !== ' ') {
      var textCriteria = textCriteriaRef.current;
      var lowerKey = event.key.toLowerCase();
      var currentTime = performance.now();
      if (textCriteria.searchString.length > 0 && textCriteria.lastTime && currentTime - textCriteria.lastTime > TEXT_NAVIGATION_RESET_TIMEOUT) {
        textCriteria.searchString = lowerKey;
      } else if (textCriteria.searchString.length !== 1 || lowerKey !== textCriteria.searchString) {
        textCriteria.searchString += lowerKey;
      }
      textCriteria.lastTime = currentTime;
      callback(textCriteria.searchString, event);
    }
  }, [callback]);
}

var EMPTY_OBJECT$1 = {};
var NOOP$1 = function NOOP() {};
var defaultItemComparer = function defaultItemComparer(optionA, optionB) {
  return optionA === optionB;
};
var defaultIsItemDisabled = function defaultIsItemDisabled() {
  return false;
};
var defaultItemStringifier = function defaultItemStringifier(item) {
  return typeof item === 'string' ? item : String(item);
};
var defaultGetInitialState = function defaultGetInitialState() {
  return {
    highlightedValue: null,
    selectedValues: []
  };
};
function useList(params) {
  var _params$controlledPro = params.controlledProps,
    controlledProps = _params$controlledPro === void 0 ? EMPTY_OBJECT$1 : _params$controlledPro,
    _params$disabledItems = params.disabledItemsFocusable,
    disabledItemsFocusable = _params$disabledItems === void 0 ? false : _params$disabledItems,
    _params$disableListWr = params.disableListWrap,
    disableListWrap = _params$disableListWr === void 0 ? false : _params$disableListWr,
    _params$focusManageme = params.focusManagement,
    focusManagement = _params$focusManageme === void 0 ? 'activeDescendant' : _params$focusManageme,
    _params$getInitialSta = params.getInitialState,
    getInitialState = _params$getInitialSta === void 0 ? defaultGetInitialState : _params$getInitialSta,
    getItemDomElement = params.getItemDomElement,
    getItemId = params.getItemId,
    _params$isItemDisable = params.isItemDisabled,
    isItemDisabled = _params$isItemDisable === void 0 ? defaultIsItemDisabled : _params$isItemDisable,
    externalListRef = params.rootRef,
    _params$onStateChange = params.onStateChange,
    onStateChange = _params$onStateChange === void 0 ? NOOP$1 : _params$onStateChange,
    items = params.items,
    _params$itemComparer = params.itemComparer,
    itemComparer = _params$itemComparer === void 0 ? defaultItemComparer : _params$itemComparer,
    _params$getItemAsStri = params.getItemAsString,
    getItemAsString = _params$getItemAsStri === void 0 ? defaultItemStringifier : _params$getItemAsStri,
    onChange = params.onChange,
    onHighlightChange = params.onHighlightChange,
    onItemsChange = params.onItemsChange,
    _params$orientation = params.orientation,
    orientation = _params$orientation === void 0 ? 'vertical' : _params$orientation,
    _params$pageSize = params.pageSize,
    pageSize = _params$pageSize === void 0 ? 5 : _params$pageSize,
    _params$reducerAction = params.reducerActionContext,
    reducerActionContext = _params$reducerAction === void 0 ? EMPTY_OBJECT$1 : _params$reducerAction,
    _params$selectionMode = params.selectionMode,
    selectionMode = _params$selectionMode === void 0 ? 'single' : _params$selectionMode,
    externalReducer = params.stateReducer;
  if (process.env.NODE_ENV !== 'production') {
    if (focusManagement === 'DOM' && getItemDomElement == null) {
      throw new Error('useList: The `getItemDomElement` prop is required when using the `DOM` focus management.');
    }
    if (focusManagement === 'activeDescendant' && getItemId == null) {
      throw new Error('useList: The `getItemId` prop is required when using the `activeDescendant` focus management.');
    }
  }
  var listRef = useRef(null);
  var handleRef = useForkRef(externalListRef, listRef);
  var handleHighlightChange = useCallback(function (event, value, reason) {
    onHighlightChange == null || onHighlightChange(event, value, reason);
    if (focusManagement === 'DOM' && value != null && (reason === ListActionTypes.itemClick || reason === ListActionTypes.keyDown || reason === ListActionTypes.textNavigation)) {
      var _getItemDomElement;
      getItemDomElement == null || (_getItemDomElement = getItemDomElement(value)) == null || _getItemDomElement.focus();
    }
  }, [getItemDomElement, onHighlightChange, focusManagement]);
  var stateComparers = useMemo(function () {
    return {
      highlightedValue: itemComparer,
      selectedValues: function selectedValues(valuesArray1, valuesArray2) {
        return areArraysEqual(valuesArray1, valuesArray2, itemComparer);
      }
    };
  }, [itemComparer]);
  var handleStateChange = useCallback(function (event, field, value, reason, state) {
    onStateChange == null || onStateChange(event, field, value, reason, state);
    switch (field) {
      case 'highlightedValue':
        handleHighlightChange(event, value, reason);
        break;
      case 'selectedValues':
        onChange == null || onChange(event, value, reason);
        break;
    }
  }, [handleHighlightChange, onChange, onStateChange]);
  var listActionContext = useMemo(function () {
    return {
      disabledItemsFocusable: disabledItemsFocusable,
      disableListWrap: disableListWrap,
      focusManagement: focusManagement,
      isItemDisabled: isItemDisabled,
      itemComparer: itemComparer,
      items: items,
      getItemAsString: getItemAsString,
      onHighlightChange: handleHighlightChange,
      orientation: orientation,
      pageSize: pageSize,
      selectionMode: selectionMode,
      stateComparers: stateComparers
    };
  }, [disabledItemsFocusable, disableListWrap, focusManagement, isItemDisabled, itemComparer, items, getItemAsString, handleHighlightChange, orientation, pageSize, selectionMode, stateComparers]);
  var initialState = getInitialState();
  var reducer = externalReducer != null ? externalReducer : listReducer;
  var actionContext = useMemo(function () {
    return _extends$1({}, reducerActionContext, listActionContext);
  }, [reducerActionContext, listActionContext]);
  var _useControllableReduc = useControllableReducer({
      reducer: reducer,
      actionContext: actionContext,
      initialState: initialState,
      controlledProps: controlledProps,
      stateComparers: stateComparers,
      onStateChange: handleStateChange
    }),
    state = _useControllableReduc[0],
    dispatch = _useControllableReduc[1];
  var highlightedValue = state.highlightedValue,
    selectedValues = state.selectedValues;
  var handleTextNavigation = useTextNavigation(function (searchString, event) {
    return dispatch({
      type: ListActionTypes.textNavigation,
      event: event,
      searchString: searchString
    });
  });
  var latestSelectedValues = useLatest(selectedValues);
  var latestHighlightedValue = useLatest(highlightedValue);
  var previousItems = useRef([]);
  useEffect(function () {
    if (areArraysEqual(previousItems.current, items, itemComparer)) {
      return;
    }
    dispatch({
      type: ListActionTypes.itemsChange,
      event: null,
      items: items,
      previousItems: previousItems.current
    });
    previousItems.current = items;
    onItemsChange == null || onItemsChange(items);
  }, [items, itemComparer, dispatch, onItemsChange]);
  var _useListChangeNotifie = useListChangeNotifiers(),
    notifySelectionChanged = _useListChangeNotifie.notifySelectionChanged,
    notifyHighlightChanged = _useListChangeNotifie.notifyHighlightChanged,
    registerHighlightChangeHandler = _useListChangeNotifie.registerHighlightChangeHandler,
    registerSelectionChangeHandler = _useListChangeNotifie.registerSelectionChangeHandler;
  useEffect(function () {
    notifySelectionChanged(selectedValues);
  }, [selectedValues, notifySelectionChanged]);
  useEffect(function () {
    notifyHighlightChanged(highlightedValue);
  }, [highlightedValue, notifyHighlightChanged]);
  var createHandleKeyDown = function createHandleKeyDown(externalHandlers) {
    return function (event) {
      var _externalHandlers$onK;
      (_externalHandlers$onK = externalHandlers.onKeyDown) == null || _externalHandlers$onK.call(externalHandlers, event);
      if (event.defaultMuiPrevented) {
        return;
      }
      var keysToPreventDefault = ['Home', 'End', 'PageUp', 'PageDown'];
      if (orientation === 'vertical') {
        keysToPreventDefault.push('ArrowUp', 'ArrowDown');
      } else {
        keysToPreventDefault.push('ArrowLeft', 'ArrowRight');
      }
      if (focusManagement === 'activeDescendant') {
        keysToPreventDefault.push(' ', 'Enter');
      }
      if (keysToPreventDefault.includes(event.key)) {
        event.preventDefault();
      }
      dispatch({
        type: ListActionTypes.keyDown,
        key: event.key,
        event: event
      });
      handleTextNavigation(event);
    };
  };
  var createHandleBlur = function createHandleBlur(externalHandlers) {
    return function (event) {
      var _externalHandlers$onB, _listRef$current;
      (_externalHandlers$onB = externalHandlers.onBlur) == null || _externalHandlers$onB.call(externalHandlers, event);
      if (event.defaultMuiPrevented) {
        return;
      }
      if ((_listRef$current = listRef.current) != null && _listRef$current.contains(event.relatedTarget)) {
        return;
      }
      dispatch({
        type: ListActionTypes.blur,
        event: event
      });
    };
  };
  var getRootProps = function getRootProps(externalProps) {
    if (externalProps === void 0) {
      externalProps = {};
    }
    var externalEventHandlers = extractEventHandlers(externalProps);
    return _extends$1({}, externalProps, {
      'aria-activedescendant': focusManagement === 'activeDescendant' && highlightedValue != null ? getItemId(highlightedValue) : undefined,
      tabIndex: focusManagement === 'DOM' ? -1 : 0,
      ref: handleRef
    }, externalEventHandlers, {
      onBlur: createHandleBlur(externalEventHandlers),
      onKeyDown: createHandleKeyDown(externalEventHandlers)
    });
  };
  var getItemState = useCallback(function (item) {
    var _latestSelectedValues;
    var index = items.findIndex(function (i) {
      return itemComparer(i, item);
    });
    var selected = ((_latestSelectedValues = latestSelectedValues.current) != null ? _latestSelectedValues : []).some(function (value) {
      return value != null && itemComparer(item, value);
    });
    var disabled = isItemDisabled(item, index);
    var highlighted = latestHighlightedValue.current != null && itemComparer(item, latestHighlightedValue.current);
    var focusable = focusManagement === 'DOM';
    return {
      disabled: disabled,
      focusable: focusable,
      highlighted: highlighted,
      index: index,
      selected: selected
    };
  }, [items, isItemDisabled, itemComparer, latestSelectedValues, latestHighlightedValue, focusManagement]);
  var contextValue = useMemo(function () {
    return {
      dispatch: dispatch,
      getItemState: getItemState,
      registerHighlightChangeHandler: registerHighlightChangeHandler,
      registerSelectionChangeHandler: registerSelectionChangeHandler
    };
  }, [dispatch, getItemState, registerHighlightChangeHandler, registerSelectionChangeHandler]);
  useDebugValue({
    state: state
  });
  return {
    contextValue: contextValue,
    dispatch: dispatch,
    getRootProps: getRootProps,
    rootRef: handleRef,
    state: state
  };
}

function useForcedRerendering() {
  var _React$useState = useState({}),
    setState = _React$useState[1];
  return useCallback(function () {
    setState({});
  }, []);
}

var ListContext = /*#__PURE__*/createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}

function useListItem(parameters) {
  var _parameters$handlePoi = parameters.handlePointerOverEvents,
    handlePointerOverEvents = _parameters$handlePoi === void 0 ? false : _parameters$handlePoi,
    item = parameters.item,
    externalRef = parameters.rootRef;
  var itemRef = useRef(null);
  var handleRef = useForkRef(itemRef, externalRef);
  var listContext = useContext(ListContext);
  if (!listContext) {
    throw new Error('useListItem must be used within a ListProvider');
  }
  var dispatch = listContext.dispatch,
    getItemState = listContext.getItemState,
    registerHighlightChangeHandler = listContext.registerHighlightChangeHandler,
    registerSelectionChangeHandler = listContext.registerSelectionChangeHandler;
  var _getItemState = getItemState(item),
    highlighted = _getItemState.highlighted,
    selected = _getItemState.selected,
    focusable = _getItemState.focusable;
  var rerender = useForcedRerendering();
  useEnhancedEffect(function () {
    function updateHighlightedState(highlightedItem) {
      if (highlightedItem === item && !highlighted) {
        rerender();
      } else if (highlightedItem !== item && highlighted) {
        rerender();
      }
    }
    return registerHighlightChangeHandler(updateHighlightedState);
  });
  useEnhancedEffect(function () {
    function updateSelectedState(selectedItems) {
      if (!selected) {
        if (selectedItems.includes(item)) {
          rerender();
        }
      } else if (!selectedItems.includes(item)) {
        rerender();
      }
    }
    return registerSelectionChangeHandler(updateSelectedState);
  }, [registerSelectionChangeHandler, rerender, selected, item]);
  var createHandleClick = useCallback(function (externalHandlers) {
    return function (event) {
      var _externalHandlers$onC;
      (_externalHandlers$onC = externalHandlers.onClick) == null || _externalHandlers$onC.call(externalHandlers, event);
      if (event.defaultPrevented) {
        return;
      }
      dispatch({
        type: ListActionTypes.itemClick,
        item: item,
        event: event
      });
    };
  }, [dispatch, item]);
  var createHandlePointerOver = useCallback(function (externalHandlers) {
    return function (event) {
      var _externalHandlers$onM;
      (_externalHandlers$onM = externalHandlers.onMouseOver) == null || _externalHandlers$onM.call(externalHandlers, event);
      if (event.defaultPrevented) {
        return;
      }
      dispatch({
        type: ListActionTypes.itemHover,
        item: item,
        event: event
      });
    };
  }, [dispatch, item]);
  var tabIndex;
  if (focusable) {
    tabIndex = highlighted ? 0 : -1;
  }
  var getRootProps = function getRootProps(externalProps) {
    if (externalProps === void 0) {
      externalProps = {};
    }
    var externalEventHandlers = extractEventHandlers(externalProps);
    return _extends$1({}, externalProps, {
      onClick: createHandleClick(externalEventHandlers),
      onPointerOver: handlePointerOverEvents ? createHandlePointerOver(externalEventHandlers) : undefined,
      ref: handleRef,
      tabIndex: tabIndex
    });
  };
  return {
    getRootProps: getRootProps,
    highlighted: highlighted,
    rootRef: handleRef,
    selected: selected
  };
}

var CompoundComponentContext = /*#__PURE__*/createContext(null);
CompoundComponentContext.displayName = 'CompoundComponentContext';
function sortSubitems(subitems) {
  var subitemsArray = Array.from(subitems.keys()).map(function (key) {
    var subitem = subitems.get(key);
    return {
      key: key,
      subitem: subitem
    };
  });
  subitemsArray.sort(function (a, b) {
    var aNode = a.subitem.ref.current;
    var bNode = b.subitem.ref.current;
    if (aNode === null || bNode === null || aNode === bNode) {
      return 0;
    }
    return aNode.compareDocumentPosition(bNode) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1;
  });
  return new Map(subitemsArray.map(function (item) {
    return [item.key, item.subitem];
  }));
}
function useCompoundParent() {
  var _React$useState = useState(new Map()),
    subitems = _React$useState[0],
    setSubitems = _React$useState[1];
  var subitemKeys = useRef(new Set());
  var deregisterItem = useCallback(function deregisterItem(id) {
    subitemKeys.current.delete(id);
    setSubitems(function (previousState) {
      var newState = new Map(previousState);
      newState.delete(id);
      return newState;
    });
  }, []);
  var registerItem = useCallback(function registerItem(id, item) {
    var providedOrGeneratedId;
    if (typeof id === 'function') {
      providedOrGeneratedId = id(subitemKeys.current);
    } else {
      providedOrGeneratedId = id;
    }
    subitemKeys.current.add(providedOrGeneratedId);
    setSubitems(function (previousState) {
      var newState = new Map(previousState);
      newState.set(providedOrGeneratedId, item);
      return newState;
    });
    return {
      id: providedOrGeneratedId,
      deregister: function deregister() {
        return deregisterItem(providedOrGeneratedId);
      }
    };
  }, [deregisterItem]);
  var sortedSubitems = useMemo(function () {
    return sortSubitems(subitems);
  }, [subitems]);
  var getItemIndex = useCallback(function getItemIndex(id) {
    return Array.from(sortedSubitems.keys()).indexOf(id);
  }, [sortedSubitems]);
  var contextValue = useMemo(function () {
    return {
      getItemIndex: getItemIndex,
      registerItem: registerItem,
      totalSubitemCount: subitems.size
    };
  }, [getItemIndex, registerItem, subitems.size]);
  return {
    contextValue: contextValue,
    subitems: sortedSubitems
  };
}

function useCompoundItem(id, itemMetadata) {
  var context = useContext(CompoundComponentContext);
  if (context === null) {
    throw new Error('useCompoundItem must be used within a useCompoundParent');
  }
  var registerItem = context.registerItem;
  var _React$useState = useState(typeof id === 'function' ? undefined : id),
    registeredId = _React$useState[0],
    setRegisteredId = _React$useState[1];
  useEnhancedEffect(function () {
    var _registerItem = registerItem(id, itemMetadata),
      returnedId = _registerItem.id,
      deregister = _registerItem.deregister;
    setRegisteredId(returnedId);
    return deregister;
  }, [registerItem, itemMetadata, id]);
  return {
    id: registeredId,
    index: registeredId !== undefined ? context.getItemIndex(registeredId) : -1,
    totalItemCount: context.totalSubitemCount
  };
}

function useOption(params) {
  var value = params.value,
    label = params.label,
    disabled = params.disabled,
    optionRefParam = params.rootRef,
    idParam = params.id;
  var _useListItem = useListItem({
      item: value
    }),
    getListItemProps = _useListItem.getRootProps,
    listItemRefHandler = _useListItem.rootRef,
    highlighted = _useListItem.highlighted,
    selected = _useListItem.selected;
  var id = useId(idParam);
  var optionRef = useRef(null);
  var selectOption = useMemo(function () {
    return {
      disabled: disabled,
      label: label,
      value: value,
      ref: optionRef,
      id: id
    };
  }, [disabled, label, value, id]);
  var _useCompoundItem = useCompoundItem(value, selectOption),
    index = _useCompoundItem.index;
  var handleRef = useForkRef(optionRefParam, optionRef, listItemRefHandler);
  return {
    getRootProps: function getRootProps(otherHandlers) {
      if (otherHandlers === void 0) {
        otherHandlers = {};
      }
      return _extends$1({}, otherHandlers, getListItemProps(otherHandlers), {
        id: id,
        ref: handleRef,
        role: 'option',
        'aria-selected': selected
      });
    },
    highlighted: highlighted,
    index: index,
    selected: selected,
    rootRef: handleRef
  };
}

var _excluded$h = ["children", "disabled", "label", "slotProps", "slots", "value"];
function useUtilityClasses(ownerState) {
  var disabled = ownerState.disabled,
    highlighted = ownerState.highlighted,
    selected = ownerState.selected;
  var slots = {
    root: ['root', disabled && 'disabled', highlighted && 'highlighted', selected && 'selected']
  };
  return composeClasses(slots, useClassNamesOverride(getOptionUtilityClass));
}
var Option = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Option(props, forwardedRef) {
  var _slots$root, _optionRef$current;
  var children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    label = props.label,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    value = props.value,
    other = _objectWithoutPropertiesLoose$1(props, _excluded$h);
  var Root = (_slots$root = slots.root) != null ? _slots$root : 'li';
  var optionRef = useRef(null);
  var combinedRef = useForkRef(optionRef, forwardedRef);
  var computedLabel = label != null ? label : typeof children === 'string' ? children : (_optionRef$current = optionRef.current) == null ? void 0 : _optionRef$current.innerText;
  var _useOption = useOption({
      disabled: disabled,
      label: computedLabel,
      rootRef: combinedRef,
      value: value
    }),
    getRootProps = _useOption.getRootProps,
    selected = _useOption.selected,
    highlighted = _useOption.highlighted,
    index = _useOption.index;
  var ownerState = _extends$1({}, props, {
    disabled: disabled,
    highlighted: highlighted,
    index: index,
    selected: selected
  });
  var classes = useUtilityClasses(ownerState);
  var rootProps = useSlotProps({
    getSlotProps: getRootProps,
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    className: classes.root,
    ownerState: ownerState
  });
  return /*#__PURE__*/jsx(Root, _extends$1({}, rootProps, {
    children: children
  }));
}));
process.env.NODE_ENV !== "production" ? Option.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  disabled: propTypes.bool,
  label: propTypes.string,
  slotProps: propTypes.shape({
    root: propTypes.oneOfType([propTypes.func, propTypes.object])
  }),
  slots: propTypes.shape({
    root: propTypes.elementType
  }),
  value: propTypes.any.isRequired
} : void 0;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead';
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain';
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement$1(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement$1(element) ? getWindow(element) : window,
    visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  return ((isElement$1(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode);
    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
};
function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
    y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
}
var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};
function effect$2(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
}
var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$2,
  data: {}
};

var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$1(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement$1(clipperElement)) {
    return [];
  }
  return clippingParents.filter(function (clippingParent) {
    return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];
  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state,
    name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
}
var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
    skidding = _ref[0],
    distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {});
  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper;
        if (!areValidElements(reference, popper)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
          _ref$options = _ref.options,
          options = _ref$options === void 0 ? {} : _ref$options,
          effect = _ref.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
});

function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
var Portal$1 = /*#__PURE__*/forwardRef(function Portal(props, forwardedRef) {
  var children = props.children,
    container = props.container,
    _props$disablePortal = props.disablePortal,
    disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;
  var _React$useState = useState(null),
    mountNode = _React$useState[0],
    setMountNode = _React$useState[1];
  var handleRef = useForkRef( /*#__PURE__*/isValidElement(children) ? children.ref : null, forwardedRef);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      setRef(forwardedRef, mountNode);
      return function () {
        setRef(forwardedRef, null);
      };
    }
    return undefined;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if ( /*#__PURE__*/isValidElement(children)) {
      var newProps = {
        ref: handleRef
      };
      return /*#__PURE__*/cloneElement(children, newProps);
    }
    return /*#__PURE__*/jsx(Fragment$1, {
      children: children
    });
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: mountNode ? /*#__PURE__*/createPortal(children, mountNode) : mountNode
  });
});
process.env.NODE_ENV !== "production" ? Portal$1.propTypes = {
  children: propTypes.node,
  container: propTypes.oneOfType([HTMLElementType, propTypes.func]),
  disablePortal: propTypes.bool
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  Portal$1['propTypes' + ''] = exactProp(Portal$1.propTypes);
}

function getPopperUtilityClass(slot) {
  return generateUtilityClass('MuiPopper', slot);
}
var popperClasses = generateUtilityClasses('MuiPopper', ['root']);

var _excluded$i = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"],
  _excluded2$2 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function flipPlacement(placement, direction) {
  if (direction === 'ltr') {
    return placement;
  }
  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';
    case 'bottom-start':
      return 'bottom-end';
    case 'top-end':
      return 'top-start';
    case 'top-start':
      return 'top-end';
    default:
      return placement;
  }
}
function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function isHTMLElement$1(element) {
  return element.nodeType !== undefined;
}
function isVirtualElement(element) {
  return !isHTMLElement$1(element);
}
var useUtilityClasses$1 = function useUtilityClasses() {
  var slots = {
    root: ['root']
  };
  return composeClasses(slots, useClassNamesOverride(getPopperUtilityClass));
};
var defaultPopperOptions = {};
var PopperTooltip = /*#__PURE__*/forwardRef(function PopperTooltip(props, forwardedRef) {
  var _slots$root;
  var anchorEl = props.anchorEl,
    children = props.children,
    direction = props.direction,
    disablePortal = props.disablePortal,
    modifiers = props.modifiers,
    open = props.open,
    initialPlacement = props.placement,
    popperOptions = props.popperOptions,
    popperRefProp = props.popperRef,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    TransitionProps = props.TransitionProps,
    other = _objectWithoutPropertiesLoose$1(props, _excluded$i);
  var tooltipRef = useRef(null);
  var ownRef = useForkRef(tooltipRef, forwardedRef);
  var popperRef = useRef(null);
  var handlePopperRef = useForkRef(popperRef, popperRefProp);
  var handlePopperRefRef = useRef(handlePopperRef);
  useEnhancedEffect(function () {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  useImperativeHandle(popperRefProp, function () {
    return popperRef.current;
  }, []);
  var rtlPlacement = flipPlacement(initialPlacement, direction);
  var _React$useState = useState(rtlPlacement),
    placement = _React$useState[0],
    setPlacement = _React$useState[1];
  var _React$useState2 = useState(resolveAnchorEl(anchorEl)),
    resolvedAnchorElement = _React$useState2[0],
    setResolvedAnchorElement = _React$useState2[1];
  useEffect(function () {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  useEffect(function () {
    if (anchorEl) {
      setResolvedAnchorElement(resolveAnchorEl(anchorEl));
    }
  }, [anchorEl]);
  useEnhancedEffect(function () {
    if (!resolvedAnchorElement || !open) {
      return undefined;
    }
    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };
    if (process.env.NODE_ENV !== 'production') {
      if (resolvedAnchorElement && isHTMLElement$1(resolvedAnchorElement) && resolvedAnchorElement.nodeType === 1) {
        var box = resolvedAnchorElement.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }
    var popperModifiers = [{
      name: 'preventOverflow',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'flip',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'onUpdate',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref) {
        var state = _ref.state;
        handlePopperUpdate(state);
      }
    }];
    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }
    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }
    var popper = createPopper(resolvedAnchorElement, tooltipRef.current, _extends$1({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: popperModifiers
    }));
    handlePopperRefRef.current(popper);
    return function () {
      popper.destroy();
      handlePopperRefRef.current(null);
    };
  }, [resolvedAnchorElement, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
  var childProps = {
    placement: placement
  };
  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }
  var classes = useUtilityClasses$1();
  var Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
  var rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      role: 'tooltip',
      ref: ownRef
    },
    ownerState: props,
    className: classes.root
  });
  return /*#__PURE__*/jsx(Root, _extends$1({}, rootProps, {
    children: typeof children === 'function' ? children(childProps) : children
  }));
});
var Popper = /*#__PURE__*/forwardRef(function Popper(props, forwardedRef) {
  var anchorEl = props.anchorEl,
    children = props.children,
    containerProp = props.container,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'ltr' : _props$direction,
    _props$disablePortal = props.disablePortal,
    disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
    _props$keepMounted = props.keepMounted,
    keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
    modifiers = props.modifiers,
    open = props.open,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'bottom' : _props$placement,
    _props$popperOptions = props.popperOptions,
    popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
    popperRef = props.popperRef,
    style = props.style,
    _props$transition = props.transition,
    transition = _props$transition === void 0 ? false : _props$transition,
    _props$slotProps2 = props.slotProps,
    slotProps = _props$slotProps2 === void 0 ? {} : _props$slotProps2,
    _props$slots2 = props.slots,
    slots = _props$slots2 === void 0 ? {} : _props$slots2,
    other = _objectWithoutPropertiesLoose$1(props, _excluded2$2);
  var _React$useState3 = useState(true),
    exited = _React$useState3[0],
    setExited = _React$useState3[1];
  var handleEnter = function handleEnter() {
    setExited(false);
  };
  var handleExited = function handleExited() {
    setExited(true);
  };
  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }
  var container;
  if (containerProp) {
    container = containerProp;
  } else if (anchorEl) {
    var resolvedAnchorEl = resolveAnchorEl(anchorEl);
    container = resolvedAnchorEl && isHTMLElement$1(resolvedAnchorEl) ? ownerDocument(resolvedAnchorEl).body : ownerDocument(null).body;
  }
  var display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
  var transitionProps = transition ? {
    in: open,
    onEnter: handleEnter,
    onExited: handleExited
  } : undefined;
  return /*#__PURE__*/jsx(Portal$1, {
    disablePortal: disablePortal,
    container: container,
    children: /*#__PURE__*/jsx(PopperTooltip, _extends$1({
      anchorEl: anchorEl,
      direction: direction,
      disablePortal: disablePortal,
      modifiers: modifiers,
      ref: forwardedRef,
      open: transition ? !exited : open,
      placement: placement,
      popperOptions: popperOptions,
      popperRef: popperRef,
      slotProps: slotProps,
      slots: slots
    }, other, {
      style: _extends$1({
        position: 'fixed',
        top: 0,
        left: 0,
        display: display
      }, style),
      TransitionProps: transitionProps,
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? Popper.propTypes = {
  anchorEl: chainPropTypes(propTypes.oneOfType([HTMLElementType, propTypes.object, propTypes.func]), function (props) {
    if (props.open) {
      var resolvedAnchorEl = resolveAnchorEl(props.anchorEl);
      if (resolvedAnchorEl && isHTMLElement$1(resolvedAnchorEl) && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== 'function' || isVirtualElement(resolvedAnchorEl) && resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) {
        return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a virtualElement ', '(https://popper.js.org/docs/v2/virtual-elements/).'].join('\n'));
      }
    }
    return null;
  }),
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  container: propTypes.oneOfType([HTMLElementType, propTypes.func]),
  direction: propTypes.oneOf(['ltr', 'rtl']),
  disablePortal: propTypes.bool,
  keepMounted: propTypes.bool,
  modifiers: propTypes.arrayOf(propTypes.shape({
    data: propTypes.object,
    effect: propTypes.func,
    enabled: propTypes.bool,
    fn: propTypes.func,
    name: propTypes.any,
    options: propTypes.object,
    phase: propTypes.oneOf(['afterMain', 'afterRead', 'afterWrite', 'beforeMain', 'beforeRead', 'beforeWrite', 'main', 'read', 'write']),
    requires: propTypes.arrayOf(propTypes.string),
    requiresIfExists: propTypes.arrayOf(propTypes.string)
  })),
  open: propTypes.bool.isRequired,
  placement: propTypes.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  popperOptions: propTypes.shape({
    modifiers: propTypes.array,
    onFirstUpdate: propTypes.func,
    placement: propTypes.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
    strategy: propTypes.oneOf(['absolute', 'fixed'])
  }),
  popperRef: refType,
  slotProps: propTypes.shape({
    root: propTypes.oneOfType([propTypes.func, propTypes.object])
  }),
  slots: propTypes.shape({
    root: propTypes.elementType
  }),
  transition: propTypes.bool
} : void 0;

function useButton(parameters) {
  if (parameters === void 0) {
    parameters = {};
  }
  var _parameters = parameters,
    _parameters$disabled = _parameters.disabled,
    disabled = _parameters$disabled === void 0 ? false : _parameters$disabled,
    focusableWhenDisabled = _parameters.focusableWhenDisabled,
    href = _parameters.href,
    externalRef = _parameters.rootRef,
    tabIndex = _parameters.tabIndex,
    to = _parameters.to,
    type = _parameters.type;
  var buttonRef = useRef();
  var _React$useState = useState(false),
    active = _React$useState[0],
    setActive = _React$useState[1];
  var _useIsFocusVisible = useIsFocusVisible(),
    isFocusVisibleRef = _useIsFocusVisible.isFocusVisibleRef,
    handleFocusVisible = _useIsFocusVisible.onFocus,
    handleBlurVisible = _useIsFocusVisible.onBlur,
    focusVisibleRef = _useIsFocusVisible.ref;
  var _React$useState2 = useState(false),
    focusVisible = _React$useState2[0],
    setFocusVisible = _React$useState2[1];
  if (disabled && !focusableWhenDisabled && focusVisible) {
    setFocusVisible(false);
  }
  useEffect(function () {
    isFocusVisibleRef.current = focusVisible;
  }, [focusVisible, isFocusVisibleRef]);
  var _React$useState3 = useState(''),
    hostElementName = _React$useState3[0],
    setHostElementName = _React$useState3[1];
  var createHandleMouseLeave = function createHandleMouseLeave(otherHandlers) {
    return function (event) {
      var _otherHandlers$onMous;
      if (focusVisible) {
        event.preventDefault();
      }
      (_otherHandlers$onMous = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous.call(otherHandlers, event);
    };
  };
  var createHandleBlur = function createHandleBlur(otherHandlers) {
    return function (event) {
      var _otherHandlers$onBlur;
      handleBlurVisible(event);
      if (isFocusVisibleRef.current === false) {
        setFocusVisible(false);
      }
      (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
    };
  };
  var createHandleFocus = function createHandleFocus(otherHandlers) {
    return function (event) {
      var _otherHandlers$onFocu2;
      if (!buttonRef.current) {
        buttonRef.current = event.currentTarget;
      }
      handleFocusVisible(event);
      if (isFocusVisibleRef.current === true) {
        var _otherHandlers$onFocu;
        setFocusVisible(true);
        (_otherHandlers$onFocu = otherHandlers.onFocusVisible) == null || _otherHandlers$onFocu.call(otherHandlers, event);
      }
      (_otherHandlers$onFocu2 = otherHandlers.onFocus) == null || _otherHandlers$onFocu2.call(otherHandlers, event);
    };
  };
  var isNativeButton = function isNativeButton() {
    var button = buttonRef.current;
    return hostElementName === 'BUTTON' || hostElementName === 'INPUT' && ['button', 'submit', 'reset'].includes(button == null ? void 0 : button.type) || hostElementName === 'A' && (button == null ? void 0 : button.href);
  };
  var createHandleClick = function createHandleClick(otherHandlers) {
    return function (event) {
      if (!disabled) {
        var _otherHandlers$onClic;
        (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
      }
    };
  };
  var createHandleMouseDown = function createHandleMouseDown(otherHandlers) {
    return function (event) {
      var _otherHandlers$onMous2;
      if (!disabled) {
        setActive(true);
        document.addEventListener('mouseup', function () {
          setActive(false);
        }, {
          once: true
        });
      }
      (_otherHandlers$onMous2 = otherHandlers.onMouseDown) == null || _otherHandlers$onMous2.call(otherHandlers, event);
    };
  };
  var createHandleKeyDown = function createHandleKeyDown(otherHandlers) {
    return function (event) {
      var _otherHandlers$onKeyD;
      (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
      if (event.defaultMuiPrevented) {
        return;
      }
      if (event.target === event.currentTarget && !isNativeButton() && event.key === ' ') {
        event.preventDefault();
      }
      if (event.target === event.currentTarget && event.key === ' ' && !disabled) {
        setActive(true);
      }
      if (event.target === event.currentTarget && !isNativeButton() && event.key === 'Enter' && !disabled) {
        var _otherHandlers$onClic2;
        (_otherHandlers$onClic2 = otherHandlers.onClick) == null || _otherHandlers$onClic2.call(otherHandlers, event);
        event.preventDefault();
      }
    };
  };
  var createHandleKeyUp = function createHandleKeyUp(otherHandlers) {
    return function (event) {
      var _otherHandlers$onKeyU;
      if (event.target === event.currentTarget) {
        setActive(false);
      }
      (_otherHandlers$onKeyU = otherHandlers.onKeyUp) == null || _otherHandlers$onKeyU.call(otherHandlers, event);
      if (event.target === event.currentTarget && !isNativeButton() && !disabled && event.key === ' ' && !event.defaultMuiPrevented) {
        var _otherHandlers$onClic3;
        (_otherHandlers$onClic3 = otherHandlers.onClick) == null || _otherHandlers$onClic3.call(otherHandlers, event);
      }
    };
  };
  var updateHostElementName = useCallback(function (instance) {
    var _instance$tagName;
    setHostElementName((_instance$tagName = instance == null ? void 0 : instance.tagName) != null ? _instance$tagName : '');
  }, []);
  var handleRef = useForkRef(updateHostElementName, externalRef, focusVisibleRef, buttonRef);
  var buttonProps = {};
  if (tabIndex !== undefined) {
    buttonProps.tabIndex = tabIndex;
  }
  if (hostElementName === 'BUTTON') {
    buttonProps.type = type != null ? type : 'button';
    if (focusableWhenDisabled) {
      buttonProps['aria-disabled'] = disabled;
    } else {
      buttonProps.disabled = disabled;
    }
  } else if (hostElementName !== '') {
    if (!href && !to) {
      buttonProps.role = 'button';
      buttonProps.tabIndex = tabIndex != null ? tabIndex : 0;
    }
    if (disabled) {
      buttonProps['aria-disabled'] = disabled;
      buttonProps.tabIndex = focusableWhenDisabled ? tabIndex != null ? tabIndex : 0 : -1;
    }
  }
  var getRootProps = function getRootProps(externalProps) {
    if (externalProps === void 0) {
      externalProps = {};
    }
    var externalEventHandlers = _extends$1({}, extractEventHandlers(parameters), extractEventHandlers(externalProps));
    var props = _extends$1({
      type: type
    }, externalEventHandlers, buttonProps, externalProps, {
      onBlur: createHandleBlur(externalEventHandlers),
      onClick: createHandleClick(externalEventHandlers),
      onFocus: createHandleFocus(externalEventHandlers),
      onKeyDown: createHandleKeyDown(externalEventHandlers),
      onKeyUp: createHandleKeyUp(externalEventHandlers),
      onMouseDown: createHandleMouseDown(externalEventHandlers),
      onMouseLeave: createHandleMouseLeave(externalEventHandlers),
      ref: handleRef
    });
    delete props.onFocusVisible;
    return props;
  };
  return {
    getRootProps: getRootProps,
    focusVisible: focusVisible,
    setFocusVisible: setFocusVisible,
    active: active,
    rootRef: handleRef
  };
}

var SelectActionTypes = {
  buttonClick: 'buttonClick'
};

var defaultOptionStringifier = function defaultOptionStringifier(option) {
  var label = option.label,
    value = option.value;
  if (typeof label === 'string') {
    return label;
  }
  if (typeof value === 'string') {
    return value;
  }
  return String(option);
};

function selectReducer(state, action) {
  var open = state.open;
  var selectionMode = action.context.selectionMode;
  if (action.type === SelectActionTypes.buttonClick) {
    var _state$selectedValues;
    var itemToHighlight = (_state$selectedValues = state.selectedValues[0]) != null ? _state$selectedValues : moveHighlight(null, 'start', action.context);
    return _extends$1({}, state, {
      open: !open,
      highlightedValue: !open ? itemToHighlight : null
    });
  }
  var newState = listReducer(state, action);
  switch (action.type) {
    case ListActionTypes.keyDown:
      if (state.open) {
        if (action.event.key === 'Escape') {
          return _extends$1({}, newState, {
            open: false
          });
        }
        if (selectionMode === 'single' && (action.event.key === 'Enter' || action.event.key === ' ')) {
          return _extends$1({}, newState, {
            open: false
          });
        }
      } else {
        if (action.event.key === 'Enter' || action.event.key === ' ' || action.event.key === 'ArrowDown') {
          var _state$selectedValues2;
          return _extends$1({}, state, {
            open: true,
            highlightedValue: (_state$selectedValues2 = state.selectedValues[0]) != null ? _state$selectedValues2 : moveHighlight(null, 'start', action.context)
          });
        }
        if (action.event.key === 'ArrowUp') {
          var _state$selectedValues3;
          return _extends$1({}, state, {
            open: true,
            highlightedValue: (_state$selectedValues3 = state.selectedValues[0]) != null ? _state$selectedValues3 : moveHighlight(null, 'end', action.context)
          });
        }
      }
      break;
    case ListActionTypes.itemClick:
      if (selectionMode === 'single') {
        return _extends$1({}, newState, {
          open: false
        });
      }
      break;
    case ListActionTypes.blur:
      return _extends$1({}, newState, {
        open: false
      });
    default:
      return newState;
  }
  return newState;
}

function combineHooksSlotProps(getFirstProps, getSecondProps) {
  return function getCombinedProps(external) {
    if (external === void 0) {
      external = {};
    }
    var firstResult = _extends$1({}, external, getFirstProps(external));
    var result = _extends$1({}, firstResult, getSecondProps(firstResult));
    return result;
  };
}

var visuallyHiddenStyle = {
  clip: 'rect(1px, 1px, 1px, 1px)',
  clipPath: 'inset(50%)',
  height: '1px',
  width: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  left: '50%',
  bottom: 0
};
var noop = function noop() {};
function defaultFormValueProvider(selectedOption) {
  if (Array.isArray(selectedOption)) {
    if (selectedOption.length === 0) {
      return '';
    }
    return JSON.stringify(selectedOption.map(function (o) {
      return o.value;
    }));
  }
  if ((selectedOption == null ? void 0 : selectedOption.value) == null) {
    return '';
  }
  if (typeof selectedOption.value === 'string' || typeof selectedOption.value === 'number') {
    return selectedOption.value;
  }
  return JSON.stringify(selectedOption.value);
}
function preventDefault(event) {
  event.preventDefault();
}
function useSelect(props) {
  var areOptionsEqual = props.areOptionsEqual,
    buttonRefProp = props.buttonRef,
    _props$defaultOpen = props.defaultOpen,
    defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen,
    defaultValueProp = props.defaultValue,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    listboxIdProp = props.listboxId,
    listboxRefProp = props.listboxRef,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    name = props.name,
    required = props.required,
    onChange = props.onChange,
    onHighlightChange = props.onHighlightChange,
    onOpenChange = props.onOpenChange,
    openProp = props.open,
    optionsParam = props.options,
    _props$getOptionAsStr = props.getOptionAsString,
    getOptionAsString = _props$getOptionAsStr === void 0 ? defaultOptionStringifier : _props$getOptionAsStr,
    _props$getSerializedV = props.getSerializedValue,
    getSerializedValue = _props$getSerializedV === void 0 ? defaultFormValueProvider : _props$getSerializedV,
    valueProp = props.value;
  var buttonRef = useRef(null);
  var handleButtonRef = useForkRef(buttonRefProp, buttonRef);
  var listboxRef = useRef(null);
  var listboxId = useId(listboxIdProp);
  var defaultValue;
  if (valueProp === undefined && defaultValueProp === undefined) {
    defaultValue = [];
  } else if (defaultValueProp !== undefined) {
    if (multiple) {
      defaultValue = defaultValueProp;
    } else {
      defaultValue = defaultValueProp == null ? [] : [defaultValueProp];
    }
  }
  var value = useMemo(function () {
    if (valueProp !== undefined) {
      if (multiple) {
        return valueProp;
      }
      return valueProp == null ? [] : [valueProp];
    }
    return undefined;
  }, [valueProp, multiple]);
  var _useCompoundParent = useCompoundParent(),
    subitems = _useCompoundParent.subitems,
    compoundComponentContextValue = _useCompoundParent.contextValue;
  var options = useMemo(function () {
    if (optionsParam != null) {
      return new Map(optionsParam.map(function (option, index) {
        return [option.value, {
          value: option.value,
          label: option.label,
          disabled: option.disabled,
          ref: /*#__PURE__*/createRef(),
          id: listboxId + "_" + index
        }];
      }));
    }
    return subitems;
  }, [optionsParam, subitems, listboxId]);
  var handleListboxRef = useForkRef(listboxRefProp, listboxRef);
  var _useButton = useButton({
      disabled: disabled,
      rootRef: handleButtonRef
    }),
    getButtonRootProps = _useButton.getRootProps,
    buttonActive = _useButton.active,
    buttonFocusVisible = _useButton.focusVisible,
    mergedButtonRef = _useButton.rootRef;
  var optionValues = useMemo(function () {
    return Array.from(options.keys());
  }, [options]);
  var getOptionByValue = useCallback(function (valueToGet) {
    if (areOptionsEqual !== undefined) {
      var similarValue = optionValues.find(function (optionValue) {
        return areOptionsEqual(optionValue, valueToGet);
      });
      return options.get(similarValue);
    }
    return options.get(valueToGet);
  }, [options, areOptionsEqual, optionValues]);
  var isItemDisabled = useCallback(function (valueToCheck) {
    var _option$disabled;
    var option = getOptionByValue(valueToCheck);
    return (_option$disabled = option == null ? void 0 : option.disabled) != null ? _option$disabled : false;
  }, [getOptionByValue]);
  var stringifyOption = useCallback(function (valueToCheck) {
    var option = getOptionByValue(valueToCheck);
    if (!option) {
      return '';
    }
    return getOptionAsString(option);
  }, [getOptionByValue, getOptionAsString]);
  var controlledState = useMemo(function () {
    return {
      selectedValues: value,
      open: openProp
    };
  }, [value, openProp]);
  var getItemId = useCallback(function (itemValue) {
    var _options$get;
    return (_options$get = options.get(itemValue)) == null ? void 0 : _options$get.id;
  }, [options]);
  var handleSelectionChange = useCallback(function (event, newValues) {
    if (multiple) {
      onChange == null || onChange(event, newValues);
    } else {
      var _newValues$;
      onChange == null || onChange(event, (_newValues$ = newValues[0]) != null ? _newValues$ : null);
    }
  }, [multiple, onChange]);
  var handleHighlightChange = useCallback(function (event, newValue) {
    onHighlightChange == null || onHighlightChange(event, newValue != null ? newValue : null);
  }, [onHighlightChange]);
  var handleStateChange = useCallback(function (event, field, fieldValue) {
    if (field === 'open') {
      onOpenChange == null || onOpenChange(fieldValue);
      if (fieldValue === false && (event == null ? void 0 : event.type) !== 'blur') {
        var _buttonRef$current;
        (_buttonRef$current = buttonRef.current) == null || _buttonRef$current.focus();
      }
    }
  }, [onOpenChange]);
  var useListParameters = {
    getInitialState: function getInitialState() {
      var _defaultValue;
      return {
        highlightedValue: null,
        selectedValues: (_defaultValue = defaultValue) != null ? _defaultValue : [],
        open: defaultOpen
      };
    },
    getItemId: getItemId,
    controlledProps: controlledState,
    itemComparer: areOptionsEqual,
    isItemDisabled: isItemDisabled,
    rootRef: mergedButtonRef,
    onChange: handleSelectionChange,
    onHighlightChange: handleHighlightChange,
    onStateChange: handleStateChange,
    reducerActionContext: useMemo(function () {
      return {
        multiple: multiple
      };
    }, [multiple]),
    items: optionValues,
    getItemAsString: stringifyOption,
    selectionMode: multiple ? 'multiple' : 'single',
    stateReducer: selectReducer
  };
  var _useList = useList(useListParameters),
    dispatch = _useList.dispatch,
    getListboxRootProps = _useList.getRootProps,
    listContextValue = _useList.contextValue,
    _useList$state = _useList.state,
    open = _useList$state.open,
    highlightedOption = _useList$state.highlightedValue,
    selectedOptions = _useList$state.selectedValues,
    mergedListRootRef = _useList.rootRef;
  var createHandleButtonMouseDown = function createHandleButtonMouseDown(otherHandlers) {
    return function (event) {
      var _otherHandlers$onMous;
      otherHandlers == null || (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
      if (!event.defaultMuiPrevented) {
        var action = {
          type: SelectActionTypes.buttonClick,
          event: event
        };
        dispatch(action);
      }
    };
  };
  useEnhancedEffect(function () {
    if (highlightedOption != null) {
      var _getOptionByValue;
      var optionRef = (_getOptionByValue = getOptionByValue(highlightedOption)) == null ? void 0 : _getOptionByValue.ref;
      if (!listboxRef.current || !(optionRef != null && optionRef.current)) {
        return;
      }
      var listboxClientRect = listboxRef.current.getBoundingClientRect();
      var optionClientRect = optionRef.current.getBoundingClientRect();
      if (optionClientRect.top < listboxClientRect.top) {
        listboxRef.current.scrollTop -= listboxClientRect.top - optionClientRect.top;
      } else if (optionClientRect.bottom > listboxClientRect.bottom) {
        listboxRef.current.scrollTop += optionClientRect.bottom - listboxClientRect.bottom;
      }
    }
  }, [highlightedOption, getOptionByValue]);
  var getOptionMetadata = useCallback(function (optionValue) {
    return getOptionByValue(optionValue);
  }, [getOptionByValue]);
  var getSelectTriggerProps = function getSelectTriggerProps(otherHandlers) {
    if (otherHandlers === void 0) {
      otherHandlers = {};
    }
    return _extends$1({}, otherHandlers, {
      onMouseDown: createHandleButtonMouseDown(otherHandlers),
      ref: mergedListRootRef,
      role: 'combobox',
      'aria-expanded': open,
      'aria-controls': listboxId
    });
  };
  var getButtonProps = function getButtonProps(otherHandlers) {
    if (otherHandlers === void 0) {
      otherHandlers = {};
    }
    var listboxAndButtonProps = combineHooksSlotProps(getButtonRootProps, getListboxRootProps);
    var combinedProps = combineHooksSlotProps(listboxAndButtonProps, getSelectTriggerProps);
    return combinedProps(otherHandlers);
  };
  var getListboxProps = function getListboxProps(otherHandlers) {
    if (otherHandlers === void 0) {
      otherHandlers = {};
    }
    return _extends$1({}, otherHandlers, {
      id: listboxId,
      role: 'listbox',
      'aria-multiselectable': multiple ? 'true' : undefined,
      ref: handleListboxRef,
      onMouseDown: preventDefault
    });
  };
  useDebugValue({
    selectedOptions: selectedOptions,
    highlightedOption: highlightedOption,
    open: open
  });
  var contextValue = useMemo(function () {
    return _extends$1({}, listContextValue, compoundComponentContextValue);
  }, [listContextValue, compoundComponentContextValue]);
  var selectValue;
  if (props.multiple) {
    selectValue = selectedOptions;
  } else {
    selectValue = selectedOptions.length > 0 ? selectedOptions[0] : null;
  }
  var selectedOptionsMetadata;
  if (multiple) {
    selectedOptionsMetadata = selectValue.map(function (v) {
      return getOptionMetadata(v);
    }).filter(function (o) {
      return o !== undefined;
    });
  } else {
    var _getOptionMetadata;
    selectedOptionsMetadata = (_getOptionMetadata = getOptionMetadata(selectValue)) != null ? _getOptionMetadata : null;
  }
  var getHiddenInputProps = function getHiddenInputProps(otherHandlers) {
    if (otherHandlers === void 0) {
      otherHandlers = {};
    }
    return _extends$1({
      name: name,
      tabIndex: -1,
      'aria-hidden': true,
      required: required ? true : undefined,
      value: getSerializedValue(selectedOptionsMetadata),
      onChange: noop,
      style: visuallyHiddenStyle
    }, otherHandlers);
  };
  return {
    buttonActive: buttonActive,
    buttonFocusVisible: buttonFocusVisible,
    buttonRef: mergedButtonRef,
    contextValue: contextValue,
    disabled: disabled,
    dispatch: dispatch,
    getButtonProps: getButtonProps,
    getHiddenInputProps: getHiddenInputProps,
    getListboxProps: getListboxProps,
    getOptionMetadata: getOptionMetadata,
    listboxRef: mergedListRootRef,
    open: open,
    options: optionValues,
    value: selectValue,
    highlightedOption: highlightedOption
  };
}

function SelectProvider(props) {
  var value = props.value,
    children = props.children;
  var dispatch = value.dispatch,
    getItemIndex = value.getItemIndex,
    getItemState = value.getItemState,
    registerHighlightChangeHandler = value.registerHighlightChangeHandler,
    registerSelectionChangeHandler = value.registerSelectionChangeHandler,
    registerItem = value.registerItem,
    totalSubitemCount = value.totalSubitemCount;
  var listContextValue = useMemo(function () {
    return {
      dispatch: dispatch,
      getItemState: getItemState,
      getItemIndex: getItemIndex,
      registerHighlightChangeHandler: registerHighlightChangeHandler,
      registerSelectionChangeHandler: registerSelectionChangeHandler
    };
  }, [dispatch, getItemIndex, getItemState, registerHighlightChangeHandler, registerSelectionChangeHandler]);
  var compoundComponentContextValue = useMemo(function () {
    return {
      getItemIndex: getItemIndex,
      registerItem: registerItem,
      totalSubitemCount: totalSubitemCount
    };
  }, [registerItem, getItemIndex, totalSubitemCount]);
  return /*#__PURE__*/jsx(CompoundComponentContext.Provider, {
    value: compoundComponentContextValue,
    children: /*#__PURE__*/jsx(ListContext.Provider, {
      value: listContextValue,
      children: children
    })
  });
}

function getSelectUtilityClass(slot) {
  return generateUtilityClass('MuiSelect', slot);
}
var selectClasses = generateUtilityClasses('MuiSelect', ['root', 'button', 'listbox', 'popper', 'active', 'expanded', 'disabled', 'focusVisible']);

var _span;
var _excluded$j = ["areOptionsEqual", "autoFocus", "children", "defaultValue", "defaultListboxOpen", "disabled", "getSerializedValue", "listboxId", "listboxOpen", "multiple", "name", "required", "onChange", "onListboxOpenChange", "getOptionAsString", "renderValue", "placeholder", "slotProps", "slots", "value"];
function defaultRenderValue(selectedOptions) {
  var _selectedOptions$labe;
  if (Array.isArray(selectedOptions)) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: selectedOptions.map(function (o) {
        return o.label;
      }).join(', ')
    });
  }
  return (_selectedOptions$labe = selectedOptions == null ? void 0 : selectedOptions.label) != null ? _selectedOptions$labe : null;
}
function useUtilityClasses$2(ownerState) {
  var active = ownerState.active,
    disabled = ownerState.disabled,
    open = ownerState.open,
    focusVisible = ownerState.focusVisible;
  var slots = {
    root: ['root', disabled && 'disabled', focusVisible && 'focusVisible', active && 'active', open && 'expanded'],
    listbox: ['listbox', disabled && 'disabled'],
    popper: ['popper']
  };
  return composeClasses(slots, useClassNamesOverride(getSelectUtilityClass));
}
var Select = /*#__PURE__*/forwardRef(function Select(props, forwardedRef) {
  var _slots$root, _slots$listbox, _slots$popper, _ref, _renderValue;
  var areOptionsEqual = props.areOptionsEqual,
    autoFocus = props.autoFocus,
    children = props.children,
    defaultValue = props.defaultValue,
    _props$defaultListbox = props.defaultListboxOpen,
    defaultListboxOpen = _props$defaultListbox === void 0 ? false : _props$defaultListbox,
    disabledProp = props.disabled,
    getSerializedValue = props.getSerializedValue,
    listboxId = props.listboxId,
    listboxOpenProp = props.listboxOpen,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    name = props.name,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    onChange = props.onChange,
    onListboxOpenChange = props.onListboxOpenChange,
    _props$getOptionAsStr = props.getOptionAsString,
    getOptionAsString = _props$getOptionAsStr === void 0 ? defaultOptionStringifier : _props$getOptionAsStr,
    renderValueProp = props.renderValue,
    placeholder = props.placeholder,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    valueProp = props.value,
    other = _objectWithoutPropertiesLoose$1(props, _excluded$j);
  var renderValue = renderValueProp != null ? renderValueProp : defaultRenderValue;
  var _React$useState = useState(false),
    buttonDefined = _React$useState[0],
    setButtonDefined = _React$useState[1];
  var buttonRef = useRef(null);
  var listboxRef = useRef(null);
  var Button = (_slots$root = slots.root) != null ? _slots$root : 'button';
  var ListboxRoot = (_slots$listbox = slots.listbox) != null ? _slots$listbox : 'ul';
  var PopperComponent = (_slots$popper = slots.popper) != null ? _slots$popper : Popper;
  var handleButtonRefChange = useCallback(function (element) {
    setButtonDefined(element != null);
  }, []);
  var handleButtonRef = useForkRef(forwardedRef, buttonRef, handleButtonRefChange);
  useEffect(function () {
    if (autoFocus) {
      buttonRef.current.focus();
    }
  }, [autoFocus]);
  var _useSelect = useSelect({
      name: name,
      required: required,
      getSerializedValue: getSerializedValue,
      areOptionsEqual: areOptionsEqual,
      buttonRef: handleButtonRef,
      defaultOpen: defaultListboxOpen,
      defaultValue: defaultValue,
      disabled: disabledProp,
      listboxId: listboxId,
      multiple: multiple,
      open: listboxOpenProp,
      onChange: onChange,
      onOpenChange: onListboxOpenChange,
      getOptionAsString: getOptionAsString,
      value: valueProp
    }),
    buttonActive = _useSelect.buttonActive,
    buttonFocusVisible = _useSelect.buttonFocusVisible,
    contextValue = _useSelect.contextValue,
    disabled = _useSelect.disabled,
    getButtonProps = _useSelect.getButtonProps,
    getListboxProps = _useSelect.getListboxProps,
    getHiddenInputProps = _useSelect.getHiddenInputProps,
    getOptionMetadata = _useSelect.getOptionMetadata,
    value = _useSelect.value,
    open = _useSelect.open;
  var ownerState = _extends$1({}, props, {
    active: buttonActive,
    defaultListboxOpen: defaultListboxOpen,
    disabled: disabled,
    focusVisible: buttonFocusVisible,
    open: open,
    multiple: multiple,
    renderValue: renderValue,
    value: value
  });
  var classes = useUtilityClasses$2(ownerState);
  var buttonProps = useSlotProps({
    elementType: Button,
    getSlotProps: getButtonProps,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    ownerState: ownerState,
    className: classes.root
  });
  var listboxProps = useSlotProps({
    elementType: ListboxRoot,
    getSlotProps: getListboxProps,
    externalSlotProps: slotProps.listbox,
    additionalProps: {
      ref: listboxRef
    },
    ownerState: ownerState,
    className: classes.listbox
  });
  var popperProps = useSlotProps({
    elementType: PopperComponent,
    externalSlotProps: slotProps.popper,
    additionalProps: {
      anchorEl: buttonRef.current,
      keepMounted: true,
      open: open,
      placement: 'bottom-start',
      role: undefined
    },
    ownerState: ownerState,
    className: classes.popper
  });
  var selectedOptionsMetadata;
  if (multiple) {
    selectedOptionsMetadata = value.map(function (v) {
      return getOptionMetadata(v);
    }).filter(function (o) {
      return o !== undefined;
    });
  } else {
    var _getOptionMetadata;
    selectedOptionsMetadata = (_getOptionMetadata = getOptionMetadata(value)) != null ? _getOptionMetadata : null;
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(Button, _extends$1({}, buttonProps, {
      children: (_ref = (_renderValue = renderValue(selectedOptionsMetadata)) != null ? _renderValue : placeholder) != null ? _ref : _span || (_span = /*#__PURE__*/jsx("span", {
        className: "notranslate",
        children: "\u200B"
      }))
    })), buttonDefined && /*#__PURE__*/jsx(PopperComponent, _extends$1({}, popperProps, {
      children: /*#__PURE__*/jsx(ListboxRoot, _extends$1({}, listboxProps, {
        children: /*#__PURE__*/jsx(SelectProvider, {
          value: contextValue,
          children: children
        })
      }))
    })), /*#__PURE__*/jsx("input", _extends$1({}, getHiddenInputProps()))]
  });
});
process.env.NODE_ENV !== "production" ? Select.propTypes = {
  areOptionsEqual: propTypes.func,
  autoFocus: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string,
  defaultListboxOpen: propTypes.bool,
  defaultValue: propTypes.any,
  disabled: propTypes.bool,
  getOptionAsString: propTypes.func,
  getSerializedValue: propTypes.func,
  listboxId: propTypes.string,
  listboxOpen: propTypes.bool,
  multiple: propTypes.bool,
  name: propTypes.string,
  onChange: propTypes.func,
  onListboxOpenChange: propTypes.func,
  placeholder: propTypes.node,
  renderValue: propTypes.func,
  required: propTypes.bool,
  slotProps: propTypes.shape({
    listbox: propTypes.oneOfType([propTypes.func, propTypes.object]),
    popper: propTypes.oneOfType([propTypes.func, propTypes.object]),
    root: propTypes.oneOfType([propTypes.func, propTypes.object])
  }),
  slots: propTypes.shape({
    listbox: propTypes.elementType,
    popper: propTypes.elementType,
    root: propTypes.elementType
  }),
  value: propTypes.any
} : void 0;

var _excluded$k = ["children", "disabled", "minWidth", "ownerState"];
var DNBSelectBaseButton = forwardRef(function DNBSelectBaseButton(_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    ownerState = _ref.ownerState,
    dnbSelectBaseButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded$k);
  var isOpen = ownerState ? ownerState.open : false;
  return React__default.createElement("button", Object.assign({
    disabled: disabled
  }, dnbSelectBaseButtonProps, {
    ref: ref
  }), children, React__default.createElement(ArrowDropDownIcon, {
    fontSize: "small",
    className: "" + (isOpen ? 'SelectionButtonIcon-expanded' : '')
  }));
});

var excludedMuiProps = {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'size' && prop !== 'minWidth' && prop !== 'listMaxHeight' && prop !== 'ownerState' && prop !== 'renderValue';
  }
};
var StyledListboxUl = styled('ul', excludedMuiProps)(function (_ref) {
  var theme = _ref.theme,
    minWidth = _ref.minWidth,
    listMaxHeight = _ref.listMaxHeight;
  return {
    background: theme.palette.background.paper,
    border: theme.borders.BorderThin + " " + theme.colors.ColorGrayIncidental,
    boxShadow: theme.boxShadows.ShadowPlus2,
    color: theme.colors.ColorGrayPrimary,
    fontWeight: 400,
    margin: 0,
    maxHeight: listMaxHeight != null ? listMaxHeight : '36rem',
    minWidth: minWidth,
    overflow: 'inherit',
    outline: 0,
    padding: theme.spacing(2)
  };
});
var StyledMuiPopper = styled(Popper, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'maxHeight' && prop !== 'zIndex';
  }
})(function (_ref2) {
  var _ref3;
  var theme = _ref2.theme,
    maxHeight = _ref2.maxHeight,
    zIndex = _ref2.zIndex;
  return _ref3 = {
    borderRadius: theme.borders.BorderRadiusDefault,
    display: 'flex',
    maxHeight: maxHeight != null ? maxHeight : 'unset',
    overflowY: 'auto',
    zIndex: zIndex
  }, _ref3["& ." + selectClasses.listbox] = {
    borderRadius: theme.borders.BorderRadiusDefault
  }, _ref3;
});
var StyledDNBSelectBaseButtonButton = styled(DNBSelectBaseButton, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'size' && prop !== 'minWidth';
  }
})(function (_ref4) {
  var theme = _ref4.theme,
    disabled = _ref4.disabled,
    minWidth = _ref4.minWidth,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'default' : _ref4$size;
  return {
    alignItems: 'center',
    background: theme.palette.background.default,
    border: theme.borders.BorderThin + " " + theme.colors.ColorGraySecondary,
    boxShadow: "inset " + theme.boxShadows.ShadowMinus1,
    display: 'flex',
    fontFamily: theme.typography.FontFamilySansSerif,
    justifyContent: 'space-between',
    minWidth: minWidth,
    opacity: disabled ? theme.opacity.OpacityDisabled : 'unset',
    paddingLeft: size === 'default' ? theme.spacing(3) : theme.spacing(2),
    paddingRight: theme.spacing(2),
    textAlign: 'left',
    width: 'inherit',
    span: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    '&:hover': {
      borderColor: disabled ? 'unset' : theme.colors.ColorPrimaryBlueInteractive
    },
    '&.DNBSelectBase': {
      '&-default': _extends({
        borderRadius: theme.borders.BorderRadiusDefault,
        height: theme.spacing(11)
      }, theme.typography['body']),
      '&-compact': _extends({
        borderRadius: theme.borders.BorderRadiusCompact,
        height: theme.spacing(9)
      }, theme.typography['compact-body']),
      '&-small': _extends({
        borderRadius: theme.borders.BorderRadiusSmall,
        height: theme.spacing(8)
      }, theme.typography['compact-body'])
    },
    '& .SelectionButtonIcon-expanded': {
      transform: 'rotate(0.5turn)'
    }
  };
});
var StyledMuiOption = styled(Option, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'size';
  }
})(function (_ref5) {
  var _ref6, _extends2;
  var theme = _ref5.theme,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? 'default' : _ref5$size;
  return _extends({}, size === 'default' ? theme.typography.body1 : theme.typography['compact-medium'], (_extends2 = {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: "" + theme.spacing(2),
    '&:last-of-type': {
      borderBottom: 'none'
    },
    '&:hover': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1,
      cursor: 'pointer'
    }
  }, _extends2["&." + optionClasses.highlighted] = {
    backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
  }, _extends2["&." + optionClasses.selected] = (_ref6 = {
    background: theme.palette.background.paper
  }, _ref6["&." + optionClasses.highlighted] = {
    backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
  }, _ref6['&:hover'] = {
    backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
  }, _ref6), _extends2["&." + optionClasses.selected + ":hover"] = {
    background: theme.colors.ColorGrayPrimaryAlpha1
  }, _extends2["&." + optionClasses.disabled] = {
    cursor: 'not-allowed',
    opacity: theme.opacity.OpacityDisabled
  }, _extends2['&.DNBSelectBaseItem'] = {
    '&-default': _extends({
      borderRadius: theme.borders.BorderRadiusDefault,
      height: theme.spacing(10)
    }, theme.typography['body']),
    '&-compact': _extends({
      borderRadius: theme.borders.BorderRadiusCompact,
      height: theme.spacing(8)
    }, theme.typography['compact-body']),
    '&-small': _extends({
      borderRadius: theme.borders.BorderRadiusSmall,
      height: theme.spacing(7)
    }, theme.typography['compact-body'])
  }, _extends2));
});
var StyledSelectedOptionSpan = styled('span', excludedMuiProps)(function (_ref7) {
  var theme = _ref7.theme,
    size = _ref7.size;
  return _extends({
    color: theme.colors.ColorGrayPrimary
  }, size === 'default' ? theme.typography.body : theme.typography['compact-body'], {
    paddingRight: theme.spacing(2)
  });
});
var StyledPlaceholderOption = styled('option', excludedMuiProps)(function (_ref8) {
  var theme = _ref8.theme,
    size = _ref8.size;
  return _extends({}, size === 'default' ? theme.typography.body : theme.typography['compact-body'], {
    color: theme.colors.ColorGraySecondary,
    padding: "0 " + theme.spacing(2) + " 0 0"
  });
});
var Option$1 = function Option(_ref9) {
  var size = _ref9.size,
    minWidth = _ref9.minWidth,
    label = _ref9.label,
    disabled = _ref9.disabled;
  return React__default.createElement(StyledSelectedOptionSpan, {
    size: size,
    minWidth: minWidth,
    disabled: disabled
  }, label);
};
var Placeholder = function Placeholder(_ref10) {
  var disabled = _ref10.disabled,
    minWidth = _ref10.minWidth,
    placeholder = _ref10.placeholder,
    size = _ref10.size;
  return React__default.createElement(StyledPlaceholderOption, {
    disabled: disabled,
    size: size,
    minWidth: minWidth
  }, placeholder);
};

var _excluded$l = ["children", "disabled", "listMaxHeight", "minWidth", "multiple", "placeholder", "optionsMaxHeight", "size", "value"];
var DNBSelectContext = createContext({});
var getNumericZIndex = function getNumericZIndex(element) {
  var computedStyle = getComputedStyle(element);
  if (computedStyle.zIndex === 'auto') {
    var parent = element.parentElement;
    while (parent && getComputedStyle(parent).zIndex === 'auto') {
      parent = parent.parentElement;
    }
    if (parent) {
      return parseInt(getComputedStyle(parent).zIndex, 10);
    } else {
      return 0;
    }
  } else {
    return parseInt(computedStyle.zIndex, 10);
  }
};
var DNBSelectBase = forwardRef(function DNBSelectBase(_ref, forwardedRef) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    listMaxHeight = _ref.listMaxHeight,
    minWidth = _ref.minWidth,
    multiple = _ref.multiple,
    optionsMaxHeight = _ref.optionsMaxHeight,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    value = _ref.value,
    selectBaseProps = _objectWithoutPropertiesLoose(_ref, _excluded$l);
  var buttonRef = useRef(null);
  var _useState = useState(null),
    boundary = _useState[0],
    setBoundary = _useState[1];
  var _useState2 = useState(false),
    hasOffset = _useState2[0],
    setHasOffset = _useState2[1];
  var _useState3 = useState(0),
    buttonZIndex = _useState3[0],
    setButtonZIndex = _useState3[1];
  var components = {
    listbox: StyledListboxUl,
    popper: StyledMuiPopper,
    root: StyledDNBSelectBaseButtonButton
  };
  var setSelectStates = {
    name: 'setSelectStates',
    enabled: true,
    phase: 'main',
    requires: ['computeStyles'],
    fn: function fn(_ref2) {
      var _state$modifiersData$, _state$rects$popper$h;
      var state = _ref2.state;
      var parent = state.scrollParents.popper[1];
      var popperOffsetY = (_state$modifiersData$ = state.modifiersData.popperOffsets.y) != null ? _state$modifiersData$ : 0;
      var parentHeight = parent.clientHeight;
      var popperHeight = (_state$rects$popper$h = state.rects.popper.height) != null ? _state$rects$popper$h : 0;
      setHasOffset(popperHeight + popperOffsetY < parentHeight);
      setBoundary(parent);
    }
  };
  var overridePreventOverflow = {
    name: 'preventOverflow',
    options: {
      altAxis: !hasOffset,
      boundary: boundary
    },
    requiresIfExists: ['offset', 'setSelectStates']
  };
  var popperModifiers = [setSelectStates, overridePreventOverflow];
  var memoizedContextValue = useMemo(function () {
    return {
      value: value
    };
  }, [value]);
  useEffect(function () {
    if (buttonRef.current) {
      setButtonZIndex(getNumericZIndex(buttonRef.current));
    }
  }, [buttonRef]);
  return React__default.createElement(DNBSelectContext.Provider, {
    value: memoizedContextValue
  }, React__default.createElement(Select, Object.assign({
    "aria-label": "Selection button",
    disabled: disabled,
    slots: components,
    slotProps: {
      listbox: {
        listMaxHeight: listMaxHeight,
        minWidth: minWidth
      },
      popper: {
        modifiers: popperModifiers,
        maxHeight: optionsMaxHeight,
        zIndex: buttonZIndex + 1
      },
      root: {
        className: "DNBSelectBase-" + size,
        disabled: disabled,
        minWidth: minWidth,
        size: size
      }
    },
    sx: {
      zIndex: 'inherit'
    },
    ref: function ref(refElement) {
      buttonRef.current = refElement;
      return forwardedRef;
    },
    value: value
  }, selectBaseProps, {
    multiple: multiple
  }), children));
});

var _excluded$m = ["children", "disabled", "minWidth", "placeholder", "size"];
var DNBMultiSelect = function DNBMultiSelect(_ref) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    minWidth = _ref.minWidth,
    placeholder = _ref.placeholder,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    multiSelectProps = _objectWithoutPropertiesLoose(_ref, _excluded$m);
  var getRenderLabel = function getRenderLabel(selectedOptions) {
    var selectedOptionsLength = selectedOptions.length;
    if (selectedOptionsLength > 0) {
      return selectedOptions.reduce(function (renderValue, option, index) {
        var separator = selectedOptionsLength - 1 === index ? '' : ', ';
        if (typeof option === 'string') {
          return "" + renderValue + option + separator;
        }
        if (option) {
          return "" + renderValue + option.label + separator;
        }
        return renderValue;
      }, '');
    }
    return null;
  };
  var getRenderValue = function getRenderValue(selectedOptions) {
    var renderLabel = getRenderLabel(selectedOptions);
    return renderLabel ? React__default.createElement(Option$1, {
      size: size,
      minWidth: minWidth,
      label: renderLabel
    }) : React__default.createElement(Placeholder, {
      disabled: disabled,
      size: size,
      minWidth: minWidth,
      placeholder: placeholder != null ? placeholder : ''
    });
  };
  return React__default.createElement(DNBSelectBase, Object.assign({
    renderValue: function renderValue(selectedOptions) {
      return getRenderValue(selectedOptions);
    }
  }, multiSelectProps, {
    disabled: disabled,
    minWidth: minWidth,
    multiple: true,
    size: size
  }), children);
};

var _excluded$n = ["children", "size", "disableCheck", "value"];
var DNBSelectOption = forwardRef(function DNBSelectOption(_ref, ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    disableCheck = _ref.disableCheck,
    value = _ref.value,
    selectOptionProps = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  var _useContext = useContext(DNBSelectContext),
    selectedValue = _useContext.value;
  var isMultiCheck = Array.isArray(selectedValue);
  var selected = isMultiCheck ? selectedValue.includes(value) : selectedValue === value;
  return React__default.createElement(StyledMuiOption, Object.assign({
    className: "DNBSelectBaseItem-" + size,
    size: size,
    ref: ref,
    value: value
  }, selectOptionProps), children, !disableCheck && selected && React__default.createElement(CheckIcon$1, {
    sx: function sx(theme) {
      return {
        color: theme.colors.ColorPrimaryBlueInteractive
      };
    }
  }));
});

var _excluded$o = ["children", "disabled", "minWidth", "placeholder", "selectOptions", "size"];
var DNBSelect = function DNBSelect(_ref) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    minWidth = _ref.minWidth,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    _ref$selectOptions = _ref.selectOptions,
    selectOptions = _ref$selectOptions === void 0 ? [] : _ref$selectOptions,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    dnbSelectProps = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  var hasLegacyOptions = selectOptions && selectOptions.length > 0;
  var getRenderValue = function getRenderValue(option) {
    var renderLabel = null;
    if (option) {
      renderLabel = option.label;
    }
    return renderLabel ? React__default.createElement(Option$1, {
      size: size,
      minWidth: minWidth,
      label: renderLabel,
      disabled: option === null || option === void 0 ? void 0 : option.disabled
    }) : React__default.createElement(Placeholder, {
      disabled: disabled,
      size: size,
      minWidth: minWidth,
      placeholder: placeholder
    });
  };
  return React__default.createElement(DNBSelectBase, Object.assign({
    renderValue: function renderValue(selectedOption) {
      return getRenderValue(selectedOption);
    }
  }, dnbSelectProps, {
    disabled: disabled,
    minWidth: minWidth,
    size: size
  }), hasLegacyOptions ? React__default.createElement(Fragment$1, null, selectOptions.map(function (option) {
    var optionLabel = option.label;
    return React__default.createElement(DNBSelectOption, {
      label: optionLabel,
      key: optionLabel,
      value: option.value,
      disabled: option.disabled
    }, optionLabel);
  })) : children);
};

var StyledMuiBoxCheckboxContainer = styled(MuiBox)(function () {
  return {
    flexDirection: 'column'
  };
});
var StyledMuiFormControlLabel = styled(MuiFormControlLabel, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'hasError' && prop !== 'excludeHoverEffect';
  }
})(function (_ref) {
  var hasError = _ref.hasError,
    theme = _ref.theme,
    excludeHoverEffect = _ref.excludeHoverEffect;
  return {
    border: hasError ? 'solid' : 'none',
    borderColor: theme.colors.ColorNotificationError,
    borderRadius: theme.borders.BorderRadiusDefault,
    color: theme.colors.ColorGrayPrimary,
    width: 'fit-content',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    margin: 0,
    '&:hover': {
      backgroundColor: excludeHoverEffect ? 'none' : theme.colors.ColorGrayPrimaryAlpha1
    },
    '& .MuiCheckbox-root:hover': {
      backgroundColor: 'unset'
    },
    '&.DNBCheckboxContainer-default': _extends({
      paddingRight: theme.spacing(3)
    }, theme.typography['body']),
    '&.DNBCheckboxContainer-compact': _extends({
      paddingRight: theme.spacing(2)
    }, theme.typography['compact-body']),
    '&.DNBCheckboxContainer-small': _extends({
      paddingRight: theme.spacing(1)
    }, theme.typography['compact-body'])
  };
});
var StyledMuiCheckbox = styled(MuiCheckbox)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.colors.ColorGraySecondary,
    backgroundColor: 'unset',
    borderRadius: theme.borders.BorderRadiusSmall,
    '&:hover': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
    },
    '& .MuiSvgIcon-root': {
      pointerEvents: 'none',
      zIndex: 1
    },
    '&.Mui-checked': {
      color: theme.colors.ColorPrimaryBlueInteractive
    },
    '&.Mui-disabled': {
      opacity: theme.opacity.OpacityDisabled
    },
    '&.DNBCheckbox-default': {
      padding: theme.spacing(3)
    },
    '&.DNBCheckbox-compact': {
      padding: theme.spacing(2)
    },
    '&.DNBCheckbox-small': {
      padding: theme.spacing(1)
    }
  };
});
var StyledDNBTypographyLabel = styled(DNBTypography)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    marginLeft: theme.spacing(1)
  };
});
var StyledMuiFormHelperText = styled(MuiFormHelperText)(function (_ref4) {
  var theme = _ref4.theme;
  return _extends({
    color: theme.colors.ColorNotificationError,
    marginTop: 0
  }, theme.typography['caption']);
});
var StyledMuiBoxHelperTextContainer = styled(MuiBox)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    alignItems: 'center',
    display: 'flex',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(4),
    '& .MuiSvgIcon-root': {
      color: theme.colors.ColorNotificationError,
      height: theme.spacing(3),
      width: theme.spacing(3),
      marginRight: theme.spacing(1)
    }
  };
});
var DNBCheckboxBaseStyle = {
  backgroundColor: theme.colors.ColorBackgroundWhite,
  border: theme.borders.BorderThin + " " + theme.colors.ColorGraySecondary,
  borderRadius: theme.spacing(1),
  width: theme.spacing(5),
  height: theme.spacing(5),
  position: 'relative'
};
var StyledDivCheckBox = styled('div')(function () {
  return _extends({}, DNBCheckboxBaseStyle);
});
var StyledDivCheckBoxChecked = styled('div')(function (_ref6) {
  var theme = _ref6.theme;
  return _extends({}, DNBCheckboxBaseStyle, {
    border: theme.borders.BorderThin + " " + theme.colors.ColorPrimaryBlueInteractive,
    '&::after': {
      border: "solid " + theme.colors.ColorBackgroundButtonPrimary,
      borderWidth: '0 0.2rem 0.2rem 0',
      content: '""',
      color: theme.colors.ColorBackgroundButtonPrimary,
      left: '0.6rem',
      top: '0.2rem',
      width: '0.6rem',
      height: theme.spacing(3),
      position: 'absolute',
      transform: 'rotate(45deg)'
    }
  });
});
var StyledDivCheckBoxIndeterminated = styled('div')(function (_ref7) {
  var theme = _ref7.theme;
  return _extends({}, DNBCheckboxBaseStyle, {
    border: theme.borders.BorderThin + " " + theme.colors.ColorPrimaryBlueInteractive,
    '&::after': {
      border: "solid " + theme.colors.ColorBackgroundButtonPrimary,
      borderWidth: '0.1rem',
      content: '""',
      color: theme.colors.ColorBackgroundButtonPrimary,
      left: '0.3rem',
      top: theme.spacing(2),
      width: theme.spacing(3),
      height: '0.1rem',
      position: 'absolute'
    }
  });
});

var _excluded$p = ["checked", "error", "label", "size", "excludeHoverEffect", "containerProps", "labelProps"];
var DNBCheckBoxBlank = function DNBCheckBoxBlank() {
  return React__default.createElement(StyledDivCheckBox, null);
};
var DNBCheckBoxChecked = function DNBCheckBoxChecked() {
  return React__default.createElement(StyledDivCheckBoxChecked, null);
};
var DNBCheckBoxIndeterminated = function DNBCheckBoxIndeterminated() {
  return React__default.createElement(StyledDivCheckBoxIndeterminated, null);
};
var DNBCheckbox = forwardRef(function (_ref, ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    error = _ref.error,
    label = _ref.label,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    _ref$excludeHoverEffe = _ref.excludeHoverEffect,
    excludeHoverEffect = _ref$excludeHoverEffe === void 0 ? false : _ref$excludeHoverEffe,
    _ref$containerProps = _ref.containerProps,
    containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
    _ref$labelProps = _ref.labelProps,
    labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
    dnbCheckboxProps = _objectWithoutPropertiesLoose(_ref, _excluded$p);
  var hasError = error !== undefined && error.length > 0;
  var typographyVariant = useCallback(function () {
    switch (size) {
      case 'compact':
      case 'small':
        return 'compact-body';
      default:
        return 'body';
    }
  }, [size]);
  var customAriaLabel = dnbCheckboxProps['aria-label'];
  var ariaLabel = customAriaLabel != null ? customAriaLabel : typeof label === 'string' ? label : 'checkbox-no-label';
  var MuiCheckboxIconProps = {
    checkedIcon: React__default.createElement(DNBCheckBoxChecked, null),
    icon: React__default.createElement(DNBCheckBoxBlank, null),
    indeterminateIcon: React__default.createElement(DNBCheckBoxIndeterminated, null)
  };
  return React__default.createElement(StyledMuiBoxCheckboxContainer, Object.assign({
    component: "div"
  }, containerProps), label ? React__default.createElement(StyledMuiFormControlLabel, Object.assign({
    excludeHoverEffect: excludeHoverEffect,
    checked: checked,
    control: React__default.createElement(StyledMuiCheckbox, Object.assign({}, dnbCheckboxProps, MuiCheckboxIconProps, {
      className: "DNBCheckbox-" + size,
      checked: checked,
      inputProps: {
        'aria-label': ariaLabel
      },
      ref: ref
    })),
    hasError: hasError,
    label: React__default.createElement(StyledDNBTypographyLabel, {
      variant: typographyVariant()
    }, label),
    className: "DNBCheckboxContainer-" + size
  }, labelProps)) : React__default.createElement(StyledMuiCheckbox, Object.assign({}, dnbCheckboxProps, MuiCheckboxIconProps, {
    className: "DNBCheckbox-" + size,
    checked: checked,
    inputProps: {
      'aria-label': ariaLabel
    },
    ref: ref
  })), hasError ? React__default.createElement(StyledMuiBoxHelperTextContainer, null, React__default.createElement(ErrorOutlineOutlinedIcon, null), React__default.createElement(StyledMuiFormHelperText, null, error)) : undefined);
});
DNBCheckbox.displayName = 'DNBCheckbox';

var _excluded$q = ["children", "disabled", "error", "label", "orientation", "name", "required"];
var StyledMuiBox = styled(MuiBox)(function () {
  return {
    display: 'flex'
  };
});
var StyledMuiFormGroup = styled(MuiFormGroup)(function () {
  return {
    alignItems: 'baseline'
  };
});
var DNBCheckboxGroup = function DNBCheckboxGroup(_ref) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    label = _ref.label,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'vertical' : _ref$orientation,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'standard' : _ref$name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$q);
  return React__default.createElement(StyledMuiBox, null, React__default.createElement(MuiFormControl, Object.assign({
    component: "fieldset",
    variant: "standard",
    required: required,
    error: error,
    disabled: disabled
  }, rest), React__default.createElement(MuiFormLabel, {
    component: "legend",
    disabled: false,
    id: name + "-checkbox-group-label-id"
  }, label), React__default.createElement(StyledMuiFormGroup, {
    "aria-labelledby": name + "-checkbox-group-label-id",
    row: orientation === 'horizontal'
  }, children)));
};

var StyledMuiFormControlLabel$1 = styled(MuiFormControlLabel)(function (_ref) {
  var theme = _ref.theme;
  return {
    borderRadius: theme.borders.BorderRadiusDefault,
    color: theme.colors.ColorGrayPrimary,
    height: 'fit-content',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    marginLeft: 0,
    width: 'fit-content',
    '&:hover': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
    },
    '&:active': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha2
    },
    '&:focus-within': {
      outline: 'none'
    },
    '& .MuiRadio-root:hover': {
      backgroundColor: 'unset'
    },
    '& .Mui-disabled': {
      opacity: theme.opacity.OpacityDisabled
    },
    '&.DNBRadioContainer': {
      '&-default': {
        paddingRight: theme.spacing(3)
      },
      '&-compact': {
        paddingRight: theme.spacing(2)
      },
      '&-small': {
        paddingRight: '6px'
      }
    }
  };
});
var StyledMuiRadio = styled(MuiRadio)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.colors.ColorGraySecondary,
    backgroundColor: 'unset',
    borderRadius: theme.borders.BorderRadiusDefault,
    '&:active': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha2
    },
    '&:hover': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
    },
    '& .MuiSvgIcon-root': {
      pointerEvents: 'none',
      zIndex: '1'
    },
    '&.DNBRadio-default': {
      padding: theme.spacing(3)
    },
    '&.DNBRadio-compact': {
      padding: theme.spacing(2)
    },
    '&.DNBRadio-small': {
      padding: '6px'
    }
  };
});
var StyledTypographyLabel = styled(DNBTypography)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    marginLeft: theme.spacing(1)
  };
});
var DNBRadioBaseStyle = {
  backgroundColor: theme.colors.ColorBackgroundWhite,
  border: theme.borders.BorderThin,
  borderRadius: '50%',
  width: theme.spacing(5),
  height: theme.spacing(5),
  position: 'relative'
};
var StyledDivRadio = styled('div')(function (_ref4) {
  var theme = _ref4.theme;
  return _extends({}, DNBRadioBaseStyle, {
    borderColor: theme.colors.ColorGraySecondary
  });
});
var StyledDivRadioChecked = styled('div')(function (_ref5) {
  var theme = _ref5.theme;
  return _extends({}, DNBRadioBaseStyle, {
    borderColor: theme.colors.ColorPrimaryBlueInteractive,
    '&::after': {
      backgroundColor: theme.colors.ColorBackgroundButtonPrimary,
      border: "solid " + theme.colors.ColorBackgroundButtonPrimary,
      borderRadius: '50%',
      content: '""',
      color: theme.colors.ColorBackgroundButtonPrimary,
      width: '1rem',
      height: '1rem',
      position: 'absolute',
      top: theme.spacing(1),
      left: theme.spacing(1)
    }
  });
});

var _excluded$r = ["disabled", "label", "name", "value", "size"];
var DNBRadioIcon = function DNBRadioIcon() {
  return React__default.createElement(StyledDivRadio, null);
};
var DNBRadioCheckedIcon = function DNBRadioCheckedIcon() {
  return React__default.createElement(StyledDivRadioChecked, null);
};
var DNBRadio = function DNBRadio(_ref) {
  var disabled = _ref.disabled,
    label = _ref.label,
    name = _ref.name,
    value = _ref.value,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$r);
  var typographyVariant = function typographyVariant() {
    switch (size) {
      case 'compact':
        return 'compact-body';
      case 'small':
        return 'compact-body';
      default:
        return 'body';
    }
  };
  return label && label.length > 0 ? React__default.createElement(StyledMuiFormControlLabel$1, {
    className: "DNBRadioContainer-" + size,
    control: React__default.createElement(StyledMuiRadio, Object.assign({
      className: "DNBRadio-" + size,
      inputProps: {
        'aria-label': name
      }
    }, rest, {
      icon: React__default.createElement(DNBRadioIcon, null),
      checkedIcon: React__default.createElement(DNBRadioCheckedIcon, null)
    })),
    disabled: disabled,
    label: React__default.createElement(StyledTypographyLabel, {
      variant: typographyVariant()
    }, label),
    value: value
  }) : React__default.createElement(StyledMuiRadio, Object.assign({
    className: "DNBRadio-" + size
  }, rest, {
    icon: React__default.createElement(DNBRadioIcon, null),
    checkedIcon: React__default.createElement(DNBRadioCheckedIcon, null),
    inputProps: {
      'aria-label': 'radio-no-label'
    }
  }));
};

var _excluded$s = ["children", "label", "name", "orientation"];
var StyledRadioGroup = styled(MuiRadioGroup)(function () {
  return {
    alignItems: 'baseline'
  };
});
var DNBRadioGroup = function DNBRadioGroup(_ref) {
  var children = _ref.children,
    label = _ref.label,
    name = _ref.name,
    orientation = _ref.orientation,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$s);
  return React__default.createElement(MuiFormControl, null, React__default.createElement(MuiFormLabel, {
    id: name + "-radio-group-label-id"
  }, label), React__default.createElement(StyledRadioGroup, Object.assign({
    "aria-labelledby": name + "-radio-group-label-id",
    name: name,
    row: orientation === 'horizontal'
  }, rest), children));
};

var CheckIcon = function CheckIcon() {
  return React__default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "-3 -5 19 19",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    d: "M3.8265 7.00995L1.22605 4.4095L0 5.62692L3.8265 9.45342L12.0625 1.21742L10.8451 0L3.8265 7.00995Z",
    fill: "#0078A7"
  }));
};

var _excluded$t = ["ariaLabel", "checked", "isLoading", "isDisabled", "onChange"];
var StyledMuiSwitch = styled(MuiSwitch)(function (_ref) {
  var disabled = _ref.disabled,
    theme = _ref.theme;
  return {
    width: 42,
    height: 24,
    padding: 5,
    opacity: disabled ? theme.opacity.OpacityDisabled : 1,
    ':hover': {
      '& .MuiSwitch-switchBase': {
        backgroundColor: theme.colors.ColorBackgroundWhite
      }
    },
    '& .MuiSwitch-switchBase': {
      backgroundColor: theme.colors.ColorBackgroundWhite,
      border: theme.borders.BorderThin + " " + theme.colors.ColorGraySecondary,
      padding: 0,
      top: '3px',
      transform: 'translateX(5px)',
      '&.Mui-checked': {
        border: theme.borders.BorderThin,
        borderColor: theme.colors.ColorPrimaryBlueInteractive,
        color: theme.colors.ColorBackgroundWhite,
        transform: 'translateX(22px)',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.colors.ColorPrimaryBlueInteractive
        },
        '&:hover': {
          backgroundColor: theme.colors.ColorBackgroundWhite
        }
      }
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.colors.ColorBackgroundWhite,
      border: theme.borders.BorderThin,
      borderColor: theme.colors.ColorGraySecondary,
      height: 18,
      width: 18,
      '&:before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0
      }
    },
    '& .MuiSwitch-track': {
      backgroundColor: theme.colors.ColorGrayIncidental,
      border: theme.borders.BorderThin,
      borderColor: theme.colors.ColorGraySecondary,
      opacity: 1
    },
    '& .Mui-disabled': {
      '& + .MuiSwitch-track': {
        opacity: 1
      }
    }
  };
});
var StyledDNBCircularProgress = styled(CircularProgress)(function () {
  return {
    padding: '2px'
  };
});
var StyledSpanThumb = styled('span')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    width: theme.spacing(4),
    height: theme.spacing(4)
  };
});
var DNBToggle = function DNBToggle(_ref3) {
  var ariaLabel = _ref3.ariaLabel,
    checked = _ref3.checked,
    _ref3$isLoading = _ref3.isLoading,
    isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading,
    _ref3$isDisabled = _ref3.isDisabled,
    isDisabled = _ref3$isDisabled === void 0 ? false : _ref3$isDisabled,
    onChange = _ref3.onChange,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded$t);
  var labels = {
    inputProps: {
      'aria-label': ariaLabel
    }
  };
  var circularProgressBarSize = theme.sizing.SizingMedium;
  var circularProgressBar = React__default.createElement(StyledDNBCircularProgress, {
    "aria-label": "circular progress bar",
    size: circularProgressBarSize
  });
  var checkedIcon = isLoading ? circularProgressBar : React__default.createElement(CheckIcon, null);
  var uncheckedIcon = isLoading ? circularProgressBar : React__default.createElement(StyledSpanThumb, null);
  return React__default.createElement(StyledMuiSwitch, Object.assign({}, labels, {
    disabled: isDisabled,
    checkedIcon: checkedIcon,
    icon: uncheckedIcon,
    checked: checked,
    onChange: onChange
  }, rest));
};

var excludedProps$1 = {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'size';
  }
};
var StyledDragIndicatorIcon = styled(DragIndicatorIcon, excludedProps$1)(function (_ref) {
  var theme = _ref.theme,
    size = _ref.size;
  return {
    height: size === 'default' ? theme.spacing(6) : theme.spacing(5),
    ':hover': {
      cursor: 'grab'
    }
  };
});
var StyledDNBDivider = styled(DNBDivider, excludedProps$1)(function (_ref2) {
  var theme = _ref2.theme,
    size = _ref2.size;
  return {
    marginBottom: theme.spacing(2),
    marginTop: size === 'default' ? theme.spacing(5) : theme.spacing(4)
  };
});
var StyledMuiBoxCheckboxGroupContainer = styled(MuiBox)(function () {
  return {
    overflow: 'auto'
  };
});
var StyledMuiBoxContainer = styled(MuiBox, excludedProps$1)(function (_ref3) {
  var theme = _ref3.theme,
    size = _ref3.size;
  return {
    display: 'flex',
    flexDirection: 'column',
    padding: size === 'default' ? theme.spacing(6) : theme.spacing(3) + " " + theme.spacing(4),
    width: '100%'
  };
});
var StyledMuiBoxDraggable = styled(MuiBox)(function () {
  return {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row'
  };
});
var StyledMuiBoxFieldContainer = styled(MuiBox)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    marginTop: theme.spacing(3)
  };
});
var DNBColumnChooser = function DNBColumnChooser(_ref5) {
  var _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? 'default' : _ref5$size;
  var apiContext = useGridApiContext();
  var columns = useGridSelector(apiContext, gridColumnDefinitionsSelector);
  var columnVisibilityModel = useGridSelector(apiContext, gridColumnVisibilityModelSelector);
  var draggedItem = useRef(-1);
  var dragOverItem = useRef(-1);
  var _useState = useState(''),
    filter = _useState[0],
    setFilter = _useState[1];
  var _useState2 = useState(columns),
    columnsToList = _useState2[0],
    setColumnsToList = _useState2[1];
  var handleDragEnter = function handleDragEnter(position) {
    dragOverItem.current = position;
  };
  var handleDragEnd = function handleDragEnd() {
    var list = [].concat(columnsToList);
    var dragItemContent = list[draggedItem.current];
    list.splice(draggedItem.current, 1);
    list.splice(dragOverItem.current, 0, dragItemContent);
    apiContext.current.setColumnIndex(dragItemContent.field, dragOverItem.current);
    draggedItem.current = -1;
    dragOverItem.current = -1;
    setColumnsToList(list);
  };
  var handleDragStart = function handleDragStart(position) {
    draggedItem.current = position;
  };
  var toggleColumn = function toggleColumn(event) {
    var value = event.target.value;
    apiContext.current.setColumnVisibility(value, columnVisibilityModel[value] === false);
  };
  useEffect(function () {
    var filteredColumns = columns.filter(function (column) {
      var _column$headerName;
      return (_column$headerName = column.headerName) === null || _column$headerName === void 0 ? void 0 : _column$headerName.toLowerCase().startsWith(filter.toLowerCase());
    });
    setColumnsToList(filteredColumns);
  }, [filter]);
  return React__default.createElement(StyledMuiBoxContainer, {
    size: size
  }, React__default.createElement(DNBTypography, {
    variant: size === 'default' ? 'h6' : 'body'
  }, "Customize Columns"), React__default.createElement(StyledMuiBoxFieldContainer, null, React__default.createElement(DNBTextField, {
    placeholder: "Filter by Name",
    size: size,
    value: filter,
    onChange: function onChange(event) {
      return setFilter(event.target.value);
    },
    fullWidth: true,
    InputProps: {
      endAdornment: filter.length > 0 ? React__default.createElement(InputAdornment, {
        position: "end"
      }, React__default.createElement(IconButton, {
        "aria-label": "clear search",
        onClick: function onClick() {
          return setFilter('');
        },
        edge: "end"
      }, React__default.createElement(CloseRoundedIcon, null))) : null
    }
  })), React__default.createElement(StyledDNBDivider, {
    orientation: 'horizontal',
    size: size
  }), React__default.createElement(StyledMuiBoxCheckboxGroupContainer, null, React__default.createElement(DNBCheckboxGroup, {
    orientation: 'vertical'
  }, columnsToList.map(function (column, index) {
    return React__default.createElement(StyledMuiBoxDraggable, {
      key: "column-" + column.field,
      draggable: true,
      onDragStart: function onDragStart() {
        return handleDragStart(index);
      },
      onDragEnter: function onDragEnter() {
        return handleDragEnter(index);
      },
      onDragEnd: function onDragEnd() {
        return handleDragEnd();
      },
      onDragOver: function onDragOver(event) {
        return event.preventDefault();
      }
    }, React__default.createElement(StyledDragIndicatorIcon, {
      size: size
    }), React__default.createElement(DNBCheckbox, {
      checked: columnVisibilityModel[column.field] !== false,
      label: column.headerName,
      name: column.headerName,
      value: column.field,
      onChange: function onChange(event) {
        return toggleColumn(event);
      },
      size: 'compact'
    }));
  }))));
};

var DNBDataTableCheckbox = forwardRef(function DNBDataTableCheckbox(props, ref) {
  return React__default.createElement(DNBCheckbox, Object.assign({}, props, {
    size: 'default',
    ref: ref
  }));
});

var StyledMuiList = styled(MuiList)(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: "0 0 0 " + theme.spacing(9) + " !important",
    border: 'none !important',
    boxShadow: 'unset !important'
  };
});
var DNBHeaderMenuGrouping = function DNBHeaderMenuGrouping(_ref2) {
  var column = _ref2.column,
    labels = _ref2.labels;
  var apiRef = useGridApiContext();
  var rootProps = useGridRootProps();
  var rowGroupingModel = useGridSelector(apiRef, gridRowGroupingSanitizedModelSelector);
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var columns = rootProps.columns;
  var field = column.field,
    _column$headerName = column.headerName,
    headerName = _column$headerName === void 0 ? '' : _column$headerName;
  var handleOnClick = function handleOnClick() {
    setIsOpen(!isOpen);
  };
  var groupColumn = function groupColumn(field) {
    apiRef.current.addRowGroupingCriteria(field);
  };
  var ungroupColumn = function ungroupColumn(field) {
    apiRef.current.removeRowGroupingCriteria(field);
  };
  if (field === GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD) {
    var _labels$stopGroupingB;
    return React__default.createElement(Fragment$1, null, React__default.createElement(MuiMenuItem, {
      onClick: function onClick() {
        return handleOnClick();
      }
    }, React__default.createElement(MuiListItemIcon, null, React__default.createElement(VerticalAlignCenterIcon, null)), React__default.createElement(MuiListItemText, null, (_labels$stopGroupingB = labels === null || labels === void 0 ? void 0 : labels.stopGroupingBy) != null ? _labels$stopGroupingB : 'Stop grouping by'), React__default.createElement(MuiListItemIcon, null, isOpen ? React__default.createElement(ArrowDropDownIcon, null) : React__default.createElement(ArrowRightIcon, null))), React__default.createElement(MuiCollapse, {
      in: isOpen,
      timeout: 'auto',
      unmountOnExit: true
    }, React__default.createElement(StyledMuiList, {
      disablePadding: true
    }, rowGroupingModel.map(function (columnField) {
      var _columns$find;
      var columnHeaderName = (_columns$find = columns.find(function (column) {
        return column.field === columnField;
      })) === null || _columns$find === void 0 ? void 0 : _columns$find.headerName;
      return React__default.createElement(MuiMenuItem, {
        onClick: function onClick() {
          return ungroupColumn(columnField);
        },
        key: column.field
      }, React__default.createElement(MuiListItemText, null, columnHeaderName));
    }))));
  }
  if (rowGroupingModel.includes(field)) {
    return React__default.createElement(MuiMenuItem, {
      onClick: function onClick() {
        return ungroupColumn(field);
      }
    }, React__default.createElement(MuiListItemIcon, null, React__default.createElement(VerticalAlignCenterIcon, null)), React__default.createElement(MuiListItemText, null, labels !== null && labels !== void 0 && labels.stopGroupingBy ? labels.stopGroupingBy + " " + headerName : apiRef.current.getLocaleText('unGroupColumn')(headerName)));
  }
  return React__default.createElement(MuiMenuItem, {
    onClick: function onClick() {
      return groupColumn(field);
    }
  }, React__default.createElement(MuiListItemIcon, null, React__default.createElement(VerticalAlignCenterIcon, null)), React__default.createElement(MuiListItemText, null, labels !== null && labels !== void 0 && labels.groupBy ? labels.groupBy + " " + headerName : apiRef.current.getLocaleText('groupColumn')(headerName)));
};

var _excluded$u = ["color", "colDef", "disableSorting", "labels", "hideMenu"];
var StyledGridColumnMenuContainer = styled(GridColumnMenuContainer, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'disableSorting';
  }
})(function (_ref) {
  var theme = _ref.theme;
  return {
    background: theme.colors.ColorBackgroundButtonPrimary
  };
});
var StyledListItemText = styled(MuiListItemText)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    paddingLeft: theme.spacing(9)
  };
});
var StyledMuiList$1 = styled(MuiList)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    padding: "0 0 0 " + theme.spacing(9) + " !important",
    border: 'none !important',
    boxShadow: 'unset !important'
  };
});
var getHeaderLabels = function getHeaderLabels(apiRef, labels) {
  var _labels$autosizeThisC, _labels$autosizeAllCo, _labels$groupBy, _labels$sort;
  var labelsOfHeaders = {
    autosizeThisColumn: (_labels$autosizeThisC = labels === null || labels === void 0 ? void 0 : labels.autosizeThisColumn) != null ? _labels$autosizeThisC : 'Autosize this column',
    autosizeAllColumns: (_labels$autosizeAllCo = labels === null || labels === void 0 ? void 0 : labels.autosizeAllColumns) != null ? _labels$autosizeAllCo : 'Autosize all columns',
    groupBy: (_labels$groupBy = labels === null || labels === void 0 ? void 0 : labels.groupBy) != null ? _labels$groupBy : apiRef.current.getLocaleText('groupColumn'),
    sort: (_labels$sort = labels === null || labels === void 0 ? void 0 : labels.sort) != null ? _labels$sort : apiRef.current.getLocaleText('columnHeaderSortIconLabel')
  };
  return labelsOfHeaders;
};
var StyledExpandIcon = styled(ExpandIcon)(function () {
  return {
    transform: 'rotate(90deg)'
  };
});
var DNBColumnMenu = function DNBColumnMenu(_ref4) {
  var colDef = _ref4.colDef,
    disableSorting = _ref4.disableSorting,
    labels = _ref4.labels,
    hideMenu = _ref4.hideMenu,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded$u);
  var _useState = useState(false),
    isSortingOpen = _useState[0],
    setIsSortingOpen = _useState[1];
  var apiRef = useGridApiContext();
  var rootProps = useGridRootProps();
  var field = colDef.field,
    minWidth = colDef.minWidth;
  var columns = rootProps.columns;
  var handleSortClick = function handleSortClick() {
    setIsSortingOpen(!isSortingOpen);
  };
  var handleAutosizeColumn = function handleAutosizeColumn() {
    if (minWidth) {
      apiRef.current.setColumnWidth(field, minWidth);
    }
  };
  var handleAutosizeAllColumns = function handleAutosizeAllColumns() {
    columns.forEach(function (column) {
      var columnField = column.field,
        columnMinWidth = column.minWidth;
      if (columnMinWidth) {
        apiRef.current.setColumnWidth(columnField, columnMinWidth);
      }
    });
  };
  var _getHeaderLabels = getHeaderLabels(apiRef, labels),
    autosizeThisColumn = _getHeaderLabels.autosizeThisColumn,
    autosizeAllColumns = _getHeaderLabels.autosizeAllColumns,
    sort = _getHeaderLabels.sort;
  var getElements = function getElements() {
    var menuElementsList = [];
    if (!disableSorting) {
      menuElementsList.push(React__default.createElement(MuiMenuItem, {
        onClick: function onClick() {
          return handleSortClick();
        },
        key: "sort-item-expand-button"
      }, React__default.createElement(MuiListItemIcon, null, React__default.createElement(ImportExportIcon, null)), React__default.createElement(MuiListItemText, null, sort), React__default.createElement(MuiListItemIcon, null, isSortingOpen ? React__default.createElement(ArrowDropDownIcon, null) : React__default.createElement(ArrowRightIcon, null))), React__default.createElement(MuiCollapse, {
        in: isSortingOpen,
        timeout: 'auto',
        unmountOnExit: true,
        key: "sort-item-collapsable"
      }, React__default.createElement(StyledMuiList$1, {
        disablePadding: true
      }, React__default.createElement(GridColumnMenuSortItem, {
        onClick: hideMenu,
        colDef: colDef
      }))), React__default.createElement(MuiDivider, {
        key: "divider-sort-item"
      }));
    }
    if (!rootProps.disableColumnResize) {
      menuElementsList.push(React__default.createElement(MuiMenuItem, {
        onClick: function onClick() {
          return handleAutosizeColumn();
        },
        key: "autosize-column-item"
      }, React__default.createElement(MuiListItemIcon, null, React__default.createElement(StyledExpandIcon, null)), React__default.createElement(MuiListItemText, null, autosizeThisColumn)), React__default.createElement(MuiMenuItem, {
        onClick: function onClick() {
          return handleAutosizeAllColumns();
        },
        key: "autosize-all-columns-item"
      }, React__default.createElement(StyledListItemText, null, autosizeAllColumns)), React__default.createElement(MuiDivider, {
        key: "divider-autosize-item"
      }));
    }
    if (!rootProps.disableRowGrouping) {
      menuElementsList.push(React__default.createElement(DNBHeaderMenuGrouping, {
        column: colDef,
        labels: labels,
        key: "row-grouping-item"
      }), React__default.createElement(MuiDivider, {
        key: "divider-grouping-item"
      }));
    }
    return menuElementsList.slice(0, -1);
  };
  return React__default.createElement(StyledGridColumnMenuContainer, Object.assign({
    hideMenu: hideMenu,
    colDef: colDef
  }, rest), getElements());
};

var _excluded$v = ["children"];
var DNBDataTablePanel = forwardRef(function DNBDataTablePanel(_ref, ref) {
  var children = _ref.children,
    panelProps = _objectWithoutPropertiesLoose(_ref, _excluded$v);
  var _useState = useState(null),
    anchorEl = _useState[0],
    setAnchorEl = _useState[1];
  var apiRef = useGridApiContext();
  useEffect(function () {
    var _apiRef$current$rootE, _apiRef$current$rootE2;
    var columnHeadersElement = (_apiRef$current$rootE = apiRef.current.rootElementRef) === null || _apiRef$current$rootE === void 0 ? void 0 : (_apiRef$current$rootE2 = _apiRef$current$rootE.current) === null || _apiRef$current$rootE2 === void 0 ? void 0 : _apiRef$current$rootE2.querySelector("." + gridClasses.columnHeaders);
    if (columnHeadersElement) {
      setAnchorEl(columnHeadersElement);
    }
  }, [apiRef]);
  if (!anchorEl) {
    return null;
  }
  return React__default.createElement(GridPanel, Object.assign({}, panelProps, {
    anchorEl: anchorEl,
    ref: ref,
    placement: "bottom-end"
  }), children);
});

var StyledGridToolbarContainer = styled(GridToolbarContainer)(function () {
  return {
    justifyContent: 'end'
  };
});
var DNBDataTableToolbar = function DNBDataTableToolbar() {
  var apiRef = useGridApiContext();
  return React__default.createElement(StyledGridToolbarContainer, null, React__default.createElement(IconButton, {
    "aria-label": "open-column-chooser",
    edge: "end",
    onClick: function onClick() {
      return apiRef.current.showPreferences(GridPreferencePanelsValue.columns);
    }
  }, React__default.createElement(ViewColumnOutlinedIcon, null)));
};

var SortIndeterminateIcon = function SortIndeterminateIcon() {
  return React__default.createElement("svg", {
    width: "14",
    height: "18",
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.99L4 0L8 3.99H5V11H3V3.99H0ZM11 7V14.01H14L10 18L6 14.01H9V7H11Z",
    fill: "#6B6D6F"
  }));
};

var _excluded$w = ["autoHeight", "columns", "disableColumnFilter", "disableColumnMenu", "disableColumnResize", "disableHeader", "disableRowSelectionOnClick", "disableSorting", "getDetailPanelContent", "getDetailPanelHeight", "labels", "noDataLabel", "onPageChange", "onPageSizeChange", "onPaginationModelChange", "page", "pageSize", "pagination", "paginationMode", "paginationModel", "rowCount", "rows", "rowsPerPageOptions", "size", "slotProps", "slots", "toolbar", "variant", "zebraStripes"];
var excludedProps$2 = {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'disableHeader' && prop !== 'variant';
  }
};
var StyledDataGrid = styled(DataGridPremium, excludedProps$2)(function (_ref) {
  var _ref2;
  var theme = _ref.theme,
    disableColumnResize = _ref.disableColumnResize,
    disableHeader = _ref.disableHeader,
    disableColumnReorder = _ref.disableColumnReorder,
    variant = _ref.variant;
  var isCard = variant === 'card';
  return _ref2 = {
    borderBottom: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: isCard ? 'none' : theme.borders.BorderThin + " " + theme.colors.ColorGraySecondary,
    borderRadius: 0,
    height: 'inherit',
    '& .MuiDataGrid-main': _extends({}, isCard ? {
      border: theme.borders.BorderThin,
      borderColor: theme.colors.ColorGrayIncidental,
      borderRadius: theme.borders.BorderRadiusDefault
    } : null),
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: disableHeader ? 0 : theme.borders.BorderMedium + " " + theme.colors.ColorGrayIncidental
    },
    '& .MuiDataGrid-cell': {
      borderBottomColor: theme.colors.ColorGrayIncidental
    },
    '& .MuiDataGrid-columnHeaderTitle': _extends({}, theme.typography['compact-medium'], {
      lineHeight: 'inherit'
    }),
    '& .MuiDataGrid-columnHeader': {
      lineHeight: theme.spacing(12),
      borderRadius: theme.borders.BorderRadiusDefault,
      '&:focus-within': {
        outline: 'none'
      },
      '&:focus-visible': {
        outline: theme.borders.BorderThin + " " + theme.colors.ColorPrimaryBlueInteractive
      },
      '&.MuiDataGrid-columnHeader--sortable:hover': {
        background: theme.colors.ColorGrayPrimaryAlpha1,
        '& .MuiDataGrid-sortIcon': {
          opacity: '1 !important'
        }
      },
      '& .MuiDataGrid-columnHeaderDraggableContainer:hover': {
        cursor: disableColumnReorder ? undefined : 'move'
      },
      '& .MuiDataGrid-sortIcon': {
        opacity: 1,
        color: theme.colors.ColorGraySecondary
      },
      '& .MuiIconButton-root:nth-of-type(1):hover': {
        background: 'unset'
      }
    }
  }, _ref2["& ." + gridClasses.row + ".even"] = {
    backgroundColor: theme.colors.ColorBackgroundGray
  }, _ref2['.MuiDataGrid-footerContainer'] = {
    borderTop: isCard ? 'none' : theme.borders.BorderThin + " " + theme.colors.ColorGraySecondary,
    minHeight: 'inherit'
  }, _ref2['& .MuiDataGrid-columnSeparator'] = {
    display: disableColumnResize ? 'none' : undefined
  }, _ref2['& .MuiDataGrid-columnSeparator--resizable'] = {
    opacity: 1,
    color: theme.colors.ColorGrayIncidental,
    ':hover': {
      color: theme.colors.ColorGraySecondary,
      cursor: 'e-resize'
    }
  }, _ref2['& .MuiDataGrid-columnHeaderCheckbox'] = {
    ':focus': {
      outline: theme.borders.BorderThin + " " + theme.colors.ColorPrimaryBlueInteractive
    }
  }, _ref2['& .MuiDataGrid-pinnedColumns--left, & .MuiDataGrid-pinnedColumnHeaders--left'] = {
    boxShadow: theme.boxShadows.ShadowLeft1
  }, _ref2['& .MuiDataGrid-pinnedColumns--right, & .MuiDataGrid-pinnedColumnHeaders--right'] = {
    boxShadow: theme.boxShadows.ShadowRight1
  }, _ref2['& .MuiDataGrid-row'] = {
    '&.Mui-selected': {
      backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha1
    },
    '& .MuiDataGrid-cell': {
      '&:focus-within': {
        outline: 'none'
      },
      '&:focus-visible': {
        outline: 'none'
      },
      '& .Mui-focusVisible': {
        outline: theme.borders.BorderThin,
        outlineColor: theme.colors.ColorPrimaryBlueInteractive
      }
    }
  }, _ref2;
});
var StyledStack = styled(Stack)(function (_ref3) {
  var theme = _ref3.theme;
  return _extends({
    alignItems: 'center',
    backgroundColor: theme.colors.ColorBackgroundGrayAlpha4,
    color: theme.colors.ColorGrayPrimary,
    height: '100%',
    justifyContent: 'center'
  }, theme.typography.body);
});
var mapColumns = function mapColumns(columns, disableSorting) {
  return columns.map(function (column) {
    var _column$sortable;
    var isColumnSortable = (_column$sortable = column.sortable) != null ? _column$sortable : true;
    return _extends({}, column, {
      sortable: disableSorting ? false : isColumnSortable
    });
  });
};
var menuSxProps$1 = {
  '& .MuiMenuItem-root': _extends({}, function (theme) {
    return theme.typography['compact-medium'];
  }, {
    padding: 2,
    borderRadius: function borderRadius(theme) {
      return theme.borders.BorderRadiusCompact;
    },
    '&:last-of-type': {
      borderBottom: 'none'
    },
    minWidth: '80px',
    '&:hover': {
      background: function background(theme) {
        return theme.colors.ColorGrayPrimaryAlpha1;
      }
    },
    '&:focus-visible': {
      background: 'transparent',
      outline: function outline(theme) {
        return theme.borders.BorderMedium + " " + theme.colors.ColorPrimaryBlueInteractive;
      }
    },
    '&.MuiFocusVisible': {
      background: 'transparent'
    }
  }),
  '& .MuiList-root': _extends({
    padding: 2,
    margin: 0,
    background: function background(theme) {
      return theme.palette.background.paper;
    },
    border: function border(theme) {
      return theme.borders.BorderThin + " " + theme.colors.ColorGrayIncidental;
    }
  }, function (theme) {
    return theme.typography['compact-medium'];
  }, {
    borderRadius: function borderRadius(theme) {
      return theme.borders.BorderRadiusDefault;
    },
    overflow: 'auto',
    outline: 0,
    color: function color(theme) {
      return theme.colors.ColorGrayPrimary;
    },
    boxShadow: function boxShadow(theme) {
      return theme.boxShadows.ShadowPlus2;
    }
  })
};
var ColumnDivider = function ColumnDivider() {
  return React__default.createElement(SvgIcon, {
    viewBox: "0 0 16 16",
    x: "0px",
    y: "0px"
  }, React__default.createElement("rect", {
    x: "8.5",
    y: "0",
    width: "1",
    height: "38"
  }));
};
var DNBNoRowsOverlay = function DNBNoRowsOverlay(_ref4) {
  var noDataLabel = _ref4.noDataLabel;
  return React__default.createElement(StyledStack, null, noDataLabel);
};
var tokenToNumber = function tokenToNumber(token) {
  return parseInt(token, 10);
};
var tokenInRemToNumber = function tokenInRemToNumber(tokenInRem) {
  return +tokenInRem.split('rem')[0] * 10;
};
var DNBDataTable = function DNBDataTable(_ref5) {
  var _ref5$autoHeight = _ref5.autoHeight,
    autoHeight = _ref5$autoHeight === void 0 ? true : _ref5$autoHeight,
    columns = _ref5.columns,
    _ref5$disableColumnFi = _ref5.disableColumnFilter,
    disableColumnFilter = _ref5$disableColumnFi === void 0 ? true : _ref5$disableColumnFi,
    _ref5$disableColumnMe = _ref5.disableColumnMenu,
    disableColumnMenu = _ref5$disableColumnMe === void 0 ? true : _ref5$disableColumnMe,
    _ref5$disableColumnRe = _ref5.disableColumnResize,
    disableColumnResize = _ref5$disableColumnRe === void 0 ? true : _ref5$disableColumnRe,
    _ref5$disableHeader = _ref5.disableHeader,
    disableHeader = _ref5$disableHeader === void 0 ? false : _ref5$disableHeader,
    _ref5$disableRowSelec = _ref5.disableRowSelectionOnClick,
    disableRowSelectionOnClick = _ref5$disableRowSelec === void 0 ? true : _ref5$disableRowSelec,
    _ref5$disableSorting = _ref5.disableSorting,
    disableSorting = _ref5$disableSorting === void 0 ? false : _ref5$disableSorting,
    _ref5$getDetailPanelC = _ref5.getDetailPanelContent,
    getDetailPanelContent = _ref5$getDetailPanelC === void 0 ? undefined : _ref5$getDetailPanelC,
    _ref5$getDetailPanelH = _ref5.getDetailPanelHeight,
    getDetailPanelHeight = _ref5$getDetailPanelH === void 0 ? undefined : _ref5$getDetailPanelH,
    labels = _ref5.labels,
    _ref5$noDataLabel = _ref5.noDataLabel,
    noDataLabel = _ref5$noDataLabel === void 0 ? 'No data yet.' : _ref5$noDataLabel,
    onPageChange = _ref5.onPageChange,
    onPageSizeChange = _ref5.onPageSizeChange,
    onPaginationModelChange = _ref5.onPaginationModelChange,
    _ref5$page = _ref5.page,
    page = _ref5$page === void 0 ? 0 : _ref5$page,
    _ref5$pageSize = _ref5.pageSize,
    pageSize = _ref5$pageSize === void 0 ? 10 : _ref5$pageSize,
    _ref5$pagination = _ref5.pagination,
    pagination = _ref5$pagination === void 0 ? true : _ref5$pagination,
    paginationMode = _ref5.paginationMode,
    paginationModel = _ref5.paginationModel,
    rowCount = _ref5.rowCount,
    rows = _ref5.rows,
    _ref5$rowsPerPageOpti = _ref5.rowsPerPageOptions,
    rowsPerPageOptions = _ref5$rowsPerPageOpti === void 0 ? [10, 25, 50, 100] : _ref5$rowsPerPageOpti,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? 'default' : _ref5$size,
    slotProps = _ref5.slotProps,
    slots = _ref5.slots,
    _ref5$toolbar = _ref5.toolbar,
    toolbar = _ref5$toolbar === void 0 ? false : _ref5$toolbar,
    _ref5$variant = _ref5.variant,
    variant = _ref5$variant === void 0 ? 'default' : _ref5$variant,
    _ref5$zebraStripes = _ref5.zebraStripes,
    zebraStripes = _ref5$zebraStripes === void 0 ? true : _ref5$zebraStripes,
    dataTableProps = _objectWithoutPropertiesLoose(_ref5, _excluded$w);
  var _useState = useState(pageSize),
    itemsPerPage = _useState[0],
    setItemsPerPage = _useState[1];
  var _useState2 = useState(page),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var _useState3 = useState({
      page: page,
      pageSize: pageSize
    }),
    paginationModelData = _useState3[0],
    setPaginationModelData = _useState3[1];
  useEffect(function () {
    setItemsPerPage(pageSize);
    if (onPageSizeChange) {
      onPageSizeChange(pageSize);
    }
  }, [pageSize]);
  useEffect(function () {
    setCurrentPage(page);
    if (onPageChange) {
      onPageChange(page || 0);
    }
  }, [page]);
  useEffect(function () {
    setPaginationModelData({
      page: currentPage,
      pageSize: itemsPerPage
    });
  }, [itemsPerPage, currentPage]);
  var dataTableLabels = noDataLabel ? _extends({}, labels, {
    noData: noDataLabel
  }) : labels;
  var mappedColumns = useMemo(function () {
    return mapColumns(columns, disableSorting);
  }, [columns, disableSorting]);
  var tableHeights = {
    default: {
      header: tokenInRemToNumber(tokens.TokenSpacing.Spacing13),
      cell: tokenToNumber(tokens.TokenSizing.SizingComponentDefault)
    },
    compact: {
      header: tokenInRemToNumber(tokens.TokenSpacing.Spacing11),
      cell: tokenToNumber(tokens.TokenSizing.SizingComponentCompact)
    },
    small: {
      header: tokenInRemToNumber(tokens.TokenSpacing.Spacing9),
      cell: tokenToNumber(tokens.TokenSizing.SizingComponentSmall)
    }
  };
  var handlePaginationPageChange = function handlePaginationPageChange(_, page) {
    if (paginationMode !== 'server') {
      setCurrentPage(page);
    }
    if (onPageChange) {
      onPageChange(page || 0);
    }
  };
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    var numberOfRows = parseInt(event.target.value, 10);
    if (paginationMode !== 'server') {
      setItemsPerPage(numberOfRows);
      setCurrentPage(0);
    }
    if (onPageSizeChange) {
      onPageSizeChange(numberOfRows);
    }
  };
  var handlePaginationModelChange = function handlePaginationModelChange(model, details) {
    if (onPaginationModelChange) {
      onPaginationModelChange(model, details);
    } else if (paginationMode === 'server') {
      setPaginationModelData({
        page: model.page,
        pageSize: model.pageSize
      });
    }
  };
  var paginationProps = _extends({}, paginationMode === 'server' ? {
    count: rowCount != null ? rowCount : -1,
    page: currentPage || 0
  } : {
    count: rows.length,
    page: currentPage
  }, {
    onPageChange: handlePaginationPageChange,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    onRowsPerPageChange: handleChangeRowsPerPage
  });
  return React__default.createElement(StyledDataGrid, Object.assign({
    autoHeight: autoHeight,
    disableColumnFilter: disableColumnFilter,
    disableColumnMenu: disableColumnMenu,
    disableColumnResize: disableColumnResize,
    disableRowSelectionOnClick: disableRowSelectionOnClick,
    disableVirtualization: true,
    getRowClassName: function getRowClassName(params) {
      var evenOrOdd = params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
      return zebraStripes ? evenOrOdd : '';
    },
    disableHeader: disableHeader,
    columnHeaderHeight: disableHeader ? 0 : tableHeights[size].header,
    pagination: pagination
  }, dataTableProps, {
    columns: mappedColumns,
    rows: rows,
    getDetailPanelContent: getDetailPanelContent,
    getDetailPanelHeight: getDetailPanelHeight,
    pageSizeOptions: rowsPerPageOptions,
    paginationModel: paginationModel != null ? paginationModel : paginationModelData,
    onPaginationModelChange: handlePaginationModelChange,
    components: _extends({
      BaseCheckbox: DNBDataTableCheckbox,
      ColumnMenu: DNBColumnMenu,
      ColumnResizeIcon: ColumnDivider,
      ColumnUnsortedIcon: SortIndeterminateIcon,
      ColumnsPanel: DNBColumnChooser,
      DetailPanelCollapseIcon: KeyboardArrowUpIcon,
      DetailPanelExpandIcon: KeyboardArrowDownIcon,
      NoRowsOverlay: DNBNoRowsOverlay,
      Pagination: DNBTablePagination,
      Panel: DNBDataTablePanel,
      Toolbar: toolbar ? DNBDataTableToolbar : null
    }, slots),
    componentsProps: _extends({
      basePopper: {
        sx: menuSxProps$1
      },
      columnMenu: {
        disableSorting: disableSorting,
        labels: dataTableLabels === null || dataTableLabels === void 0 ? void 0 : dataTableLabels.headerMenu
      },
      columnsPanel: {
        size: size === 'default' ? 'default' : 'compact'
      },
      noRowsOverlay: {
        noDataLabel: dataTableLabels === null || dataTableLabels === void 0 ? void 0 : dataTableLabels.noData
      },
      pagination: _extends({}, paginationProps)
    }, slotProps),
    rowHeight: tableHeights[size].cell,
    size: size,
    variant: variant
  }));
};

var Adder = /*#__PURE__*/function () {
  function Adder() {
    this._partials = new Float64Array(32);
    this._n = 0;
  }
  var _proto = Adder.prototype;
  _proto.add = function add(x) {
    var p = this._partials;
    var i = 0;
    for (var j = 0; j < this._n && j < 32; j++) {
      var y = p[j],
        hi = x + y,
        lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
      if (lo) p[i++] = lo;
      x = hi;
    }
    p[i] = x;
    this._n = i + 1;
    return this;
  };
  _proto.valueOf = function valueOf() {
    var p = this._partials;
    var n = this._n,
      x,
      y,
      lo,
      hi = 0;
    if (n > 0) {
      hi = p[--n];
      while (n > 0) {
        x = hi;
        y = p[--n];
        hi = x + y;
        lo = y - (hi - x);
        if (lo) break;
      }
      if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
        y = lo * 2;
        x = hi + y;
        if (y == x - hi) hi = x;
      }
    }
    return hi;
  };
  return Adder;
}();

var _marked = /*#__PURE__*/_regeneratorRuntime().mark(flatten);
function flatten(arrays) {
  var _iterator, _step, array;
  return _regeneratorRuntime().wrap(function flatten$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _iterator = _createForOfIteratorHelperLoose(arrays);
      case 1:
        if ((_step = _iterator()).done) {
          _context.next = 6;
          break;
        }
        array = _step.value;
        return _context.delegateYield(array, "t0", 4);
      case 4:
        _context.next = 1;
        break;
      case 6:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
function merge(arrays) {
  return Array.from(flatten(arrays));
}

var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var exp = Math.exp;
var log = Math.log;
var sin = Math.sin;
var sign = Math.sign || function (x) {
  return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt = Math.sqrt;
var tan = Math.tan;
function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function noop$1() {}

function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}
var streamObjectType = {
  Feature: function Feature(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function FeatureCollection(object, stream) {
    var features = object.features,
      i = -1,
      n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};
var streamGeometryType = {
  Sphere: function Sphere(object, stream) {
    stream.sphere();
  },
  Point: function Point(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function MultiPoint(object, stream) {
    var coordinates = object.coordinates,
      i = -1,
      n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function LineString(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function MultiLineString(object, stream) {
    var coordinates = object.coordinates,
      i = -1,
      n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function Polygon(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function MultiPolygon(object, stream) {
    var coordinates = object.coordinates,
      i = -1,
      n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function GeometryCollection(object, stream) {
    var geometries = object.geometries,
      i = -1,
      n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};
function streamLine(coordinates, stream, closed) {
  var i = -1,
    n = coordinates.length - closed,
    coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}
function streamPolygon(coordinates, stream) {
  var i = -1,
    n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}
function geoStream (object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
}

function spherical(cartesian) {
  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
}
function cartesian(spherical) {
  var lambda = spherical[0],
    phi = spherical[1],
    cosPhi = cos(phi);
  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
}
function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}

function compose (a, b) {
  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }
  if (a.invert && b.invert) compose.invert = function (x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };
  return compose;
}

function rotationIdentity(lambda, phi) {
  if (abs(lambda) > pi) lambda -= Math.round(lambda / tau) * tau;
  return [lambda, phi];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
  return function (lambda, phi) {
    lambda += deltaLambda;
    if (abs(lambda) > pi) lambda -= Math.round(lambda / tau) * tau;
    return [lambda, phi];
  };
}
function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos(deltaPhi),
    sinDeltaPhi = sin(deltaPhi),
    cosDeltaGamma = cos(deltaGamma),
    sinDeltaGamma = sin(deltaGamma);
  function rotation(lambda, phi) {
    var cosPhi = cos(phi),
      x = cos(lambda) * cosPhi,
      y = sin(lambda) * cosPhi,
      z = sin(phi),
      k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi), asin(k * cosDeltaGamma + y * sinDeltaGamma)];
  }
  rotation.invert = function (lambda, phi) {
    var cosPhi = cos(phi),
      x = cos(lambda) * cosPhi,
      y = sin(lambda) * cosPhi,
      z = sin(phi),
      k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi), asin(k * cosDeltaPhi - x * sinDeltaPhi)];
  };
  return rotation;
}
function rotation (rotate) {
  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
  }
  forward.invert = function (coordinates) {
    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
  };
  return forward;
}

function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = cos(radius),
    sinRadius = sin(radius),
    step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * tau;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
    stream.point(point[0], point[1]);
  }
}
function circleRadius(cosRadius, point) {
  point = cartesian(point), point[0] -= cosRadius;
  cartesianNormalizeInPlace(point);
  var radius = acos(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
}

function clipBuffer () {
  var lines = [],
    line;
  return {
    point: function point(x, y, m) {
      line.push([x, y, m]);
    },
    lineStart: function lineStart() {
      lines.push(line = []);
    },
    lineEnd: noop$1,
    rejoin: function rejoin() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function result() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}

function pointEqual (a, b) {
  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
}

function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other;
  this.e = entry;
  this.v = false;
  this.n = this.p = null;
}
function clipRejoin (segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
    clip = [],
    i,
    n;
  segments.forEach(function (segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n,
      p0 = segment[0],
      p1 = segment[n],
      x;
    if (pointEqual(p0, p1)) {
      if (!p0[2] && !p1[2]) {
        stream.lineStart();
        for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
        stream.lineEnd();
        return;
      }
      p1[0] += 2 * epsilon;
    }
    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });
  if (!subject.length) return;
  clip.sort(compareIntersection);
  link(subject);
  link(clip);
  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }
  var start = subject[0],
    points,
    point;
  while (1) {
    var current = start,
      isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
}
function link(array) {
  if (!(n = array.length)) return;
  var n,
    i = 0,
    a = array[0],
    b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}

function longitude(point) {
  return abs(point[0]) <= pi ? point[0] : sign(point[0]) * ((abs(point[0]) + pi) % tau - pi);
}
function polygonContains (polygon, point) {
  var lambda = longitude(point),
    phi = point[1],
    sinPhi = sin(phi),
    normal = [sin(lambda), -cos(lambda), 0],
    angle = 0,
    winding = 0;
  var sum = new Adder();
  if (sinPhi === 1) phi = halfPi + epsilon;else if (sinPhi === -1) phi = -halfPi - epsilon;
  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
      m,
      point0 = ring[m - 1],
      lambda0 = longitude(point0),
      phi0 = point0[1] / 2 + quarterPi,
      sinPhi0 = sin(phi0),
      cosPhi0 = cos(phi0);
    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
        lambda1 = longitude(point1),
        phi1 = point1[1] / 2 + quarterPi,
        sinPhi1 = sin(phi1),
        cosPhi1 = cos(phi1),
        delta = lambda1 - lambda0,
        sign = delta >= 0 ? 1 : -1,
        absDelta = sign * delta,
        antimeridian = absDelta > pi,
        k = sinPhi0 * sinPhi1;
      sum.add(atan2(k * sign * sin(absDelta), cosPhi0 * cosPhi1 + k * cos(absDelta)));
      angle += antimeridian ? delta + sign * tau : delta;
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }
  return (angle < -epsilon || angle < epsilon && sum < -epsilon2) ^ winding & 1;
}

function clip (pointVisible, clipLine, interpolate, start) {
  return function (sink) {
    var line = clipLine(sink),
      ringBuffer = clipBuffer(),
      ringSink = clipLine(ringBuffer),
      polygonStarted = false,
      polygon,
      segments,
      ring;
    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function polygonStart() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function polygonEnd() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = merge(segments);
        var startInside = polygonContains(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function sphere() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };
    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }
    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }
    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }
    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }
    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }
    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }
    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();
      var clean = ringSink.clean(),
        ringSegments = ringBuffer.result(),
        i,
        n = ringSegments.length,
        m,
        segment,
        point;
      ring.pop();
      polygon.push(ring);
      ring = null;
      if (!n) return;
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
      segments.push(ringSegments.filter(validSegment));
    }
    return clip;
  };
}
function validSegment(segment) {
  return segment.length > 1;
}
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
}

var clipAntimeridian = clip(function () {
  return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [-pi, -halfPi]);
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
    phi0 = NaN,
    sign0 = NaN,
    _clean;
  return {
    lineStart: function lineStart() {
      stream.lineStart();
      _clean = 1;
    },
    point: function point(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi : -pi,
        delta = abs(lambda1 - lambda0);
      if (abs(delta - pi) < epsilon) {
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        _clean = 0;
      } else if (sign0 !== sign1 && delta >= pi) {
        if (abs(lambda0 - sign0) < epsilon) lambda0 -= sign0 * epsilon;
        if (abs(lambda1 - sign1) < epsilon) lambda1 -= sign1 * epsilon;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        _clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function lineEnd() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function clean() {
      return 2 - _clean;
    }
  };
}
function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
    cosPhi1,
    sinLambda0Lambda1 = sin(lambda0 - lambda1);
  return abs(sinLambda0Lambda1) > epsilon ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1) - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi;
    stream.point(-pi, phi);
    stream.point(0, phi);
    stream.point(pi, phi);
    stream.point(pi, 0);
    stream.point(pi, -phi);
    stream.point(0, -phi);
    stream.point(-pi, -phi);
    stream.point(-pi, 0);
    stream.point(-pi, phi);
  } else if (abs(from[0] - to[0]) > epsilon) {
    var lambda = from[0] < to[0] ? pi : -pi;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}

function clipCircle (radius) {
  var cr = cos(radius),
    delta = 6 * radians,
    smallRadius = cr > 0,
    notHemisphere = abs(cr) > epsilon;
  function interpolate(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }
  function visible(lambda, phi) {
    return cos(lambda) * cos(phi) > cr;
  }
  function clipLine(stream) {
    var point0, c0, v0, v00, _clean;
    return {
      lineStart: function lineStart() {
        v00 = v0 = false;
        _clean = 1;
      },
      point: function point(lambda, phi) {
        var point1 = [lambda, phi],
          point2,
          v = visible(lambda, phi),
          c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) point1[2] = 1;
        }
        if (v !== v0) {
          _clean = 0;
          if (v) {
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1], 2);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            _clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1], 3);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function lineEnd() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      clean: function clean() {
        return _clean | (v00 && v0) << 1;
      }
    };
  }
  function intersect(a, b, two) {
    var pa = cartesian(a),
      pb = cartesian(b);
    var n1 = [1, 0, 0],
      n2 = cartesianCross(pa, pb),
      n2n2 = cartesianDot(n2, n2),
      n1n2 = n2[0],
      determinant = n2n2 - n1n2 * n1n2;
    if (!determinant) return !two && a;
    var c1 = cr * n2n2 / determinant,
      c2 = -cr * n1n2 / determinant,
      n1xn2 = cartesianCross(n1, n2),
      A = cartesianScale(n1, c1),
      B = cartesianScale(n2, c2);
    cartesianAddInPlace(A, B);
    var u = n1xn2,
      w = cartesianDot(A, u),
      uu = cartesianDot(u, u),
      t2 = w * w - uu * (cartesianDot(A, A) - 1);
    if (t2 < 0) return;
    var t = sqrt(t2),
      q = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q, A);
    q = spherical(q);
    if (!two) return q;
    var lambda0 = a[0],
      lambda1 = b[0],
      phi0 = a[1],
      phi1 = b[1],
      z;
    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
    var delta = lambda1 - lambda0,
      polar = abs(delta - pi) < epsilon,
      meridian = polar || delta < epsilon;
    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
    if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A);
      return [q, spherical(q1)];
    }
  }
  function code(lambda, phi) {
    var r = smallRadius ? radius : pi - radius,
      code = 0;
    if (lambda < -r) code |= 1;else if (lambda > r) code |= 2;
    if (phi < -r) code |= 4;else if (phi > r) code |= 8;
    return code;
  }
  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi, radius - pi]);
}

function clipLine (a, b, x0, y0, x1, y1) {
  var ax = a[0],
    ay = a[1],
    bx = b[0],
    by = b[1],
    t0 = 0,
    t1 = 1,
    dx = bx - ax,
    dy = by - ay,
    r;
  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }
  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }
  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }
  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }
  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
}

var clipMax = 1e9,
  clipMin = -clipMax;
function clipRectangle(x0, y0, x1, y1) {
  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }
  function interpolate(from, to, direction, stream) {
    var a = 0,
      a1 = 0;
    if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0); while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }
  function corner(p, direction) {
    return abs(p[0] - x0) < epsilon ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < epsilon ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < epsilon ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
  }
  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }
  function comparePoint(a, b) {
    var ca = corner(a, 1),
      cb = corner(b, 1);
    return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
  }
  return function (stream) {
    var activeStream = stream,
      bufferStream = clipBuffer(),
      segments,
      polygon,
      ring,
      x__,
      y__,
      v__,
      x_,
      y_,
      v_,
      first,
      clean;
    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };
    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }
    function polygonInside() {
      var winding = 0;
      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) {
            if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
          } else {
            if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
          }
        }
      }
      return winding;
    }
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }
    function polygonEnd() {
      var startInside = polygonInside(),
        cleanInside = clean && startInside,
        visible = (segments = merge(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }
    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }
    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
            b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }
    return clipStream;
  };
}

var identity = (function (x) {
  return x;
});

var areaSum = new Adder(),
  areaRingSum = new Adder(),
  x00,
  y00,
  x0,
  y0;
var areaStream = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function polygonStart() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function polygonEnd() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$1;
    areaSum.add(abs(areaRingSum));
    areaRingSum = new Adder();
  },
  result: function result() {
    var area = areaSum / 2;
    areaSum = new Adder();
    return area;
  }
};
function areaRingStart() {
  areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}
function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}
function areaRingEnd() {
  areaPoint(x00, y00);
}

var x0$1 = Infinity,
  y0$1 = x0$1,
  x1 = -x0$1,
  y1 = x1;
var boundsStream = {
  point: boundsPoint,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1,
  result: function result() {
    var bounds = [[x0$1, y0$1], [x1, y1]];
    x1 = y1 = -(y0$1 = x0$1 = Infinity);
    return bounds;
  }
};
function boundsPoint(x, y) {
  if (x < x0$1) x0$1 = x;
  if (x > x1) x1 = x;
  if (y < y0$1) y0$1 = y;
  if (y > y1) y1 = y;
}

var X0 = 0,
  Y0 = 0,
  Z0 = 0,
  X1 = 0,
  Y1 = 0,
  Z1 = 0,
  X2 = 0,
  Y2 = 0,
  Z2 = 0,
  x00$1,
  y00$1,
  x0$2,
  y0$2;
var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function polygonStart() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function polygonEnd() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function result() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2] : Z1 ? [X1 / Z1, Y1 / Z1] : Z0 ? [X0 / Z0, Y0 / Z0] : [NaN, NaN];
    X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
    return centroid;
  }
};
function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}
function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0$2 = x, y0$2 = y);
}
function centroidPointLine(x, y) {
  var dx = x - x0$2,
    dy = y - y0$2,
    z = sqrt(dx * dx + dy * dy);
  X1 += z * (x0$2 + x) / 2;
  Y1 += z * (y0$2 + y) / 2;
  Z1 += z;
  centroidPoint(x0$2 = x, y0$2 = y);
}
function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}
function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
  centroidPointRing(x00$1, y00$1);
}
function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00$1 = x0$2 = x, y00$1 = y0$2 = y);
}
function centroidPointRing(x, y) {
  var dx = x - x0$2,
    dy = y - y0$2,
    z = sqrt(dx * dx + dy * dy);
  X1 += z * (x0$2 + x) / 2;
  Y1 += z * (y0$2 + y) / 2;
  Z1 += z;
  z = y0$2 * x - x0$2 * y;
  X2 += z * (x0$2 + x);
  Y2 += z * (y0$2 + y);
  Z2 += z * 3;
  centroidPoint(x0$2 = x, y0$2 = y);
}

function PathContext(context) {
  this._context = context;
}
PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function pointRadius(_) {
    return this._radius = _, this;
  },
  polygonStart: function polygonStart() {
    this._line = 0;
  },
  polygonEnd: function polygonEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function point(x, y) {
    switch (this._point) {
      case 0:
        {
          this._context.moveTo(x, y);
          this._point = 1;
          break;
        }
      case 1:
        {
          this._context.lineTo(x, y);
          break;
        }
      default:
        {
          this._context.moveTo(x + this._radius, y);
          this._context.arc(x, y, this._radius, 0, tau);
          break;
        }
    }
  },
  result: noop$1
};

var lengthSum = new Adder(),
  lengthRing,
  x00$2,
  y00$2,
  x0$3,
  y0$3;
var lengthStream = {
  point: noop$1,
  lineStart: function lineStart() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function lineEnd() {
    if (lengthRing) lengthPoint(x00$2, y00$2);
    lengthStream.point = noop$1;
  },
  polygonStart: function polygonStart() {
    lengthRing = true;
  },
  polygonEnd: function polygonEnd() {
    lengthRing = null;
  },
  result: function result() {
    var length = +lengthSum;
    lengthSum = new Adder();
    return length;
  }
};
function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00$2 = x0$3 = x, y00$2 = y0$3 = y;
}
function lengthPoint(x, y) {
  x0$3 -= x, y0$3 -= y;
  lengthSum.add(sqrt(x0$3 * x0$3 + y0$3 * y0$3));
  x0$3 = x, y0$3 = y;
}

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4;
var cacheDigits, cacheAppend, cacheRadius, cacheCircle;
var PathString = /*#__PURE__*/function () {
  function PathString(digits) {
    this._append = digits == null ? append : appendRound(digits);
    this._radius = 4.5;
    this._ = "";
  }
  var _proto = PathString.prototype;
  _proto.pointRadius = function pointRadius(_) {
    this._radius = +_;
    return this;
  };
  _proto.polygonStart = function polygonStart() {
    this._line = 0;
  };
  _proto.polygonEnd = function polygonEnd() {
    this._line = NaN;
  };
  _proto.lineStart = function lineStart() {
    this._point = 0;
  };
  _proto.lineEnd = function lineEnd() {
    if (this._line === 0) this._ += "Z";
    this._point = NaN;
  };
  _proto.point = function point(x, y) {
    switch (this._point) {
      case 0:
        {
          this._append(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["M", ",", ""])), x, y);
          this._point = 1;
          break;
        }
      case 1:
        {
          this._append(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["L", ",", ""])), x, y);
          break;
        }
      default:
        {
          this._append(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["M", ",", ""])), x, y);
          if (this._radius !== cacheRadius || this._append !== cacheAppend) {
            var r = this._radius;
            var s = this._;
            this._ = "";
            this._append(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["m0,", "a", ",", " 0 1,1 0,", "a", ",", " 0 1,1 0,", "z"])), r, r, r, -2 * r, r, r, 2 * r);
            cacheRadius = r;
            cacheAppend = this._append;
            cacheCircle = this._;
            this._ = s;
          }
          this._ += cacheCircle;
          break;
        }
    }
  };
  _proto.result = function result() {
    var result = this._;
    this._ = "";
    return result.length ? result : null;
  };
  return PathString;
}();
function append(strings) {
  var i = 1;
  this._ += strings[0];
  for (var j = strings.length; i < j; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  var d = Math.floor(digits);
  if (!(d >= 0)) throw new RangeError("invalid digits: " + digits);
  if (d > 15) return append;
  if (d !== cacheDigits) {
    var k = Math.pow(10, d);
    cacheDigits = d;
    cacheAppend = function append(strings) {
      var i = 1;
      this._ += strings[0];
      for (var j = strings.length; i < j; ++i) {
        this._ += Math.round(arguments[i] * k) / k + strings[i];
      }
    };
  }
  return cacheAppend;
}

function index (projection, context) {
  var digits = 3,
    pointRadius = 4.5,
    projectionStream,
    contextStream;
  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }
  path.area = function (object) {
    geoStream(object, projectionStream(areaStream));
    return areaStream.result();
  };
  path.measure = function (object) {
    geoStream(object, projectionStream(lengthStream));
    return lengthStream.result();
  };
  path.bounds = function (object) {
    geoStream(object, projectionStream(boundsStream));
    return boundsStream.result();
  };
  path.centroid = function (object) {
    geoStream(object, projectionStream(centroidStream));
    return centroidStream.result();
  };
  path.projection = function (_) {
    if (!arguments.length) return projection;
    projectionStream = _ == null ? (projection = null, identity) : (projection = _).stream;
    return path;
  };
  path.context = function (_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString(digits)) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };
  path.pointRadius = function (_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };
  path.digits = function (_) {
    if (!arguments.length) return digits;
    if (_ == null) digits = null;else {
      var d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError("invalid digits: " + _);
      digits = d;
    }
    if (context === null) contextStream = new PathString(digits);
    return path;
  };
  return path.projection(projection).digits(digits).context(context);
}

function transformer(methods) {
  return function (stream) {
    var s = new TransformStream();
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}
function TransformStream() {}
TransformStream.prototype = {
  constructor: TransformStream,
  point: function point(x, y) {
    this.stream.point(x, y);
  },
  sphere: function sphere() {
    this.stream.sphere();
  },
  lineStart: function lineStart() {
    this.stream.lineStart();
  },
  lineEnd: function lineEnd() {
    this.stream.lineEnd();
  },
  polygonStart: function polygonStart() {
    this.stream.polygonStart();
  },
  polygonEnd: function polygonEnd() {
    this.stream.polygonEnd();
  }
};

function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  geoStream(object, projection.stream(boundsStream));
  fitBounds(boundsStream.result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}
function fitExtent(projection, extent, object) {
  return fit(projection, function (b) {
    var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}
function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}
function fitWidth(projection, width, object) {
  return fit(projection, function (b) {
    var w = +width,
      k = w / (b[1][0] - b[0][0]),
      x = (w - k * (b[1][0] + b[0][0])) / 2,
      y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}
function fitHeight(projection, height, object) {
  return fit(projection, function (b) {
    var h = +height,
      k = h / (b[1][1] - b[0][1]),
      x = -k * b[0][0],
      y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

var maxDepth = 16,
  cosMinDistance = cos(30 * radians);
function resample (project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
}
function resampleNone(project) {
  return transformer({
    point: function point(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}
function resample$1(project, delta2) {
  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
      dy = y1 - y0,
      d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
        b = b0 + b1,
        c = c0 + c1,
        m = sqrt(a * a + b * b + c * c),
        phi2 = asin(c /= m),
        lambda2 = abs(abs(c) - 1) < epsilon || abs(lambda0 - lambda1) < epsilon ? (lambda0 + lambda1) / 2 : atan2(b, a),
        p = project(lambda2, phi2),
        x2 = p[0],
        y2 = p[1],
        dx2 = x2 - x0,
        dy2 = y2 - y0,
        dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function (stream) {
    var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0;
    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function polygonStart() {
        stream.polygonStart();
        resampleStream.lineStart = ringStart;
      },
      polygonEnd: function polygonEnd() {
        stream.polygonEnd();
        resampleStream.lineStart = lineStart;
      }
    };
    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }
    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }
    function linePoint(lambda, phi) {
      var c = cartesian([lambda, phi]),
        p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }
    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }
    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }
    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }
    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }
    return resampleStream;
  };
}

var transformRadians = transformer({
  point: function point(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});
function transformRotate(rotate) {
  return transformer({
    point: function point(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function scaleTranslate(k, dx, dy, sx, sy) {
  function transform(x, y) {
    x *= sx;
    y *= sy;
    return [dx + k * x, dy - k * y];
  }
  transform.invert = function (x, y) {
    return [(x - dx) / k * sx, (dy - y) / k * sy];
  };
  return transform;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
  if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
  var cosAlpha = cos(alpha),
    sinAlpha = sin(alpha),
    a = cosAlpha * k,
    b = sinAlpha * k,
    ai = cosAlpha / k,
    bi = sinAlpha / k,
    ci = (sinAlpha * dy - cosAlpha * dx) / k,
    fi = (sinAlpha * dx + cosAlpha * dy) / k;
  function transform(x, y) {
    x *= sx;
    y *= sy;
    return [a * x - b * y + dx, dy - b * x - a * y];
  }
  transform.invert = function (x, y) {
    return [sx * (ai * x - bi * y + ci), sy * (fi - bi * x - ai * y)];
  };
  return transform;
}
function projection(project) {
  return projectionMutator(function () {
    return project;
  })();
}
function projectionMutator(projectAt) {
  var project,
    k = 150,
    x = 480,
    y = 250,
    lambda = 0,
    phi = 0,
    deltaLambda = 0,
    deltaPhi = 0,
    deltaGamma = 0,
    rotate,
    alpha = 0,
    sx = 1,
    sy = 1,
    theta = null,
    preclip = clipAntimeridian,
    x0 = null,
    y0,
    x1,
    y1,
    postclip = identity,
    delta2 = 0.5,
    projectResample,
    projectTransform,
    projectRotateTransform,
    cache,
    cacheStream;
  function projection(point) {
    return projectRotateTransform(point[0] * radians, point[1] * radians);
  }
  function invert(point) {
    point = projectRotateTransform.invert(point[0], point[1]);
    return point && [point[0] * degrees, point[1] * degrees];
  }
  projection.stream = function (stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };
  projection.preclip = function (_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };
  projection.postclip = function (_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };
  projection.clipAngle = function (_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
  };
  projection.clipExtent = function (_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };
  projection.scale = function (_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };
  projection.translate = function (_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };
  projection.center = function (_) {
    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
  };
  projection.rotate = function (_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
  };
  projection.angle = function (_) {
    return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
  };
  projection.reflectX = function (_) {
    return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
  };
  projection.reflectY = function (_) {
    return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
  };
  projection.precision = function (_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
  };
  projection.fitExtent = function (extent, object) {
    return fitExtent(projection, extent, object);
  };
  projection.fitSize = function (size, object) {
    return fitSize(projection, size, object);
  };
  projection.fitWidth = function (width, object) {
    return fitWidth(projection, width, object);
  };
  projection.fitHeight = function (height, object) {
    return fitHeight(projection, height, object);
  };
  function recenter() {
    var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)),
      transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
    rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = compose(project, transform);
    projectRotateTransform = compose(rotate, projectTransform);
    projectResample = resample(projectTransform, delta2);
    return reset();
  }
  function reset() {
    cache = cacheStream = null;
    return projection;
  }
  return function () {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}

function conicProjection(projectAt) {
  var phi0 = 0,
    phi1 = pi / 3,
    m = projectionMutator(projectAt),
    p = m(phi0, phi1);
  p.parallels = function (_) {
    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
  };
  return p;
}

function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos(phi0);
  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin(phi) / cosPhi0];
  }
  forward.invert = function (x, y) {
    return [x / cosPhi0, asin(y * cosPhi0)];
  };
  return forward;
}

function conicEqualAreaRaw(y0, y1) {
  var sy0 = sin(y0),
    n = (sy0 + sin(y1)) / 2;
  if (abs(n) < epsilon) return cylindricalEqualAreaRaw(y0);
  var c = 1 + sy0 * (2 * n - sy0),
    r0 = sqrt(c) / n;
  function project(x, y) {
    var r = sqrt(c - 2 * n * sin(y)) / n;
    return [r * sin(x *= n), r0 - r * cos(x)];
  }
  project.invert = function (x, y) {
    var r0y = r0 - y,
      l = atan2(x, abs(r0y)) * sign(r0y);
    if (r0y * n < 0) l -= pi * sign(x) * sign(r0y);
    return [l / n, asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };
  return project;
}
function conicEqualArea () {
  return conicProjection(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
}

function albers () {
  return conicEqualArea().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}

function multiplex(streams) {
  var n = streams.length;
  return {
    point: function point(x, y) {
      var i = -1;
      while (++i < n) streams[i].point(x, y);
    },
    sphere: function sphere() {
      var i = -1;
      while (++i < n) streams[i].sphere();
    },
    lineStart: function lineStart() {
      var i = -1;
      while (++i < n) streams[i].lineStart();
    },
    lineEnd: function lineEnd() {
      var i = -1;
      while (++i < n) streams[i].lineEnd();
    },
    polygonStart: function polygonStart() {
      var i = -1;
      while (++i < n) streams[i].polygonStart();
    },
    polygonEnd: function polygonEnd() {
      var i = -1;
      while (++i < n) streams[i].polygonEnd();
    }
  };
}
function albersUsa () {
  var cache,
    cacheStream,
    lower48 = albers(),
    lower48Point,
    alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
    alaskaPoint,
    hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
    hawaiiPoint,
    _point,
    pointStream = {
      point: function point(x, y) {
        _point = [x, y];
      }
    };
  function albersUsa(coordinates) {
    var x = coordinates[0],
      y = coordinates[1];
    return _point = null, (lower48Point.point(x, y), _point) || (alaskaPoint.point(x, y), _point) || (hawaiiPoint.point(x, y), _point);
  }
  albersUsa.invert = function (coordinates) {
    var k = lower48.scale(),
      t = lower48.translate(),
      x = (coordinates[0] - t[0]) / k,
      y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
  };
  albersUsa.stream = function (stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };
  albersUsa.precision = function (_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };
  albersUsa.scale = function (_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };
  albersUsa.translate = function (_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(),
      x = +_[0],
      y = +_[1];
    lower48Point = lower48.translate(_).clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]]).stream(pointStream);
    alaskaPoint = alaska.translate([x - 0.307 * k, y + 0.201 * k]).clipExtent([[x - 0.425 * k + epsilon, y + 0.120 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]]).stream(pointStream);
    hawaiiPoint = hawaii.translate([x - 0.205 * k, y + 0.212 * k]).clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]]).stream(pointStream);
    return reset();
  };
  albersUsa.fitExtent = function (extent, object) {
    return fitExtent(albersUsa, extent, object);
  };
  albersUsa.fitSize = function (size, object) {
    return fitSize(albersUsa, size, object);
  };
  albersUsa.fitWidth = function (width, object) {
    return fitWidth(albersUsa, width, object);
  };
  albersUsa.fitHeight = function (height, object) {
    return fitHeight(albersUsa, height, object);
  };
  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }
  return albersUsa.scale(1070);
}

function mercatorRaw(lambda, phi) {
  return [lambda, log(tan((halfPi + phi) / 2))];
}
mercatorRaw.invert = function (x, y) {
  return [x, 2 * atan(exp(y)) - halfPi];
};
function mercator () {
  return mercatorProjection(mercatorRaw).scale(961 / tau);
}
function mercatorProjection(project) {
  var m = projection(project),
    center = m.center,
    scale = m.scale,
    translate = m.translate,
    clipExtent = m.clipExtent,
    x0 = null,
    y0,
    x1,
    y1;
  m.scale = function (_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };
  m.translate = function (_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };
  m.center = function (_) {
    return arguments.length ? (center(_), reclip()) : center();
  };
  m.clipExtent = function (_) {
    return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };
  function reclip() {
    var k = pi * scale(),
      t = m(rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]] : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }
  return reclip();
}

var type = "FeatureCollection";
var features = [
	{
		type: "Feature",
		id: "01",
		id2: "AL",
		properties: {
			name: "Alabama"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-87.359296,
						35.00118
					],
					[
						-85.606675,
						34.984749
					],
					[
						-85.431413,
						34.124869
					],
					[
						-85.184951,
						32.859696
					],
					[
						-85.069935,
						32.580372
					],
					[
						-84.960397,
						32.421541
					],
					[
						-85.004212,
						32.322956
					],
					[
						-84.889196,
						32.262709
					],
					[
						-85.058981,
						32.13674
					],
					[
						-85.053504,
						32.01077
					],
					[
						-85.141136,
						31.840985
					],
					[
						-85.042551,
						31.539753
					],
					[
						-85.113751,
						31.27686
					],
					[
						-85.004212,
						31.003013
					],
					[
						-85.497137,
						30.997536
					],
					[
						-87.600282,
						30.997536
					],
					[
						-87.633143,
						30.86609
					],
					[
						-87.408589,
						30.674397
					],
					[
						-87.446927,
						30.510088
					],
					[
						-87.37025,
						30.427934
					],
					[
						-87.518128,
						30.280057
					],
					[
						-87.655051,
						30.247195
					],
					[
						-87.90699,
						30.411504
					],
					[
						-87.934375,
						30.657966
					],
					[
						-88.011052,
						30.685351
					],
					[
						-88.10416,
						30.499135
					],
					[
						-88.137022,
						30.318396
					],
					[
						-88.394438,
						30.367688
					],
					[
						-88.471115,
						31.895754
					],
					[
						-88.241084,
						33.796253
					],
					[
						-88.098683,
						34.891641
					],
					[
						-88.202745,
						34.995703
					],
					[
						-87.359296,
						35.00118
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "02",
		id2: "AK",
		properties: {
			name: "Alaska"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-131.602021,
							55.117982
						],
						[
							-131.569159,
							55.28229
						],
						[
							-131.355558,
							55.183705
						],
						[
							-131.38842,
							55.01392
						],
						[
							-131.645836,
							55.035827
						],
						[
							-131.602021,
							55.117982
						]
					]
				],
				[
					[
						[
							-131.832052,
							55.42469
						],
						[
							-131.645836,
							55.304197
						],
						[
							-131.749898,
							55.128935
						],
						[
							-131.832052,
							55.189182
						],
						[
							-131.832052,
							55.42469
						]
					]
				],
				[
					[
						[
							-132.976733,
							56.437924
						],
						[
							-132.735747,
							56.459832
						],
						[
							-132.631685,
							56.421493
						],
						[
							-132.664547,
							56.273616
						],
						[
							-132.878148,
							56.240754
						],
						[
							-133.069841,
							56.333862
						],
						[
							-132.976733,
							56.437924
						]
					]
				],
				[
					[
						[
							-133.595627,
							56.350293
						],
						[
							-133.162949,
							56.317431
						],
						[
							-133.05341,
							56.125739
						],
						[
							-132.620732,
							55.912138
						],
						[
							-132.472854,
							55.780691
						],
						[
							-132.4619,
							55.671152
						],
						[
							-132.357838,
							55.649245
						],
						[
							-132.341408,
							55.506844
						],
						[
							-132.166146,
							55.364444
						],
						[
							-132.144238,
							55.238474
						],
						[
							-132.029222,
							55.276813
						],
						[
							-131.97993,
							55.178228
						],
						[
							-131.958022,
							54.789365
						],
						[
							-132.029222,
							54.701734
						],
						[
							-132.308546,
							54.718165
						],
						[
							-132.385223,
							54.915335
						],
						[
							-132.483808,
							54.898904
						],
						[
							-132.686455,
							55.046781
						],
						[
							-132.746701,
							54.997489
						],
						[
							-132.916486,
							55.046781
						],
						[
							-132.889102,
							54.898904
						],
						[
							-132.73027,
							54.937242
						],
						[
							-132.626209,
							54.882473
						],
						[
							-132.675501,
							54.679826
						],
						[
							-132.867194,
							54.701734
						],
						[
							-133.157472,
							54.95915
						],
						[
							-133.239626,
							55.090597
						],
						[
							-133.223195,
							55.22752
						],
						[
							-133.453227,
							55.216566
						],
						[
							-133.453227,
							55.320628
						],
						[
							-133.277964,
							55.331582
						],
						[
							-133.102702,
							55.42469
						],
						[
							-133.17938,
							55.588998
						],
						[
							-133.387503,
							55.62186
						],
						[
							-133.420365,
							55.884753
						],
						[
							-133.497042,
							56.0162
						],
						[
							-133.639442,
							55.923092
						],
						[
							-133.694212,
							56.070969
						],
						[
							-133.546335,
							56.142169
						],
						[
							-133.666827,
							56.311955
						],
						[
							-133.595627,
							56.350293
						]
					]
				],
				[
					[
						[
							-133.738027,
							55.556137
						],
						[
							-133.546335,
							55.490413
						],
						[
							-133.414888,
							55.572568
						],
						[
							-133.283441,
							55.534229
						],
						[
							-133.420365,
							55.386352
						],
						[
							-133.633966,
							55.430167
						],
						[
							-133.738027,
							55.556137
						]
					]
				],
				[
					[
						[
							-133.907813,
							56.930849
						],
						[
							-134.050213,
							57.029434
						],
						[
							-133.885905,
							57.095157
						],
						[
							-133.343688,
							57.002049
						],
						[
							-133.102702,
							57.007526
						],
						[
							-132.932917,
							56.82131
						],
						[
							-132.620732,
							56.667956
						],
						[
							-132.653593,
							56.55294
						],
						[
							-132.817901,
							56.492694
						],
						[
							-133.042456,
							56.520078
						],
						[
							-133.201287,
							56.448878
						],
						[
							-133.420365,
							56.492694
						],
						[
							-133.66135,
							56.448878
						],
						[
							-133.710643,
							56.684386
						],
						[
							-133.688735,
							56.837741
						],
						[
							-133.869474,
							56.843218
						],
						[
							-133.907813,
							56.930849
						]
					]
				],
				[
					[
						[
							-134.115936,
							56.48174
						],
						[
							-134.25286,
							56.558417
						],
						[
							-134.400737,
							56.722725
						],
						[
							-134.417168,
							56.848695
						],
						[
							-134.296675,
							56.908941
						],
						[
							-134.170706,
							56.848695
						],
						[
							-134.143321,
							56.952757
						],
						[
							-133.748981,
							56.772017
						],
						[
							-133.710643,
							56.596755
						],
						[
							-133.847566,
							56.574848
						],
						[
							-133.935197,
							56.377678
						],
						[
							-133.836612,
							56.322908
						],
						[
							-133.957105,
							56.092877
						],
						[
							-134.110459,
							56.142169
						],
						[
							-134.132367,
							55.999769
						],
						[
							-134.230952,
							56.070969
						],
						[
							-134.291198,
							56.350293
						],
						[
							-134.115936,
							56.48174
						]
					]
				],
				[
					[
						[
							-134.636246,
							56.28457
						],
						[
							-134.669107,
							56.169554
						],
						[
							-134.806031,
							56.235277
						],
						[
							-135.178463,
							56.67891
						],
						[
							-135.413971,
							56.810356
						],
						[
							-135.331817,
							56.914418
						],
						[
							-135.424925,
							57.166357
						],
						[
							-135.687818,
							57.369004
						],
						[
							-135.419448,
							57.566174
						],
						[
							-135.298955,
							57.48402
						],
						[
							-135.063447,
							57.418296
						],
						[
							-134.849846,
							57.407343
						],
						[
							-134.844369,
							57.248511
						],
						[
							-134.636246,
							56.728202
						],
						[
							-134.636246,
							56.28457
						]
					]
				],
				[
					[
						[
							-134.712923,
							58.223407
						],
						[
							-134.373353,
							58.14673
						],
						[
							-134.176183,
							58.157683
						],
						[
							-134.187137,
							58.081006
						],
						[
							-133.902336,
							57.807159
						],
						[
							-134.099505,
							57.850975
						],
						[
							-134.148798,
							57.757867
						],
						[
							-133.935197,
							57.615466
						],
						[
							-133.869474,
							57.363527
						],
						[
							-134.083075,
							57.297804
						],
						[
							-134.154275,
							57.210173
						],
						[
							-134.499322,
							57.029434
						],
						[
							-134.603384,
							57.034911
						],
						[
							-134.6472,
							57.226604
						],
						[
							-134.575999,
							57.341619
						],
						[
							-134.608861,
							57.511404
						],
						[
							-134.729354,
							57.719528
						],
						[
							-134.707446,
							57.829067
						],
						[
							-134.784123,
							58.097437
						],
						[
							-134.91557,
							58.212453
						],
						[
							-134.953908,
							58.409623
						],
						[
							-134.712923,
							58.223407
						]
					]
				],
				[
					[
						[
							-135.857603,
							57.330665
						],
						[
							-135.715203,
							57.330665
						],
						[
							-135.567326,
							57.149926
						],
						[
							-135.633049,
							57.023957
						],
						[
							-135.857603,
							56.996572
						],
						[
							-135.824742,
							57.193742
						],
						[
							-135.857603,
							57.330665
						]
					]
				],
				[
					[
						[
							-136.279328,
							58.206976
						],
						[
							-135.978096,
							58.201499
						],
						[
							-135.780926,
							58.28913
						],
						[
							-135.496125,
							58.168637
						],
						[
							-135.64948,
							58.037191
						],
						[
							-135.59471,
							57.987898
						],
						[
							-135.45231,
							58.135776
						],
						[
							-135.107263,
							58.086483
						],
						[
							-134.91557,
							57.976944
						],
						[
							-135.025108,
							57.779775
						],
						[
							-134.937477,
							57.763344
						],
						[
							-134.822462,
							57.500451
						],
						[
							-135.085355,
							57.462112
						],
						[
							-135.572802,
							57.675713
						],
						[
							-135.556372,
							57.456635
						],
						[
							-135.709726,
							57.369004
						],
						[
							-135.890465,
							57.407343
						],
						[
							-136.000004,
							57.544266
						],
						[
							-136.208128,
							57.637374
						],
						[
							-136.366959,
							57.829067
						],
						[
							-136.569606,
							57.916698
						],
						[
							-136.558652,
							58.075529
						],
						[
							-136.421728,
							58.130299
						],
						[
							-136.377913,
							58.267222
						],
						[
							-136.279328,
							58.206976
						]
					]
				],
				[
					[
						[
							-147.079854,
							60.200582
						],
						[
							-147.501579,
							59.948643
						],
						[
							-147.53444,
							59.850058
						],
						[
							-147.874011,
							59.784335
						],
						[
							-147.80281,
							59.937689
						],
						[
							-147.435855,
							60.09652
						],
						[
							-147.205824,
							60.271782
						],
						[
							-147.079854,
							60.200582
						]
					]
				],
				[
					[
						[
							-147.561825,
							60.578491
						],
						[
							-147.616594,
							60.370367
						],
						[
							-147.758995,
							60.156767
						],
						[
							-147.956165,
							60.227967
						],
						[
							-147.791856,
							60.474429
						],
						[
							-147.561825,
							60.578491
						]
					]
				],
				[
					[
						[
							-147.786379,
							70.245291
						],
						[
							-147.682318,
							70.201475
						],
						[
							-147.162008,
							70.15766
						],
						[
							-146.888161,
							70.185044
						],
						[
							-146.510252,
							70.185044
						],
						[
							-146.099482,
							70.146706
						],
						[
							-145.858496,
							70.168614
						],
						[
							-145.622988,
							70.08646
						],
						[
							-145.195787,
							69.993352
						],
						[
							-144.620708,
							69.971444
						],
						[
							-144.461877,
							70.026213
						],
						[
							-144.078491,
							70.059075
						],
						[
							-143.914183,
							70.130275
						],
						[
							-143.497935,
							70.141229
						],
						[
							-143.503412,
							70.091936
						],
						[
							-143.25695,
							70.119321
						],
						[
							-142.747594,
							70.042644
						],
						[
							-142.402547,
							69.916674
						],
						[
							-142.079408,
							69.856428
						],
						[
							-142.008207,
							69.801659
						],
						[
							-141.712453,
							69.790705
						],
						[
							-141.433129,
							69.697597
						],
						[
							-141.378359,
							69.63735
						],
						[
							-141.208574,
							69.686643
						],
						[
							-141.00045,
							69.648304
						],
						[
							-141.00045,
							60.304644
						],
						[
							-140.53491,
							60.22249
						],
						[
							-140.474664,
							60.310121
						],
						[
							-139.987216,
							60.184151
						],
						[
							-139.696939,
							60.342983
						],
						[
							-139.088998,
							60.359413
						],
						[
							-139.198537,
							60.091043
						],
						[
							-139.045183,
							59.997935
						],
						[
							-138.700135,
							59.910304
						],
						[
							-138.623458,
							59.767904
						],
						[
							-137.604747,
							59.242118
						],
						[
							-137.445916,
							58.908024
						],
						[
							-137.265177,
							59.001132
						],
						[
							-136.827022,
							59.159963
						],
						[
							-136.580559,
							59.16544
						],
						[
							-136.465544,
							59.285933
						],
						[
							-136.476498,
							59.466672
						],
						[
							-136.301236,
							59.466672
						],
						[
							-136.25742,
							59.625503
						],
						[
							-135.945234,
							59.663842
						],
						[
							-135.479694,
							59.800766
						],
						[
							-135.025108,
							59.565257
						],
						[
							-135.068924,
							59.422857
						],
						[
							-134.959385,
							59.280456
						],
						[
							-134.701969,
							59.247595
						],
						[
							-134.378829,
							59.033994
						],
						[
							-134.400737,
							58.973748
						],
						[
							-134.25286,
							58.858732
						],
						[
							-133.842089,
							58.727285
						],
						[
							-133.173903,
							58.152206
						],
						[
							-133.075318,
							57.998852
						],
						[
							-132.867194,
							57.845498
						],
						[
							-132.560485,
							57.505928
						],
						[
							-132.253777,
							57.21565
						],
						[
							-132.368792,
							57.095157
						],
						[
							-132.05113,
							57.051341
						],
						[
							-132.127807,
							56.876079
						],
						[
							-131.870391,
							56.804879
						],
						[
							-131.837529,
							56.602232
						],
						[
							-131.580113,
							56.613186
						],
						[
							-131.087188,
							56.405062
						],
						[
							-130.78048,
							56.366724
						],
						[
							-130.621648,
							56.268139
						],
						[
							-130.468294,
							56.240754
						],
						[
							-130.424478,
							56.142169
						],
						[
							-130.101339,
							56.114785
						],
						[
							-130.002754,
							55.994292
						],
						[
							-130.150631,
							55.769737
						],
						[
							-130.128724,
							55.583521
						],
						[
							-129.986323,
							55.276813
						],
						[
							-130.095862,
							55.200136
						],
						[
							-130.336847,
							54.920812
						],
						[
							-130.687372,
							54.718165
						],
						[
							-130.785957,
							54.822227
						],
						[
							-130.917403,
							54.789365
						],
						[
							-131.010511,
							54.997489
						],
						[
							-130.983126,
							55.08512
						],
						[
							-131.092665,
							55.189182
						],
						[
							-130.862634,
							55.298721
						],
						[
							-130.928357,
							55.337059
						],
						[
							-131.158389,
							55.200136
						],
						[
							-131.284358,
							55.287767
						],
						[
							-131.426759,
							55.238474
						],
						[
							-131.843006,
							55.457552
						],
						[
							-131.700606,
							55.698537
						],
						[
							-131.963499,
							55.616383
						],
						[
							-131.974453,
							55.49589
						],
						[
							-132.182576,
							55.588998
						],
						[
							-132.226392,
							55.704014
						],
						[
							-132.083991,
							55.829984
						],
						[
							-132.127807,
							55.955953
						],
						[
							-132.324977,
							55.851892
						],
						[
							-132.522147,
							56.076446
						],
						[
							-132.642639,
							56.032631
						],
						[
							-132.719317,
							56.218847
						],
						[
							-132.527624,
							56.339339
						],
						[
							-132.341408,
							56.339339
						],
						[
							-132.396177,
							56.487217
						],
						[
							-132.297592,
							56.67891
						],
						[
							-132.450946,
							56.673433
						],
						[
							-132.768609,
							56.837741
						],
						[
							-132.993164,
							57.034911
						],
						[
							-133.51895,
							57.177311
						],
						[
							-133.507996,
							57.577128
						],
						[
							-133.677781,
							57.62642
						],
						[
							-133.639442,
							57.790728
						],
						[
							-133.814705,
							57.834544
						],
						[
							-134.072121,
							58.053622
						],
						[
							-134.143321,
							58.168637
						],
						[
							-134.586953,
							58.206976
						],
						[
							-135.074401,
							58.502731
						],
						[
							-135.282525,
							59.192825
						],
						[
							-135.38111,
							59.033994
						],
						[
							-135.337294,
							58.891593
						],
						[
							-135.140124,
							58.617746
						],
						[
							-135.189417,
							58.573931
						],
						[
							-135.05797,
							58.349376
						],
						[
							-135.085355,
							58.201499
						],
						[
							-135.277048,
							58.234361
						],
						[
							-135.430402,
							58.398669
						],
						[
							-135.633049,
							58.426053
						],
						[
							-135.91785,
							58.382238
						],
						[
							-135.912373,
							58.617746
						],
						[
							-136.087635,
							58.814916
						],
						[
							-136.246466,
							58.75467
						],
						[
							-136.876314,
							58.962794
						],
						[
							-136.931084,
							58.902547
						],
						[
							-136.586036,
							58.836824
						],
						[
							-136.317666,
							58.672516
						],
						[
							-136.213604,
							58.667039
						],
						[
							-136.180743,
							58.535592
						],
						[
							-136.043819,
							58.382238
						],
						[
							-136.388867,
							58.294607
						],
						[
							-136.591513,
							58.349376
						],
						[
							-136.59699,
							58.212453
						],
						[
							-136.859883,
							58.316515
						],
						[
							-136.947514,
							58.393192
						],
						[
							-137.111823,
							58.393192
						],
						[
							-137.566409,
							58.590362
						],
						[
							-137.900502,
							58.765624
						],
						[
							-137.933364,
							58.869686
						],
						[
							-138.11958,
							59.02304
						],
						[
							-138.634412,
							59.132579
						],
						[
							-138.919213,
							59.247595
						],
						[
							-139.417615,
							59.379041
						],
						[
							-139.746231,
							59.505011
						],
						[
							-139.718846,
							59.641934
						],
						[
							-139.625738,
							59.598119
						],
						[
							-139.5162,
							59.68575
						],
						[
							-139.625738,
							59.88292
						],
						[
							-139.488815,
							59.992458
						],
						[
							-139.554538,
							60.041751
						],
						[
							-139.801,
							59.833627
						],
						[
							-140.315833,
							59.696704
						],
						[
							-140.92925,
							59.745996
						],
						[
							-141.444083,
							59.871966
						],
						[
							-141.46599,
							59.970551
						],
						[
							-141.706976,
							59.948643
						],
						[
							-141.964392,
							60.019843
						],
						[
							-142.539471,
							60.085566
						],
						[
							-142.873564,
							60.091043
						],
						[
							-143.623905,
							60.036274
						],
						[
							-143.892275,
							59.997935
						],
						[
							-144.231845,
							60.140336
						],
						[
							-144.65357,
							60.206059
						],
						[
							-144.785016,
							60.29369
						],
						[
							-144.834309,
							60.441568
						],
						[
							-145.124586,
							60.430614
						],
						[
							-145.223171,
							60.299167
						],
						[
							-145.738004,
							60.474429
						],
						[
							-145.820158,
							60.551106
						],
						[
							-146.351421,
							60.408706
						],
						[
							-146.608837,
							60.238921
						],
						[
							-146.718376,
							60.397752
						],
						[
							-146.608837,
							60.485383
						],
						[
							-146.455483,
							60.463475
						],
						[
							-145.951604,
							60.578491
						],
						[
							-146.017328,
							60.666122
						],
						[
							-146.252836,
							60.622307
						],
						[
							-146.345944,
							60.737322
						],
						[
							-146.565022,
							60.753753
						],
						[
							-146.784099,
							61.044031
						],
						[
							-146.866253,
							60.972831
						],
						[
							-147.172962,
							60.934492
						],
						[
							-147.271547,
							60.972831
						],
						[
							-147.375609,
							60.879723
						],
						[
							-147.758995,
							60.912584
						],
						[
							-147.775426,
							60.808523
						],
						[
							-148.032842,
							60.781138
						],
						[
							-148.153334,
							60.819476
						],
						[
							-148.065703,
							61.005692
						],
						[
							-148.175242,
							61.000215
						],
						[
							-148.350504,
							60.803046
						],
						[
							-148.109519,
							60.737322
						],
						[
							-148.087611,
							60.594922
						],
						[
							-147.939734,
							60.441568
						],
						[
							-148.027365,
							60.277259
						],
						[
							-148.219058,
							60.332029
						],
						[
							-148.273827,
							60.249875
						],
						[
							-148.087611,
							60.217013
						],
						[
							-147.983549,
							59.997935
						],
						[
							-148.251919,
							59.95412
						],
						[
							-148.399797,
							59.997935
						],
						[
							-148.635305,
							59.937689
						],
						[
							-148.755798,
							59.986981
						],
						[
							-149.067984,
							59.981505
						],
						[
							-149.05703,
							60.063659
						],
						[
							-149.204907,
							60.008889
						],
						[
							-149.287061,
							59.904827
						],
						[
							-149.418508,
							59.997935
						],
						[
							-149.582816,
							59.866489
						],
						[
							-149.511616,
							59.806242
						],
						[
							-149.741647,
							59.729565
						],
						[
							-149.949771,
							59.718611
						],
						[
							-150.031925,
							59.61455
						],
						[
							-150.25648,
							59.521442
						],
						[
							-150.409834,
							59.554303
						],
						[
							-150.579619,
							59.444764
						],
						[
							-150.716543,
							59.450241
						],
						[
							-151.001343,
							59.225687
						],
						[
							-151.308052,
							59.209256
						],
						[
							-151.406637,
							59.280456
						],
						[
							-151.592853,
							59.159963
						],
						[
							-151.976239,
							59.253071
						],
						[
							-151.888608,
							59.422857
						],
						[
							-151.636669,
							59.483103
						],
						[
							-151.47236,
							59.472149
						],
						[
							-151.423068,
							59.537872
						],
						[
							-151.127313,
							59.669319
						],
						[
							-151.116359,
							59.778858
						],
						[
							-151.505222,
							59.63098
						],
						[
							-151.828361,
							59.718611
						],
						[
							-151.8667,
							59.778858
						],
						[
							-151.702392,
							60.030797
						],
						[
							-151.423068,
							60.211536
						],
						[
							-151.379252,
							60.359413
						],
						[
							-151.297098,
							60.386798
						],
						[
							-151.264237,
							60.545629
						],
						[
							-151.406637,
							60.720892
						],
						[
							-151.06159,
							60.786615
						],
						[
							-150.404357,
							61.038554
						],
						[
							-150.245526,
							60.939969
						],
						[
							-150.042879,
							60.912584
						],
						[
							-149.741647,
							61.016646
						],
						[
							-150.075741,
							61.15357
						],
						[
							-150.207187,
							61.257632
						],
						[
							-150.47008,
							61.246678
						],
						[
							-150.656296,
							61.29597
						],
						[
							-150.711066,
							61.252155
						],
						[
							-151.023251,
							61.180954
						],
						[
							-151.165652,
							61.044031
						],
						[
							-151.477837,
							61.011169
						],
						[
							-151.800977,
							60.852338
						],
						[
							-151.833838,
							60.748276
						],
						[
							-152.080301,
							60.693507
						],
						[
							-152.13507,
							60.578491
						],
						[
							-152.310332,
							60.507291
						],
						[
							-152.392486,
							60.304644
						],
						[
							-152.732057,
							60.173197
						],
						[
							-152.567748,
							60.069136
						],
						[
							-152.704672,
							59.915781
						],
						[
							-153.022334,
							59.888397
						],
						[
							-153.049719,
							59.691227
						],
						[
							-153.345474,
							59.620026
						],
						[
							-153.438582,
							59.702181
						],
						[
							-153.586459,
							59.548826
						],
						[
							-153.761721,
							59.543349
						],
						[
							-153.72886,
							59.433811
						],
						[
							-154.117723,
							59.368087
						],
						[
							-154.1944,
							59.066856
						],
						[
							-153.750768,
							59.050425
						],
						[
							-153.400243,
							58.968271
						],
						[
							-153.301658,
							58.869686
						],
						[
							-153.444059,
							58.710854
						],
						[
							-153.679567,
							58.612269
						],
						[
							-153.898645,
							58.606793
						],
						[
							-153.920553,
							58.519161
						],
						[
							-154.062953,
							58.4863
						],
						[
							-153.99723,
							58.376761
						],
						[
							-154.145107,
							58.212453
						],
						[
							-154.46277,
							58.059098
						],
						[
							-154.643509,
							58.059098
						],
						[
							-154.818771,
							58.004329
						],
						[
							-154.988556,
							58.015283
						],
						[
							-155.120003,
							57.955037
						],
						[
							-155.081664,
							57.872883
						],
						[
							-155.328126,
							57.829067
						],
						[
							-155.377419,
							57.708574
						],
						[
							-155.547204,
							57.785251
						],
						[
							-155.73342,
							57.549743
						],
						[
							-156.045606,
							57.566174
						],
						[
							-156.023698,
							57.440204
						],
						[
							-156.209914,
							57.473066
						],
						[
							-156.34136,
							57.418296
						],
						[
							-156.34136,
							57.248511
						],
						[
							-156.549484,
							56.985618
						],
						[
							-156.883577,
							56.952757
						],
						[
							-157.157424,
							56.832264
						],
						[
							-157.20124,
							56.766541
						],
						[
							-157.376502,
							56.859649
						],
						[
							-157.672257,
							56.607709
						],
						[
							-157.754411,
							56.67891
						],
						[
							-157.918719,
							56.657002
						],
						[
							-157.957058,
							56.514601
						],
						[
							-158.126843,
							56.459832
						],
						[
							-158.32949,
							56.48174
						],
						[
							-158.488321,
							56.339339
						],
						[
							-158.208997,
							56.295524
						],
						[
							-158.510229,
							55.977861
						],
						[
							-159.375585,
							55.873799
						],
						[
							-159.616571,
							55.594475
						],
						[
							-159.676817,
							55.654722
						],
						[
							-159.643955,
							55.829984
						],
						[
							-159.813741,
							55.857368
						],
						[
							-160.027341,
							55.791645
						],
						[
							-160.060203,
							55.720445
						],
						[
							-160.394296,
							55.605429
						],
						[
							-160.536697,
							55.473983
						],
						[
							-160.580512,
							55.567091
						],
						[
							-160.668143,
							55.457552
						],
						[
							-160.865313,
							55.528752
						],
						[
							-161.232268,
							55.358967
						],
						[
							-161.506115,
							55.364444
						],
						[
							-161.467776,
							55.49589
						],
						[
							-161.588269,
							55.62186
						],
						[
							-161.697808,
							55.517798
						],
						[
							-161.686854,
							55.408259
						],
						[
							-162.053809,
							55.074166
						],
						[
							-162.179779,
							55.15632
						],
						[
							-162.218117,
							55.03035
						],
						[
							-162.470057,
							55.052258
						],
						[
							-162.508395,
							55.249428
						],
						[
							-162.661749,
							55.293244
						],
						[
							-162.716519,
							55.222043
						],
						[
							-162.579595,
							55.134412
						],
						[
							-162.645319,
							54.997489
						],
						[
							-162.847965,
							54.926289
						],
						[
							-163.00132,
							55.079643
						],
						[
							-163.187536,
							55.090597
						],
						[
							-163.220397,
							55.03035
						],
						[
							-163.034181,
							54.942719
						],
						[
							-163.373752,
							54.800319
						],
						[
							-163.14372,
							54.76198
						],
						[
							-163.138243,
							54.696257
						],
						[
							-163.329936,
							54.74555
						],
						[
							-163.587352,
							54.614103
						],
						[
							-164.085754,
							54.61958
						],
						[
							-164.332216,
							54.531949
						],
						[
							-164.354124,
							54.466226
						],
						[
							-164.638925,
							54.389548
						],
						[
							-164.847049,
							54.416933
						],
						[
							-164.918249,
							54.603149
						],
						[
							-164.710125,
							54.663395
						],
						[
							-164.551294,
							54.88795
						],
						[
							-164.34317,
							54.893427
						],
						[
							-163.894061,
							55.041304
						],
						[
							-163.532583,
							55.046781
						],
						[
							-163.39566,
							54.904381
						],
						[
							-163.291598,
							55.008443
						],
						[
							-163.313505,
							55.128935
						],
						[
							-163.105382,
							55.183705
						],
						[
							-162.880827,
							55.183705
						],
						[
							-162.579595,
							55.446598
						],
						[
							-162.245502,
							55.682106
						],
						[
							-161.807347,
							55.89023
						],
						[
							-161.292514,
							55.983338
						],
						[
							-161.078914,
							55.939523
						],
						[
							-160.87079,
							55.999769
						],
						[
							-160.816021,
							55.912138
						],
						[
							-160.931036,
							55.813553
						],
						[
							-160.805067,
							55.736876
						],
						[
							-160.766728,
							55.857368
						],
						[
							-160.509312,
							55.868322
						],
						[
							-160.438112,
							55.791645
						],
						[
							-160.27928,
							55.76426
						],
						[
							-160.273803,
							55.857368
						],
						[
							-160.536697,
							55.939523
						],
						[
							-160.558604,
							55.994292
						],
						[
							-160.383342,
							56.251708
						],
						[
							-160.147834,
							56.399586
						],
						[
							-159.830171,
							56.541986
						],
						[
							-159.326293,
							56.667956
						],
						[
							-158.959338,
							56.848695
						],
						[
							-158.784076,
							56.782971
						],
						[
							-158.641675,
							56.810356
						],
						[
							-158.701922,
							56.925372
						],
						[
							-158.658106,
							57.034911
						],
						[
							-158.378782,
							57.264942
						],
						[
							-157.995396,
							57.41282
						],
						[
							-157.688688,
							57.609989
						],
						[
							-157.705118,
							57.719528
						],
						[
							-157.458656,
							58.497254
						],
						[
							-157.07527,
							58.705377
						],
						[
							-157.119086,
							58.869686
						],
						[
							-158.039212,
							58.634177
						],
						[
							-158.32949,
							58.661562
						],
						[
							-158.40069,
							58.760147
						],
						[
							-158.564998,
							58.803962
						],
						[
							-158.619768,
							58.913501
						],
						[
							-158.767645,
							58.864209
						],
						[
							-158.860753,
							58.694424
						],
						[
							-158.701922,
							58.480823
						],
						[
							-158.893615,
							58.387715
						],
						[
							-159.0634,
							58.420577
						],
						[
							-159.392016,
							58.760147
						],
						[
							-159.616571,
							58.929932
						],
						[
							-159.731586,
							58.929932
						],
						[
							-159.808264,
							58.803962
						],
						[
							-159.906848,
							58.782055
						],
						[
							-160.054726,
							58.886116
						],
						[
							-160.235465,
							58.902547
						],
						[
							-160.317619,
							59.072332
						],
						[
							-160.854359,
							58.88064
						],
						[
							-161.33633,
							58.743716
						],
						[
							-161.374669,
							58.667039
						],
						[
							-161.752577,
							58.552023
						],
						[
							-161.938793,
							58.656085
						],
						[
							-161.769008,
							58.776578
						],
						[
							-161.829255,
							59.061379
						],
						[
							-161.955224,
							59.36261
						],
						[
							-161.703285,
							59.48858
						],
						[
							-161.911409,
							59.740519
						],
						[
							-162.092148,
							59.88292
						],
						[
							-162.234548,
							60.091043
						],
						[
							-162.448149,
							60.178674
						],
						[
							-162.502918,
							59.997935
						],
						[
							-162.760334,
							59.959597
						],
						[
							-163.171105,
							59.844581
						],
						[
							-163.66403,
							59.795289
						],
						[
							-163.9324,
							59.806242
						],
						[
							-164.162431,
							59.866489
						],
						[
							-164.189816,
							60.02532
						],
						[
							-164.386986,
							60.074613
						],
						[
							-164.699171,
							60.29369
						],
						[
							-164.962064,
							60.337506
						],
						[
							-165.268773,
							60.578491
						],
						[
							-165.060649,
							60.68803
						],
						[
							-165.016834,
							60.890677
						],
						[
							-165.175665,
							60.846861
						],
						[
							-165.197573,
							60.972831
						],
						[
							-165.120896,
							61.076893
						],
						[
							-165.323543,
							61.170001
						],
						[
							-165.34545,
							61.071416
						],
						[
							-165.591913,
							61.109754
						],
						[
							-165.624774,
							61.279539
						],
						[
							-165.816467,
							61.301447
						],
						[
							-165.920529,
							61.416463
						],
						[
							-165.915052,
							61.558863
						],
						[
							-166.106745,
							61.49314
						],
						[
							-166.139607,
							61.630064
						],
						[
							-165.904098,
							61.662925
						],
						[
							-166.095791,
							61.81628
						],
						[
							-165.756221,
							61.827233
						],
						[
							-165.756221,
							62.013449
						],
						[
							-165.674067,
							62.139419
						],
						[
							-165.044219,
							62.539236
						],
						[
							-164.912772,
							62.659728
						],
						[
							-164.819664,
							62.637821
						],
						[
							-164.874433,
							62.807606
						],
						[
							-164.633448,
							63.097884
						],
						[
							-164.425324,
							63.212899
						],
						[
							-164.036462,
							63.262192
						],
						[
							-163.73523,
							63.212899
						],
						[
							-163.313505,
							63.037637
						],
						[
							-163.039658,
							63.059545
						],
						[
							-162.661749,
							63.22933
						],
						[
							-162.272887,
							63.486746
						],
						[
							-162.075717,
							63.514131
						],
						[
							-162.026424,
							63.448408
						],
						[
							-161.555408,
							63.448408
						],
						[
							-161.13916,
							63.503177
						],
						[
							-160.766728,
							63.771547
						],
						[
							-160.766728,
							63.837271
						],
						[
							-160.952944,
							64.08921
						],
						[
							-160.974852,
							64.237087
						],
						[
							-161.26513,
							64.395918
						],
						[
							-161.374669,
							64.532842
						],
						[
							-161.078914,
							64.494503
						],
						[
							-160.79959,
							64.609519
						],
						[
							-160.783159,
							64.719058
						],
						[
							-161.144637,
							64.921705
						],
						[
							-161.413007,
							64.762873
						],
						[
							-161.664946,
							64.790258
						],
						[
							-161.900455,
							64.702627
						],
						[
							-162.168825,
							64.680719
						],
						[
							-162.234548,
							64.620473
						],
						[
							-162.541257,
							64.532842
						],
						[
							-162.634365,
							64.384965
						],
						[
							-162.787719,
							64.324718
						],
						[
							-162.858919,
							64.49998
						],
						[
							-163.045135,
							64.538319
						],
						[
							-163.176582,
							64.401395
						],
						[
							-163.253259,
							64.467119
						],
						[
							-163.598306,
							64.565704
						],
						[
							-164.304832,
							64.560227
						],
						[
							-164.80871,
							64.450688
						],
						[
							-165.000403,
							64.434257
						],
						[
							-165.411174,
							64.49998
						],
						[
							-166.188899,
							64.576658
						],
						[
							-166.391546,
							64.636904
						],
						[
							-166.484654,
							64.735489
						],
						[
							-166.413454,
							64.872412
						],
						[
							-166.692778,
							64.987428
						],
						[
							-166.638008,
							65.113398
						],
						[
							-166.462746,
							65.179121
						],
						[
							-166.517516,
							65.337952
						],
						[
							-166.796839,
							65.337952
						],
						[
							-167.026871,
							65.381768
						],
						[
							-167.47598,
							65.414629
						],
						[
							-167.711489,
							65.496784
						],
						[
							-168.072967,
							65.578938
						],
						[
							-168.105828,
							65.682999
						],
						[
							-167.541703,
							65.819923
						],
						[
							-166.829701,
							66.049954
						],
						[
							-166.3313,
							66.186878
						],
						[
							-166.046499,
							66.110201
						],
						[
							-165.756221,
							66.09377
						],
						[
							-165.690498,
							66.203309
						],
						[
							-165.86576,
							66.21974
						],
						[
							-165.88219,
							66.312848
						],
						[
							-165.186619,
							66.466202
						],
						[
							-164.403417,
							66.581218
						],
						[
							-163.981692,
							66.592172
						],
						[
							-163.751661,
							66.553833
						],
						[
							-163.872153,
							66.389525
						],
						[
							-163.828338,
							66.274509
						],
						[
							-163.915969,
							66.192355
						],
						[
							-163.768091,
							66.060908
						],
						[
							-163.494244,
							66.082816
						],
						[
							-163.149197,
							66.060908
						],
						[
							-162.749381,
							66.088293
						],
						[
							-162.634365,
							66.039001
						],
						[
							-162.371472,
							66.028047
						],
						[
							-162.14144,
							66.077339
						],
						[
							-161.840208,
							66.02257
						],
						[
							-161.549931,
							66.241647
						],
						[
							-161.341807,
							66.252601
						],
						[
							-161.199406,
							66.208786
						],
						[
							-161.128206,
							66.334755
						],
						[
							-161.528023,
							66.395002
						],
						[
							-161.911409,
							66.345709
						],
						[
							-161.87307,
							66.510017
						],
						[
							-162.174302,
							66.68528
						],
						[
							-162.502918,
							66.740049
						],
						[
							-162.601503,
							66.89888
						],
						[
							-162.344087,
							66.937219
						],
						[
							-162.015471,
							66.778388
						],
						[
							-162.075717,
							66.652418
						],
						[
							-161.916886,
							66.553833
						],
						[
							-161.571838,
							66.438817
						],
						[
							-161.489684,
							66.55931
						],
						[
							-161.884024,
							66.718141
						],
						[
							-161.714239,
							67.002942
						],
						[
							-161.851162,
							67.052235
						],
						[
							-162.240025,
							66.991988
						],
						[
							-162.639842,
							67.008419
						],
						[
							-162.700088,
							67.057712
						],
						[
							-162.902735,
							67.008419
						],
						[
							-163.740707,
							67.128912
						],
						[
							-163.757138,
							67.254881
						],
						[
							-164.009077,
							67.534205
						],
						[
							-164.211724,
							67.638267
						],
						[
							-164.534863,
							67.725898
						],
						[
							-165.192096,
							67.966884
						],
						[
							-165.493328,
							68.059992
						],
						[
							-165.794559,
							68.081899
						],
						[
							-166.243668,
							68.246208
						],
						[
							-166.681824,
							68.339316
						],
						[
							-166.703731,
							68.372177
						],
						[
							-166.375115,
							68.42147
						],
						[
							-166.227238,
							68.574824
						],
						[
							-166.216284,
							68.881533
						],
						[
							-165.329019,
							68.859625
						],
						[
							-164.255539,
							68.930825
						],
						[
							-163.976215,
							68.985595
						],
						[
							-163.532583,
							69.138949
						],
						[
							-163.110859,
							69.374457
						],
						[
							-163.023228,
							69.609966
						],
						[
							-162.842489,
							69.812613
						],
						[
							-162.470057,
							69.982398
						],
						[
							-162.311225,
							70.108367
						],
						[
							-161.851162,
							70.311014
						],
						[
							-161.779962,
							70.256245
						],
						[
							-161.396576,
							70.239814
						],
						[
							-160.837928,
							70.343876
						],
						[
							-160.487404,
							70.453415
						],
						[
							-159.649432,
							70.792985
						],
						[
							-159.33177,
							70.809416
						],
						[
							-159.298908,
							70.760123
						],
						[
							-158.975769,
							70.798462
						],
						[
							-158.658106,
							70.787508
						],
						[
							-158.033735,
							70.831323
						],
						[
							-157.420318,
							70.979201
						],
						[
							-156.812377,
							71.285909
						],
						[
							-156.565915,
							71.351633
						],
						[
							-156.522099,
							71.296863
						],
						[
							-155.585543,
							71.170894
						],
						[
							-155.508865,
							71.083263
						],
						[
							-155.832005,
							70.968247
						],
						[
							-155.979882,
							70.96277
						],
						[
							-155.974405,
							70.809416
						],
						[
							-155.503388,
							70.858708
						],
						[
							-155.476004,
							70.940862
						],
						[
							-155.262403,
							71.017539
						],
						[
							-155.191203,
							70.973724
						],
						[
							-155.032372,
							71.148986
						],
						[
							-154.566832,
							70.990155
						],
						[
							-154.643509,
							70.869662
						],
						[
							-154.353231,
							70.8368
						],
						[
							-154.183446,
							70.7656
						],
						[
							-153.931507,
							70.880616
						],
						[
							-153.487874,
							70.886093
						],
						[
							-153.235935,
							70.924431
						],
						[
							-152.589656,
							70.886093
						],
						[
							-152.26104,
							70.842277
						],
						[
							-152.419871,
							70.606769
						],
						[
							-151.817408,
							70.546523
						],
						[
							-151.773592,
							70.486276
						],
						[
							-151.187559,
							70.382214
						],
						[
							-151.182082,
							70.431507
						],
						[
							-150.760358,
							70.49723
						],
						[
							-150.355064,
							70.491753
						],
						[
							-150.349588,
							70.436984
						],
						[
							-150.114079,
							70.431507
						],
						[
							-149.867617,
							70.508184
						],
						[
							-149.462323,
							70.519138
						],
						[
							-149.177522,
							70.486276
						],
						[
							-148.78866,
							70.404122
						],
						[
							-148.607921,
							70.420553
						],
						[
							-148.350504,
							70.305537
						],
						[
							-148.202627,
							70.349353
						],
						[
							-147.961642,
							70.316491
						],
						[
							-147.786379,
							70.245291
						]
					]
				],
				[
					[
						[
							-152.94018,
							58.026237
						],
						[
							-152.945657,
							57.982421
						],
						[
							-153.290705,
							58.048145
						],
						[
							-153.044242,
							58.305561
						],
						[
							-152.819688,
							58.327469
						],
						[
							-152.666333,
							58.562977
						],
						[
							-152.496548,
							58.354853
						],
						[
							-152.354148,
							58.426053
						],
						[
							-152.080301,
							58.311038
						],
						[
							-152.080301,
							58.152206
						],
						[
							-152.480117,
							58.130299
						],
						[
							-152.655379,
							58.059098
						],
						[
							-152.94018,
							58.026237
						]
					]
				],
				[
					[
						[
							-153.958891,
							57.538789
						],
						[
							-153.67409,
							57.670236
						],
						[
							-153.931507,
							57.69762
						],
						[
							-153.936983,
							57.812636
						],
						[
							-153.723383,
							57.889313
						],
						[
							-153.570028,
							57.834544
						],
						[
							-153.548121,
							57.719528
						],
						[
							-153.46049,
							57.796205
						],
						[
							-153.455013,
							57.96599
						],
						[
							-153.268797,
							57.889313
						],
						[
							-153.235935,
							57.998852
						],
						[
							-153.071627,
							57.933129
						],
						[
							-152.874457,
							57.933129
						],
						[
							-152.721103,
							57.993375
						],
						[
							-152.469163,
							57.889313
						],
						[
							-152.469163,
							57.599035
						],
						[
							-152.151501,
							57.620943
						],
						[
							-152.359625,
							57.42925
						],
						[
							-152.74301,
							57.505928
						],
						[
							-152.60061,
							57.379958
						],
						[
							-152.710149,
							57.275896
						],
						[
							-152.907319,
							57.325188
						],
						[
							-152.912796,
							57.128019
						],
						[
							-153.214027,
							57.073249
						],
						[
							-153.312612,
							56.991095
						],
						[
							-153.498828,
							57.067772
						],
						[
							-153.695998,
							56.859649
						],
						[
							-153.849352,
							56.837741
						],
						[
							-154.013661,
							56.744633
						],
						[
							-154.073907,
							56.969187
						],
						[
							-154.303938,
							56.848695
						],
						[
							-154.314892,
							56.919895
						],
						[
							-154.523016,
							56.991095
						],
						[
							-154.539447,
							57.193742
						],
						[
							-154.742094,
							57.275896
						],
						[
							-154.627078,
							57.511404
						],
						[
							-154.227261,
							57.659282
						],
						[
							-153.980799,
							57.648328
						],
						[
							-153.958891,
							57.538789
						]
					]
				],
				[
					[
						[
							-154.53397,
							56.602232
						],
						[
							-154.742094,
							56.399586
						],
						[
							-154.807817,
							56.432447
						],
						[
							-154.53397,
							56.602232
						]
					]
				],
				[
					[
						[
							-155.634835,
							55.923092
						],
						[
							-155.476004,
							55.912138
						],
						[
							-155.530773,
							55.704014
						],
						[
							-155.793666,
							55.731399
						],
						[
							-155.837482,
							55.802599
						],
						[
							-155.634835,
							55.923092
						]
					]
				],
				[
					[
						[
							-159.890418,
							55.28229
						],
						[
							-159.950664,
							55.068689
						],
						[
							-160.257373,
							54.893427
						],
						[
							-160.109495,
							55.161797
						],
						[
							-160.005433,
							55.134412
						],
						[
							-159.890418,
							55.28229
						]
					]
				],
				[
					[
						[
							-160.520266,
							55.358967
						],
						[
							-160.33405,
							55.358967
						],
						[
							-160.339527,
							55.249428
						],
						[
							-160.525743,
							55.128935
						],
						[
							-160.690051,
							55.211089
						],
						[
							-160.794113,
							55.134412
						],
						[
							-160.854359,
							55.320628
						],
						[
							-160.79959,
							55.380875
						],
						[
							-160.520266,
							55.358967
						]
					]
				],
				[
					[
						[
							-162.256456,
							54.981058
						],
						[
							-162.234548,
							54.893427
						],
						[
							-162.349564,
							54.838658
						],
						[
							-162.437195,
							54.931766
						],
						[
							-162.256456,
							54.981058
						]
					]
				],
				[
					[
						[
							-162.415287,
							63.634624
						],
						[
							-162.563165,
							63.536039
						],
						[
							-162.612457,
							63.62367
						],
						[
							-162.415287,
							63.634624
						]
					]
				],
				[
					[
						[
							-162.80415,
							54.488133
						],
						[
							-162.590549,
							54.449795
						],
						[
							-162.612457,
							54.367641
						],
						[
							-162.782242,
							54.373118
						],
						[
							-162.80415,
							54.488133
						]
					]
				],
				[
					[
						[
							-165.548097,
							54.29644
						],
						[
							-165.476897,
							54.181425
						],
						[
							-165.630251,
							54.132132
						],
						[
							-165.685021,
							54.252625
						],
						[
							-165.548097,
							54.29644
						]
					]
				],
				[
					[
						[
							-165.73979,
							54.15404
						],
						[
							-166.046499,
							54.044501
						],
						[
							-166.112222,
							54.121178
						],
						[
							-165.980775,
							54.219763
						],
						[
							-165.73979,
							54.15404
						]
					]
				],
				[
					[
						[
							-166.364161,
							60.359413
						],
						[
							-166.13413,
							60.397752
						],
						[
							-166.084837,
							60.326552
						],
						[
							-165.88219,
							60.342983
						],
						[
							-165.685021,
							60.277259
						],
						[
							-165.646682,
							59.992458
						],
						[
							-165.750744,
							59.89935
						],
						[
							-166.00816,
							59.844581
						],
						[
							-166.062929,
							59.745996
						],
						[
							-166.440838,
							59.855535
						],
						[
							-166.6161,
							59.850058
						],
						[
							-166.994009,
							59.992458
						],
						[
							-167.125456,
							59.992458
						],
						[
							-167.344534,
							60.074613
						],
						[
							-167.421211,
							60.206059
						],
						[
							-167.311672,
							60.238921
						],
						[
							-166.93924,
							60.206059
						],
						[
							-166.763978,
							60.310121
						],
						[
							-166.577762,
							60.321075
						],
						[
							-166.495608,
							60.392275
						],
						[
							-166.364161,
							60.359413
						]
					]
				],
				[
					[
						[
							-166.375115,
							54.01164
						],
						[
							-166.210807,
							53.934962
						],
						[
							-166.5449,
							53.748746
						],
						[
							-166.539423,
							53.715885
						],
						[
							-166.117699,
							53.852808
						],
						[
							-166.112222,
							53.776131
						],
						[
							-166.282007,
							53.683023
						],
						[
							-166.555854,
							53.622777
						],
						[
							-166.583239,
							53.529669
						],
						[
							-166.878994,
							53.431084
						],
						[
							-167.13641,
							53.425607
						],
						[
							-167.306195,
							53.332499
						],
						[
							-167.623857,
							53.250345
						],
						[
							-167.793643,
							53.337976
						],
						[
							-167.459549,
							53.442038
						],
						[
							-167.355487,
							53.425607
						],
						[
							-167.103548,
							53.513238
						],
						[
							-167.163794,
							53.611823
						],
						[
							-167.021394,
							53.715885
						],
						[
							-166.807793,
							53.666592
						],
						[
							-166.785886,
							53.732316
						],
						[
							-167.015917,
							53.754223
						],
						[
							-167.141887,
							53.825424
						],
						[
							-167.032348,
							53.945916
						],
						[
							-166.643485,
							54.017116
						],
						[
							-166.561331,
							53.880193
						],
						[
							-166.375115,
							54.01164
						]
					]
				],
				[
					[
						[
							-168.790446,
							53.157237
						],
						[
							-168.40706,
							53.34893
						],
						[
							-168.385152,
							53.431084
						],
						[
							-168.237275,
							53.524192
						],
						[
							-168.007243,
							53.568007
						],
						[
							-167.886751,
							53.518715
						],
						[
							-167.842935,
							53.387268
						],
						[
							-168.270136,
							53.244868
						],
						[
							-168.500168,
							53.036744
						],
						[
							-168.686384,
							52.965544
						],
						[
							-168.790446,
							53.157237
						]
					]
				],
				[
					[
						[
							-169.74891,
							52.894344
						],
						[
							-169.705095,
							52.795759
						],
						[
							-169.962511,
							52.790282
						],
						[
							-169.989896,
							52.856005
						],
						[
							-169.74891,
							52.894344
						]
					]
				],
				[
					[
						[
							-170.148727,
							57.221127
						],
						[
							-170.28565,
							57.128019
						],
						[
							-170.313035,
							57.221127
						],
						[
							-170.148727,
							57.221127
						]
					]
				],
				[
					[
						[
							-170.669036,
							52.697174
						],
						[
							-170.603313,
							52.604066
						],
						[
							-170.789529,
							52.538343
						],
						[
							-170.816914,
							52.636928
						],
						[
							-170.669036,
							52.697174
						]
					]
				],
				[
					[
						[
							-171.742517,
							63.716778
						],
						[
							-170.94836,
							63.5689
						],
						[
							-170.488297,
							63.69487
						],
						[
							-170.280174,
							63.683916
						],
						[
							-170.093958,
							63.612716
						],
						[
							-170.044665,
							63.492223
						],
						[
							-169.644848,
							63.4265
						],
						[
							-169.518879,
							63.366254
						],
						[
							-168.99857,
							63.338869
						],
						[
							-168.686384,
							63.295053
						],
						[
							-168.856169,
							63.147176
						],
						[
							-169.108108,
							63.180038
						],
						[
							-169.376478,
							63.152653
						],
						[
							-169.513402,
							63.08693
						],
						[
							-169.639372,
							62.939052
						],
						[
							-169.831064,
							63.075976
						],
						[
							-170.055619,
							63.169084
						],
						[
							-170.263743,
							63.180038
						],
						[
							-170.362328,
							63.2841
						],
						[
							-170.866206,
							63.415546
						],
						[
							-171.101715,
							63.421023
						],
						[
							-171.463193,
							63.306007
						],
						[
							-171.73704,
							63.366254
						],
						[
							-171.852055,
							63.486746
						],
						[
							-171.742517,
							63.716778
						]
					]
				],
				[
					[
						[
							-172.432611,
							52.390465
						],
						[
							-172.41618,
							52.275449
						],
						[
							-172.607873,
							52.253542
						],
						[
							-172.569535,
							52.352127
						],
						[
							-172.432611,
							52.390465
						]
					]
				],
				[
					[
						[
							-173.626584,
							52.14948
						],
						[
							-173.495138,
							52.105664
						],
						[
							-173.122706,
							52.111141
						],
						[
							-173.106275,
							52.07828
						],
						[
							-173.549907,
							52.028987
						],
						[
							-173.626584,
							52.14948
						]
					]
				],
				[
					[
						[
							-174.322156,
							52.280926
						],
						[
							-174.327632,
							52.379511
						],
						[
							-174.185232,
							52.41785
						],
						[
							-173.982585,
							52.319265
						],
						[
							-174.059262,
							52.226157
						],
						[
							-174.179755,
							52.231634
						],
						[
							-174.141417,
							52.127572
						],
						[
							-174.333109,
							52.116618
						],
						[
							-174.738403,
							52.007079
						],
						[
							-174.968435,
							52.039941
						],
						[
							-174.902711,
							52.116618
						],
						[
							-174.656249,
							52.105664
						],
						[
							-174.322156,
							52.280926
						]
					]
				],
				[
					[
						[
							-176.469116,
							51.853725
						],
						[
							-176.288377,
							51.870156
						],
						[
							-176.288377,
							51.744186
						],
						[
							-176.518409,
							51.760617
						],
						[
							-176.80321,
							51.61274
						],
						[
							-176.912748,
							51.80991
						],
						[
							-176.792256,
							51.815386
						],
						[
							-176.775825,
							51.963264
						],
						[
							-176.627947,
							51.968741
						],
						[
							-176.627947,
							51.859202
						],
						[
							-176.469116,
							51.853725
						]
					]
				],
				[
					[
						[
							-177.153734,
							51.946833
						],
						[
							-177.044195,
							51.897541
						],
						[
							-177.120872,
							51.727755
						],
						[
							-177.274226,
							51.678463
						],
						[
							-177.279703,
							51.782525
						],
						[
							-177.153734,
							51.946833
						]
					]
				],
				[
					[
						[
							-178.123152,
							51.919448
						],
						[
							-177.953367,
							51.913971
						],
						[
							-177.800013,
							51.793479
						],
						[
							-177.964321,
							51.651078
						],
						[
							-178.123152,
							51.919448
						]
					]
				],
				[
					[
						[
							173.107557,
							52.992929
						],
						[
							173.293773,
							52.927205
						],
						[
							173.304726,
							52.823143
						],
						[
							172.90491,
							52.762897
						],
						[
							172.642017,
							52.927205
						],
						[
							172.642017,
							53.003883
						],
						[
							173.107557,
							52.992929
						]
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "04",
		id2: "AZ",
		properties: {
			name: "Arizona"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-109.042503,
						37.000263
					],
					[
						-109.04798,
						31.331629
					],
					[
						-111.074448,
						31.331629
					],
					[
						-112.246513,
						31.704061
					],
					[
						-114.815198,
						32.492741
					],
					[
						-114.72209,
						32.717295
					],
					[
						-114.524921,
						32.755634
					],
					[
						-114.470151,
						32.843265
					],
					[
						-114.524921,
						33.029481
					],
					[
						-114.661844,
						33.034958
					],
					[
						-114.727567,
						33.40739
					],
					[
						-114.524921,
						33.54979
					],
					[
						-114.497536,
						33.697668
					],
					[
						-114.535874,
						33.933176
					],
					[
						-114.415382,
						34.108438
					],
					[
						-114.256551,
						34.174162
					],
					[
						-114.136058,
						34.305608
					],
					[
						-114.333228,
						34.448009
					],
					[
						-114.470151,
						34.710902
					],
					[
						-114.634459,
						34.87521
					],
					[
						-114.634459,
						35.00118
					],
					[
						-114.574213,
						35.138103
					],
					[
						-114.596121,
						35.324319
					],
					[
						-114.678275,
						35.516012
					],
					[
						-114.738521,
						36.102045
					],
					[
						-114.371566,
						36.140383
					],
					[
						-114.251074,
						36.01989
					],
					[
						-114.152489,
						36.025367
					],
					[
						-114.048427,
						36.195153
					],
					[
						-114.048427,
						37.000263
					],
					[
						-110.499369,
						37.00574
					],
					[
						-109.042503,
						37.000263
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "05",
		id2: "AR",
		properties: {
			name: "Arkansas"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-94.473842,
						36.501861
					],
					[
						-90.152536,
						36.496384
					],
					[
						-90.064905,
						36.304691
					],
					[
						-90.218259,
						36.184199
					],
					[
						-90.377091,
						35.997983
					],
					[
						-89.730812,
						35.997983
					],
					[
						-89.763673,
						35.811767
					],
					[
						-89.911551,
						35.756997
					],
					[
						-89.944412,
						35.603643
					],
					[
						-90.130628,
						35.439335
					],
					[
						-90.114197,
						35.198349
					],
					[
						-90.212782,
						35.023087
					],
					[
						-90.311367,
						34.995703
					],
					[
						-90.251121,
						34.908072
					],
					[
						-90.409952,
						34.831394
					],
					[
						-90.481152,
						34.661609
					],
					[
						-90.585214,
						34.617794
					],
					[
						-90.568783,
						34.420624
					],
					[
						-90.749522,
						34.365854
					],
					[
						-90.744046,
						34.300131
					],
					[
						-90.952169,
						34.135823
					],
					[
						-90.891923,
						34.026284
					],
					[
						-91.072662,
						33.867453
					],
					[
						-91.231493,
						33.560744
					],
					[
						-91.056231,
						33.429298
					],
					[
						-91.143862,
						33.347144
					],
					[
						-91.089093,
						33.13902
					],
					[
						-91.16577,
						33.002096
					],
					[
						-93.608485,
						33.018527
					],
					[
						-94.041164,
						33.018527
					],
					[
						-94.041164,
						33.54979
					],
					[
						-94.183564,
						33.593606
					],
					[
						-94.380734,
						33.544313
					],
					[
						-94.484796,
						33.637421
					],
					[
						-94.430026,
						35.395519
					],
					[
						-94.616242,
						36.501861
					],
					[
						-94.473842,
						36.501861
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "06",
		id2: "CA",
		properties: {
			name: "California"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-123.233256,
						42.006186
					],
					[
						-122.378853,
						42.011663
					],
					[
						-121.037003,
						41.995232
					],
					[
						-120.001861,
						41.995232
					],
					[
						-119.996384,
						40.264519
					],
					[
						-120.001861,
						38.999346
					],
					[
						-118.71478,
						38.101128
					],
					[
						-117.498899,
						37.21934
					],
					[
						-116.540435,
						36.501861
					],
					[
						-115.85034,
						35.970598
					],
					[
						-114.634459,
						35.00118
					],
					[
						-114.634459,
						34.87521
					],
					[
						-114.470151,
						34.710902
					],
					[
						-114.333228,
						34.448009
					],
					[
						-114.136058,
						34.305608
					],
					[
						-114.256551,
						34.174162
					],
					[
						-114.415382,
						34.108438
					],
					[
						-114.535874,
						33.933176
					],
					[
						-114.497536,
						33.697668
					],
					[
						-114.524921,
						33.54979
					],
					[
						-114.727567,
						33.40739
					],
					[
						-114.661844,
						33.034958
					],
					[
						-114.524921,
						33.029481
					],
					[
						-114.470151,
						32.843265
					],
					[
						-114.524921,
						32.755634
					],
					[
						-114.72209,
						32.717295
					],
					[
						-116.04751,
						32.624187
					],
					[
						-117.126467,
						32.536556
					],
					[
						-117.24696,
						32.668003
					],
					[
						-117.252437,
						32.876127
					],
					[
						-117.329114,
						33.122589
					],
					[
						-117.471515,
						33.297851
					],
					[
						-117.7837,
						33.538836
					],
					[
						-118.183517,
						33.763391
					],
					[
						-118.260194,
						33.703145
					],
					[
						-118.413548,
						33.741483
					],
					[
						-118.391641,
						33.840068
					],
					[
						-118.566903,
						34.042715
					],
					[
						-118.802411,
						33.998899
					],
					[
						-119.218659,
						34.146777
					],
					[
						-119.278905,
						34.26727
					],
					[
						-119.558229,
						34.415147
					],
					[
						-119.875891,
						34.40967
					],
					[
						-120.138784,
						34.475393
					],
					[
						-120.472878,
						34.448009
					],
					[
						-120.64814,
						34.579455
					],
					[
						-120.609801,
						34.858779
					],
					[
						-120.670048,
						34.902595
					],
					[
						-120.631709,
						35.099764
					],
					[
						-120.894602,
						35.247642
					],
					[
						-120.905556,
						35.450289
					],
					[
						-121.004141,
						35.461243
					],
					[
						-121.168449,
						35.636505
					],
					[
						-121.283465,
						35.674843
					],
					[
						-121.332757,
						35.784382
					],
					[
						-121.716143,
						36.195153
					],
					[
						-121.896882,
						36.315645
					],
					[
						-121.935221,
						36.638785
					],
					[
						-121.858544,
						36.6114
					],
					[
						-121.787344,
						36.803093
					],
					[
						-121.929744,
						36.978355
					],
					[
						-122.105006,
						36.956447
					],
					[
						-122.335038,
						37.115279
					],
					[
						-122.417192,
						37.241248
					],
					[
						-122.400761,
						37.361741
					],
					[
						-122.515777,
						37.520572
					],
					[
						-122.515777,
						37.783465
					],
					[
						-122.329561,
						37.783465
					],
					[
						-122.406238,
						38.15042
					],
					[
						-122.488392,
						38.112082
					],
					[
						-122.504823,
						37.931343
					],
					[
						-122.701993,
						37.893004
					],
					[
						-122.937501,
						38.029928
					],
					[
						-122.97584,
						38.265436
					],
					[
						-123.129194,
						38.451652
					],
					[
						-123.331841,
						38.566668
					],
					[
						-123.44138,
						38.698114
					],
					[
						-123.737134,
						38.95553
					],
					[
						-123.687842,
						39.032208
					],
					[
						-123.824765,
						39.366301
					],
					[
						-123.764519,
						39.552517
					],
					[
						-123.85215,
						39.831841
					],
					[
						-124.109566,
						40.105688
					],
					[
						-124.361506,
						40.259042
					],
					[
						-124.410798,
						40.439781
					],
					[
						-124.158859,
						40.877937
					],
					[
						-124.109566,
						41.025814
					],
					[
						-124.158859,
						41.14083
					],
					[
						-124.065751,
						41.442061
					],
					[
						-124.147905,
						41.715908
					],
					[
						-124.257444,
						41.781632
					],
					[
						-124.213628,
						42.000709
					],
					[
						-123.233256,
						42.006186
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "08",
		id2: "CO",
		properties: {
			name: "Colorado"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-107.919731,
						41.003906
					],
					[
						-105.728954,
						40.998429
					],
					[
						-104.053011,
						41.003906
					],
					[
						-102.053927,
						41.003906
					],
					[
						-102.053927,
						40.001626
					],
					[
						-102.042974,
						36.994786
					],
					[
						-103.001438,
						37.000263
					],
					[
						-104.337812,
						36.994786
					],
					[
						-106.868158,
						36.994786
					],
					[
						-107.421329,
						37.000263
					],
					[
						-109.042503,
						37.000263
					],
					[
						-109.042503,
						38.166851
					],
					[
						-109.058934,
						38.27639
					],
					[
						-109.053457,
						39.125316
					],
					[
						-109.04798,
						40.998429
					],
					[
						-107.919731,
						41.003906
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "09",
		id2: "CT",
		properties: {
			name: "Connecticut"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-73.053528,
						42.039048
					],
					[
						-71.799309,
						42.022617
					],
					[
						-71.799309,
						42.006186
					],
					[
						-71.799309,
						41.414677
					],
					[
						-71.859555,
						41.321569
					],
					[
						-71.947186,
						41.338
					],
					[
						-72.385341,
						41.261322
					],
					[
						-72.905651,
						41.28323
					],
					[
						-73.130205,
						41.146307
					],
					[
						-73.371191,
						41.102491
					],
					[
						-73.655992,
						40.987475
					],
					[
						-73.727192,
						41.102491
					],
					[
						-73.48073,
						41.21203
					],
					[
						-73.55193,
						41.294184
					],
					[
						-73.486206,
						42.050002
					],
					[
						-73.053528,
						42.039048
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "10",
		id2: "DE",
		properties: {
			name: "Delaware"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-75.414089,
						39.804456
					],
					[
						-75.507197,
						39.683964
					],
					[
						-75.611259,
						39.61824
					],
					[
						-75.589352,
						39.459409
					],
					[
						-75.441474,
						39.311532
					],
					[
						-75.403136,
						39.065069
					],
					[
						-75.189535,
						38.807653
					],
					[
						-75.09095,
						38.796699
					],
					[
						-75.047134,
						38.451652
					],
					[
						-75.693413,
						38.462606
					],
					[
						-75.786521,
						39.722302
					],
					[
						-75.616736,
						39.831841
					],
					[
						-75.414089,
						39.804456
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "11",
		id2: "DC",
		properties: {
			name: "District of Columbia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-77.035264,
						38.993869
					],
					[
						-76.909294,
						38.895284
					],
					[
						-77.040741,
						38.791222
					],
					[
						-77.117418,
						38.933623
					],
					[
						-77.035264,
						38.993869
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "12",
		id2: "FL",
		properties: {
			name: "Florida"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-85.497137,
						30.997536
					],
					[
						-85.004212,
						31.003013
					],
					[
						-84.867289,
						30.712735
					],
					[
						-83.498053,
						30.647012
					],
					[
						-82.216449,
						30.570335
					],
					[
						-82.167157,
						30.356734
					],
					[
						-82.046664,
						30.362211
					],
					[
						-82.002849,
						30.564858
					],
					[
						-82.041187,
						30.751074
					],
					[
						-81.948079,
						30.827751
					],
					[
						-81.718048,
						30.745597
					],
					[
						-81.444201,
						30.707258
					],
					[
						-81.383954,
						30.27458
					],
					[
						-81.257985,
						29.787132
					],
					[
						-80.967707,
						29.14633
					],
					[
						-80.524075,
						28.461713
					],
					[
						-80.589798,
						28.41242
					],
					[
						-80.56789,
						28.094758
					],
					[
						-80.381674,
						27.738757
					],
					[
						-80.091397,
						27.021277
					],
					[
						-80.03115,
						26.796723
					],
					[
						-80.036627,
						26.566691
					],
					[
						-80.146166,
						25.739673
					],
					[
						-80.239274,
						25.723243
					],
					[
						-80.337859,
						25.465826
					],
					[
						-80.304997,
						25.383672
					],
					[
						-80.49669,
						25.197456
					],
					[
						-80.573367,
						25.241272
					],
					[
						-80.759583,
						25.164595
					],
					[
						-81.077246,
						25.120779
					],
					[
						-81.170354,
						25.224841
					],
					[
						-81.126538,
						25.378195
					],
					[
						-81.351093,
						25.821827
					],
					[
						-81.526355,
						25.903982
					],
					[
						-81.679709,
						25.843735
					],
					[
						-81.800202,
						26.090198
					],
					[
						-81.833064,
						26.292844
					],
					[
						-82.041187,
						26.517399
					],
					[
						-82.09048,
						26.665276
					],
					[
						-82.057618,
						26.878877
					],
					[
						-82.172634,
						26.917216
					],
					[
						-82.145249,
						26.791246
					],
					[
						-82.249311,
						26.758384
					],
					[
						-82.566974,
						27.300601
					],
					[
						-82.692943,
						27.437525
					],
					[
						-82.391711,
						27.837342
					],
					[
						-82.588881,
						27.815434
					],
					[
						-82.720328,
						27.689464
					],
					[
						-82.851774,
						27.886634
					],
					[
						-82.676512,
						28.434328
					],
					[
						-82.643651,
						28.888914
					],
					[
						-82.764143,
						28.998453
					],
					[
						-82.802482,
						29.14633
					],
					[
						-82.994175,
						29.179192
					],
					[
						-83.218729,
						29.420177
					],
					[
						-83.399469,
						29.518762
					],
					[
						-83.410422,
						29.66664
					],
					[
						-83.536392,
						29.721409
					],
					[
						-83.640454,
						29.885717
					],
					[
						-84.02384,
						30.104795
					],
					[
						-84.357933,
						30.055502
					],
					[
						-84.341502,
						29.902148
					],
					[
						-84.451041,
						29.929533
					],
					[
						-84.867289,
						29.743317
					],
					[
						-85.310921,
						29.699501
					],
					[
						-85.299967,
						29.80904
					],
					[
						-85.404029,
						29.940487
					],
					[
						-85.924338,
						30.236241
					],
					[
						-86.29677,
						30.362211
					],
					[
						-86.630863,
						30.395073
					],
					[
						-86.910187,
						30.373165
					],
					[
						-87.518128,
						30.280057
					],
					[
						-87.37025,
						30.427934
					],
					[
						-87.446927,
						30.510088
					],
					[
						-87.408589,
						30.674397
					],
					[
						-87.633143,
						30.86609
					],
					[
						-87.600282,
						30.997536
					],
					[
						-85.497137,
						30.997536
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "13",
		id2: "GA",
		properties: {
			name: "Georgia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-83.109191,
						35.00118
					],
					[
						-83.322791,
						34.787579
					],
					[
						-83.339222,
						34.683517
					],
					[
						-83.005129,
						34.469916
					],
					[
						-82.901067,
						34.486347
					],
					[
						-82.747713,
						34.26727
					],
					[
						-82.714851,
						34.152254
					],
					[
						-82.55602,
						33.94413
					],
					[
						-82.325988,
						33.81816
					],
					[
						-82.194542,
						33.631944
					],
					[
						-81.926172,
						33.462159
					],
					[
						-81.937125,
						33.347144
					],
					[
						-81.761863,
						33.160928
					],
					[
						-81.493493,
						33.007573
					],
					[
						-81.42777,
						32.843265
					],
					[
						-81.416816,
						32.629664
					],
					[
						-81.279893,
						32.558464
					],
					[
						-81.121061,
						32.290094
					],
					[
						-81.115584,
						32.120309
					],
					[
						-80.885553,
						32.032678
					],
					[
						-81.132015,
						31.693108
					],
					[
						-81.175831,
						31.517845
					],
					[
						-81.279893,
						31.364491
					],
					[
						-81.290846,
						31.20566
					],
					[
						-81.400385,
						31.13446
					],
					[
						-81.444201,
						30.707258
					],
					[
						-81.718048,
						30.745597
					],
					[
						-81.948079,
						30.827751
					],
					[
						-82.041187,
						30.751074
					],
					[
						-82.002849,
						30.564858
					],
					[
						-82.046664,
						30.362211
					],
					[
						-82.167157,
						30.356734
					],
					[
						-82.216449,
						30.570335
					],
					[
						-83.498053,
						30.647012
					],
					[
						-84.867289,
						30.712735
					],
					[
						-85.004212,
						31.003013
					],
					[
						-85.113751,
						31.27686
					],
					[
						-85.042551,
						31.539753
					],
					[
						-85.141136,
						31.840985
					],
					[
						-85.053504,
						32.01077
					],
					[
						-85.058981,
						32.13674
					],
					[
						-84.889196,
						32.262709
					],
					[
						-85.004212,
						32.322956
					],
					[
						-84.960397,
						32.421541
					],
					[
						-85.069935,
						32.580372
					],
					[
						-85.184951,
						32.859696
					],
					[
						-85.431413,
						34.124869
					],
					[
						-85.606675,
						34.984749
					],
					[
						-84.319594,
						34.990226
					],
					[
						-83.618546,
						34.984749
					],
					[
						-83.109191,
						35.00118
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "15",
		id2: "HI",
		properties: {
			name: "Hawaii"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-155.634835,
							18.948267
						],
						[
							-155.881297,
							19.035898
						],
						[
							-155.919636,
							19.123529
						],
						[
							-155.886774,
							19.348084
						],
						[
							-156.062036,
							19.73147
						],
						[
							-155.925113,
							19.857439
						],
						[
							-155.826528,
							20.032702
						],
						[
							-155.897728,
							20.147717
						],
						[
							-155.87582,
							20.26821
						],
						[
							-155.596496,
							20.12581
						],
						[
							-155.284311,
							20.021748
						],
						[
							-155.092618,
							19.868393
						],
						[
							-155.092618,
							19.736947
						],
						[
							-154.807817,
							19.523346
						],
						[
							-154.983079,
							19.348084
						],
						[
							-155.295265,
							19.26593
						],
						[
							-155.514342,
							19.134483
						],
						[
							-155.634835,
							18.948267
						]
					]
				],
				[
					[
						[
							-156.587823,
							21.029505
						],
						[
							-156.472807,
							20.892581
						],
						[
							-156.324929,
							20.952827
						],
						[
							-156.00179,
							20.793996
						],
						[
							-156.051082,
							20.651596
						],
						[
							-156.379699,
							20.580396
						],
						[
							-156.445422,
							20.60778
						],
						[
							-156.461853,
							20.783042
						],
						[
							-156.631638,
							20.821381
						],
						[
							-156.697361,
							20.919966
						],
						[
							-156.587823,
							21.029505
						]
					]
				],
				[
					[
						[
							-156.982162,
							21.210244
						],
						[
							-157.080747,
							21.106182
						],
						[
							-157.310779,
							21.106182
						],
						[
							-157.239579,
							21.221198
						],
						[
							-156.982162,
							21.210244
						]
					]
				],
				[
					[
						[
							-157.951581,
							21.697691
						],
						[
							-157.842042,
							21.462183
						],
						[
							-157.896811,
							21.325259
						],
						[
							-158.110412,
							21.303352
						],
						[
							-158.252813,
							21.582676
						],
						[
							-158.126843,
							21.588153
						],
						[
							-157.951581,
							21.697691
						]
					]
				],
				[
					[
						[
							-159.468693,
							22.228955
						],
						[
							-159.353678,
							22.218001
						],
						[
							-159.298908,
							22.113939
						],
						[
							-159.33177,
							21.966061
						],
						[
							-159.446786,
							21.872953
						],
						[
							-159.764448,
							21.987969
						],
						[
							-159.726109,
							22.152277
						],
						[
							-159.468693,
							22.228955
						]
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "16",
		id2: "ID",
		properties: {
			name: "Idaho"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-116.04751,
						49.000239
					],
					[
						-116.04751,
						47.976051
					],
					[
						-115.724371,
						47.696727
					],
					[
						-115.718894,
						47.42288
					],
					[
						-115.527201,
						47.302388
					],
					[
						-115.324554,
						47.258572
					],
					[
						-115.302646,
						47.187372
					],
					[
						-114.930214,
						46.919002
					],
					[
						-114.886399,
						46.809463
					],
					[
						-114.623506,
						46.705401
					],
					[
						-114.612552,
						46.639678
					],
					[
						-114.322274,
						46.645155
					],
					[
						-114.464674,
						46.272723
					],
					[
						-114.492059,
						46.037214
					],
					[
						-114.387997,
						45.88386
					],
					[
						-114.568736,
						45.774321
					],
					[
						-114.497536,
						45.670259
					],
					[
						-114.546828,
						45.560721
					],
					[
						-114.333228,
						45.456659
					],
					[
						-114.086765,
						45.593582
					],
					[
						-113.98818,
						45.703121
					],
					[
						-113.807441,
						45.604536
					],
					[
						-113.834826,
						45.522382
					],
					[
						-113.736241,
						45.330689
					],
					[
						-113.571933,
						45.128042
					],
					[
						-113.45144,
						45.056842
					],
					[
						-113.456917,
						44.865149
					],
					[
						-113.341901,
						44.782995
					],
					[
						-113.133778,
						44.772041
					],
					[
						-113.002331,
						44.448902
					],
					[
						-112.887315,
						44.394132
					],
					[
						-112.783254,
						44.48724
					],
					[
						-112.471068,
						44.481763
					],
					[
						-112.241036,
						44.569394
					],
					[
						-112.104113,
						44.520102
					],
					[
						-111.868605,
						44.563917
					],
					[
						-111.819312,
						44.509148
					],
					[
						-111.616665,
						44.547487
					],
					[
						-111.386634,
						44.75561
					],
					[
						-111.227803,
						44.580348
					],
					[
						-111.047063,
						44.476286
					],
					[
						-111.047063,
						42.000709
					],
					[
						-112.164359,
						41.995232
					],
					[
						-114.04295,
						41.995232
					],
					[
						-117.027882,
						42.000709
					],
					[
						-117.027882,
						43.830007
					],
					[
						-116.896436,
						44.158624
					],
					[
						-116.97859,
						44.240778
					],
					[
						-117.170283,
						44.257209
					],
					[
						-117.241483,
						44.394132
					],
					[
						-117.038836,
						44.750133
					],
					[
						-116.934774,
						44.782995
					],
					[
						-116.830713,
						44.930872
					],
					[
						-116.847143,
						45.02398
					],
					[
						-116.732128,
						45.144473
					],
					[
						-116.671881,
						45.319735
					],
					[
						-116.463758,
						45.61549
					],
					[
						-116.545912,
						45.752413
					],
					[
						-116.78142,
						45.823614
					],
					[
						-116.918344,
						45.993399
					],
					[
						-116.92382,
						46.168661
					],
					[
						-117.055267,
						46.343923
					],
					[
						-117.038836,
						46.426077
					],
					[
						-117.044313,
						47.762451
					],
					[
						-117.033359,
						49.000239
					],
					[
						-116.04751,
						49.000239
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "17",
		id2: "IL",
		properties: {
			name: "Illinois"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-90.639984,
						42.510065
					],
					[
						-88.788778,
						42.493634
					],
					[
						-87.802929,
						42.493634
					],
					[
						-87.83579,
						42.301941
					],
					[
						-87.682436,
						42.077386
					],
					[
						-87.523605,
						41.710431
					],
					[
						-87.529082,
						39.34987
					],
					[
						-87.63862,
						39.169131
					],
					[
						-87.512651,
						38.95553
					],
					[
						-87.49622,
						38.780268
					],
					[
						-87.62219,
						38.637868
					],
					[
						-87.655051,
						38.506421
					],
					[
						-87.83579,
						38.292821
					],
					[
						-87.950806,
						38.27639
					],
					[
						-87.923421,
						38.15042
					],
					[
						-88.000098,
						38.101128
					],
					[
						-88.060345,
						37.865619
					],
					[
						-88.027483,
						37.799896
					],
					[
						-88.15893,
						37.657496
					],
					[
						-88.065822,
						37.482234
					],
					[
						-88.476592,
						37.389126
					],
					[
						-88.514931,
						37.285064
					],
					[
						-88.421823,
						37.153617
					],
					[
						-88.547792,
						37.071463
					],
					[
						-88.914747,
						37.224817
					],
					[
						-89.029763,
						37.213863
					],
					[
						-89.183118,
						37.038601
					],
					[
						-89.133825,
						36.983832
					],
					[
						-89.292656,
						36.994786
					],
					[
						-89.517211,
						37.279587
					],
					[
						-89.435057,
						37.34531
					],
					[
						-89.517211,
						37.537003
					],
					[
						-89.517211,
						37.690357
					],
					[
						-89.84035,
						37.903958
					],
					[
						-89.949889,
						37.88205
					],
					[
						-90.059428,
						38.013497
					],
					[
						-90.355183,
						38.216144
					],
					[
						-90.349706,
						38.374975
					],
					[
						-90.179921,
						38.632391
					],
					[
						-90.207305,
						38.725499
					],
					[
						-90.10872,
						38.845992
					],
					[
						-90.251121,
						38.917192
					],
					[
						-90.470199,
						38.961007
					],
					[
						-90.585214,
						38.867899
					],
					[
						-90.661891,
						38.928146
					],
					[
						-90.727615,
						39.256762
					],
					[
						-91.061708,
						39.470363
					],
					[
						-91.368417,
						39.727779
					],
					[
						-91.494386,
						40.034488
					],
					[
						-91.50534,
						40.237135
					],
					[
						-91.417709,
						40.379535
					],
					[
						-91.401278,
						40.560274
					],
					[
						-91.121954,
						40.669813
					],
					[
						-91.09457,
						40.823167
					],
					[
						-90.963123,
						40.921752
					],
					[
						-90.946692,
						41.097014
					],
					[
						-91.111001,
						41.239415
					],
					[
						-91.045277,
						41.414677
					],
					[
						-90.656414,
						41.463969
					],
					[
						-90.344229,
						41.589939
					],
					[
						-90.311367,
						41.743293
					],
					[
						-90.179921,
						41.809016
					],
					[
						-90.141582,
						42.000709
					],
					[
						-90.168967,
						42.126679
					],
					[
						-90.393521,
						42.225264
					],
					[
						-90.420906,
						42.329326
					],
					[
						-90.639984,
						42.510065
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "18",
		id2: "IN",
		properties: {
			name: "Indiana"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-85.990061,
						41.759724
					],
					[
						-84.807042,
						41.759724
					],
					[
						-84.807042,
						41.694001
					],
					[
						-84.801565,
						40.500028
					],
					[
						-84.817996,
						39.103408
					],
					[
						-84.894673,
						39.059592
					],
					[
						-84.812519,
						38.785745
					],
					[
						-84.987781,
						38.780268
					],
					[
						-85.173997,
						38.68716
					],
					[
						-85.431413,
						38.730976
					],
					[
						-85.42046,
						38.533806
					],
					[
						-85.590245,
						38.451652
					],
					[
						-85.655968,
						38.325682
					],
					[
						-85.83123,
						38.27639
					],
					[
						-85.924338,
						38.024451
					],
					[
						-86.039354,
						37.958727
					],
					[
						-86.263908,
						38.051835
					],
					[
						-86.302247,
						38.166851
					],
					[
						-86.521325,
						38.040881
					],
					[
						-86.504894,
						37.931343
					],
					[
						-86.729448,
						37.893004
					],
					[
						-86.795172,
						37.991589
					],
					[
						-87.047111,
						37.893004
					],
					[
						-87.129265,
						37.788942
					],
					[
						-87.381204,
						37.93682
					],
					[
						-87.512651,
						37.903958
					],
					[
						-87.600282,
						37.975158
					],
					[
						-87.682436,
						37.903958
					],
					[
						-87.934375,
						37.893004
					],
					[
						-88.027483,
						37.799896
					],
					[
						-88.060345,
						37.865619
					],
					[
						-88.000098,
						38.101128
					],
					[
						-87.923421,
						38.15042
					],
					[
						-87.950806,
						38.27639
					],
					[
						-87.83579,
						38.292821
					],
					[
						-87.655051,
						38.506421
					],
					[
						-87.62219,
						38.637868
					],
					[
						-87.49622,
						38.780268
					],
					[
						-87.512651,
						38.95553
					],
					[
						-87.63862,
						39.169131
					],
					[
						-87.529082,
						39.34987
					],
					[
						-87.523605,
						41.710431
					],
					[
						-87.42502,
						41.644708
					],
					[
						-87.118311,
						41.644708
					],
					[
						-86.822556,
						41.759724
					],
					[
						-85.990061,
						41.759724
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "19",
		id2: "IA",
		properties: {
			name: "Iowa"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-91.368417,
						43.501391
					],
					[
						-91.215062,
						43.501391
					],
					[
						-91.204109,
						43.353514
					],
					[
						-91.056231,
						43.254929
					],
					[
						-91.176724,
						43.134436
					],
					[
						-91.143862,
						42.909881
					],
					[
						-91.067185,
						42.75105
					],
					[
						-90.711184,
						42.636034
					],
					[
						-90.639984,
						42.510065
					],
					[
						-90.420906,
						42.329326
					],
					[
						-90.393521,
						42.225264
					],
					[
						-90.168967,
						42.126679
					],
					[
						-90.141582,
						42.000709
					],
					[
						-90.179921,
						41.809016
					],
					[
						-90.311367,
						41.743293
					],
					[
						-90.344229,
						41.589939
					],
					[
						-90.656414,
						41.463969
					],
					[
						-91.045277,
						41.414677
					],
					[
						-91.111001,
						41.239415
					],
					[
						-90.946692,
						41.097014
					],
					[
						-90.963123,
						40.921752
					],
					[
						-91.09457,
						40.823167
					],
					[
						-91.121954,
						40.669813
					],
					[
						-91.401278,
						40.560274
					],
					[
						-91.417709,
						40.379535
					],
					[
						-91.527248,
						40.412397
					],
					[
						-91.729895,
						40.615043
					],
					[
						-91.833957,
						40.609566
					],
					[
						-93.257961,
						40.582182
					],
					[
						-94.632673,
						40.571228
					],
					[
						-95.7664,
						40.587659
					],
					[
						-95.881416,
						40.719105
					],
					[
						-95.826646,
						40.976521
					],
					[
						-95.925231,
						41.201076
					],
					[
						-95.919754,
						41.453015
					],
					[
						-96.095016,
						41.540646
					],
					[
						-96.122401,
						41.67757
					],
					[
						-96.062155,
						41.798063
					],
					[
						-96.127878,
						41.973325
					],
					[
						-96.264801,
						42.039048
					],
					[
						-96.44554,
						42.488157
					],
					[
						-96.631756,
						42.707235
					],
					[
						-96.544125,
						42.855112
					],
					[
						-96.511264,
						43.052282
					],
					[
						-96.434587,
						43.123482
					],
					[
						-96.560556,
						43.222067
					],
					[
						-96.527695,
						43.397329
					],
					[
						-96.582464,
						43.479483
					],
					[
						-96.451017,
						43.501391
					],
					[
						-91.368417,
						43.501391
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "20",
		id2: "KS",
		properties: {
			name: "Kansas"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-101.90605,
						40.001626
					],
					[
						-95.306337,
						40.001626
					],
					[
						-95.207752,
						39.908518
					],
					[
						-94.884612,
						39.831841
					],
					[
						-95.109167,
						39.541563
					],
					[
						-94.983197,
						39.442978
					],
					[
						-94.824366,
						39.20747
					],
					[
						-94.610765,
						39.158177
					],
					[
						-94.616242,
						37.000263
					],
					[
						-100.087706,
						37.000263
					],
					[
						-102.042974,
						36.994786
					],
					[
						-102.053927,
						40.001626
					],
					[
						-101.90605,
						40.001626
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "21",
		id2: "KY",
		properties: {
			name: "Kentucky"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-83.903347,
						38.769315
					],
					[
						-83.678792,
						38.632391
					],
					[
						-83.519961,
						38.703591
					],
					[
						-83.142052,
						38.626914
					],
					[
						-83.032514,
						38.725499
					],
					[
						-82.890113,
						38.758361
					],
					[
						-82.846298,
						38.588575
					],
					[
						-82.731282,
						38.561191
					],
					[
						-82.594358,
						38.424267
					],
					[
						-82.621743,
						38.123036
					],
					[
						-82.50125,
						37.931343
					],
					[
						-82.342419,
						37.783465
					],
					[
						-82.293127,
						37.668449
					],
					[
						-82.101434,
						37.553434
					],
					[
						-81.969987,
						37.537003
					],
					[
						-82.353373,
						37.268633
					],
					[
						-82.720328,
						37.120755
					],
					[
						-82.720328,
						37.044078
					],
					[
						-82.868205,
						36.978355
					],
					[
						-82.879159,
						36.890724
					],
					[
						-83.070852,
						36.852385
					],
					[
						-83.136575,
						36.742847
					],
					[
						-83.673316,
						36.600446
					],
					[
						-83.689746,
						36.584015
					],
					[
						-84.544149,
						36.594969
					],
					[
						-85.289013,
						36.627831
					],
					[
						-85.486183,
						36.616877
					],
					[
						-86.592525,
						36.655216
					],
					[
						-87.852221,
						36.633308
					],
					[
						-88.071299,
						36.677123
					],
					[
						-88.054868,
						36.496384
					],
					[
						-89.298133,
						36.507338
					],
					[
						-89.418626,
						36.496384
					],
					[
						-89.363857,
						36.622354
					],
					[
						-89.215979,
						36.578538
					],
					[
						-89.133825,
						36.983832
					],
					[
						-89.183118,
						37.038601
					],
					[
						-89.029763,
						37.213863
					],
					[
						-88.914747,
						37.224817
					],
					[
						-88.547792,
						37.071463
					],
					[
						-88.421823,
						37.153617
					],
					[
						-88.514931,
						37.285064
					],
					[
						-88.476592,
						37.389126
					],
					[
						-88.065822,
						37.482234
					],
					[
						-88.15893,
						37.657496
					],
					[
						-88.027483,
						37.799896
					],
					[
						-87.934375,
						37.893004
					],
					[
						-87.682436,
						37.903958
					],
					[
						-87.600282,
						37.975158
					],
					[
						-87.512651,
						37.903958
					],
					[
						-87.381204,
						37.93682
					],
					[
						-87.129265,
						37.788942
					],
					[
						-87.047111,
						37.893004
					],
					[
						-86.795172,
						37.991589
					],
					[
						-86.729448,
						37.893004
					],
					[
						-86.504894,
						37.931343
					],
					[
						-86.521325,
						38.040881
					],
					[
						-86.302247,
						38.166851
					],
					[
						-86.263908,
						38.051835
					],
					[
						-86.039354,
						37.958727
					],
					[
						-85.924338,
						38.024451
					],
					[
						-85.83123,
						38.27639
					],
					[
						-85.655968,
						38.325682
					],
					[
						-85.590245,
						38.451652
					],
					[
						-85.42046,
						38.533806
					],
					[
						-85.431413,
						38.730976
					],
					[
						-85.173997,
						38.68716
					],
					[
						-84.987781,
						38.780268
					],
					[
						-84.812519,
						38.785745
					],
					[
						-84.894673,
						39.059592
					],
					[
						-84.817996,
						39.103408
					],
					[
						-84.43461,
						39.103408
					],
					[
						-84.231963,
						38.895284
					],
					[
						-84.215533,
						38.807653
					],
					[
						-83.903347,
						38.769315
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "22",
		id2: "LA",
		properties: {
			name: "Louisiana"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-93.608485,
						33.018527
					],
					[
						-91.16577,
						33.002096
					],
					[
						-91.072662,
						32.887081
					],
					[
						-91.143862,
						32.843265
					],
					[
						-91.154816,
						32.640618
					],
					[
						-91.006939,
						32.514649
					],
					[
						-90.985031,
						32.218894
					],
					[
						-91.105524,
						31.988862
					],
					[
						-91.341032,
						31.846462
					],
					[
						-91.401278,
						31.621907
					],
					[
						-91.499863,
						31.643815
					],
					[
						-91.516294,
						31.27686
					],
					[
						-91.636787,
						31.265906
					],
					[
						-91.565587,
						31.068736
					],
					[
						-91.636787,
						30.997536
					],
					[
						-89.747242,
						30.997536
					],
					[
						-89.845827,
						30.66892
					],
					[
						-89.681519,
						30.449842
					],
					[
						-89.643181,
						30.285534
					],
					[
						-89.522688,
						30.181472
					],
					[
						-89.818443,
						30.044549
					],
					[
						-89.84035,
						29.945964
					],
					[
						-89.599365,
						29.88024
					],
					[
						-89.495303,
						30.039072
					],
					[
						-89.287179,
						29.88024
					],
					[
						-89.30361,
						29.754271
					],
					[
						-89.424103,
						29.699501
					],
					[
						-89.648657,
						29.748794
					],
					[
						-89.621273,
						29.655686
					],
					[
						-89.69795,
						29.513285
					],
					[
						-89.506257,
						29.387316
					],
					[
						-89.199548,
						29.348977
					],
					[
						-89.09001,
						29.2011
					],
					[
						-89.002379,
						29.179192
					],
					[
						-89.16121,
						29.009407
					],
					[
						-89.336472,
						29.042268
					],
					[
						-89.484349,
						29.217531
					],
					[
						-89.851304,
						29.310638
					],
					[
						-89.851304,
						29.480424
					],
					[
						-90.032043,
						29.425654
					],
					[
						-90.021089,
						29.283254
					],
					[
						-90.103244,
						29.151807
					],
					[
						-90.23469,
						29.129899
					],
					[
						-90.333275,
						29.277777
					],
					[
						-90.563307,
						29.283254
					],
					[
						-90.645461,
						29.129899
					],
					[
						-90.798815,
						29.086084
					],
					[
						-90.963123,
						29.179192
					],
					[
						-91.09457,
						29.190146
					],
					[
						-91.220539,
						29.436608
					],
					[
						-91.445094,
						29.546147
					],
					[
						-91.532725,
						29.529716
					],
					[
						-91.620356,
						29.73784
					],
					[
						-91.883249,
						29.710455
					],
					[
						-91.888726,
						29.836425
					],
					[
						-92.146142,
						29.715932
					],
					[
						-92.113281,
						29.622824
					],
					[
						-92.31045,
						29.535193
					],
					[
						-92.617159,
						29.579009
					],
					[
						-92.97316,
						29.715932
					],
					[
						-93.2251,
						29.776178
					],
					[
						-93.767317,
						29.726886
					],
					[
						-93.838517,
						29.688547
					],
					[
						-93.926148,
						29.787132
					],
					[
						-93.690639,
						30.143133
					],
					[
						-93.767317,
						30.334826
					],
					[
						-93.696116,
						30.438888
					],
					[
						-93.728978,
						30.575812
					],
					[
						-93.630393,
						30.679874
					],
					[
						-93.526331,
						30.93729
					],
					[
						-93.542762,
						31.15089
					],
					[
						-93.816609,
						31.556184
					],
					[
						-93.822086,
						31.775262
					],
					[
						-94.041164,
						31.994339
					],
					[
						-94.041164,
						33.018527
					],
					[
						-93.608485,
						33.018527
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "23",
		id2: "ME",
		properties: {
			name: "Maine"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-70.703921,
						43.057759
					],
					[
						-70.824413,
						43.128959
					],
					[
						-70.807983,
						43.227544
					],
					[
						-70.966814,
						43.34256
					],
					[
						-71.032537,
						44.657025
					],
					[
						-71.08183,
						45.303304
					],
					[
						-70.649151,
						45.440228
					],
					[
						-70.720352,
						45.511428
					],
					[
						-70.556043,
						45.664782
					],
					[
						-70.386258,
						45.735983
					],
					[
						-70.41912,
						45.796229
					],
					[
						-70.260289,
						45.889337
					],
					[
						-70.309581,
						46.064599
					],
					[
						-70.210996,
						46.327492
					],
					[
						-70.057642,
						46.415123
					],
					[
						-69.997395,
						46.694447
					],
					[
						-69.225147,
						47.461219
					],
					[
						-69.044408,
						47.428357
					],
					[
						-69.033454,
						47.242141
					],
					[
						-68.902007,
						47.176418
					],
					[
						-68.578868,
						47.285957
					],
					[
						-68.376221,
						47.285957
					],
					[
						-68.233821,
						47.357157
					],
					[
						-67.954497,
						47.198326
					],
					[
						-67.790188,
						47.066879
					],
					[
						-67.779235,
						45.944106
					],
					[
						-67.801142,
						45.675736
					],
					[
						-67.456095,
						45.604536
					],
					[
						-67.505388,
						45.48952
					],
					[
						-67.417757,
						45.379982
					],
					[
						-67.488957,
						45.281397
					],
					[
						-67.346556,
						45.128042
					],
					[
						-67.16034,
						45.160904
					],
					[
						-66.979601,
						44.804903
					],
					[
						-67.187725,
						44.646072
					],
					[
						-67.308218,
						44.706318
					],
					[
						-67.406803,
						44.596779
					],
					[
						-67.549203,
						44.624164
					],
					[
						-67.565634,
						44.531056
					],
					[
						-67.75185,
						44.54201
					],
					[
						-68.047605,
						44.328409
					],
					[
						-68.118805,
						44.476286
					],
					[
						-68.222867,
						44.48724
					],
					[
						-68.173574,
						44.328409
					],
					[
						-68.403606,
						44.251732
					],
					[
						-68.458375,
						44.377701
					],
					[
						-68.567914,
						44.311978
					],
					[
						-68.82533,
						44.311978
					],
					[
						-68.830807,
						44.459856
					],
					[
						-68.984161,
						44.426994
					],
					[
						-68.956777,
						44.322932
					],
					[
						-69.099177,
						44.103854
					],
					[
						-69.071793,
						44.043608
					],
					[
						-69.258008,
						43.923115
					],
					[
						-69.444224,
						43.966931
					],
					[
						-69.553763,
						43.840961
					],
					[
						-69.707118,
						43.82453
					],
					[
						-69.833087,
						43.720469
					],
					[
						-69.986442,
						43.742376
					],
					[
						-70.030257,
						43.851915
					],
					[
						-70.254812,
						43.676653
					],
					[
						-70.194565,
						43.567114
					],
					[
						-70.358873,
						43.528776
					],
					[
						-70.369827,
						43.435668
					],
					[
						-70.556043,
						43.320652
					],
					[
						-70.703921,
						43.057759
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "24",
		id2: "MD",
		properties: {
			name: "Maryland"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-75.994645,
							37.95325
						],
						[
							-76.016553,
							37.95325
						],
						[
							-76.043938,
							37.95325
						],
						[
							-75.994645,
							37.95325
						]
					]
				],
				[
					[
						[
							-79.477979,
							39.722302
						],
						[
							-75.786521,
							39.722302
						],
						[
							-75.693413,
							38.462606
						],
						[
							-75.047134,
							38.451652
						],
						[
							-75.244304,
							38.029928
						],
						[
							-75.397659,
							38.013497
						],
						[
							-75.671506,
							37.95325
						],
						[
							-75.885106,
							37.909435
						],
						[
							-75.879629,
							38.073743
						],
						[
							-75.961783,
							38.139466
						],
						[
							-75.846768,
							38.210667
						],
						[
							-76.000122,
							38.374975
						],
						[
							-76.049415,
							38.303775
						],
						[
							-76.257538,
							38.320205
						],
						[
							-76.328738,
							38.500944
						],
						[
							-76.263015,
							38.500944
						],
						[
							-76.257538,
							38.736453
						],
						[
							-76.191815,
							38.829561
						],
						[
							-76.279446,
							39.147223
						],
						[
							-76.169907,
							39.333439
						],
						[
							-76.000122,
							39.366301
						],
						[
							-75.972737,
							39.557994
						],
						[
							-76.098707,
							39.536086
						],
						[
							-76.104184,
							39.437501
						],
						[
							-76.367077,
							39.311532
						],
						[
							-76.443754,
							39.196516
						],
						[
							-76.460185,
							38.906238
						],
						[
							-76.55877,
							38.769315
						],
						[
							-76.514954,
							38.539283
						],
						[
							-76.383508,
							38.380452
						],
						[
							-76.399939,
							38.259959
						],
						[
							-76.317785,
							38.139466
						],
						[
							-76.3616,
							38.057312
						],
						[
							-76.591632,
							38.216144
						],
						[
							-76.920248,
							38.292821
						],
						[
							-77.018833,
							38.446175
						],
						[
							-77.205049,
							38.358544
						],
						[
							-77.276249,
							38.479037
						],
						[
							-77.128372,
							38.632391
						],
						[
							-77.040741,
							38.791222
						],
						[
							-76.909294,
							38.895284
						],
						[
							-77.035264,
							38.993869
						],
						[
							-77.117418,
							38.933623
						],
						[
							-77.248864,
							39.026731
						],
						[
							-77.456988,
							39.076023
						],
						[
							-77.456988,
							39.223901
						],
						[
							-77.566527,
							39.306055
						],
						[
							-77.719881,
							39.322485
						],
						[
							-77.834897,
							39.601809
						],
						[
							-78.004682,
							39.601809
						],
						[
							-78.174467,
							39.694917
						],
						[
							-78.267575,
							39.61824
						],
						[
							-78.431884,
							39.623717
						],
						[
							-78.470222,
							39.514178
						],
						[
							-78.765977,
							39.585379
						],
						[
							-78.963147,
							39.437501
						],
						[
							-79.094593,
							39.470363
						],
						[
							-79.291763,
							39.300578
						],
						[
							-79.488933,
							39.20747
						],
						[
							-79.477979,
							39.722302
						]
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "25",
		id2: "MA",
		properties: {
			name: "Massachusetts"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-70.917521,
						42.887974
					],
					[
						-70.818936,
						42.871543
					],
					[
						-70.780598,
						42.696281
					],
					[
						-70.824413,
						42.55388
					],
					[
						-70.983245,
						42.422434
					],
					[
						-70.988722,
						42.269079
					],
					[
						-70.769644,
						42.247172
					],
					[
						-70.638197,
						42.08834
					],
					[
						-70.660105,
						41.962371
					],
					[
						-70.550566,
						41.929509
					],
					[
						-70.539613,
						41.814493
					],
					[
						-70.260289,
						41.715908
					],
					[
						-69.937149,
						41.809016
					],
					[
						-70.008349,
						41.672093
					],
					[
						-70.484843,
						41.5516
					],
					[
						-70.660105,
						41.546123
					],
					[
						-70.764167,
						41.639231
					],
					[
						-70.928475,
						41.611847
					],
					[
						-70.933952,
						41.540646
					],
					[
						-71.120168,
						41.496831
					],
					[
						-71.196845,
						41.67757
					],
					[
						-71.22423,
						41.710431
					],
					[
						-71.328292,
						41.781632
					],
					[
						-71.383061,
						42.01714
					],
					[
						-71.530939,
						42.01714
					],
					[
						-71.799309,
						42.006186
					],
					[
						-71.799309,
						42.022617
					],
					[
						-73.053528,
						42.039048
					],
					[
						-73.486206,
						42.050002
					],
					[
						-73.508114,
						42.08834
					],
					[
						-73.267129,
						42.745573
					],
					[
						-72.456542,
						42.729142
					],
					[
						-71.29543,
						42.696281
					],
					[
						-71.185891,
						42.789389
					],
					[
						-70.917521,
						42.887974
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "26",
		id2: "MI",
		properties: {
			name: "Michigan"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-83.454238,
							41.732339
						],
						[
							-84.807042,
							41.694001
						],
						[
							-84.807042,
							41.759724
						],
						[
							-85.990061,
							41.759724
						],
						[
							-86.822556,
							41.759724
						],
						[
							-86.619909,
							41.891171
						],
						[
							-86.482986,
							42.115725
						],
						[
							-86.357016,
							42.252649
						],
						[
							-86.263908,
							42.444341
						],
						[
							-86.209139,
							42.718189
						],
						[
							-86.231047,
							43.013943
						],
						[
							-86.526801,
							43.594499
						],
						[
							-86.433693,
							43.813577
						],
						[
							-86.499417,
							44.07647
						],
						[
							-86.269385,
							44.34484
						],
						[
							-86.220093,
							44.569394
						],
						[
							-86.252954,
							44.689887
						],
						[
							-86.088646,
							44.73918
						],
						[
							-86.066738,
							44.903488
						],
						[
							-85.809322,
							44.947303
						],
						[
							-85.612152,
							45.128042
						],
						[
							-85.628583,
							44.766564
						],
						[
							-85.524521,
							44.750133
						],
						[
							-85.393075,
							44.930872
						],
						[
							-85.387598,
							45.237581
						],
						[
							-85.305444,
							45.314258
						],
						[
							-85.031597,
							45.363551
						],
						[
							-85.119228,
							45.577151
						],
						[
							-84.938489,
							45.75789
						],
						[
							-84.713934,
							45.768844
						],
						[
							-84.461995,
							45.653829
						],
						[
							-84.215533,
							45.637398
						],
						[
							-84.09504,
							45.494997
						],
						[
							-83.908824,
							45.484043
						],
						[
							-83.596638,
							45.352597
						],
						[
							-83.4871,
							45.358074
						],
						[
							-83.317314,
							45.144473
						],
						[
							-83.454238,
							45.029457
						],
						[
							-83.322791,
							44.88158
						],
						[
							-83.273499,
							44.711795
						],
						[
							-83.333745,
							44.339363
						],
						[
							-83.536392,
							44.246255
						],
						[
							-83.585684,
							44.054562
						],
						[
							-83.82667,
							43.988839
						],
						[
							-83.958116,
							43.758807
						],
						[
							-83.908824,
							43.671176
						],
						[
							-83.667839,
							43.589022
						],
						[
							-83.481623,
							43.714992
						],
						[
							-83.262545,
							43.972408
						],
						[
							-82.917498,
							44.070993
						],
						[
							-82.747713,
							43.994316
						],
						[
							-82.643651,
							43.851915
						],
						[
							-82.539589,
							43.435668
						],
						[
							-82.523158,
							43.227544
						],
						[
							-82.413619,
							42.975605
						],
						[
							-82.517681,
							42.614127
						],
						[
							-82.681989,
							42.559357
						],
						[
							-82.687466,
							42.690804
						],
						[
							-82.797005,
							42.652465
						],
						[
							-82.922975,
							42.351234
						],
						[
							-83.125621,
							42.236218
						],
						[
							-83.185868,
							42.006186
						],
						[
							-83.437807,
							41.814493
						],
						[
							-83.454238,
							41.732339
						]
					]
				],
				[
					[
						[
							-85.508091,
							45.730506
						],
						[
							-85.49166,
							45.610013
						],
						[
							-85.623106,
							45.588105
						],
						[
							-85.568337,
							45.75789
						],
						[
							-85.508091,
							45.730506
						]
					]
				],
				[
					[
						[
							-87.589328,
							45.095181
						],
						[
							-87.742682,
							45.199243
						],
						[
							-87.649574,
							45.341643
						],
						[
							-87.885083,
							45.363551
						],
						[
							-87.791975,
							45.500474
						],
						[
							-87.781021,
							45.675736
						],
						[
							-87.989145,
							45.796229
						],
						[
							-88.10416,
							45.922199
						],
						[
							-88.531362,
							46.020784
						],
						[
							-88.662808,
							45.987922
						],
						[
							-89.09001,
							46.135799
						],
						[
							-90.119674,
							46.338446
						],
						[
							-90.229213,
							46.508231
						],
						[
							-90.415429,
							46.568478
						],
						[
							-90.026566,
							46.672539
						],
						[
							-89.851304,
							46.793032
						],
						[
							-89.413149,
							46.842325
						],
						[
							-89.128348,
							46.990202
						],
						[
							-88.996902,
							46.995679
						],
						[
							-88.887363,
							47.099741
						],
						[
							-88.575177,
							47.247618
						],
						[
							-88.416346,
							47.373588
						],
						[
							-88.180837,
							47.455742
						],
						[
							-87.956283,
							47.384542
						],
						[
							-88.350623,
							47.077833
						],
						[
							-88.443731,
							46.973771
						],
						[
							-88.438254,
							46.787555
						],
						[
							-88.246561,
							46.929956
						],
						[
							-87.901513,
							46.908048
						],
						[
							-87.633143,
							46.809463
						],
						[
							-87.392158,
							46.535616
						],
						[
							-87.260711,
							46.486323
						],
						[
							-87.008772,
							46.530139
						],
						[
							-86.948526,
							46.469893
						],
						[
							-86.696587,
							46.437031
						],
						[
							-86.159846,
							46.667063
						],
						[
							-85.880522,
							46.68897
						],
						[
							-85.508091,
							46.678016
						],
						[
							-85.256151,
							46.754694
						],
						[
							-85.064458,
							46.760171
						],
						[
							-85.02612,
							46.480847
						],
						[
							-84.82895,
							46.442508
						],
						[
							-84.63178,
							46.486323
						],
						[
							-84.549626,
							46.4206
						],
						[
							-84.418179,
							46.502754
						],
						[
							-84.127902,
							46.530139
						],
						[
							-84.122425,
							46.179615
						],
						[
							-83.990978,
							46.031737
						],
						[
							-83.793808,
							45.993399
						],
						[
							-83.7719,
							46.091984
						],
						[
							-83.580208,
							46.091984
						],
						[
							-83.476146,
							45.987922
						],
						[
							-83.563777,
							45.911245
						],
						[
							-84.111471,
							45.976968
						],
						[
							-84.374364,
							45.933153
						],
						[
							-84.659165,
							46.053645
						],
						[
							-84.741319,
							45.944106
						],
						[
							-84.70298,
							45.850998
						],
						[
							-84.82895,
							45.872906
						],
						[
							-85.015166,
							46.00983
						],
						[
							-85.338305,
							46.091984
						],
						[
							-85.502614,
							46.097461
						],
						[
							-85.661445,
							45.966014
						],
						[
							-85.924338,
							45.933153
						],
						[
							-86.209139,
							45.960537
						],
						[
							-86.324155,
							45.905768
						],
						[
							-86.351539,
							45.796229
						],
						[
							-86.663725,
							45.703121
						],
						[
							-86.647294,
							45.834568
						],
						[
							-86.784218,
							45.861952
						],
						[
							-86.838987,
							45.725029
						],
						[
							-87.069019,
							45.719552
						],
						[
							-87.17308,
							45.659305
						],
						[
							-87.326435,
							45.423797
						],
						[
							-87.611236,
							45.122565
						],
						[
							-87.589328,
							45.095181
						]
					]
				],
				[
					[
						[
							-88.805209,
							47.976051
						],
						[
							-89.057148,
							47.850082
						],
						[
							-89.188594,
							47.833651
						],
						[
							-89.177641,
							47.937713
						],
						[
							-88.547792,
							48.173221
						],
						[
							-88.668285,
							48.008913
						],
						[
							-88.805209,
							47.976051
						]
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "27",
		id2: "MN",
		properties: {
			name: "Minnesota"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-92.014696,
						46.705401
					],
					[
						-92.091373,
						46.749217
					],
					[
						-92.29402,
						46.667063
					],
					[
						-92.29402,
						46.075553
					],
					[
						-92.354266,
						46.015307
					],
					[
						-92.639067,
						45.933153
					],
					[
						-92.869098,
						45.719552
					],
					[
						-92.885529,
						45.577151
					],
					[
						-92.770513,
						45.566198
					],
					[
						-92.644544,
						45.440228
					],
					[
						-92.75956,
						45.286874
					],
					[
						-92.737652,
						45.117088
					],
					[
						-92.808852,
						44.750133
					],
					[
						-92.545959,
						44.569394
					],
					[
						-92.337835,
						44.552964
					],
					[
						-92.233773,
						44.443425
					],
					[
						-91.927065,
						44.333886
					],
					[
						-91.877772,
						44.202439
					],
					[
						-91.592971,
						44.032654
					],
					[
						-91.43414,
						43.994316
					],
					[
						-91.242447,
						43.775238
					],
					[
						-91.269832,
						43.616407
					],
					[
						-91.215062,
						43.501391
					],
					[
						-91.368417,
						43.501391
					],
					[
						-96.451017,
						43.501391
					],
					[
						-96.451017,
						45.297827
					],
					[
						-96.681049,
						45.412843
					],
					[
						-96.856311,
						45.604536
					],
					[
						-96.582464,
						45.818137
					],
					[
						-96.560556,
						45.933153
					],
					[
						-96.598895,
						46.332969
					],
					[
						-96.719387,
						46.437031
					],
					[
						-96.801542,
						46.656109
					],
					[
						-96.785111,
						46.924479
					],
					[
						-96.823449,
						46.968294
					],
					[
						-96.856311,
						47.609096
					],
					[
						-97.053481,
						47.948667
					],
					[
						-97.130158,
						48.140359
					],
					[
						-97.16302,
						48.545653
					],
					[
						-97.097296,
						48.682577
					],
					[
						-97.228743,
						49.000239
					],
					[
						-95.152983,
						49.000239
					],
					[
						-95.152983,
						49.383625
					],
					[
						-94.955813,
						49.372671
					],
					[
						-94.824366,
						49.295994
					],
					[
						-94.69292,
						48.775685
					],
					[
						-94.588858,
						48.715438
					],
					[
						-94.260241,
						48.699007
					],
					[
						-94.221903,
						48.649715
					],
					[
						-93.838517,
						48.627807
					],
					[
						-93.794701,
						48.518268
					],
					[
						-93.466085,
						48.545653
					],
					[
						-93.466085,
						48.589469
					],
					[
						-93.208669,
						48.644238
					],
					[
						-92.984114,
						48.62233
					],
					[
						-92.726698,
						48.540176
					],
					[
						-92.655498,
						48.436114
					],
					[
						-92.50762,
						48.447068
					],
					[
						-92.370697,
						48.222514
					],
					[
						-92.304974,
						48.315622
					],
					[
						-92.053034,
						48.359437
					],
					[
						-92.009219,
						48.266329
					],
					[
						-91.713464,
						48.200606
					],
					[
						-91.713464,
						48.112975
					],
					[
						-91.565587,
						48.041775
					],
					[
						-91.264355,
						48.080113
					],
					[
						-91.083616,
						48.178698
					],
					[
						-90.837154,
						48.238944
					],
					[
						-90.749522,
						48.091067
					],
					[
						-90.579737,
						48.123929
					],
					[
						-90.377091,
						48.091067
					],
					[
						-90.141582,
						48.112975
					],
					[
						-89.873212,
						47.987005
					],
					[
						-89.615796,
						48.008913
					],
					[
						-89.637704,
						47.954144
					],
					[
						-89.971797,
						47.828174
					],
					[
						-90.437337,
						47.729589
					],
					[
						-90.738569,
						47.625527
					],
					[
						-91.171247,
						47.368111
					],
					[
						-91.357463,
						47.20928
					],
					[
						-91.642264,
						47.028541
					],
					[
						-92.091373,
						46.787555
					],
					[
						-92.014696,
						46.705401
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "28",
		id2: "MS",
		properties: {
			name: "Mississippi"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-88.471115,
						34.995703
					],
					[
						-88.202745,
						34.995703
					],
					[
						-88.098683,
						34.891641
					],
					[
						-88.241084,
						33.796253
					],
					[
						-88.471115,
						31.895754
					],
					[
						-88.394438,
						30.367688
					],
					[
						-88.503977,
						30.323872
					],
					[
						-88.744962,
						30.34578
					],
					[
						-88.843547,
						30.411504
					],
					[
						-89.084533,
						30.367688
					],
					[
						-89.418626,
						30.252672
					],
					[
						-89.522688,
						30.181472
					],
					[
						-89.643181,
						30.285534
					],
					[
						-89.681519,
						30.449842
					],
					[
						-89.845827,
						30.66892
					],
					[
						-89.747242,
						30.997536
					],
					[
						-91.636787,
						30.997536
					],
					[
						-91.565587,
						31.068736
					],
					[
						-91.636787,
						31.265906
					],
					[
						-91.516294,
						31.27686
					],
					[
						-91.499863,
						31.643815
					],
					[
						-91.401278,
						31.621907
					],
					[
						-91.341032,
						31.846462
					],
					[
						-91.105524,
						31.988862
					],
					[
						-90.985031,
						32.218894
					],
					[
						-91.006939,
						32.514649
					],
					[
						-91.154816,
						32.640618
					],
					[
						-91.143862,
						32.843265
					],
					[
						-91.072662,
						32.887081
					],
					[
						-91.16577,
						33.002096
					],
					[
						-91.089093,
						33.13902
					],
					[
						-91.143862,
						33.347144
					],
					[
						-91.056231,
						33.429298
					],
					[
						-91.231493,
						33.560744
					],
					[
						-91.072662,
						33.867453
					],
					[
						-90.891923,
						34.026284
					],
					[
						-90.952169,
						34.135823
					],
					[
						-90.744046,
						34.300131
					],
					[
						-90.749522,
						34.365854
					],
					[
						-90.568783,
						34.420624
					],
					[
						-90.585214,
						34.617794
					],
					[
						-90.481152,
						34.661609
					],
					[
						-90.409952,
						34.831394
					],
					[
						-90.251121,
						34.908072
					],
					[
						-90.311367,
						34.995703
					],
					[
						-88.471115,
						34.995703
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "29",
		id2: "MO",
		properties: {
			name: "Missouri"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-91.833957,
						40.609566
					],
					[
						-91.729895,
						40.615043
					],
					[
						-91.527248,
						40.412397
					],
					[
						-91.417709,
						40.379535
					],
					[
						-91.50534,
						40.237135
					],
					[
						-91.494386,
						40.034488
					],
					[
						-91.368417,
						39.727779
					],
					[
						-91.061708,
						39.470363
					],
					[
						-90.727615,
						39.256762
					],
					[
						-90.661891,
						38.928146
					],
					[
						-90.585214,
						38.867899
					],
					[
						-90.470199,
						38.961007
					],
					[
						-90.251121,
						38.917192
					],
					[
						-90.10872,
						38.845992
					],
					[
						-90.207305,
						38.725499
					],
					[
						-90.179921,
						38.632391
					],
					[
						-90.349706,
						38.374975
					],
					[
						-90.355183,
						38.216144
					],
					[
						-90.059428,
						38.013497
					],
					[
						-89.949889,
						37.88205
					],
					[
						-89.84035,
						37.903958
					],
					[
						-89.517211,
						37.690357
					],
					[
						-89.517211,
						37.537003
					],
					[
						-89.435057,
						37.34531
					],
					[
						-89.517211,
						37.279587
					],
					[
						-89.292656,
						36.994786
					],
					[
						-89.133825,
						36.983832
					],
					[
						-89.215979,
						36.578538
					],
					[
						-89.363857,
						36.622354
					],
					[
						-89.418626,
						36.496384
					],
					[
						-89.484349,
						36.496384
					],
					[
						-89.539119,
						36.496384
					],
					[
						-89.533642,
						36.249922
					],
					[
						-89.730812,
						35.997983
					],
					[
						-90.377091,
						35.997983
					],
					[
						-90.218259,
						36.184199
					],
					[
						-90.064905,
						36.304691
					],
					[
						-90.152536,
						36.496384
					],
					[
						-94.473842,
						36.501861
					],
					[
						-94.616242,
						36.501861
					],
					[
						-94.616242,
						37.000263
					],
					[
						-94.610765,
						39.158177
					],
					[
						-94.824366,
						39.20747
					],
					[
						-94.983197,
						39.442978
					],
					[
						-95.109167,
						39.541563
					],
					[
						-94.884612,
						39.831841
					],
					[
						-95.207752,
						39.908518
					],
					[
						-95.306337,
						40.001626
					],
					[
						-95.552799,
						40.264519
					],
					[
						-95.7664,
						40.587659
					],
					[
						-94.632673,
						40.571228
					],
					[
						-93.257961,
						40.582182
					],
					[
						-91.833957,
						40.609566
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "30",
		id2: "MT",
		properties: {
			name: "Montana"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-104.047534,
						49.000239
					],
					[
						-104.042057,
						47.861036
					],
					[
						-104.047534,
						45.944106
					],
					[
						-104.042057,
						44.996596
					],
					[
						-104.058488,
						44.996596
					],
					[
						-105.91517,
						45.002073
					],
					[
						-109.080842,
						45.002073
					],
					[
						-111.05254,
						45.002073
					],
					[
						-111.047063,
						44.476286
					],
					[
						-111.227803,
						44.580348
					],
					[
						-111.386634,
						44.75561
					],
					[
						-111.616665,
						44.547487
					],
					[
						-111.819312,
						44.509148
					],
					[
						-111.868605,
						44.563917
					],
					[
						-112.104113,
						44.520102
					],
					[
						-112.241036,
						44.569394
					],
					[
						-112.471068,
						44.481763
					],
					[
						-112.783254,
						44.48724
					],
					[
						-112.887315,
						44.394132
					],
					[
						-113.002331,
						44.448902
					],
					[
						-113.133778,
						44.772041
					],
					[
						-113.341901,
						44.782995
					],
					[
						-113.456917,
						44.865149
					],
					[
						-113.45144,
						45.056842
					],
					[
						-113.571933,
						45.128042
					],
					[
						-113.736241,
						45.330689
					],
					[
						-113.834826,
						45.522382
					],
					[
						-113.807441,
						45.604536
					],
					[
						-113.98818,
						45.703121
					],
					[
						-114.086765,
						45.593582
					],
					[
						-114.333228,
						45.456659
					],
					[
						-114.546828,
						45.560721
					],
					[
						-114.497536,
						45.670259
					],
					[
						-114.568736,
						45.774321
					],
					[
						-114.387997,
						45.88386
					],
					[
						-114.492059,
						46.037214
					],
					[
						-114.464674,
						46.272723
					],
					[
						-114.322274,
						46.645155
					],
					[
						-114.612552,
						46.639678
					],
					[
						-114.623506,
						46.705401
					],
					[
						-114.886399,
						46.809463
					],
					[
						-114.930214,
						46.919002
					],
					[
						-115.302646,
						47.187372
					],
					[
						-115.324554,
						47.258572
					],
					[
						-115.527201,
						47.302388
					],
					[
						-115.718894,
						47.42288
					],
					[
						-115.724371,
						47.696727
					],
					[
						-116.04751,
						47.976051
					],
					[
						-116.04751,
						49.000239
					],
					[
						-111.50165,
						48.994762
					],
					[
						-109.453274,
						49.000239
					],
					[
						-104.047534,
						49.000239
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "31",
		id2: "NE",
		properties: {
			name: "Nebraska"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-103.324578,
						43.002989
					],
					[
						-101.626726,
						42.997512
					],
					[
						-98.499393,
						42.997512
					],
					[
						-98.466531,
						42.94822
					],
					[
						-97.951699,
						42.767481
					],
					[
						-97.831206,
						42.866066
					],
					[
						-97.688806,
						42.844158
					],
					[
						-97.217789,
						42.844158
					],
					[
						-96.692003,
						42.657942
					],
					[
						-96.626279,
						42.515542
					],
					[
						-96.44554,
						42.488157
					],
					[
						-96.264801,
						42.039048
					],
					[
						-96.127878,
						41.973325
					],
					[
						-96.062155,
						41.798063
					],
					[
						-96.122401,
						41.67757
					],
					[
						-96.095016,
						41.540646
					],
					[
						-95.919754,
						41.453015
					],
					[
						-95.925231,
						41.201076
					],
					[
						-95.826646,
						40.976521
					],
					[
						-95.881416,
						40.719105
					],
					[
						-95.7664,
						40.587659
					],
					[
						-95.552799,
						40.264519
					],
					[
						-95.306337,
						40.001626
					],
					[
						-101.90605,
						40.001626
					],
					[
						-102.053927,
						40.001626
					],
					[
						-102.053927,
						41.003906
					],
					[
						-104.053011,
						41.003906
					],
					[
						-104.053011,
						43.002989
					],
					[
						-103.324578,
						43.002989
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "32",
		id2: "NV",
		properties: {
			name: "Nevada"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-117.027882,
						42.000709
					],
					[
						-114.04295,
						41.995232
					],
					[
						-114.048427,
						37.000263
					],
					[
						-114.048427,
						36.195153
					],
					[
						-114.152489,
						36.025367
					],
					[
						-114.251074,
						36.01989
					],
					[
						-114.371566,
						36.140383
					],
					[
						-114.738521,
						36.102045
					],
					[
						-114.678275,
						35.516012
					],
					[
						-114.596121,
						35.324319
					],
					[
						-114.574213,
						35.138103
					],
					[
						-114.634459,
						35.00118
					],
					[
						-115.85034,
						35.970598
					],
					[
						-116.540435,
						36.501861
					],
					[
						-117.498899,
						37.21934
					],
					[
						-118.71478,
						38.101128
					],
					[
						-120.001861,
						38.999346
					],
					[
						-119.996384,
						40.264519
					],
					[
						-120.001861,
						41.995232
					],
					[
						-118.698349,
						41.989755
					],
					[
						-117.027882,
						42.000709
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "33",
		id2: "NH",
		properties: {
			name: "New Hampshire"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-71.08183,
						45.303304
					],
					[
						-71.032537,
						44.657025
					],
					[
						-70.966814,
						43.34256
					],
					[
						-70.807983,
						43.227544
					],
					[
						-70.824413,
						43.128959
					],
					[
						-70.703921,
						43.057759
					],
					[
						-70.818936,
						42.871543
					],
					[
						-70.917521,
						42.887974
					],
					[
						-71.185891,
						42.789389
					],
					[
						-71.29543,
						42.696281
					],
					[
						-72.456542,
						42.729142
					],
					[
						-72.544173,
						42.80582
					],
					[
						-72.533219,
						42.953697
					],
					[
						-72.445588,
						43.008466
					],
					[
						-72.456542,
						43.150867
					],
					[
						-72.379864,
						43.572591
					],
					[
						-72.204602,
						43.769761
					],
					[
						-72.116971,
						43.994316
					],
					[
						-72.02934,
						44.07647
					],
					[
						-72.034817,
						44.322932
					],
					[
						-71.700724,
						44.41604
					],
					[
						-71.536416,
						44.585825
					],
					[
						-71.629524,
						44.750133
					],
					[
						-71.4926,
						44.914442
					],
					[
						-71.503554,
						45.013027
					],
					[
						-71.361154,
						45.270443
					],
					[
						-71.131122,
						45.243058
					],
					[
						-71.08183,
						45.303304
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "34",
		id2: "NJ",
		properties: {
			name: "New Jersey"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-74.236547,
						41.14083
					],
					[
						-73.902454,
						40.998429
					],
					[
						-74.022947,
						40.708151
					],
					[
						-74.187255,
						40.642428
					],
					[
						-74.274886,
						40.489074
					],
					[
						-74.001039,
						40.412397
					],
					[
						-73.979131,
						40.297381
					],
					[
						-74.099624,
						39.760641
					],
					[
						-74.411809,
						39.360824
					],
					[
						-74.614456,
						39.245808
					],
					[
						-74.795195,
						38.993869
					],
					[
						-74.888303,
						39.158177
					],
					[
						-75.178581,
						39.240331
					],
					[
						-75.534582,
						39.459409
					],
					[
						-75.55649,
						39.607286
					],
					[
						-75.561967,
						39.629194
					],
					[
						-75.507197,
						39.683964
					],
					[
						-75.414089,
						39.804456
					],
					[
						-75.145719,
						39.88661
					],
					[
						-75.129289,
						39.963288
					],
					[
						-74.82258,
						40.127596
					],
					[
						-74.773287,
						40.215227
					],
					[
						-75.058088,
						40.417874
					],
					[
						-75.069042,
						40.543843
					],
					[
						-75.195012,
						40.576705
					],
					[
						-75.205966,
						40.691721
					],
					[
						-75.052611,
						40.866983
					],
					[
						-75.134765,
						40.971045
					],
					[
						-74.882826,
						41.179168
					],
					[
						-74.828057,
						41.288707
					],
					[
						-74.69661,
						41.359907
					],
					[
						-74.236547,
						41.14083
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "35",
		id2: "NM",
		properties: {
			name: "New Mexico"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-107.421329,
						37.000263
					],
					[
						-106.868158,
						36.994786
					],
					[
						-104.337812,
						36.994786
					],
					[
						-103.001438,
						37.000263
					],
					[
						-103.001438,
						36.501861
					],
					[
						-103.039777,
						36.501861
					],
					[
						-103.045254,
						34.01533
					],
					[
						-103.067161,
						33.002096
					],
					[
						-103.067161,
						31.999816
					],
					[
						-106.616219,
						31.999816
					],
					[
						-106.643603,
						31.901231
					],
					[
						-106.528588,
						31.786216
					],
					[
						-108.210008,
						31.786216
					],
					[
						-108.210008,
						31.331629
					],
					[
						-109.04798,
						31.331629
					],
					[
						-109.042503,
						37.000263
					],
					[
						-107.421329,
						37.000263
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "36",
		id2: "NY",
		properties: {
			name: "New York"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-73.343806,
						45.013027
					],
					[
						-73.332852,
						44.804903
					],
					[
						-73.387622,
						44.618687
					],
					[
						-73.294514,
						44.437948
					],
					[
						-73.321898,
						44.246255
					],
					[
						-73.436914,
						44.043608
					],
					[
						-73.349283,
						43.769761
					],
					[
						-73.404052,
						43.687607
					],
					[
						-73.245221,
						43.523299
					],
					[
						-73.278083,
						42.833204
					],
					[
						-73.267129,
						42.745573
					],
					[
						-73.508114,
						42.08834
					],
					[
						-73.486206,
						42.050002
					],
					[
						-73.55193,
						41.294184
					],
					[
						-73.48073,
						41.21203
					],
					[
						-73.727192,
						41.102491
					],
					[
						-73.655992,
						40.987475
					],
					[
						-73.22879,
						40.905321
					],
					[
						-73.141159,
						40.965568
					],
					[
						-72.774204,
						40.965568
					],
					[
						-72.587988,
						40.998429
					],
					[
						-72.28128,
						41.157261
					],
					[
						-72.259372,
						41.042245
					],
					[
						-72.100541,
						40.992952
					],
					[
						-72.467496,
						40.845075
					],
					[
						-73.239744,
						40.625997
					],
					[
						-73.562884,
						40.582182
					],
					[
						-73.776484,
						40.593136
					],
					[
						-73.935316,
						40.543843
					],
					[
						-74.022947,
						40.708151
					],
					[
						-73.902454,
						40.998429
					],
					[
						-74.236547,
						41.14083
					],
					[
						-74.69661,
						41.359907
					],
					[
						-74.740426,
						41.431108
					],
					[
						-74.89378,
						41.436584
					],
					[
						-75.074519,
						41.60637
					],
					[
						-75.052611,
						41.754247
					],
					[
						-75.173104,
						41.869263
					],
					[
						-75.249781,
						41.863786
					],
					[
						-75.35932,
						42.000709
					],
					[
						-79.76278,
						42.000709
					],
					[
						-79.76278,
						42.252649
					],
					[
						-79.76278,
						42.269079
					],
					[
						-79.149363,
						42.55388
					],
					[
						-79.050778,
						42.690804
					],
					[
						-78.853608,
						42.783912
					],
					[
						-78.930285,
						42.953697
					],
					[
						-79.012439,
						42.986559
					],
					[
						-79.072686,
						43.260406
					],
					[
						-78.486653,
						43.375421
					],
					[
						-77.966344,
						43.369944
					],
					[
						-77.75822,
						43.34256
					],
					[
						-77.533665,
						43.233021
					],
					[
						-77.391265,
						43.276836
					],
					[
						-76.958587,
						43.271359
					],
					[
						-76.695693,
						43.34256
					],
					[
						-76.41637,
						43.523299
					],
					[
						-76.235631,
						43.528776
					],
					[
						-76.230154,
						43.802623
					],
					[
						-76.137046,
						43.961454
					],
					[
						-76.3616,
						44.070993
					],
					[
						-76.312308,
						44.196962
					],
					[
						-75.912491,
						44.366748
					],
					[
						-75.764614,
						44.514625
					],
					[
						-75.282643,
						44.848718
					],
					[
						-74.828057,
						45.018503
					],
					[
						-74.148916,
						44.991119
					],
					[
						-73.343806,
						45.013027
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "37",
		id2: "NC",
		properties: {
			name: "North Carolina"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-80.978661,
						36.562108
					],
					[
						-80.294043,
						36.545677
					],
					[
						-79.510841,
						36.5402
					],
					[
						-75.868676,
						36.551154
					],
					[
						-75.75366,
						36.151337
					],
					[
						-76.032984,
						36.189676
					],
					[
						-76.071322,
						36.140383
					],
					[
						-76.410893,
						36.080137
					],
					[
						-76.460185,
						36.025367
					],
					[
						-76.68474,
						36.008937
					],
					[
						-76.673786,
						35.937736
					],
					[
						-76.399939,
						35.987029
					],
					[
						-76.3616,
						35.943213
					],
					[
						-76.060368,
						35.992506
					],
					[
						-75.961783,
						35.899398
					],
					[
						-75.781044,
						35.937736
					],
					[
						-75.715321,
						35.696751
					],
					[
						-75.775568,
						35.581735
					],
					[
						-75.89606,
						35.570781
					],
					[
						-76.147999,
						35.324319
					],
					[
						-76.482093,
						35.313365
					],
					[
						-76.536862,
						35.14358
					],
					[
						-76.394462,
						34.973795
					],
					[
						-76.279446,
						34.940933
					],
					[
						-76.493047,
						34.661609
					],
					[
						-76.673786,
						34.694471
					],
					[
						-76.991448,
						34.667086
					],
					[
						-77.210526,
						34.60684
					],
					[
						-77.555573,
						34.415147
					],
					[
						-77.82942,
						34.163208
					],
					[
						-77.971821,
						33.845545
					],
					[
						-78.179944,
						33.916745
					],
					[
						-78.541422,
						33.851022
					],
					[
						-79.675149,
						34.80401
					],
					[
						-80.797922,
						34.820441
					],
					[
						-80.781491,
						34.935456
					],
					[
						-80.934845,
						35.105241
					],
					[
						-81.038907,
						35.044995
					],
					[
						-81.044384,
						35.149057
					],
					[
						-82.276696,
						35.198349
					],
					[
						-82.550543,
						35.160011
					],
					[
						-82.764143,
						35.066903
					],
					[
						-83.109191,
						35.00118
					],
					[
						-83.618546,
						34.984749
					],
					[
						-84.319594,
						34.990226
					],
					[
						-84.29221,
						35.225734
					],
					[
						-84.09504,
						35.247642
					],
					[
						-84.018363,
						35.41195
					],
					[
						-83.7719,
						35.559827
					],
					[
						-83.498053,
						35.565304
					],
					[
						-83.251591,
						35.718659
					],
					[
						-82.994175,
						35.773428
					],
					[
						-82.775097,
						35.997983
					],
					[
						-82.638174,
						36.063706
					],
					[
						-82.610789,
						35.965121
					],
					[
						-82.216449,
						36.156814
					],
					[
						-82.03571,
						36.118475
					],
					[
						-81.909741,
						36.304691
					],
					[
						-81.723525,
						36.353984
					],
					[
						-81.679709,
						36.589492
					],
					[
						-80.978661,
						36.562108
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "38",
		id2: "ND",
		properties: {
			name: "North Dakota"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-97.228743,
						49.000239
					],
					[
						-97.097296,
						48.682577
					],
					[
						-97.16302,
						48.545653
					],
					[
						-97.130158,
						48.140359
					],
					[
						-97.053481,
						47.948667
					],
					[
						-96.856311,
						47.609096
					],
					[
						-96.823449,
						46.968294
					],
					[
						-96.785111,
						46.924479
					],
					[
						-96.801542,
						46.656109
					],
					[
						-96.719387,
						46.437031
					],
					[
						-96.598895,
						46.332969
					],
					[
						-96.560556,
						45.933153
					],
					[
						-104.047534,
						45.944106
					],
					[
						-104.042057,
						47.861036
					],
					[
						-104.047534,
						49.000239
					],
					[
						-97.228743,
						49.000239
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "39",
		id2: "OH",
		properties: {
			name: "Ohio"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-80.518598,
						41.978802
					],
					[
						-80.518598,
						40.636951
					],
					[
						-80.666475,
						40.582182
					],
					[
						-80.595275,
						40.472643
					],
					[
						-80.600752,
						40.319289
					],
					[
						-80.737675,
						40.078303
					],
					[
						-80.830783,
						39.711348
					],
					[
						-81.219646,
						39.388209
					],
					[
						-81.345616,
						39.344393
					],
					[
						-81.455155,
						39.410117
					],
					[
						-81.57017,
						39.267716
					],
					[
						-81.685186,
						39.273193
					],
					[
						-81.811156,
						39.0815
					],
					[
						-81.783771,
						38.966484
					],
					[
						-81.887833,
						38.873376
					],
					[
						-82.03571,
						39.026731
					],
					[
						-82.221926,
						38.785745
					],
					[
						-82.172634,
						38.632391
					],
					[
						-82.293127,
						38.577622
					],
					[
						-82.331465,
						38.446175
					],
					[
						-82.594358,
						38.424267
					],
					[
						-82.731282,
						38.561191
					],
					[
						-82.846298,
						38.588575
					],
					[
						-82.890113,
						38.758361
					],
					[
						-83.032514,
						38.725499
					],
					[
						-83.142052,
						38.626914
					],
					[
						-83.519961,
						38.703591
					],
					[
						-83.678792,
						38.632391
					],
					[
						-83.903347,
						38.769315
					],
					[
						-84.215533,
						38.807653
					],
					[
						-84.231963,
						38.895284
					],
					[
						-84.43461,
						39.103408
					],
					[
						-84.817996,
						39.103408
					],
					[
						-84.801565,
						40.500028
					],
					[
						-84.807042,
						41.694001
					],
					[
						-83.454238,
						41.732339
					],
					[
						-83.065375,
						41.595416
					],
					[
						-82.933929,
						41.513262
					],
					[
						-82.835344,
						41.589939
					],
					[
						-82.616266,
						41.431108
					],
					[
						-82.479343,
						41.381815
					],
					[
						-82.013803,
						41.513262
					],
					[
						-81.739956,
						41.485877
					],
					[
						-81.444201,
						41.672093
					],
					[
						-81.011523,
						41.852832
					],
					[
						-80.518598,
						41.978802
					],
					[
						-80.518598,
						41.978802
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "40",
		id2: "OK",
		properties: {
			name: "Oklahoma"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-100.087706,
						37.000263
					],
					[
						-94.616242,
						37.000263
					],
					[
						-94.616242,
						36.501861
					],
					[
						-94.430026,
						35.395519
					],
					[
						-94.484796,
						33.637421
					],
					[
						-94.868182,
						33.74696
					],
					[
						-94.966767,
						33.861976
					],
					[
						-95.224183,
						33.960561
					],
					[
						-95.289906,
						33.87293
					],
					[
						-95.547322,
						33.878407
					],
					[
						-95.602092,
						33.933176
					],
					[
						-95.8376,
						33.834591
					],
					[
						-95.936185,
						33.889361
					],
					[
						-96.149786,
						33.840068
					],
					[
						-96.346956,
						33.686714
					],
					[
						-96.423633,
						33.774345
					],
					[
						-96.631756,
						33.845545
					],
					[
						-96.850834,
						33.845545
					],
					[
						-96.922034,
						33.960561
					],
					[
						-97.173974,
						33.736006
					],
					[
						-97.256128,
						33.861976
					],
					[
						-97.371143,
						33.823637
					],
					[
						-97.458774,
						33.905791
					],
					[
						-97.694283,
						33.982469
					],
					[
						-97.869545,
						33.851022
					],
					[
						-97.946222,
						33.987946
					],
					[
						-98.088623,
						34.004376
					],
					[
						-98.170777,
						34.113915
					],
					[
						-98.36247,
						34.157731
					],
					[
						-98.488439,
						34.064623
					],
					[
						-98.570593,
						34.146777
					],
					[
						-98.767763,
						34.135823
					],
					[
						-98.986841,
						34.223454
					],
					[
						-99.189488,
						34.2125
					],
					[
						-99.260688,
						34.404193
					],
					[
						-99.57835,
						34.415147
					],
					[
						-99.698843,
						34.382285
					],
					[
						-99.923398,
						34.573978
					],
					[
						-100.000075,
						34.563024
					],
					[
						-100.000075,
						36.501861
					],
					[
						-101.812942,
						36.501861
					],
					[
						-103.001438,
						36.501861
					],
					[
						-103.001438,
						37.000263
					],
					[
						-102.042974,
						36.994786
					],
					[
						-100.087706,
						37.000263
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "41",
		id2: "OR",
		properties: {
			name: "Oregon"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-123.211348,
						46.174138
					],
					[
						-123.11824,
						46.185092
					],
					[
						-122.904639,
						46.08103
					],
					[
						-122.811531,
						45.960537
					],
					[
						-122.762239,
						45.659305
					],
					[
						-122.247407,
						45.549767
					],
					[
						-121.809251,
						45.708598
					],
					[
						-121.535404,
						45.725029
					],
					[
						-121.217742,
						45.670259
					],
					[
						-121.18488,
						45.604536
					],
					[
						-120.637186,
						45.746937
					],
					[
						-120.505739,
						45.697644
					],
					[
						-120.209985,
						45.725029
					],
					[
						-119.963522,
						45.823614
					],
					[
						-119.525367,
						45.911245
					],
					[
						-119.125551,
						45.933153
					],
					[
						-118.988627,
						45.998876
					],
					[
						-116.918344,
						45.993399
					],
					[
						-116.78142,
						45.823614
					],
					[
						-116.545912,
						45.752413
					],
					[
						-116.463758,
						45.61549
					],
					[
						-116.671881,
						45.319735
					],
					[
						-116.732128,
						45.144473
					],
					[
						-116.847143,
						45.02398
					],
					[
						-116.830713,
						44.930872
					],
					[
						-116.934774,
						44.782995
					],
					[
						-117.038836,
						44.750133
					],
					[
						-117.241483,
						44.394132
					],
					[
						-117.170283,
						44.257209
					],
					[
						-116.97859,
						44.240778
					],
					[
						-116.896436,
						44.158624
					],
					[
						-117.027882,
						43.830007
					],
					[
						-117.027882,
						42.000709
					],
					[
						-118.698349,
						41.989755
					],
					[
						-120.001861,
						41.995232
					],
					[
						-121.037003,
						41.995232
					],
					[
						-122.378853,
						42.011663
					],
					[
						-123.233256,
						42.006186
					],
					[
						-124.213628,
						42.000709
					],
					[
						-124.356029,
						42.115725
					],
					[
						-124.432706,
						42.438865
					],
					[
						-124.416275,
						42.663419
					],
					[
						-124.553198,
						42.838681
					],
					[
						-124.454613,
						43.002989
					],
					[
						-124.383413,
						43.271359
					],
					[
						-124.235536,
						43.55616
					],
					[
						-124.169813,
						43.8081
					],
					[
						-124.060274,
						44.657025
					],
					[
						-124.076705,
						44.772041
					],
					[
						-123.97812,
						45.144473
					],
					[
						-123.939781,
						45.659305
					],
					[
						-123.994551,
						45.944106
					],
					[
						-123.945258,
						46.113892
					],
					[
						-123.545441,
						46.261769
					],
					[
						-123.370179,
						46.146753
					],
					[
						-123.211348,
						46.174138
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "42",
		id2: "PA",
		properties: {
			name: "Pennsylvania"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-79.76278,
						42.252649
					],
					[
						-79.76278,
						42.000709
					],
					[
						-75.35932,
						42.000709
					],
					[
						-75.249781,
						41.863786
					],
					[
						-75.173104,
						41.869263
					],
					[
						-75.052611,
						41.754247
					],
					[
						-75.074519,
						41.60637
					],
					[
						-74.89378,
						41.436584
					],
					[
						-74.740426,
						41.431108
					],
					[
						-74.69661,
						41.359907
					],
					[
						-74.828057,
						41.288707
					],
					[
						-74.882826,
						41.179168
					],
					[
						-75.134765,
						40.971045
					],
					[
						-75.052611,
						40.866983
					],
					[
						-75.205966,
						40.691721
					],
					[
						-75.195012,
						40.576705
					],
					[
						-75.069042,
						40.543843
					],
					[
						-75.058088,
						40.417874
					],
					[
						-74.773287,
						40.215227
					],
					[
						-74.82258,
						40.127596
					],
					[
						-75.129289,
						39.963288
					],
					[
						-75.145719,
						39.88661
					],
					[
						-75.414089,
						39.804456
					],
					[
						-75.616736,
						39.831841
					],
					[
						-75.786521,
						39.722302
					],
					[
						-79.477979,
						39.722302
					],
					[
						-80.518598,
						39.722302
					],
					[
						-80.518598,
						40.636951
					],
					[
						-80.518598,
						41.978802
					],
					[
						-80.518598,
						41.978802
					],
					[
						-80.332382,
						42.033571
					],
					[
						-79.76278,
						42.269079
					],
					[
						-79.76278,
						42.252649
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "44",
		id2: "RI",
		properties: {
			name: "Rhode Island"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-71.196845,
							41.67757
						],
						[
							-71.120168,
							41.496831
						],
						[
							-71.317338,
							41.474923
						],
						[
							-71.196845,
							41.67757
						]
					]
				],
				[
					[
						[
							-71.530939,
							42.01714
						],
						[
							-71.383061,
							42.01714
						],
						[
							-71.328292,
							41.781632
						],
						[
							-71.22423,
							41.710431
						],
						[
							-71.344723,
							41.726862
						],
						[
							-71.448785,
							41.578985
						],
						[
							-71.481646,
							41.370861
						],
						[
							-71.859555,
							41.321569
						],
						[
							-71.799309,
							41.414677
						],
						[
							-71.799309,
							42.006186
						],
						[
							-71.530939,
							42.01714
						]
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "45",
		id2: "SC",
		properties: {
			name: "South Carolina"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-82.764143,
						35.066903
					],
					[
						-82.550543,
						35.160011
					],
					[
						-82.276696,
						35.198349
					],
					[
						-81.044384,
						35.149057
					],
					[
						-81.038907,
						35.044995
					],
					[
						-80.934845,
						35.105241
					],
					[
						-80.781491,
						34.935456
					],
					[
						-80.797922,
						34.820441
					],
					[
						-79.675149,
						34.80401
					],
					[
						-78.541422,
						33.851022
					],
					[
						-78.716684,
						33.80173
					],
					[
						-78.935762,
						33.637421
					],
					[
						-79.149363,
						33.380005
					],
					[
						-79.187701,
						33.171881
					],
					[
						-79.357487,
						33.007573
					],
					[
						-79.582041,
						33.007573
					],
					[
						-79.631334,
						32.887081
					],
					[
						-79.866842,
						32.755634
					],
					[
						-79.998289,
						32.613234
					],
					[
						-80.206412,
						32.552987
					],
					[
						-80.430967,
						32.399633
					],
					[
						-80.452875,
						32.328433
					],
					[
						-80.660998,
						32.246279
					],
					[
						-80.885553,
						32.032678
					],
					[
						-81.115584,
						32.120309
					],
					[
						-81.121061,
						32.290094
					],
					[
						-81.279893,
						32.558464
					],
					[
						-81.416816,
						32.629664
					],
					[
						-81.42777,
						32.843265
					],
					[
						-81.493493,
						33.007573
					],
					[
						-81.761863,
						33.160928
					],
					[
						-81.937125,
						33.347144
					],
					[
						-81.926172,
						33.462159
					],
					[
						-82.194542,
						33.631944
					],
					[
						-82.325988,
						33.81816
					],
					[
						-82.55602,
						33.94413
					],
					[
						-82.714851,
						34.152254
					],
					[
						-82.747713,
						34.26727
					],
					[
						-82.901067,
						34.486347
					],
					[
						-83.005129,
						34.469916
					],
					[
						-83.339222,
						34.683517
					],
					[
						-83.322791,
						34.787579
					],
					[
						-83.109191,
						35.00118
					],
					[
						-82.764143,
						35.066903
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "46",
		id2: "SD",
		properties: {
			name: "South Dakota"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-104.047534,
						45.944106
					],
					[
						-96.560556,
						45.933153
					],
					[
						-96.582464,
						45.818137
					],
					[
						-96.856311,
						45.604536
					],
					[
						-96.681049,
						45.412843
					],
					[
						-96.451017,
						45.297827
					],
					[
						-96.451017,
						43.501391
					],
					[
						-96.582464,
						43.479483
					],
					[
						-96.527695,
						43.397329
					],
					[
						-96.560556,
						43.222067
					],
					[
						-96.434587,
						43.123482
					],
					[
						-96.511264,
						43.052282
					],
					[
						-96.544125,
						42.855112
					],
					[
						-96.631756,
						42.707235
					],
					[
						-96.44554,
						42.488157
					],
					[
						-96.626279,
						42.515542
					],
					[
						-96.692003,
						42.657942
					],
					[
						-97.217789,
						42.844158
					],
					[
						-97.688806,
						42.844158
					],
					[
						-97.831206,
						42.866066
					],
					[
						-97.951699,
						42.767481
					],
					[
						-98.466531,
						42.94822
					],
					[
						-98.499393,
						42.997512
					],
					[
						-101.626726,
						42.997512
					],
					[
						-103.324578,
						43.002989
					],
					[
						-104.053011,
						43.002989
					],
					[
						-104.058488,
						44.996596
					],
					[
						-104.042057,
						44.996596
					],
					[
						-104.047534,
						45.944106
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "47",
		id2: "TN",
		properties: {
			name: "Tennessee"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-88.054868,
						36.496384
					],
					[
						-88.071299,
						36.677123
					],
					[
						-87.852221,
						36.633308
					],
					[
						-86.592525,
						36.655216
					],
					[
						-85.486183,
						36.616877
					],
					[
						-85.289013,
						36.627831
					],
					[
						-84.544149,
						36.594969
					],
					[
						-83.689746,
						36.584015
					],
					[
						-83.673316,
						36.600446
					],
					[
						-81.679709,
						36.589492
					],
					[
						-81.723525,
						36.353984
					],
					[
						-81.909741,
						36.304691
					],
					[
						-82.03571,
						36.118475
					],
					[
						-82.216449,
						36.156814
					],
					[
						-82.610789,
						35.965121
					],
					[
						-82.638174,
						36.063706
					],
					[
						-82.775097,
						35.997983
					],
					[
						-82.994175,
						35.773428
					],
					[
						-83.251591,
						35.718659
					],
					[
						-83.498053,
						35.565304
					],
					[
						-83.7719,
						35.559827
					],
					[
						-84.018363,
						35.41195
					],
					[
						-84.09504,
						35.247642
					],
					[
						-84.29221,
						35.225734
					],
					[
						-84.319594,
						34.990226
					],
					[
						-85.606675,
						34.984749
					],
					[
						-87.359296,
						35.00118
					],
					[
						-88.202745,
						34.995703
					],
					[
						-88.471115,
						34.995703
					],
					[
						-90.311367,
						34.995703
					],
					[
						-90.212782,
						35.023087
					],
					[
						-90.114197,
						35.198349
					],
					[
						-90.130628,
						35.439335
					],
					[
						-89.944412,
						35.603643
					],
					[
						-89.911551,
						35.756997
					],
					[
						-89.763673,
						35.811767
					],
					[
						-89.730812,
						35.997983
					],
					[
						-89.533642,
						36.249922
					],
					[
						-89.539119,
						36.496384
					],
					[
						-89.484349,
						36.496384
					],
					[
						-89.418626,
						36.496384
					],
					[
						-89.298133,
						36.507338
					],
					[
						-88.054868,
						36.496384
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "48",
		id2: "TX",
		properties: {
			name: "Texas"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-101.812942,
						36.501861
					],
					[
						-100.000075,
						36.501861
					],
					[
						-100.000075,
						34.563024
					],
					[
						-99.923398,
						34.573978
					],
					[
						-99.698843,
						34.382285
					],
					[
						-99.57835,
						34.415147
					],
					[
						-99.260688,
						34.404193
					],
					[
						-99.189488,
						34.2125
					],
					[
						-98.986841,
						34.223454
					],
					[
						-98.767763,
						34.135823
					],
					[
						-98.570593,
						34.146777
					],
					[
						-98.488439,
						34.064623
					],
					[
						-98.36247,
						34.157731
					],
					[
						-98.170777,
						34.113915
					],
					[
						-98.088623,
						34.004376
					],
					[
						-97.946222,
						33.987946
					],
					[
						-97.869545,
						33.851022
					],
					[
						-97.694283,
						33.982469
					],
					[
						-97.458774,
						33.905791
					],
					[
						-97.371143,
						33.823637
					],
					[
						-97.256128,
						33.861976
					],
					[
						-97.173974,
						33.736006
					],
					[
						-96.922034,
						33.960561
					],
					[
						-96.850834,
						33.845545
					],
					[
						-96.631756,
						33.845545
					],
					[
						-96.423633,
						33.774345
					],
					[
						-96.346956,
						33.686714
					],
					[
						-96.149786,
						33.840068
					],
					[
						-95.936185,
						33.889361
					],
					[
						-95.8376,
						33.834591
					],
					[
						-95.602092,
						33.933176
					],
					[
						-95.547322,
						33.878407
					],
					[
						-95.289906,
						33.87293
					],
					[
						-95.224183,
						33.960561
					],
					[
						-94.966767,
						33.861976
					],
					[
						-94.868182,
						33.74696
					],
					[
						-94.484796,
						33.637421
					],
					[
						-94.380734,
						33.544313
					],
					[
						-94.183564,
						33.593606
					],
					[
						-94.041164,
						33.54979
					],
					[
						-94.041164,
						33.018527
					],
					[
						-94.041164,
						31.994339
					],
					[
						-93.822086,
						31.775262
					],
					[
						-93.816609,
						31.556184
					],
					[
						-93.542762,
						31.15089
					],
					[
						-93.526331,
						30.93729
					],
					[
						-93.630393,
						30.679874
					],
					[
						-93.728978,
						30.575812
					],
					[
						-93.696116,
						30.438888
					],
					[
						-93.767317,
						30.334826
					],
					[
						-93.690639,
						30.143133
					],
					[
						-93.926148,
						29.787132
					],
					[
						-93.838517,
						29.688547
					],
					[
						-94.002825,
						29.68307
					],
					[
						-94.523134,
						29.546147
					],
					[
						-94.70935,
						29.622824
					],
					[
						-94.742212,
						29.787132
					],
					[
						-94.873659,
						29.672117
					],
					[
						-94.966767,
						29.699501
					],
					[
						-95.016059,
						29.557101
					],
					[
						-94.911997,
						29.496854
					],
					[
						-94.895566,
						29.310638
					],
					[
						-95.081782,
						29.113469
					],
					[
						-95.383014,
						28.867006
					],
					[
						-95.985477,
						28.604113
					],
					[
						-96.045724,
						28.647929
					],
					[
						-96.226463,
						28.582205
					],
					[
						-96.23194,
						28.642452
					],
					[
						-96.478402,
						28.598636
					],
					[
						-96.593418,
						28.724606
					],
					[
						-96.664618,
						28.697221
					],
					[
						-96.401725,
						28.439805
					],
					[
						-96.593418,
						28.357651
					],
					[
						-96.774157,
						28.406943
					],
					[
						-96.801542,
						28.226204
					],
					[
						-97.026096,
						28.039988
					],
					[
						-97.256128,
						27.694941
					],
					[
						-97.404005,
						27.333463
					],
					[
						-97.513544,
						27.360848
					],
					[
						-97.540929,
						27.229401
					],
					[
						-97.425913,
						27.262263
					],
					[
						-97.480682,
						26.99937
					],
					[
						-97.557359,
						26.988416
					],
					[
						-97.562836,
						26.840538
					],
					[
						-97.469728,
						26.758384
					],
					[
						-97.442344,
						26.457153
					],
					[
						-97.332805,
						26.353091
					],
					[
						-97.30542,
						26.161398
					],
					[
						-97.217789,
						25.991613
					],
					[
						-97.524498,
						25.887551
					],
					[
						-97.650467,
						26.018997
					],
					[
						-97.885976,
						26.06829
					],
					[
						-98.198161,
						26.057336
					],
					[
						-98.466531,
						26.221644
					],
					[
						-98.669178,
						26.238075
					],
					[
						-98.822533,
						26.369522
					],
					[
						-99.030656,
						26.413337
					],
					[
						-99.173057,
						26.539307
					],
					[
						-99.266165,
						26.840538
					],
					[
						-99.446904,
						27.021277
					],
					[
						-99.424996,
						27.174632
					],
					[
						-99.50715,
						27.33894
					],
					[
						-99.479765,
						27.48134
					],
					[
						-99.605735,
						27.640172
					],
					[
						-99.709797,
						27.656603
					],
					[
						-99.879582,
						27.799003
					],
					[
						-99.934351,
						27.979742
					],
					[
						-100.082229,
						28.14405
					],
					[
						-100.29583,
						28.280974
					],
					[
						-100.399891,
						28.582205
					],
					[
						-100.498476,
						28.66436
					],
					[
						-100.629923,
						28.905345
					],
					[
						-100.673738,
						29.102515
					],
					[
						-100.799708,
						29.244915
					],
					[
						-101.013309,
						29.370885
					],
					[
						-101.062601,
						29.458516
					],
					[
						-101.259771,
						29.535193
					],
					[
						-101.413125,
						29.754271
					],
					[
						-101.851281,
						29.803563
					],
					[
						-102.114174,
						29.792609
					],
					[
						-102.338728,
						29.869286
					],
					[
						-102.388021,
						29.765225
					],
					[
						-102.629006,
						29.732363
					],
					[
						-102.809745,
						29.524239
					],
					[
						-102.919284,
						29.190146
					],
					[
						-102.97953,
						29.184669
					],
					[
						-103.116454,
						28.987499
					],
					[
						-103.280762,
						28.982022
					],
					[
						-103.527224,
						29.135376
					],
					[
						-104.146119,
						29.381839
					],
					[
						-104.266611,
						29.513285
					],
					[
						-104.507597,
						29.639255
					],
					[
						-104.677382,
						29.924056
					],
					[
						-104.688336,
						30.181472
					],
					[
						-104.858121,
						30.389596
					],
					[
						-104.896459,
						30.570335
					],
					[
						-105.005998,
						30.685351
					],
					[
						-105.394861,
						30.855136
					],
					[
						-105.602985,
						31.085167
					],
					[
						-105.77277,
						31.167321
					],
					[
						-105.953509,
						31.364491
					],
					[
						-106.205448,
						31.468553
					],
					[
						-106.38071,
						31.731446
					],
					[
						-106.528588,
						31.786216
					],
					[
						-106.643603,
						31.901231
					],
					[
						-106.616219,
						31.999816
					],
					[
						-103.067161,
						31.999816
					],
					[
						-103.067161,
						33.002096
					],
					[
						-103.045254,
						34.01533
					],
					[
						-103.039777,
						36.501861
					],
					[
						-103.001438,
						36.501861
					],
					[
						-101.812942,
						36.501861
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "49",
		id2: "UT",
		properties: {
			name: "Utah"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-112.164359,
						41.995232
					],
					[
						-111.047063,
						42.000709
					],
					[
						-111.047063,
						40.998429
					],
					[
						-109.04798,
						40.998429
					],
					[
						-109.053457,
						39.125316
					],
					[
						-109.058934,
						38.27639
					],
					[
						-109.042503,
						38.166851
					],
					[
						-109.042503,
						37.000263
					],
					[
						-110.499369,
						37.00574
					],
					[
						-114.048427,
						37.000263
					],
					[
						-114.04295,
						41.995232
					],
					[
						-112.164359,
						41.995232
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "50",
		id2: "VT",
		properties: {
			name: "Vermont"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-71.503554,
						45.013027
					],
					[
						-71.4926,
						44.914442
					],
					[
						-71.629524,
						44.750133
					],
					[
						-71.536416,
						44.585825
					],
					[
						-71.700724,
						44.41604
					],
					[
						-72.034817,
						44.322932
					],
					[
						-72.02934,
						44.07647
					],
					[
						-72.116971,
						43.994316
					],
					[
						-72.204602,
						43.769761
					],
					[
						-72.379864,
						43.572591
					],
					[
						-72.456542,
						43.150867
					],
					[
						-72.445588,
						43.008466
					],
					[
						-72.533219,
						42.953697
					],
					[
						-72.544173,
						42.80582
					],
					[
						-72.456542,
						42.729142
					],
					[
						-73.267129,
						42.745573
					],
					[
						-73.278083,
						42.833204
					],
					[
						-73.245221,
						43.523299
					],
					[
						-73.404052,
						43.687607
					],
					[
						-73.349283,
						43.769761
					],
					[
						-73.436914,
						44.043608
					],
					[
						-73.321898,
						44.246255
					],
					[
						-73.294514,
						44.437948
					],
					[
						-73.387622,
						44.618687
					],
					[
						-73.332852,
						44.804903
					],
					[
						-73.343806,
						45.013027
					],
					[
						-72.308664,
						45.002073
					],
					[
						-71.503554,
						45.013027
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "51",
		id2: "VA",
		properties: {
			name: "Virginia"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-78.349729,
							39.464886
						],
						[
							-77.82942,
							39.130793
						],
						[
							-77.719881,
							39.322485
						],
						[
							-77.566527,
							39.306055
						],
						[
							-77.456988,
							39.223901
						],
						[
							-77.456988,
							39.076023
						],
						[
							-77.248864,
							39.026731
						],
						[
							-77.117418,
							38.933623
						],
						[
							-77.040741,
							38.791222
						],
						[
							-77.128372,
							38.632391
						],
						[
							-77.248864,
							38.588575
						],
						[
							-77.325542,
							38.446175
						],
						[
							-77.281726,
							38.342113
						],
						[
							-77.013356,
							38.374975
						],
						[
							-76.964064,
							38.216144
						],
						[
							-76.613539,
							38.15042
						],
						[
							-76.514954,
							38.024451
						],
						[
							-76.235631,
							37.887527
						],
						[
							-76.3616,
							37.608203
						],
						[
							-76.246584,
							37.389126
						],
						[
							-76.383508,
							37.285064
						],
						[
							-76.399939,
							37.159094
						],
						[
							-76.273969,
							37.082417
						],
						[
							-76.410893,
							36.961924
						],
						[
							-76.619016,
							37.120755
						],
						[
							-76.668309,
							37.065986
						],
						[
							-76.48757,
							36.95097
						],
						[
							-75.994645,
							36.923586
						],
						[
							-75.868676,
							36.551154
						],
						[
							-79.510841,
							36.5402
						],
						[
							-80.294043,
							36.545677
						],
						[
							-80.978661,
							36.562108
						],
						[
							-81.679709,
							36.589492
						],
						[
							-83.673316,
							36.600446
						],
						[
							-83.136575,
							36.742847
						],
						[
							-83.070852,
							36.852385
						],
						[
							-82.879159,
							36.890724
						],
						[
							-82.868205,
							36.978355
						],
						[
							-82.720328,
							37.044078
						],
						[
							-82.720328,
							37.120755
						],
						[
							-82.353373,
							37.268633
						],
						[
							-81.969987,
							37.537003
						],
						[
							-81.986418,
							37.454849
						],
						[
							-81.849494,
							37.285064
						],
						[
							-81.679709,
							37.20291
						],
						[
							-81.55374,
							37.208387
						],
						[
							-81.362047,
							37.339833
						],
						[
							-81.225123,
							37.235771
						],
						[
							-80.967707,
							37.290541
						],
						[
							-80.513121,
							37.482234
						],
						[
							-80.474782,
							37.421987
						],
						[
							-80.29952,
							37.509618
						],
						[
							-80.294043,
							37.690357
						],
						[
							-80.184505,
							37.849189
						],
						[
							-79.998289,
							37.997066
						],
						[
							-79.921611,
							38.177805
						],
						[
							-79.724442,
							38.364021
						],
						[
							-79.647764,
							38.594052
						],
						[
							-79.477979,
							38.457129
						],
						[
							-79.313671,
							38.413313
						],
						[
							-79.209609,
							38.495467
						],
						[
							-78.996008,
							38.851469
						],
						[
							-78.870039,
							38.763838
						],
						[
							-78.404499,
							39.169131
						],
						[
							-78.349729,
							39.464886
						]
					]
				],
				[
					[
						[
							-75.397659,
							38.013497
						],
						[
							-75.244304,
							38.029928
						],
						[
							-75.375751,
							37.860142
						],
						[
							-75.512674,
							37.799896
						],
						[
							-75.594828,
							37.569865
						],
						[
							-75.802952,
							37.197433
						],
						[
							-75.972737,
							37.120755
						],
						[
							-76.027507,
							37.257679
						],
						[
							-75.939876,
							37.564388
						],
						[
							-75.671506,
							37.95325
						],
						[
							-75.397659,
							38.013497
						]
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "53",
		id2: "WA",
		properties: {
			name: "Washington"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-117.033359,
							49.000239
						],
						[
							-117.044313,
							47.762451
						],
						[
							-117.038836,
							46.426077
						],
						[
							-117.055267,
							46.343923
						],
						[
							-116.92382,
							46.168661
						],
						[
							-116.918344,
							45.993399
						],
						[
							-118.988627,
							45.998876
						],
						[
							-119.125551,
							45.933153
						],
						[
							-119.525367,
							45.911245
						],
						[
							-119.963522,
							45.823614
						],
						[
							-120.209985,
							45.725029
						],
						[
							-120.505739,
							45.697644
						],
						[
							-120.637186,
							45.746937
						],
						[
							-121.18488,
							45.604536
						],
						[
							-121.217742,
							45.670259
						],
						[
							-121.535404,
							45.725029
						],
						[
							-121.809251,
							45.708598
						],
						[
							-122.247407,
							45.549767
						],
						[
							-122.762239,
							45.659305
						],
						[
							-122.811531,
							45.960537
						],
						[
							-122.904639,
							46.08103
						],
						[
							-123.11824,
							46.185092
						],
						[
							-123.211348,
							46.174138
						],
						[
							-123.370179,
							46.146753
						],
						[
							-123.545441,
							46.261769
						],
						[
							-123.72618,
							46.300108
						],
						[
							-123.874058,
							46.239861
						],
						[
							-124.065751,
							46.327492
						],
						[
							-124.027412,
							46.464416
						],
						[
							-123.895966,
							46.535616
						],
						[
							-124.098612,
							46.74374
						],
						[
							-124.235536,
							47.285957
						],
						[
							-124.31769,
							47.357157
						],
						[
							-124.427229,
							47.740543
						],
						[
							-124.624399,
							47.88842
						],
						[
							-124.706553,
							48.184175
						],
						[
							-124.597014,
							48.381345
						],
						[
							-124.394367,
							48.288237
						],
						[
							-123.983597,
							48.162267
						],
						[
							-123.704273,
							48.167744
						],
						[
							-123.424949,
							48.118452
						],
						[
							-123.162056,
							48.167744
						],
						[
							-123.036086,
							48.080113
						],
						[
							-122.800578,
							48.08559
						],
						[
							-122.636269,
							47.866512
						],
						[
							-122.515777,
							47.882943
						],
						[
							-122.493869,
							47.587189
						],
						[
							-122.422669,
							47.318818
						],
						[
							-122.324084,
							47.346203
						],
						[
							-122.422669,
							47.576235
						],
						[
							-122.395284,
							47.800789
						],
						[
							-122.230976,
							48.030821
						],
						[
							-122.362422,
							48.123929
						],
						[
							-122.373376,
							48.288237
						],
						[
							-122.471961,
							48.468976
						],
						[
							-122.422669,
							48.600422
						],
						[
							-122.488392,
							48.753777
						],
						[
							-122.647223,
							48.775685
						],
						[
							-122.795101,
							48.8907
						],
						[
							-122.756762,
							49.000239
						],
						[
							-117.033359,
							49.000239
						]
					]
				],
				[
					[
						[
							-122.718423,
							48.310145
						],
						[
							-122.586977,
							48.35396
						],
						[
							-122.608885,
							48.151313
						],
						[
							-122.767716,
							48.227991
						],
						[
							-122.718423,
							48.310145
						]
					]
				],
				[
					[
						[
							-123.025132,
							48.583992
						],
						[
							-122.915593,
							48.715438
						],
						[
							-122.767716,
							48.556607
						],
						[
							-122.811531,
							48.419683
						],
						[
							-123.041563,
							48.458022
						],
						[
							-123.025132,
							48.583992
						]
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "54",
		id2: "WV",
		properties: {
			name: "West Virginia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-80.518598,
						40.636951
					],
					[
						-80.518598,
						39.722302
					],
					[
						-79.477979,
						39.722302
					],
					[
						-79.488933,
						39.20747
					],
					[
						-79.291763,
						39.300578
					],
					[
						-79.094593,
						39.470363
					],
					[
						-78.963147,
						39.437501
					],
					[
						-78.765977,
						39.585379
					],
					[
						-78.470222,
						39.514178
					],
					[
						-78.431884,
						39.623717
					],
					[
						-78.267575,
						39.61824
					],
					[
						-78.174467,
						39.694917
					],
					[
						-78.004682,
						39.601809
					],
					[
						-77.834897,
						39.601809
					],
					[
						-77.719881,
						39.322485
					],
					[
						-77.82942,
						39.130793
					],
					[
						-78.349729,
						39.464886
					],
					[
						-78.404499,
						39.169131
					],
					[
						-78.870039,
						38.763838
					],
					[
						-78.996008,
						38.851469
					],
					[
						-79.209609,
						38.495467
					],
					[
						-79.313671,
						38.413313
					],
					[
						-79.477979,
						38.457129
					],
					[
						-79.647764,
						38.594052
					],
					[
						-79.724442,
						38.364021
					],
					[
						-79.921611,
						38.177805
					],
					[
						-79.998289,
						37.997066
					],
					[
						-80.184505,
						37.849189
					],
					[
						-80.294043,
						37.690357
					],
					[
						-80.29952,
						37.509618
					],
					[
						-80.474782,
						37.421987
					],
					[
						-80.513121,
						37.482234
					],
					[
						-80.967707,
						37.290541
					],
					[
						-81.225123,
						37.235771
					],
					[
						-81.362047,
						37.339833
					],
					[
						-81.55374,
						37.208387
					],
					[
						-81.679709,
						37.20291
					],
					[
						-81.849494,
						37.285064
					],
					[
						-81.986418,
						37.454849
					],
					[
						-81.969987,
						37.537003
					],
					[
						-82.101434,
						37.553434
					],
					[
						-82.293127,
						37.668449
					],
					[
						-82.342419,
						37.783465
					],
					[
						-82.50125,
						37.931343
					],
					[
						-82.621743,
						38.123036
					],
					[
						-82.594358,
						38.424267
					],
					[
						-82.331465,
						38.446175
					],
					[
						-82.293127,
						38.577622
					],
					[
						-82.172634,
						38.632391
					],
					[
						-82.221926,
						38.785745
					],
					[
						-82.03571,
						39.026731
					],
					[
						-81.887833,
						38.873376
					],
					[
						-81.783771,
						38.966484
					],
					[
						-81.811156,
						39.0815
					],
					[
						-81.685186,
						39.273193
					],
					[
						-81.57017,
						39.267716
					],
					[
						-81.455155,
						39.410117
					],
					[
						-81.345616,
						39.344393
					],
					[
						-81.219646,
						39.388209
					],
					[
						-80.830783,
						39.711348
					],
					[
						-80.737675,
						40.078303
					],
					[
						-80.600752,
						40.319289
					],
					[
						-80.595275,
						40.472643
					],
					[
						-80.666475,
						40.582182
					],
					[
						-80.518598,
						40.636951
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "55",
		id2: "WI",
		properties: {
			name: "Wisconsin"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-90.415429,
						46.568478
					],
					[
						-90.229213,
						46.508231
					],
					[
						-90.119674,
						46.338446
					],
					[
						-89.09001,
						46.135799
					],
					[
						-88.662808,
						45.987922
					],
					[
						-88.531362,
						46.020784
					],
					[
						-88.10416,
						45.922199
					],
					[
						-87.989145,
						45.796229
					],
					[
						-87.781021,
						45.675736
					],
					[
						-87.791975,
						45.500474
					],
					[
						-87.885083,
						45.363551
					],
					[
						-87.649574,
						45.341643
					],
					[
						-87.742682,
						45.199243
					],
					[
						-87.589328,
						45.095181
					],
					[
						-87.627666,
						44.974688
					],
					[
						-87.819359,
						44.95278
					],
					[
						-87.983668,
						44.722749
					],
					[
						-88.043914,
						44.563917
					],
					[
						-87.928898,
						44.536533
					],
					[
						-87.775544,
						44.640595
					],
					[
						-87.611236,
						44.837764
					],
					[
						-87.403112,
						44.914442
					],
					[
						-87.238804,
						45.166381
					],
					[
						-87.03068,
						45.22115
					],
					[
						-87.047111,
						45.089704
					],
					[
						-87.189511,
						44.969211
					],
					[
						-87.468835,
						44.552964
					],
					[
						-87.545512,
						44.322932
					],
					[
						-87.540035,
						44.158624
					],
					[
						-87.644097,
						44.103854
					],
					[
						-87.737205,
						43.8793
					],
					[
						-87.704344,
						43.687607
					],
					[
						-87.791975,
						43.561637
					],
					[
						-87.912467,
						43.249452
					],
					[
						-87.885083,
						43.002989
					],
					[
						-87.76459,
						42.783912
					],
					[
						-87.802929,
						42.493634
					],
					[
						-88.788778,
						42.493634
					],
					[
						-90.639984,
						42.510065
					],
					[
						-90.711184,
						42.636034
					],
					[
						-91.067185,
						42.75105
					],
					[
						-91.143862,
						42.909881
					],
					[
						-91.176724,
						43.134436
					],
					[
						-91.056231,
						43.254929
					],
					[
						-91.204109,
						43.353514
					],
					[
						-91.215062,
						43.501391
					],
					[
						-91.269832,
						43.616407
					],
					[
						-91.242447,
						43.775238
					],
					[
						-91.43414,
						43.994316
					],
					[
						-91.592971,
						44.032654
					],
					[
						-91.877772,
						44.202439
					],
					[
						-91.927065,
						44.333886
					],
					[
						-92.233773,
						44.443425
					],
					[
						-92.337835,
						44.552964
					],
					[
						-92.545959,
						44.569394
					],
					[
						-92.808852,
						44.750133
					],
					[
						-92.737652,
						45.117088
					],
					[
						-92.75956,
						45.286874
					],
					[
						-92.644544,
						45.440228
					],
					[
						-92.770513,
						45.566198
					],
					[
						-92.885529,
						45.577151
					],
					[
						-92.869098,
						45.719552
					],
					[
						-92.639067,
						45.933153
					],
					[
						-92.354266,
						46.015307
					],
					[
						-92.29402,
						46.075553
					],
					[
						-92.29402,
						46.667063
					],
					[
						-92.091373,
						46.749217
					],
					[
						-92.014696,
						46.705401
					],
					[
						-91.790141,
						46.694447
					],
					[
						-91.09457,
						46.864232
					],
					[
						-90.837154,
						46.95734
					],
					[
						-90.749522,
						46.88614
					],
					[
						-90.886446,
						46.754694
					],
					[
						-90.55783,
						46.584908
					],
					[
						-90.415429,
						46.568478
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "56",
		id2: "WY",
		properties: {
			name: "Wyoming"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-109.080842,
						45.002073
					],
					[
						-105.91517,
						45.002073
					],
					[
						-104.058488,
						44.996596
					],
					[
						-104.053011,
						43.002989
					],
					[
						-104.053011,
						41.003906
					],
					[
						-105.728954,
						40.998429
					],
					[
						-107.919731,
						41.003906
					],
					[
						-109.04798,
						40.998429
					],
					[
						-111.047063,
						40.998429
					],
					[
						-111.047063,
						42.000709
					],
					[
						-111.047063,
						44.476286
					],
					[
						-111.05254,
						45.002073
					],
					[
						-109.080842,
						45.002073
					]
				]
			]
		}
	},
	{
		type: "Feature",
		id: "72",
		id2: "PR",
		properties: {
			name: "Puerto Rico"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-66.448338,
						17.984326
					],
					[
						-66.771478,
						18.006234
					],
					[
						-66.924832,
						17.929556
					],
					[
						-66.985078,
						17.973372
					],
					[
						-67.209633,
						17.956941
					],
					[
						-67.154863,
						18.19245
					],
					[
						-67.269879,
						18.362235
					],
					[
						-67.094617,
						18.515589
					],
					[
						-66.957694,
						18.488204
					],
					[
						-66.409999,
						18.488204
					],
					[
						-65.840398,
						18.433435
					],
					[
						-65.632274,
						18.367712
					],
					[
						-65.626797,
						18.203403
					],
					[
						-65.730859,
						18.186973
					],
					[
						-65.834921,
						18.017187
					],
					[
						-66.234737,
						17.929556
					],
					[
						-66.448338,
						17.984326
					]
				]
			]
		}
	}
];
var us = {
	type: type,
	features: features
};

var type$1 = "FeatureCollection";
var features$1 = [
	{
		type: "Feature",
		properties: {
			name: "Afghanistan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						61.210817,
						35.650072
					],
					[
						62.230651,
						35.270664
					],
					[
						62.984662,
						35.404041
					],
					[
						63.193538,
						35.857166
					],
					[
						63.982896,
						36.007957
					],
					[
						64.546479,
						36.312073
					],
					[
						64.746105,
						37.111818
					],
					[
						65.588948,
						37.305217
					],
					[
						65.745631,
						37.661164
					],
					[
						66.217385,
						37.39379
					],
					[
						66.518607,
						37.362784
					],
					[
						67.075782,
						37.356144
					],
					[
						67.83,
						37.144994
					],
					[
						68.135562,
						37.023115
					],
					[
						68.859446,
						37.344336
					],
					[
						69.196273,
						37.151144
					],
					[
						69.518785,
						37.608997
					],
					[
						70.116578,
						37.588223
					],
					[
						70.270574,
						37.735165
					],
					[
						70.376304,
						38.138396
					],
					[
						70.806821,
						38.486282
					],
					[
						71.348131,
						38.258905
					],
					[
						71.239404,
						37.953265
					],
					[
						71.541918,
						37.905774
					],
					[
						71.448693,
						37.065645
					],
					[
						71.844638,
						36.738171
					],
					[
						72.193041,
						36.948288
					],
					[
						72.63689,
						37.047558
					],
					[
						73.260056,
						37.495257
					],
					[
						73.948696,
						37.421566
					],
					[
						74.980002,
						37.41999
					],
					[
						75.158028,
						37.133031
					],
					[
						74.575893,
						37.020841
					],
					[
						74.067552,
						36.836176
					],
					[
						72.920025,
						36.720007
					],
					[
						71.846292,
						36.509942
					],
					[
						71.262348,
						36.074388
					],
					[
						71.498768,
						35.650563
					],
					[
						71.613076,
						35.153203
					],
					[
						71.115019,
						34.733126
					],
					[
						71.156773,
						34.348911
					],
					[
						70.881803,
						33.988856
					],
					[
						69.930543,
						34.02012
					],
					[
						70.323594,
						33.358533
					],
					[
						69.687147,
						33.105499
					],
					[
						69.262522,
						32.501944
					],
					[
						69.317764,
						31.901412
					],
					[
						68.926677,
						31.620189
					],
					[
						68.556932,
						31.71331
					],
					[
						67.792689,
						31.58293
					],
					[
						67.683394,
						31.303154
					],
					[
						66.938891,
						31.304911
					],
					[
						66.381458,
						30.738899
					],
					[
						66.346473,
						29.887943
					],
					[
						65.046862,
						29.472181
					],
					[
						64.350419,
						29.560031
					],
					[
						64.148002,
						29.340819
					],
					[
						63.550261,
						29.468331
					],
					[
						62.549857,
						29.318572
					],
					[
						60.874248,
						29.829239
					],
					[
						61.781222,
						30.73585
					],
					[
						61.699314,
						31.379506
					],
					[
						60.941945,
						31.548075
					],
					[
						60.863655,
						32.18292
					],
					[
						60.536078,
						32.981269
					],
					[
						60.9637,
						33.528832
					],
					[
						60.52843,
						33.676446
					],
					[
						60.803193,
						34.404102
					],
					[
						61.210817,
						35.650072
					]
				]
			]
		},
		id: "AFG",
		id2: "AF",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Albania"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						20.590247,
						41.855404
					],
					[
						20.463175,
						41.515089
					],
					[
						20.605182,
						41.086226
					],
					[
						21.02004,
						40.842727
					],
					[
						20.99999,
						40.580004
					],
					[
						20.674997,
						40.435
					],
					[
						20.615,
						40.110007
					],
					[
						20.150016,
						39.624998
					],
					[
						19.98,
						39.694993
					],
					[
						19.960002,
						39.915006
					],
					[
						19.406082,
						40.250773
					],
					[
						19.319059,
						40.72723
					],
					[
						19.40355,
						41.409566
					],
					[
						19.540027,
						41.719986
					],
					[
						19.371769,
						41.877548
					],
					[
						19.304486,
						42.195745
					],
					[
						19.738051,
						42.688247
					],
					[
						19.801613,
						42.500093
					],
					[
						20.0707,
						42.58863
					],
					[
						20.283755,
						42.32026
					],
					[
						20.52295,
						42.21787
					],
					[
						20.590247,
						41.855404
					]
				]
			]
		},
		id: "ALB",
		id2: "AL",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Algeria"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						11.999506,
						23.471668
					],
					[
						8.572893,
						21.565661
					],
					[
						5.677566,
						19.601207
					],
					[
						4.267419,
						19.155265
					],
					[
						3.158133,
						19.057364
					],
					[
						3.146661,
						19.693579
					],
					[
						2.683588,
						19.85623
					],
					[
						2.060991,
						20.142233
					],
					[
						1.823228,
						20.610809
					],
					[
						-1.550055,
						22.792666
					],
					[
						-4.923337,
						24.974574
					],
					[
						-8.6844,
						27.395744
					],
					[
						-8.665124,
						27.589479
					],
					[
						-8.66559,
						27.656426
					],
					[
						-8.674116,
						28.841289
					],
					[
						-7.059228,
						29.579228
					],
					[
						-6.060632,
						29.7317
					],
					[
						-5.242129,
						30.000443
					],
					[
						-4.859646,
						30.501188
					],
					[
						-3.690441,
						30.896952
					],
					[
						-3.647498,
						31.637294
					],
					[
						-3.06898,
						31.724498
					],
					[
						-2.616605,
						32.094346
					],
					[
						-1.307899,
						32.262889
					],
					[
						-1.124551,
						32.651522
					],
					[
						-1.388049,
						32.864015
					],
					[
						-1.733455,
						33.919713
					],
					[
						-1.792986,
						34.527919
					],
					[
						-2.169914,
						35.168396
					],
					[
						-1.208603,
						35.714849
					],
					[
						-0.127454,
						35.888662
					],
					[
						0.503877,
						36.301273
					],
					[
						1.466919,
						36.605647
					],
					[
						3.161699,
						36.783905
					],
					[
						4.815758,
						36.865037
					],
					[
						5.32012,
						36.716519
					],
					[
						6.26182,
						37.110655
					],
					[
						7.330385,
						37.118381
					],
					[
						7.737078,
						36.885708
					],
					[
						8.420964,
						36.946427
					],
					[
						8.217824,
						36.433177
					],
					[
						8.376368,
						35.479876
					],
					[
						8.140981,
						34.655146
					],
					[
						7.524482,
						34.097376
					],
					[
						7.612642,
						33.344115
					],
					[
						8.430473,
						32.748337
					],
					[
						8.439103,
						32.506285
					],
					[
						9.055603,
						32.102692
					],
					[
						9.48214,
						30.307556
					],
					[
						9.805634,
						29.424638
					],
					[
						9.859998,
						28.95999
					],
					[
						9.683885,
						28.144174
					],
					[
						9.756128,
						27.688259
					],
					[
						9.629056,
						27.140953
					],
					[
						9.716286,
						26.512206
					],
					[
						9.319411,
						26.094325
					],
					[
						9.910693,
						25.365455
					],
					[
						9.948261,
						24.936954
					],
					[
						10.303847,
						24.379313
					],
					[
						10.771364,
						24.562532
					],
					[
						11.560669,
						24.097909
					],
					[
						11.999506,
						23.471668
					]
				]
			]
		},
		id: "DZA",
		id2: "DZ",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "American Samoa"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-170.64,
							-14.29
						],
						[
							-170.83,
							-14.33
						],
						[
							-170.56,
							-14.27
						],
						[
							-170.64,
							-14.29
						]
					]
				],
				[
					[
						[
							-169.44,
							-14.26
						],
						[
							-169.51,
							-14.28
						],
						[
							-169.54,
							-14.23
						],
						[
							-169.44,
							-14.26
						]
					]
				]
			]
		},
		id: "ASM",
		id2: "AS",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							1.78,
							42.57
						],
						[
							1.72,
							42.51
						],
						[
							1.45,
							42.6
						],
						[
							1.78,
							42.57
						]
					]
				]
			]
		},
		properties: {
			name: "Andorra"
		},
		id2: "AD",
		id: "AND",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Angola"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							16.326528,
							-5.87747
						],
						[
							16.57318,
							-6.622645
						],
						[
							16.860191,
							-7.222298
						],
						[
							17.089996,
							-7.545689
						],
						[
							17.47297,
							-8.068551
						],
						[
							18.134222,
							-7.987678
						],
						[
							18.464176,
							-7.847014
						],
						[
							19.016752,
							-7.988246
						],
						[
							19.166613,
							-7.738184
						],
						[
							19.417502,
							-7.155429
						],
						[
							20.037723,
							-7.116361
						],
						[
							20.091622,
							-6.94309
						],
						[
							20.601823,
							-6.939318
						],
						[
							20.514748,
							-7.299606
						],
						[
							21.728111,
							-7.290872
						],
						[
							21.746456,
							-7.920085
						],
						[
							21.949131,
							-8.305901
						],
						[
							21.801801,
							-8.908707
						],
						[
							21.875182,
							-9.523708
						],
						[
							22.208753,
							-9.894796
						],
						[
							22.155268,
							-11.084801
						],
						[
							22.402798,
							-10.993075
						],
						[
							22.837345,
							-11.017622
						],
						[
							23.456791,
							-10.867863
						],
						[
							23.912215,
							-10.926826
						],
						[
							24.017894,
							-11.237298
						],
						[
							23.904154,
							-11.722282
						],
						[
							24.079905,
							-12.191297
						],
						[
							23.930922,
							-12.565848
						],
						[
							24.016137,
							-12.911046
						],
						[
							21.933886,
							-12.898437
						],
						[
							21.887843,
							-16.08031
						],
						[
							22.562478,
							-16.898451
						],
						[
							23.215048,
							-17.523116
						],
						[
							21.377176,
							-17.930636
						],
						[
							18.956187,
							-17.789095
						],
						[
							18.263309,
							-17.309951
						],
						[
							14.209707,
							-17.353101
						],
						[
							14.058501,
							-17.423381
						],
						[
							13.462362,
							-16.971212
						],
						[
							12.814081,
							-16.941343
						],
						[
							12.215461,
							-17.111668
						],
						[
							11.734199,
							-17.301889
						],
						[
							11.640096,
							-16.673142
						],
						[
							11.778537,
							-15.793816
						],
						[
							12.123581,
							-14.878316
						],
						[
							12.175619,
							-14.449144
						],
						[
							12.500095,
							-13.5477
						],
						[
							12.738479,
							-13.137906
						],
						[
							13.312914,
							-12.48363
						],
						[
							13.633721,
							-12.038645
						],
						[
							13.738728,
							-11.297863
						],
						[
							13.686379,
							-10.731076
						],
						[
							13.387328,
							-10.373578
						],
						[
							13.120988,
							-9.766897
						],
						[
							12.87537,
							-9.166934
						],
						[
							12.929061,
							-8.959091
						],
						[
							13.236433,
							-8.562629
						],
						[
							12.93304,
							-7.596539
						],
						[
							12.728298,
							-6.927122
						],
						[
							12.227347,
							-6.294448
						],
						[
							12.322432,
							-6.100092
						],
						[
							12.735171,
							-5.965682
						],
						[
							13.024869,
							-5.984389
						],
						[
							13.375597,
							-5.864241
						],
						[
							16.326528,
							-5.87747
						]
					]
				],
				[
					[
						[
							12.436688,
							-5.684304
						],
						[
							12.182337,
							-5.789931
						],
						[
							11.914963,
							-5.037987
						],
						[
							12.318608,
							-4.60623
						],
						[
							12.62076,
							-4.438023
						],
						[
							12.995517,
							-4.781103
						],
						[
							12.631612,
							-4.991271
						],
						[
							12.468004,
							-5.248362
						],
						[
							12.436688,
							-5.684304
						]
					]
				]
			]
		},
		id: "AGO",
		id2: "AO",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Anguilla"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-62.9,
						17.9
					],
					[
						-63.1,
						17.9
					],
					[
						-63.1,
						18.1
					],
					[
						-62.9,
						18.1
					],
					[
						-62.9,
						17.9
					]
				]
			]
		},
		id: "AIA",
		id2: "AI",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Antarctica"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-59.572095,
							-80.040179
						],
						[
							-59.865849,
							-80.549657
						],
						[
							-60.159656,
							-81.000327
						],
						[
							-62.255393,
							-80.863178
						],
						[
							-64.488125,
							-80.921934
						],
						[
							-65.741666,
							-80.588827
						],
						[
							-65.741666,
							-80.549657
						],
						[
							-66.290031,
							-80.255773
						],
						[
							-64.037688,
							-80.294944
						],
						[
							-61.883246,
							-80.39287
						],
						[
							-61.138976,
							-79.981371
						],
						[
							-60.610119,
							-79.628679
						],
						[
							-59.572095,
							-80.040179
						]
					]
				],
				[
					[
						[
							-159.208184,
							-79.497059
						],
						[
							-161.127601,
							-79.634209
						],
						[
							-162.439847,
							-79.281465
						],
						[
							-163.027408,
							-78.928774
						],
						[
							-163.066604,
							-78.869966
						],
						[
							-163.712896,
							-78.595667
						],
						[
							-163.712896,
							-78.595667
						],
						[
							-163.105801,
							-78.223338
						],
						[
							-161.245113,
							-78.380176
						],
						[
							-160.246208,
							-78.693645
						],
						[
							-159.482405,
							-79.046338
						],
						[
							-159.208184,
							-79.497059
						]
					]
				],
				[
					[
						[
							-45.154758,
							-78.04707
						],
						[
							-43.920828,
							-78.478103
						],
						[
							-43.48995,
							-79.08556
						],
						[
							-43.372438,
							-79.516645
						],
						[
							-43.333267,
							-80.026123
						],
						[
							-44.880537,
							-80.339644
						],
						[
							-46.506174,
							-80.594357
						],
						[
							-48.386421,
							-80.829485
						],
						[
							-50.482107,
							-81.025442
						],
						[
							-52.851988,
							-80.966685
						],
						[
							-54.164259,
							-80.633528
						],
						[
							-53.987991,
							-80.222028
						],
						[
							-51.853134,
							-79.94773
						],
						[
							-50.991326,
							-79.614623
						],
						[
							-50.364595,
							-79.183487
						],
						[
							-49.914131,
							-78.811209
						],
						[
							-49.306959,
							-78.458569
						],
						[
							-48.660616,
							-78.047018
						],
						[
							-48.660616,
							-78.047019
						],
						[
							-48.151396,
							-78.04707
						],
						[
							-46.662857,
							-77.831476
						],
						[
							-45.154758,
							-78.04707
						]
					]
				],
				[
					[
						[
							-121.211511,
							-73.50099
						],
						[
							-119.918851,
							-73.657725
						],
						[
							-118.724143,
							-73.481353
						],
						[
							-119.292119,
							-73.834097
						],
						[
							-120.232217,
							-74.08881
						],
						[
							-121.62283,
							-74.010468
						],
						[
							-122.621735,
							-73.657778
						],
						[
							-122.621735,
							-73.657777
						],
						[
							-122.406245,
							-73.324619
						],
						[
							-121.211511,
							-73.50099
						]
					]
				],
				[
					[
						[
							-125.559566,
							-73.481353
						],
						[
							-124.031882,
							-73.873268
						],
						[
							-124.619469,
							-73.834097
						],
						[
							-125.912181,
							-73.736118
						],
						[
							-127.28313,
							-73.461769
						],
						[
							-127.28313,
							-73.461768
						],
						[
							-126.558472,
							-73.246226
						],
						[
							-125.559566,
							-73.481353
						]
					]
				],
				[
					[
						[
							-98.98155,
							-71.933334
						],
						[
							-97.884743,
							-72.070535
						],
						[
							-96.787937,
							-71.952971
						],
						[
							-96.20035,
							-72.521205
						],
						[
							-96.983765,
							-72.442864
						],
						[
							-98.198083,
							-72.482035
						],
						[
							-99.432013,
							-72.442864
						],
						[
							-100.783455,
							-72.50162
						],
						[
							-101.801868,
							-72.305663
						],
						[
							-102.330725,
							-71.894164
						],
						[
							-102.330725,
							-71.894164
						],
						[
							-101.703967,
							-71.717792
						],
						[
							-100.430919,
							-71.854993
						],
						[
							-98.98155,
							-71.933334
						]
					]
				],
				[
					[
						[
							-68.451346,
							-70.955823
						],
						[
							-68.333834,
							-71.406493
						],
						[
							-68.510128,
							-71.798407
						],
						[
							-68.784297,
							-72.170736
						],
						[
							-69.959471,
							-72.307885
						],
						[
							-71.075889,
							-72.503842
						],
						[
							-72.388134,
							-72.484257
						],
						[
							-71.8985,
							-72.092343
						],
						[
							-73.073622,
							-72.229492
						],
						[
							-74.19004,
							-72.366693
						],
						[
							-74.953895,
							-72.072757
						],
						[
							-75.012625,
							-71.661258
						],
						[
							-73.915819,
							-71.269345
						],
						[
							-73.915819,
							-71.269344
						],
						[
							-73.230331,
							-71.15178
						],
						[
							-72.074717,
							-71.190951
						],
						[
							-71.780962,
							-70.681473
						],
						[
							-71.72218,
							-70.309196
						],
						[
							-71.741791,
							-69.505782
						],
						[
							-71.173815,
							-69.035475
						],
						[
							-70.253252,
							-68.87874
						],
						[
							-69.724447,
							-69.251017
						],
						[
							-69.489422,
							-69.623346
						],
						[
							-69.058518,
							-70.074016
						],
						[
							-68.725541,
							-70.505153
						],
						[
							-68.451346,
							-70.955823
						]
					]
				],
				[
					[
						[
							-58.614143,
							-64.152467
						],
						[
							-59.045073,
							-64.36801
						],
						[
							-59.789342,
							-64.211223
						],
						[
							-60.611928,
							-64.309202
						],
						[
							-61.297416,
							-64.54433
						],
						[
							-62.0221,
							-64.799094
						],
						[
							-62.51176,
							-65.09303
						],
						[
							-62.648858,
							-65.484942
						],
						[
							-62.590128,
							-65.857219
						],
						[
							-62.120079,
							-66.190326
						],
						[
							-62.805567,
							-66.425505
						],
						[
							-63.74569,
							-66.503847
						],
						[
							-64.294106,
							-66.837004
						],
						[
							-64.881693,
							-67.150474
						],
						[
							-65.508425,
							-67.58161
						],
						[
							-65.665082,
							-67.953887
						],
						[
							-65.312545,
							-68.365335
						],
						[
							-64.783715,
							-68.678908
						],
						[
							-63.961103,
							-68.913984
						],
						[
							-63.1973,
							-69.227556
						],
						[
							-62.785955,
							-69.619419
						],
						[
							-62.570516,
							-69.991747
						],
						[
							-62.276736,
							-70.383661
						],
						[
							-61.806661,
							-70.716768
						],
						[
							-61.512906,
							-71.089045
						],
						[
							-61.375809,
							-72.010074
						],
						[
							-61.081977,
							-72.382351
						],
						[
							-61.003661,
							-72.774265
						],
						[
							-60.690269,
							-73.166179
						],
						[
							-60.827367,
							-73.695242
						],
						[
							-61.375809,
							-74.106742
						],
						[
							-61.96337,
							-74.439848
						],
						[
							-63.295201,
							-74.576997
						],
						[
							-63.74569,
							-74.92974
						],
						[
							-64.352836,
							-75.262847
						],
						[
							-65.860987,
							-75.635124
						],
						[
							-67.192818,
							-75.79191
						],
						[
							-68.446282,
							-76.007452
						],
						[
							-69.797724,
							-76.222995
						],
						[
							-70.600724,
							-76.634494
						],
						[
							-72.206776,
							-76.673665
						],
						[
							-73.969536,
							-76.634494
						],
						[
							-75.555977,
							-76.712887
						],
						[
							-77.24037,
							-76.712887
						],
						[
							-76.926979,
							-77.104802
						],
						[
							-75.399294,
							-77.28107
						],
						[
							-74.282876,
							-77.55542
						],
						[
							-73.656119,
							-77.908112
						],
						[
							-74.772536,
							-78.221633
						],
						[
							-76.4961,
							-78.123654
						],
						[
							-77.925858,
							-78.378419
						],
						[
							-77.984666,
							-78.789918
						],
						[
							-78.023785,
							-79.181833
						],
						[
							-76.848637,
							-79.514939
						],
						[
							-76.633224,
							-79.887216
						],
						[
							-75.360097,
							-80.259545
						],
						[
							-73.244852,
							-80.416331
						],
						[
							-71.442946,
							-80.69063
						],
						[
							-70.013163,
							-81.004151
						],
						[
							-68.191646,
							-81.317672
						],
						[
							-65.704279,
							-81.474458
						],
						[
							-63.25603,
							-81.748757
						],
						[
							-61.552026,
							-82.042692
						],
						[
							-59.691416,
							-82.37585
						],
						[
							-58.712121,
							-82.846106
						],
						[
							-58.222487,
							-83.218434
						],
						[
							-57.008117,
							-82.865691
						],
						[
							-55.362894,
							-82.571755
						],
						[
							-53.619771,
							-82.258235
						],
						[
							-51.543644,
							-82.003521
						],
						[
							-49.76135,
							-81.729171
						],
						[
							-47.273931,
							-81.709586
						],
						[
							-44.825708,
							-81.846735
						],
						[
							-42.808363,
							-82.081915
						],
						[
							-42.16202,
							-81.65083
						],
						[
							-40.771433,
							-81.356894
						],
						[
							-38.244818,
							-81.337309
						],
						[
							-36.26667,
							-81.121715
						],
						[
							-34.386397,
							-80.906172
						],
						[
							-32.310296,
							-80.769023
						],
						[
							-30.097098,
							-80.592651
						],
						[
							-28.549802,
							-80.337938
						],
						[
							-29.254901,
							-79.985195
						],
						[
							-29.685805,
							-79.632503
						],
						[
							-29.685805,
							-79.260226
						],
						[
							-31.624808,
							-79.299397
						],
						[
							-33.681324,
							-79.456132
						],
						[
							-35.639912,
							-79.456132
						],
						[
							-35.914107,
							-79.083855
						],
						[
							-35.77701,
							-78.339248
						],
						[
							-35.326546,
							-78.123654
						],
						[
							-33.896763,
							-77.888526
						],
						[
							-32.212369,
							-77.65345
						],
						[
							-30.998051,
							-77.359515
						],
						[
							-29.783732,
							-77.065579
						],
						[
							-28.882779,
							-76.673665
						],
						[
							-27.511752,
							-76.497345
						],
						[
							-26.160336,
							-76.360144
						],
						[
							-25.474822,
							-76.281803
						],
						[
							-23.927552,
							-76.24258
						],
						[
							-22.458598,
							-76.105431
						],
						[
							-21.224694,
							-75.909474
						],
						[
							-20.010375,
							-75.674346
						],
						[
							-18.913543,
							-75.439218
						],
						[
							-17.522982,
							-75.125698
						],
						[
							-16.641589,
							-74.79254
						],
						[
							-15.701491,
							-74.498604
						],
						[
							-15.40771,
							-74.106742
						],
						[
							-16.46532,
							-73.871614
						],
						[
							-16.112784,
							-73.460114
						],
						[
							-15.446855,
							-73.146542
						],
						[
							-14.408805,
							-72.950585
						],
						[
							-13.311973,
							-72.715457
						],
						[
							-12.293508,
							-72.401936
						],
						[
							-11.510067,
							-72.010074
						],
						[
							-11.020433,
							-71.539767
						],
						[
							-10.295774,
							-71.265416
						],
						[
							-9.101015,
							-71.324224
						],
						[
							-8.611381,
							-71.65733
						],
						[
							-7.416622,
							-71.696501
						],
						[
							-7.377451,
							-71.324224
						],
						[
							-6.868232,
							-70.93231
						],
						[
							-5.790985,
							-71.030289
						],
						[
							-5.536375,
							-71.402617
						],
						[
							-4.341667,
							-71.461373
						],
						[
							-3.048981,
							-71.285053
						],
						[
							-1.795492,
							-71.167438
						],
						[
							-0.659489,
							-71.226246
						],
						[
							-0.228637,
							-71.637745
						],
						[
							0.868195,
							-71.304639
						],
						[
							1.886686,
							-71.128267
						],
						[
							3.022638,
							-70.991118
						],
						[
							4.139055,
							-70.853917
						],
						[
							5.157546,
							-70.618789
						],
						[
							6.273912,
							-70.462055
						],
						[
							7.13572,
							-70.246512
						],
						[
							7.742866,
							-69.893769
						],
						[
							8.48711,
							-70.148534
						],
						[
							9.525135,
							-70.011333
						],
						[
							10.249845,
							-70.48164
						],
						[
							10.817821,
							-70.834332
						],
						[
							11.953824,
							-70.638375
						],
						[
							12.404287,
							-70.246512
						],
						[
							13.422778,
							-69.972162
						],
						[
							14.734998,
							-70.030918
						],
						[
							15.126757,
							-70.403247
						],
						[
							15.949342,
							-70.030918
						],
						[
							17.026589,
							-69.913354
						],
						[
							18.201711,
							-69.874183
						],
						[
							19.259373,
							-69.893769
						],
						[
							20.375739,
							-70.011333
						],
						[
							21.452985,
							-70.07014
						],
						[
							21.923034,
							-70.403247
						],
						[
							22.569403,
							-70.697182
						],
						[
							23.666184,
							-70.520811
						],
						[
							24.841357,
							-70.48164
						],
						[
							25.977309,
							-70.48164
						],
						[
							27.093726,
							-70.462055
						],
						[
							28.09258,
							-70.324854
						],
						[
							29.150242,
							-70.20729
						],
						[
							30.031583,
							-69.93294
						],
						[
							30.971733,
							-69.75662
						],
						[
							31.990172,
							-69.658641
						],
						[
							32.754053,
							-69.384291
						],
						[
							33.302443,
							-68.835642
						],
						[
							33.870419,
							-68.502588
						],
						[
							34.908495,
							-68.659271
						],
						[
							35.300202,
							-69.012014
						],
						[
							36.16201,
							-69.247142
						],
						[
							37.200035,
							-69.168748
						],
						[
							37.905108,
							-69.52144
						],
						[
							38.649404,
							-69.776205
						],
						[
							39.667894,
							-69.541077
						],
						[
							40.020431,
							-69.109941
						],
						[
							40.921358,
							-68.933621
						],
						[
							41.959434,
							-68.600514
						],
						[
							42.938702,
							-68.463313
						],
						[
							44.113876,
							-68.267408
						],
						[
							44.897291,
							-68.051866
						],
						[
							45.719928,
							-67.816738
						],
						[
							46.503343,
							-67.601196
						],
						[
							47.44344,
							-67.718759
						],
						[
							48.344419,
							-67.366068
						],
						[
							48.990736,
							-67.091718
						],
						[
							49.930885,
							-67.111303
						],
						[
							50.753471,
							-66.876175
						],
						[
							50.949325,
							-66.523484
						],
						[
							51.791547,
							-66.249133
						],
						[
							52.614133,
							-66.053176
						],
						[
							53.613038,
							-65.89639
						],
						[
							54.53355,
							-65.818049
						],
						[
							55.414943,
							-65.876805
						],
						[
							56.355041,
							-65.974783
						],
						[
							57.158093,
							-66.249133
						],
						[
							57.255968,
							-66.680218
						],
						[
							58.137361,
							-67.013324
						],
						[
							58.744508,
							-67.287675
						],
						[
							59.939318,
							-67.405239
						],
						[
							60.605221,
							-67.679589
						],
						[
							61.427806,
							-67.953887
						],
						[
							62.387489,
							-68.012695
						],
						[
							63.19049,
							-67.816738
						],
						[
							64.052349,
							-67.405239
						],
						[
							64.992447,
							-67.620729
						],
						[
							65.971715,
							-67.738345
						],
						[
							66.911864,
							-67.855909
						],
						[
							67.891133,
							-67.934302
						],
						[
							68.890038,
							-67.934302
						],
						[
							69.712624,
							-68.972791
						],
						[
							69.673453,
							-69.227556
						],
						[
							69.555941,
							-69.678226
						],
						[
							68.596258,
							-69.93294
						],
						[
							67.81274,
							-70.305268
						],
						[
							67.949889,
							-70.697182
						],
						[
							69.066307,
							-70.677545
						],
						[
							68.929157,
							-71.069459
						],
						[
							68.419989,
							-71.441788
						],
						[
							67.949889,
							-71.853287
						],
						[
							68.71377,
							-72.166808
						],
						[
							69.869307,
							-72.264787
						],
						[
							71.024895,
							-72.088415
						],
						[
							71.573285,
							-71.696501
						],
						[
							71.906288,
							-71.324224
						],
						[
							72.454627,
							-71.010703
						],
						[
							73.08141,
							-70.716768
						],
						[
							73.33602,
							-70.364024
						],
						[
							73.864877,
							-69.874183
						],
						[
							74.491557,
							-69.776205
						],
						[
							75.62756,
							-69.737034
						],
						[
							76.626465,
							-69.619419
						],
						[
							77.644904,
							-69.462684
						],
						[
							78.134539,
							-69.07077
						],
						[
							78.428371,
							-68.698441
						],
						[
							79.113859,
							-68.326216
						],
						[
							80.093127,
							-68.071503
						],
						[
							80.93535,
							-67.875546
						],
						[
							81.483792,
							-67.542388
						],
						[
							82.051767,
							-67.366068
						],
						[
							82.776426,
							-67.209282
						],
						[
							83.775331,
							-67.30726
						],
						[
							84.676206,
							-67.209282
						],
						[
							85.655527,
							-67.091718
						],
						[
							86.752359,
							-67.150474
						],
						[
							87.477017,
							-66.876175
						],
						[
							87.986289,
							-66.209911
						],
						[
							88.358411,
							-66.484261
						],
						[
							88.828408,
							-66.954568
						],
						[
							89.67063,
							-67.150474
						],
						[
							90.630365,
							-67.228867
						],
						[
							91.5901,
							-67.111303
						],
						[
							92.608539,
							-67.189696
						],
						[
							93.548637,
							-67.209282
						],
						[
							94.17542,
							-67.111303
						],
						[
							95.017591,
							-67.170111
						],
						[
							95.781472,
							-67.385653
						],
						[
							96.682399,
							-67.248504
						],
						[
							97.759646,
							-67.248504
						],
						[
							98.68021,
							-67.111303
						],
						[
							99.718182,
							-67.248504
						],
						[
							100.384188,
							-66.915346
						],
						[
							100.893356,
							-66.58224
						],
						[
							101.578896,
							-66.30789
						],
						[
							102.832411,
							-65.563284
						],
						[
							103.478676,
							-65.700485
						],
						[
							104.242557,
							-65.974783
						],
						[
							104.90846,
							-66.327527
						],
						[
							106.181561,
							-66.934931
						],
						[
							107.160881,
							-66.954568
						],
						[
							108.081393,
							-66.954568
						],
						[
							109.15864,
							-66.837004
						],
						[
							110.235835,
							-66.699804
						],
						[
							111.058472,
							-66.425505
						],
						[
							111.74396,
							-66.13157
						],
						[
							112.860378,
							-66.092347
						],
						[
							113.604673,
							-65.876805
						],
						[
							114.388088,
							-66.072762
						],
						[
							114.897308,
							-66.386283
						],
						[
							115.602381,
							-66.699804
						],
						[
							116.699161,
							-66.660633
						],
						[
							117.384701,
							-66.915346
						],
						[
							118.57946,
							-67.170111
						],
						[
							119.832924,
							-67.268089
						],
						[
							120.871,
							-67.189696
						],
						[
							121.654415,
							-66.876175
						],
						[
							122.320369,
							-66.562654
						],
						[
							123.221296,
							-66.484261
						],
						[
							124.122274,
							-66.621462
						],
						[
							125.160247,
							-66.719389
						],
						[
							126.100396,
							-66.562654
						],
						[
							127.001427,
							-66.562654
						],
						[
							127.882768,
							-66.660633
						],
						[
							128.80328,
							-66.758611
						],
						[
							129.704259,
							-66.58224
						],
						[
							130.781454,
							-66.425505
						],
						[
							131.799945,
							-66.386283
						],
						[
							132.935896,
							-66.386283
						],
						[
							133.85646,
							-66.288304
						],
						[
							134.757387,
							-66.209963
						],
						[
							135.031582,
							-65.72007
						],
						[
							135.070753,
							-65.308571
						],
						[
							135.697485,
							-65.582869
						],
						[
							135.873805,
							-66.033591
						],
						[
							136.206705,
							-66.44509
						],
						[
							136.618049,
							-66.778197
						],
						[
							137.460271,
							-66.954568
						],
						[
							138.596223,
							-66.895761
						],
						[
							139.908442,
							-66.876175
						],
						[
							140.809421,
							-66.817367
						],
						[
							142.121692,
							-66.817367
						],
						[
							143.061842,
							-66.797782
						],
						[
							144.374061,
							-66.837004
						],
						[
							145.490427,
							-66.915346
						],
						[
							146.195552,
							-67.228867
						],
						[
							145.999699,
							-67.601196
						],
						[
							146.646067,
							-67.895131
						],
						[
							147.723263,
							-68.130259
						],
						[
							148.839629,
							-68.385024
						],
						[
							150.132314,
							-68.561292
						],
						[
							151.483705,
							-68.71813
						],
						[
							152.502247,
							-68.874813
						],
						[
							153.638199,
							-68.894502
						],
						[
							154.284567,
							-68.561292
						],
						[
							155.165857,
							-68.835642
						],
						[
							155.92979,
							-69.149215
						],
						[
							156.811132,
							-69.384291
						],
						[
							158.025528,
							-69.482269
						],
						[
							159.181013,
							-69.599833
						],
						[
							159.670699,
							-69.991747
						],
						[
							160.80665,
							-70.226875
						],
						[
							161.570479,
							-70.579618
						],
						[
							162.686897,
							-70.736353
						],
						[
							163.842434,
							-70.716768
						],
						[
							164.919681,
							-70.775524
						],
						[
							166.11444,
							-70.755938
						],
						[
							167.309095,
							-70.834332
						],
						[
							168.425616,
							-70.971481
						],
						[
							169.463589,
							-71.20666
						],
						[
							170.501665,
							-71.402617
						],
						[
							171.20679,
							-71.696501
						],
						[
							171.089227,
							-72.088415
						],
						[
							170.560422,
							-72.441159
						],
						[
							170.109958,
							-72.891829
						],
						[
							169.75737,
							-73.24452
						],
						[
							169.287321,
							-73.65602
						],
						[
							167.975101,
							-73.812806
						],
						[
							167.387489,
							-74.165498
						],
						[
							166.094803,
							-74.38104
						],
						[
							165.644391,
							-74.772954
						],
						[
							164.958851,
							-75.145283
						],
						[
							164.234193,
							-75.458804
						],
						[
							163.822797,
							-75.870303
						],
						[
							163.568239,
							-76.24258
						],
						[
							163.47026,
							-76.693302
						],
						[
							163.489897,
							-77.065579
						],
						[
							164.057873,
							-77.457442
						],
						[
							164.273363,
							-77.82977
						],
						[
							164.743464,
							-78.182514
						],
						[
							166.604126,
							-78.319611
						],
						[
							166.995781,
							-78.750748
						],
						[
							165.193876,
							-78.907483
						],
						[
							163.666217,
							-79.123025
						],
						[
							161.766385,
							-79.162248
						],
						[
							160.924162,
							-79.730482
						],
						[
							160.747894,
							-80.200737
						],
						[
							160.316964,
							-80.573066
						],
						[
							159.788211,
							-80.945395
						],
						[
							161.120016,
							-81.278501
						],
						[
							161.629287,
							-81.690001
						],
						[
							162.490992,
							-82.062278
						],
						[
							163.705336,
							-82.395435
						],
						[
							165.095949,
							-82.708956
						],
						[
							166.604126,
							-83.022477
						],
						[
							168.895665,
							-83.335998
						],
						[
							169.404782,
							-83.825891
						],
						[
							172.283934,
							-84.041433
						],
						[
							172.477049,
							-84.117914
						],
						[
							173.224083,
							-84.41371
						],
						[
							175.985672,
							-84.158997
						],
						[
							178.277212,
							-84.472518
						],
						[
							180,
							-84.71338
						],
						[
							-179.942499,
							-84.721443
						],
						[
							-179.058677,
							-84.139412
						],
						[
							-177.256772,
							-84.452933
						],
						[
							-177.140807,
							-84.417941
						],
						[
							-176.084673,
							-84.099259
						],
						[
							-175.947235,
							-84.110449
						],
						[
							-175.829882,
							-84.117914
						],
						[
							-174.382503,
							-84.534323
						],
						[
							-173.116559,
							-84.117914
						],
						[
							-172.889106,
							-84.061019
						],
						[
							-169.951223,
							-83.884647
						],
						[
							-168.999989,
							-84.117914
						],
						[
							-168.530199,
							-84.23739
						],
						[
							-167.022099,
							-84.570497
						],
						[
							-164.182144,
							-84.82521
						],
						[
							-161.929775,
							-85.138731
						],
						[
							-158.07138,
							-85.37391
						],
						[
							-155.192253,
							-85.09956
						],
						[
							-150.942099,
							-85.295517
						],
						[
							-148.533073,
							-85.609038
						],
						[
							-145.888918,
							-85.315102
						],
						[
							-143.107718,
							-85.040752
						],
						[
							-142.892279,
							-84.570497
						],
						[
							-146.829068,
							-84.531274
						],
						[
							-150.060732,
							-84.296146
						],
						[
							-150.902928,
							-83.904232
						],
						[
							-153.586201,
							-83.68869
						],
						[
							-153.409907,
							-83.23802
						],
						[
							-153.037759,
							-82.82652
						],
						[
							-152.665637,
							-82.454192
						],
						[
							-152.861517,
							-82.042692
						],
						[
							-154.526299,
							-81.768394
						],
						[
							-155.29018,
							-81.41565
						],
						[
							-156.83745,
							-81.102129
						],
						[
							-154.408787,
							-81.160937
						],
						[
							-152.097662,
							-81.004151
						],
						[
							-150.648293,
							-81.337309
						],
						[
							-148.865998,
							-81.043373
						],
						[
							-147.22075,
							-80.671045
						],
						[
							-146.417749,
							-80.337938
						],
						[
							-146.770286,
							-79.926439
						],
						[
							-148.062947,
							-79.652089
						],
						[
							-149.531901,
							-79.358205
						],
						[
							-151.588416,
							-79.299397
						],
						[
							-153.390322,
							-79.162248
						],
						[
							-155.329376,
							-79.064269
						],
						[
							-155.975668,
							-78.69194
						],
						[
							-157.268302,
							-78.378419
						],
						[
							-158.051768,
							-78.025676
						],
						[
							-158.365134,
							-76.889207
						],
						[
							-157.875474,
							-76.987238
						],
						[
							-156.974573,
							-77.300759
						],
						[
							-155.329376,
							-77.202728
						],
						[
							-153.742832,
							-77.065579
						],
						[
							-152.920247,
							-77.496664
						],
						[
							-151.33378,
							-77.398737
						],
						[
							-150.00195,
							-77.183143
						],
						[
							-148.748486,
							-76.908845
						],
						[
							-147.612483,
							-76.575738
						],
						[
							-146.104409,
							-76.47776
						],
						[
							-146.143528,
							-76.105431
						],
						[
							-146.496091,
							-75.733154
						],
						[
							-146.20231,
							-75.380411
						],
						[
							-144.909624,
							-75.204039
						],
						[
							-144.322037,
							-75.537197
						],
						[
							-142.794353,
							-75.34124
						],
						[
							-141.638764,
							-75.086475
						],
						[
							-140.209007,
							-75.06689
						],
						[
							-138.85759,
							-74.968911
						],
						[
							-137.5062,
							-74.733783
						],
						[
							-136.428901,
							-74.518241
						],
						[
							-135.214583,
							-74.302699
						],
						[
							-134.431194,
							-74.361455
						],
						[
							-133.745654,
							-74.439848
						],
						[
							-132.257168,
							-74.302699
						],
						[
							-130.925311,
							-74.479019
						],
						[
							-129.554284,
							-74.459433
						],
						[
							-128.242038,
							-74.322284
						],
						[
							-126.890622,
							-74.420263
						],
						[
							-125.402082,
							-74.518241
						],
						[
							-124.011496,
							-74.479019
						],
						[
							-122.562152,
							-74.498604
						],
						[
							-121.073613,
							-74.518241
						],
						[
							-119.70256,
							-74.479019
						],
						[
							-118.684145,
							-74.185083
						],
						[
							-117.469801,
							-74.028348
						],
						[
							-116.216312,
							-74.243891
						],
						[
							-115.021552,
							-74.067519
						],
						[
							-113.944331,
							-73.714828
						],
						[
							-113.297988,
							-74.028348
						],
						[
							-112.945452,
							-74.38104
						],
						[
							-112.299083,
							-74.714198
						],
						[
							-111.261059,
							-74.420263
						],
						[
							-110.066325,
							-74.79254
						],
						[
							-108.714909,
							-74.910103
						],
						[
							-107.559346,
							-75.184454
						],
						[
							-106.149148,
							-75.125698
						],
						[
							-104.876074,
							-74.949326
						],
						[
							-103.367949,
							-74.988497
						],
						[
							-102.016507,
							-75.125698
						],
						[
							-100.645531,
							-75.302018
						],
						[
							-100.1167,
							-74.870933
						],
						[
							-100.763043,
							-74.537826
						],
						[
							-101.252703,
							-74.185083
						],
						[
							-102.545337,
							-74.106742
						],
						[
							-103.113313,
							-73.734413
						],
						[
							-103.328752,
							-73.362084
						],
						[
							-103.681289,
							-72.61753
						],
						[
							-102.917485,
							-72.754679
						],
						[
							-101.60524,
							-72.813436
						],
						[
							-100.312528,
							-72.754679
						],
						[
							-99.13738,
							-72.911414
						],
						[
							-98.118889,
							-73.20535
						],
						[
							-97.688037,
							-73.558041
						],
						[
							-96.336595,
							-73.616849
						],
						[
							-95.043961,
							-73.4797
						],
						[
							-93.672907,
							-73.283743
						],
						[
							-92.439003,
							-73.166179
						],
						[
							-91.420564,
							-73.401307
						],
						[
							-90.088733,
							-73.322914
						],
						[
							-89.226951,
							-72.558722
						],
						[
							-88.423951,
							-73.009393
						],
						[
							-87.268337,
							-73.185764
						],
						[
							-86.014822,
							-73.087786
						],
						[
							-85.192236,
							-73.4797
						],
						[
							-83.879991,
							-73.518871
						],
						[
							-82.665646,
							-73.636434
						],
						[
							-81.470913,
							-73.851977
						],
						[
							-80.687447,
							-73.4797
						],
						[
							-80.295791,
							-73.126956
						],
						[
							-79.296886,
							-73.518871
						],
						[
							-77.925858,
							-73.420892
						],
						[
							-76.907367,
							-73.636434
						],
						[
							-76.221879,
							-73.969541
						],
						[
							-74.890049,
							-73.871614
						],
						[
							-73.852024,
							-73.65602
						],
						[
							-72.833533,
							-73.401307
						],
						[
							-71.619215,
							-73.264157
						],
						[
							-70.209042,
							-73.146542
						],
						[
							-68.935916,
							-73.009393
						],
						[
							-67.956622,
							-72.79385
						],
						[
							-67.369061,
							-72.480329
						],
						[
							-67.134036,
							-72.049244
						],
						[
							-67.251548,
							-71.637745
						],
						[
							-67.56494,
							-71.245831
						],
						[
							-67.917477,
							-70.853917
						],
						[
							-68.230843,
							-70.462055
						],
						[
							-68.485452,
							-70.109311
						],
						[
							-68.544209,
							-69.717397
						],
						[
							-68.446282,
							-69.325535
						],
						[
							-67.976233,
							-68.953206
						],
						[
							-67.5845,
							-68.541707
						],
						[
							-67.427843,
							-68.149844
						],
						[
							-67.62367,
							-67.718759
						],
						[
							-67.741183,
							-67.326845
						],
						[
							-67.251548,
							-66.876175
						],
						[
							-66.703184,
							-66.58224
						],
						[
							-66.056815,
							-66.209963
						],
						[
							-65.371327,
							-65.89639
						],
						[
							-64.568276,
							-65.602506
						],
						[
							-64.176542,
							-65.171423
						],
						[
							-63.628152,
							-64.897073
						],
						[
							-63.001394,
							-64.642308
						],
						[
							-62.041686,
							-64.583552
						],
						[
							-61.414928,
							-64.270031
						],
						[
							-60.709855,
							-64.074074
						],
						[
							-59.887269,
							-63.95651
						],
						[
							-59.162585,
							-63.701745
						],
						[
							-58.594557,
							-63.388224
						],
						[
							-57.811143,
							-63.27066
						],
						[
							-57.223582,
							-63.525425
						],
						[
							-57.59573,
							-63.858532
						],
						[
							-58.614143,
							-64.152467
						]
					]
				]
			]
		},
		id: "ATA",
		id2: "AQ",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-61.69,
							17.02
						],
						[
							-61.89,
							17.11
						],
						[
							-61.79,
							17.16
						],
						[
							-61.69,
							17.02
						]
					]
				],
				[
					[
						[
							-61.73,
							17.61
						],
						[
							-61.85,
							17.58
						],
						[
							-61.87,
							17.7
						],
						[
							-61.73,
							17.61
						]
					]
				]
			]
		},
		properties: {
			name: "Antigua and Barbuda"
		},
		id2: "AG",
		id: "ATG",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Argentina"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-65.5,
							-55.2
						],
						[
							-66.45,
							-55.25
						],
						[
							-66.95992,
							-54.89681
						],
						[
							-67.56244,
							-54.87001
						],
						[
							-68.63335,
							-54.8695
						],
						[
							-68.63401,
							-52.63637
						],
						[
							-68.25,
							-53.1
						],
						[
							-67.75,
							-53.85
						],
						[
							-66.45,
							-54.45
						],
						[
							-65.05,
							-54.7
						],
						[
							-65.5,
							-55.2
						]
					]
				],
				[
					[
						[
							-64.964892,
							-22.075862
						],
						[
							-64.377021,
							-22.798091
						],
						[
							-63.986838,
							-21.993644
						],
						[
							-62.846468,
							-22.034985
						],
						[
							-62.685057,
							-22.249029
						],
						[
							-60.846565,
							-23.880713
						],
						[
							-60.028966,
							-24.032796
						],
						[
							-58.807128,
							-24.771459
						],
						[
							-57.777217,
							-25.16234
						],
						[
							-57.63366,
							-25.603657
						],
						[
							-58.618174,
							-27.123719
						],
						[
							-57.60976,
							-27.395899
						],
						[
							-56.486702,
							-27.548499
						],
						[
							-55.695846,
							-27.387837
						],
						[
							-54.788795,
							-26.621786
						],
						[
							-54.625291,
							-25.739255
						],
						[
							-54.13005,
							-25.547639
						],
						[
							-53.628349,
							-26.124865
						],
						[
							-53.648735,
							-26.923473
						],
						[
							-54.490725,
							-27.474757
						],
						[
							-55.162286,
							-27.881915
						],
						[
							-56.2909,
							-28.852761
						],
						[
							-57.625133,
							-30.216295
						],
						[
							-57.874937,
							-31.016556
						],
						[
							-58.14244,
							-32.044504
						],
						[
							-58.132648,
							-33.040567
						],
						[
							-58.349611,
							-33.263189
						],
						[
							-58.427074,
							-33.909454
						],
						[
							-58.495442,
							-34.43149
						],
						[
							-57.22583,
							-35.288027
						],
						[
							-57.362359,
							-35.97739
						],
						[
							-56.737487,
							-36.413126
						],
						[
							-56.788285,
							-36.901572
						],
						[
							-57.749157,
							-38.183871
						],
						[
							-59.231857,
							-38.72022
						],
						[
							-61.237445,
							-38.928425
						],
						[
							-62.335957,
							-38.827707
						],
						[
							-62.125763,
							-39.424105
						],
						[
							-62.330531,
							-40.172586
						],
						[
							-62.145994,
							-40.676897
						],
						[
							-62.745803,
							-41.028761
						],
						[
							-63.770495,
							-41.166789
						],
						[
							-64.73209,
							-40.802677
						],
						[
							-65.118035,
							-41.064315
						],
						[
							-64.978561,
							-42.058001
						],
						[
							-64.303408,
							-42.359016
						],
						[
							-63.755948,
							-42.043687
						],
						[
							-63.458059,
							-42.563138
						],
						[
							-64.378804,
							-42.873558
						],
						[
							-65.181804,
							-43.495381
						],
						[
							-65.328823,
							-44.501366
						],
						[
							-65.565269,
							-45.036786
						],
						[
							-66.509966,
							-45.039628
						],
						[
							-67.293794,
							-45.551896
						],
						[
							-67.580546,
							-46.301773
						],
						[
							-66.597066,
							-47.033925
						],
						[
							-65.641027,
							-47.236135
						],
						[
							-65.985088,
							-48.133289
						],
						[
							-67.166179,
							-48.697337
						],
						[
							-67.816088,
							-49.869669
						],
						[
							-68.728745,
							-50.264218
						],
						[
							-69.138539,
							-50.73251
						],
						[
							-68.815561,
							-51.771104
						],
						[
							-68.149995,
							-52.349983
						],
						[
							-68.571545,
							-52.299444
						],
						[
							-69.498362,
							-52.142761
						],
						[
							-71.914804,
							-52.009022
						],
						[
							-72.329404,
							-51.425956
						],
						[
							-72.309974,
							-50.67701
						],
						[
							-72.975747,
							-50.74145
						],
						[
							-73.328051,
							-50.378785
						],
						[
							-73.415436,
							-49.318436
						],
						[
							-72.648247,
							-48.878618
						],
						[
							-72.331161,
							-48.244238
						],
						[
							-72.447355,
							-47.738533
						],
						[
							-71.917258,
							-46.884838
						],
						[
							-71.552009,
							-45.560733
						],
						[
							-71.659316,
							-44.973689
						],
						[
							-71.222779,
							-44.784243
						],
						[
							-71.329801,
							-44.407522
						],
						[
							-71.793623,
							-44.207172
						],
						[
							-71.464056,
							-43.787611
						],
						[
							-71.915424,
							-43.408565
						],
						[
							-72.148898,
							-42.254888
						],
						[
							-71.746804,
							-42.051386
						],
						[
							-71.915734,
							-40.832339
						],
						[
							-71.680761,
							-39.808164
						],
						[
							-71.413517,
							-38.916022
						],
						[
							-70.814664,
							-38.552995
						],
						[
							-71.118625,
							-37.576827
						],
						[
							-71.121881,
							-36.658124
						],
						[
							-70.364769,
							-36.005089
						],
						[
							-70.388049,
							-35.169688
						],
						[
							-69.817309,
							-34.193571
						],
						[
							-69.814777,
							-33.273886
						],
						[
							-70.074399,
							-33.09121
						],
						[
							-70.535069,
							-31.36501
						],
						[
							-69.919008,
							-30.336339
						],
						[
							-70.01355,
							-29.367923
						],
						[
							-69.65613,
							-28.459141
						],
						[
							-69.001235,
							-27.521214
						],
						[
							-68.295542,
							-26.89934
						],
						[
							-68.5948,
							-26.506909
						],
						[
							-68.386001,
							-26.185016
						],
						[
							-68.417653,
							-24.518555
						],
						[
							-67.328443,
							-24.025303
						],
						[
							-66.985234,
							-22.986349
						],
						[
							-67.106674,
							-22.735925
						],
						[
							-66.273339,
							-21.83231
						],
						[
							-64.964892,
							-22.075862
						]
					]
				]
			]
		},
		id: "ARG",
		id2: "AR",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Armenia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						43.582746,
						41.092143
					],
					[
						44.97248,
						41.248129
					],
					[
						45.179496,
						40.985354
					],
					[
						45.560351,
						40.81229
					],
					[
						45.359175,
						40.561504
					],
					[
						45.891907,
						40.218476
					],
					[
						45.610012,
						39.899994
					],
					[
						46.034534,
						39.628021
					],
					[
						46.483499,
						39.464155
					],
					[
						46.50572,
						38.770605
					],
					[
						46.143623,
						38.741201
					],
					[
						45.735379,
						39.319719
					],
					[
						45.739978,
						39.473999
					],
					[
						45.298145,
						39.471751
					],
					[
						45.001987,
						39.740004
					],
					[
						44.79399,
						39.713003
					],
					[
						44.400009,
						40.005
					],
					[
						43.656436,
						40.253564
					],
					[
						43.752658,
						40.740201
					],
					[
						43.582746,
						41.092143
					]
				]
			]
		},
		id: "ARM",
		id2: "AM",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-69.88,
							12.41
						],
						[
							-70.06,
							12.54
						],
						[
							-70.06,
							12.63
						],
						[
							-69.88,
							12.41
						]
					]
				]
			]
		},
		properties: {
			name: "Aruba"
		},
		id2: "AW",
		id: "ABW",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Australia"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							145.397978,
							-40.792549
						],
						[
							146.364121,
							-41.137695
						],
						[
							146.908584,
							-41.000546
						],
						[
							147.689259,
							-40.808258
						],
						[
							148.289068,
							-40.875438
						],
						[
							148.359865,
							-42.062445
						],
						[
							148.017301,
							-42.407024
						],
						[
							147.914052,
							-43.211522
						],
						[
							147.564564,
							-42.937689
						],
						[
							146.870343,
							-43.634597
						],
						[
							146.663327,
							-43.580854
						],
						[
							146.048378,
							-43.549745
						],
						[
							145.43193,
							-42.693776
						],
						[
							145.29509,
							-42.03361
						],
						[
							144.718071,
							-41.162552
						],
						[
							144.743755,
							-40.703975
						],
						[
							145.397978,
							-40.792549
						]
					]
				],
				[
					[
						[
							143.561811,
							-13.763656
						],
						[
							143.922099,
							-14.548311
						],
						[
							144.563714,
							-14.171176
						],
						[
							144.894908,
							-14.594458
						],
						[
							145.374724,
							-14.984976
						],
						[
							145.271991,
							-15.428205
						],
						[
							145.48526,
							-16.285672
						],
						[
							145.637033,
							-16.784918
						],
						[
							145.888904,
							-16.906926
						],
						[
							146.160309,
							-17.761655
						],
						[
							146.063674,
							-18.280073
						],
						[
							146.387478,
							-18.958274
						],
						[
							147.471082,
							-19.480723
						],
						[
							148.177602,
							-19.955939
						],
						[
							148.848414,
							-20.39121
						],
						[
							148.717465,
							-20.633469
						],
						[
							149.28942,
							-21.260511
						],
						[
							149.678337,
							-22.342512
						],
						[
							150.077382,
							-22.122784
						],
						[
							150.482939,
							-22.556142
						],
						[
							150.727265,
							-22.402405
						],
						[
							150.899554,
							-23.462237
						],
						[
							151.609175,
							-24.076256
						],
						[
							152.07354,
							-24.457887
						],
						[
							152.855197,
							-25.267501
						],
						[
							153.136162,
							-26.071173
						],
						[
							153.161949,
							-26.641319
						],
						[
							153.092909,
							-27.2603
						],
						[
							153.569469,
							-28.110067
						],
						[
							153.512108,
							-28.995077
						],
						[
							153.339095,
							-29.458202
						],
						[
							153.069241,
							-30.35024
						],
						[
							153.089602,
							-30.923642
						],
						[
							152.891578,
							-31.640446
						],
						[
							152.450002,
							-32.550003
						],
						[
							151.709117,
							-33.041342
						],
						[
							151.343972,
							-33.816023
						],
						[
							151.010555,
							-34.31036
						],
						[
							150.714139,
							-35.17346
						],
						[
							150.32822,
							-35.671879
						],
						[
							150.075212,
							-36.420206
						],
						[
							149.946124,
							-37.109052
						],
						[
							149.997284,
							-37.425261
						],
						[
							149.423882,
							-37.772681
						],
						[
							148.304622,
							-37.809061
						],
						[
							147.381733,
							-38.219217
						],
						[
							146.922123,
							-38.606532
						],
						[
							146.317922,
							-39.035757
						],
						[
							145.489652,
							-38.593768
						],
						[
							144.876976,
							-38.417448
						],
						[
							145.032212,
							-37.896188
						],
						[
							144.485682,
							-38.085324
						],
						[
							143.609974,
							-38.809465
						],
						[
							142.745427,
							-38.538268
						],
						[
							142.17833,
							-38.380034
						],
						[
							141.606582,
							-38.308514
						],
						[
							140.638579,
							-38.019333
						],
						[
							139.992158,
							-37.402936
						],
						[
							139.806588,
							-36.643603
						],
						[
							139.574148,
							-36.138362
						],
						[
							139.082808,
							-35.732754
						],
						[
							138.120748,
							-35.612296
						],
						[
							138.449462,
							-35.127261
						],
						[
							138.207564,
							-34.384723
						],
						[
							137.71917,
							-35.076825
						],
						[
							136.829406,
							-35.260535
						],
						[
							137.352371,
							-34.707339
						],
						[
							137.503886,
							-34.130268
						],
						[
							137.890116,
							-33.640479
						],
						[
							137.810328,
							-32.900007
						],
						[
							136.996837,
							-33.752771
						],
						[
							136.372069,
							-34.094766
						],
						[
							135.989043,
							-34.890118
						],
						[
							135.208213,
							-34.47867
						],
						[
							135.239218,
							-33.947953
						],
						[
							134.613417,
							-33.222778
						],
						[
							134.085904,
							-32.848072
						],
						[
							134.273903,
							-32.617234
						],
						[
							132.990777,
							-32.011224
						],
						[
							132.288081,
							-31.982647
						],
						[
							131.326331,
							-31.495803
						],
						[
							129.535794,
							-31.590423
						],
						[
							128.240938,
							-31.948489
						],
						[
							127.102867,
							-32.282267
						],
						[
							126.148714,
							-32.215966
						],
						[
							125.088623,
							-32.728751
						],
						[
							124.221648,
							-32.959487
						],
						[
							124.028947,
							-33.483847
						],
						[
							123.659667,
							-33.890179
						],
						[
							122.811036,
							-33.914467
						],
						[
							122.183064,
							-34.003402
						],
						[
							121.299191,
							-33.821036
						],
						[
							120.580268,
							-33.930177
						],
						[
							119.893695,
							-33.976065
						],
						[
							119.298899,
							-34.509366
						],
						[
							119.007341,
							-34.464149
						],
						[
							118.505718,
							-34.746819
						],
						[
							118.024972,
							-35.064733
						],
						[
							117.295507,
							-35.025459
						],
						[
							116.625109,
							-35.025097
						],
						[
							115.564347,
							-34.386428
						],
						[
							115.026809,
							-34.196517
						],
						[
							115.048616,
							-33.623425
						],
						[
							115.545123,
							-33.487258
						],
						[
							115.714674,
							-33.259572
						],
						[
							115.679379,
							-32.900369
						],
						[
							115.801645,
							-32.205062
						],
						[
							115.689611,
							-31.612437
						],
						[
							115.160909,
							-30.601594
						],
						[
							114.997043,
							-30.030725
						],
						[
							115.040038,
							-29.461095
						],
						[
							114.641974,
							-28.810231
						],
						[
							114.616498,
							-28.516399
						],
						[
							114.173579,
							-28.118077
						],
						[
							114.048884,
							-27.334765
						],
						[
							113.477498,
							-26.543134
						],
						[
							113.338953,
							-26.116545
						],
						[
							113.778358,
							-26.549025
						],
						[
							113.440962,
							-25.621278
						],
						[
							113.936901,
							-25.911235
						],
						[
							114.232852,
							-26.298446
						],
						[
							114.216161,
							-25.786281
						],
						[
							113.721255,
							-24.998939
						],
						[
							113.625344,
							-24.683971
						],
						[
							113.393523,
							-24.384764
						],
						[
							113.502044,
							-23.80635
						],
						[
							113.706993,
							-23.560215
						],
						[
							113.843418,
							-23.059987
						],
						[
							113.736552,
							-22.475475
						],
						[
							114.149756,
							-21.755881
						],
						[
							114.225307,
							-22.517488
						],
						[
							114.647762,
							-21.82952
						],
						[
							115.460167,
							-21.495173
						],
						[
							115.947373,
							-21.068688
						],
						[
							116.711615,
							-20.701682
						],
						[
							117.166316,
							-20.623599
						],
						[
							117.441545,
							-20.746899
						],
						[
							118.229559,
							-20.374208
						],
						[
							118.836085,
							-20.263311
						],
						[
							118.987807,
							-20.044203
						],
						[
							119.252494,
							-19.952942
						],
						[
							119.805225,
							-19.976506
						],
						[
							120.85622,
							-19.683708
						],
						[
							121.399856,
							-19.239756
						],
						[
							121.655138,
							-18.705318
						],
						[
							122.241665,
							-18.197649
						],
						[
							122.286624,
							-17.798603
						],
						[
							122.312772,
							-17.254967
						],
						[
							123.012574,
							-16.4052
						],
						[
							123.433789,
							-17.268558
						],
						[
							123.859345,
							-17.069035
						],
						[
							123.503242,
							-16.596506
						],
						[
							123.817073,
							-16.111316
						],
						[
							124.258287,
							-16.327944
						],
						[
							124.379726,
							-15.56706
						],
						[
							124.926153,
							-15.0751
						],
						[
							125.167275,
							-14.680396
						],
						[
							125.670087,
							-14.51007
						],
						[
							125.685796,
							-14.230656
						],
						[
							126.125149,
							-14.347341
						],
						[
							126.142823,
							-14.095987
						],
						[
							126.582589,
							-13.952791
						],
						[
							127.065867,
							-13.817968
						],
						[
							127.804633,
							-14.276906
						],
						[
							128.35969,
							-14.86917
						],
						[
							128.985543,
							-14.875991
						],
						[
							129.621473,
							-14.969784
						],
						[
							129.4096,
							-14.42067
						],
						[
							129.888641,
							-13.618703
						],
						[
							130.339466,
							-13.357376
						],
						[
							130.183506,
							-13.10752
						],
						[
							130.617795,
							-12.536392
						],
						[
							131.223495,
							-12.183649
						],
						[
							131.735091,
							-12.302453
						],
						[
							132.575298,
							-12.114041
						],
						[
							132.557212,
							-11.603012
						],
						[
							131.824698,
							-11.273782
						],
						[
							132.357224,
							-11.128519
						],
						[
							133.019561,
							-11.376411
						],
						[
							133.550846,
							-11.786515
						],
						[
							134.393068,
							-12.042365
						],
						[
							134.678632,
							-11.941183
						],
						[
							135.298491,
							-12.248606
						],
						[
							135.882693,
							-11.962267
						],
						[
							136.258381,
							-12.049342
						],
						[
							136.492475,
							-11.857209
						],
						[
							136.95162,
							-12.351959
						],
						[
							136.685125,
							-12.887223
						],
						[
							136.305407,
							-13.29123
						],
						[
							135.961758,
							-13.324509
						],
						[
							136.077617,
							-13.724278
						],
						[
							135.783836,
							-14.223989
						],
						[
							135.428664,
							-14.715432
						],
						[
							135.500184,
							-14.997741
						],
						[
							136.295175,
							-15.550265
						],
						[
							137.06536,
							-15.870762
						],
						[
							137.580471,
							-16.215082
						],
						[
							138.303217,
							-16.807604
						],
						[
							138.585164,
							-16.806622
						],
						[
							139.108543,
							-17.062679
						],
						[
							139.260575,
							-17.371601
						],
						[
							140.215245,
							-17.710805
						],
						[
							140.875463,
							-17.369069
						],
						[
							141.07111,
							-16.832047
						],
						[
							141.274095,
							-16.38887
						],
						[
							141.398222,
							-15.840532
						],
						[
							141.702183,
							-15.044921
						],
						[
							141.56338,
							-14.561333
						],
						[
							141.63552,
							-14.270395
						],
						[
							141.519869,
							-13.698078
						],
						[
							141.65092,
							-12.944688
						],
						[
							141.842691,
							-12.741548
						],
						[
							141.68699,
							-12.407614
						],
						[
							141.928629,
							-11.877466
						],
						[
							142.118488,
							-11.328042
						],
						[
							142.143706,
							-11.042737
						],
						[
							142.51526,
							-10.668186
						],
						[
							142.79731,
							-11.157355
						],
						[
							142.866763,
							-11.784707
						],
						[
							143.115947,
							-11.90563
						],
						[
							143.158632,
							-12.325656
						],
						[
							143.522124,
							-12.834358
						],
						[
							143.597158,
							-13.400422
						],
						[
							143.561811,
							-13.763656
						]
					]
				]
			]
		},
		id: "AUS",
		id2: "AU",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Austria"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						16.979667,
						48.123497
					],
					[
						16.903754,
						47.714866
					],
					[
						16.340584,
						47.712902
					],
					[
						16.534268,
						47.496171
					],
					[
						16.202298,
						46.852386
					],
					[
						16.011664,
						46.683611
					],
					[
						15.137092,
						46.658703
					],
					[
						14.632472,
						46.431817
					],
					[
						13.806475,
						46.509306
					],
					[
						12.376485,
						46.767559
					],
					[
						12.153088,
						47.115393
					],
					[
						11.164828,
						46.941579
					],
					[
						11.048556,
						46.751359
					],
					[
						10.442701,
						46.893546
					],
					[
						9.932448,
						46.920728
					],
					[
						9.47997,
						47.10281
					],
					[
						9.632932,
						47.347601
					],
					[
						9.594226,
						47.525058
					],
					[
						9.896068,
						47.580197
					],
					[
						10.402084,
						47.302488
					],
					[
						10.544504,
						47.566399
					],
					[
						11.426414,
						47.523766
					],
					[
						12.141357,
						47.703083
					],
					[
						12.62076,
						47.672388
					],
					[
						12.932627,
						47.467646
					],
					[
						13.025851,
						47.637584
					],
					[
						12.884103,
						48.289146
					],
					[
						13.243357,
						48.416115
					],
					[
						13.595946,
						48.877172
					],
					[
						14.338898,
						48.555305
					],
					[
						14.901447,
						48.964402
					],
					[
						15.253416,
						49.039074
					],
					[
						16.029647,
						48.733899
					],
					[
						16.499283,
						48.785808
					],
					[
						16.960288,
						48.596982
					],
					[
						16.879983,
						48.470013
					],
					[
						16.979667,
						48.123497
					]
				]
			]
		},
		id: "AUT",
		id2: "AT",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Azerbaijan"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							45.001987,
							39.740004
						],
						[
							45.298145,
							39.471751
						],
						[
							45.739978,
							39.473999
						],
						[
							45.735379,
							39.319719
						],
						[
							46.143623,
							38.741201
						],
						[
							45.457722,
							38.874139
						],
						[
							44.952688,
							39.335765
						],
						[
							44.79399,
							39.713003
						],
						[
							45.001987,
							39.740004
						]
					]
				],
				[
					[
						[
							47.373315,
							41.219732
						],
						[
							47.815666,
							41.151416
						],
						[
							47.987283,
							41.405819
						],
						[
							48.584353,
							41.80887
						],
						[
							49.110264,
							41.282287
						],
						[
							49.618915,
							40.572924
						],
						[
							50.08483,
							40.526157
						],
						[
							50.392821,
							40.256561
						],
						[
							49.569202,
							40.176101
						],
						[
							49.395259,
							39.399482
						],
						[
							49.223228,
							39.049219
						],
						[
							48.856532,
							38.815486
						],
						[
							48.883249,
							38.320245
						],
						[
							48.634375,
							38.270378
						],
						[
							48.010744,
							38.794015
						],
						[
							48.355529,
							39.288765
						],
						[
							48.060095,
							39.582235
						],
						[
							47.685079,
							39.508364
						],
						[
							46.50572,
							38.770605
						],
						[
							46.483499,
							39.464155
						],
						[
							46.034534,
							39.628021
						],
						[
							45.610012,
							39.899994
						],
						[
							45.891907,
							40.218476
						],
						[
							45.359175,
							40.561504
						],
						[
							45.560351,
							40.81229
						],
						[
							45.179496,
							40.985354
						],
						[
							44.97248,
							41.248129
						],
						[
							45.217426,
							41.411452
						],
						[
							45.962601,
							41.123873
						],
						[
							46.501637,
							41.064445
						],
						[
							46.637908,
							41.181673
						],
						[
							46.145432,
							41.722802
						],
						[
							46.404951,
							41.860675
						],
						[
							46.686071,
							41.827137
						],
						[
							47.373315,
							41.219732
						]
					]
				]
			]
		},
		id: "AZE",
		id2: "AZ",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "The Bahamas"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-77.53466,
							23.75975
						],
						[
							-77.78,
							23.71
						],
						[
							-78.03405,
							24.28615
						],
						[
							-78.40848,
							24.57564
						],
						[
							-78.19087,
							25.2103
						],
						[
							-77.89,
							25.17
						],
						[
							-77.54,
							24.34
						],
						[
							-77.53466,
							23.75975
						]
					]
				],
				[
					[
						[
							-77.82,
							26.58
						],
						[
							-78.91,
							26.42
						],
						[
							-78.98,
							26.79
						],
						[
							-78.51,
							26.87
						],
						[
							-77.85,
							26.84
						],
						[
							-77.82,
							26.58
						]
					]
				],
				[
					[
						[
							-77,
							26.59
						],
						[
							-77.17255,
							25.87918
						],
						[
							-77.35641,
							26.00735
						],
						[
							-77.34,
							26.53
						],
						[
							-77.78802,
							26.92516
						],
						[
							-77.79,
							27.04
						],
						[
							-77,
							26.59
						]
					]
				]
			]
		},
		id: "BHS",
		id2: "BS",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							50.53,
							26.23
						],
						[
							50.57,
							25.81
						],
						[
							50.46,
							25.97
						],
						[
							50.53,
							26.23
						]
					]
				]
			]
		},
		properties: {
			name: "Bahrain"
		},
		id2: "BH",
		id: "BHR",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Bangladesh"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						92.672721,
						22.041239
					],
					[
						92.652257,
						21.324048
					],
					[
						92.303234,
						21.475485
					],
					[
						92.368554,
						20.670883
					],
					[
						92.082886,
						21.192195
					],
					[
						92.025215,
						21.70157
					],
					[
						91.834891,
						22.182936
					],
					[
						91.417087,
						22.765019
					],
					[
						90.496006,
						22.805017
					],
					[
						90.586957,
						22.392794
					],
					[
						90.272971,
						21.836368
					],
					[
						89.847467,
						22.039146
					],
					[
						89.70205,
						21.857116
					],
					[
						89.418863,
						21.966179
					],
					[
						89.031961,
						22.055708
					],
					[
						88.876312,
						22.879146
					],
					[
						88.52977,
						23.631142
					],
					[
						88.69994,
						24.233715
					],
					[
						88.084422,
						24.501657
					],
					[
						88.306373,
						24.866079
					],
					[
						88.931554,
						25.238692
					],
					[
						88.209789,
						25.768066
					],
					[
						88.563049,
						26.446526
					],
					[
						89.355094,
						26.014407
					],
					[
						89.832481,
						25.965082
					],
					[
						89.920693,
						25.26975
					],
					[
						90.872211,
						25.132601
					],
					[
						91.799596,
						25.147432
					],
					[
						92.376202,
						24.976693
					],
					[
						91.915093,
						24.130414
					],
					[
						91.46773,
						24.072639
					],
					[
						91.158963,
						23.503527
					],
					[
						91.706475,
						22.985264
					],
					[
						91.869928,
						23.624346
					],
					[
						92.146035,
						23.627499
					],
					[
						92.672721,
						22.041239
					]
				]
			]
		},
		id: "BGD",
		id2: "BD",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Barbados"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-59.6,
						12.7
					],
					[
						-59.8,
						12.7
					],
					[
						-59.8,
						12.9
					],
					[
						-59.6,
						12.9
					],
					[
						-59.6,
						12.7
					]
				]
			]
		},
		id: "BRB",
		id2: "BB",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Belarus"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						23.484128,
						53.912498
					],
					[
						24.450684,
						53.905702
					],
					[
						25.536354,
						54.282423
					],
					[
						25.768433,
						54.846963
					],
					[
						26.588279,
						55.167176
					],
					[
						26.494331,
						55.615107
					],
					[
						27.10246,
						55.783314
					],
					[
						28.176709,
						56.16913
					],
					[
						29.229513,
						55.918344
					],
					[
						29.371572,
						55.670091
					],
					[
						29.896294,
						55.789463
					],
					[
						30.873909,
						55.550976
					],
					[
						30.971836,
						55.081548
					],
					[
						30.757534,
						54.811771
					],
					[
						31.384472,
						54.157056
					],
					[
						31.791424,
						53.974639
					],
					[
						31.731273,
						53.794029
					],
					[
						32.405599,
						53.618045
					],
					[
						32.693643,
						53.351421
					],
					[
						32.304519,
						53.132726
					],
					[
						31.497644,
						53.167427
					],
					[
						31.305201,
						53.073996
					],
					[
						31.540018,
						52.742052
					],
					[
						31.785998,
						52.101678
					],
					[
						30.927549,
						52.042353
					],
					[
						30.619454,
						51.822806
					],
					[
						30.555117,
						51.319503
					],
					[
						30.157364,
						51.416138
					],
					[
						29.254938,
						51.368234
					],
					[
						28.992835,
						51.602044
					],
					[
						28.617613,
						51.427714
					],
					[
						28.241615,
						51.572227
					],
					[
						27.454066,
						51.592303
					],
					[
						26.337959,
						51.832289
					],
					[
						25.327788,
						51.910656
					],
					[
						24.553106,
						51.888461
					],
					[
						24.005078,
						51.617444
					],
					[
						23.527071,
						51.578454
					],
					[
						23.508002,
						52.023647
					],
					[
						23.199494,
						52.486977
					],
					[
						23.799199,
						52.691099
					],
					[
						23.804935,
						53.089731
					],
					[
						23.527536,
						53.470122
					],
					[
						23.484128,
						53.912498
					]
				]
			]
		},
		id: "BLR",
		id2: "BY",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Belgium"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						3.314971,
						51.345781
					],
					[
						4.047071,
						51.267259
					],
					[
						4.973991,
						51.475024
					],
					[
						5.606976,
						51.037298
					],
					[
						6.156658,
						50.803721
					],
					[
						6.043073,
						50.128052
					],
					[
						5.782417,
						50.090328
					],
					[
						5.674052,
						49.529484
					],
					[
						4.799222,
						49.985373
					],
					[
						4.286023,
						49.907497
					],
					[
						3.588184,
						50.378992
					],
					[
						3.123252,
						50.780363
					],
					[
						2.658422,
						50.796848
					],
					[
						2.513573,
						51.148506
					],
					[
						3.314971,
						51.345781
					]
				]
			]
		},
		id: "BEL",
		id2: "BE",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Belize"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-89.14308,
						17.808319
					],
					[
						-89.150909,
						17.955468
					],
					[
						-89.029857,
						18.001511
					],
					[
						-88.848344,
						17.883198
					],
					[
						-88.490123,
						18.486831
					],
					[
						-88.300031,
						18.499982
					],
					[
						-88.296336,
						18.353273
					],
					[
						-88.106813,
						18.348674
					],
					[
						-88.123479,
						18.076675
					],
					[
						-88.285355,
						17.644143
					],
					[
						-88.197867,
						17.489475
					],
					[
						-88.302641,
						17.131694
					],
					[
						-88.239518,
						17.036066
					],
					[
						-88.355428,
						16.530774
					],
					[
						-88.551825,
						16.265467
					],
					[
						-88.732434,
						16.233635
					],
					[
						-88.930613,
						15.887273
					],
					[
						-89.229122,
						15.886938
					],
					[
						-89.150806,
						17.015577
					],
					[
						-89.14308,
						17.808319
					]
				]
			]
		},
		id: "BLZ",
		id2: "BZ",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Benin"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						2.691702,
						6.258817
					],
					[
						1.865241,
						6.142158
					],
					[
						1.618951,
						6.832038
					],
					[
						1.664478,
						9.12859
					],
					[
						1.463043,
						9.334624
					],
					[
						1.425061,
						9.825395
					],
					[
						1.077795,
						10.175607
					],
					[
						0.772336,
						10.470808
					],
					[
						0.899563,
						10.997339
					],
					[
						1.24347,
						11.110511
					],
					[
						1.447178,
						11.547719
					],
					[
						1.935986,
						11.64115
					],
					[
						2.154474,
						11.94015
					],
					[
						2.490164,
						12.233052
					],
					[
						2.848643,
						12.235636
					],
					[
						3.61118,
						11.660167
					],
					[
						3.572216,
						11.327939
					],
					[
						3.797112,
						10.734746
					],
					[
						3.60007,
						10.332186
					],
					[
						3.705438,
						10.06321
					],
					[
						3.220352,
						9.444153
					],
					[
						2.912308,
						9.137608
					],
					[
						2.723793,
						8.506845
					],
					[
						2.749063,
						7.870734
					],
					[
						2.691702,
						6.258817
					]
				]
			]
		},
		id: "BEN",
		id2: "BJ",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Bermuda"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-64.4,
						31.2
					],
					[
						-64.6,
						31.2
					],
					[
						-64.6,
						31.4
					],
					[
						-64.4,
						31.4
					],
					[
						-64.6,
						31.2
					]
				]
			]
		},
		id: "BMU",
		id2: "BM",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Bhutan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						91.696657,
						27.771742
					],
					[
						92.103712,
						27.452614
					],
					[
						92.033484,
						26.83831
					],
					[
						91.217513,
						26.808648
					],
					[
						90.373275,
						26.875724
					],
					[
						89.744528,
						26.719403
					],
					[
						88.835643,
						27.098966
					],
					[
						88.814248,
						27.299316
					],
					[
						89.47581,
						28.042759
					],
					[
						90.015829,
						28.296439
					],
					[
						90.730514,
						28.064954
					],
					[
						91.258854,
						28.040614
					],
					[
						91.696657,
						27.771742
					]
				]
			]
		},
		id: "BTN",
		id2: "BT",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Bolivia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-62.846468,
						-22.034985
					],
					[
						-63.986838,
						-21.993644
					],
					[
						-64.377021,
						-22.798091
					],
					[
						-64.964892,
						-22.075862
					],
					[
						-66.273339,
						-21.83231
					],
					[
						-67.106674,
						-22.735925
					],
					[
						-67.82818,
						-22.872919
					],
					[
						-68.219913,
						-21.494347
					],
					[
						-68.757167,
						-20.372658
					],
					[
						-68.442225,
						-19.405068
					],
					[
						-68.966818,
						-18.981683
					],
					[
						-69.100247,
						-18.260125
					],
					[
						-69.590424,
						-17.580012
					],
					[
						-68.959635,
						-16.500698
					],
					[
						-69.389764,
						-15.660129
					],
					[
						-69.160347,
						-15.323974
					],
					[
						-69.339535,
						-14.953195
					],
					[
						-68.948887,
						-14.453639
					],
					[
						-68.929224,
						-13.602684
					],
					[
						-68.88008,
						-12.899729
					],
					[
						-68.66508,
						-12.5613
					],
					[
						-69.529678,
						-10.951734
					],
					[
						-68.786158,
						-11.03638
					],
					[
						-68.271254,
						-11.014521
					],
					[
						-68.048192,
						-10.712059
					],
					[
						-67.173801,
						-10.306812
					],
					[
						-66.646908,
						-9.931331
					],
					[
						-65.338435,
						-9.761988
					],
					[
						-65.444837,
						-10.511451
					],
					[
						-65.321899,
						-10.895872
					],
					[
						-65.402281,
						-11.56627
					],
					[
						-64.316353,
						-12.461978
					],
					[
						-63.196499,
						-12.627033
					],
					[
						-62.80306,
						-13.000653
					],
					[
						-62.127081,
						-13.198781
					],
					[
						-61.713204,
						-13.489202
					],
					[
						-61.084121,
						-13.479384
					],
					[
						-60.503304,
						-13.775955
					],
					[
						-60.459198,
						-14.354007
					],
					[
						-60.264326,
						-14.645979
					],
					[
						-60.251149,
						-15.077219
					],
					[
						-60.542966,
						-15.09391
					],
					[
						-60.15839,
						-16.258284
					],
					[
						-58.24122,
						-16.299573
					],
					[
						-58.388058,
						-16.877109
					],
					[
						-58.280804,
						-17.27171
					],
					[
						-57.734558,
						-17.552468
					],
					[
						-57.498371,
						-18.174188
					],
					[
						-57.676009,
						-18.96184
					],
					[
						-57.949997,
						-19.400004
					],
					[
						-57.853802,
						-19.969995
					],
					[
						-58.166392,
						-20.176701
					],
					[
						-58.183471,
						-19.868399
					],
					[
						-59.115042,
						-19.356906
					],
					[
						-60.043565,
						-19.342747
					],
					[
						-61.786326,
						-19.633737
					],
					[
						-62.265961,
						-20.513735
					],
					[
						-62.291179,
						-21.051635
					],
					[
						-62.685057,
						-22.249029
					],
					[
						-62.846468,
						-22.034985
					]
				]
			]
		},
		id: "BOL",
		id2: "BO",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Bonaire, Sint Eustatius and Saba"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-68.374,
						12.289
					],
					[
						-68.274,
						12.267
					],
					[
						-68.219,
						12.224
					],
					[
						-68.241,
						12.072
					],
					[
						-68.274,
						12.083
					],
					[
						-68.319,
						12.18
					],
					[
						-68.396,
						12.256
					],
					[
						-68.44,
						12.343
					],
					[
						-68.374,
						12.289
					]
				]
			]
		},
		id: "BES",
		id2: "BQ",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Bosnia and Herzegovina"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						19.005486,
						44.860234
					],
					[
						19.36803,
						44.863
					],
					[
						19.11761,
						44.42307
					],
					[
						19.59976,
						44.03847
					],
					[
						19.454,
						43.5681
					],
					[
						19.21852,
						43.52384
					],
					[
						19.03165,
						43.43253
					],
					[
						18.70648,
						43.20011
					],
					[
						18.56,
						42.65
					],
					[
						17.674922,
						43.028563
					],
					[
						17.297373,
						43.446341
					],
					[
						16.916156,
						43.667722
					],
					[
						16.456443,
						44.04124
					],
					[
						16.23966,
						44.351143
					],
					[
						15.750026,
						44.818712
					],
					[
						15.959367,
						45.233777
					],
					[
						16.318157,
						45.004127
					],
					[
						16.534939,
						45.211608
					],
					[
						17.002146,
						45.233777
					],
					[
						17.861783,
						45.06774
					],
					[
						18.553214,
						45.08159
					],
					[
						19.005486,
						44.860234
					]
				]
			]
		},
		id: "BIH",
		id2: "BA",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Botswana"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						25.649163,
						-18.536026
					],
					[
						25.850391,
						-18.714413
					],
					[
						26.164791,
						-19.293086
					],
					[
						27.296505,
						-20.39152
					],
					[
						27.724747,
						-20.499059
					],
					[
						27.727228,
						-20.851802
					],
					[
						28.02137,
						-21.485975
					],
					[
						28.794656,
						-21.639454
					],
					[
						29.432188,
						-22.091313
					],
					[
						28.017236,
						-22.827754
					],
					[
						27.11941,
						-23.574323
					],
					[
						26.786407,
						-24.240691
					],
					[
						26.485753,
						-24.616327
					],
					[
						25.941652,
						-24.696373
					],
					[
						25.765849,
						-25.174845
					],
					[
						25.664666,
						-25.486816
					],
					[
						25.025171,
						-25.71967
					],
					[
						24.211267,
						-25.670216
					],
					[
						23.73357,
						-25.390129
					],
					[
						23.312097,
						-25.26869
					],
					[
						22.824271,
						-25.500459
					],
					[
						22.579532,
						-25.979448
					],
					[
						22.105969,
						-26.280256
					],
					[
						21.605896,
						-26.726534
					],
					[
						20.889609,
						-26.828543
					],
					[
						20.66647,
						-26.477453
					],
					[
						20.758609,
						-25.868136
					],
					[
						20.165726,
						-24.917962
					],
					[
						19.895768,
						-24.76779
					],
					[
						19.895458,
						-21.849157
					],
					[
						20.881134,
						-21.814327
					],
					[
						20.910641,
						-18.252219
					],
					[
						21.65504,
						-18.219146
					],
					[
						23.196858,
						-17.869038
					],
					[
						23.579006,
						-18.281261
					],
					[
						24.217365,
						-17.889347
					],
					[
						24.520705,
						-17.887125
					],
					[
						25.084443,
						-17.661816
					],
					[
						25.264226,
						-17.73654
					],
					[
						25.649163,
						-18.536026
					]
				]
			]
		},
		id: "BWA",
		id2: "BW",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							3.36,
							-54.46
						],
						[
							3.37,
							-54.4
						],
						[
							3.48,
							-54.4
						],
						[
							3.36,
							-54.46
						]
					]
				]
			]
		},
		properties: {
			name: "Bouvet Island"
		},
		id2: "BV",
		id: "BVT",
		continent: "AN",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Brazil"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-57.625133,
						-30.216295
					],
					[
						-56.2909,
						-28.852761
					],
					[
						-55.162286,
						-27.881915
					],
					[
						-54.490725,
						-27.474757
					],
					[
						-53.648735,
						-26.923473
					],
					[
						-53.628349,
						-26.124865
					],
					[
						-54.13005,
						-25.547639
					],
					[
						-54.625291,
						-25.739255
					],
					[
						-54.428946,
						-25.162185
					],
					[
						-54.293476,
						-24.5708
					],
					[
						-54.29296,
						-24.021014
					],
					[
						-54.652834,
						-23.839578
					],
					[
						-55.027902,
						-24.001274
					],
					[
						-55.400747,
						-23.956935
					],
					[
						-55.517639,
						-23.571998
					],
					[
						-55.610683,
						-22.655619
					],
					[
						-55.797958,
						-22.35693
					],
					[
						-56.473317,
						-22.0863
					],
					[
						-56.88151,
						-22.282154
					],
					[
						-57.937156,
						-22.090176
					],
					[
						-57.870674,
						-20.732688
					],
					[
						-58.166392,
						-20.176701
					],
					[
						-57.853802,
						-19.969995
					],
					[
						-57.949997,
						-19.400004
					],
					[
						-57.676009,
						-18.96184
					],
					[
						-57.498371,
						-18.174188
					],
					[
						-57.734558,
						-17.552468
					],
					[
						-58.280804,
						-17.27171
					],
					[
						-58.388058,
						-16.877109
					],
					[
						-58.24122,
						-16.299573
					],
					[
						-60.15839,
						-16.258284
					],
					[
						-60.542966,
						-15.09391
					],
					[
						-60.251149,
						-15.077219
					],
					[
						-60.264326,
						-14.645979
					],
					[
						-60.459198,
						-14.354007
					],
					[
						-60.503304,
						-13.775955
					],
					[
						-61.084121,
						-13.479384
					],
					[
						-61.713204,
						-13.489202
					],
					[
						-62.127081,
						-13.198781
					],
					[
						-62.80306,
						-13.000653
					],
					[
						-63.196499,
						-12.627033
					],
					[
						-64.316353,
						-12.461978
					],
					[
						-65.402281,
						-11.56627
					],
					[
						-65.321899,
						-10.895872
					],
					[
						-65.444837,
						-10.511451
					],
					[
						-65.338435,
						-9.761988
					],
					[
						-66.646908,
						-9.931331
					],
					[
						-67.173801,
						-10.306812
					],
					[
						-68.048192,
						-10.712059
					],
					[
						-68.271254,
						-11.014521
					],
					[
						-68.786158,
						-11.03638
					],
					[
						-69.529678,
						-10.951734
					],
					[
						-70.093752,
						-11.123972
					],
					[
						-70.548686,
						-11.009147
					],
					[
						-70.481894,
						-9.490118
					],
					[
						-71.302412,
						-10.079436
					],
					[
						-72.184891,
						-10.053598
					],
					[
						-72.563033,
						-9.520194
					],
					[
						-73.226713,
						-9.462213
					],
					[
						-73.015383,
						-9.032833
					],
					[
						-73.571059,
						-8.424447
					],
					[
						-73.987235,
						-7.52383
					],
					[
						-73.723401,
						-7.340999
					],
					[
						-73.724487,
						-6.918595
					],
					[
						-73.120027,
						-6.629931
					],
					[
						-73.219711,
						-6.089189
					],
					[
						-72.964507,
						-5.741251
					],
					[
						-72.891928,
						-5.274561
					],
					[
						-71.748406,
						-4.593983
					],
					[
						-70.928843,
						-4.401591
					],
					[
						-70.794769,
						-4.251265
					],
					[
						-69.893635,
						-4.298187
					],
					[
						-69.444102,
						-1.556287
					],
					[
						-69.420486,
						-1.122619
					],
					[
						-69.577065,
						-0.549992
					],
					[
						-70.020656,
						-0.185156
					],
					[
						-70.015566,
						0.541414
					],
					[
						-69.452396,
						0.706159
					],
					[
						-69.252434,
						0.602651
					],
					[
						-69.218638,
						0.985677
					],
					[
						-69.804597,
						1.089081
					],
					[
						-69.816973,
						1.714805
					],
					[
						-67.868565,
						1.692455
					],
					[
						-67.53781,
						2.037163
					],
					[
						-67.259998,
						1.719999
					],
					[
						-67.065048,
						1.130112
					],
					[
						-66.876326,
						1.253361
					],
					[
						-66.325765,
						0.724452
					],
					[
						-65.548267,
						0.789254
					],
					[
						-65.354713,
						1.095282
					],
					[
						-64.611012,
						1.328731
					],
					[
						-64.199306,
						1.492855
					],
					[
						-64.083085,
						1.916369
					],
					[
						-63.368788,
						2.2009
					],
					[
						-63.422867,
						2.411068
					],
					[
						-64.269999,
						2.497006
					],
					[
						-64.408828,
						3.126786
					],
					[
						-64.368494,
						3.79721
					],
					[
						-64.816064,
						4.056445
					],
					[
						-64.628659,
						4.148481
					],
					[
						-63.888343,
						4.02053
					],
					[
						-63.093198,
						3.770571
					],
					[
						-62.804533,
						4.006965
					],
					[
						-62.08543,
						4.162124
					],
					[
						-60.966893,
						4.536468
					],
					[
						-60.601179,
						4.918098
					],
					[
						-60.733574,
						5.200277
					],
					[
						-60.213683,
						5.244486
					],
					[
						-59.980959,
						5.014061
					],
					[
						-60.111002,
						4.574967
					],
					[
						-59.767406,
						4.423503
					],
					[
						-59.53804,
						3.958803
					],
					[
						-59.815413,
						3.606499
					],
					[
						-59.974525,
						2.755233
					],
					[
						-59.718546,
						2.24963
					],
					[
						-59.646044,
						1.786894
					],
					[
						-59.030862,
						1.317698
					],
					[
						-58.540013,
						1.268088
					],
					[
						-58.429477,
						1.463942
					],
					[
						-58.11345,
						1.507195
					],
					[
						-57.660971,
						1.682585
					],
					[
						-57.335823,
						1.948538
					],
					[
						-56.782704,
						1.863711
					],
					[
						-56.539386,
						1.899523
					],
					[
						-55.995698,
						1.817667
					],
					[
						-55.9056,
						2.021996
					],
					[
						-56.073342,
						2.220795
					],
					[
						-55.973322,
						2.510364
					],
					[
						-55.569755,
						2.421506
					],
					[
						-55.097587,
						2.523748
					],
					[
						-54.524754,
						2.311849
					],
					[
						-54.088063,
						2.105557
					],
					[
						-53.778521,
						2.376703
					],
					[
						-53.554839,
						2.334897
					],
					[
						-53.418465,
						2.053389
					],
					[
						-52.939657,
						2.124858
					],
					[
						-52.556425,
						2.504705
					],
					[
						-52.249338,
						3.241094
					],
					[
						-51.657797,
						4.156232
					],
					[
						-51.317146,
						4.203491
					],
					[
						-51.069771,
						3.650398
					],
					[
						-50.508875,
						1.901564
					],
					[
						-49.974076,
						1.736483
					],
					[
						-49.947101,
						1.04619
					],
					[
						-50.699251,
						0.222984
					],
					[
						-50.388211,
						-0.078445
					],
					[
						-48.620567,
						-0.235489
					],
					[
						-48.584497,
						-1.237805
					],
					[
						-47.824956,
						-0.581618
					],
					[
						-46.566584,
						-0.941028
					],
					[
						-44.905703,
						-1.55174
					],
					[
						-44.417619,
						-2.13775
					],
					[
						-44.581589,
						-2.691308
					],
					[
						-43.418791,
						-2.38311
					],
					[
						-41.472657,
						-2.912018
					],
					[
						-39.978665,
						-2.873054
					],
					[
						-38.500383,
						-3.700652
					],
					[
						-37.223252,
						-4.820946
					],
					[
						-36.452937,
						-5.109404
					],
					[
						-35.597796,
						-5.149504
					],
					[
						-35.235389,
						-5.464937
					],
					[
						-34.89603,
						-6.738193
					],
					[
						-34.729993,
						-7.343221
					],
					[
						-35.128212,
						-8.996401
					],
					[
						-35.636967,
						-9.649282
					],
					[
						-37.046519,
						-11.040721
					],
					[
						-37.683612,
						-12.171195
					],
					[
						-38.423877,
						-13.038119
					],
					[
						-38.673887,
						-13.057652
					],
					[
						-38.953276,
						-13.79337
					],
					[
						-38.882298,
						-15.667054
					],
					[
						-39.161092,
						-17.208407
					],
					[
						-39.267339,
						-17.867746
					],
					[
						-39.583521,
						-18.262296
					],
					[
						-39.760823,
						-19.599113
					],
					[
						-40.774741,
						-20.904512
					],
					[
						-40.944756,
						-21.937317
					],
					[
						-41.754164,
						-22.370676
					],
					[
						-41.988284,
						-22.97007
					],
					[
						-43.074704,
						-22.967693
					],
					[
						-44.647812,
						-23.351959
					],
					[
						-45.352136,
						-23.796842
					],
					[
						-46.472093,
						-24.088969
					],
					[
						-47.648972,
						-24.885199
					],
					[
						-48.495458,
						-25.877025
					],
					[
						-48.641005,
						-26.623698
					],
					[
						-48.474736,
						-27.175912
					],
					[
						-48.66152,
						-28.186135
					],
					[
						-48.888457,
						-28.674115
					],
					[
						-49.587329,
						-29.224469
					],
					[
						-50.696874,
						-30.984465
					],
					[
						-51.576226,
						-31.777698
					],
					[
						-52.256081,
						-32.24537
					],
					[
						-52.7121,
						-33.196578
					],
					[
						-53.373662,
						-33.768378
					],
					[
						-53.650544,
						-33.202004
					],
					[
						-53.209589,
						-32.727666
					],
					[
						-53.787952,
						-32.047243
					],
					[
						-54.572452,
						-31.494511
					],
					[
						-55.60151,
						-30.853879
					],
					[
						-55.973245,
						-30.883076
					],
					[
						-56.976026,
						-30.109686
					],
					[
						-57.625133,
						-30.216295
					]
				]
			]
		},
		id: "BRA",
		id2: "BR",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							72.49,
							-7.38
						],
						[
							72.36,
							-7.27
						],
						[
							72.45,
							-7.23
						],
						[
							72.49,
							-7.38
						]
					]
				]
			]
		},
		properties: {
			name: "British Indian Ocean Territory"
		},
		id2: "IO",
		id: "IOT",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Brunei"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						114.204017,
						4.525874
					],
					[
						114.599961,
						4.900011
					],
					[
						115.45071,
						5.44773
					],
					[
						115.4057,
						4.955228
					],
					[
						115.347461,
						4.316636
					],
					[
						114.869557,
						4.348314
					],
					[
						114.659596,
						4.007637
					],
					[
						114.204017,
						4.525874
					]
				]
			]
		},
		id: "BRN",
		id2: "BN",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Bulgaria"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						22.65715,
						44.234923
					],
					[
						22.944832,
						43.823785
					],
					[
						23.332302,
						43.897011
					],
					[
						24.100679,
						43.741051
					],
					[
						25.569272,
						43.688445
					],
					[
						26.065159,
						43.943494
					],
					[
						27.2424,
						44.175986
					],
					[
						27.970107,
						43.812468
					],
					[
						28.558081,
						43.707462
					],
					[
						28.039095,
						43.293172
					],
					[
						27.673898,
						42.577892
					],
					[
						27.99672,
						42.007359
					],
					[
						27.135739,
						42.141485
					],
					[
						26.117042,
						41.826905
					],
					[
						26.106138,
						41.328899
					],
					[
						25.197201,
						41.234486
					],
					[
						24.492645,
						41.583896
					],
					[
						23.692074,
						41.309081
					],
					[
						22.952377,
						41.337994
					],
					[
						22.881374,
						41.999297
					],
					[
						22.380526,
						42.32026
					],
					[
						22.545012,
						42.461362
					],
					[
						22.436595,
						42.580321
					],
					[
						22.604801,
						42.898519
					],
					[
						22.986019,
						43.211161
					],
					[
						22.500157,
						43.642814
					],
					[
						22.410446,
						44.008063
					],
					[
						22.65715,
						44.234923
					]
				]
			]
		},
		id: "BGR",
		id2: "BG",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Burkina Faso"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-2.827496,
						9.642461
					],
					[
						-3.511899,
						9.900326
					],
					[
						-3.980449,
						9.862344
					],
					[
						-4.330247,
						9.610835
					],
					[
						-4.779884,
						9.821985
					],
					[
						-4.954653,
						10.152714
					],
					[
						-5.404342,
						10.370737
					],
					[
						-5.470565,
						10.95127
					],
					[
						-5.197843,
						11.375146
					],
					[
						-5.220942,
						11.713859
					],
					[
						-4.427166,
						12.542646
					],
					[
						-4.280405,
						13.228444
					],
					[
						-4.006391,
						13.472485
					],
					[
						-3.522803,
						13.337662
					],
					[
						-3.103707,
						13.541267
					],
					[
						-2.967694,
						13.79815
					],
					[
						-2.191825,
						14.246418
					],
					[
						-2.001035,
						14.559008
					],
					[
						-1.066363,
						14.973815
					],
					[
						-0.515854,
						15.116158
					],
					[
						-0.266257,
						14.924309
					],
					[
						0.374892,
						14.928908
					],
					[
						0.295646,
						14.444235
					],
					[
						0.429928,
						13.988733
					],
					[
						0.993046,
						13.33575
					],
					[
						1.024103,
						12.851826
					],
					[
						2.177108,
						12.625018
					],
					[
						2.154474,
						11.94015
					],
					[
						1.935986,
						11.64115
					],
					[
						1.447178,
						11.547719
					],
					[
						1.24347,
						11.110511
					],
					[
						0.899563,
						10.997339
					],
					[
						0.023803,
						11.018682
					],
					[
						-0.438702,
						11.098341
					],
					[
						-0.761576,
						10.93693
					],
					[
						-1.203358,
						11.009819
					],
					[
						-2.940409,
						10.96269
					],
					[
						-2.963896,
						10.395335
					],
					[
						-2.827496,
						9.642461
					]
				]
			]
		},
		id: "BFA",
		id2: "BF",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Burundi"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						29.339998,
						-4.499983
					],
					[
						29.276384,
						-3.293907
					],
					[
						29.024926,
						-2.839258
					],
					[
						29.632176,
						-2.917858
					],
					[
						29.938359,
						-2.348487
					],
					[
						30.469696,
						-2.413858
					],
					[
						30.527677,
						-2.807632
					],
					[
						30.743013,
						-3.034285
					],
					[
						30.752263,
						-3.35933
					],
					[
						30.50556,
						-3.568567
					],
					[
						30.116333,
						-4.090138
					],
					[
						29.753512,
						-4.452389
					],
					[
						29.339998,
						-4.499983
					]
				]
			]
		},
		id: "BDI",
		id2: "BI",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-24.37,
							14.81
						],
						[
							-24.53,
							14.92
						],
						[
							-24.38,
							15.05
						],
						[
							-24.37,
							14.81
						]
					]
				],
				[
					[
						[
							-23.45,
							14.98
						],
						[
							-23.68,
							14.94
						],
						[
							-23.77,
							15.25
						],
						[
							-23.45,
							14.98
						]
					]
				],
				[
					[
						[
							-22.71,
							16.04
						],
						[
							-22.96,
							16.09
						],
						[
							-22.8,
							16.24
						],
						[
							-22.71,
							16.04
						]
					]
				],
				[
					[
						[
							-24.03,
							16.59
						],
						[
							-24.32,
							16.48
						],
						[
							-24.43,
							16.64
						],
						[
							-24.03,
							16.59
						]
					]
				],
				[
					[
						[
							-25.28,
							16.91
						],
						[
							-25.33,
							17.1
						],
						[
							-24.97,
							17.11
						],
						[
							-25.28,
							16.91
						]
					]
				]
			]
		},
		properties: {
			name: "Cabo Verde"
		},
		id2: "CV",
		id: "CPV",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Cambodia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						103.49728,
						10.632555
					],
					[
						103.09069,
						11.153661
					],
					[
						102.584932,
						12.186595
					],
					[
						102.348099,
						13.394247
					],
					[
						102.988422,
						14.225721
					],
					[
						104.281418,
						14.416743
					],
					[
						105.218777,
						14.273212
					],
					[
						106.043946,
						13.881091
					],
					[
						106.496373,
						14.570584
					],
					[
						107.382727,
						14.202441
					],
					[
						107.614548,
						13.535531
					],
					[
						107.491403,
						12.337206
					],
					[
						105.810524,
						11.567615
					],
					[
						106.24967,
						10.961812
					],
					[
						105.199915,
						10.88931
					],
					[
						104.334335,
						10.486544
					],
					[
						103.49728,
						10.632555
					]
				]
			]
		},
		id: "KHM",
		id2: "KH",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Cameroon"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						13.075822,
						2.267097
					],
					[
						12.951334,
						2.321616
					],
					[
						12.35938,
						2.192812
					],
					[
						11.751665,
						2.326758
					],
					[
						11.276449,
						2.261051
					],
					[
						9.649158,
						2.283866
					],
					[
						9.795196,
						3.073404
					],
					[
						9.404367,
						3.734527
					],
					[
						8.948116,
						3.904129
					],
					[
						8.744924,
						4.352215
					],
					[
						8.488816,
						4.495617
					],
					[
						8.500288,
						4.771983
					],
					[
						8.757533,
						5.479666
					],
					[
						9.233163,
						6.444491
					],
					[
						9.522706,
						6.453482
					],
					[
						10.118277,
						7.03877
					],
					[
						10.497375,
						7.055358
					],
					[
						11.058788,
						6.644427
					],
					[
						11.745774,
						6.981383
					],
					[
						11.839309,
						7.397042
					],
					[
						12.063946,
						7.799808
					],
					[
						12.218872,
						8.305824
					],
					[
						12.753672,
						8.717763
					],
					[
						12.955468,
						9.417772
					],
					[
						13.1676,
						9.640626
					],
					[
						13.308676,
						10.160362
					],
					[
						13.57295,
						10.798566
					],
					[
						14.415379,
						11.572369
					],
					[
						14.468192,
						11.904752
					],
					[
						14.577178,
						12.085361
					],
					[
						14.181336,
						12.483657
					],
					[
						14.213531,
						12.802035
					],
					[
						14.495787,
						12.859396
					],
					[
						14.893386,
						12.219048
					],
					[
						14.960152,
						11.555574
					],
					[
						14.923565,
						10.891325
					],
					[
						15.467873,
						9.982337
					],
					[
						14.909354,
						9.992129
					],
					[
						14.627201,
						9.920919
					],
					[
						14.171466,
						10.021378
					],
					[
						13.954218,
						9.549495
					],
					[
						14.544467,
						8.965861
					],
					[
						14.979996,
						8.796104
					],
					[
						15.120866,
						8.38215
					],
					[
						15.436092,
						7.692812
					],
					[
						15.27946,
						7.421925
					],
					[
						14.776545,
						6.408498
					],
					[
						14.53656,
						6.226959
					],
					[
						14.459407,
						5.451761
					],
					[
						14.558936,
						5.030598
					],
					[
						14.478372,
						4.732605
					],
					[
						14.950953,
						4.210389
					],
					[
						15.03622,
						3.851367
					],
					[
						15.405396,
						3.335301
					],
					[
						15.862732,
						3.013537
					],
					[
						15.907381,
						2.557389
					],
					[
						16.012852,
						2.26764
					],
					[
						15.940919,
						1.727673
					],
					[
						15.146342,
						1.964015
					],
					[
						14.337813,
						2.227875
					],
					[
						13.075822,
						2.267097
					]
				]
			]
		},
		id: "CMR",
		id2: "CM",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Canada"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-63.6645,
							46.55001
						],
						[
							-62.9393,
							46.41587
						],
						[
							-62.01208,
							46.44314
						],
						[
							-62.50391,
							46.03339
						],
						[
							-62.87433,
							45.96818
						],
						[
							-64.1428,
							46.39265
						],
						[
							-64.39261,
							46.72747
						],
						[
							-64.01486,
							47.03601
						],
						[
							-63.6645,
							46.55001
						]
					]
				],
				[
					[
						[
							-61.806305,
							49.10506
						],
						[
							-62.29318,
							49.08717
						],
						[
							-63.58926,
							49.40069
						],
						[
							-64.51912,
							49.87304
						],
						[
							-64.17322,
							49.95718
						],
						[
							-62.85829,
							49.70641
						],
						[
							-61.835585,
							49.28855
						],
						[
							-61.806305,
							49.10506
						]
					]
				],
				[
					[
						[
							-123.510002,
							48.510011
						],
						[
							-124.012891,
							48.370846
						],
						[
							-125.655013,
							48.825005
						],
						[
							-125.954994,
							49.179996
						],
						[
							-126.850004,
							49.53
						],
						[
							-127.029993,
							49.814996
						],
						[
							-128.059336,
							49.994959
						],
						[
							-128.444584,
							50.539138
						],
						[
							-128.358414,
							50.770648
						],
						[
							-127.308581,
							50.552574
						],
						[
							-126.695001,
							50.400903
						],
						[
							-125.755007,
							50.295018
						],
						[
							-125.415002,
							49.950001
						],
						[
							-124.920768,
							49.475275
						],
						[
							-123.922509,
							49.062484
						],
						[
							-123.510002,
							48.510011
						]
					]
				],
				[
					[
						[
							-56.134036,
							50.68701
						],
						[
							-56.795882,
							49.812309
						],
						[
							-56.143105,
							50.150117
						],
						[
							-55.471492,
							49.935815
						],
						[
							-55.822401,
							49.587129
						],
						[
							-54.935143,
							49.313011
						],
						[
							-54.473775,
							49.556691
						],
						[
							-53.476549,
							49.249139
						],
						[
							-53.786014,
							48.516781
						],
						[
							-53.086134,
							48.687804
						],
						[
							-52.958648,
							48.157164
						],
						[
							-52.648099,
							47.535548
						],
						[
							-53.069158,
							46.655499
						],
						[
							-53.521456,
							46.618292
						],
						[
							-54.178936,
							46.807066
						],
						[
							-53.961869,
							47.625207
						],
						[
							-54.240482,
							47.752279
						],
						[
							-55.400773,
							46.884994
						],
						[
							-55.997481,
							46.91972
						],
						[
							-55.291219,
							47.389562
						],
						[
							-56.250799,
							47.632545
						],
						[
							-57.325229,
							47.572807
						],
						[
							-59.266015,
							47.603348
						],
						[
							-59.419494,
							47.899454
						],
						[
							-58.796586,
							48.251525
						],
						[
							-59.231625,
							48.523188
						],
						[
							-58.391805,
							49.125581
						],
						[
							-57.35869,
							50.718274
						],
						[
							-56.73865,
							51.287438
						],
						[
							-55.870977,
							51.632094
						],
						[
							-55.406974,
							51.588273
						],
						[
							-55.600218,
							51.317075
						],
						[
							-56.134036,
							50.68701
						]
					]
				],
				[
					[
						[
							-132.710008,
							54.040009
						],
						[
							-132.710009,
							54.040009
						],
						[
							-132.710008,
							54.040009
						],
						[
							-132.710008,
							54.040009
						],
						[
							-131.74999,
							54.120004
						],
						[
							-132.04948,
							52.984621
						],
						[
							-131.179043,
							52.180433
						],
						[
							-131.57783,
							52.182371
						],
						[
							-132.180428,
							52.639707
						],
						[
							-132.549992,
							53.100015
						],
						[
							-133.054611,
							53.411469
						],
						[
							-133.239664,
							53.85108
						],
						[
							-133.180004,
							54.169975
						],
						[
							-132.710008,
							54.040009
						]
					]
				],
				[
					[
						[
							-79.26582,
							62.158675
						],
						[
							-79.65752,
							61.63308
						],
						[
							-80.09956,
							61.7181
						],
						[
							-80.36215,
							62.01649
						],
						[
							-80.315395,
							62.085565
						],
						[
							-79.92939,
							62.3856
						],
						[
							-79.52002,
							62.36371
						],
						[
							-79.26582,
							62.158675
						]
					]
				],
				[
					[
						[
							-81.89825,
							62.7108
						],
						[
							-83.06857,
							62.15922
						],
						[
							-83.77462,
							62.18231
						],
						[
							-83.99367,
							62.4528
						],
						[
							-83.25048,
							62.91409
						],
						[
							-81.87699,
							62.90458
						],
						[
							-81.89825,
							62.7108
						]
					]
				],
				[
					[
						[
							-85.161308,
							65.657285
						],
						[
							-84.975764,
							65.217518
						],
						[
							-84.464012,
							65.371772
						],
						[
							-83.882626,
							65.109618
						],
						[
							-82.787577,
							64.766693
						],
						[
							-81.642014,
							64.455136
						],
						[
							-81.55344,
							63.979609
						],
						[
							-80.817361,
							64.057486
						],
						[
							-80.103451,
							63.725981
						],
						[
							-80.99102,
							63.411246
						],
						[
							-82.547178,
							63.651722
						],
						[
							-83.108798,
							64.101876
						],
						[
							-84.100417,
							63.569712
						],
						[
							-85.523405,
							63.052379
						],
						[
							-85.866769,
							63.637253
						],
						[
							-87.221983,
							63.541238
						],
						[
							-86.35276,
							64.035833
						],
						[
							-86.224886,
							64.822917
						],
						[
							-85.883848,
							65.738778
						],
						[
							-85.161308,
							65.657285
						]
					]
				],
				[
					[
						[
							-75.86588,
							67.14886
						],
						[
							-76.98687,
							67.09873
						],
						[
							-77.2364,
							67.58809
						],
						[
							-76.81166,
							68.14856
						],
						[
							-75.89521,
							68.28721
						],
						[
							-75.1145,
							68.01036
						],
						[
							-75.10333,
							67.58202
						],
						[
							-75.21597,
							67.44425
						],
						[
							-75.86588,
							67.14886
						]
					]
				],
				[
					[
						[
							-95.647681,
							69.10769
						],
						[
							-96.269521,
							68.75704
						],
						[
							-97.617401,
							69.06003
						],
						[
							-98.431801,
							68.9507
						],
						[
							-99.797401,
							69.40003
						],
						[
							-98.917401,
							69.71003
						],
						[
							-98.218261,
							70.14354
						],
						[
							-97.157401,
							69.86003
						],
						[
							-96.557401,
							69.68003
						],
						[
							-96.257401,
							69.49003
						],
						[
							-95.647681,
							69.10769
						]
					]
				],
				[
					[
						[
							-90.5471,
							69.49766
						],
						[
							-90.55151,
							68.47499
						],
						[
							-89.21515,
							69.25873
						],
						[
							-88.01966,
							68.61508
						],
						[
							-88.31749,
							67.87338
						],
						[
							-87.35017,
							67.19872
						],
						[
							-86.30607,
							67.92146
						],
						[
							-85.57664,
							68.78456
						],
						[
							-85.52197,
							69.88211
						],
						[
							-84.10081,
							69.80539
						],
						[
							-82.62258,
							69.65826
						],
						[
							-81.28043,
							69.16202
						],
						[
							-81.2202,
							68.66567
						],
						[
							-81.96436,
							68.13253
						],
						[
							-81.25928,
							67.59716
						],
						[
							-81.38653,
							67.11078
						],
						[
							-83.34456,
							66.41154
						],
						[
							-84.73542,
							66.2573
						],
						[
							-85.76943,
							66.55833
						],
						[
							-86.0676,
							66.05625
						],
						[
							-87.03143,
							65.21297
						],
						[
							-87.32324,
							64.77563
						],
						[
							-88.48296,
							64.09897
						],
						[
							-89.91444,
							64.03273
						],
						[
							-90.70398,
							63.61017
						],
						[
							-90.77004,
							62.96021
						],
						[
							-91.93342,
							62.83508
						],
						[
							-93.15698,
							62.02469
						],
						[
							-94.24153,
							60.89865
						],
						[
							-94.62931,
							60.11021
						],
						[
							-94.6846,
							58.94882
						],
						[
							-93.21502,
							58.78212
						],
						[
							-92.76462,
							57.84571
						],
						[
							-92.29703,
							57.08709
						],
						[
							-90.89769,
							57.28468
						],
						[
							-89.03953,
							56.85172
						],
						[
							-88.03978,
							56.47162
						],
						[
							-87.32421,
							55.99914
						],
						[
							-86.07121,
							55.72383
						],
						[
							-85.01181,
							55.3026
						],
						[
							-83.36055,
							55.24489
						],
						[
							-82.27285,
							55.14832
						],
						[
							-82.4362,
							54.28227
						],
						[
							-82.12502,
							53.27703
						],
						[
							-81.40075,
							52.15788
						],
						[
							-79.91289,
							51.20842
						],
						[
							-79.14301,
							51.53393
						],
						[
							-78.60191,
							52.56208
						],
						[
							-79.12421,
							54.14145
						],
						[
							-79.82958,
							54.66772
						],
						[
							-78.22874,
							55.13645
						],
						[
							-77.0956,
							55.83741
						],
						[
							-76.54137,
							56.53423
						],
						[
							-76.62319,
							57.20263
						],
						[
							-77.30226,
							58.05209
						],
						[
							-78.51688,
							58.80458
						],
						[
							-77.33676,
							59.85261
						],
						[
							-77.77272,
							60.75788
						],
						[
							-78.10687,
							62.31964
						],
						[
							-77.41067,
							62.55053
						],
						[
							-75.69621,
							62.2784
						],
						[
							-74.6682,
							62.18111
						],
						[
							-73.83988,
							62.4438
						],
						[
							-72.90853,
							62.10507
						],
						[
							-71.67708,
							61.52535
						],
						[
							-71.37369,
							61.13717
						],
						[
							-69.59042,
							61.06141
						],
						[
							-69.62033,
							60.22125
						],
						[
							-69.2879,
							58.95736
						],
						[
							-68.37455,
							58.80106
						],
						[
							-67.64976,
							58.21206
						],
						[
							-66.20178,
							58.76731
						],
						[
							-65.24517,
							59.87071
						],
						[
							-64.58352,
							60.33558
						],
						[
							-63.80475,
							59.4426
						],
						[
							-62.50236,
							58.16708
						],
						[
							-61.39655,
							56.96745
						],
						[
							-61.79866,
							56.33945
						],
						[
							-60.46853,
							55.77548
						],
						[
							-59.56962,
							55.20407
						],
						[
							-57.97508,
							54.94549
						],
						[
							-57.3332,
							54.6265
						],
						[
							-56.93689,
							53.78032
						],
						[
							-56.15811,
							53.64749
						],
						[
							-55.75632,
							53.27036
						],
						[
							-55.68338,
							52.14664
						],
						[
							-56.40916,
							51.7707
						],
						[
							-57.12691,
							51.41972
						],
						[
							-58.77482,
							51.0643
						],
						[
							-60.03309,
							50.24277
						],
						[
							-61.72366,
							50.08046
						],
						[
							-63.86251,
							50.29099
						],
						[
							-65.36331,
							50.2982
						],
						[
							-66.39905,
							50.22897
						],
						[
							-67.23631,
							49.51156
						],
						[
							-68.51114,
							49.06836
						],
						[
							-69.95362,
							47.74488
						],
						[
							-71.10458,
							46.82171
						],
						[
							-70.25522,
							46.98606
						],
						[
							-68.65,
							48.3
						],
						[
							-66.55243,
							49.1331
						],
						[
							-65.05626,
							49.23278
						],
						[
							-64.17099,
							48.74248
						],
						[
							-65.11545,
							48.07085
						],
						[
							-64.79854,
							46.99297
						],
						[
							-64.47219,
							46.23849
						],
						[
							-63.17329,
							45.73902
						],
						[
							-61.52072,
							45.88377
						],
						[
							-60.51815,
							47.00793
						],
						[
							-60.4486,
							46.28264
						],
						[
							-59.80287,
							45.9204
						],
						[
							-61.03988,
							45.26525
						],
						[
							-63.25471,
							44.67014
						],
						[
							-64.24656,
							44.26553
						],
						[
							-65.36406,
							43.54523
						],
						[
							-66.1234,
							43.61867
						],
						[
							-66.16173,
							44.46512
						],
						[
							-64.42549,
							45.29204
						],
						[
							-66.02605,
							45.25931
						],
						[
							-67.13741,
							45.13753
						],
						[
							-67.79134,
							45.70281
						],
						[
							-67.79046,
							47.06636
						],
						[
							-68.23444,
							47.35486
						],
						[
							-68.905,
							47.185
						],
						[
							-69.237216,
							47.447781
						],
						[
							-69.99997,
							46.69307
						],
						[
							-70.305,
							45.915
						],
						[
							-70.66,
							45.46
						],
						[
							-71.08482,
							45.30524
						],
						[
							-71.405,
							45.255
						],
						[
							-71.50506,
							45.0082
						],
						[
							-73.34783,
							45.00738
						],
						[
							-74.867,
							45.00048
						],
						[
							-75.31821,
							44.81645
						],
						[
							-76.375,
							44.09631
						],
						[
							-76.5,
							44.018459
						],
						[
							-76.820034,
							43.628784
						],
						[
							-77.737885,
							43.629056
						],
						[
							-78.72028,
							43.625089
						],
						[
							-79.171674,
							43.466339
						],
						[
							-79.01,
							43.27
						],
						[
							-78.92,
							42.965
						],
						[
							-78.939362,
							42.863611
						],
						[
							-80.247448,
							42.3662
						],
						[
							-81.277747,
							42.209026
						],
						[
							-82.439278,
							41.675105
						],
						[
							-82.690089,
							41.675105
						],
						[
							-83.02981,
							41.832796
						],
						[
							-83.142,
							41.975681
						],
						[
							-83.12,
							42.08
						],
						[
							-82.9,
							42.43
						],
						[
							-82.43,
							42.98
						],
						[
							-82.137642,
							43.571088
						],
						[
							-82.337763,
							44.44
						],
						[
							-82.550925,
							45.347517
						],
						[
							-83.592851,
							45.816894
						],
						[
							-83.469551,
							45.994686
						],
						[
							-83.616131,
							46.116927
						],
						[
							-83.890765,
							46.116927
						],
						[
							-84.091851,
							46.275419
						],
						[
							-84.14212,
							46.512226
						],
						[
							-84.3367,
							46.40877
						],
						[
							-84.6049,
							46.4396
						],
						[
							-84.543749,
							46.538684
						],
						[
							-84.779238,
							46.637102
						],
						[
							-84.87608,
							46.900083
						],
						[
							-85.652363,
							47.220219
						],
						[
							-86.461991,
							47.553338
						],
						[
							-87.439793,
							47.94
						],
						[
							-88.378114,
							48.302918
						],
						[
							-89.272917,
							48.019808
						],
						[
							-89.6,
							48.01
						],
						[
							-90.83,
							48.27
						],
						[
							-91.64,
							48.14
						],
						[
							-92.61,
							48.45
						],
						[
							-93.63087,
							48.60926
						],
						[
							-94.32914,
							48.67074
						],
						[
							-94.64,
							48.84
						],
						[
							-94.81758,
							49.38905
						],
						[
							-95.15609,
							49.38425
						],
						[
							-95.15907,
							49
						],
						[
							-97.22872,
							49.0007
						],
						[
							-100.65,
							49
						],
						[
							-104.04826,
							48.99986
						],
						[
							-107.05,
							49
						],
						[
							-110.05,
							49
						],
						[
							-113,
							49
						],
						[
							-116.04818,
							49
						],
						[
							-117.03121,
							49
						],
						[
							-120,
							49
						],
						[
							-122.84,
							49
						],
						[
							-122.97421,
							49.002538
						],
						[
							-124.91024,
							49.98456
						],
						[
							-125.62461,
							50.41656
						],
						[
							-127.43561,
							50.83061
						],
						[
							-127.99276,
							51.71583
						],
						[
							-127.85032,
							52.32961
						],
						[
							-129.12979,
							52.75538
						],
						[
							-129.30523,
							53.56159
						],
						[
							-130.51497,
							54.28757
						],
						[
							-130.53611,
							54.80278
						],
						[
							-129.98,
							55.285
						],
						[
							-130.00778,
							55.91583
						],
						[
							-131.70781,
							56.55212
						],
						[
							-132.73042,
							57.69289
						],
						[
							-133.35556,
							58.41028
						],
						[
							-134.27111,
							58.86111
						],
						[
							-134.945,
							59.27056
						],
						[
							-135.47583,
							59.78778
						],
						[
							-136.47972,
							59.46389
						],
						[
							-137.4525,
							58.905
						],
						[
							-138.34089,
							59.56211
						],
						[
							-139.039,
							60
						],
						[
							-140.013,
							60.27682
						],
						[
							-140.99778,
							60.30639
						],
						[
							-140.9925,
							66.00003
						],
						[
							-140.986,
							69.712
						],
						[
							-139.12052,
							69.47102
						],
						[
							-137.54636,
							68.99002
						],
						[
							-136.50358,
							68.89804
						],
						[
							-135.62576,
							69.31512
						],
						[
							-134.41464,
							69.62743
						],
						[
							-132.92925,
							69.50534
						],
						[
							-131.43136,
							69.94451
						],
						[
							-129.79471,
							70.19369
						],
						[
							-129.10773,
							69.77927
						],
						[
							-128.36156,
							70.01286
						],
						[
							-128.13817,
							70.48384
						],
						[
							-127.44712,
							70.37721
						],
						[
							-125.75632,
							69.48058
						],
						[
							-124.42483,
							70.1584
						],
						[
							-124.28968,
							69.39969
						],
						[
							-123.06108,
							69.56372
						],
						[
							-122.6835,
							69.85553
						],
						[
							-121.47226,
							69.79778
						],
						[
							-119.94288,
							69.37786
						],
						[
							-117.60268,
							69.01128
						],
						[
							-116.22643,
							68.84151
						],
						[
							-115.2469,
							68.90591
						],
						[
							-113.89794,
							68.3989
						],
						[
							-115.30489,
							67.90261
						],
						[
							-113.49727,
							67.68815
						],
						[
							-110.798,
							67.80612
						],
						[
							-109.94619,
							67.98104
						],
						[
							-108.8802,
							67.38144
						],
						[
							-107.79239,
							67.88736
						],
						[
							-108.81299,
							68.31164
						],
						[
							-108.16721,
							68.65392
						],
						[
							-106.95,
							68.7
						],
						[
							-106.15,
							68.8
						],
						[
							-105.34282,
							68.56122
						],
						[
							-104.33791,
							68.018
						],
						[
							-103.22115,
							68.09775
						],
						[
							-101.45433,
							67.64689
						],
						[
							-99.90195,
							67.80566
						],
						[
							-98.4432,
							67.78165
						],
						[
							-98.5586,
							68.40394
						],
						[
							-97.66948,
							68.57864
						],
						[
							-96.11991,
							68.23939
						],
						[
							-96.12588,
							67.29338
						],
						[
							-95.48943,
							68.0907
						],
						[
							-94.685,
							68.06383
						],
						[
							-94.23282,
							69.06903
						],
						[
							-95.30408,
							69.68571
						],
						[
							-96.47131,
							70.08976
						],
						[
							-96.39115,
							71.19482
						],
						[
							-95.2088,
							71.92053
						],
						[
							-93.88997,
							71.76015
						],
						[
							-92.87818,
							71.31869
						],
						[
							-91.51964,
							70.19129
						],
						[
							-92.40692,
							69.69997
						],
						[
							-90.5471,
							69.49766
						]
					]
				],
				[
					[
						[
							-114.16717,
							73.12145
						],
						[
							-114.66634,
							72.65277
						],
						[
							-112.44102,
							72.9554
						],
						[
							-111.05039,
							72.4504
						],
						[
							-109.92035,
							72.96113
						],
						[
							-109.00654,
							72.63335
						],
						[
							-108.18835,
							71.65089
						],
						[
							-107.68599,
							72.06548
						],
						[
							-108.39639,
							73.08953
						],
						[
							-107.51645,
							73.23598
						],
						[
							-106.52259,
							73.07601
						],
						[
							-105.40246,
							72.67259
						],
						[
							-104.77484,
							71.6984
						],
						[
							-104.46476,
							70.99297
						],
						[
							-102.78537,
							70.49776
						],
						[
							-100.98078,
							70.02432
						],
						[
							-101.08929,
							69.58447
						],
						[
							-102.73116,
							69.50402
						],
						[
							-102.09329,
							69.11962
						],
						[
							-102.43024,
							68.75282
						],
						[
							-104.24,
							68.91
						],
						[
							-105.96,
							69.18
						],
						[
							-107.12254,
							69.11922
						],
						[
							-109,
							68.78
						],
						[
							-111.534149,
							68.630059
						],
						[
							-113.3132,
							68.53554
						],
						[
							-113.85496,
							69.00744
						],
						[
							-115.22,
							69.28
						],
						[
							-116.10794,
							69.16821
						],
						[
							-117.34,
							69.96
						],
						[
							-116.67473,
							70.06655
						],
						[
							-115.13112,
							70.2373
						],
						[
							-113.72141,
							70.19237
						],
						[
							-112.4161,
							70.36638
						],
						[
							-114.35,
							70.6
						],
						[
							-116.48684,
							70.52045
						],
						[
							-117.9048,
							70.54056
						],
						[
							-118.43238,
							70.9092
						],
						[
							-116.11311,
							71.30918
						],
						[
							-117.65568,
							71.2952
						],
						[
							-119.40199,
							71.55859
						],
						[
							-118.56267,
							72.30785
						],
						[
							-117.86642,
							72.70594
						],
						[
							-115.18909,
							73.31459
						],
						[
							-114.16717,
							73.12145
						]
					]
				],
				[
					[
						[
							-104.5,
							73.42
						],
						[
							-105.38,
							72.76
						],
						[
							-106.94,
							73.46
						],
						[
							-106.6,
							73.6
						],
						[
							-105.26,
							73.64
						],
						[
							-104.5,
							73.42
						]
					]
				],
				[
					[
						[
							-76.34,
							73.102685
						],
						[
							-76.251404,
							72.826385
						],
						[
							-77.314438,
							72.855545
						],
						[
							-78.39167,
							72.876656
						],
						[
							-79.486252,
							72.742203
						],
						[
							-79.775833,
							72.802902
						],
						[
							-80.876099,
							73.333183
						],
						[
							-80.833885,
							73.693184
						],
						[
							-80.353058,
							73.75972
						],
						[
							-78.064438,
							73.651932
						],
						[
							-76.34,
							73.102685
						]
					]
				],
				[
					[
						[
							-86.562179,
							73.157447
						],
						[
							-85.774371,
							72.534126
						],
						[
							-84.850112,
							73.340278
						],
						[
							-82.31559,
							73.750951
						],
						[
							-80.600088,
							72.716544
						],
						[
							-80.748942,
							72.061907
						],
						[
							-78.770639,
							72.352173
						],
						[
							-77.824624,
							72.749617
						],
						[
							-75.605845,
							72.243678
						],
						[
							-74.228616,
							71.767144
						],
						[
							-74.099141,
							71.33084
						],
						[
							-72.242226,
							71.556925
						],
						[
							-71.200015,
							70.920013
						],
						[
							-68.786054,
							70.525024
						],
						[
							-67.91497,
							70.121948
						],
						[
							-66.969033,
							69.186087
						],
						[
							-68.805123,
							68.720198
						],
						[
							-66.449866,
							68.067163
						],
						[
							-64.862314,
							67.847539
						],
						[
							-63.424934,
							66.928473
						],
						[
							-61.851981,
							66.862121
						],
						[
							-62.163177,
							66.160251
						],
						[
							-63.918444,
							64.998669
						],
						[
							-65.14886,
							65.426033
						],
						[
							-66.721219,
							66.388041
						],
						[
							-68.015016,
							66.262726
						],
						[
							-68.141287,
							65.689789
						],
						[
							-67.089646,
							65.108455
						],
						[
							-65.73208,
							64.648406
						],
						[
							-65.320168,
							64.382737
						],
						[
							-64.669406,
							63.392927
						],
						[
							-65.013804,
							62.674185
						],
						[
							-66.275045,
							62.945099
						],
						[
							-68.783186,
							63.74567
						],
						[
							-67.369681,
							62.883966
						],
						[
							-66.328297,
							62.280075
						],
						[
							-66.165568,
							61.930897
						],
						[
							-68.877367,
							62.330149
						],
						[
							-71.023437,
							62.910708
						],
						[
							-72.235379,
							63.397836
						],
						[
							-71.886278,
							63.679989
						],
						[
							-73.378306,
							64.193963
						],
						[
							-74.834419,
							64.679076
						],
						[
							-74.818503,
							64.389093
						],
						[
							-77.70998,
							64.229542
						],
						[
							-78.555949,
							64.572906
						],
						[
							-77.897281,
							65.309192
						],
						[
							-76.018274,
							65.326969
						],
						[
							-73.959795,
							65.454765
						],
						[
							-74.293883,
							65.811771
						],
						[
							-73.944912,
							66.310578
						],
						[
							-72.651167,
							67.284576
						],
						[
							-72.92606,
							67.726926
						],
						[
							-73.311618,
							68.069437
						],
						[
							-74.843307,
							68.554627
						],
						[
							-76.869101,
							68.894736
						],
						[
							-76.228649,
							69.147769
						],
						[
							-77.28737,
							69.76954
						],
						[
							-78.168634,
							69.826488
						],
						[
							-78.957242,
							70.16688
						],
						[
							-79.492455,
							69.871808
						],
						[
							-81.305471,
							69.743185
						],
						[
							-84.944706,
							69.966634
						],
						[
							-87.060003,
							70.260001
						],
						[
							-88.681713,
							70.410741
						],
						[
							-89.51342,
							70.762038
						],
						[
							-88.467721,
							71.218186
						],
						[
							-89.888151,
							71.222552
						],
						[
							-90.20516,
							72.235074
						],
						[
							-89.436577,
							73.129464
						],
						[
							-88.408242,
							73.537889
						],
						[
							-85.826151,
							73.803816
						],
						[
							-86.562179,
							73.157447
						]
					]
				],
				[
					[
						[
							-100.35642,
							73.84389
						],
						[
							-99.16387,
							73.63339
						],
						[
							-97.38,
							73.76
						],
						[
							-97.12,
							73.47
						],
						[
							-98.05359,
							72.99052
						],
						[
							-96.54,
							72.56
						],
						[
							-96.72,
							71.66
						],
						[
							-98.35966,
							71.27285
						],
						[
							-99.32286,
							71.35639
						],
						[
							-100.01482,
							71.73827
						],
						[
							-102.5,
							72.51
						],
						[
							-102.48,
							72.83
						],
						[
							-100.43836,
							72.70588
						],
						[
							-101.54,
							73.36
						],
						[
							-100.35642,
							73.84389
						]
					]
				],
				[
					[
						[
							-93.196296,
							72.771992
						],
						[
							-94.269047,
							72.024596
						],
						[
							-95.409856,
							72.061881
						],
						[
							-96.033745,
							72.940277
						],
						[
							-96.018268,
							73.43743
						],
						[
							-95.495793,
							73.862417
						],
						[
							-94.503658,
							74.134907
						],
						[
							-92.420012,
							74.100025
						],
						[
							-90.509793,
							73.856732
						],
						[
							-92.003965,
							72.966244
						],
						[
							-93.196296,
							72.771992
						]
					]
				],
				[
					[
						[
							-120.46,
							71.383602
						],
						[
							-123.09219,
							70.90164
						],
						[
							-123.62,
							71.34
						],
						[
							-125.928949,
							71.868688
						],
						[
							-125.5,
							72.292261
						],
						[
							-124.80729,
							73.02256
						],
						[
							-123.94,
							73.68
						],
						[
							-124.91775,
							74.29275
						],
						[
							-121.53788,
							74.44893
						],
						[
							-120.10978,
							74.24135
						],
						[
							-117.55564,
							74.18577
						],
						[
							-116.58442,
							73.89607
						],
						[
							-115.51081,
							73.47519
						],
						[
							-116.76794,
							73.22292
						],
						[
							-119.22,
							72.52
						],
						[
							-120.46,
							71.82
						],
						[
							-120.46,
							71.383602
						]
					]
				],
				[
					[
						[
							-93.612756,
							74.979997
						],
						[
							-94.156909,
							74.592347
						],
						[
							-95.608681,
							74.666864
						],
						[
							-96.820932,
							74.927623
						],
						[
							-96.288587,
							75.377828
						],
						[
							-94.85082,
							75.647218
						],
						[
							-93.977747,
							75.29649
						],
						[
							-93.612756,
							74.979997
						]
					]
				],
				[
					[
						[
							-98.5,
							76.72
						],
						[
							-97.735585,
							76.25656
						],
						[
							-97.704415,
							75.74344
						],
						[
							-98.16,
							75
						],
						[
							-99.80874,
							74.89744
						],
						[
							-100.88366,
							75.05736
						],
						[
							-100.86292,
							75.64075
						],
						[
							-102.50209,
							75.5638
						],
						[
							-102.56552,
							76.3366
						],
						[
							-101.48973,
							76.30537
						],
						[
							-99.98349,
							76.64634
						],
						[
							-98.57699,
							76.58859
						],
						[
							-98.5,
							76.72
						]
					]
				],
				[
					[
						[
							-108.21141,
							76.20168
						],
						[
							-107.81943,
							75.84552
						],
						[
							-106.92893,
							76.01282
						],
						[
							-105.881,
							75.9694
						],
						[
							-105.70498,
							75.47951
						],
						[
							-106.31347,
							75.00527
						],
						[
							-109.7,
							74.85
						],
						[
							-112.22307,
							74.41696
						],
						[
							-113.74381,
							74.39427
						],
						[
							-113.87135,
							74.72029
						],
						[
							-111.79421,
							75.1625
						],
						[
							-116.31221,
							75.04343
						],
						[
							-117.7104,
							75.2222
						],
						[
							-116.34602,
							76.19903
						],
						[
							-115.40487,
							76.47887
						],
						[
							-112.59056,
							76.14134
						],
						[
							-110.81422,
							75.54919
						],
						[
							-109.0671,
							75.47321
						],
						[
							-110.49726,
							76.42982
						],
						[
							-109.5811,
							76.79417
						],
						[
							-108.54859,
							76.67832
						],
						[
							-108.21141,
							76.20168
						]
					]
				],
				[
					[
						[
							-94.684086,
							77.097878
						],
						[
							-93.573921,
							76.776296
						],
						[
							-91.605023,
							76.778518
						],
						[
							-90.741846,
							76.449597
						],
						[
							-90.969661,
							76.074013
						],
						[
							-89.822238,
							75.847774
						],
						[
							-89.187083,
							75.610166
						],
						[
							-87.838276,
							75.566189
						],
						[
							-86.379192,
							75.482421
						],
						[
							-84.789625,
							75.699204
						],
						[
							-82.753445,
							75.784315
						],
						[
							-81.128531,
							75.713983
						],
						[
							-80.057511,
							75.336849
						],
						[
							-79.833933,
							74.923127
						],
						[
							-80.457771,
							74.657304
						],
						[
							-81.948843,
							74.442459
						],
						[
							-83.228894,
							74.564028
						],
						[
							-86.097452,
							74.410032
						],
						[
							-88.15035,
							74.392307
						],
						[
							-89.764722,
							74.515555
						],
						[
							-92.422441,
							74.837758
						],
						[
							-92.768285,
							75.38682
						],
						[
							-92.889906,
							75.882655
						],
						[
							-93.893824,
							76.319244
						],
						[
							-95.962457,
							76.441381
						],
						[
							-97.121379,
							76.751078
						],
						[
							-96.745123,
							77.161389
						],
						[
							-94.684086,
							77.097878
						]
					]
				],
				[
					[
						[
							-116.198587,
							77.645287
						],
						[
							-116.335813,
							76.876962
						],
						[
							-117.106051,
							76.530032
						],
						[
							-118.040412,
							76.481172
						],
						[
							-119.899318,
							76.053213
						],
						[
							-121.499995,
							75.900019
						],
						[
							-122.854924,
							76.116543
						],
						[
							-122.854925,
							76.116543
						],
						[
							-121.157535,
							76.864508
						],
						[
							-119.103939,
							77.51222
						],
						[
							-117.570131,
							77.498319
						],
						[
							-116.198587,
							77.645287
						]
					]
				],
				[
					[
						[
							-93.840003,
							77.519997
						],
						[
							-94.295608,
							77.491343
						],
						[
							-96.169654,
							77.555111
						],
						[
							-96.436304,
							77.834629
						],
						[
							-94.422577,
							77.820005
						],
						[
							-93.720656,
							77.634331
						],
						[
							-93.840003,
							77.519997
						]
					]
				],
				[
					[
						[
							-110.186938,
							77.697015
						],
						[
							-112.051191,
							77.409229
						],
						[
							-113.534279,
							77.732207
						],
						[
							-112.724587,
							78.05105
						],
						[
							-111.264443,
							78.152956
						],
						[
							-109.854452,
							77.996325
						],
						[
							-110.186938,
							77.697015
						]
					]
				],
				[
					[
						[
							-109.663146,
							78.601973
						],
						[
							-110.881314,
							78.40692
						],
						[
							-112.542091,
							78.407902
						],
						[
							-112.525891,
							78.550555
						],
						[
							-111.50001,
							78.849994
						],
						[
							-110.963661,
							78.804441
						],
						[
							-109.663146,
							78.601973
						]
					]
				],
				[
					[
						[
							-95.830295,
							78.056941
						],
						[
							-97.309843,
							77.850597
						],
						[
							-98.124289,
							78.082857
						],
						[
							-98.552868,
							78.458105
						],
						[
							-98.631984,
							78.87193
						],
						[
							-97.337231,
							78.831984
						],
						[
							-96.754399,
							78.765813
						],
						[
							-95.559278,
							78.418315
						],
						[
							-95.830295,
							78.056941
						]
					]
				],
				[
					[
						[
							-100.060192,
							78.324754
						],
						[
							-99.670939,
							77.907545
						],
						[
							-101.30394,
							78.018985
						],
						[
							-102.949809,
							78.343229
						],
						[
							-105.176133,
							78.380332
						],
						[
							-104.210429,
							78.67742
						],
						[
							-105.41958,
							78.918336
						],
						[
							-105.492289,
							79.301594
						],
						[
							-103.529282,
							79.165349
						],
						[
							-100.825158,
							78.800462
						],
						[
							-100.060192,
							78.324754
						]
					]
				],
				[
					[
						[
							-87.02,
							79.66
						],
						[
							-85.81435,
							79.3369
						],
						[
							-87.18756,
							79.0393
						],
						[
							-89.03535,
							78.28723
						],
						[
							-90.80436,
							78.21533
						],
						[
							-92.87669,
							78.34333
						],
						[
							-93.95116,
							78.75099
						],
						[
							-93.93574,
							79.11373
						],
						[
							-93.14524,
							79.3801
						],
						[
							-94.974,
							79.37248
						],
						[
							-96.07614,
							79.70502
						],
						[
							-96.70972,
							80.15777
						],
						[
							-96.01644,
							80.60233
						],
						[
							-95.32345,
							80.90729
						],
						[
							-94.29843,
							80.97727
						],
						[
							-94.73542,
							81.20646
						],
						[
							-92.40984,
							81.25739
						],
						[
							-91.13289,
							80.72345
						],
						[
							-89.45,
							80.509322
						],
						[
							-87.81,
							80.32
						],
						[
							-87.02,
							79.66
						]
					]
				],
				[
					[
						[
							-68.5,
							83.106322
						],
						[
							-65.82735,
							83.02801
						],
						[
							-63.68,
							82.9
						],
						[
							-61.85,
							82.6286
						],
						[
							-61.89388,
							82.36165
						],
						[
							-64.334,
							81.92775
						],
						[
							-66.75342,
							81.72527
						],
						[
							-67.65755,
							81.50141
						],
						[
							-65.48031,
							81.50657
						],
						[
							-67.84,
							80.9
						],
						[
							-69.4697,
							80.61683
						],
						[
							-71.18,
							79.8
						],
						[
							-73.2428,
							79.63415
						],
						[
							-73.88,
							79.430162
						],
						[
							-76.90773,
							79.32309
						],
						[
							-75.52924,
							79.19766
						],
						[
							-76.22046,
							79.01907
						],
						[
							-75.39345,
							78.52581
						],
						[
							-76.34354,
							78.18296
						],
						[
							-77.88851,
							77.89991
						],
						[
							-78.36269,
							77.50859
						],
						[
							-79.75951,
							77.20968
						],
						[
							-79.61965,
							76.98336
						],
						[
							-77.91089,
							77.022045
						],
						[
							-77.88911,
							76.777955
						],
						[
							-80.56125,
							76.17812
						],
						[
							-83.17439,
							76.45403
						],
						[
							-86.11184,
							76.29901
						],
						[
							-87.6,
							76.42
						],
						[
							-89.49068,
							76.47239
						],
						[
							-89.6161,
							76.95213
						],
						[
							-87.76739,
							77.17833
						],
						[
							-88.26,
							77.9
						],
						[
							-87.65,
							77.970222
						],
						[
							-84.97634,
							77.53873
						],
						[
							-86.34,
							78.18
						],
						[
							-87.96192,
							78.37181
						],
						[
							-87.15198,
							78.75867
						],
						[
							-85.37868,
							78.9969
						],
						[
							-85.09495,
							79.34543
						],
						[
							-86.50734,
							79.73624
						],
						[
							-86.93179,
							80.25145
						],
						[
							-84.19844,
							80.20836
						],
						[
							-83.408696,
							80.1
						],
						[
							-81.84823,
							80.46442
						],
						[
							-84.1,
							80.58
						],
						[
							-87.59895,
							80.51627
						],
						[
							-89.36663,
							80.85569
						],
						[
							-90.2,
							81.26
						],
						[
							-91.36786,
							81.5531
						],
						[
							-91.58702,
							81.89429
						],
						[
							-90.1,
							82.085
						],
						[
							-88.93227,
							82.11751
						],
						[
							-86.97024,
							82.27961
						],
						[
							-85.5,
							82.652273
						],
						[
							-84.260005,
							82.6
						],
						[
							-83.18,
							82.32
						],
						[
							-82.42,
							82.86
						],
						[
							-81.1,
							83.02
						],
						[
							-79.30664,
							83.13056
						],
						[
							-76.25,
							83.172059
						],
						[
							-75.71878,
							83.06404
						],
						[
							-72.83153,
							83.23324
						],
						[
							-70.665765,
							83.169781
						],
						[
							-68.5,
							83.106322
						]
					]
				]
			]
		},
		id: "CAN",
		id2: "CA",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Cayman Islands"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-80.8,
						19.2
					],
					[
						-81,
						19.2
					],
					[
						-81,
						19.4
					],
					[
						-80.8,
						19.4
					],
					[
						-81,
						19.2
					]
				]
			]
		},
		id: "CYM",
		id2: "KY",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Central African Republic"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						15.27946,
						7.421925
					],
					[
						16.106232,
						7.497088
					],
					[
						16.290562,
						7.754307
					],
					[
						16.456185,
						7.734774
					],
					[
						16.705988,
						7.508328
					],
					[
						17.96493,
						7.890914
					],
					[
						18.389555,
						8.281304
					],
					[
						18.911022,
						8.630895
					],
					[
						18.81201,
						8.982915
					],
					[
						19.094008,
						9.074847
					],
					[
						20.059685,
						9.012706
					],
					[
						21.000868,
						9.475985
					],
					[
						21.723822,
						10.567056
					],
					[
						22.231129,
						10.971889
					],
					[
						22.864165,
						11.142395
					],
					[
						22.977544,
						10.714463
					],
					[
						23.554304,
						10.089255
					],
					[
						23.55725,
						9.681218
					],
					[
						23.394779,
						9.265068
					],
					[
						23.459013,
						8.954286
					],
					[
						23.805813,
						8.666319
					],
					[
						24.567369,
						8.229188
					],
					[
						25.114932,
						7.825104
					],
					[
						25.124131,
						7.500085
					],
					[
						25.796648,
						6.979316
					],
					[
						26.213418,
						6.546603
					],
					[
						26.465909,
						5.946717
					],
					[
						27.213409,
						5.550953
					],
					[
						27.374226,
						5.233944
					],
					[
						27.044065,
						5.127853
					],
					[
						26.402761,
						5.150875
					],
					[
						25.650455,
						5.256088
					],
					[
						25.278798,
						5.170408
					],
					[
						25.128833,
						4.927245
					],
					[
						24.805029,
						4.897247
					],
					[
						24.410531,
						5.108784
					],
					[
						23.297214,
						4.609693
					],
					[
						22.84148,
						4.710126
					],
					[
						22.704124,
						4.633051
					],
					[
						22.405124,
						4.02916
					],
					[
						21.659123,
						4.224342
					],
					[
						20.927591,
						4.322786
					],
					[
						20.290679,
						4.691678
					],
					[
						19.467784,
						5.031528
					],
					[
						18.932312,
						4.709506
					],
					[
						18.542982,
						4.201785
					],
					[
						18.453065,
						3.504386
					],
					[
						17.8099,
						3.560196
					],
					[
						17.133042,
						3.728197
					],
					[
						16.537058,
						3.198255
					],
					[
						16.012852,
						2.26764
					],
					[
						15.907381,
						2.557389
					],
					[
						15.862732,
						3.013537
					],
					[
						15.405396,
						3.335301
					],
					[
						15.03622,
						3.851367
					],
					[
						14.950953,
						4.210389
					],
					[
						14.478372,
						4.732605
					],
					[
						14.558936,
						5.030598
					],
					[
						14.459407,
						5.451761
					],
					[
						14.53656,
						6.226959
					],
					[
						14.776545,
						6.408498
					],
					[
						15.27946,
						7.421925
					]
				]
			]
		},
		id: "CAF",
		id2: "CF",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Chad"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						14.495787,
						12.859396
					],
					[
						14.595781,
						13.330427
					],
					[
						13.954477,
						13.353449
					],
					[
						13.956699,
						13.996691
					],
					[
						13.540394,
						14.367134
					],
					[
						13.97217,
						15.68437
					],
					[
						15.247731,
						16.627306
					],
					[
						15.300441,
						17.92795
					],
					[
						15.685741,
						19.95718
					],
					[
						15.903247,
						20.387619
					],
					[
						15.487148,
						20.730415
					],
					[
						15.47106,
						21.04845
					],
					[
						15.096888,
						21.308519
					],
					[
						14.8513,
						22.86295
					],
					[
						15.86085,
						23.40972
					],
					[
						19.84926,
						21.49509
					],
					[
						23.83766,
						19.58047
					],
					[
						23.88689,
						15.61084
					],
					[
						23.02459,
						15.68072
					],
					[
						22.56795,
						14.94429
					],
					[
						22.30351,
						14.32682
					],
					[
						22.51202,
						14.09318
					],
					[
						22.18329,
						13.78648
					],
					[
						22.29658,
						13.37232
					],
					[
						22.03759,
						12.95546
					],
					[
						21.93681,
						12.58818
					],
					[
						22.28801,
						12.64605
					],
					[
						22.49762,
						12.26024
					],
					[
						22.50869,
						11.67936
					],
					[
						22.87622,
						11.38461
					],
					[
						22.864165,
						11.142395
					],
					[
						22.231129,
						10.971889
					],
					[
						21.723822,
						10.567056
					],
					[
						21.000868,
						9.475985
					],
					[
						20.059685,
						9.012706
					],
					[
						19.094008,
						9.074847
					],
					[
						18.81201,
						8.982915
					],
					[
						18.911022,
						8.630895
					],
					[
						18.389555,
						8.281304
					],
					[
						17.96493,
						7.890914
					],
					[
						16.705988,
						7.508328
					],
					[
						16.456185,
						7.734774
					],
					[
						16.290562,
						7.754307
					],
					[
						16.106232,
						7.497088
					],
					[
						15.27946,
						7.421925
					],
					[
						15.436092,
						7.692812
					],
					[
						15.120866,
						8.38215
					],
					[
						14.979996,
						8.796104
					],
					[
						14.544467,
						8.965861
					],
					[
						13.954218,
						9.549495
					],
					[
						14.171466,
						10.021378
					],
					[
						14.627201,
						9.920919
					],
					[
						14.909354,
						9.992129
					],
					[
						15.467873,
						9.982337
					],
					[
						14.923565,
						10.891325
					],
					[
						14.960152,
						11.555574
					],
					[
						14.89336,
						12.21905
					],
					[
						14.495787,
						12.859396
					]
				]
			]
		},
		id: "TCD",
		id2: "TD",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Chile"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-68.63401,
							-52.63637
						],
						[
							-68.63335,
							-54.8695
						],
						[
							-67.56244,
							-54.87001
						],
						[
							-66.95992,
							-54.89681
						],
						[
							-67.29103,
							-55.30124
						],
						[
							-68.14863,
							-55.61183
						],
						[
							-68.639991,
							-55.580018
						],
						[
							-69.2321,
							-55.49906
						],
						[
							-69.95809,
							-55.19843
						],
						[
							-71.00568,
							-55.05383
						],
						[
							-72.2639,
							-54.49514
						],
						[
							-73.2852,
							-53.95752
						],
						[
							-74.66253,
							-52.83749
						],
						[
							-73.8381,
							-53.04743
						],
						[
							-72.43418,
							-53.7154
						],
						[
							-71.10773,
							-54.07433
						],
						[
							-70.59178,
							-53.61583
						],
						[
							-70.26748,
							-52.93123
						],
						[
							-69.34565,
							-52.5183
						],
						[
							-68.63401,
							-52.63637
						]
					]
				],
				[
					[
						[
							-68.219913,
							-21.494347
						],
						[
							-67.82818,
							-22.872919
						],
						[
							-67.106674,
							-22.735925
						],
						[
							-66.985234,
							-22.986349
						],
						[
							-67.328443,
							-24.025303
						],
						[
							-68.417653,
							-24.518555
						],
						[
							-68.386001,
							-26.185016
						],
						[
							-68.5948,
							-26.506909
						],
						[
							-68.295542,
							-26.89934
						],
						[
							-69.001235,
							-27.521214
						],
						[
							-69.65613,
							-28.459141
						],
						[
							-70.01355,
							-29.367923
						],
						[
							-69.919008,
							-30.336339
						],
						[
							-70.535069,
							-31.36501
						],
						[
							-70.074399,
							-33.09121
						],
						[
							-69.814777,
							-33.273886
						],
						[
							-69.817309,
							-34.193571
						],
						[
							-70.388049,
							-35.169688
						],
						[
							-70.364769,
							-36.005089
						],
						[
							-71.121881,
							-36.658124
						],
						[
							-71.118625,
							-37.576827
						],
						[
							-70.814664,
							-38.552995
						],
						[
							-71.413517,
							-38.916022
						],
						[
							-71.680761,
							-39.808164
						],
						[
							-71.915734,
							-40.832339
						],
						[
							-71.746804,
							-42.051386
						],
						[
							-72.148898,
							-42.254888
						],
						[
							-71.915424,
							-43.408565
						],
						[
							-71.464056,
							-43.787611
						],
						[
							-71.793623,
							-44.207172
						],
						[
							-71.329801,
							-44.407522
						],
						[
							-71.222779,
							-44.784243
						],
						[
							-71.659316,
							-44.973689
						],
						[
							-71.552009,
							-45.560733
						],
						[
							-71.917258,
							-46.884838
						],
						[
							-72.447355,
							-47.738533
						],
						[
							-72.331161,
							-48.244238
						],
						[
							-72.648247,
							-48.878618
						],
						[
							-73.415436,
							-49.318436
						],
						[
							-73.328051,
							-50.378785
						],
						[
							-72.975747,
							-50.74145
						],
						[
							-72.309974,
							-50.67701
						],
						[
							-72.329404,
							-51.425956
						],
						[
							-71.914804,
							-52.009022
						],
						[
							-69.498362,
							-52.142761
						],
						[
							-68.571545,
							-52.299444
						],
						[
							-69.461284,
							-52.291951
						],
						[
							-69.94278,
							-52.537931
						],
						[
							-70.845102,
							-52.899201
						],
						[
							-71.006332,
							-53.833252
						],
						[
							-71.429795,
							-53.856455
						],
						[
							-72.557943,
							-53.53141
						],
						[
							-73.702757,
							-52.835069
						],
						[
							-73.702757,
							-52.83507
						],
						[
							-74.946763,
							-52.262754
						],
						[
							-75.260026,
							-51.629355
						],
						[
							-74.976632,
							-51.043396
						],
						[
							-75.479754,
							-50.378372
						],
						[
							-75.608015,
							-48.673773
						],
						[
							-75.18277,
							-47.711919
						],
						[
							-74.126581,
							-46.939253
						],
						[
							-75.644395,
							-46.647643
						],
						[
							-74.692154,
							-45.763976
						],
						[
							-74.351709,
							-44.103044
						],
						[
							-73.240356,
							-44.454961
						],
						[
							-72.717804,
							-42.383356
						],
						[
							-73.3889,
							-42.117532
						],
						[
							-73.701336,
							-43.365776
						],
						[
							-74.331943,
							-43.224958
						],
						[
							-74.017957,
							-41.794813
						],
						[
							-73.677099,
							-39.942213
						],
						[
							-73.217593,
							-39.258689
						],
						[
							-73.505559,
							-38.282883
						],
						[
							-73.588061,
							-37.156285
						],
						[
							-73.166717,
							-37.12378
						],
						[
							-72.553137,
							-35.50884
						],
						[
							-71.861732,
							-33.909093
						],
						[
							-71.43845,
							-32.418899
						],
						[
							-71.668721,
							-30.920645
						],
						[
							-71.370083,
							-30.095682
						],
						[
							-71.489894,
							-28.861442
						],
						[
							-70.905124,
							-27.64038
						],
						[
							-70.724954,
							-25.705924
						],
						[
							-70.403966,
							-23.628997
						],
						[
							-70.091246,
							-21.393319
						],
						[
							-70.16442,
							-19.756468
						],
						[
							-70.372572,
							-18.347975
						],
						[
							-69.858444,
							-18.092694
						],
						[
							-69.590424,
							-17.580012
						],
						[
							-69.100247,
							-18.260125
						],
						[
							-68.966818,
							-18.981683
						],
						[
							-68.442225,
							-19.405068
						],
						[
							-68.757167,
							-20.372658
						],
						[
							-68.219913,
							-21.494347
						]
					]
				]
			]
		},
		id: "CHL",
		id2: "CL",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "China"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							110.339188,
							18.678395
						],
						[
							109.47521,
							18.197701
						],
						[
							108.655208,
							18.507682
						],
						[
							108.626217,
							19.367888
						],
						[
							109.119056,
							19.821039
						],
						[
							110.211599,
							20.101254
						],
						[
							110.786551,
							20.077534
						],
						[
							111.010051,
							19.69593
						],
						[
							110.570647,
							19.255879
						],
						[
							110.339188,
							18.678395
						]
					],
					[
						[
							113.80678,
							22.54834
						],
						[
							113.80678,
							22.251367
						],
						[
							113.481078,
							22.251367
						],
						[
							113.80678,
							22.54834
						]
					],
					[
						[
							114.463827,
							22.568074
						],
						[
							114.152547,
							22.22376
						],
						[
							113.80678,
							22.54834
						],
						[
							114.153827,
							22.74834
						],
						[
							114.463827,
							22.568074
						]
					],
					[
						[
							121.777818,
							24.394274
						],
						[
							121.175632,
							22.790857
						],
						[
							120.74708,
							21.970571
						],
						[
							120.220083,
							22.814861
						],
						[
							120.106189,
							23.556263
						],
						[
							120.69468,
							24.538451
						],
						[
							121.495044,
							25.295459
						],
						[
							121.951244,
							24.997596
						],
						[
							121.777818,
							24.394274
						]
					]
				],
				[
					[
						[
							127.657407,
							49.76027
						],
						[
							129.397818,
							49.4406
						],
						[
							130.582293,
							48.729687
						],
						[
							130.987282,
							47.790132
						],
						[
							132.506672,
							47.78897
						],
						[
							133.373596,
							48.183442
						],
						[
							135.026311,
							48.47823
						],
						[
							134.500814,
							47.57844
						],
						[
							134.112362,
							47.212467
						],
						[
							133.769644,
							46.116927
						],
						[
							133.097127,
							45.144066
						],
						[
							131.883454,
							45.321162
						],
						[
							131.025212,
							44.967953
						],
						[
							131.288555,
							44.11152
						],
						[
							131.144688,
							42.92999
						],
						[
							130.633866,
							42.903015
						],
						[
							130.640016,
							42.395009
						],
						[
							129.994267,
							42.985387
						],
						[
							129.596669,
							42.424982
						],
						[
							128.052215,
							41.994285
						],
						[
							128.208433,
							41.466772
						],
						[
							127.343783,
							41.503152
						],
						[
							126.869083,
							41.816569
						],
						[
							126.182045,
							41.107336
						],
						[
							125.079942,
							40.569824
						],
						[
							124.265625,
							39.928493
						],
						[
							122.86757,
							39.637788
						],
						[
							122.131388,
							39.170452
						],
						[
							121.054554,
							38.897471
						],
						[
							121.585995,
							39.360854
						],
						[
							121.376757,
							39.750261
						],
						[
							122.168595,
							40.422443
						],
						[
							121.640359,
							40.94639
						],
						[
							120.768629,
							40.593388
						],
						[
							119.639602,
							39.898056
						],
						[
							119.023464,
							39.252333
						],
						[
							118.042749,
							39.204274
						],
						[
							117.532702,
							38.737636
						],
						[
							118.059699,
							38.061476
						],
						[
							118.87815,
							37.897325
						],
						[
							118.911636,
							37.448464
						],
						[
							119.702802,
							37.156389
						],
						[
							120.823457,
							37.870428
						],
						[
							121.711259,
							37.481123
						],
						[
							122.357937,
							37.454484
						],
						[
							122.519995,
							36.930614
						],
						[
							121.104164,
							36.651329
						],
						[
							120.637009,
							36.11144
						],
						[
							119.664562,
							35.609791
						],
						[
							119.151208,
							34.909859
						],
						[
							120.227525,
							34.360332
						],
						[
							120.620369,
							33.376723
						],
						[
							121.229014,
							32.460319
						],
						[
							121.908146,
							31.692174
						],
						[
							121.891919,
							30.949352
						],
						[
							121.264257,
							30.676267
						],
						[
							121.503519,
							30.142915
						],
						[
							122.092114,
							29.83252
						],
						[
							121.938428,
							29.018022
						],
						[
							121.684439,
							28.225513
						],
						[
							121.125661,
							28.135673
						],
						[
							120.395473,
							27.053207
						],
						[
							119.585497,
							25.740781
						],
						[
							118.656871,
							24.547391
						],
						[
							117.281606,
							23.624501
						],
						[
							115.890735,
							22.782873
						],
						[
							114.763827,
							22.668074
						],
						[
							114.463827,
							22.54834
						],
						[
							114.153827,
							22.74834
						],
						[
							113.80678,
							22.54834
						],
						[
							113.241078,
							22.051367
						],
						[
							111.843592,
							21.550494
						],
						[
							110.785466,
							21.397144
						],
						[
							110.444039,
							20.341033
						],
						[
							109.889861,
							20.282457
						],
						[
							109.627655,
							21.008227
						],
						[
							109.864488,
							21.395051
						],
						[
							108.522813,
							21.715212
						],
						[
							108.05018,
							21.55238
						],
						[
							107.04342,
							21.811899
						],
						[
							106.567273,
							22.218205
						],
						[
							106.725403,
							22.794268
						],
						[
							105.811247,
							22.976892
						],
						[
							105.329209,
							23.352063
						],
						[
							104.476858,
							22.81915
						],
						[
							103.504515,
							22.703757
						],
						[
							102.706992,
							22.708795
						],
						[
							102.170436,
							22.464753
						],
						[
							101.652018,
							22.318199
						],
						[
							101.80312,
							21.174367
						],
						[
							101.270026,
							21.201652
						],
						[
							101.180005,
							21.436573
						],
						[
							101.150033,
							21.849984
						],
						[
							100.416538,
							21.558839
						],
						[
							99.983489,
							21.742937
						],
						[
							99.240899,
							22.118314
						],
						[
							99.531992,
							22.949039
						],
						[
							98.898749,
							23.142722
						],
						[
							98.660262,
							24.063286
						],
						[
							97.60472,
							23.897405
						],
						[
							97.724609,
							25.083637
						],
						[
							98.671838,
							25.918703
						],
						[
							98.712094,
							26.743536
						],
						[
							98.68269,
							27.508812
						],
						[
							98.246231,
							27.747221
						],
						[
							97.911988,
							28.335945
						],
						[
							97.327114,
							28.261583
						],
						[
							96.248833,
							28.411031
						],
						[
							96.586591,
							28.83098
						],
						[
							96.117679,
							29.452802
						],
						[
							95.404802,
							29.031717
						],
						[
							94.56599,
							29.277438
						],
						[
							93.413348,
							28.640629
						],
						[
							92.503119,
							27.896876
						],
						[
							91.696657,
							27.771742
						],
						[
							91.258854,
							28.040614
						],
						[
							90.730514,
							28.064954
						],
						[
							90.015829,
							28.296439
						],
						[
							89.47581,
							28.042759
						],
						[
							88.814248,
							27.299316
						],
						[
							88.730326,
							28.086865
						],
						[
							88.120441,
							27.876542
						],
						[
							86.954517,
							27.974262
						],
						[
							85.82332,
							28.203576
						],
						[
							85.011638,
							28.642774
						],
						[
							84.23458,
							28.839894
						],
						[
							83.898993,
							29.320226
						],
						[
							83.337115,
							29.463732
						],
						[
							82.327513,
							30.115268
						],
						[
							81.525804,
							30.422717
						],
						[
							81.111256,
							30.183481
						],
						[
							79.721367,
							30.882715
						],
						[
							78.738894,
							31.515906
						],
						[
							78.458446,
							32.618164
						],
						[
							79.176129,
							32.48378
						],
						[
							79.208892,
							32.994395
						],
						[
							78.811086,
							33.506198
						],
						[
							78.912269,
							34.321936
						],
						[
							77.837451,
							35.49401
						],
						[
							76.192848,
							35.898403
						],
						[
							75.896897,
							36.666806
						],
						[
							75.158028,
							37.133031
						],
						[
							74.980002,
							37.41999
						],
						[
							74.829986,
							37.990007
						],
						[
							74.864816,
							38.378846
						],
						[
							74.257514,
							38.606507
						],
						[
							73.928852,
							38.505815
						],
						[
							73.675379,
							39.431237
						],
						[
							73.960013,
							39.660008
						],
						[
							73.822244,
							39.893973
						],
						[
							74.776862,
							40.366425
						],
						[
							75.467828,
							40.562072
						],
						[
							76.526368,
							40.427946
						],
						[
							76.904484,
							41.066486
						],
						[
							78.187197,
							41.185316
						],
						[
							78.543661,
							41.582243
						],
						[
							80.11943,
							42.123941
						],
						[
							80.25999,
							42.349999
						],
						[
							80.18015,
							42.920068
						],
						[
							80.866206,
							43.180362
						],
						[
							79.966106,
							44.917517
						],
						[
							81.947071,
							45.317027
						],
						[
							82.458926,
							45.53965
						],
						[
							83.180484,
							47.330031
						],
						[
							85.16429,
							47.000956
						],
						[
							85.720484,
							47.452969
						],
						[
							85.768233,
							48.455751
						],
						[
							86.598776,
							48.549182
						],
						[
							87.35997,
							49.214981
						],
						[
							87.751264,
							49.297198
						],
						[
							88.013832,
							48.599463
						],
						[
							88.854298,
							48.069082
						],
						[
							90.280826,
							47.693549
						],
						[
							90.970809,
							46.888146
						],
						[
							90.585768,
							45.719716
						],
						[
							90.94554,
							45.286073
						],
						[
							92.133891,
							45.115076
						],
						[
							93.480734,
							44.975472
						],
						[
							94.688929,
							44.352332
						],
						[
							95.306875,
							44.241331
						],
						[
							95.762455,
							43.319449
						],
						[
							96.349396,
							42.725635
						],
						[
							97.451757,
							42.74889
						],
						[
							99.515817,
							42.524691
						],
						[
							100.845866,
							42.663804
						],
						[
							101.83304,
							42.514873
						],
						[
							103.312278,
							41.907468
						],
						[
							104.522282,
							41.908347
						],
						[
							104.964994,
							41.59741
						],
						[
							106.129316,
							42.134328
						],
						[
							107.744773,
							42.481516
						],
						[
							109.243596,
							42.519446
						],
						[
							110.412103,
							42.871234
						],
						[
							111.129682,
							43.406834
						],
						[
							111.829588,
							43.743118
						],
						[
							111.667737,
							44.073176
						],
						[
							111.348377,
							44.457442
						],
						[
							111.873306,
							45.102079
						],
						[
							112.436062,
							45.011646
						],
						[
							113.463907,
							44.808893
						],
						[
							114.460332,
							45.339817
						],
						[
							115.985096,
							45.727235
						],
						[
							116.717868,
							46.388202
						],
						[
							117.421701,
							46.672733
						],
						[
							118.874326,
							46.805412
						],
						[
							119.66327,
							46.69268
						],
						[
							119.772824,
							47.048059
						],
						[
							118.866574,
							47.74706
						],
						[
							118.064143,
							48.06673
						],
						[
							117.295507,
							47.697709
						],
						[
							116.308953,
							47.85341
						],
						[
							115.742837,
							47.726545
						],
						[
							115.485282,
							48.135383
						],
						[
							116.191802,
							49.134598
						],
						[
							116.678801,
							49.888531
						],
						[
							117.879244,
							49.510983
						],
						[
							119.288461,
							50.142883
						],
						[
							119.279366,
							50.582908
						],
						[
							120.18205,
							51.643566
						],
						[
							120.738191,
							51.964115
						],
						[
							120.725789,
							52.516226
						],
						[
							120.177089,
							52.753886
						],
						[
							121.003085,
							53.251401
						],
						[
							122.245748,
							53.431726
						],
						[
							123.571507,
							53.458804
						],
						[
							125.068211,
							53.161045
						],
						[
							125.946349,
							52.792799
						],
						[
							126.564399,
							51.784255
						],
						[
							126.939157,
							51.353894
						],
						[
							127.287456,
							50.739797
						],
						[
							127.657407,
							49.76027
						]
					]
				]
			]
		},
		id: "CHN",
		id2: "CN",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							105.7,
							-10.51
						],
						[
							105.63,
							-10.44
						],
						[
							105.74,
							-10.38
						],
						[
							105.7,
							-10.51
						]
					]
				]
			]
		},
		properties: {
			name: "Christmas Island"
		},
		id2: "CX",
		id: "CXR",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							96.86,
							-12.2
						],
						[
							96.82,
							-12.18
						],
						[
							96.83,
							-12.13
						],
						[
							96.86,
							-12.2
						]
					]
				]
			]
		},
		properties: {
			name: "Cocos (Keeling) Islands"
		},
		id2: "CC",
		id: "CCK",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Colombia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-75.373223,
						-0.152032
					],
					[
						-75.801466,
						0.084801
					],
					[
						-76.292314,
						0.416047
					],
					[
						-76.57638,
						0.256936
					],
					[
						-77.424984,
						0.395687
					],
					[
						-77.668613,
						0.825893
					],
					[
						-77.855061,
						0.809925
					],
					[
						-78.855259,
						1.380924
					],
					[
						-78.990935,
						1.69137
					],
					[
						-78.617831,
						1.766404
					],
					[
						-78.662118,
						2.267355
					],
					[
						-78.42761,
						2.629556
					],
					[
						-77.931543,
						2.696606
					],
					[
						-77.510431,
						3.325017
					],
					[
						-77.12769,
						3.849636
					],
					[
						-77.496272,
						4.087606
					],
					[
						-77.307601,
						4.667984
					],
					[
						-77.533221,
						5.582812
					],
					[
						-77.318815,
						5.845354
					],
					[
						-77.476661,
						6.691116
					],
					[
						-77.881571,
						7.223771
					],
					[
						-77.753414,
						7.70984
					],
					[
						-77.431108,
						7.638061
					],
					[
						-77.242566,
						7.935278
					],
					[
						-77.474723,
						8.524286
					],
					[
						-77.353361,
						8.670505
					],
					[
						-76.836674,
						8.638749
					],
					[
						-76.086384,
						9.336821
					],
					[
						-75.6746,
						9.443248
					],
					[
						-75.664704,
						9.774003
					],
					[
						-75.480426,
						10.61899
					],
					[
						-74.906895,
						11.083045
					],
					[
						-74.276753,
						11.102036
					],
					[
						-74.197223,
						11.310473
					],
					[
						-73.414764,
						11.227015
					],
					[
						-72.627835,
						11.731972
					],
					[
						-72.238195,
						11.95555
					],
					[
						-71.75409,
						12.437303
					],
					[
						-71.399822,
						12.376041
					],
					[
						-71.137461,
						12.112982
					],
					[
						-71.331584,
						11.776284
					],
					[
						-71.973922,
						11.608672
					],
					[
						-72.227575,
						11.108702
					],
					[
						-72.614658,
						10.821975
					],
					[
						-72.905286,
						10.450344
					],
					[
						-73.027604,
						9.73677
					],
					[
						-73.304952,
						9.152
					],
					[
						-72.78873,
						9.085027
					],
					[
						-72.660495,
						8.625288
					],
					[
						-72.439862,
						8.405275
					],
					[
						-72.360901,
						8.002638
					],
					[
						-72.479679,
						7.632506
					],
					[
						-72.444487,
						7.423785
					],
					[
						-72.198352,
						7.340431
					],
					[
						-71.960176,
						6.991615
					],
					[
						-70.674234,
						7.087785
					],
					[
						-70.093313,
						6.960376
					],
					[
						-69.38948,
						6.099861
					],
					[
						-68.985319,
						6.206805
					],
					[
						-68.265052,
						6.153268
					],
					[
						-67.695087,
						6.267318
					],
					[
						-67.34144,
						6.095468
					],
					[
						-67.521532,
						5.55687
					],
					[
						-67.744697,
						5.221129
					],
					[
						-67.823012,
						4.503937
					],
					[
						-67.621836,
						3.839482
					],
					[
						-67.337564,
						3.542342
					],
					[
						-67.303173,
						3.318454
					],
					[
						-67.809938,
						2.820655
					],
					[
						-67.447092,
						2.600281
					],
					[
						-67.181294,
						2.250638
					],
					[
						-66.876326,
						1.253361
					],
					[
						-67.065048,
						1.130112
					],
					[
						-67.259998,
						1.719999
					],
					[
						-67.53781,
						2.037163
					],
					[
						-67.868565,
						1.692455
					],
					[
						-69.816973,
						1.714805
					],
					[
						-69.804597,
						1.089081
					],
					[
						-69.218638,
						0.985677
					],
					[
						-69.252434,
						0.602651
					],
					[
						-69.452396,
						0.706159
					],
					[
						-70.015566,
						0.541414
					],
					[
						-70.020656,
						-0.185156
					],
					[
						-69.577065,
						-0.549992
					],
					[
						-69.420486,
						-1.122619
					],
					[
						-69.444102,
						-1.556287
					],
					[
						-69.893635,
						-4.298187
					],
					[
						-70.394044,
						-3.766591
					],
					[
						-70.692682,
						-3.742872
					],
					[
						-70.047709,
						-2.725156
					],
					[
						-70.813476,
						-2.256865
					],
					[
						-71.413646,
						-2.342802
					],
					[
						-71.774761,
						-2.16979
					],
					[
						-72.325787,
						-2.434218
					],
					[
						-73.070392,
						-2.308954
					],
					[
						-73.659504,
						-1.260491
					],
					[
						-74.122395,
						-1.002833
					],
					[
						-74.441601,
						-0.53082
					],
					[
						-75.106625,
						-0.057205
					],
					[
						-75.373223,
						-0.152032
					]
				]
			]
		},
		id: "COL",
		id2: "CO",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							44.49,
							-12.09
						],
						[
							44.51,
							-12.38
						],
						[
							44.21,
							-12.16
						],
						[
							44.49,
							-12.09
						]
					]
				],
				[
					[
						[
							43.46,
							-11.94
						],
						[
							43.22,
							-11.76
						],
						[
							43.28,
							-11.38
						],
						[
							43.46,
							-11.94
						]
					]
				]
			]
		},
		properties: {
			name: "Comoros"
		},
		id2: "KM",
		id: "COM",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Democratic Republic of the Congo"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						30.83386,
						3.509166
					],
					[
						30.773347,
						2.339883
					],
					[
						31.174149,
						2.204465
					],
					[
						30.85267,
						1.849396
					],
					[
						30.468508,
						1.583805
					],
					[
						30.086154,
						1.062313
					],
					[
						29.875779,
						0.59738
					],
					[
						29.819503,
						-0.20531
					],
					[
						29.587838,
						-0.587406
					],
					[
						29.579466,
						-1.341313
					],
					[
						29.291887,
						-1.620056
					],
					[
						29.254835,
						-2.21511
					],
					[
						29.117479,
						-2.292211
					],
					[
						29.024926,
						-2.839258
					],
					[
						29.276384,
						-3.293907
					],
					[
						29.339998,
						-4.499983
					],
					[
						29.519987,
						-5.419979
					],
					[
						29.419993,
						-5.939999
					],
					[
						29.620032,
						-6.520015
					],
					[
						30.199997,
						-7.079981
					],
					[
						30.740015,
						-8.340007
					],
					[
						30.346086,
						-8.238257
					],
					[
						29.002912,
						-8.407032
					],
					[
						28.734867,
						-8.526559
					],
					[
						28.449871,
						-9.164918
					],
					[
						28.673682,
						-9.605925
					],
					[
						28.49607,
						-10.789884
					],
					[
						28.372253,
						-11.793647
					],
					[
						28.642417,
						-11.971569
					],
					[
						29.341548,
						-12.360744
					],
					[
						29.616001,
						-12.178895
					],
					[
						29.699614,
						-13.257227
					],
					[
						28.934286,
						-13.248958
					],
					[
						28.523562,
						-12.698604
					],
					[
						28.155109,
						-12.272481
					],
					[
						27.388799,
						-12.132747
					],
					[
						27.16442,
						-11.608748
					],
					[
						26.553088,
						-11.92444
					],
					[
						25.75231,
						-11.784965
					],
					[
						25.418118,
						-11.330936
					],
					[
						24.78317,
						-11.238694
					],
					[
						24.314516,
						-11.262826
					],
					[
						24.257155,
						-10.951993
					],
					[
						23.912215,
						-10.926826
					],
					[
						23.456791,
						-10.867863
					],
					[
						22.837345,
						-11.017622
					],
					[
						22.402798,
						-10.993075
					],
					[
						22.155268,
						-11.084801
					],
					[
						22.208753,
						-9.894796
					],
					[
						21.875182,
						-9.523708
					],
					[
						21.801801,
						-8.908707
					],
					[
						21.949131,
						-8.305901
					],
					[
						21.746456,
						-7.920085
					],
					[
						21.728111,
						-7.290872
					],
					[
						20.514748,
						-7.299606
					],
					[
						20.601823,
						-6.939318
					],
					[
						20.091622,
						-6.94309
					],
					[
						20.037723,
						-7.116361
					],
					[
						19.417502,
						-7.155429
					],
					[
						19.166613,
						-7.738184
					],
					[
						19.016752,
						-7.988246
					],
					[
						18.464176,
						-7.847014
					],
					[
						18.134222,
						-7.987678
					],
					[
						17.47297,
						-8.068551
					],
					[
						17.089996,
						-7.545689
					],
					[
						16.860191,
						-7.222298
					],
					[
						16.57318,
						-6.622645
					],
					[
						16.326528,
						-5.87747
					],
					[
						13.375597,
						-5.864241
					],
					[
						13.024869,
						-5.984389
					],
					[
						12.735171,
						-5.965682
					],
					[
						12.322432,
						-6.100092
					],
					[
						12.182337,
						-5.789931
					],
					[
						12.436688,
						-5.684304
					],
					[
						12.468004,
						-5.248362
					],
					[
						12.631612,
						-4.991271
					],
					[
						12.995517,
						-4.781103
					],
					[
						13.25824,
						-4.882957
					],
					[
						13.600235,
						-4.500138
					],
					[
						14.144956,
						-4.510009
					],
					[
						14.209035,
						-4.793092
					],
					[
						14.582604,
						-4.970239
					],
					[
						15.170992,
						-4.343507
					],
					[
						15.75354,
						-3.855165
					],
					[
						16.00629,
						-3.535133
					],
					[
						15.972803,
						-2.712392
					],
					[
						16.407092,
						-1.740927
					],
					[
						16.865307,
						-1.225816
					],
					[
						17.523716,
						-0.74383
					],
					[
						17.638645,
						-0.424832
					],
					[
						17.663553,
						-0.058084
					],
					[
						17.82654,
						0.288923
					],
					[
						17.774192,
						0.855659
					],
					[
						17.898835,
						1.741832
					],
					[
						18.094276,
						2.365722
					],
					[
						18.393792,
						2.900443
					],
					[
						18.453065,
						3.504386
					],
					[
						18.542982,
						4.201785
					],
					[
						18.932312,
						4.709506
					],
					[
						19.467784,
						5.031528
					],
					[
						20.290679,
						4.691678
					],
					[
						20.927591,
						4.322786
					],
					[
						21.659123,
						4.224342
					],
					[
						22.405124,
						4.02916
					],
					[
						22.704124,
						4.633051
					],
					[
						22.84148,
						4.710126
					],
					[
						23.297214,
						4.609693
					],
					[
						24.410531,
						5.108784
					],
					[
						24.805029,
						4.897247
					],
					[
						25.128833,
						4.927245
					],
					[
						25.278798,
						5.170408
					],
					[
						25.650455,
						5.256088
					],
					[
						26.402761,
						5.150875
					],
					[
						27.044065,
						5.127853
					],
					[
						27.374226,
						5.233944
					],
					[
						27.979977,
						4.408413
					],
					[
						28.428994,
						4.287155
					],
					[
						28.696678,
						4.455077
					],
					[
						29.159078,
						4.389267
					],
					[
						29.715995,
						4.600805
					],
					[
						29.9535,
						4.173699
					],
					[
						30.83386,
						3.509166
					]
				]
			]
		},
		id: "COD",
		id2: "CD",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Republic of the Congo"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						12.995517,
						-4.781103
					],
					[
						12.62076,
						-4.438023
					],
					[
						12.318608,
						-4.60623
					],
					[
						11.914963,
						-5.037987
					],
					[
						11.093773,
						-3.978827
					],
					[
						11.855122,
						-3.426871
					],
					[
						11.478039,
						-2.765619
					],
					[
						11.820964,
						-2.514161
					],
					[
						12.495703,
						-2.391688
					],
					[
						12.575284,
						-1.948511
					],
					[
						13.109619,
						-2.42874
					],
					[
						13.992407,
						-2.470805
					],
					[
						14.29921,
						-1.998276
					],
					[
						14.425456,
						-1.333407
					],
					[
						14.316418,
						-0.552627
					],
					[
						13.843321,
						0.038758
					],
					[
						14.276266,
						1.19693
					],
					[
						14.026669,
						1.395677
					],
					[
						13.282631,
						1.314184
					],
					[
						13.003114,
						1.830896
					],
					[
						13.075822,
						2.267097
					],
					[
						14.337813,
						2.227875
					],
					[
						15.146342,
						1.964015
					],
					[
						15.940919,
						1.727673
					],
					[
						16.012852,
						2.26764
					],
					[
						16.537058,
						3.198255
					],
					[
						17.133042,
						3.728197
					],
					[
						17.8099,
						3.560196
					],
					[
						18.453065,
						3.504386
					],
					[
						18.393792,
						2.900443
					],
					[
						18.094276,
						2.365722
					],
					[
						17.898835,
						1.741832
					],
					[
						17.774192,
						0.855659
					],
					[
						17.82654,
						0.288923
					],
					[
						17.663553,
						-0.058084
					],
					[
						17.638645,
						-0.424832
					],
					[
						17.523716,
						-0.74383
					],
					[
						16.865307,
						-1.225816
					],
					[
						16.407092,
						-1.740927
					],
					[
						15.972803,
						-2.712392
					],
					[
						16.00629,
						-3.535133
					],
					[
						15.75354,
						-3.855165
					],
					[
						15.170992,
						-4.343507
					],
					[
						14.582604,
						-4.970239
					],
					[
						14.209035,
						-4.793092
					],
					[
						14.144956,
						-4.510009
					],
					[
						13.600235,
						-4.500138
					],
					[
						13.25824,
						-4.882957
					],
					[
						12.995517,
						-4.781103
					]
				]
			]
		},
		id: "COG",
		id2: "CG",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-157.89,
							-21.94
						],
						[
							-157.96,
							-21.9
						],
						[
							-157.92,
							-21.88
						],
						[
							-157.89,
							-21.94
						]
					]
				],
				[
					[
						[
							-159.74,
							-21.25
						],
						[
							-159.83,
							-21.2
						],
						[
							-159.75,
							-21.19
						],
						[
							-159.74,
							-21.25
						]
					]
				],
				[
					[
						[
							-157.32,
							-20.19
						],
						[
							-157.33,
							-20.13
						],
						[
							-157.31,
							-20.15
						],
						[
							-157.32,
							-20.19
						]
					]
				]
			]
		},
		properties: {
			name: "Cook Islands"
		},
		id2: "CK",
		id: "COK",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Costa Rica"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-82.965783,
						8.225028
					],
					[
						-83.508437,
						8.446927
					],
					[
						-83.711474,
						8.656836
					],
					[
						-83.596313,
						8.830443
					],
					[
						-83.632642,
						9.051386
					],
					[
						-83.909886,
						9.290803
					],
					[
						-84.303402,
						9.487354
					],
					[
						-84.647644,
						9.615537
					],
					[
						-84.713351,
						9.908052
					],
					[
						-84.97566,
						10.086723
					],
					[
						-84.911375,
						9.795992
					],
					[
						-85.110923,
						9.55704
					],
					[
						-85.339488,
						9.834542
					],
					[
						-85.660787,
						9.933347
					],
					[
						-85.797445,
						10.134886
					],
					[
						-85.791709,
						10.439337
					],
					[
						-85.659314,
						10.754331
					],
					[
						-85.941725,
						10.895278
					],
					[
						-85.71254,
						11.088445
					],
					[
						-85.561852,
						11.217119
					],
					[
						-84.903003,
						10.952303
					],
					[
						-84.673069,
						11.082657
					],
					[
						-84.355931,
						10.999226
					],
					[
						-84.190179,
						10.79345
					],
					[
						-83.895054,
						10.726839
					],
					[
						-83.655612,
						10.938764
					],
					[
						-83.40232,
						10.395438
					],
					[
						-83.015677,
						9.992982
					],
					[
						-82.546196,
						9.566135
					],
					[
						-82.932891,
						9.476812
					],
					[
						-82.927155,
						9.07433
					],
					[
						-82.719183,
						8.925709
					],
					[
						-82.868657,
						8.807266
					],
					[
						-82.829771,
						8.626295
					],
					[
						-82.913176,
						8.423517
					],
					[
						-82.965783,
						8.225028
					]
				]
			]
		},
		id: "CRI",
		id2: "CR",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Croatia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						18.829838,
						45.908878
					],
					[
						19.072769,
						45.521511
					],
					[
						19.390476,
						45.236516
					],
					[
						19.005486,
						44.860234
					],
					[
						18.553214,
						45.08159
					],
					[
						17.861783,
						45.06774
					],
					[
						17.002146,
						45.233777
					],
					[
						16.534939,
						45.211608
					],
					[
						16.318157,
						45.004127
					],
					[
						15.959367,
						45.233777
					],
					[
						15.750026,
						44.818712
					],
					[
						16.23966,
						44.351143
					],
					[
						16.456443,
						44.04124
					],
					[
						16.916156,
						43.667722
					],
					[
						17.297373,
						43.446341
					],
					[
						17.674922,
						43.028563
					],
					[
						18.56,
						42.65
					],
					[
						18.450016,
						42.479991
					],
					[
						17.50997,
						42.849995
					],
					[
						16.930006,
						43.209998
					],
					[
						16.015385,
						43.507215
					],
					[
						15.174454,
						44.243191
					],
					[
						15.37625,
						44.317915
					],
					[
						14.920309,
						44.738484
					],
					[
						14.901602,
						45.07606
					],
					[
						14.258748,
						45.233777
					],
					[
						13.952255,
						44.802124
					],
					[
						13.656976,
						45.136935
					],
					[
						13.679403,
						45.484149
					],
					[
						13.71506,
						45.500324
					],
					[
						14.411968,
						45.466166
					],
					[
						14.595109,
						45.634941
					],
					[
						14.935244,
						45.471695
					],
					[
						15.327675,
						45.452316
					],
					[
						15.323954,
						45.731783
					],
					[
						15.67153,
						45.834154
					],
					[
						15.768733,
						46.238108
					],
					[
						16.564808,
						46.503751
					],
					[
						16.882515,
						46.380632
					],
					[
						17.630066,
						45.951769
					],
					[
						18.456062,
						45.759481
					],
					[
						18.829838,
						45.908878
					]
				]
			]
		},
		id: "HRV",
		id2: "HR",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Cuba"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-82.268151,
						23.188611
					],
					[
						-81.404457,
						23.117271
					],
					[
						-80.618769,
						23.10598
					],
					[
						-79.679524,
						22.765303
					],
					[
						-79.281486,
						22.399202
					],
					[
						-78.347434,
						22.512166
					],
					[
						-77.993296,
						22.277194
					],
					[
						-77.146422,
						21.657851
					],
					[
						-76.523825,
						21.20682
					],
					[
						-76.19462,
						21.220565
					],
					[
						-75.598222,
						21.016624
					],
					[
						-75.67106,
						20.735091
					],
					[
						-74.933896,
						20.693905
					],
					[
						-74.178025,
						20.284628
					],
					[
						-74.296648,
						20.050379
					],
					[
						-74.961595,
						19.923435
					],
					[
						-75.63468,
						19.873774
					],
					[
						-76.323656,
						19.952891
					],
					[
						-77.755481,
						19.855481
					],
					[
						-77.085108,
						20.413354
					],
					[
						-77.492655,
						20.673105
					],
					[
						-78.137292,
						20.739949
					],
					[
						-78.482827,
						21.028613
					],
					[
						-78.719867,
						21.598114
					],
					[
						-79.285,
						21.559175
					],
					[
						-80.217475,
						21.827324
					],
					[
						-80.517535,
						22.037079
					],
					[
						-81.820943,
						22.192057
					],
					[
						-82.169992,
						22.387109
					],
					[
						-81.795002,
						22.636965
					],
					[
						-82.775898,
						22.68815
					],
					[
						-83.494459,
						22.168518
					],
					[
						-83.9088,
						22.154565
					],
					[
						-84.052151,
						21.910575
					],
					[
						-84.54703,
						21.801228
					],
					[
						-84.974911,
						21.896028
					],
					[
						-84.447062,
						22.20495
					],
					[
						-84.230357,
						22.565755
					],
					[
						-83.77824,
						22.788118
					],
					[
						-83.267548,
						22.983042
					],
					[
						-82.510436,
						23.078747
					],
					[
						-82.268151,
						23.188611
					]
				]
			]
		},
		id: "CUB",
		id2: "CU",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Curaçao"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-69.2,
						12
					],
					[
						-69.5,
						12
					],
					[
						-69.5,
						12.2
					],
					[
						-69.2,
						12.2
					],
					[
						-69.2,
						12
					]
				]
			]
		},
		id: "CUW",
		id2: "CW",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Cyprus"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						33.973617,
						35.058506
					],
					[
						34.004881,
						34.978098
					],
					[
						32.979827,
						34.571869
					],
					[
						32.490296,
						34.701655
					],
					[
						32.256667,
						35.103232
					],
					[
						32.73178,
						35.140026
					],
					[
						32.919572,
						35.087833
					],
					[
						33.190977,
						35.173125
					],
					[
						33.383833,
						35.162712
					],
					[
						33.455922,
						35.101424
					],
					[
						33.475817,
						35.000345
					],
					[
						33.525685,
						35.038688
					],
					[
						33.675392,
						35.017863
					],
					[
						33.86644,
						35.093595
					],
					[
						33.973617,
						35.058506
					]
				],
				[
					[
						32.73178,
						35.140026
					],
					[
						32.802474,
						35.145504
					],
					[
						32.946961,
						35.386703
					],
					[
						33.667227,
						35.373216
					],
					[
						34.576474,
						35.671596
					],
					[
						33.900804,
						35.245756
					],
					[
						33.973617,
						35.058506
					],
					[
						33.86644,
						35.093595
					],
					[
						33.675392,
						35.017863
					],
					[
						33.525685,
						35.038688
					],
					[
						33.475817,
						35.000345
					],
					[
						33.455922,
						35.101424
					],
					[
						33.383833,
						35.162712
					],
					[
						33.190977,
						35.173125
					],
					[
						32.919572,
						35.087833
					],
					[
						32.73178,
						35.140026
					]
				]
			]
		},
		id: "CYP",
		id2: "CY",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Czech Republic"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						16.960288,
						48.596982
					],
					[
						16.499283,
						48.785808
					],
					[
						16.029647,
						48.733899
					],
					[
						15.253416,
						49.039074
					],
					[
						14.901447,
						48.964402
					],
					[
						14.338898,
						48.555305
					],
					[
						13.595946,
						48.877172
					],
					[
						13.031329,
						49.307068
					],
					[
						12.521024,
						49.547415
					],
					[
						12.415191,
						49.969121
					],
					[
						12.240111,
						50.266338
					],
					[
						12.966837,
						50.484076
					],
					[
						13.338132,
						50.733234
					],
					[
						14.056228,
						50.926918
					],
					[
						14.307013,
						51.117268
					],
					[
						14.570718,
						51.002339
					],
					[
						15.016996,
						51.106674
					],
					[
						15.490972,
						50.78473
					],
					[
						16.238627,
						50.697733
					],
					[
						16.176253,
						50.422607
					],
					[
						16.719476,
						50.215747
					],
					[
						16.868769,
						50.473974
					],
					[
						17.554567,
						50.362146
					],
					[
						17.649445,
						50.049038
					],
					[
						18.392914,
						49.988629
					],
					[
						18.853144,
						49.49623
					],
					[
						18.554971,
						49.495015
					],
					[
						18.399994,
						49.315001
					],
					[
						18.170498,
						49.271515
					],
					[
						18.104973,
						49.043983
					],
					[
						17.913512,
						48.996493
					],
					[
						17.886485,
						48.903475
					],
					[
						17.545007,
						48.800019
					],
					[
						17.101985,
						48.816969
					],
					[
						16.960288,
						48.596982
					]
				]
			]
		},
		id: "CZE",
		id2: "CZ",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Ivory Coast"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-2.856125,
						4.994476
					],
					[
						-3.311084,
						4.984296
					],
					[
						-4.00882,
						5.179813
					],
					[
						-4.649917,
						5.168264
					],
					[
						-5.834496,
						4.993701
					],
					[
						-6.528769,
						4.705088
					],
					[
						-7.518941,
						4.338288
					],
					[
						-7.712159,
						4.364566
					],
					[
						-7.635368,
						5.188159
					],
					[
						-7.539715,
						5.313345
					],
					[
						-7.570153,
						5.707352
					],
					[
						-7.993693,
						6.12619
					],
					[
						-8.311348,
						6.193033
					],
					[
						-8.60288,
						6.467564
					],
					[
						-8.385452,
						6.911801
					],
					[
						-8.485446,
						7.395208
					],
					[
						-8.439298,
						7.686043
					],
					[
						-8.280703,
						7.68718
					],
					[
						-8.221792,
						8.123329
					],
					[
						-8.299049,
						8.316444
					],
					[
						-8.203499,
						8.455453
					],
					[
						-7.8321,
						8.575704
					],
					[
						-8.079114,
						9.376224
					],
					[
						-8.309616,
						9.789532
					],
					[
						-8.229337,
						10.12902
					],
					[
						-8.029944,
						10.206535
					],
					[
						-7.89959,
						10.297382
					],
					[
						-7.622759,
						10.147236
					],
					[
						-6.850507,
						10.138994
					],
					[
						-6.666461,
						10.430811
					],
					[
						-6.493965,
						10.411303
					],
					[
						-6.205223,
						10.524061
					],
					[
						-6.050452,
						10.096361
					],
					[
						-5.816926,
						10.222555
					],
					[
						-5.404342,
						10.370737
					],
					[
						-4.954653,
						10.152714
					],
					[
						-4.779884,
						9.821985
					],
					[
						-4.330247,
						9.610835
					],
					[
						-3.980449,
						9.862344
					],
					[
						-3.511899,
						9.900326
					],
					[
						-2.827496,
						9.642461
					],
					[
						-2.56219,
						8.219628
					],
					[
						-2.983585,
						7.379705
					],
					[
						-3.24437,
						6.250472
					],
					[
						-2.810701,
						5.389051
					],
					[
						-2.856125,
						4.994476
					]
				]
			]
		},
		id: "CIV",
		id2: "CI",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Denmark"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							12.690006,
							55.609991
						],
						[
							12.089991,
							54.800015
						],
						[
							11.043543,
							55.364864
						],
						[
							10.903914,
							55.779955
						],
						[
							12.370904,
							56.111407
						],
						[
							12.690006,
							55.609991
						]
					]
				],
				[
					[
						[
							10.912182,
							56.458621
						],
						[
							10.667804,
							56.081383
						],
						[
							10.369993,
							56.190007
						],
						[
							9.649985,
							55.469999
						],
						[
							9.921906,
							54.983104
						],
						[
							9.282049,
							54.830865
						],
						[
							8.526229,
							54.962744
						],
						[
							8.120311,
							55.517723
						],
						[
							8.089977,
							56.540012
						],
						[
							8.256582,
							56.809969
						],
						[
							8.543438,
							57.110003
						],
						[
							9.424469,
							57.172066
						],
						[
							9.775559,
							57.447941
						],
						[
							10.580006,
							57.730017
						],
						[
							10.546106,
							57.215733
						],
						[
							10.25,
							56.890016
						],
						[
							10.369993,
							56.609982
						],
						[
							10.912182,
							56.458621
						]
					]
				]
			]
		},
		id: "DNK",
		id2: "DK",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Djibouti"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						43.081226,
						12.699639
					],
					[
						43.317852,
						12.390148
					],
					[
						43.286381,
						11.974928
					],
					[
						42.715874,
						11.735641
					],
					[
						43.145305,
						11.46204
					],
					[
						42.776852,
						10.926879
					],
					[
						42.55493,
						11.10511
					],
					[
						42.31414,
						11.0342
					],
					[
						41.75557,
						11.05091
					],
					[
						41.73959,
						11.35511
					],
					[
						41.66176,
						11.6312
					],
					[
						42,
						12.1
					],
					[
						42.35156,
						12.54223
					],
					[
						42.779642,
						12.455416
					],
					[
						43.081226,
						12.699639
					]
				]
			]
		},
		id: "DJI",
		id2: "DJ",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-61.36,
							15.2
						],
						[
							-61.45,
							15.63
						],
						[
							-61.25,
							15.46
						],
						[
							-61.36,
							15.2
						]
					]
				]
			]
		},
		properties: {
			name: "Dominica"
		},
		id2: "DM",
		id: "DMA",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Dominican Republic"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-71.712361,
						19.714456
					],
					[
						-71.587304,
						19.884911
					],
					[
						-70.806706,
						19.880286
					],
					[
						-70.214365,
						19.622885
					],
					[
						-69.950815,
						19.648
					],
					[
						-69.76925,
						19.293267
					],
					[
						-69.222126,
						19.313214
					],
					[
						-69.254346,
						19.015196
					],
					[
						-68.809412,
						18.979074
					],
					[
						-68.317943,
						18.612198
					],
					[
						-68.689316,
						18.205142
					],
					[
						-69.164946,
						18.422648
					],
					[
						-69.623988,
						18.380713
					],
					[
						-69.952934,
						18.428307
					],
					[
						-70.133233,
						18.245915
					],
					[
						-70.517137,
						18.184291
					],
					[
						-70.669298,
						18.426886
					],
					[
						-70.99995,
						18.283329
					],
					[
						-71.40021,
						17.598564
					],
					[
						-71.657662,
						17.757573
					],
					[
						-71.708305,
						18.044997
					],
					[
						-71.687738,
						18.31666
					],
					[
						-71.945112,
						18.6169
					],
					[
						-71.701303,
						18.785417
					],
					[
						-71.624873,
						19.169838
					],
					[
						-71.712361,
						19.714456
					]
				]
			]
		},
		id: "DOM",
		id2: "DO",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Ecuador"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-80.302561,
						-3.404856
					],
					[
						-79.770293,
						-2.657512
					],
					[
						-79.986559,
						-2.220794
					],
					[
						-80.368784,
						-2.685159
					],
					[
						-80.967765,
						-2.246943
					],
					[
						-80.764806,
						-1.965048
					],
					[
						-80.933659,
						-1.057455
					],
					[
						-80.58337,
						-0.906663
					],
					[
						-80.399325,
						-0.283703
					],
					[
						-80.020898,
						0.36034
					],
					[
						-80.09061,
						0.768429
					],
					[
						-79.542762,
						0.982938
					],
					[
						-78.855259,
						1.380924
					],
					[
						-77.855061,
						0.809925
					],
					[
						-77.668613,
						0.825893
					],
					[
						-77.424984,
						0.395687
					],
					[
						-76.57638,
						0.256936
					],
					[
						-76.292314,
						0.416047
					],
					[
						-75.801466,
						0.084801
					],
					[
						-75.373223,
						-0.152032
					],
					[
						-75.233723,
						-0.911417
					],
					[
						-75.544996,
						-1.56161
					],
					[
						-76.635394,
						-2.608678
					],
					[
						-77.837905,
						-3.003021
					],
					[
						-78.450684,
						-3.873097
					],
					[
						-78.639897,
						-4.547784
					],
					[
						-79.205289,
						-4.959129
					],
					[
						-79.624979,
						-4.454198
					],
					[
						-80.028908,
						-4.346091
					],
					[
						-80.442242,
						-4.425724
					],
					[
						-80.469295,
						-4.059287
					],
					[
						-80.184015,
						-3.821162
					],
					[
						-80.302561,
						-3.404856
					]
				]
			]
		},
		id: "ECU",
		id2: "EC",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Egypt"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						34.9226,
						29.50133
					],
					[
						34.64174,
						29.09942
					],
					[
						34.42655,
						28.34399
					],
					[
						34.15451,
						27.8233
					],
					[
						33.92136,
						27.6487
					],
					[
						33.58811,
						27.97136
					],
					[
						33.13676,
						28.41765
					],
					[
						32.42323,
						29.85108
					],
					[
						32.32046,
						29.76043
					],
					[
						32.73482,
						28.70523
					],
					[
						33.34876,
						27.69989
					],
					[
						34.10455,
						26.14227
					],
					[
						34.47387,
						25.59856
					],
					[
						34.79507,
						25.03375
					],
					[
						35.69241,
						23.92671
					],
					[
						35.49372,
						23.75237
					],
					[
						35.52598,
						23.10244
					],
					[
						36.69069,
						22.20485
					],
					[
						36.86623,
						22
					],
					[
						32.9,
						22
					],
					[
						29.02,
						22
					],
					[
						25,
						22
					],
					[
						25,
						25.6825
					],
					[
						25,
						29.238655
					],
					[
						24.70007,
						30.04419
					],
					[
						24.95762,
						30.6616
					],
					[
						24.80287,
						31.08929
					],
					[
						25.16482,
						31.56915
					],
					[
						26.49533,
						31.58568
					],
					[
						27.45762,
						31.32126
					],
					[
						28.45048,
						31.02577
					],
					[
						28.91353,
						30.87005
					],
					[
						29.68342,
						31.18686
					],
					[
						30.09503,
						31.4734
					],
					[
						30.97693,
						31.55586
					],
					[
						31.68796,
						31.4296
					],
					[
						31.96041,
						30.9336
					],
					[
						32.19247,
						31.26034
					],
					[
						32.99392,
						31.02407
					],
					[
						33.7734,
						30.96746
					],
					[
						34.26544,
						31.21936
					],
					[
						34.9226,
						29.50133
					]
				]
			]
		},
		id: "EGY",
		id2: "EG",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "El Salvador"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-87.793111,
						13.38448
					],
					[
						-87.904112,
						13.149017
					],
					[
						-88.483302,
						13.163951
					],
					[
						-88.843228,
						13.259734
					],
					[
						-89.256743,
						13.458533
					],
					[
						-89.812394,
						13.520622
					],
					[
						-90.095555,
						13.735338
					],
					[
						-90.064678,
						13.88197
					],
					[
						-89.721934,
						14.134228
					],
					[
						-89.534219,
						14.244816
					],
					[
						-89.587343,
						14.362586
					],
					[
						-89.353326,
						14.424133
					],
					[
						-89.058512,
						14.340029
					],
					[
						-88.843073,
						14.140507
					],
					[
						-88.541231,
						13.980155
					],
					[
						-88.503998,
						13.845486
					],
					[
						-88.065343,
						13.964626
					],
					[
						-87.859515,
						13.893312
					],
					[
						-87.723503,
						13.78505
					],
					[
						-87.793111,
						13.38448
					]
				]
			]
		},
		id: "SLV",
		id2: "SV",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Equatorial Guinea"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						9.492889,
						1.01012
					],
					[
						9.305613,
						1.160911
					],
					[
						9.649158,
						2.283866
					],
					[
						11.276449,
						2.261051
					],
					[
						11.285079,
						1.057662
					],
					[
						9.830284,
						1.067894
					],
					[
						9.492889,
						1.01012
					]
				]
			]
		},
		id: "GNQ",
		id2: "GQ",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Eritrea"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						42.35156,
						12.54223
					],
					[
						42.00975,
						12.86582
					],
					[
						41.59856,
						13.45209
					],
					[
						41.155194,
						13.77332
					],
					[
						40.8966,
						14.11864
					],
					[
						40.026219,
						14.519579
					],
					[
						39.34061,
						14.53155
					],
					[
						39.0994,
						14.74064
					],
					[
						38.51295,
						14.50547
					],
					[
						37.90607,
						14.95943
					],
					[
						37.59377,
						14.2131
					],
					[
						36.42951,
						14.42211
					],
					[
						36.323189,
						14.822481
					],
					[
						36.75386,
						16.291874
					],
					[
						36.85253,
						16.95655
					],
					[
						37.16747,
						17.26314
					],
					[
						37.904,
						17.42754
					],
					[
						38.41009,
						17.998307
					],
					[
						38.990623,
						16.840626
					],
					[
						39.26611,
						15.922723
					],
					[
						39.814294,
						15.435647
					],
					[
						41.179275,
						14.49108
					],
					[
						41.734952,
						13.921037
					],
					[
						42.276831,
						13.343992
					],
					[
						42.589576,
						13.000421
					],
					[
						43.081226,
						12.699639
					],
					[
						42.779642,
						12.455416
					],
					[
						42.35156,
						12.54223
					]
				]
			]
		},
		id: "ERI",
		id2: "ER",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Estonia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						24.312863,
						57.793424
					],
					[
						24.428928,
						58.383413
					],
					[
						24.061198,
						58.257375
					],
					[
						23.42656,
						58.612753
					],
					[
						23.339795,
						59.18724
					],
					[
						24.604214,
						59.465854
					],
					[
						25.864189,
						59.61109
					],
					[
						26.949136,
						59.445803
					],
					[
						27.981114,
						59.475388
					],
					[
						28.131699,
						59.300825
					],
					[
						27.420166,
						58.724581
					],
					[
						27.716686,
						57.791899
					],
					[
						27.288185,
						57.474528
					],
					[
						26.463532,
						57.476389
					],
					[
						25.60281,
						57.847529
					],
					[
						25.164594,
						57.970157
					],
					[
						24.312863,
						57.793424
					]
				]
			]
		},
		id: "EST",
		id2: "EE",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Swaziland"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						32.071665,
						-26.73382
					],
					[
						31.86806,
						-27.177927
					],
					[
						31.282773,
						-27.285879
					],
					[
						30.685962,
						-26.743845
					],
					[
						30.676609,
						-26.398078
					],
					[
						30.949667,
						-26.022649
					],
					[
						31.04408,
						-25.731452
					],
					[
						31.333158,
						-25.660191
					],
					[
						31.837778,
						-25.843332
					],
					[
						31.985779,
						-26.29178
					],
					[
						32.071665,
						-26.73382
					]
				]
			]
		},
		id: "SWZ",
		id2: "SZ",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Ethiopia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						37.90607,
						14.95943
					],
					[
						38.51295,
						14.50547
					],
					[
						39.0994,
						14.74064
					],
					[
						39.34061,
						14.53155
					],
					[
						40.02625,
						14.51959
					],
					[
						40.8966,
						14.11864
					],
					[
						41.1552,
						13.77333
					],
					[
						41.59856,
						13.45209
					],
					[
						42.00975,
						12.86582
					],
					[
						42.35156,
						12.54223
					],
					[
						42,
						12.1
					],
					[
						41.66176,
						11.6312
					],
					[
						41.73959,
						11.35511
					],
					[
						41.75557,
						11.05091
					],
					[
						42.31414,
						11.0342
					],
					[
						42.55493,
						11.10511
					],
					[
						42.776852,
						10.926879
					],
					[
						42.55876,
						10.57258
					],
					[
						42.92812,
						10.02194
					],
					[
						43.29699,
						9.54048
					],
					[
						43.67875,
						9.18358
					],
					[
						46.94834,
						7.99688
					],
					[
						47.78942,
						8.003
					],
					[
						44.9636,
						5.00162
					],
					[
						43.66087,
						4.95755
					],
					[
						42.76967,
						4.25259
					],
					[
						42.12861,
						4.23413
					],
					[
						41.855083,
						3.918912
					],
					[
						41.1718,
						3.91909
					],
					[
						40.76848,
						4.25702
					],
					[
						39.85494,
						3.83879
					],
					[
						39.559384,
						3.42206
					],
					[
						38.89251,
						3.50074
					],
					[
						38.67114,
						3.61607
					],
					[
						38.43697,
						3.58851
					],
					[
						38.120915,
						3.598605
					],
					[
						36.855093,
						4.447864
					],
					[
						36.159079,
						4.447864
					],
					[
						35.817448,
						4.776966
					],
					[
						35.817448,
						5.338232
					],
					[
						35.298007,
						5.506
					],
					[
						34.70702,
						6.59422
					],
					[
						34.25032,
						6.82607
					],
					[
						34.0751,
						7.22595
					],
					[
						33.56829,
						7.71334
					],
					[
						32.95418,
						7.78497
					],
					[
						33.2948,
						8.35458
					],
					[
						33.8255,
						8.37916
					],
					[
						33.97498,
						8.68456
					],
					[
						33.96162,
						9.58358
					],
					[
						34.25745,
						10.63009
					],
					[
						34.73115,
						10.91017
					],
					[
						34.83163,
						11.31896
					],
					[
						35.26049,
						12.08286
					],
					[
						35.86363,
						12.57828
					],
					[
						36.27022,
						13.56333
					],
					[
						36.42951,
						14.42211
					],
					[
						37.59377,
						14.2131
					],
					[
						37.90607,
						14.95943
					]
				]
			]
		},
		id: "ETH",
		id2: "ET",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Falkland Islands"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-61.2,
						-51.85
					],
					[
						-60,
						-51.25
					],
					[
						-59.15,
						-51.5
					],
					[
						-58.55,
						-51.1
					],
					[
						-57.75,
						-51.55
					],
					[
						-58.05,
						-51.9
					],
					[
						-59.4,
						-52.2
					],
					[
						-59.85,
						-51.85
					],
					[
						-60.7,
						-52.3
					],
					[
						-61.2,
						-51.85
					]
				]
			]
		},
		id: "FLK",
		id2: "FK",
		continent: "SA",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-7.05,
							62.07
						],
						[
							-7.2,
							62.02
						],
						[
							-7.44,
							62.14
						],
						[
							-7.05,
							62.07
						]
					]
				],
				[
					[
						[
							-6.71,
							61.94
						],
						[
							-7.23,
							62.17
						],
						[
							-7.21,
							62.28
						],
						[
							-6.71,
							61.94
						]
					]
				],
				[
					[
						[
							-6.66,
							62.09
						],
						[
							-7.06,
							62.31
						],
						[
							-6.6,
							62.2
						],
						[
							-6.66,
							62.09
						]
					]
				]
			]
		},
		properties: {
			name: "Faroe Islands"
		},
		id2: "FO",
		id: "FRO",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Fiji"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							178.3736,
							-17.33992
						],
						[
							178.71806,
							-17.62846
						],
						[
							178.55271,
							-18.15059
						],
						[
							177.93266,
							-18.28799
						],
						[
							177.38146,
							-18.16432
						],
						[
							177.28504,
							-17.72465
						],
						[
							177.67087,
							-17.38114
						],
						[
							178.12557,
							-17.50481
						],
						[
							178.3736,
							-17.33992
						]
					]
				],
				[
					[
						[
							179.364143,
							-16.801354
						],
						[
							178.725059,
							-17.012042
						],
						[
							178.596839,
							-16.63915
						],
						[
							179.096609,
							-16.433984
						],
						[
							179.413509,
							-16.379054
						],
						[
							180,
							-16.067133
						],
						[
							180,
							-16.555217
						],
						[
							179.364143,
							-16.801354
						]
					]
				],
				[
					[
						[
							-179.917369,
							-16.501783
						],
						[
							-180,
							-16.555217
						],
						[
							-180,
							-16.067133
						],
						[
							-179.79332,
							-16.020882
						],
						[
							-179.917369,
							-16.501783
						]
					]
				]
			]
		},
		id: "FJI",
		id2: "FJ",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Finland"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						28.59193,
						69.064777
					],
					[
						28.445944,
						68.364613
					],
					[
						29.977426,
						67.698297
					],
					[
						29.054589,
						66.944286
					],
					[
						30.21765,
						65.80598
					],
					[
						29.54443,
						64.948672
					],
					[
						30.444685,
						64.204453
					],
					[
						30.035872,
						63.552814
					],
					[
						31.516092,
						62.867687
					],
					[
						31.139991,
						62.357693
					],
					[
						30.211107,
						61.780028
					],
					[
						28.069998,
						60.503517
					],
					[
						26.255173,
						60.423961
					],
					[
						24.496624,
						60.057316
					],
					[
						22.869695,
						59.846373
					],
					[
						22.290764,
						60.391921
					],
					[
						21.322244,
						60.72017
					],
					[
						21.544866,
						61.705329
					],
					[
						21.059211,
						62.607393
					],
					[
						21.536029,
						63.189735
					],
					[
						22.442744,
						63.81781
					],
					[
						24.730512,
						64.902344
					],
					[
						25.398068,
						65.111427
					],
					[
						25.294043,
						65.534346
					],
					[
						23.903379,
						66.006927
					],
					[
						23.56588,
						66.396051
					],
					[
						23.539473,
						67.936009
					],
					[
						21.978535,
						68.616846
					],
					[
						20.645593,
						69.106247
					],
					[
						21.244936,
						69.370443
					],
					[
						22.356238,
						68.841741
					],
					[
						23.66205,
						68.891247
					],
					[
						24.735679,
						68.649557
					],
					[
						25.689213,
						69.092114
					],
					[
						26.179622,
						69.825299
					],
					[
						27.732292,
						70.164193
					],
					[
						29.015573,
						69.766491
					],
					[
						28.59193,
						69.064777
					]
				]
			]
		},
		id: "FIN",
		id2: "FI",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "France"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							9.560016,
							42.152492
						],
						[
							9.229752,
							41.380007
						],
						[
							8.775723,
							41.583612
						],
						[
							8.544213,
							42.256517
						],
						[
							8.746009,
							42.628122
						],
						[
							9.390001,
							43.009985
						],
						[
							9.560016,
							42.152492
						]
					]
				],
				[
					[
						[
							3.588184,
							50.378992
						],
						[
							4.286023,
							49.907497
						],
						[
							4.799222,
							49.985373
						],
						[
							5.674052,
							49.529484
						],
						[
							5.897759,
							49.442667
						],
						[
							6.18632,
							49.463803
						],
						[
							6.65823,
							49.201958
						],
						[
							8.099279,
							49.017784
						],
						[
							7.593676,
							48.333019
						],
						[
							7.466759,
							47.620582
						],
						[
							7.192202,
							47.449766
						],
						[
							6.736571,
							47.541801
						],
						[
							6.768714,
							47.287708
						],
						[
							6.037389,
							46.725779
						],
						[
							6.022609,
							46.27299
						],
						[
							6.5001,
							46.429673
						],
						[
							6.843593,
							45.991147
						],
						[
							6.802355,
							45.70858
						],
						[
							7.096652,
							45.333099
						],
						[
							6.749955,
							45.028518
						],
						[
							7.007562,
							44.254767
						],
						[
							7.549596,
							44.127901
						],
						[
							7.435185,
							43.693845
						],
						[
							6.529245,
							43.128892
						],
						[
							4.556963,
							43.399651
						],
						[
							3.100411,
							43.075201
						],
						[
							2.985999,
							42.473015
						],
						[
							1.826793,
							42.343385
						],
						[
							0.701591,
							42.795734
						],
						[
							0.338047,
							42.579546
						],
						[
							-1.502771,
							43.034014
						],
						[
							-1.901351,
							43.422802
						],
						[
							-1.384225,
							44.02261
						],
						[
							-1.193798,
							46.014918
						],
						[
							-2.225724,
							47.064363
						],
						[
							-2.963276,
							47.570327
						],
						[
							-4.491555,
							47.954954
						],
						[
							-4.59235,
							48.68416
						],
						[
							-3.295814,
							48.901692
						],
						[
							-1.616511,
							48.644421
						],
						[
							-1.933494,
							49.776342
						],
						[
							-0.989469,
							49.347376
						],
						[
							1.338761,
							50.127173
						],
						[
							1.639001,
							50.946606
						],
						[
							2.513573,
							51.148506
						],
						[
							2.658422,
							50.796848
						],
						[
							3.123252,
							50.780363
						],
						[
							3.588184,
							50.378992
						]
					]
				]
			]
		},
		id: "FRA",
		id2: "FR",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-53.49,
							5.57
						],
						[
							-52.29,
							4.94
						],
						[
							-52.04,
							4.33
						],
						[
							-51.85,
							4.65
						],
						[
							-51.68,
							4.03
						],
						[
							-52.91,
							2.2
						],
						[
							-54.6,
							2.33
						],
						[
							-54,
							3.45
						],
						[
							-54.48,
							4.75
						],
						[
							-54.17,
							5.35
						],
						[
							-53.94,
							5.74
						],
						[
							-53.49,
							5.57
						]
					]
				]
			]
		},
		properties: {
			name: "French Guiana"
		},
		id2: "GF",
		id: "GUF",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-149.21,
							-17.73
						],
						[
							-149.18,
							-17.87
						],
						[
							-149.63,
							-17.55
						],
						[
							-149.21,
							-17.73
						]
					]
				],
				[
					[
						[
							-151.4,
							-16.89
						],
						[
							-151.48,
							-16.9
						],
						[
							-151.48,
							-16.74
						],
						[
							-151.4,
							-16.89
						]
					]
				],
				[
					[
						[
							-138.96,
							-9.74
						],
						[
							-138.81,
							-9.74
						],
						[
							-139.17,
							-9.78
						],
						[
							-138.96,
							-9.74
						]
					]
				],
				[
					[
						[
							-140.03,
							-8.9
						],
						[
							-140.19,
							-8.95
						],
						[
							-140.25,
							-8.8
						],
						[
							-140.03,
							-8.9
						]
					]
				]
			]
		},
		properties: {
			name: "French Polynesia"
		},
		id2: "PF",
		id: "PYF",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "French Southern and Antarctic Lands"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						68.935,
						-48.625
					],
					[
						69.58,
						-48.94
					],
					[
						70.525,
						-49.065
					],
					[
						70.56,
						-49.255
					],
					[
						70.28,
						-49.71
					],
					[
						68.745,
						-49.775
					],
					[
						68.72,
						-49.2425
					],
					[
						68.8675,
						-48.83
					],
					[
						68.935,
						-48.625
					]
				]
			]
		},
		id: "ATF",
		id2: "TF",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Gabon"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						11.093773,
						-3.978827
					],
					[
						10.066135,
						-2.969483
					],
					[
						9.405245,
						-2.144313
					],
					[
						8.797996,
						-1.111301
					],
					[
						8.830087,
						-0.779074
					],
					[
						9.04842,
						-0.459351
					],
					[
						9.291351,
						0.268666
					],
					[
						9.492889,
						1.01012
					],
					[
						9.830284,
						1.067894
					],
					[
						11.285079,
						1.057662
					],
					[
						11.276449,
						2.261051
					],
					[
						11.751665,
						2.326758
					],
					[
						12.35938,
						2.192812
					],
					[
						12.951334,
						2.321616
					],
					[
						13.075822,
						2.267097
					],
					[
						13.003114,
						1.830896
					],
					[
						13.282631,
						1.314184
					],
					[
						14.026669,
						1.395677
					],
					[
						14.276266,
						1.19693
					],
					[
						13.843321,
						0.038758
					],
					[
						14.316418,
						-0.552627
					],
					[
						14.425456,
						-1.333407
					],
					[
						14.29921,
						-1.998276
					],
					[
						13.992407,
						-2.470805
					],
					[
						13.109619,
						-2.42874
					],
					[
						12.575284,
						-1.948511
					],
					[
						12.495703,
						-2.391688
					],
					[
						11.820964,
						-2.514161
					],
					[
						11.478039,
						-2.765619
					],
					[
						11.855122,
						-3.426871
					],
					[
						11.093773,
						-3.978827
					]
				]
			]
		},
		id: "GAB",
		id2: "GA",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Gambia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-16.841525,
						13.151394
					],
					[
						-16.713729,
						13.594959
					],
					[
						-15.624596,
						13.623587
					],
					[
						-15.39877,
						13.860369
					],
					[
						-15.081735,
						13.876492
					],
					[
						-14.687031,
						13.630357
					],
					[
						-14.376714,
						13.62568
					],
					[
						-14.046992,
						13.794068
					],
					[
						-13.844963,
						13.505042
					],
					[
						-14.277702,
						13.280585
					],
					[
						-14.712197,
						13.298207
					],
					[
						-15.141163,
						13.509512
					],
					[
						-15.511813,
						13.27857
					],
					[
						-15.691001,
						13.270353
					],
					[
						-15.931296,
						13.130284
					],
					[
						-16.841525,
						13.151394
					]
				]
			]
		},
		id: "GMB",
		id2: "GM",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Georgia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						41.554084,
						41.535656
					],
					[
						41.703171,
						41.962943
					],
					[
						41.45347,
						42.645123
					],
					[
						40.875469,
						43.013628
					],
					[
						40.321394,
						43.128634
					],
					[
						39.955009,
						43.434998
					],
					[
						40.076965,
						43.553104
					],
					[
						40.922185,
						43.382159
					],
					[
						42.394395,
						43.220308
					],
					[
						43.756017,
						42.740828
					],
					[
						43.9312,
						42.554974
					],
					[
						44.537623,
						42.711993
					],
					[
						45.470279,
						42.502781
					],
					[
						45.77641,
						42.092444
					],
					[
						46.404951,
						41.860675
					],
					[
						46.145432,
						41.722802
					],
					[
						46.637908,
						41.181673
					],
					[
						46.501637,
						41.064445
					],
					[
						45.962601,
						41.123873
					],
					[
						45.217426,
						41.411452
					],
					[
						44.97248,
						41.248129
					],
					[
						43.582746,
						41.092143
					],
					[
						42.619549,
						41.583173
					],
					[
						41.554084,
						41.535656
					]
				]
			]
		},
		id: "GEO",
		id2: "GE",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Germany"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						9.921906,
						54.983104
					],
					[
						9.93958,
						54.596642
					],
					[
						10.950112,
						54.363607
					],
					[
						10.939467,
						54.008693
					],
					[
						11.956252,
						54.196486
					],
					[
						12.51844,
						54.470371
					],
					[
						13.647467,
						54.075511
					],
					[
						14.119686,
						53.757029
					],
					[
						14.353315,
						53.248171
					],
					[
						14.074521,
						52.981263
					],
					[
						14.4376,
						52.62485
					],
					[
						14.685026,
						52.089947
					],
					[
						14.607098,
						51.745188
					],
					[
						15.016996,
						51.106674
					],
					[
						14.570718,
						51.002339
					],
					[
						14.307013,
						51.117268
					],
					[
						14.056228,
						50.926918
					],
					[
						13.338132,
						50.733234
					],
					[
						12.966837,
						50.484076
					],
					[
						12.240111,
						50.266338
					],
					[
						12.415191,
						49.969121
					],
					[
						12.521024,
						49.547415
					],
					[
						13.031329,
						49.307068
					],
					[
						13.595946,
						48.877172
					],
					[
						13.243357,
						48.416115
					],
					[
						12.884103,
						48.289146
					],
					[
						13.025851,
						47.637584
					],
					[
						12.932627,
						47.467646
					],
					[
						12.62076,
						47.672388
					],
					[
						12.141357,
						47.703083
					],
					[
						11.426414,
						47.523766
					],
					[
						10.544504,
						47.566399
					],
					[
						10.402084,
						47.302488
					],
					[
						9.896068,
						47.580197
					],
					[
						9.594226,
						47.525058
					],
					[
						8.522612,
						47.830828
					],
					[
						8.317301,
						47.61358
					],
					[
						7.466759,
						47.620582
					],
					[
						7.593676,
						48.333019
					],
					[
						8.099279,
						49.017784
					],
					[
						6.65823,
						49.201958
					],
					[
						6.18632,
						49.463803
					],
					[
						6.242751,
						49.902226
					],
					[
						6.043073,
						50.128052
					],
					[
						6.156658,
						50.803721
					],
					[
						5.988658,
						51.851616
					],
					[
						6.589397,
						51.852029
					],
					[
						6.84287,
						52.22844
					],
					[
						7.092053,
						53.144043
					],
					[
						6.90514,
						53.482162
					],
					[
						7.100425,
						53.693932
					],
					[
						7.936239,
						53.748296
					],
					[
						8.121706,
						53.527792
					],
					[
						8.800734,
						54.020786
					],
					[
						8.572118,
						54.395646
					],
					[
						8.526229,
						54.962744
					],
					[
						9.282049,
						54.830865
					],
					[
						9.921906,
						54.983104
					]
				]
			]
		},
		id: "DEU",
		id2: "DE",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Ghana"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						1.060122,
						5.928837
					],
					[
						-0.507638,
						5.343473
					],
					[
						-1.063625,
						5.000548
					],
					[
						-1.964707,
						4.710462
					],
					[
						-2.856125,
						4.994476
					],
					[
						-2.810701,
						5.389051
					],
					[
						-3.24437,
						6.250472
					],
					[
						-2.983585,
						7.379705
					],
					[
						-2.56219,
						8.219628
					],
					[
						-2.827496,
						9.642461
					],
					[
						-2.963896,
						10.395335
					],
					[
						-2.940409,
						10.96269
					],
					[
						-1.203358,
						11.009819
					],
					[
						-0.761576,
						10.93693
					],
					[
						-0.438702,
						11.098341
					],
					[
						0.023803,
						11.018682
					],
					[
						-0.049785,
						10.706918
					],
					[
						0.36758,
						10.191213
					],
					[
						0.365901,
						9.465004
					],
					[
						0.461192,
						8.677223
					],
					[
						0.712029,
						8.312465
					],
					[
						0.490957,
						7.411744
					],
					[
						0.570384,
						6.914359
					],
					[
						0.836931,
						6.279979
					],
					[
						1.060122,
						5.928837
					]
				]
			]
		},
		id: "GHA",
		id2: "GH",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Gibraltar"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-5.33,
						36.16
					],
					[
						-5.34,
						36.11
					],
					[
						-5.36,
						36.16
					],
					[
						-5.33,
						36.16
					]
				]
			]
		},
		id: "GIB",
		id2: "GI",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Greece"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							23.69998,
							35.705004
						],
						[
							24.246665,
							35.368022
						],
						[
							25.025015,
							35.424996
						],
						[
							25.769208,
							35.354018
						],
						[
							25.745023,
							35.179998
						],
						[
							26.290003,
							35.29999
						],
						[
							26.164998,
							35.004995
						],
						[
							24.724982,
							34.919988
						],
						[
							24.735007,
							35.084991
						],
						[
							23.514978,
							35.279992
						],
						[
							23.69998,
							35.705004
						]
					]
				],
				[
					[
						[
							26.604196,
							41.562115
						],
						[
							26.294602,
							40.936261
						],
						[
							26.056942,
							40.824123
						],
						[
							25.447677,
							40.852545
						],
						[
							24.925848,
							40.947062
						],
						[
							23.714811,
							40.687129
						],
						[
							24.407999,
							40.124993
						],
						[
							23.899968,
							39.962006
						],
						[
							23.342999,
							39.960998
						],
						[
							22.813988,
							40.476005
						],
						[
							22.626299,
							40.256561
						],
						[
							22.849748,
							39.659311
						],
						[
							23.350027,
							39.190011
						],
						[
							22.973099,
							38.970903
						],
						[
							23.530016,
							38.510001
						],
						[
							24.025025,
							38.219993
						],
						[
							24.040011,
							37.655015
						],
						[
							23.115003,
							37.920011
						],
						[
							23.409972,
							37.409991
						],
						[
							22.774972,
							37.30501
						],
						[
							23.154225,
							36.422506
						],
						[
							22.490028,
							36.41
						],
						[
							21.670026,
							36.844986
						],
						[
							21.295011,
							37.644989
						],
						[
							21.120034,
							38.310323
						],
						[
							20.730032,
							38.769985
						],
						[
							20.217712,
							39.340235
						],
						[
							20.150016,
							39.624998
						],
						[
							20.615,
							40.110007
						],
						[
							20.674997,
							40.435
						],
						[
							20.99999,
							40.580004
						],
						[
							21.02004,
							40.842727
						],
						[
							21.674161,
							40.931275
						],
						[
							22.055378,
							41.149866
						],
						[
							22.597308,
							41.130487
						],
						[
							22.76177,
							41.3048
						],
						[
							22.952377,
							41.337994
						],
						[
							23.692074,
							41.309081
						],
						[
							24.492645,
							41.583896
						],
						[
							25.197201,
							41.234486
						],
						[
							26.106138,
							41.328899
						],
						[
							26.117042,
							41.826905
						],
						[
							26.604196,
							41.562115
						]
					]
				]
			]
		},
		id: "GRC",
		id2: "GR",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Greenland"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-46.76379,
						82.62796
					],
					[
						-43.40644,
						83.22516
					],
					[
						-39.89753,
						83.18018
					],
					[
						-38.62214,
						83.54905
					],
					[
						-35.08787,
						83.64513
					],
					[
						-27.10046,
						83.51966
					],
					[
						-20.84539,
						82.72669
					],
					[
						-22.69182,
						82.34165
					],
					[
						-26.51753,
						82.29765
					],
					[
						-31.9,
						82.2
					],
					[
						-31.39646,
						82.02154
					],
					[
						-27.85666,
						82.13178
					],
					[
						-24.84448,
						81.78697
					],
					[
						-22.90328,
						82.09317
					],
					[
						-22.07175,
						81.73449
					],
					[
						-23.16961,
						81.15271
					],
					[
						-20.62363,
						81.52462
					],
					[
						-15.76818,
						81.91245
					],
					[
						-12.77018,
						81.71885
					],
					[
						-12.20855,
						81.29154
					],
					[
						-16.28533,
						80.58004
					],
					[
						-16.85,
						80.35
					],
					[
						-20.04624,
						80.17708
					],
					[
						-17.73035,
						80.12912
					],
					[
						-18.9,
						79.4
					],
					[
						-19.70499,
						78.75128
					],
					[
						-19.67353,
						77.63859
					],
					[
						-18.47285,
						76.98565
					],
					[
						-20.03503,
						76.94434
					],
					[
						-21.67944,
						76.62795
					],
					[
						-19.83407,
						76.09808
					],
					[
						-19.59896,
						75.24838
					],
					[
						-20.66818,
						75.15585
					],
					[
						-19.37281,
						74.29561
					],
					[
						-21.59422,
						74.22382
					],
					[
						-20.43454,
						73.81713
					],
					[
						-20.76234,
						73.46436
					],
					[
						-22.17221,
						73.30955
					],
					[
						-23.56593,
						73.30663
					],
					[
						-22.31311,
						72.62928
					],
					[
						-22.29954,
						72.18409
					],
					[
						-24.27834,
						72.59788
					],
					[
						-24.79296,
						72.3302
					],
					[
						-23.44296,
						72.08016
					],
					[
						-22.13281,
						71.46898
					],
					[
						-21.75356,
						70.66369
					],
					[
						-23.53603,
						70.471
					],
					[
						-24.30702,
						70.85649
					],
					[
						-25.54341,
						71.43094
					],
					[
						-25.20135,
						70.75226
					],
					[
						-26.36276,
						70.22646
					],
					[
						-23.72742,
						70.18401
					],
					[
						-22.34902,
						70.12946
					],
					[
						-25.02927,
						69.2588
					],
					[
						-27.74737,
						68.47046
					],
					[
						-30.67371,
						68.12503
					],
					[
						-31.77665,
						68.12078
					],
					[
						-32.81105,
						67.73547
					],
					[
						-34.20196,
						66.67974
					],
					[
						-36.35284,
						65.9789
					],
					[
						-37.04378,
						65.93768
					],
					[
						-38.37505,
						65.69213
					],
					[
						-39.81222,
						65.45848
					],
					[
						-40.66899,
						64.83997
					],
					[
						-40.68281,
						64.13902
					],
					[
						-41.1887,
						63.48246
					],
					[
						-42.81938,
						62.68233
					],
					[
						-42.41666,
						61.90093
					],
					[
						-42.86619,
						61.07404
					],
					[
						-43.3784,
						60.09772
					],
					[
						-44.7875,
						60.03676
					],
					[
						-46.26364,
						60.85328
					],
					[
						-48.26294,
						60.85843
					],
					[
						-49.23308,
						61.40681
					],
					[
						-49.90039,
						62.38336
					],
					[
						-51.63325,
						63.62691
					],
					[
						-52.14014,
						64.27842
					],
					[
						-52.27659,
						65.1767
					],
					[
						-53.66166,
						66.09957
					],
					[
						-53.30161,
						66.8365
					],
					[
						-53.96911,
						67.18899
					],
					[
						-52.9804,
						68.35759
					],
					[
						-51.47536,
						68.72958
					],
					[
						-51.08041,
						69.14781
					],
					[
						-50.87122,
						69.9291
					],
					[
						-52.013585,
						69.574925
					],
					[
						-52.55792,
						69.42616
					],
					[
						-53.45629,
						69.283625
					],
					[
						-54.68336,
						69.61003
					],
					[
						-54.75001,
						70.28932
					],
					[
						-54.35884,
						70.821315
					],
					[
						-53.431315,
						70.835755
					],
					[
						-51.39014,
						70.56978
					],
					[
						-53.10937,
						71.20485
					],
					[
						-54.00422,
						71.54719
					],
					[
						-55,
						71.406537
					],
					[
						-55.83468,
						71.65444
					],
					[
						-54.71819,
						72.58625
					],
					[
						-55.32634,
						72.95861
					],
					[
						-56.12003,
						73.64977
					],
					[
						-57.32363,
						74.71026
					],
					[
						-58.59679,
						75.09861
					],
					[
						-58.58516,
						75.51727
					],
					[
						-61.26861,
						76.10238
					],
					[
						-63.39165,
						76.1752
					],
					[
						-66.06427,
						76.13486
					],
					[
						-68.50438,
						76.06141
					],
					[
						-69.66485,
						76.37975
					],
					[
						-71.40257,
						77.00857
					],
					[
						-68.77671,
						77.32312
					],
					[
						-66.76397,
						77.37595
					],
					[
						-71.04293,
						77.63595
					],
					[
						-73.297,
						78.04419
					],
					[
						-73.15938,
						78.43271
					],
					[
						-69.37345,
						78.91388
					],
					[
						-65.7107,
						79.39436
					],
					[
						-65.3239,
						79.75814
					],
					[
						-68.02298,
						80.11721
					],
					[
						-67.15129,
						80.51582
					],
					[
						-63.68925,
						81.21396
					],
					[
						-62.23444,
						81.3211
					],
					[
						-62.65116,
						81.77042
					],
					[
						-60.28249,
						82.03363
					],
					[
						-57.20744,
						82.19074
					],
					[
						-54.13442,
						82.19962
					],
					[
						-53.04328,
						81.88833
					],
					[
						-50.39061,
						82.43883
					],
					[
						-48.00386,
						82.06481
					],
					[
						-46.59984,
						81.985945
					],
					[
						-44.523,
						81.6607
					],
					[
						-46.9007,
						82.19979
					],
					[
						-46.76379,
						82.62796
					]
				]
			]
		},
		id: "GRL",
		id2: "GL",
		continent: "NA",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-61.75,
							12
						],
						[
							-61.61,
							12.23
						],
						[
							-61.63,
							12.05
						],
						[
							-61.75,
							12
						]
					]
				],
				[
					[
						[
							-61.43,
							12.45
						],
						[
							-61.5,
							12.44
						],
						[
							-61.43,
							12.53
						],
						[
							-61.43,
							12.45
						]
					]
				]
			]
		},
		properties: {
			name: "Grenada"
		},
		id2: "GD",
		id: "GRD",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Guadeloupe"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-61.4,
						15.4
					],
					[
						-61.6,
						15.4
					],
					[
						-61.6,
						15.6
					],
					[
						-61.4,
						15.6
					],
					[
						-61.4,
						15.4
					]
				]
			]
		},
		id: "GLP",
		id2: "GP",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Guam"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						144.71,
						13.23
					],
					[
						144.66,
						13.43
					],
					[
						144.88,
						13.65
					],
					[
						144.71,
						13.23
					]
				]
			]
		},
		id: "GUM",
		id2: "GU",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Guatemala"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-90.095555,
						13.735338
					],
					[
						-90.608624,
						13.909771
					],
					[
						-91.23241,
						13.927832
					],
					[
						-91.689747,
						14.126218
					],
					[
						-92.22775,
						14.538829
					],
					[
						-92.20323,
						14.830103
					],
					[
						-92.087216,
						15.064585
					],
					[
						-92.229249,
						15.251447
					],
					[
						-91.74796,
						16.066565
					],
					[
						-90.464473,
						16.069562
					],
					[
						-90.438867,
						16.41011
					],
					[
						-90.600847,
						16.470778
					],
					[
						-90.711822,
						16.687483
					],
					[
						-91.08167,
						16.918477
					],
					[
						-91.453921,
						17.252177
					],
					[
						-91.002269,
						17.254658
					],
					[
						-91.00152,
						17.817595
					],
					[
						-90.067934,
						17.819326
					],
					[
						-89.14308,
						17.808319
					],
					[
						-89.150806,
						17.015577
					],
					[
						-89.229122,
						15.886938
					],
					[
						-88.930613,
						15.887273
					],
					[
						-88.604586,
						15.70638
					],
					[
						-88.518364,
						15.855389
					],
					[
						-88.225023,
						15.727722
					],
					[
						-88.68068,
						15.346247
					],
					[
						-89.154811,
						15.066419
					],
					[
						-89.22522,
						14.874286
					],
					[
						-89.145535,
						14.678019
					],
					[
						-89.353326,
						14.424133
					],
					[
						-89.587343,
						14.362586
					],
					[
						-89.534219,
						14.244816
					],
					[
						-89.721934,
						14.134228
					],
					[
						-90.064678,
						13.88197
					],
					[
						-90.095555,
						13.735338
					]
				]
			]
		},
		id: "GTM",
		id2: "GT",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-2.59,
							49.42
						],
						[
							-2.67,
							49.43
						],
						[
							-2.5,
							49.51
						],
						[
							-2.59,
							49.42
						]
					]
				]
			]
		},
		properties: {
			name: "Guernsey"
		},
		id2: "GG",
		id: "GGY",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Guinea"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-8.439298,
						7.686043
					],
					[
						-8.722124,
						7.711674
					],
					[
						-8.926065,
						7.309037
					],
					[
						-9.208786,
						7.313921
					],
					[
						-9.403348,
						7.526905
					],
					[
						-9.33728,
						7.928534
					],
					[
						-9.755342,
						8.541055
					],
					[
						-10.016567,
						8.428504
					],
					[
						-10.230094,
						8.406206
					],
					[
						-10.505477,
						8.348896
					],
					[
						-10.494315,
						8.715541
					],
					[
						-10.65477,
						8.977178
					],
					[
						-10.622395,
						9.26791
					],
					[
						-10.839152,
						9.688246
					],
					[
						-11.117481,
						10.045873
					],
					[
						-11.917277,
						10.046984
					],
					[
						-12.150338,
						9.858572
					],
					[
						-12.425929,
						9.835834
					],
					[
						-12.596719,
						9.620188
					],
					[
						-12.711958,
						9.342712
					],
					[
						-13.24655,
						8.903049
					],
					[
						-13.685154,
						9.494744
					],
					[
						-14.074045,
						9.886167
					],
					[
						-14.330076,
						10.01572
					],
					[
						-14.579699,
						10.214467
					],
					[
						-14.693232,
						10.656301
					],
					[
						-14.839554,
						10.876572
					],
					[
						-15.130311,
						11.040412
					],
					[
						-14.685687,
						11.527824
					],
					[
						-14.382192,
						11.509272
					],
					[
						-14.121406,
						11.677117
					],
					[
						-13.9008,
						11.678719
					],
					[
						-13.743161,
						11.811269
					],
					[
						-13.828272,
						12.142644
					],
					[
						-13.718744,
						12.247186
					],
					[
						-13.700476,
						12.586183
					],
					[
						-13.217818,
						12.575874
					],
					[
						-12.499051,
						12.33209
					],
					[
						-12.278599,
						12.35444
					],
					[
						-12.203565,
						12.465648
					],
					[
						-11.658301,
						12.386583
					],
					[
						-11.513943,
						12.442988
					],
					[
						-11.456169,
						12.076834
					],
					[
						-11.297574,
						12.077971
					],
					[
						-11.036556,
						12.211245
					],
					[
						-10.87083,
						12.177887
					],
					[
						-10.593224,
						11.923975
					],
					[
						-10.165214,
						11.844084
					],
					[
						-9.890993,
						12.060479
					],
					[
						-9.567912,
						12.194243
					],
					[
						-9.327616,
						12.334286
					],
					[
						-9.127474,
						12.30806
					],
					[
						-8.905265,
						12.088358
					],
					[
						-8.786099,
						11.812561
					],
					[
						-8.376305,
						11.393646
					],
					[
						-8.581305,
						11.136246
					],
					[
						-8.620321,
						10.810891
					],
					[
						-8.407311,
						10.909257
					],
					[
						-8.282357,
						10.792597
					],
					[
						-8.335377,
						10.494812
					],
					[
						-8.029944,
						10.206535
					],
					[
						-8.229337,
						10.12902
					],
					[
						-8.309616,
						9.789532
					],
					[
						-8.079114,
						9.376224
					],
					[
						-7.8321,
						8.575704
					],
					[
						-8.203499,
						8.455453
					],
					[
						-8.299049,
						8.316444
					],
					[
						-8.221792,
						8.123329
					],
					[
						-8.280703,
						7.68718
					],
					[
						-8.439298,
						7.686043
					]
				]
			]
		},
		id: "GIN",
		id2: "GN",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Guinea Bissau"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-15.130311,
						11.040412
					],
					[
						-15.66418,
						11.458474
					],
					[
						-16.085214,
						11.524594
					],
					[
						-16.314787,
						11.806515
					],
					[
						-16.308947,
						11.958702
					],
					[
						-16.613838,
						12.170911
					],
					[
						-16.677452,
						12.384852
					],
					[
						-16.147717,
						12.547762
					],
					[
						-15.816574,
						12.515567
					],
					[
						-15.548477,
						12.62817
					],
					[
						-13.700476,
						12.586183
					],
					[
						-13.718744,
						12.247186
					],
					[
						-13.828272,
						12.142644
					],
					[
						-13.743161,
						11.811269
					],
					[
						-13.9008,
						11.678719
					],
					[
						-14.121406,
						11.677117
					],
					[
						-14.382192,
						11.509272
					],
					[
						-14.685687,
						11.527824
					],
					[
						-15.130311,
						11.040412
					]
				]
			]
		},
		id: "GNB",
		id2: "GW",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Guyana"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-59.758285,
						8.367035
					],
					[
						-59.101684,
						7.999202
					],
					[
						-58.482962,
						7.347691
					],
					[
						-58.454876,
						6.832787
					],
					[
						-58.078103,
						6.809094
					],
					[
						-57.542219,
						6.321268
					],
					[
						-57.147436,
						5.97315
					],
					[
						-57.307246,
						5.073567
					],
					[
						-57.914289,
						4.812626
					],
					[
						-57.86021,
						4.576801
					],
					[
						-58.044694,
						4.060864
					],
					[
						-57.601569,
						3.334655
					],
					[
						-57.281433,
						3.333492
					],
					[
						-57.150098,
						2.768927
					],
					[
						-56.539386,
						1.899523
					],
					[
						-56.782704,
						1.863711
					],
					[
						-57.335823,
						1.948538
					],
					[
						-57.660971,
						1.682585
					],
					[
						-58.11345,
						1.507195
					],
					[
						-58.429477,
						1.463942
					],
					[
						-58.540013,
						1.268088
					],
					[
						-59.030862,
						1.317698
					],
					[
						-59.646044,
						1.786894
					],
					[
						-59.718546,
						2.24963
					],
					[
						-59.974525,
						2.755233
					],
					[
						-59.815413,
						3.606499
					],
					[
						-59.53804,
						3.958803
					],
					[
						-59.767406,
						4.423503
					],
					[
						-60.111002,
						4.574967
					],
					[
						-59.980959,
						5.014061
					],
					[
						-60.213683,
						5.244486
					],
					[
						-60.733574,
						5.200277
					],
					[
						-61.410303,
						5.959068
					],
					[
						-61.139415,
						6.234297
					],
					[
						-61.159336,
						6.696077
					],
					[
						-60.543999,
						6.856584
					],
					[
						-60.295668,
						7.043911
					],
					[
						-60.637973,
						7.415
					],
					[
						-60.550588,
						7.779603
					],
					[
						-59.758285,
						8.367035
					]
				]
			]
		},
		id: "GUY",
		id2: "GY",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Haiti"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-73.189791,
						19.915684
					],
					[
						-72.579673,
						19.871501
					],
					[
						-71.712361,
						19.714456
					],
					[
						-71.624873,
						19.169838
					],
					[
						-71.701303,
						18.785417
					],
					[
						-71.945112,
						18.6169
					],
					[
						-71.687738,
						18.31666
					],
					[
						-71.708305,
						18.044997
					],
					[
						-72.372476,
						18.214961
					],
					[
						-72.844411,
						18.145611
					],
					[
						-73.454555,
						18.217906
					],
					[
						-73.922433,
						18.030993
					],
					[
						-74.458034,
						18.34255
					],
					[
						-74.369925,
						18.664908
					],
					[
						-73.449542,
						18.526053
					],
					[
						-72.694937,
						18.445799
					],
					[
						-72.334882,
						18.668422
					],
					[
						-72.79165,
						19.101625
					],
					[
						-72.784105,
						19.483591
					],
					[
						-73.415022,
						19.639551
					],
					[
						-73.189791,
						19.915684
					]
				]
			]
		},
		id: "HTI",
		id2: "HT",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							73.77,
							-53.13
						],
						[
							73.47,
							-53.19
						],
						[
							73.23,
							-52.99
						],
						[
							73.77,
							-53.13
						]
					]
				]
			]
		},
		properties: {
			name: "Heard Island and McDonald Islands"
		},
		id2: "HM",
		id: "HMD",
		continent: "AN",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							12.45,
							41.9
						],
						[
							12.45,
							41.91
						],
						[
							12.46,
							41.9
						],
						[
							12.45,
							41.9
						]
					]
				]
			]
		},
		properties: {
			name: "Holy See (Vatican City)"
		},
		id2: "VA",
		id: "VAT",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Honduras"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-87.316654,
						12.984686
					],
					[
						-87.489409,
						13.297535
					],
					[
						-87.793111,
						13.38448
					],
					[
						-87.723503,
						13.78505
					],
					[
						-87.859515,
						13.893312
					],
					[
						-88.065343,
						13.964626
					],
					[
						-88.503998,
						13.845486
					],
					[
						-88.541231,
						13.980155
					],
					[
						-88.843073,
						14.140507
					],
					[
						-89.058512,
						14.340029
					],
					[
						-89.353326,
						14.424133
					],
					[
						-89.145535,
						14.678019
					],
					[
						-89.22522,
						14.874286
					],
					[
						-89.154811,
						15.066419
					],
					[
						-88.68068,
						15.346247
					],
					[
						-88.225023,
						15.727722
					],
					[
						-88.121153,
						15.688655
					],
					[
						-87.901813,
						15.864458
					],
					[
						-87.61568,
						15.878799
					],
					[
						-87.522921,
						15.797279
					],
					[
						-87.367762,
						15.84694
					],
					[
						-86.903191,
						15.756713
					],
					[
						-86.440946,
						15.782835
					],
					[
						-86.119234,
						15.893449
					],
					[
						-86.001954,
						16.005406
					],
					[
						-85.683317,
						15.953652
					],
					[
						-85.444004,
						15.885749
					],
					[
						-85.182444,
						15.909158
					],
					[
						-84.983722,
						15.995923
					],
					[
						-84.52698,
						15.857224
					],
					[
						-84.368256,
						15.835158
					],
					[
						-84.063055,
						15.648244
					],
					[
						-83.773977,
						15.424072
					],
					[
						-83.410381,
						15.270903
					],
					[
						-83.147219,
						14.995829
					],
					[
						-83.489989,
						15.016267
					],
					[
						-83.628585,
						14.880074
					],
					[
						-83.975721,
						14.749436
					],
					[
						-84.228342,
						14.748764
					],
					[
						-84.449336,
						14.621614
					],
					[
						-84.649582,
						14.666805
					],
					[
						-84.820037,
						14.819587
					],
					[
						-84.924501,
						14.790493
					],
					[
						-85.052787,
						14.551541
					],
					[
						-85.148751,
						14.560197
					],
					[
						-85.165365,
						14.35437
					],
					[
						-85.514413,
						14.079012
					],
					[
						-85.698665,
						13.960078
					],
					[
						-85.801295,
						13.836055
					],
					[
						-86.096264,
						14.038187
					],
					[
						-86.312142,
						13.771356
					],
					[
						-86.520708,
						13.778487
					],
					[
						-86.755087,
						13.754845
					],
					[
						-86.733822,
						13.263093
					],
					[
						-86.880557,
						13.254204
					],
					[
						-87.005769,
						13.025794
					],
					[
						-87.316654,
						12.984686
					]
				]
			]
		},
		id: "HND",
		id2: "HN",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Hungary"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						16.202298,
						46.852386
					],
					[
						16.534268,
						47.496171
					],
					[
						16.340584,
						47.712902
					],
					[
						16.903754,
						47.714866
					],
					[
						16.979667,
						48.123497
					],
					[
						17.488473,
						47.867466
					],
					[
						17.857133,
						47.758429
					],
					[
						18.696513,
						47.880954
					],
					[
						18.777025,
						48.081768
					],
					[
						19.174365,
						48.111379
					],
					[
						19.661364,
						48.266615
					],
					[
						19.769471,
						48.202691
					],
					[
						20.239054,
						48.327567
					],
					[
						20.473562,
						48.56285
					],
					[
						20.801294,
						48.623854
					],
					[
						21.872236,
						48.319971
					],
					[
						22.085608,
						48.422264
					],
					[
						22.64082,
						48.15024
					],
					[
						22.710531,
						47.882194
					],
					[
						22.099768,
						47.672439
					],
					[
						21.626515,
						46.994238
					],
					[
						21.021952,
						46.316088
					],
					[
						20.220192,
						46.127469
					],
					[
						19.596045,
						46.17173
					],
					[
						18.829838,
						45.908878
					],
					[
						18.456062,
						45.759481
					],
					[
						17.630066,
						45.951769
					],
					[
						16.882515,
						46.380632
					],
					[
						16.564808,
						46.503751
					],
					[
						16.370505,
						46.841327
					],
					[
						16.202298,
						46.852386
					]
				]
			]
		},
		id: "HUN",
		id2: "HU",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Iceland"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-14.508695,
						66.455892
					],
					[
						-14.739637,
						65.808748
					],
					[
						-13.609732,
						65.126671
					],
					[
						-14.909834,
						64.364082
					],
					[
						-17.794438,
						63.678749
					],
					[
						-18.656246,
						63.496383
					],
					[
						-19.972755,
						63.643635
					],
					[
						-22.762972,
						63.960179
					],
					[
						-21.778484,
						64.402116
					],
					[
						-23.955044,
						64.89113
					],
					[
						-22.184403,
						65.084968
					],
					[
						-22.227423,
						65.378594
					],
					[
						-24.326184,
						65.611189
					],
					[
						-23.650515,
						66.262519
					],
					[
						-22.134922,
						66.410469
					],
					[
						-20.576284,
						65.732112
					],
					[
						-19.056842,
						66.276601
					],
					[
						-17.798624,
						65.993853
					],
					[
						-16.167819,
						66.526792
					],
					[
						-14.508695,
						66.455892
					]
				]
			]
		},
		id: "ISL",
		id2: "IS",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "India"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						77.837451,
						35.49401
					],
					[
						78.912269,
						34.321936
					],
					[
						78.811086,
						33.506198
					],
					[
						79.208892,
						32.994395
					],
					[
						79.176129,
						32.48378
					],
					[
						78.458446,
						32.618164
					],
					[
						78.738894,
						31.515906
					],
					[
						79.721367,
						30.882715
					],
					[
						81.111256,
						30.183481
					],
					[
						80.476721,
						29.729865
					],
					[
						80.088425,
						28.79447
					],
					[
						81.057203,
						28.416095
					],
					[
						81.999987,
						27.925479
					],
					[
						83.304249,
						27.364506
					],
					[
						84.675018,
						27.234901
					],
					[
						85.251779,
						26.726198
					],
					[
						86.024393,
						26.630985
					],
					[
						87.227472,
						26.397898
					],
					[
						88.060238,
						26.414615
					],
					[
						88.174804,
						26.810405
					],
					[
						88.043133,
						27.445819
					],
					[
						88.120441,
						27.876542
					],
					[
						88.730326,
						28.086865
					],
					[
						88.814248,
						27.299316
					],
					[
						88.835643,
						27.098966
					],
					[
						89.744528,
						26.719403
					],
					[
						90.373275,
						26.875724
					],
					[
						91.217513,
						26.808648
					],
					[
						92.033484,
						26.83831
					],
					[
						92.103712,
						27.452614
					],
					[
						91.696657,
						27.771742
					],
					[
						92.503119,
						27.896876
					],
					[
						93.413348,
						28.640629
					],
					[
						94.56599,
						29.277438
					],
					[
						95.404802,
						29.031717
					],
					[
						96.117679,
						29.452802
					],
					[
						96.586591,
						28.83098
					],
					[
						96.248833,
						28.411031
					],
					[
						97.327114,
						28.261583
					],
					[
						97.402561,
						27.882536
					],
					[
						97.051989,
						27.699059
					],
					[
						97.133999,
						27.083774
					],
					[
						96.419366,
						27.264589
					],
					[
						95.124768,
						26.573572
					],
					[
						95.155153,
						26.001307
					],
					[
						94.603249,
						25.162495
					],
					[
						94.552658,
						24.675238
					],
					[
						94.106742,
						23.850741
					],
					[
						93.325188,
						24.078556
					],
					[
						93.286327,
						23.043658
					],
					[
						93.060294,
						22.703111
					],
					[
						93.166128,
						22.27846
					],
					[
						92.672721,
						22.041239
					],
					[
						92.146035,
						23.627499
					],
					[
						91.869928,
						23.624346
					],
					[
						91.706475,
						22.985264
					],
					[
						91.158963,
						23.503527
					],
					[
						91.46773,
						24.072639
					],
					[
						91.915093,
						24.130414
					],
					[
						92.376202,
						24.976693
					],
					[
						91.799596,
						25.147432
					],
					[
						90.872211,
						25.132601
					],
					[
						89.920693,
						25.26975
					],
					[
						89.832481,
						25.965082
					],
					[
						89.355094,
						26.014407
					],
					[
						88.563049,
						26.446526
					],
					[
						88.209789,
						25.768066
					],
					[
						88.931554,
						25.238692
					],
					[
						88.306373,
						24.866079
					],
					[
						88.084422,
						24.501657
					],
					[
						88.69994,
						24.233715
					],
					[
						88.52977,
						23.631142
					],
					[
						88.876312,
						22.879146
					],
					[
						89.031961,
						22.055708
					],
					[
						88.888766,
						21.690588
					],
					[
						88.208497,
						21.703172
					],
					[
						86.975704,
						21.495562
					],
					[
						87.033169,
						20.743308
					],
					[
						86.499351,
						20.151638
					],
					[
						85.060266,
						19.478579
					],
					[
						83.941006,
						18.30201
					],
					[
						83.189217,
						17.671221
					],
					[
						82.192792,
						17.016636
					],
					[
						82.191242,
						16.556664
					],
					[
						81.692719,
						16.310219
					],
					[
						80.791999,
						15.951972
					],
					[
						80.324896,
						15.899185
					],
					[
						80.025069,
						15.136415
					],
					[
						80.233274,
						13.835771
					],
					[
						80.286294,
						13.006261
					],
					[
						79.862547,
						12.056215
					],
					[
						79.857999,
						10.357275
					],
					[
						79.340512,
						10.308854
					],
					[
						78.885345,
						9.546136
					],
					[
						79.18972,
						9.216544
					],
					[
						78.277941,
						8.933047
					],
					[
						77.941165,
						8.252959
					],
					[
						77.539898,
						7.965535
					],
					[
						76.592979,
						8.899276
					],
					[
						76.130061,
						10.29963
					],
					[
						75.746467,
						11.308251
					],
					[
						75.396101,
						11.781245
					],
					[
						74.864816,
						12.741936
					],
					[
						74.616717,
						13.992583
					],
					[
						74.443859,
						14.617222
					],
					[
						73.534199,
						15.990652
					],
					[
						73.119909,
						17.92857
					],
					[
						72.820909,
						19.208234
					],
					[
						72.824475,
						20.419503
					],
					[
						72.630533,
						21.356009
					],
					[
						71.175273,
						20.757441
					],
					[
						70.470459,
						20.877331
					],
					[
						69.16413,
						22.089298
					],
					[
						69.644928,
						22.450775
					],
					[
						69.349597,
						22.84318
					],
					[
						68.176645,
						23.691965
					],
					[
						68.842599,
						24.359134
					],
					[
						71.04324,
						24.356524
					],
					[
						70.844699,
						25.215102
					],
					[
						70.282873,
						25.722229
					],
					[
						70.168927,
						26.491872
					],
					[
						69.514393,
						26.940966
					],
					[
						70.616496,
						27.989196
					],
					[
						71.777666,
						27.91318
					],
					[
						72.823752,
						28.961592
					],
					[
						73.450638,
						29.976413
					],
					[
						74.42138,
						30.979815
					],
					[
						74.405929,
						31.692639
					],
					[
						75.258642,
						32.271105
					],
					[
						74.451559,
						32.7649
					],
					[
						74.104294,
						33.441473
					],
					[
						73.749948,
						34.317699
					],
					[
						74.240203,
						34.748887
					],
					[
						75.757061,
						34.504923
					],
					[
						76.871722,
						34.653544
					],
					[
						77.837451,
						35.49401
					]
				]
			]
		},
		id: "IND",
		id2: "IN",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Indonesia"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							120.715609,
							-10.239581
						],
						[
							120.295014,
							-10.25865
						],
						[
							118.967808,
							-9.557969
						],
						[
							119.90031,
							-9.36134
						],
						[
							120.425756,
							-9.665921
						],
						[
							120.775502,
							-9.969675
						],
						[
							120.715609,
							-10.239581
						]
					]
				],
				[
					[
						[
							124.43595,
							-10.140001
						],
						[
							123.579982,
							-10.359987
						],
						[
							123.459989,
							-10.239995
						],
						[
							123.550009,
							-9.900016
						],
						[
							123.980009,
							-9.290027
						],
						[
							124.968682,
							-8.89279
						],
						[
							125.07002,
							-9.089987
						],
						[
							125.08852,
							-9.393173
						],
						[
							124.43595,
							-10.140001
						]
					]
				],
				[
					[
						[
							117.900018,
							-8.095681
						],
						[
							118.260616,
							-8.362383
						],
						[
							118.87846,
							-8.280683
						],
						[
							119.126507,
							-8.705825
						],
						[
							117.970402,
							-8.906639
						],
						[
							117.277731,
							-9.040895
						],
						[
							116.740141,
							-9.032937
						],
						[
							117.083737,
							-8.457158
						],
						[
							117.632024,
							-8.449303
						],
						[
							117.900018,
							-8.095681
						]
					]
				],
				[
					[
						[
							122.903537,
							-8.094234
						],
						[
							122.756983,
							-8.649808
						],
						[
							121.254491,
							-8.933666
						],
						[
							119.924391,
							-8.810418
						],
						[
							119.920929,
							-8.444859
						],
						[
							120.715092,
							-8.236965
						],
						[
							121.341669,
							-8.53674
						],
						[
							122.007365,
							-8.46062
						],
						[
							122.903537,
							-8.094234
						]
					]
				],
				[
					[
						[
							108.623479,
							-6.777674
						],
						[
							110.539227,
							-6.877358
						],
						[
							110.759576,
							-6.465186
						],
						[
							112.614811,
							-6.946036
						],
						[
							112.978768,
							-7.594213
						],
						[
							114.478935,
							-7.776528
						],
						[
							115.705527,
							-8.370807
						],
						[
							114.564511,
							-8.751817
						],
						[
							113.464734,
							-8.348947
						],
						[
							112.559672,
							-8.376181
						],
						[
							111.522061,
							-8.302129
						],
						[
							110.58615,
							-8.122605
						],
						[
							109.427667,
							-7.740664
						],
						[
							108.693655,
							-7.6416
						],
						[
							108.277763,
							-7.766657
						],
						[
							106.454102,
							-7.3549
						],
						[
							106.280624,
							-6.9249
						],
						[
							105.365486,
							-6.851416
						],
						[
							106.051646,
							-5.895919
						],
						[
							107.265009,
							-5.954985
						],
						[
							108.072091,
							-6.345762
						],
						[
							108.486846,
							-6.421985
						],
						[
							108.623479,
							-6.777674
						]
					]
				],
				[
					[
						[
							134.724624,
							-6.214401
						],
						[
							134.210134,
							-6.895238
						],
						[
							134.112776,
							-6.142467
						],
						[
							134.290336,
							-5.783058
						],
						[
							134.499625,
							-5.445042
						],
						[
							134.727002,
							-5.737582
						],
						[
							134.724624,
							-6.214401
						]
					]
				],
				[
					[
						[
							127.249215,
							-3.459065
						],
						[
							126.874923,
							-3.790983
						],
						[
							126.183802,
							-3.607376
						],
						[
							125.989034,
							-3.177273
						],
						[
							127.000651,
							-3.129318
						],
						[
							127.249215,
							-3.459065
						]
					]
				],
				[
					[
						[
							130.471344,
							-3.093764
						],
						[
							130.834836,
							-3.858472
						],
						[
							129.990547,
							-3.446301
						],
						[
							129.155249,
							-3.362637
						],
						[
							128.590684,
							-3.428679
						],
						[
							127.898891,
							-3.393436
						],
						[
							128.135879,
							-2.84365
						],
						[
							129.370998,
							-2.802154
						],
						[
							130.471344,
							-3.093764
						]
					]
				],
				[
					[
						[
							134.143368,
							-1.151867
						],
						[
							134.422627,
							-2.769185
						],
						[
							135.457603,
							-3.367753
						],
						[
							136.293314,
							-2.307042
						],
						[
							137.440738,
							-1.703513
						],
						[
							138.329727,
							-1.702686
						],
						[
							139.184921,
							-2.051296
						],
						[
							139.926684,
							-2.409052
						],
						[
							141.00021,
							-2.600151
						],
						[
							141.017057,
							-5.859022
						],
						[
							141.033852,
							-9.117893
						],
						[
							140.143415,
							-8.297168
						],
						[
							139.127767,
							-8.096043
						],
						[
							138.881477,
							-8.380935
						],
						[
							137.614474,
							-8.411683
						],
						[
							138.039099,
							-7.597882
						],
						[
							138.668621,
							-7.320225
						],
						[
							138.407914,
							-6.232849
						],
						[
							137.92784,
							-5.393366
						],
						[
							135.98925,
							-4.546544
						],
						[
							135.164598,
							-4.462931
						],
						[
							133.66288,
							-3.538853
						],
						[
							133.367705,
							-4.024819
						],
						[
							132.983956,
							-4.112979
						],
						[
							132.756941,
							-3.746283
						],
						[
							132.753789,
							-3.311787
						],
						[
							131.989804,
							-2.820551
						],
						[
							133.066845,
							-2.460418
						],
						[
							133.780031,
							-2.479848
						],
						[
							133.696212,
							-2.214542
						],
						[
							132.232373,
							-2.212526
						],
						[
							131.836222,
							-1.617162
						],
						[
							130.94284,
							-1.432522
						],
						[
							130.519558,
							-0.93772
						],
						[
							131.867538,
							-0.695461
						],
						[
							132.380116,
							-0.369538
						],
						[
							133.985548,
							-0.78021
						],
						[
							134.143368,
							-1.151867
						]
					]
				],
				[
					[
						[
							125.240501,
							1.419836
						],
						[
							124.437035,
							0.427881
						],
						[
							123.685505,
							0.235593
						],
						[
							122.723083,
							0.431137
						],
						[
							121.056725,
							0.381217
						],
						[
							120.183083,
							0.237247
						],
						[
							120.04087,
							-0.519658
						],
						[
							120.935905,
							-1.408906
						],
						[
							121.475821,
							-0.955962
						],
						[
							123.340565,
							-0.615673
						],
						[
							123.258399,
							-1.076213
						],
						[
							122.822715,
							-0.930951
						],
						[
							122.38853,
							-1.516858
						],
						[
							121.508274,
							-1.904483
						],
						[
							122.454572,
							-3.186058
						],
						[
							122.271896,
							-3.5295
						],
						[
							123.170963,
							-4.683693
						],
						[
							123.162333,
							-5.340604
						],
						[
							122.628515,
							-5.634591
						],
						[
							122.236394,
							-5.282933
						],
						[
							122.719569,
							-4.464172
						],
						[
							121.738234,
							-4.851331
						],
						[
							121.489463,
							-4.574553
						],
						[
							121.619171,
							-4.188478
						],
						[
							120.898182,
							-3.602105
						],
						[
							120.972389,
							-2.627643
						],
						[
							120.305453,
							-2.931604
						],
						[
							120.390047,
							-4.097579
						],
						[
							120.430717,
							-5.528241
						],
						[
							119.796543,
							-5.6734
						],
						[
							119.366906,
							-5.379878
						],
						[
							119.653606,
							-4.459417
						],
						[
							119.498835,
							-3.494412
						],
						[
							119.078344,
							-3.487022
						],
						[
							118.767769,
							-2.801999
						],
						[
							119.180974,
							-2.147104
						],
						[
							119.323394,
							-1.353147
						],
						[
							119.825999,
							0.154254
						],
						[
							120.035702,
							0.566477
						],
						[
							120.885779,
							1.309223
						],
						[
							121.666817,
							1.013944
						],
						[
							122.927567,
							0.875192
						],
						[
							124.077522,
							0.917102
						],
						[
							125.065989,
							1.643259
						],
						[
							125.240501,
							1.419836
						]
					]
				],
				[
					[
						[
							128.688249,
							1.132386
						],
						[
							128.635952,
							0.258486
						],
						[
							128.12017,
							0.356413
						],
						[
							127.968034,
							-0.252077
						],
						[
							128.379999,
							-0.780004
						],
						[
							128.100016,
							-0.899996
						],
						[
							127.696475,
							-0.266598
						],
						[
							127.39949,
							1.011722
						],
						[
							127.600512,
							1.810691
						],
						[
							127.932378,
							2.174596
						],
						[
							128.004156,
							1.628531
						],
						[
							128.594559,
							1.540811
						],
						[
							128.688249,
							1.132386
						]
					]
				],
				[
					[
						[
							117.875627,
							1.827641
						],
						[
							118.996747,
							0.902219
						],
						[
							117.811858,
							0.784242
						],
						[
							117.478339,
							0.102475
						],
						[
							117.521644,
							-0.803723
						],
						[
							116.560048,
							-1.487661
						],
						[
							116.533797,
							-2.483517
						],
						[
							116.148084,
							-4.012726
						],
						[
							116.000858,
							-3.657037
						],
						[
							114.864803,
							-4.106984
						],
						[
							114.468652,
							-3.495704
						],
						[
							113.755672,
							-3.43917
						],
						[
							113.256994,
							-3.118776
						],
						[
							112.068126,
							-3.478392
						],
						[
							111.703291,
							-2.994442
						],
						[
							111.04824,
							-3.049426
						],
						[
							110.223846,
							-2.934032
						],
						[
							110.070936,
							-1.592874
						],
						[
							109.571948,
							-1.314907
						],
						[
							109.091874,
							-0.459507
						],
						[
							108.952658,
							0.415375
						],
						[
							109.069136,
							1.341934
						],
						[
							109.66326,
							2.006467
						],
						[
							109.830227,
							1.338136
						],
						[
							110.514061,
							0.773131
						],
						[
							111.159138,
							0.976478
						],
						[
							111.797548,
							0.904441
						],
						[
							112.380252,
							1.410121
						],
						[
							112.859809,
							1.49779
						],
						[
							113.80585,
							1.217549
						],
						[
							114.621355,
							1.430688
						],
						[
							115.134037,
							2.821482
						],
						[
							115.519078,
							3.169238
						],
						[
							115.865517,
							4.306559
						],
						[
							117.015214,
							4.306094
						],
						[
							117.882035,
							4.137551
						],
						[
							117.313232,
							3.234428
						],
						[
							118.04833,
							2.28769
						],
						[
							117.875627,
							1.827641
						]
					]
				],
				[
					[
						[
							105.817655,
							-5.852356
						],
						[
							104.710384,
							-5.873285
						],
						[
							103.868213,
							-5.037315
						],
						[
							102.584261,
							-4.220259
						],
						[
							102.156173,
							-3.614146
						],
						[
							101.399113,
							-2.799777
						],
						[
							100.902503,
							-2.050262
						],
						[
							100.141981,
							-0.650348
						],
						[
							99.26374,
							0.183142
						],
						[
							98.970011,
							1.042882
						],
						[
							98.601351,
							1.823507
						],
						[
							97.699598,
							2.453184
						],
						[
							97.176942,
							3.308791
						],
						[
							96.424017,
							3.86886
						],
						[
							95.380876,
							4.970782
						],
						[
							95.293026,
							5.479821
						],
						[
							95.936863,
							5.439513
						],
						[
							97.484882,
							5.246321
						],
						[
							98.369169,
							4.26837
						],
						[
							99.142559,
							3.59035
						],
						[
							99.693998,
							3.174329
						],
						[
							100.641434,
							2.099381
						],
						[
							101.658012,
							2.083697
						],
						[
							102.498271,
							1.3987
						],
						[
							103.07684,
							0.561361
						],
						[
							103.838396,
							0.104542
						],
						[
							103.437645,
							-0.711946
						],
						[
							104.010789,
							-1.059212
						],
						[
							104.369991,
							-1.084843
						],
						[
							104.53949,
							-1.782372
						],
						[
							104.887893,
							-2.340425
						],
						[
							105.622111,
							-2.428844
						],
						[
							106.108593,
							-3.061777
						],
						[
							105.857446,
							-4.305525
						],
						[
							105.817655,
							-5.852356
						]
					]
				]
			]
		},
		id: "IDN",
		id2: "ID",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Iran"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						53.921598,
						37.198918
					],
					[
						54.800304,
						37.392421
					],
					[
						55.511578,
						37.964117
					],
					[
						56.180375,
						37.935127
					],
					[
						56.619366,
						38.121394
					],
					[
						57.330434,
						38.029229
					],
					[
						58.436154,
						37.522309
					],
					[
						59.234762,
						37.412988
					],
					[
						60.377638,
						36.527383
					],
					[
						61.123071,
						36.491597
					],
					[
						61.210817,
						35.650072
					],
					[
						60.803193,
						34.404102
					],
					[
						60.52843,
						33.676446
					],
					[
						60.9637,
						33.528832
					],
					[
						60.536078,
						32.981269
					],
					[
						60.863655,
						32.18292
					],
					[
						60.941945,
						31.548075
					],
					[
						61.699314,
						31.379506
					],
					[
						61.781222,
						30.73585
					],
					[
						60.874248,
						29.829239
					],
					[
						61.369309,
						29.303276
					],
					[
						61.771868,
						28.699334
					],
					[
						62.72783,
						28.259645
					],
					[
						62.755426,
						27.378923
					],
					[
						63.233898,
						27.217047
					],
					[
						63.316632,
						26.756532
					],
					[
						61.874187,
						26.239975
					],
					[
						61.497363,
						25.078237
					],
					[
						59.616134,
						25.380157
					],
					[
						58.525761,
						25.609962
					],
					[
						57.397251,
						25.739902
					],
					[
						56.970766,
						26.966106
					],
					[
						56.492139,
						27.143305
					],
					[
						55.72371,
						26.964633
					],
					[
						54.71509,
						26.480658
					],
					[
						53.493097,
						26.812369
					],
					[
						52.483598,
						27.580849
					],
					[
						51.520763,
						27.86569
					],
					[
						50.852948,
						28.814521
					],
					[
						50.115009,
						30.147773
					],
					[
						49.57685,
						29.985715
					],
					[
						48.941333,
						30.31709
					],
					[
						48.567971,
						29.926778
					],
					[
						48.014568,
						30.452457
					],
					[
						48.004698,
						30.985137
					],
					[
						47.685286,
						30.984853
					],
					[
						47.849204,
						31.709176
					],
					[
						47.334661,
						32.469155
					],
					[
						46.109362,
						33.017287
					],
					[
						45.416691,
						33.967798
					],
					[
						45.64846,
						34.748138
					],
					[
						46.151788,
						35.093259
					],
					[
						46.07634,
						35.677383
					],
					[
						45.420618,
						35.977546
					],
					[
						44.77267,
						37.17045
					],
					[
						44.225756,
						37.971584
					],
					[
						44.421403,
						38.281281
					],
					[
						44.109225,
						39.428136
					],
					[
						44.79399,
						39.713003
					],
					[
						44.952688,
						39.335765
					],
					[
						45.457722,
						38.874139
					],
					[
						46.143623,
						38.741201
					],
					[
						46.50572,
						38.770605
					],
					[
						47.685079,
						39.508364
					],
					[
						48.060095,
						39.582235
					],
					[
						48.355529,
						39.288765
					],
					[
						48.010744,
						38.794015
					],
					[
						48.634375,
						38.270378
					],
					[
						48.883249,
						38.320245
					],
					[
						49.199612,
						37.582874
					],
					[
						50.147771,
						37.374567
					],
					[
						50.842354,
						36.872814
					],
					[
						52.264025,
						36.700422
					],
					[
						53.82579,
						36.965031
					],
					[
						53.921598,
						37.198918
					]
				]
			]
		},
		id: "IRN",
		id2: "IR",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Iraq"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						45.420618,
						35.977546
					],
					[
						46.07634,
						35.677383
					],
					[
						46.151788,
						35.093259
					],
					[
						45.64846,
						34.748138
					],
					[
						45.416691,
						33.967798
					],
					[
						46.109362,
						33.017287
					],
					[
						47.334661,
						32.469155
					],
					[
						47.849204,
						31.709176
					],
					[
						47.685286,
						30.984853
					],
					[
						48.004698,
						30.985137
					],
					[
						48.014568,
						30.452457
					],
					[
						48.567971,
						29.926778
					],
					[
						47.974519,
						29.975819
					],
					[
						47.302622,
						30.05907
					],
					[
						46.568713,
						29.099025
					],
					[
						44.709499,
						29.178891
					],
					[
						41.889981,
						31.190009
					],
					[
						40.399994,
						31.889992
					],
					[
						39.195468,
						32.161009
					],
					[
						38.792341,
						33.378686
					],
					[
						41.006159,
						34.419372
					],
					[
						41.383965,
						35.628317
					],
					[
						41.289707,
						36.358815
					],
					[
						41.837064,
						36.605854
					],
					[
						42.349591,
						37.229873
					],
					[
						42.779126,
						37.385264
					],
					[
						43.942259,
						37.256228
					],
					[
						44.293452,
						37.001514
					],
					[
						44.772699,
						37.170445
					],
					[
						45.420618,
						35.977546
					]
				]
			]
		},
		id: "IRQ",
		id2: "IQ",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Ireland"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-6.197885,
						53.867565
					],
					[
						-6.032985,
						53.153164
					],
					[
						-6.788857,
						52.260118
					],
					[
						-8.561617,
						51.669301
					],
					[
						-9.977086,
						51.820455
					],
					[
						-9.166283,
						52.864629
					],
					[
						-9.688525,
						53.881363
					],
					[
						-8.327987,
						54.664519
					],
					[
						-7.572168,
						55.131622
					],
					[
						-7.366031,
						54.595841
					],
					[
						-7.572168,
						54.059956
					],
					[
						-6.95373,
						54.073702
					],
					[
						-6.197885,
						53.867565
					]
				]
			]
		},
		id: "IRL",
		id2: "IE",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-4.78,
							54.06
						],
						[
							-4.35,
							54.41
						],
						[
							-4.39,
							54.19
						],
						[
							-4.78,
							54.06
						]
					]
				]
			]
		},
		properties: {
			name: "Isle of Man"
		},
		id2: "IM",
		id: "IMN",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Israel"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						35.719918,
						32.709192
					],
					[
						35.545665,
						32.393992
					],
					[
						35.18393,
						32.532511
					],
					[
						34.974641,
						31.866582
					],
					[
						35.225892,
						31.754341
					],
					[
						34.970507,
						31.616778
					],
					[
						34.927408,
						31.353435
					],
					[
						35.397561,
						31.489086
					],
					[
						35.420918,
						31.100066
					],
					[
						34.922603,
						29.501326
					],
					[
						34.265433,
						31.219361
					],
					[
						34.556372,
						31.548824
					],
					[
						34.488107,
						31.605539
					],
					[
						34.752587,
						32.072926
					],
					[
						34.955417,
						32.827376
					],
					[
						35.098457,
						33.080539
					],
					[
						35.126053,
						33.0909
					],
					[
						35.460709,
						33.08904
					],
					[
						35.552797,
						33.264275
					],
					[
						35.821101,
						33.277426
					],
					[
						35.836397,
						32.868123
					],
					[
						35.700798,
						32.716014
					],
					[
						35.719918,
						32.709192
					]
				]
			]
		},
		id: "ISR",
		id2: "IL",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Italy"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							15.520376,
							38.231155
						],
						[
							15.160243,
							37.444046
						],
						[
							15.309898,
							37.134219
						],
						[
							15.099988,
							36.619987
						],
						[
							14.335229,
							36.996631
						],
						[
							13.826733,
							37.104531
						],
						[
							12.431004,
							37.61295
						],
						[
							12.570944,
							38.126381
						],
						[
							13.741156,
							38.034966
						],
						[
							14.761249,
							38.143874
						],
						[
							15.520376,
							38.231155
						]
					]
				],
				[
					[
						[
							9.210012,
							41.209991
						],
						[
							9.809975,
							40.500009
						],
						[
							9.669519,
							39.177376
						],
						[
							9.214818,
							39.240473
						],
						[
							8.806936,
							38.906618
						],
						[
							8.428302,
							39.171847
						],
						[
							8.388253,
							40.378311
						],
						[
							8.159998,
							40.950007
						],
						[
							8.709991,
							40.899984
						],
						[
							9.210012,
							41.209991
						]
					]
				],
				[
					[
						[
							12.376485,
							46.767559
						],
						[
							13.806475,
							46.509306
						],
						[
							13.69811,
							46.016778
						],
						[
							13.93763,
							45.591016
						],
						[
							13.141606,
							45.736692
						],
						[
							12.328581,
							45.381778
						],
						[
							12.383875,
							44.885374
						],
						[
							12.261453,
							44.600482
						],
						[
							12.589237,
							44.091366
						],
						[
							13.526906,
							43.587727
						],
						[
							14.029821,
							42.761008
						],
						[
							15.14257,
							41.95514
						],
						[
							15.926191,
							41.961315
						],
						[
							16.169897,
							41.740295
						],
						[
							15.889346,
							41.541082
						],
						[
							16.785002,
							41.179606
						],
						[
							17.519169,
							40.877143
						],
						[
							18.376687,
							40.355625
						],
						[
							18.480247,
							40.168866
						],
						[
							18.293385,
							39.810774
						],
						[
							17.73838,
							40.277671
						],
						[
							16.869596,
							40.442235
						],
						[
							16.448743,
							39.795401
						],
						[
							17.17149,
							39.4247
						],
						[
							17.052841,
							38.902871
						],
						[
							16.635088,
							38.843572
						],
						[
							16.100961,
							37.985899
						],
						[
							15.684087,
							37.908849
						],
						[
							15.687963,
							38.214593
						],
						[
							15.891981,
							38.750942
						],
						[
							16.109332,
							38.964547
						],
						[
							15.718814,
							39.544072
						],
						[
							15.413613,
							40.048357
						],
						[
							14.998496,
							40.172949
						],
						[
							14.703268,
							40.60455
						],
						[
							14.060672,
							40.786348
						],
						[
							13.627985,
							41.188287
						],
						[
							12.888082,
							41.25309
						],
						[
							12.106683,
							41.704535
						],
						[
							11.191906,
							42.355425
						],
						[
							10.511948,
							42.931463
						],
						[
							10.200029,
							43.920007
						],
						[
							9.702488,
							44.036279
						],
						[
							8.888946,
							44.366336
						],
						[
							8.428561,
							44.231228
						],
						[
							7.850767,
							43.767148
						],
						[
							7.435185,
							43.693845
						],
						[
							7.549596,
							44.127901
						],
						[
							7.007562,
							44.254767
						],
						[
							6.749955,
							45.028518
						],
						[
							7.096652,
							45.333099
						],
						[
							6.802355,
							45.70858
						],
						[
							6.843593,
							45.991147
						],
						[
							7.273851,
							45.776948
						],
						[
							7.755992,
							45.82449
						],
						[
							8.31663,
							46.163642
						],
						[
							8.489952,
							46.005151
						],
						[
							8.966306,
							46.036932
						],
						[
							9.182882,
							46.440215
						],
						[
							9.922837,
							46.314899
						],
						[
							10.363378,
							46.483571
						],
						[
							10.442701,
							46.893546
						],
						[
							11.048556,
							46.751359
						],
						[
							11.164828,
							46.941579
						],
						[
							12.153088,
							47.115393
						],
						[
							12.376485,
							46.767559
						]
					]
				]
			]
		},
		id: "ITA",
		id2: "IT",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Jamaica"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-77.569601,
						18.490525
					],
					[
						-76.896619,
						18.400867
					],
					[
						-76.365359,
						18.160701
					],
					[
						-76.199659,
						17.886867
					],
					[
						-76.902561,
						17.868238
					],
					[
						-77.206341,
						17.701116
					],
					[
						-77.766023,
						17.861597
					],
					[
						-78.337719,
						18.225968
					],
					[
						-78.217727,
						18.454533
					],
					[
						-77.797365,
						18.524218
					],
					[
						-77.569601,
						18.490525
					]
				]
			]
		},
		id: "JAM",
		id2: "JM",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Japan"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							134.638428,
							34.149234
						],
						[
							134.766379,
							33.806335
						],
						[
							134.203416,
							33.201178
						],
						[
							133.79295,
							33.521985
						],
						[
							133.280268,
							33.28957
						],
						[
							133.014858,
							32.704567
						],
						[
							132.363115,
							32.989382
						],
						[
							132.371176,
							33.463642
						],
						[
							132.924373,
							34.060299
						],
						[
							133.492968,
							33.944621
						],
						[
							133.904106,
							34.364931
						],
						[
							134.638428,
							34.149234
						]
					]
				],
				[
					[
						[
							140.976388,
							37.142074
						],
						[
							140.59977,
							36.343983
						],
						[
							140.774074,
							35.842877
						],
						[
							140.253279,
							35.138114
						],
						[
							138.975528,
							34.6676
						],
						[
							137.217599,
							34.606286
						],
						[
							135.792983,
							33.464805
						],
						[
							135.120983,
							33.849071
						],
						[
							135.079435,
							34.596545
						],
						[
							133.340316,
							34.375938
						],
						[
							132.156771,
							33.904933
						],
						[
							130.986145,
							33.885761
						],
						[
							132.000036,
							33.149992
						],
						[
							131.33279,
							31.450355
						],
						[
							130.686318,
							31.029579
						],
						[
							130.20242,
							31.418238
						],
						[
							130.447676,
							32.319475
						],
						[
							129.814692,
							32.61031
						],
						[
							129.408463,
							33.296056
						],
						[
							130.353935,
							33.604151
						],
						[
							130.878451,
							34.232743
						],
						[
							131.884229,
							34.749714
						],
						[
							132.617673,
							35.433393
						],
						[
							134.608301,
							35.731618
						],
						[
							135.677538,
							35.527134
						],
						[
							136.723831,
							37.304984
						],
						[
							137.390612,
							36.827391
						],
						[
							138.857602,
							37.827485
						],
						[
							139.426405,
							38.215962
						],
						[
							140.05479,
							39.438807
						],
						[
							139.883379,
							40.563312
						],
						[
							140.305783,
							41.195005
						],
						[
							141.368973,
							41.37856
						],
						[
							141.914263,
							39.991616
						],
						[
							141.884601,
							39.180865
						],
						[
							140.959489,
							38.174001
						],
						[
							140.976388,
							37.142074
						]
					]
				],
				[
					[
						[
							143.910162,
							44.1741
						],
						[
							144.613427,
							43.960883
						],
						[
							145.320825,
							44.384733
						],
						[
							145.543137,
							43.262088
						],
						[
							144.059662,
							42.988358
						],
						[
							143.18385,
							41.995215
						],
						[
							141.611491,
							42.678791
						],
						[
							141.067286,
							41.584594
						],
						[
							139.955106,
							41.569556
						],
						[
							139.817544,
							42.563759
						],
						[
							140.312087,
							43.333273
						],
						[
							141.380549,
							43.388825
						],
						[
							141.671952,
							44.772125
						],
						[
							141.967645,
							45.551483
						],
						[
							143.14287,
							44.510358
						],
						[
							143.910162,
							44.1741
						]
					]
				]
			]
		},
		id: "JPN",
		id2: "JP",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-2.01,
							49.21
						],
						[
							-2.21,
							49.18
						],
						[
							-2.25,
							49.25
						],
						[
							-2.01,
							49.21
						]
					]
				]
			]
		},
		properties: {
			name: "Jersey"
		},
		id2: "JE",
		id: "JEY",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Jordan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						35.545665,
						32.393992
					],
					[
						35.719918,
						32.709192
					],
					[
						36.834062,
						32.312938
					],
					[
						38.792341,
						33.378686
					],
					[
						39.195468,
						32.161009
					],
					[
						39.004886,
						32.010217
					],
					[
						37.002166,
						31.508413
					],
					[
						37.998849,
						30.5085
					],
					[
						37.66812,
						30.338665
					],
					[
						37.503582,
						30.003776
					],
					[
						36.740528,
						29.865283
					],
					[
						36.501214,
						29.505254
					],
					[
						36.068941,
						29.197495
					],
					[
						34.956037,
						29.356555
					],
					[
						34.922603,
						29.501326
					],
					[
						35.420918,
						31.100066
					],
					[
						35.397561,
						31.489086
					],
					[
						35.545252,
						31.782505
					],
					[
						35.545665,
						32.393992
					]
				]
			]
		},
		id: "JOR",
		id2: "JO",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Kazakhstan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						70.962315,
						42.266154
					],
					[
						70.388965,
						42.081308
					],
					[
						69.070027,
						41.384244
					],
					[
						68.632483,
						40.668681
					],
					[
						68.259896,
						40.662325
					],
					[
						67.985856,
						41.135991
					],
					[
						66.714047,
						41.168444
					],
					[
						66.510649,
						41.987644
					],
					[
						66.023392,
						41.994646
					],
					[
						66.098012,
						42.99766
					],
					[
						64.900824,
						43.728081
					],
					[
						63.185787,
						43.650075
					],
					[
						62.0133,
						43.504477
					],
					[
						61.05832,
						44.405817
					],
					[
						60.239972,
						44.784037
					],
					[
						58.689989,
						45.500014
					],
					[
						58.503127,
						45.586804
					],
					[
						55.928917,
						44.995858
					],
					[
						55.968191,
						41.308642
					],
					[
						55.455251,
						41.259859
					],
					[
						54.755345,
						42.043971
					],
					[
						54.079418,
						42.324109
					],
					[
						52.944293,
						42.116034
					],
					[
						52.50246,
						41.783316
					],
					[
						52.446339,
						42.027151
					],
					[
						52.692112,
						42.443895
					],
					[
						52.501426,
						42.792298
					],
					[
						51.342427,
						43.132975
					],
					[
						50.891292,
						44.031034
					],
					[
						50.339129,
						44.284016
					],
					[
						50.305643,
						44.609836
					],
					[
						51.278503,
						44.514854
					],
					[
						51.316899,
						45.245998
					],
					[
						52.16739,
						45.408391
					],
					[
						53.040876,
						45.259047
					],
					[
						53.220866,
						46.234646
					],
					[
						53.042737,
						46.853006
					],
					[
						52.042023,
						46.804637
					],
					[
						51.191945,
						47.048705
					],
					[
						50.034083,
						46.60899
					],
					[
						49.10116,
						46.39933
					],
					[
						48.593241,
						46.561034
					],
					[
						48.694734,
						47.075628
					],
					[
						48.057253,
						47.743753
					],
					[
						47.315231,
						47.715847
					],
					[
						46.466446,
						48.394152
					],
					[
						47.043672,
						49.152039
					],
					[
						46.751596,
						49.356006
					],
					[
						47.54948,
						50.454698
					],
					[
						48.577841,
						49.87476
					],
					[
						48.702382,
						50.605128
					],
					[
						50.766648,
						51.692762
					],
					[
						52.328724,
						51.718652
					],
					[
						54.532878,
						51.02624
					],
					[
						55.716941,
						50.621717
					],
					[
						56.777961,
						51.043551
					],
					[
						58.363291,
						51.063653
					],
					[
						59.642282,
						50.545442
					],
					[
						59.932807,
						50.842194
					],
					[
						61.337424,
						50.79907
					],
					[
						61.588003,
						51.272659
					],
					[
						59.967534,
						51.96042
					],
					[
						60.927269,
						52.447548
					],
					[
						60.739993,
						52.719986
					],
					[
						61.699986,
						52.979996
					],
					[
						60.978066,
						53.664993
					],
					[
						61.436591,
						54.006265
					],
					[
						65.178534,
						54.354228
					],
					[
						65.666876,
						54.601267
					],
					[
						68.1691,
						54.970392
					],
					[
						69.068167,
						55.38525
					],
					[
						70.865267,
						55.169734
					],
					[
						71.180131,
						54.133285
					],
					[
						72.22415,
						54.376655
					],
					[
						73.508516,
						54.035617
					],
					[
						73.425679,
						53.48981
					],
					[
						74.384845,
						53.546861
					],
					[
						76.8911,
						54.490524
					],
					[
						76.525179,
						54.177003
					],
					[
						77.800916,
						53.404415
					],
					[
						80.03556,
						50.864751
					],
					[
						80.568447,
						51.388336
					],
					[
						81.945986,
						50.812196
					],
					[
						83.383004,
						51.069183
					],
					[
						83.935115,
						50.889246
					],
					[
						84.416377,
						50.3114
					],
					[
						85.11556,
						50.117303
					],
					[
						85.54127,
						49.692859
					],
					[
						86.829357,
						49.826675
					],
					[
						87.35997,
						49.214981
					],
					[
						86.598776,
						48.549182
					],
					[
						85.768233,
						48.455751
					],
					[
						85.720484,
						47.452969
					],
					[
						85.16429,
						47.000956
					],
					[
						83.180484,
						47.330031
					],
					[
						82.458926,
						45.53965
					],
					[
						81.947071,
						45.317027
					],
					[
						79.966106,
						44.917517
					],
					[
						80.866206,
						43.180362
					],
					[
						80.18015,
						42.920068
					],
					[
						80.25999,
						42.349999
					],
					[
						79.643645,
						42.496683
					],
					[
						79.142177,
						42.856092
					],
					[
						77.658392,
						42.960686
					],
					[
						76.000354,
						42.988022
					],
					[
						75.636965,
						42.8779
					],
					[
						74.212866,
						43.298339
					],
					[
						73.645304,
						43.091272
					],
					[
						73.489758,
						42.500894
					],
					[
						71.844638,
						42.845395
					],
					[
						71.186281,
						42.704293
					],
					[
						70.962315,
						42.266154
					]
				]
			]
		},
		id: "KAZ",
		id2: "KZ",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Kenya"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						40.993,
						-0.85829
					],
					[
						41.58513,
						-1.68325
					],
					[
						40.88477,
						-2.08255
					],
					[
						40.63785,
						-2.49979
					],
					[
						40.26304,
						-2.57309
					],
					[
						40.12119,
						-3.27768
					],
					[
						39.80006,
						-3.68116
					],
					[
						39.60489,
						-4.34653
					],
					[
						39.20222,
						-4.67677
					],
					[
						37.7669,
						-3.67712
					],
					[
						37.69869,
						-3.09699
					],
					[
						34.07262,
						-1.05982
					],
					[
						33.903711,
						-0.95
					],
					[
						33.893569,
						0.109814
					],
					[
						34.18,
						0.515
					],
					[
						34.6721,
						1.17694
					],
					[
						35.03599,
						1.90584
					],
					[
						34.59607,
						3.05374
					],
					[
						34.47913,
						3.5556
					],
					[
						34.005,
						4.249885
					],
					[
						34.620196,
						4.847123
					],
					[
						35.298007,
						5.506
					],
					[
						35.817448,
						5.338232
					],
					[
						35.817448,
						4.776966
					],
					[
						36.159079,
						4.447864
					],
					[
						36.855093,
						4.447864
					],
					[
						38.120915,
						3.598605
					],
					[
						38.43697,
						3.58851
					],
					[
						38.67114,
						3.61607
					],
					[
						38.89251,
						3.50074
					],
					[
						39.559384,
						3.42206
					],
					[
						39.85494,
						3.83879
					],
					[
						40.76848,
						4.25702
					],
					[
						41.1718,
						3.91909
					],
					[
						41.855083,
						3.918912
					],
					[
						40.98105,
						2.78452
					],
					[
						40.993,
						-0.85829
					]
				]
			]
		},
		id: "KEN",
		id2: "KE",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							175.59,
							-1.92
						],
						[
							175.55,
							-1.82
						],
						[
							175.59,
							-1.88
						],
						[
							175.59,
							-1.92
						]
					]
				],
				[
					[
						[
							175.04,
							-1.55
						],
						[
							175,
							-1.53
						],
						[
							175.05,
							-1.43
						],
						[
							175.04,
							-1.55
						]
					]
				],
				[
					[
						[
							173.62,
							0.13
						],
						[
							173.6,
							0.21
						],
						[
							173.63,
							0.22
						],
						[
							173.62,
							0.13
						]
					]
				],
				[
					[
						[
							173.02,
							1.01
						],
						[
							173.08,
							0.95
						],
						[
							172.98,
							0.82
						],
						[
							173.02,
							1.01
						]
					]
				],
				[
					[
						[
							173.01,
							1.71
						],
						[
							172.93,
							1.94
						],
						[
							173.03,
							1.82
						],
						[
							173.01,
							1.71
						]
					]
				],
				[
					[
						[
							172.87,
							3.06
						],
						[
							172.77,
							3
						],
						[
							172.75,
							3.02
						],
						[
							172.87,
							3.06
						]
					]
				]
			]
		},
		properties: {
			name: "Kiribati"
		},
		id2: "KI",
		id: "KIR",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "North Korea"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						130.640016,
						42.395009
					],
					[
						130.780007,
						42.220007
					],
					[
						130.400031,
						42.280004
					],
					[
						129.965949,
						41.941368
					],
					[
						129.667362,
						41.601104
					],
					[
						129.705189,
						40.882828
					],
					[
						129.188115,
						40.661808
					],
					[
						129.0104,
						40.485436
					],
					[
						128.633368,
						40.189847
					],
					[
						127.967414,
						40.025413
					],
					[
						127.533436,
						39.75685
					],
					[
						127.50212,
						39.323931
					],
					[
						127.385434,
						39.213472
					],
					[
						127.783343,
						39.050898
					],
					[
						128.349716,
						38.612243
					],
					[
						128.205746,
						38.370397
					],
					[
						127.780035,
						38.304536
					],
					[
						127.073309,
						38.256115
					],
					[
						126.68372,
						37.804773
					],
					[
						126.237339,
						37.840378
					],
					[
						126.174759,
						37.749686
					],
					[
						125.689104,
						37.94001
					],
					[
						125.568439,
						37.752089
					],
					[
						125.27533,
						37.669071
					],
					[
						125.240087,
						37.857224
					],
					[
						124.981033,
						37.948821
					],
					[
						124.712161,
						38.108346
					],
					[
						124.985994,
						38.548474
					],
					[
						125.221949,
						38.665857
					],
					[
						125.132859,
						38.848559
					],
					[
						125.38659,
						39.387958
					],
					[
						125.321116,
						39.551385
					],
					[
						124.737482,
						39.660344
					],
					[
						124.265625,
						39.928493
					],
					[
						125.079942,
						40.569824
					],
					[
						126.182045,
						41.107336
					],
					[
						126.869083,
						41.816569
					],
					[
						127.343783,
						41.503152
					],
					[
						128.208433,
						41.466772
					],
					[
						128.052215,
						41.994285
					],
					[
						129.596669,
						42.424982
					],
					[
						129.994267,
						42.985387
					],
					[
						130.640016,
						42.395009
					]
				]
			]
		},
		id: "PRK",
		id2: "KP",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "South Korea"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						128.349716,
						38.612243
					],
					[
						129.21292,
						37.432392
					],
					[
						129.46045,
						36.784189
					],
					[
						129.468304,
						35.632141
					],
					[
						129.091377,
						35.082484
					],
					[
						128.18585,
						34.890377
					],
					[
						127.386519,
						34.475674
					],
					[
						126.485748,
						34.390046
					],
					[
						126.37392,
						34.93456
					],
					[
						126.559231,
						35.684541
					],
					[
						126.117398,
						36.725485
					],
					[
						126.860143,
						36.893924
					],
					[
						126.174759,
						37.749686
					],
					[
						126.237339,
						37.840378
					],
					[
						126.68372,
						37.804773
					],
					[
						127.073309,
						38.256115
					],
					[
						127.780035,
						38.304536
					],
					[
						128.205746,
						38.370397
					],
					[
						128.349716,
						38.612243
					]
				]
			]
		},
		id: "KOR",
		id2: "KR",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Kuwait"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						47.974519,
						29.975819
					],
					[
						48.183189,
						29.534477
					],
					[
						48.093943,
						29.306299
					],
					[
						48.416094,
						28.552004
					],
					[
						47.708851,
						28.526063
					],
					[
						47.459822,
						29.002519
					],
					[
						46.568713,
						29.099025
					],
					[
						47.302622,
						30.05907
					],
					[
						47.974519,
						29.975819
					]
				]
			]
		},
		id: "KWT",
		id2: "KW",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Kyrgyzstan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						70.962315,
						42.266154
					],
					[
						71.186281,
						42.704293
					],
					[
						71.844638,
						42.845395
					],
					[
						73.489758,
						42.500894
					],
					[
						73.645304,
						43.091272
					],
					[
						74.212866,
						43.298339
					],
					[
						75.636965,
						42.8779
					],
					[
						76.000354,
						42.988022
					],
					[
						77.658392,
						42.960686
					],
					[
						79.142177,
						42.856092
					],
					[
						79.643645,
						42.496683
					],
					[
						80.25999,
						42.349999
					],
					[
						80.11943,
						42.123941
					],
					[
						78.543661,
						41.582243
					],
					[
						78.187197,
						41.185316
					],
					[
						76.904484,
						41.066486
					],
					[
						76.526368,
						40.427946
					],
					[
						75.467828,
						40.562072
					],
					[
						74.776862,
						40.366425
					],
					[
						73.822244,
						39.893973
					],
					[
						73.960013,
						39.660008
					],
					[
						73.675379,
						39.431237
					],
					[
						71.784694,
						39.279463
					],
					[
						70.549162,
						39.604198
					],
					[
						69.464887,
						39.526683
					],
					[
						69.55961,
						40.103211
					],
					[
						70.648019,
						39.935754
					],
					[
						71.014198,
						40.244366
					],
					[
						71.774875,
						40.145844
					],
					[
						73.055417,
						40.866033
					],
					[
						71.870115,
						41.3929
					],
					[
						71.157859,
						41.143587
					],
					[
						70.420022,
						41.519998
					],
					[
						71.259248,
						42.167711
					],
					[
						70.962315,
						42.266154
					]
				]
			]
		},
		id: "KGZ",
		id2: "KG",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Laos"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						105.218777,
						14.273212
					],
					[
						105.544338,
						14.723934
					],
					[
						105.589039,
						15.570316
					],
					[
						104.779321,
						16.441865
					],
					[
						104.716947,
						17.428859
					],
					[
						103.956477,
						18.240954
					],
					[
						103.200192,
						18.309632
					],
					[
						102.998706,
						17.961695
					],
					[
						102.413005,
						17.932782
					],
					[
						102.113592,
						18.109102
					],
					[
						101.059548,
						17.512497
					],
					[
						101.035931,
						18.408928
					],
					[
						101.282015,
						19.462585
					],
					[
						100.606294,
						19.508344
					],
					[
						100.548881,
						20.109238
					],
					[
						100.115988,
						20.41785
					],
					[
						100.329101,
						20.786122
					],
					[
						101.180005,
						21.436573
					],
					[
						101.270026,
						21.201652
					],
					[
						101.80312,
						21.174367
					],
					[
						101.652018,
						22.318199
					],
					[
						102.170436,
						22.464753
					],
					[
						102.754896,
						21.675137
					],
					[
						103.203861,
						20.766562
					],
					[
						104.435,
						20.758733
					],
					[
						104.822574,
						19.886642
					],
					[
						104.183388,
						19.624668
					],
					[
						103.896532,
						19.265181
					],
					[
						105.094598,
						18.666975
					],
					[
						105.925762,
						17.485315
					],
					[
						106.556008,
						16.604284
					],
					[
						107.312706,
						15.908538
					],
					[
						107.564525,
						15.202173
					],
					[
						107.382727,
						14.202441
					],
					[
						106.496373,
						14.570584
					],
					[
						106.043946,
						13.881091
					],
					[
						105.218777,
						14.273212
					]
				]
			]
		},
		id: "LAO",
		id2: "LA",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Latvia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						21.0558,
						56.031076
					],
					[
						21.090424,
						56.783873
					],
					[
						21.581866,
						57.411871
					],
					[
						22.524341,
						57.753374
					],
					[
						23.318453,
						57.006236
					],
					[
						24.12073,
						57.025693
					],
					[
						24.312863,
						57.793424
					],
					[
						25.164594,
						57.970157
					],
					[
						25.60281,
						57.847529
					],
					[
						26.463532,
						57.476389
					],
					[
						27.288185,
						57.474528
					],
					[
						27.770016,
						57.244258
					],
					[
						27.855282,
						56.759326
					],
					[
						28.176709,
						56.16913
					],
					[
						27.10246,
						55.783314
					],
					[
						26.494331,
						55.615107
					],
					[
						25.533047,
						56.100297
					],
					[
						25.000934,
						56.164531
					],
					[
						24.860684,
						56.372528
					],
					[
						23.878264,
						56.273671
					],
					[
						22.201157,
						56.337802
					],
					[
						21.0558,
						56.031076
					]
				]
			]
		},
		id: "LVA",
		id2: "LV",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Lebanon"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						35.821101,
						33.277426
					],
					[
						35.552797,
						33.264275
					],
					[
						35.460709,
						33.08904
					],
					[
						35.126053,
						33.0909
					],
					[
						35.482207,
						33.90545
					],
					[
						35.979592,
						34.610058
					],
					[
						35.998403,
						34.644914
					],
					[
						36.448194,
						34.593935
					],
					[
						36.61175,
						34.201789
					],
					[
						36.06646,
						33.824912
					],
					[
						35.821101,
						33.277426
					]
				]
			]
		},
		id: "LBN",
		id2: "LB",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Lesotho"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						28.978263,
						-28.955597
					],
					[
						29.325166,
						-29.257387
					],
					[
						29.018415,
						-29.743766
					],
					[
						28.8484,
						-30.070051
					],
					[
						28.291069,
						-30.226217
					],
					[
						28.107205,
						-30.545732
					],
					[
						27.749397,
						-30.645106
					],
					[
						26.999262,
						-29.875954
					],
					[
						27.532511,
						-29.242711
					],
					[
						28.074338,
						-28.851469
					],
					[
						28.5417,
						-28.647502
					],
					[
						28.978263,
						-28.955597
					]
				]
			]
		},
		id: "LSO",
		id2: "LS",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Liberia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-7.712159,
						4.364566
					],
					[
						-7.974107,
						4.355755
					],
					[
						-9.004794,
						4.832419
					],
					[
						-9.91342,
						5.593561
					],
					[
						-10.765384,
						6.140711
					],
					[
						-11.438779,
						6.785917
					],
					[
						-11.199802,
						7.105846
					],
					[
						-11.146704,
						7.396706
					],
					[
						-10.695595,
						7.939464
					],
					[
						-10.230094,
						8.406206
					],
					[
						-10.016567,
						8.428504
					],
					[
						-9.755342,
						8.541055
					],
					[
						-9.33728,
						7.928534
					],
					[
						-9.403348,
						7.526905
					],
					[
						-9.208786,
						7.313921
					],
					[
						-8.926065,
						7.309037
					],
					[
						-8.722124,
						7.711674
					],
					[
						-8.439298,
						7.686043
					],
					[
						-8.485446,
						7.395208
					],
					[
						-8.385452,
						6.911801
					],
					[
						-8.60288,
						6.467564
					],
					[
						-8.311348,
						6.193033
					],
					[
						-7.993693,
						6.12619
					],
					[
						-7.570153,
						5.707352
					],
					[
						-7.539715,
						5.313345
					],
					[
						-7.635368,
						5.188159
					],
					[
						-7.712159,
						4.364566
					]
				]
			]
		},
		id: "LBR",
		id2: "LR",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Libya"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						14.8513,
						22.86295
					],
					[
						14.143871,
						22.491289
					],
					[
						13.581425,
						23.040506
					],
					[
						11.999506,
						23.471668
					],
					[
						11.560669,
						24.097909
					],
					[
						10.771364,
						24.562532
					],
					[
						10.303847,
						24.379313
					],
					[
						9.948261,
						24.936954
					],
					[
						9.910693,
						25.365455
					],
					[
						9.319411,
						26.094325
					],
					[
						9.716286,
						26.512206
					],
					[
						9.629056,
						27.140953
					],
					[
						9.756128,
						27.688259
					],
					[
						9.683885,
						28.144174
					],
					[
						9.859998,
						28.95999
					],
					[
						9.805634,
						29.424638
					],
					[
						9.48214,
						30.307556
					],
					[
						9.970017,
						30.539325
					],
					[
						10.056575,
						30.961831
					],
					[
						9.950225,
						31.37607
					],
					[
						10.636901,
						31.761421
					],
					[
						10.94479,
						32.081815
					],
					[
						11.432253,
						32.368903
					],
					[
						11.488787,
						33.136996
					],
					[
						12.66331,
						32.79278
					],
					[
						13.08326,
						32.87882
					],
					[
						13.91868,
						32.71196
					],
					[
						15.24563,
						32.26508
					],
					[
						15.71394,
						31.37626
					],
					[
						16.61162,
						31.18218
					],
					[
						18.02109,
						30.76357
					],
					[
						19.08641,
						30.26639
					],
					[
						19.57404,
						30.52582
					],
					[
						20.05335,
						30.98576
					],
					[
						19.82033,
						31.75179
					],
					[
						20.13397,
						32.2382
					],
					[
						20.85452,
						32.7068
					],
					[
						21.54298,
						32.8432
					],
					[
						22.89576,
						32.63858
					],
					[
						23.2368,
						32.19149
					],
					[
						23.60913,
						32.18726
					],
					[
						23.9275,
						32.01667
					],
					[
						24.92114,
						31.89936
					],
					[
						25.16482,
						31.56915
					],
					[
						24.80287,
						31.08929
					],
					[
						24.95762,
						30.6616
					],
					[
						24.70007,
						30.04419
					],
					[
						25,
						29.238655
					],
					[
						25,
						25.6825
					],
					[
						25,
						22
					],
					[
						25,
						20.00304
					],
					[
						23.85,
						20
					],
					[
						23.83766,
						19.58047
					],
					[
						19.84926,
						21.49509
					],
					[
						15.86085,
						23.40972
					],
					[
						14.8513,
						22.86295
					]
				]
			]
		},
		id: "LBY",
		id2: "LY",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Liechtenstein"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						9.53,
						47.27
					],
					[
						9.6,
						47.06
					],
					[
						9.47,
						47.06
					],
					[
						9.53,
						47.27
					]
				]
			]
		},
		id: "LIE",
		id2: "LI",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Lithuania"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						22.731099,
						54.327537
					],
					[
						22.651052,
						54.582741
					],
					[
						22.757764,
						54.856574
					],
					[
						22.315724,
						55.015299
					],
					[
						21.268449,
						55.190482
					],
					[
						21.0558,
						56.031076
					],
					[
						22.201157,
						56.337802
					],
					[
						23.878264,
						56.273671
					],
					[
						24.860684,
						56.372528
					],
					[
						25.000934,
						56.164531
					],
					[
						25.533047,
						56.100297
					],
					[
						26.494331,
						55.615107
					],
					[
						26.588279,
						55.167176
					],
					[
						25.768433,
						54.846963
					],
					[
						25.536354,
						54.282423
					],
					[
						24.450684,
						53.905702
					],
					[
						23.484128,
						53.912498
					],
					[
						23.243987,
						54.220567
					],
					[
						22.731099,
						54.327537
					]
				]
			]
		},
		id: "LTU",
		id2: "LT",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Luxembourg"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						6.043073,
						50.128052
					],
					[
						6.242751,
						49.902226
					],
					[
						6.18632,
						49.463803
					],
					[
						5.897759,
						49.442667
					],
					[
						5.674052,
						49.529484
					],
					[
						5.782417,
						50.090328
					],
					[
						6.043073,
						50.128052
					]
				]
			]
		},
		id: "LUX",
		id2: "LU",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Madagascar"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						49.543519,
						-12.469833
					],
					[
						49.808981,
						-12.895285
					],
					[
						50.056511,
						-13.555761
					],
					[
						50.217431,
						-14.758789
					],
					[
						50.476537,
						-15.226512
					],
					[
						50.377111,
						-15.706069
					],
					[
						50.200275,
						-16.000263
					],
					[
						49.860606,
						-15.414253
					],
					[
						49.672607,
						-15.710204
					],
					[
						49.863344,
						-16.451037
					],
					[
						49.774564,
						-16.875042
					],
					[
						49.498612,
						-17.106036
					],
					[
						49.435619,
						-17.953064
					],
					[
						49.041792,
						-19.118781
					],
					[
						48.548541,
						-20.496888
					],
					[
						47.930749,
						-22.391501
					],
					[
						47.547723,
						-23.781959
					],
					[
						47.095761,
						-24.94163
					],
					[
						46.282478,
						-25.178463
					],
					[
						45.409508,
						-25.601434
					],
					[
						44.833574,
						-25.346101
					],
					[
						44.03972,
						-24.988345
					],
					[
						43.763768,
						-24.460677
					],
					[
						43.697778,
						-23.574116
					],
					[
						43.345654,
						-22.776904
					],
					[
						43.254187,
						-22.057413
					],
					[
						43.433298,
						-21.336475
					],
					[
						43.893683,
						-21.163307
					],
					[
						43.89637,
						-20.830459
					],
					[
						44.374325,
						-20.072366
					],
					[
						44.464397,
						-19.435454
					],
					[
						44.232422,
						-18.961995
					],
					[
						44.042976,
						-18.331387
					],
					[
						43.963084,
						-17.409945
					],
					[
						44.312469,
						-16.850496
					],
					[
						44.446517,
						-16.216219
					],
					[
						44.944937,
						-16.179374
					],
					[
						45.502732,
						-15.974373
					],
					[
						45.872994,
						-15.793454
					],
					[
						46.312243,
						-15.780018
					],
					[
						46.882183,
						-15.210182
					],
					[
						47.70513,
						-14.594303
					],
					[
						48.005215,
						-14.091233
					],
					[
						47.869047,
						-13.663869
					],
					[
						48.293828,
						-13.784068
					],
					[
						48.84506,
						-13.089175
					],
					[
						48.863509,
						-12.487868
					],
					[
						49.194651,
						-12.040557
					],
					[
						49.543519,
						-12.469833
					]
				]
			]
		},
		id: "MDG",
		id2: "MG",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Malawi"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						34.559989,
						-11.52002
					],
					[
						34.280006,
						-12.280025
					],
					[
						34.559989,
						-13.579998
					],
					[
						34.907151,
						-13.565425
					],
					[
						35.267956,
						-13.887834
					],
					[
						35.686845,
						-14.611046
					],
					[
						35.771905,
						-15.896859
					],
					[
						35.339063,
						-16.10744
					],
					[
						35.03381,
						-16.8013
					],
					[
						34.381292,
						-16.18356
					],
					[
						34.307291,
						-15.478641
					],
					[
						34.517666,
						-15.013709
					],
					[
						34.459633,
						-14.61301
					],
					[
						34.064825,
						-14.35995
					],
					[
						33.7897,
						-14.451831
					],
					[
						33.214025,
						-13.97186
					],
					[
						32.688165,
						-13.712858
					],
					[
						32.991764,
						-12.783871
					],
					[
						33.306422,
						-12.435778
					],
					[
						33.114289,
						-11.607198
					],
					[
						33.31531,
						-10.79655
					],
					[
						33.485688,
						-10.525559
					],
					[
						33.231388,
						-9.676722
					],
					[
						32.759375,
						-9.230599
					],
					[
						33.739729,
						-9.417151
					],
					[
						33.940838,
						-9.693674
					],
					[
						34.280006,
						-10.16
					],
					[
						34.559989,
						-11.52002
					]
				]
			]
		},
		id: "MWI",
		id2: "MW",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Malaysia"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							101.075516,
							6.204867
						],
						[
							101.154219,
							5.691384
						],
						[
							101.814282,
							5.810808
						],
						[
							102.141187,
							6.221636
						],
						[
							102.371147,
							6.128205
						],
						[
							102.961705,
							5.524495
						],
						[
							103.381215,
							4.855001
						],
						[
							103.438575,
							4.181606
						],
						[
							103.332122,
							3.726698
						],
						[
							103.429429,
							3.382869
						],
						[
							103.502448,
							2.791019
						],
						[
							103.854674,
							2.515454
						],
						[
							104.247932,
							1.631141
						],
						[
							104.228811,
							1.293048
						],
						[
							103.519707,
							1.226334
						],
						[
							102.573615,
							1.967115
						],
						[
							101.390638,
							2.760814
						],
						[
							101.27354,
							3.270292
						],
						[
							100.695435,
							3.93914
						],
						[
							100.557408,
							4.76728
						],
						[
							100.196706,
							5.312493
						],
						[
							100.30626,
							6.040562
						],
						[
							100.085757,
							6.464489
						],
						[
							100.259596,
							6.642825
						],
						[
							101.075516,
							6.204867
						]
					]
				],
				[
					[
						[
							118.618321,
							4.478202
						],
						[
							117.882035,
							4.137551
						],
						[
							117.015214,
							4.306094
						],
						[
							115.865517,
							4.306559
						],
						[
							115.519078,
							3.169238
						],
						[
							115.134037,
							2.821482
						],
						[
							114.621355,
							1.430688
						],
						[
							113.80585,
							1.217549
						],
						[
							112.859809,
							1.49779
						],
						[
							112.380252,
							1.410121
						],
						[
							111.797548,
							0.904441
						],
						[
							111.159138,
							0.976478
						],
						[
							110.514061,
							0.773131
						],
						[
							109.830227,
							1.338136
						],
						[
							109.66326,
							2.006467
						],
						[
							110.396135,
							1.663775
						],
						[
							111.168853,
							1.850637
						],
						[
							111.370081,
							2.697303
						],
						[
							111.796928,
							2.885897
						],
						[
							112.995615,
							3.102395
						],
						[
							113.712935,
							3.893509
						],
						[
							114.204017,
							4.525874
						],
						[
							114.659596,
							4.007637
						],
						[
							114.869557,
							4.348314
						],
						[
							115.347461,
							4.316636
						],
						[
							115.4057,
							4.955228
						],
						[
							115.45071,
							5.44773
						],
						[
							116.220741,
							6.143191
						],
						[
							116.725103,
							6.924771
						],
						[
							117.129626,
							6.928053
						],
						[
							117.643393,
							6.422166
						],
						[
							117.689075,
							5.98749
						],
						[
							118.347691,
							5.708696
						],
						[
							119.181904,
							5.407836
						],
						[
							119.110694,
							5.016128
						],
						[
							118.439727,
							4.966519
						],
						[
							118.618321,
							4.478202
						]
					]
				]
			]
		},
		id: "MYS",
		id2: "MY",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							73.18,
							-0.69
						],
						[
							73.16,
							-0.68
						],
						[
							73.17,
							-0.68
						],
						[
							73.18,
							-0.69
						]
					]
				],
				[
					[
						[
							73.2,
							-0.68
						],
						[
							73.19,
							-0.68
						],
						[
							73.2,
							-0.67
						],
						[
							73.2,
							-0.68
						]
					]
				],
				[
					[
						[
							73.13,
							-0.67
						],
						[
							73.13,
							-0.67
						],
						[
							73.12,
							-0.65
						],
						[
							73.13,
							-0.67
						]
					]
				],
				[
					[
						[
							73.23,
							-0.65
						],
						[
							73.23,
							-0.63
						],
						[
							73.24,
							-0.62
						],
						[
							73.23,
							-0.65
						]
					]
				],
				[
					[
						[
							73.12,
							-0.64
						],
						[
							73.09,
							-0.61
						],
						[
							73.09,
							-0.58
						],
						[
							73.12,
							-0.64
						]
					]
				],
				[
					[
						[
							73.25,
							-0.61
						],
						[
							73.24,
							-0.59
						],
						[
							73.25,
							-0.58
						],
						[
							73.25,
							-0.61
						]
					]
				]
			]
		},
		properties: {
			name: "Maldives"
		},
		id2: "MV",
		id: "MDV",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Mali"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-12.17075,
						14.616834
					],
					[
						-11.834208,
						14.799097
					],
					[
						-11.666078,
						15.388208
					],
					[
						-11.349095,
						15.411256
					],
					[
						-10.650791,
						15.132746
					],
					[
						-10.086846,
						15.330486
					],
					[
						-9.700255,
						15.264107
					],
					[
						-9.550238,
						15.486497
					],
					[
						-5.537744,
						15.50169
					],
					[
						-5.315277,
						16.201854
					],
					[
						-5.488523,
						16.325102
					],
					[
						-5.971129,
						20.640833
					],
					[
						-6.453787,
						24.956591
					],
					[
						-4.923337,
						24.974574
					],
					[
						-1.550055,
						22.792666
					],
					[
						1.823228,
						20.610809
					],
					[
						2.060991,
						20.142233
					],
					[
						2.683588,
						19.85623
					],
					[
						3.146661,
						19.693579
					],
					[
						3.158133,
						19.057364
					],
					[
						4.267419,
						19.155265
					],
					[
						4.27021,
						16.852227
					],
					[
						3.723422,
						16.184284
					],
					[
						3.638259,
						15.56812
					],
					[
						2.749993,
						15.409525
					],
					[
						1.385528,
						15.323561
					],
					[
						1.015783,
						14.968182
					],
					[
						0.374892,
						14.928908
					],
					[
						-0.266257,
						14.924309
					],
					[
						-0.515854,
						15.116158
					],
					[
						-1.066363,
						14.973815
					],
					[
						-2.001035,
						14.559008
					],
					[
						-2.191825,
						14.246418
					],
					[
						-2.967694,
						13.79815
					],
					[
						-3.103707,
						13.541267
					],
					[
						-3.522803,
						13.337662
					],
					[
						-4.006391,
						13.472485
					],
					[
						-4.280405,
						13.228444
					],
					[
						-4.427166,
						12.542646
					],
					[
						-5.220942,
						11.713859
					],
					[
						-5.197843,
						11.375146
					],
					[
						-5.470565,
						10.95127
					],
					[
						-5.404342,
						10.370737
					],
					[
						-5.816926,
						10.222555
					],
					[
						-6.050452,
						10.096361
					],
					[
						-6.205223,
						10.524061
					],
					[
						-6.493965,
						10.411303
					],
					[
						-6.666461,
						10.430811
					],
					[
						-6.850507,
						10.138994
					],
					[
						-7.622759,
						10.147236
					],
					[
						-7.89959,
						10.297382
					],
					[
						-8.029944,
						10.206535
					],
					[
						-8.335377,
						10.494812
					],
					[
						-8.282357,
						10.792597
					],
					[
						-8.407311,
						10.909257
					],
					[
						-8.620321,
						10.810891
					],
					[
						-8.581305,
						11.136246
					],
					[
						-8.376305,
						11.393646
					],
					[
						-8.786099,
						11.812561
					],
					[
						-8.905265,
						12.088358
					],
					[
						-9.127474,
						12.30806
					],
					[
						-9.327616,
						12.334286
					],
					[
						-9.567912,
						12.194243
					],
					[
						-9.890993,
						12.060479
					],
					[
						-10.165214,
						11.844084
					],
					[
						-10.593224,
						11.923975
					],
					[
						-10.87083,
						12.177887
					],
					[
						-11.036556,
						12.211245
					],
					[
						-11.297574,
						12.077971
					],
					[
						-11.456169,
						12.076834
					],
					[
						-11.513943,
						12.442988
					],
					[
						-11.467899,
						12.754519
					],
					[
						-11.553398,
						13.141214
					],
					[
						-11.927716,
						13.422075
					],
					[
						-12.124887,
						13.994727
					],
					[
						-12.17075,
						14.616834
					]
				]
			]
		},
		id: "MLI",
		id2: "ML",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							14.56,
							35.82
						],
						[
							14.37,
							35.85
						],
						[
							14.33,
							35.98
						],
						[
							14.56,
							35.82
						]
					]
				],
				[
					[
						[
							14.27,
							36.01
						],
						[
							14.18,
							36.06
						],
						[
							14.34,
							36.03
						],
						[
							14.27,
							36.01
						]
					]
				]
			]
		},
		properties: {
			name: "Malta"
		},
		id2: "MT",
		id: "MLT",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Marshall Islands"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						170,
						8.2
					],
					[
						170.2,
						8.2
					],
					[
						170.2,
						8
					],
					[
						170,
						8
					],
					[
						170,
						8.2
					]
				]
			]
		},
		id: "MHL",
		id2: "MH",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-60.86,
							14.4
						],
						[
							-61.17,
							14.88
						],
						[
							-60.94,
							14.74
						],
						[
							-60.86,
							14.4
						]
					]
				]
			]
		},
		properties: {
			name: "Martinique"
		},
		id2: "MQ",
		id: "MTQ",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Mauritania"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-12.17075,
						14.616834
					],
					[
						-12.830658,
						15.303692
					],
					[
						-13.435738,
						16.039383
					],
					[
						-14.099521,
						16.304302
					],
					[
						-14.577348,
						16.598264
					],
					[
						-15.135737,
						16.587282
					],
					[
						-15.623666,
						16.369337
					],
					[
						-16.12069,
						16.455663
					],
					[
						-16.463098,
						16.135036
					],
					[
						-16.549708,
						16.673892
					],
					[
						-16.270552,
						17.166963
					],
					[
						-16.146347,
						18.108482
					],
					[
						-16.256883,
						19.096716
					],
					[
						-16.377651,
						19.593817
					],
					[
						-16.277838,
						20.092521
					],
					[
						-16.536324,
						20.567866
					],
					[
						-17.063423,
						20.999752
					],
					[
						-16.845194,
						21.333323
					],
					[
						-12.929102,
						21.327071
					],
					[
						-13.118754,
						22.77122
					],
					[
						-12.874222,
						23.284832
					],
					[
						-11.937224,
						23.374594
					],
					[
						-11.969419,
						25.933353
					],
					[
						-8.687294,
						25.881056
					],
					[
						-8.6844,
						27.395744
					],
					[
						-4.923337,
						24.974574
					],
					[
						-6.453787,
						24.956591
					],
					[
						-5.971129,
						20.640833
					],
					[
						-5.488523,
						16.325102
					],
					[
						-5.315277,
						16.201854
					],
					[
						-5.537744,
						15.50169
					],
					[
						-9.550238,
						15.486497
					],
					[
						-9.700255,
						15.264107
					],
					[
						-10.086846,
						15.330486
					],
					[
						-10.650791,
						15.132746
					],
					[
						-11.349095,
						15.411256
					],
					[
						-11.666078,
						15.388208
					],
					[
						-11.834208,
						14.799097
					],
					[
						-12.17075,
						14.616834
					]
				]
			]
		},
		id: "MRT",
		id2: "MR",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							57.57,
							-20.51
						],
						[
							57.3,
							-20.45
						],
						[
							57.62,
							-19.99
						],
						[
							57.57,
							-20.51
						]
					]
				]
			]
		},
		properties: {
			name: "Mauritius"
		},
		id2: "MU",
		id: "MUS",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							45.2,
							-12.85
						],
						[
							45.1,
							-12.99
						],
						[
							45.08,
							-12.66
						],
						[
							45.2,
							-12.85
						]
					]
				]
			]
		},
		properties: {
			name: "Mayotte"
		},
		id2: "YT",
		id: "MYT",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Mexico"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-97.140008,
						25.869997
					],
					[
						-97.528072,
						24.992144
					],
					[
						-97.702946,
						24.272343
					],
					[
						-97.776042,
						22.93258
					],
					[
						-97.872367,
						22.444212
					],
					[
						-97.699044,
						21.898689
					],
					[
						-97.38896,
						21.411019
					],
					[
						-97.189333,
						20.635433
					],
					[
						-96.525576,
						19.890931
					],
					[
						-96.292127,
						19.320371
					],
					[
						-95.900885,
						18.828024
					],
					[
						-94.839063,
						18.562717
					],
					[
						-94.42573,
						18.144371
					],
					[
						-93.548651,
						18.423837
					],
					[
						-92.786114,
						18.524839
					],
					[
						-92.037348,
						18.704569
					],
					[
						-91.407903,
						18.876083
					],
					[
						-90.77187,
						19.28412
					],
					[
						-90.53359,
						19.867418
					],
					[
						-90.451476,
						20.707522
					],
					[
						-90.278618,
						20.999855
					],
					[
						-89.601321,
						21.261726
					],
					[
						-88.543866,
						21.493675
					],
					[
						-87.658417,
						21.458846
					],
					[
						-87.05189,
						21.543543
					],
					[
						-86.811982,
						21.331515
					],
					[
						-86.845908,
						20.849865
					],
					[
						-87.383291,
						20.255405
					],
					[
						-87.621054,
						19.646553
					],
					[
						-87.43675,
						19.472403
					],
					[
						-87.58656,
						19.04013
					],
					[
						-87.837191,
						18.259816
					],
					[
						-88.090664,
						18.516648
					],
					[
						-88.300031,
						18.499982
					],
					[
						-88.490123,
						18.486831
					],
					[
						-88.848344,
						17.883198
					],
					[
						-89.029857,
						18.001511
					],
					[
						-89.150909,
						17.955468
					],
					[
						-89.14308,
						17.808319
					],
					[
						-90.067934,
						17.819326
					],
					[
						-91.00152,
						17.817595
					],
					[
						-91.002269,
						17.254658
					],
					[
						-91.453921,
						17.252177
					],
					[
						-91.08167,
						16.918477
					],
					[
						-90.711822,
						16.687483
					],
					[
						-90.600847,
						16.470778
					],
					[
						-90.438867,
						16.41011
					],
					[
						-90.464473,
						16.069562
					],
					[
						-91.74796,
						16.066565
					],
					[
						-92.229249,
						15.251447
					],
					[
						-92.087216,
						15.064585
					],
					[
						-92.20323,
						14.830103
					],
					[
						-92.22775,
						14.538829
					],
					[
						-93.359464,
						15.61543
					],
					[
						-93.875169,
						15.940164
					],
					[
						-94.691656,
						16.200975
					],
					[
						-95.250227,
						16.128318
					],
					[
						-96.053382,
						15.752088
					],
					[
						-96.557434,
						15.653515
					],
					[
						-97.263592,
						15.917065
					],
					[
						-98.01303,
						16.107312
					],
					[
						-98.947676,
						16.566043
					],
					[
						-99.697397,
						16.706164
					],
					[
						-100.829499,
						17.171071
					],
					[
						-101.666089,
						17.649026
					],
					[
						-101.918528,
						17.91609
					],
					[
						-102.478132,
						17.975751
					],
					[
						-103.50099,
						18.292295
					],
					[
						-103.917527,
						18.748572
					],
					[
						-104.99201,
						19.316134
					],
					[
						-105.493038,
						19.946767
					],
					[
						-105.731396,
						20.434102
					],
					[
						-105.397773,
						20.531719
					],
					[
						-105.500661,
						20.816895
					],
					[
						-105.270752,
						21.076285
					],
					[
						-105.265817,
						21.422104
					],
					[
						-105.603161,
						21.871146
					],
					[
						-105.693414,
						22.26908
					],
					[
						-106.028716,
						22.773752
					],
					[
						-106.90998,
						23.767774
					],
					[
						-107.915449,
						24.548915
					],
					[
						-108.401905,
						25.172314
					],
					[
						-109.260199,
						25.580609
					],
					[
						-109.444089,
						25.824884
					],
					[
						-109.291644,
						26.442934
					],
					[
						-109.801458,
						26.676176
					],
					[
						-110.391732,
						27.162115
					],
					[
						-110.641019,
						27.859876
					],
					[
						-111.178919,
						27.941241
					],
					[
						-111.759607,
						28.467953
					],
					[
						-112.228235,
						28.954409
					],
					[
						-112.271824,
						29.266844
					],
					[
						-112.809594,
						30.021114
					],
					[
						-113.163811,
						30.786881
					],
					[
						-113.148669,
						31.170966
					],
					[
						-113.871881,
						31.567608
					],
					[
						-114.205737,
						31.524045
					],
					[
						-114.776451,
						31.799532
					],
					[
						-114.9367,
						31.393485
					],
					[
						-114.771232,
						30.913617
					],
					[
						-114.673899,
						30.162681
					],
					[
						-114.330974,
						29.750432
					],
					[
						-113.588875,
						29.061611
					],
					[
						-113.424053,
						28.826174
					],
					[
						-113.271969,
						28.754783
					],
					[
						-113.140039,
						28.411289
					],
					[
						-112.962298,
						28.42519
					],
					[
						-112.761587,
						27.780217
					],
					[
						-112.457911,
						27.525814
					],
					[
						-112.244952,
						27.171727
					],
					[
						-111.616489,
						26.662817
					],
					[
						-111.284675,
						25.73259
					],
					[
						-110.987819,
						25.294606
					],
					[
						-110.710007,
						24.826004
					],
					[
						-110.655049,
						24.298595
					],
					[
						-110.172856,
						24.265548
					],
					[
						-109.771847,
						23.811183
					],
					[
						-109.409104,
						23.364672
					],
					[
						-109.433392,
						23.185588
					],
					[
						-109.854219,
						22.818272
					],
					[
						-110.031392,
						22.823078
					],
					[
						-110.295071,
						23.430973
					],
					[
						-110.949501,
						24.000964
					],
					[
						-111.670568,
						24.484423
					],
					[
						-112.182036,
						24.738413
					],
					[
						-112.148989,
						25.470125
					],
					[
						-112.300711,
						26.012004
					],
					[
						-112.777297,
						26.32196
					],
					[
						-113.464671,
						26.768186
					],
					[
						-113.59673,
						26.63946
					],
					[
						-113.848937,
						26.900064
					],
					[
						-114.465747,
						27.14209
					],
					[
						-115.055142,
						27.722727
					],
					[
						-114.982253,
						27.7982
					],
					[
						-114.570366,
						27.741485
					],
					[
						-114.199329,
						28.115003
					],
					[
						-114.162018,
						28.566112
					],
					[
						-114.931842,
						29.279479
					],
					[
						-115.518654,
						29.556362
					],
					[
						-115.887365,
						30.180794
					],
					[
						-116.25835,
						30.836464
					],
					[
						-116.721526,
						31.635744
					],
					[
						-117.12776,
						32.53534
					],
					[
						-115.99135,
						32.61239
					],
					[
						-114.72139,
						32.72083
					],
					[
						-114.815,
						32.52528
					],
					[
						-113.30498,
						32.03914
					],
					[
						-111.02361,
						31.33472
					],
					[
						-109.035,
						31.34194
					],
					[
						-108.24194,
						31.34222
					],
					[
						-108.24,
						31.754854
					],
					[
						-106.50759,
						31.75452
					],
					[
						-106.1429,
						31.39995
					],
					[
						-105.63159,
						31.08383
					],
					[
						-105.03737,
						30.64402
					],
					[
						-104.70575,
						30.12173
					],
					[
						-104.45697,
						29.57196
					],
					[
						-103.94,
						29.27
					],
					[
						-103.11,
						28.97
					],
					[
						-102.48,
						29.76
					],
					[
						-101.6624,
						29.7793
					],
					[
						-100.9576,
						29.38071
					],
					[
						-100.45584,
						28.69612
					],
					[
						-100.11,
						28.11
					],
					[
						-99.52,
						27.54
					],
					[
						-99.3,
						26.84
					],
					[
						-99.02,
						26.37
					],
					[
						-98.24,
						26.06
					],
					[
						-97.53,
						25.84
					],
					[
						-97.140008,
						25.869997
					]
				]
			]
		},
		id: "MEX",
		id2: "MX",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							163.01,
							5.26
						],
						[
							162.9,
							5.31
						],
						[
							163.02,
							5.38
						],
						[
							163.01,
							5.26
						]
					]
				],
				[
					[
						[
							158.3,
							6.79
						],
						[
							158.12,
							6.93
						],
						[
							158.32,
							6.93
						],
						[
							158.3,
							6.79
						]
					]
				],
				[
					[
						[
							138.21,
							9.52
						],
						[
							138.06,
							9.42
						],
						[
							138.13,
							9.57
						],
						[
							138.21,
							9.52
						]
					]
				]
			]
		},
		properties: {
			name: "Micronesia, Federated States of"
		},
		id2: "FM",
		id: "FSM",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Moldova"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						26.619337,
						48.220726
					],
					[
						26.857824,
						48.368211
					],
					[
						27.522537,
						48.467119
					],
					[
						28.259547,
						48.155562
					],
					[
						28.670891,
						48.118149
					],
					[
						29.122698,
						47.849095
					],
					[
						29.050868,
						47.510227
					],
					[
						29.415135,
						47.346645
					],
					[
						29.559674,
						46.928583
					],
					[
						29.908852,
						46.674361
					],
					[
						29.83821,
						46.525326
					],
					[
						30.024659,
						46.423937
					],
					[
						29.759972,
						46.349988
					],
					[
						29.170654,
						46.379262
					],
					[
						29.072107,
						46.517678
					],
					[
						28.862972,
						46.437889
					],
					[
						28.933717,
						46.25883
					],
					[
						28.659987,
						45.939987
					],
					[
						28.485269,
						45.596907
					],
					[
						28.233554,
						45.488283
					],
					[
						28.054443,
						45.944586
					],
					[
						28.160018,
						46.371563
					],
					[
						28.12803,
						46.810476
					],
					[
						27.551166,
						47.405117
					],
					[
						27.233873,
						47.826771
					],
					[
						26.924176,
						48.123264
					],
					[
						26.619337,
						48.220726
					]
				]
			]
		},
		id: "MDA",
		id2: "MD",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							7.44,
							43.76
						],
						[
							7.39,
							43.73
						],
						[
							7.42,
							43.77
						],
						[
							7.44,
							43.76
						]
					]
				]
			]
		},
		properties: {
			name: "Monaco"
		},
		id2: "MC",
		id: "MCO",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Mongolia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						87.751264,
						49.297198
					],
					[
						88.805567,
						49.470521
					],
					[
						90.713667,
						50.331812
					],
					[
						92.234712,
						50.802171
					],
					[
						93.104219,
						50.49529
					],
					[
						94.147566,
						50.480537
					],
					[
						94.815949,
						50.013433
					],
					[
						95.814028,
						49.977467
					],
					[
						97.259728,
						49.726061
					],
					[
						98.231762,
						50.422401
					],
					[
						97.82574,
						51.010995
					],
					[
						98.861491,
						52.047366
					],
					[
						99.981732,
						51.634006
					],
					[
						100.88948,
						51.516856
					],
					[
						102.065223,
						51.259921
					],
					[
						102.255909,
						50.510561
					],
					[
						103.676545,
						50.089966
					],
					[
						104.621552,
						50.275329
					],
					[
						105.886591,
						50.406019
					],
					[
						106.888804,
						50.274296
					],
					[
						107.868176,
						49.793705
					],
					[
						108.475167,
						49.282548
					],
					[
						109.402449,
						49.292961
					],
					[
						110.662011,
						49.130128
					],
					[
						111.581231,
						49.377968
					],
					[
						112.89774,
						49.543565
					],
					[
						114.362456,
						50.248303
					],
					[
						114.96211,
						50.140247
					],
					[
						115.485695,
						49.805177
					],
					[
						116.678801,
						49.888531
					],
					[
						116.191802,
						49.134598
					],
					[
						115.485282,
						48.135383
					],
					[
						115.742837,
						47.726545
					],
					[
						116.308953,
						47.85341
					],
					[
						117.295507,
						47.697709
					],
					[
						118.064143,
						48.06673
					],
					[
						118.866574,
						47.74706
					],
					[
						119.772824,
						47.048059
					],
					[
						119.66327,
						46.69268
					],
					[
						118.874326,
						46.805412
					],
					[
						117.421701,
						46.672733
					],
					[
						116.717868,
						46.388202
					],
					[
						115.985096,
						45.727235
					],
					[
						114.460332,
						45.339817
					],
					[
						113.463907,
						44.808893
					],
					[
						112.436062,
						45.011646
					],
					[
						111.873306,
						45.102079
					],
					[
						111.348377,
						44.457442
					],
					[
						111.667737,
						44.073176
					],
					[
						111.829588,
						43.743118
					],
					[
						111.129682,
						43.406834
					],
					[
						110.412103,
						42.871234
					],
					[
						109.243596,
						42.519446
					],
					[
						107.744773,
						42.481516
					],
					[
						106.129316,
						42.134328
					],
					[
						104.964994,
						41.59741
					],
					[
						104.522282,
						41.908347
					],
					[
						103.312278,
						41.907468
					],
					[
						101.83304,
						42.514873
					],
					[
						100.845866,
						42.663804
					],
					[
						99.515817,
						42.524691
					],
					[
						97.451757,
						42.74889
					],
					[
						96.349396,
						42.725635
					],
					[
						95.762455,
						43.319449
					],
					[
						95.306875,
						44.241331
					],
					[
						94.688929,
						44.352332
					],
					[
						93.480734,
						44.975472
					],
					[
						92.133891,
						45.115076
					],
					[
						90.94554,
						45.286073
					],
					[
						90.585768,
						45.719716
					],
					[
						90.970809,
						46.888146
					],
					[
						90.280826,
						47.693549
					],
					[
						88.854298,
						48.069082
					],
					[
						88.013832,
						48.599463
					],
					[
						87.751264,
						49.297198
					]
				]
			]
		},
		id: "MNG",
		id2: "MN",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Montenegro"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						19.801613,
						42.500093
					],
					[
						19.738051,
						42.688247
					],
					[
						19.30449,
						42.19574
					],
					[
						19.37177,
						41.87755
					],
					[
						19.16246,
						41.95502
					],
					[
						18.88214,
						42.28151
					],
					[
						18.45,
						42.48
					],
					[
						18.56,
						42.65
					],
					[
						18.70648,
						43.20011
					],
					[
						19.03165,
						43.43253
					],
					[
						19.21852,
						43.52384
					],
					[
						19.48389,
						43.35229
					],
					[
						19.63,
						43.21378
					],
					[
						19.95857,
						43.10604
					],
					[
						20.3398,
						42.89852
					],
					[
						20.25758,
						42.81275
					],
					[
						20.0707,
						42.58863
					],
					[
						19.801613,
						42.500093
					]
				]
			]
		},
		id: "MNE",
		id2: "ME",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-62.17,
							16.67
						],
						[
							-62.24,
							16.71
						],
						[
							-62.2,
							16.81
						],
						[
							-62.17,
							16.67
						]
					]
				]
			]
		},
		properties: {
			name: "Montserrat"
		},
		id2: "MS",
		id: "MSR",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Morocco"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-5.193863,
						35.755182
					],
					[
						-4.591006,
						35.330712
					],
					[
						-3.640057,
						35.399855
					],
					[
						-2.604306,
						35.179093
					],
					[
						-2.169914,
						35.168396
					],
					[
						-1.792986,
						34.527919
					],
					[
						-1.733455,
						33.919713
					],
					[
						-1.388049,
						32.864015
					],
					[
						-1.124551,
						32.651522
					],
					[
						-1.307899,
						32.262889
					],
					[
						-2.616605,
						32.094346
					],
					[
						-3.06898,
						31.724498
					],
					[
						-3.647498,
						31.637294
					],
					[
						-3.690441,
						30.896952
					],
					[
						-4.859646,
						30.501188
					],
					[
						-5.242129,
						30.000443
					],
					[
						-6.060632,
						29.7317
					],
					[
						-7.059228,
						29.579228
					],
					[
						-8.674116,
						28.841289
					],
					[
						-8.66559,
						27.656426
					],
					[
						-8.817809,
						27.656426
					],
					[
						-8.817828,
						27.656426
					],
					[
						-8.794884,
						27.120696
					],
					[
						-9.413037,
						27.088476
					],
					[
						-9.735343,
						26.860945
					],
					[
						-10.189424,
						26.860945
					],
					[
						-10.551263,
						26.990808
					],
					[
						-11.392555,
						26.883424
					],
					[
						-11.71822,
						26.104092
					],
					[
						-12.030759,
						26.030866
					],
					[
						-12.500963,
						24.770116
					],
					[
						-13.89111,
						23.691009
					],
					[
						-14.221168,
						22.310163
					],
					[
						-14.630833,
						21.86094
					],
					[
						-14.750955,
						21.5006
					],
					[
						-17.002962,
						21.420734
					],
					[
						-17.020428,
						21.42231
					],
					[
						-16.973248,
						21.885745
					],
					[
						-16.589137,
						22.158234
					],
					[
						-16.261922,
						22.67934
					],
					[
						-16.326414,
						23.017768
					],
					[
						-15.982611,
						23.723358
					],
					[
						-15.426004,
						24.359134
					],
					[
						-15.089332,
						24.520261
					],
					[
						-14.824645,
						25.103533
					],
					[
						-14.800926,
						25.636265
					],
					[
						-14.43994,
						26.254418
					],
					[
						-13.773805,
						26.618892
					],
					[
						-13.139942,
						27.640148
					],
					[
						-13.121613,
						27.654148
					],
					[
						-12.618837,
						28.038186
					],
					[
						-11.688919,
						28.148644
					],
					[
						-10.900957,
						28.832142
					],
					[
						-10.399592,
						29.098586
					],
					[
						-9.564811,
						29.933574
					],
					[
						-9.814718,
						31.177736
					],
					[
						-9.434793,
						32.038096
					],
					[
						-9.300693,
						32.564679
					],
					[
						-8.657476,
						33.240245
					],
					[
						-7.654178,
						33.697065
					],
					[
						-6.912544,
						34.110476
					],
					[
						-6.244342,
						35.145865
					],
					[
						-5.929994,
						35.759988
					],
					[
						-5.193863,
						35.755182
					]
				]
			]
		},
		id: "MAR",
		id2: "MA",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Mozambique"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						34.559989,
						-11.52002
					],
					[
						35.312398,
						-11.439146
					],
					[
						36.514082,
						-11.720938
					],
					[
						36.775151,
						-11.594537
					],
					[
						37.471284,
						-11.568751
					],
					[
						37.827645,
						-11.268769
					],
					[
						38.427557,
						-11.285202
					],
					[
						39.52103,
						-10.896854
					],
					[
						40.316589,
						-10.317096
					],
					[
						40.478387,
						-10.765441
					],
					[
						40.437253,
						-11.761711
					],
					[
						40.560811,
						-12.639177
					],
					[
						40.59962,
						-14.201975
					],
					[
						40.775475,
						-14.691764
					],
					[
						40.477251,
						-15.406294
					],
					[
						40.089264,
						-16.100774
					],
					[
						39.452559,
						-16.720891
					],
					[
						38.538351,
						-17.101023
					],
					[
						37.411133,
						-17.586368
					],
					[
						36.281279,
						-18.659688
					],
					[
						35.896497,
						-18.84226
					],
					[
						35.1984,
						-19.552811
					],
					[
						34.786383,
						-19.784012
					],
					[
						34.701893,
						-20.497043
					],
					[
						35.176127,
						-21.254361
					],
					[
						35.373428,
						-21.840837
					],
					[
						35.385848,
						-22.14
					],
					[
						35.562546,
						-22.09
					],
					[
						35.533935,
						-23.070788
					],
					[
						35.371774,
						-23.535359
					],
					[
						35.60747,
						-23.706563
					],
					[
						35.458746,
						-24.12261
					],
					[
						35.040735,
						-24.478351
					],
					[
						34.215824,
						-24.816314
					],
					[
						33.01321,
						-25.357573
					],
					[
						32.574632,
						-25.727318
					],
					[
						32.660363,
						-26.148584
					],
					[
						32.915955,
						-26.215867
					],
					[
						32.83012,
						-26.742192
					],
					[
						32.071665,
						-26.73382
					],
					[
						31.985779,
						-26.29178
					],
					[
						31.837778,
						-25.843332
					],
					[
						31.752408,
						-25.484284
					],
					[
						31.930589,
						-24.369417
					],
					[
						31.670398,
						-23.658969
					],
					[
						31.191409,
						-22.25151
					],
					[
						32.244988,
						-21.116489
					],
					[
						32.508693,
						-20.395292
					],
					[
						32.659743,
						-20.30429
					],
					[
						32.772708,
						-19.715592
					],
					[
						32.611994,
						-19.419383
					],
					[
						32.654886,
						-18.67209
					],
					[
						32.849861,
						-17.979057
					],
					[
						32.847639,
						-16.713398
					],
					[
						32.328239,
						-16.392074
					],
					[
						31.852041,
						-16.319417
					],
					[
						31.636498,
						-16.07199
					],
					[
						31.173064,
						-15.860944
					],
					[
						30.338955,
						-15.880839
					],
					[
						30.274256,
						-15.507787
					],
					[
						30.179481,
						-14.796099
					],
					[
						33.214025,
						-13.97186
					],
					[
						33.7897,
						-14.451831
					],
					[
						34.064825,
						-14.35995
					],
					[
						34.459633,
						-14.61301
					],
					[
						34.517666,
						-15.013709
					],
					[
						34.307291,
						-15.478641
					],
					[
						34.381292,
						-16.18356
					],
					[
						35.03381,
						-16.8013
					],
					[
						35.339063,
						-16.10744
					],
					[
						35.771905,
						-15.896859
					],
					[
						35.686845,
						-14.611046
					],
					[
						35.267956,
						-13.887834
					],
					[
						34.907151,
						-13.565425
					],
					[
						34.559989,
						-13.579998
					],
					[
						34.280006,
						-12.280025
					],
					[
						34.559989,
						-11.52002
					]
				]
			]
		},
		id: "MOZ",
		id2: "MZ",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Myanmar"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						99.543309,
						20.186598
					],
					[
						98.959676,
						19.752981
					],
					[
						98.253724,
						19.708203
					],
					[
						97.797783,
						18.62708
					],
					[
						97.375896,
						18.445438
					],
					[
						97.859123,
						17.567946
					],
					[
						98.493761,
						16.837836
					],
					[
						98.903348,
						16.177824
					],
					[
						98.537376,
						15.308497
					],
					[
						98.192074,
						15.123703
					],
					[
						98.430819,
						14.622028
					],
					[
						99.097755,
						13.827503
					],
					[
						99.212012,
						13.269294
					],
					[
						99.196354,
						12.804748
					],
					[
						99.587286,
						11.892763
					],
					[
						99.038121,
						10.960546
					],
					[
						98.553551,
						9.93296
					],
					[
						98.457174,
						10.675266
					],
					[
						98.764546,
						11.441292
					],
					[
						98.428339,
						12.032987
					],
					[
						98.509574,
						13.122378
					],
					[
						98.103604,
						13.64046
					],
					[
						97.777732,
						14.837286
					],
					[
						97.597072,
						16.100568
					],
					[
						97.16454,
						16.928734
					],
					[
						96.505769,
						16.427241
					],
					[
						95.369352,
						15.71439
					],
					[
						94.808405,
						15.803454
					],
					[
						94.188804,
						16.037936
					],
					[
						94.533486,
						17.27724
					],
					[
						94.324817,
						18.213514
					],
					[
						93.540988,
						19.366493
					],
					[
						93.663255,
						19.726962
					],
					[
						93.078278,
						19.855145
					],
					[
						92.368554,
						20.670883
					],
					[
						92.303234,
						21.475485
					],
					[
						92.652257,
						21.324048
					],
					[
						92.672721,
						22.041239
					],
					[
						93.166128,
						22.27846
					],
					[
						93.060294,
						22.703111
					],
					[
						93.286327,
						23.043658
					],
					[
						93.325188,
						24.078556
					],
					[
						94.106742,
						23.850741
					],
					[
						94.552658,
						24.675238
					],
					[
						94.603249,
						25.162495
					],
					[
						95.155153,
						26.001307
					],
					[
						95.124768,
						26.573572
					],
					[
						96.419366,
						27.264589
					],
					[
						97.133999,
						27.083774
					],
					[
						97.051989,
						27.699059
					],
					[
						97.402561,
						27.882536
					],
					[
						97.327114,
						28.261583
					],
					[
						97.911988,
						28.335945
					],
					[
						98.246231,
						27.747221
					],
					[
						98.68269,
						27.508812
					],
					[
						98.712094,
						26.743536
					],
					[
						98.671838,
						25.918703
					],
					[
						97.724609,
						25.083637
					],
					[
						97.60472,
						23.897405
					],
					[
						98.660262,
						24.063286
					],
					[
						98.898749,
						23.142722
					],
					[
						99.531992,
						22.949039
					],
					[
						99.240899,
						22.118314
					],
					[
						99.983489,
						21.742937
					],
					[
						100.416538,
						21.558839
					],
					[
						101.150033,
						21.849984
					],
					[
						101.180005,
						21.436573
					],
					[
						100.329101,
						20.786122
					],
					[
						100.115988,
						20.41785
					],
					[
						99.543309,
						20.186598
					]
				]
			]
		},
		id: "MMR",
		id2: "MM",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Namibia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						16.344977,
						-28.576705
					],
					[
						15.601818,
						-27.821247
					],
					[
						15.210472,
						-27.090956
					],
					[
						14.989711,
						-26.117372
					],
					[
						14.743214,
						-25.39292
					],
					[
						14.408144,
						-23.853014
					],
					[
						14.385717,
						-22.656653
					],
					[
						14.257714,
						-22.111208
					],
					[
						13.868642,
						-21.699037
					],
					[
						13.352498,
						-20.872834
					],
					[
						12.826845,
						-19.673166
					],
					[
						12.608564,
						-19.045349
					],
					[
						11.794919,
						-18.069129
					],
					[
						11.734199,
						-17.301889
					],
					[
						12.215461,
						-17.111668
					],
					[
						12.814081,
						-16.941343
					],
					[
						13.462362,
						-16.971212
					],
					[
						14.058501,
						-17.423381
					],
					[
						14.209707,
						-17.353101
					],
					[
						18.263309,
						-17.309951
					],
					[
						18.956187,
						-17.789095
					],
					[
						21.377176,
						-17.930636
					],
					[
						23.215048,
						-17.523116
					],
					[
						24.033862,
						-17.295843
					],
					[
						24.682349,
						-17.353411
					],
					[
						25.07695,
						-17.578823
					],
					[
						25.084443,
						-17.661816
					],
					[
						24.520705,
						-17.887125
					],
					[
						24.217365,
						-17.889347
					],
					[
						23.579006,
						-18.281261
					],
					[
						23.196858,
						-17.869038
					],
					[
						21.65504,
						-18.219146
					],
					[
						20.910641,
						-18.252219
					],
					[
						20.881134,
						-21.814327
					],
					[
						19.895458,
						-21.849157
					],
					[
						19.895768,
						-24.76779
					],
					[
						19.894734,
						-28.461105
					],
					[
						19.002127,
						-28.972443
					],
					[
						18.464899,
						-29.045462
					],
					[
						17.836152,
						-28.856378
					],
					[
						17.387497,
						-28.783514
					],
					[
						17.218929,
						-28.355943
					],
					[
						16.824017,
						-28.082162
					],
					[
						16.344977,
						-28.576705
					]
				]
			]
		},
		id: "NAM",
		id2: "NA",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							166.93,
							-0.55
						],
						[
							166.93,
							-0.49
						],
						[
							166.96,
							-0.51
						],
						[
							166.93,
							-0.55
						]
					]
				]
			]
		},
		properties: {
			name: "Nauru"
		},
		id2: "NR",
		id: "NRU",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Nepal"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						88.120441,
						27.876542
					],
					[
						88.043133,
						27.445819
					],
					[
						88.174804,
						26.810405
					],
					[
						88.060238,
						26.414615
					],
					[
						87.227472,
						26.397898
					],
					[
						86.024393,
						26.630985
					],
					[
						85.251779,
						26.726198
					],
					[
						84.675018,
						27.234901
					],
					[
						83.304249,
						27.364506
					],
					[
						81.999987,
						27.925479
					],
					[
						81.057203,
						28.416095
					],
					[
						80.088425,
						28.79447
					],
					[
						80.476721,
						29.729865
					],
					[
						81.111256,
						30.183481
					],
					[
						81.525804,
						30.422717
					],
					[
						82.327513,
						30.115268
					],
					[
						83.337115,
						29.463732
					],
					[
						83.898993,
						29.320226
					],
					[
						84.23458,
						28.839894
					],
					[
						85.011638,
						28.642774
					],
					[
						85.82332,
						28.203576
					],
					[
						86.954517,
						27.974262
					],
					[
						88.120441,
						27.876542
					]
				]
			]
		},
		id: "NPL",
		id2: "NP",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Netherlands"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						6.074183,
						53.510403
					],
					[
						6.90514,
						53.482162
					],
					[
						7.092053,
						53.144043
					],
					[
						6.84287,
						52.22844
					],
					[
						6.589397,
						51.852029
					],
					[
						5.988658,
						51.851616
					],
					[
						6.156658,
						50.803721
					],
					[
						5.606976,
						51.037298
					],
					[
						4.973991,
						51.475024
					],
					[
						4.047071,
						51.267259
					],
					[
						3.314971,
						51.345755
					],
					[
						3.830289,
						51.620545
					],
					[
						4.705997,
						53.091798
					],
					[
						6.074183,
						53.510403
					]
				]
			]
		},
		id: "NLD",
		id2: "NL",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "New Caledonia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						165.77999,
						-21.080005
					],
					[
						166.599991,
						-21.700019
					],
					[
						167.120011,
						-22.159991
					],
					[
						166.740035,
						-22.399976
					],
					[
						166.189732,
						-22.129708
					],
					[
						165.474375,
						-21.679607
					],
					[
						164.829815,
						-21.14982
					],
					[
						164.167995,
						-20.444747
					],
					[
						164.029606,
						-20.105646
					],
					[
						164.459967,
						-20.120012
					],
					[
						165.020036,
						-20.459991
					],
					[
						165.460009,
						-20.800022
					],
					[
						165.77999,
						-21.080005
					]
				]
			]
		},
		id: "NCL",
		id2: "NC",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "New Zealand"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							173.020375,
							-40.919052
						],
						[
							173.247234,
							-41.331999
						],
						[
							173.958405,
							-40.926701
						],
						[
							174.247587,
							-41.349155
						],
						[
							174.248517,
							-41.770008
						],
						[
							173.876447,
							-42.233184
						],
						[
							173.22274,
							-42.970038
						],
						[
							172.711246,
							-43.372288
						],
						[
							173.080113,
							-43.853344
						],
						[
							172.308584,
							-43.865694
						],
						[
							171.452925,
							-44.242519
						],
						[
							171.185138,
							-44.897104
						],
						[
							170.616697,
							-45.908929
						],
						[
							169.831422,
							-46.355775
						],
						[
							169.332331,
							-46.641235
						],
						[
							168.411354,
							-46.619945
						],
						[
							167.763745,
							-46.290197
						],
						[
							166.676886,
							-46.219917
						],
						[
							166.509144,
							-45.852705
						],
						[
							167.046424,
							-45.110941
						],
						[
							168.303763,
							-44.123973
						],
						[
							168.949409,
							-43.935819
						],
						[
							169.667815,
							-43.555326
						],
						[
							170.52492,
							-43.031688
						],
						[
							171.12509,
							-42.512754
						],
						[
							171.569714,
							-41.767424
						],
						[
							171.948709,
							-41.514417
						],
						[
							172.097227,
							-40.956104
						],
						[
							172.79858,
							-40.493962
						],
						[
							173.020375,
							-40.919052
						]
					]
				],
				[
					[
						[
							174.612009,
							-36.156397
						],
						[
							175.336616,
							-37.209098
						],
						[
							175.357596,
							-36.526194
						],
						[
							175.808887,
							-36.798942
						],
						[
							175.95849,
							-37.555382
						],
						[
							176.763195,
							-37.881253
						],
						[
							177.438813,
							-37.961248
						],
						[
							178.010354,
							-37.579825
						],
						[
							178.517094,
							-37.695373
						],
						[
							178.274731,
							-38.582813
						],
						[
							177.97046,
							-39.166343
						],
						[
							177.206993,
							-39.145776
						],
						[
							176.939981,
							-39.449736
						],
						[
							177.032946,
							-39.879943
						],
						[
							176.885824,
							-40.065978
						],
						[
							176.508017,
							-40.604808
						],
						[
							176.01244,
							-41.289624
						],
						[
							175.239567,
							-41.688308
						],
						[
							175.067898,
							-41.425895
						],
						[
							174.650973,
							-41.281821
						],
						[
							175.22763,
							-40.459236
						],
						[
							174.900157,
							-39.908933
						],
						[
							173.824047,
							-39.508854
						],
						[
							173.852262,
							-39.146602
						],
						[
							174.574802,
							-38.797683
						],
						[
							174.743474,
							-38.027808
						],
						[
							174.697017,
							-37.381129
						],
						[
							174.292028,
							-36.711092
						],
						[
							174.319004,
							-36.534824
						],
						[
							173.840997,
							-36.121981
						],
						[
							173.054171,
							-35.237125
						],
						[
							172.636005,
							-34.529107
						],
						[
							173.007042,
							-34.450662
						],
						[
							173.551298,
							-35.006183
						],
						[
							174.32939,
							-35.265496
						],
						[
							174.612009,
							-36.156397
						]
					]
				]
			]
		},
		id: "NZL",
		id2: "NZ",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Nicaragua"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-85.71254,
						11.088445
					],
					[
						-86.058488,
						11.403439
					],
					[
						-86.52585,
						11.806877
					],
					[
						-86.745992,
						12.143962
					],
					[
						-87.167516,
						12.458258
					],
					[
						-87.668493,
						12.90991
					],
					[
						-87.557467,
						13.064552
					],
					[
						-87.392386,
						12.914018
					],
					[
						-87.316654,
						12.984686
					],
					[
						-87.005769,
						13.025794
					],
					[
						-86.880557,
						13.254204
					],
					[
						-86.733822,
						13.263093
					],
					[
						-86.755087,
						13.754845
					],
					[
						-86.520708,
						13.778487
					],
					[
						-86.312142,
						13.771356
					],
					[
						-86.096264,
						14.038187
					],
					[
						-85.801295,
						13.836055
					],
					[
						-85.698665,
						13.960078
					],
					[
						-85.514413,
						14.079012
					],
					[
						-85.165365,
						14.35437
					],
					[
						-85.148751,
						14.560197
					],
					[
						-85.052787,
						14.551541
					],
					[
						-84.924501,
						14.790493
					],
					[
						-84.820037,
						14.819587
					],
					[
						-84.649582,
						14.666805
					],
					[
						-84.449336,
						14.621614
					],
					[
						-84.228342,
						14.748764
					],
					[
						-83.975721,
						14.749436
					],
					[
						-83.628585,
						14.880074
					],
					[
						-83.489989,
						15.016267
					],
					[
						-83.147219,
						14.995829
					],
					[
						-83.233234,
						14.899866
					],
					[
						-83.284162,
						14.676624
					],
					[
						-83.182126,
						14.310703
					],
					[
						-83.4125,
						13.970078
					],
					[
						-83.519832,
						13.567699
					],
					[
						-83.552207,
						13.127054
					],
					[
						-83.498515,
						12.869292
					],
					[
						-83.473323,
						12.419087
					],
					[
						-83.626104,
						12.32085
					],
					[
						-83.719613,
						11.893124
					],
					[
						-83.650858,
						11.629032
					],
					[
						-83.85547,
						11.373311
					],
					[
						-83.808936,
						11.103044
					],
					[
						-83.655612,
						10.938764
					],
					[
						-83.895054,
						10.726839
					],
					[
						-84.190179,
						10.79345
					],
					[
						-84.355931,
						10.999226
					],
					[
						-84.673069,
						11.082657
					],
					[
						-84.903003,
						10.952303
					],
					[
						-85.561852,
						11.217119
					],
					[
						-85.71254,
						11.088445
					]
				]
			]
		},
		id: "NIC",
		id2: "NI",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Niger"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						2.154474,
						11.94015
					],
					[
						2.177108,
						12.625018
					],
					[
						1.024103,
						12.851826
					],
					[
						0.993046,
						13.33575
					],
					[
						0.429928,
						13.988733
					],
					[
						0.295646,
						14.444235
					],
					[
						0.374892,
						14.928908
					],
					[
						1.015783,
						14.968182
					],
					[
						1.385528,
						15.323561
					],
					[
						2.749993,
						15.409525
					],
					[
						3.638259,
						15.56812
					],
					[
						3.723422,
						16.184284
					],
					[
						4.27021,
						16.852227
					],
					[
						4.267419,
						19.155265
					],
					[
						5.677566,
						19.601207
					],
					[
						8.572893,
						21.565661
					],
					[
						11.999506,
						23.471668
					],
					[
						13.581425,
						23.040506
					],
					[
						14.143871,
						22.491289
					],
					[
						14.8513,
						22.86295
					],
					[
						15.096888,
						21.308519
					],
					[
						15.471077,
						21.048457
					],
					[
						15.487148,
						20.730415
					],
					[
						15.903247,
						20.387619
					],
					[
						15.685741,
						19.95718
					],
					[
						15.300441,
						17.92795
					],
					[
						15.247731,
						16.627306
					],
					[
						13.972202,
						15.684366
					],
					[
						13.540394,
						14.367134
					],
					[
						13.956699,
						13.996691
					],
					[
						13.954477,
						13.353449
					],
					[
						14.595781,
						13.330427
					],
					[
						14.495787,
						12.859396
					],
					[
						14.213531,
						12.802035
					],
					[
						14.181336,
						12.483657
					],
					[
						13.995353,
						12.461565
					],
					[
						13.318702,
						13.556356
					],
					[
						13.083987,
						13.596147
					],
					[
						12.302071,
						13.037189
					],
					[
						11.527803,
						13.32898
					],
					[
						10.989593,
						13.387323
					],
					[
						10.701032,
						13.246918
					],
					[
						10.114814,
						13.277252
					],
					[
						9.524928,
						12.851102
					],
					[
						9.014933,
						12.826659
					],
					[
						7.804671,
						13.343527
					],
					[
						7.330747,
						13.098038
					],
					[
						6.820442,
						13.115091
					],
					[
						6.445426,
						13.492768
					],
					[
						5.443058,
						13.865924
					],
					[
						4.368344,
						13.747482
					],
					[
						4.107946,
						13.531216
					],
					[
						3.967283,
						12.956109
					],
					[
						3.680634,
						12.552903
					],
					[
						3.61118,
						11.660167
					],
					[
						2.848643,
						12.235636
					],
					[
						2.490164,
						12.233052
					],
					[
						2.154474,
						11.94015
					]
				]
			]
		},
		id: "NER",
		id2: "NE",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Nigeria"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						8.500288,
						4.771983
					],
					[
						7.462108,
						4.412108
					],
					[
						7.082596,
						4.464689
					],
					[
						6.698072,
						4.240594
					],
					[
						5.898173,
						4.262453
					],
					[
						5.362805,
						4.887971
					],
					[
						5.033574,
						5.611802
					],
					[
						4.325607,
						6.270651
					],
					[
						3.57418,
						6.2583
					],
					[
						2.691702,
						6.258817
					],
					[
						2.749063,
						7.870734
					],
					[
						2.723793,
						8.506845
					],
					[
						2.912308,
						9.137608
					],
					[
						3.220352,
						9.444153
					],
					[
						3.705438,
						10.06321
					],
					[
						3.60007,
						10.332186
					],
					[
						3.797112,
						10.734746
					],
					[
						3.572216,
						11.327939
					],
					[
						3.61118,
						11.660167
					],
					[
						3.680634,
						12.552903
					],
					[
						3.967283,
						12.956109
					],
					[
						4.107946,
						13.531216
					],
					[
						4.368344,
						13.747482
					],
					[
						5.443058,
						13.865924
					],
					[
						6.445426,
						13.492768
					],
					[
						6.820442,
						13.115091
					],
					[
						7.330747,
						13.098038
					],
					[
						7.804671,
						13.343527
					],
					[
						9.014933,
						12.826659
					],
					[
						9.524928,
						12.851102
					],
					[
						10.114814,
						13.277252
					],
					[
						10.701032,
						13.246918
					],
					[
						10.989593,
						13.387323
					],
					[
						11.527803,
						13.32898
					],
					[
						12.302071,
						13.037189
					],
					[
						13.083987,
						13.596147
					],
					[
						13.318702,
						13.556356
					],
					[
						13.995353,
						12.461565
					],
					[
						14.181336,
						12.483657
					],
					[
						14.577178,
						12.085361
					],
					[
						14.468192,
						11.904752
					],
					[
						14.415379,
						11.572369
					],
					[
						13.57295,
						10.798566
					],
					[
						13.308676,
						10.160362
					],
					[
						13.1676,
						9.640626
					],
					[
						12.955468,
						9.417772
					],
					[
						12.753672,
						8.717763
					],
					[
						12.218872,
						8.305824
					],
					[
						12.063946,
						7.799808
					],
					[
						11.839309,
						7.397042
					],
					[
						11.745774,
						6.981383
					],
					[
						11.058788,
						6.644427
					],
					[
						10.497375,
						7.055358
					],
					[
						10.118277,
						7.03877
					],
					[
						9.522706,
						6.453482
					],
					[
						9.233163,
						6.444491
					],
					[
						8.757533,
						5.479666
					],
					[
						8.500288,
						4.771983
					]
				]
			]
		},
		id: "NGA",
		id2: "NG",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-169.89,
							-19.15
						],
						[
							-169.93,
							-19.02
						],
						[
							-169.82,
							-18.97
						],
						[
							-169.89,
							-19.15
						]
					]
				]
			]
		},
		properties: {
			name: "Niue"
		},
		id2: "NU",
		id: "NIU",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							167.96,
							-29.08
						],
						[
							167.91,
							-29.01
						],
						[
							168,
							-29.03
						],
						[
							167.96,
							-29.08
						]
					]
				]
			]
		},
		properties: {
			name: "Norfolk Island"
		},
		id2: "NF",
		id: "NFK",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							145.28,
							14.16
						],
						[
							145.12,
							14.12
						],
						[
							145.24,
							14.19
						],
						[
							145.28,
							14.16
						]
					]
				],
				[
					[
						[
							145.62,
							14.91
						],
						[
							145.57,
							15.01
						],
						[
							145.63,
							15.08
						],
						[
							145.62,
							14.91
						]
					]
				],
				[
					[
						[
							145.74,
							15.13
						],
						[
							145.68,
							15.11
						],
						[
							145.82,
							15.27
						],
						[
							145.74,
							15.13
						]
					]
				],
				[
					[
						[
							145.74,
							18.04
						],
						[
							145.78,
							18.17
						],
						[
							145.82,
							18.16
						],
						[
							145.74,
							18.04
						]
					]
				],
				[
					[
						[
							145.68,
							18.72
						],
						[
							145.66,
							18.81
						],
						[
							145.71,
							18.77
						],
						[
							145.68,
							18.72
						]
					]
				]
			]
		},
		properties: {
			name: "Northern Mariana Islands"
		},
		id2: "MP",
		id: "MNP",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Norway"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							28.165547,
							71.185474
						],
						[
							31.293418,
							70.453788
						],
						[
							30.005435,
							70.186259
						],
						[
							31.101079,
							69.55808
						],
						[
							29.399581,
							69.156916
						],
						[
							28.59193,
							69.064777
						],
						[
							29.015573,
							69.766491
						],
						[
							27.732292,
							70.164193
						],
						[
							26.179622,
							69.825299
						],
						[
							25.689213,
							69.092114
						],
						[
							24.735679,
							68.649557
						],
						[
							23.66205,
							68.891247
						],
						[
							22.356238,
							68.841741
						],
						[
							21.244936,
							69.370443
						],
						[
							20.645593,
							69.106247
						],
						[
							20.025269,
							69.065139
						],
						[
							19.87856,
							68.407194
						],
						[
							17.993868,
							68.567391
						],
						[
							17.729182,
							68.010552
						],
						[
							16.768879,
							68.013937
						],
						[
							16.108712,
							67.302456
						],
						[
							15.108411,
							66.193867
						],
						[
							13.55569,
							64.787028
						],
						[
							13.919905,
							64.445421
						],
						[
							13.571916,
							64.049114
						],
						[
							12.579935,
							64.066219
						],
						[
							11.930569,
							63.128318
						],
						[
							11.992064,
							61.800362
						],
						[
							12.631147,
							61.293572
						],
						[
							12.300366,
							60.117933
						],
						[
							11.468272,
							59.432393
						],
						[
							11.027369,
							58.856149
						],
						[
							10.356557,
							59.469807
						],
						[
							8.382,
							58.313288
						],
						[
							7.048748,
							58.078884
						],
						[
							5.665835,
							58.588155
						],
						[
							5.308234,
							59.663232
						],
						[
							4.992078,
							61.970998
						],
						[
							5.9129,
							62.614473
						],
						[
							8.553411,
							63.454008
						],
						[
							10.527709,
							64.486038
						],
						[
							12.358347,
							65.879726
						],
						[
							14.761146,
							67.810642
						],
						[
							16.435927,
							68.563205
						],
						[
							19.184028,
							69.817444
						],
						[
							21.378416,
							70.255169
						],
						[
							23.023742,
							70.202072
						],
						[
							24.546543,
							71.030497
						],
						[
							26.37005,
							70.986262
						],
						[
							28.165547,
							71.185474
						]
					]
				]
			]
		},
		id: "NOR",
		id2: "NO",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Oman"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							58.861141,
							21.114035
						],
						[
							58.487986,
							20.428986
						],
						[
							58.034318,
							20.481437
						],
						[
							57.826373,
							20.243002
						],
						[
							57.665762,
							19.736005
						],
						[
							57.7887,
							19.06757
						],
						[
							57.694391,
							18.94471
						],
						[
							57.234264,
							18.947991
						],
						[
							56.609651,
							18.574267
						],
						[
							56.512189,
							18.087113
						],
						[
							56.283521,
							17.876067
						],
						[
							55.661492,
							17.884128
						],
						[
							55.269939,
							17.632309
						],
						[
							55.2749,
							17.228354
						],
						[
							54.791002,
							16.950697
						],
						[
							54.239253,
							17.044981
						],
						[
							53.570508,
							16.707663
						],
						[
							53.108573,
							16.651051
						],
						[
							52.782184,
							17.349742
						],
						[
							52.00001,
							19.000003
						],
						[
							54.999982,
							19.999994
						],
						[
							55.666659,
							22.000001
						],
						[
							55.208341,
							22.70833
						],
						[
							55.234489,
							23.110993
						],
						[
							55.525841,
							23.524869
						],
						[
							55.528632,
							23.933604
						],
						[
							55.981214,
							24.130543
						],
						[
							55.804119,
							24.269604
						],
						[
							55.886233,
							24.920831
						],
						[
							56.396847,
							24.924732
						],
						[
							56.84514,
							24.241673
						],
						[
							57.403453,
							23.878594
						],
						[
							58.136948,
							23.747931
						],
						[
							58.729211,
							23.565668
						],
						[
							59.180502,
							22.992395
						],
						[
							59.450098,
							22.660271
						],
						[
							59.80806,
							22.533612
						],
						[
							59.806148,
							22.310525
						],
						[
							59.442191,
							21.714541
						],
						[
							59.282408,
							21.433886
						],
						[
							58.861141,
							21.114035
						]
					]
				],
				[
					[
						[
							56.391421,
							25.895991
						],
						[
							56.261042,
							25.714606
						],
						[
							56.070821,
							26.055464
						],
						[
							56.362017,
							26.395934
						],
						[
							56.485679,
							26.309118
						],
						[
							56.391421,
							25.895991
						]
					]
				]
			]
		},
		id: "OMN",
		id2: "OM",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Pakistan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						75.158028,
						37.133031
					],
					[
						75.896897,
						36.666806
					],
					[
						76.192848,
						35.898403
					],
					[
						77.837451,
						35.49401
					],
					[
						76.871722,
						34.653544
					],
					[
						75.757061,
						34.504923
					],
					[
						74.240203,
						34.748887
					],
					[
						73.749948,
						34.317699
					],
					[
						74.104294,
						33.441473
					],
					[
						74.451559,
						32.7649
					],
					[
						75.258642,
						32.271105
					],
					[
						74.405929,
						31.692639
					],
					[
						74.42138,
						30.979815
					],
					[
						73.450638,
						29.976413
					],
					[
						72.823752,
						28.961592
					],
					[
						71.777666,
						27.91318
					],
					[
						70.616496,
						27.989196
					],
					[
						69.514393,
						26.940966
					],
					[
						70.168927,
						26.491872
					],
					[
						70.282873,
						25.722229
					],
					[
						70.844699,
						25.215102
					],
					[
						71.04324,
						24.356524
					],
					[
						68.842599,
						24.359134
					],
					[
						68.176645,
						23.691965
					],
					[
						67.443667,
						23.944844
					],
					[
						67.145442,
						24.663611
					],
					[
						66.372828,
						25.425141
					],
					[
						64.530408,
						25.237039
					],
					[
						62.905701,
						25.218409
					],
					[
						61.497363,
						25.078237
					],
					[
						61.874187,
						26.239975
					],
					[
						63.316632,
						26.756532
					],
					[
						63.233898,
						27.217047
					],
					[
						62.755426,
						27.378923
					],
					[
						62.72783,
						28.259645
					],
					[
						61.771868,
						28.699334
					],
					[
						61.369309,
						29.303276
					],
					[
						60.874248,
						29.829239
					],
					[
						62.549857,
						29.318572
					],
					[
						63.550261,
						29.468331
					],
					[
						64.148002,
						29.340819
					],
					[
						64.350419,
						29.560031
					],
					[
						65.046862,
						29.472181
					],
					[
						66.346473,
						29.887943
					],
					[
						66.381458,
						30.738899
					],
					[
						66.938891,
						31.304911
					],
					[
						67.683394,
						31.303154
					],
					[
						67.792689,
						31.58293
					],
					[
						68.556932,
						31.71331
					],
					[
						68.926677,
						31.620189
					],
					[
						69.317764,
						31.901412
					],
					[
						69.262522,
						32.501944
					],
					[
						69.687147,
						33.105499
					],
					[
						70.323594,
						33.358533
					],
					[
						69.930543,
						34.02012
					],
					[
						70.881803,
						33.988856
					],
					[
						71.156773,
						34.348911
					],
					[
						71.115019,
						34.733126
					],
					[
						71.613076,
						35.153203
					],
					[
						71.498768,
						35.650563
					],
					[
						71.262348,
						36.074388
					],
					[
						71.846292,
						36.509942
					],
					[
						72.920025,
						36.720007
					],
					[
						74.067552,
						36.836176
					],
					[
						74.575893,
						37.020841
					],
					[
						75.158028,
						37.133031
					]
				]
			]
		},
		id: "PAK",
		id2: "PK",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							134.56,
							7.37
						],
						[
							134.49,
							7.44
						],
						[
							134.63,
							7.73
						],
						[
							134.56,
							7.37
						]
					]
				]
			]
		},
		properties: {
			name: "Palau"
		},
		id2: "PW",
		id: "PLW",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "West Bank"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						35.545665,
						32.393992
					],
					[
						35.545252,
						31.782505
					],
					[
						35.397561,
						31.489086
					],
					[
						34.927408,
						31.353435
					],
					[
						34.970507,
						31.616778
					],
					[
						35.225892,
						31.754341
					],
					[
						34.974641,
						31.866582
					],
					[
						35.18393,
						32.532511
					],
					[
						35.545665,
						32.393992
					]
				]
			]
		},
		id: "PSE",
		id2: "PS",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Panama"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-77.881571,
						7.223771
					],
					[
						-78.214936,
						7.512255
					],
					[
						-78.429161,
						8.052041
					],
					[
						-78.182096,
						8.319182
					],
					[
						-78.435465,
						8.387705
					],
					[
						-78.622121,
						8.718124
					],
					[
						-79.120307,
						8.996092
					],
					[
						-79.557877,
						8.932375
					],
					[
						-79.760578,
						8.584515
					],
					[
						-80.164481,
						8.333316
					],
					[
						-80.382659,
						8.298409
					],
					[
						-80.480689,
						8.090308
					],
					[
						-80.00369,
						7.547524
					],
					[
						-80.276671,
						7.419754
					],
					[
						-80.421158,
						7.271572
					],
					[
						-80.886401,
						7.220541
					],
					[
						-81.059543,
						7.817921
					],
					[
						-81.189716,
						7.647906
					],
					[
						-81.519515,
						7.70661
					],
					[
						-81.721311,
						8.108963
					],
					[
						-82.131441,
						8.175393
					],
					[
						-82.390934,
						8.292362
					],
					[
						-82.820081,
						8.290864
					],
					[
						-82.850958,
						8.073823
					],
					[
						-82.965783,
						8.225028
					],
					[
						-82.913176,
						8.423517
					],
					[
						-82.829771,
						8.626295
					],
					[
						-82.868657,
						8.807266
					],
					[
						-82.719183,
						8.925709
					],
					[
						-82.927155,
						9.07433
					],
					[
						-82.932891,
						9.476812
					],
					[
						-82.546196,
						9.566135
					],
					[
						-82.187123,
						9.207449
					],
					[
						-82.207586,
						8.995575
					],
					[
						-81.808567,
						8.950617
					],
					[
						-81.714154,
						9.031955
					],
					[
						-81.439287,
						8.786234
					],
					[
						-80.947302,
						8.858504
					],
					[
						-80.521901,
						9.111072
					],
					[
						-79.9146,
						9.312765
					],
					[
						-79.573303,
						9.61161
					],
					[
						-79.021192,
						9.552931
					],
					[
						-79.05845,
						9.454565
					],
					[
						-78.500888,
						9.420459
					],
					[
						-78.055928,
						9.24773
					],
					[
						-77.729514,
						8.946844
					],
					[
						-77.353361,
						8.670505
					],
					[
						-77.474723,
						8.524286
					],
					[
						-77.242566,
						7.935278
					],
					[
						-77.431108,
						7.638061
					],
					[
						-77.753414,
						7.70984
					],
					[
						-77.881571,
						7.223771
					]
				]
			]
		},
		id: "PAN",
		id2: "PA",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Papua New Guinea"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							155.880026,
							-6.819997
						],
						[
							155.599991,
							-6.919991
						],
						[
							155.166994,
							-6.535931
						],
						[
							154.729192,
							-5.900828
						],
						[
							154.514114,
							-5.139118
						],
						[
							154.652504,
							-5.042431
						],
						[
							154.759991,
							-5.339984
						],
						[
							155.062918,
							-5.566792
						],
						[
							155.547746,
							-6.200655
						],
						[
							156.019965,
							-6.540014
						],
						[
							155.880026,
							-6.819997
						]
					]
				],
				[
					[
						[
							151.982796,
							-5.478063
						],
						[
							151.459107,
							-5.56028
						],
						[
							151.30139,
							-5.840728
						],
						[
							150.754447,
							-6.083763
						],
						[
							150.241197,
							-6.317754
						],
						[
							149.709963,
							-6.316513
						],
						[
							148.890065,
							-6.02604
						],
						[
							148.318937,
							-5.747142
						],
						[
							148.401826,
							-5.437756
						],
						[
							149.298412,
							-5.583742
						],
						[
							149.845562,
							-5.505503
						],
						[
							149.99625,
							-5.026101
						],
						[
							150.139756,
							-5.001348
						],
						[
							150.236908,
							-5.53222
						],
						[
							150.807467,
							-5.455842
						],
						[
							151.089672,
							-5.113693
						],
						[
							151.647881,
							-4.757074
						],
						[
							151.537862,
							-4.167807
						],
						[
							152.136792,
							-4.14879
						],
						[
							152.338743,
							-4.312966
						],
						[
							152.318693,
							-4.867661
						],
						[
							151.982796,
							-5.478063
						]
					]
				],
				[
					[
						[
							147.191874,
							-7.388024
						],
						[
							148.084636,
							-8.044108
						],
						[
							148.734105,
							-9.104664
						],
						[
							149.306835,
							-9.071436
						],
						[
							149.266631,
							-9.514406
						],
						[
							150.038728,
							-9.684318
						],
						[
							149.738798,
							-9.872937
						],
						[
							150.801628,
							-10.293687
						],
						[
							150.690575,
							-10.582713
						],
						[
							150.028393,
							-10.652476
						],
						[
							149.78231,
							-10.393267
						],
						[
							148.923138,
							-10.280923
						],
						[
							147.913018,
							-10.130441
						],
						[
							147.135443,
							-9.492444
						],
						[
							146.567881,
							-8.942555
						],
						[
							146.048481,
							-8.067414
						],
						[
							144.744168,
							-7.630128
						],
						[
							143.897088,
							-7.91533
						],
						[
							143.286376,
							-8.245491
						],
						[
							143.413913,
							-8.983069
						],
						[
							142.628431,
							-9.326821
						],
						[
							142.068259,
							-9.159596
						],
						[
							141.033852,
							-9.117893
						],
						[
							141.017057,
							-5.859022
						],
						[
							141.00021,
							-2.600151
						],
						[
							142.735247,
							-3.289153
						],
						[
							144.583971,
							-3.861418
						],
						[
							145.27318,
							-4.373738
						],
						[
							145.829786,
							-4.876498
						],
						[
							145.981922,
							-5.465609
						],
						[
							147.648073,
							-6.083659
						],
						[
							147.891108,
							-6.614015
						],
						[
							146.970905,
							-6.721657
						],
						[
							147.191874,
							-7.388024
						]
					]
				],
				[
					[
						[
							153.140038,
							-4.499983
						],
						[
							152.827292,
							-4.766427
						],
						[
							152.638673,
							-4.176127
						],
						[
							152.406026,
							-3.789743
						],
						[
							151.953237,
							-3.462062
						],
						[
							151.384279,
							-3.035422
						],
						[
							150.66205,
							-2.741486
						],
						[
							150.939965,
							-2.500002
						],
						[
							151.479984,
							-2.779985
						],
						[
							151.820015,
							-2.999972
						],
						[
							152.239989,
							-3.240009
						],
						[
							152.640017,
							-3.659983
						],
						[
							153.019994,
							-3.980015
						],
						[
							153.140038,
							-4.499983
						]
					]
				]
			]
		},
		id: "PNG",
		id2: "PG",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Paraguay"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-62.685057,
						-22.249029
					],
					[
						-62.291179,
						-21.051635
					],
					[
						-62.265961,
						-20.513735
					],
					[
						-61.786326,
						-19.633737
					],
					[
						-60.043565,
						-19.342747
					],
					[
						-59.115042,
						-19.356906
					],
					[
						-58.183471,
						-19.868399
					],
					[
						-58.166392,
						-20.176701
					],
					[
						-57.870674,
						-20.732688
					],
					[
						-57.937156,
						-22.090176
					],
					[
						-56.88151,
						-22.282154
					],
					[
						-56.473317,
						-22.0863
					],
					[
						-55.797958,
						-22.35693
					],
					[
						-55.610683,
						-22.655619
					],
					[
						-55.517639,
						-23.571998
					],
					[
						-55.400747,
						-23.956935
					],
					[
						-55.027902,
						-24.001274
					],
					[
						-54.652834,
						-23.839578
					],
					[
						-54.29296,
						-24.021014
					],
					[
						-54.293476,
						-24.5708
					],
					[
						-54.428946,
						-25.162185
					],
					[
						-54.625291,
						-25.739255
					],
					[
						-54.788795,
						-26.621786
					],
					[
						-55.695846,
						-27.387837
					],
					[
						-56.486702,
						-27.548499
					],
					[
						-57.60976,
						-27.395899
					],
					[
						-58.618174,
						-27.123719
					],
					[
						-57.63366,
						-25.603657
					],
					[
						-57.777217,
						-25.16234
					],
					[
						-58.807128,
						-24.771459
					],
					[
						-60.028966,
						-24.032796
					],
					[
						-60.846565,
						-23.880713
					],
					[
						-62.685057,
						-22.249029
					]
				]
			]
		},
		id: "PRY",
		id2: "PY",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Peru"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-69.590424,
						-17.580012
					],
					[
						-69.858444,
						-18.092694
					],
					[
						-70.372572,
						-18.347975
					],
					[
						-71.37525,
						-17.773799
					],
					[
						-71.462041,
						-17.363488
					],
					[
						-73.44453,
						-16.359363
					],
					[
						-75.237883,
						-15.265683
					],
					[
						-76.009205,
						-14.649286
					],
					[
						-76.423469,
						-13.823187
					],
					[
						-76.259242,
						-13.535039
					],
					[
						-77.106192,
						-12.222716
					],
					[
						-78.092153,
						-10.377712
					],
					[
						-79.036953,
						-8.386568
					],
					[
						-79.44592,
						-7.930833
					],
					[
						-79.760578,
						-7.194341
					],
					[
						-80.537482,
						-6.541668
					],
					[
						-81.249996,
						-6.136834
					],
					[
						-80.926347,
						-5.690557
					],
					[
						-81.410943,
						-4.736765
					],
					[
						-81.09967,
						-4.036394
					],
					[
						-80.302561,
						-3.404856
					],
					[
						-80.184015,
						-3.821162
					],
					[
						-80.469295,
						-4.059287
					],
					[
						-80.442242,
						-4.425724
					],
					[
						-80.028908,
						-4.346091
					],
					[
						-79.624979,
						-4.454198
					],
					[
						-79.205289,
						-4.959129
					],
					[
						-78.639897,
						-4.547784
					],
					[
						-78.450684,
						-3.873097
					],
					[
						-77.837905,
						-3.003021
					],
					[
						-76.635394,
						-2.608678
					],
					[
						-75.544996,
						-1.56161
					],
					[
						-75.233723,
						-0.911417
					],
					[
						-75.373223,
						-0.152032
					],
					[
						-75.106625,
						-0.057205
					],
					[
						-74.441601,
						-0.53082
					],
					[
						-74.122395,
						-1.002833
					],
					[
						-73.659504,
						-1.260491
					],
					[
						-73.070392,
						-2.308954
					],
					[
						-72.325787,
						-2.434218
					],
					[
						-71.774761,
						-2.16979
					],
					[
						-71.413646,
						-2.342802
					],
					[
						-70.813476,
						-2.256865
					],
					[
						-70.047709,
						-2.725156
					],
					[
						-70.692682,
						-3.742872
					],
					[
						-70.394044,
						-3.766591
					],
					[
						-69.893635,
						-4.298187
					],
					[
						-70.794769,
						-4.251265
					],
					[
						-70.928843,
						-4.401591
					],
					[
						-71.748406,
						-4.593983
					],
					[
						-72.891928,
						-5.274561
					],
					[
						-72.964507,
						-5.741251
					],
					[
						-73.219711,
						-6.089189
					],
					[
						-73.120027,
						-6.629931
					],
					[
						-73.724487,
						-6.918595
					],
					[
						-73.723401,
						-7.340999
					],
					[
						-73.987235,
						-7.52383
					],
					[
						-73.571059,
						-8.424447
					],
					[
						-73.015383,
						-9.032833
					],
					[
						-73.226713,
						-9.462213
					],
					[
						-72.563033,
						-9.520194
					],
					[
						-72.184891,
						-10.053598
					],
					[
						-71.302412,
						-10.079436
					],
					[
						-70.481894,
						-9.490118
					],
					[
						-70.548686,
						-11.009147
					],
					[
						-70.093752,
						-11.123972
					],
					[
						-69.529678,
						-10.951734
					],
					[
						-68.66508,
						-12.5613
					],
					[
						-68.88008,
						-12.899729
					],
					[
						-68.929224,
						-13.602684
					],
					[
						-68.948887,
						-14.453639
					],
					[
						-69.339535,
						-14.953195
					],
					[
						-69.160347,
						-15.323974
					],
					[
						-69.389764,
						-15.660129
					],
					[
						-68.959635,
						-16.500698
					],
					[
						-69.590424,
						-17.580012
					]
				]
			]
		},
		id: "PER",
		id2: "PE",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Philippines"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							126.376814,
							8.414706
						],
						[
							126.478513,
							7.750354
						],
						[
							126.537424,
							7.189381
						],
						[
							126.196773,
							6.274294
						],
						[
							125.831421,
							7.293715
						],
						[
							125.363852,
							6.786485
						],
						[
							125.683161,
							6.049657
						],
						[
							125.396512,
							5.581003
						],
						[
							124.219788,
							6.161355
						],
						[
							123.93872,
							6.885136
						],
						[
							124.243662,
							7.36061
						],
						[
							123.610212,
							7.833527
						],
						[
							123.296071,
							7.418876
						],
						[
							122.825506,
							7.457375
						],
						[
							122.085499,
							6.899424
						],
						[
							121.919928,
							7.192119
						],
						[
							122.312359,
							8.034962
						],
						[
							122.942398,
							8.316237
						],
						[
							123.487688,
							8.69301
						],
						[
							123.841154,
							8.240324
						],
						[
							124.60147,
							8.514158
						],
						[
							124.764612,
							8.960409
						],
						[
							125.471391,
							8.986997
						],
						[
							125.412118,
							9.760335
						],
						[
							126.222714,
							9.286074
						],
						[
							126.306637,
							8.782487
						],
						[
							126.376814,
							8.414706
						]
					]
				],
				[
					[
						[
							123.982438,
							10.278779
						],
						[
							123.623183,
							9.950091
						],
						[
							123.309921,
							9.318269
						],
						[
							122.995883,
							9.022189
						],
						[
							122.380055,
							9.713361
						],
						[
							122.586089,
							9.981045
						],
						[
							122.837081,
							10.261157
						],
						[
							122.947411,
							10.881868
						],
						[
							123.49885,
							10.940624
						],
						[
							123.337774,
							10.267384
						],
						[
							124.077936,
							11.232726
						],
						[
							123.982438,
							10.278779
						]
					]
				],
				[
					[
						[
							118.504581,
							9.316383
						],
						[
							117.174275,
							8.3675
						],
						[
							117.664477,
							9.066889
						],
						[
							118.386914,
							9.6845
						],
						[
							118.987342,
							10.376292
						],
						[
							119.511496,
							11.369668
						],
						[
							119.689677,
							10.554291
						],
						[
							119.029458,
							10.003653
						],
						[
							118.504581,
							9.316383
						]
					]
				],
				[
					[
						[
							121.883548,
							11.891755
						],
						[
							122.483821,
							11.582187
						],
						[
							123.120217,
							11.58366
						],
						[
							123.100838,
							11.165934
						],
						[
							122.637714,
							10.741308
						],
						[
							122.00261,
							10.441017
						],
						[
							121.967367,
							10.905691
						],
						[
							122.03837,
							11.415841
						],
						[
							121.883548,
							11.891755
						]
					]
				],
				[
					[
						[
							125.502552,
							12.162695
						],
						[
							125.783465,
							11.046122
						],
						[
							125.011884,
							11.311455
						],
						[
							125.032761,
							10.975816
						],
						[
							125.277449,
							10.358722
						],
						[
							124.801819,
							10.134679
						],
						[
							124.760168,
							10.837995
						],
						[
							124.459101,
							10.88993
						],
						[
							124.302522,
							11.495371
						],
						[
							124.891013,
							11.415583
						],
						[
							124.87799,
							11.79419
						],
						[
							124.266762,
							12.557761
						],
						[
							125.227116,
							12.535721
						],
						[
							125.502552,
							12.162695
						]
					]
				],
				[
					[
						[
							121.527394,
							13.06959
						],
						[
							121.26219,
							12.20556
						],
						[
							120.833896,
							12.704496
						],
						[
							120.323436,
							13.466413
						],
						[
							121.180128,
							13.429697
						],
						[
							121.527394,
							13.06959
						]
					]
				],
				[
					[
						[
							121.321308,
							18.504065
						],
						[
							121.937601,
							18.218552
						],
						[
							122.246006,
							18.47895
						],
						[
							122.336957,
							18.224883
						],
						[
							122.174279,
							17.810283
						],
						[
							122.515654,
							17.093505
						],
						[
							122.252311,
							16.262444
						],
						[
							121.662786,
							15.931018
						],
						[
							121.50507,
							15.124814
						],
						[
							121.728829,
							14.328376
						],
						[
							122.258925,
							14.218202
						],
						[
							122.701276,
							14.336541
						],
						[
							123.950295,
							13.782131
						],
						[
							123.855107,
							13.237771
						],
						[
							124.181289,
							12.997527
						],
						[
							124.077419,
							12.536677
						],
						[
							123.298035,
							13.027526
						],
						[
							122.928652,
							13.55292
						],
						[
							122.671355,
							13.185836
						],
						[
							122.03465,
							13.784482
						],
						[
							121.126385,
							13.636687
						],
						[
							120.628637,
							13.857656
						],
						[
							120.679384,
							14.271016
						],
						[
							120.991819,
							14.525393
						],
						[
							120.693336,
							14.756671
						],
						[
							120.564145,
							14.396279
						],
						[
							120.070429,
							14.970869
						],
						[
							119.920929,
							15.406347
						],
						[
							119.883773,
							16.363704
						],
						[
							120.286488,
							16.034629
						],
						[
							120.390047,
							17.599081
						],
						[
							120.715867,
							18.505227
						],
						[
							121.321308,
							18.504065
						]
					]
				]
			]
		},
		id: "PHL",
		id2: "PH",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-128.29,
							-24.41
						],
						[
							-128.34,
							-24.33
						],
						[
							-128.3,
							-24.33
						],
						[
							-128.29,
							-24.41
						]
					]
				]
			]
		},
		properties: {
			name: "Pitcairn Islands"
		},
		id2: "PN",
		id: "PCN",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Poland"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						15.016996,
						51.106674
					],
					[
						14.607098,
						51.745188
					],
					[
						14.685026,
						52.089947
					],
					[
						14.4376,
						52.62485
					],
					[
						14.074521,
						52.981263
					],
					[
						14.353315,
						53.248171
					],
					[
						14.119686,
						53.757029
					],
					[
						14.8029,
						54.050706
					],
					[
						16.363477,
						54.513159
					],
					[
						17.622832,
						54.851536
					],
					[
						18.620859,
						54.682606
					],
					[
						18.696255,
						54.438719
					],
					[
						19.66064,
						54.426084
					],
					[
						20.892245,
						54.312525
					],
					[
						22.731099,
						54.327537
					],
					[
						23.243987,
						54.220567
					],
					[
						23.484128,
						53.912498
					],
					[
						23.527536,
						53.470122
					],
					[
						23.804935,
						53.089731
					],
					[
						23.799199,
						52.691099
					],
					[
						23.199494,
						52.486977
					],
					[
						23.508002,
						52.023647
					],
					[
						23.527071,
						51.578454
					],
					[
						24.029986,
						50.705407
					],
					[
						23.922757,
						50.424881
					],
					[
						23.426508,
						50.308506
					],
					[
						22.51845,
						49.476774
					],
					[
						22.776419,
						49.027395
					],
					[
						22.558138,
						49.085738
					],
					[
						21.607808,
						49.470107
					],
					[
						20.887955,
						49.328772
					],
					[
						20.415839,
						49.431453
					],
					[
						19.825023,
						49.217125
					],
					[
						19.320713,
						49.571574
					],
					[
						18.909575,
						49.435846
					],
					[
						18.853144,
						49.49623
					],
					[
						18.392914,
						49.988629
					],
					[
						17.649445,
						50.049038
					],
					[
						17.554567,
						50.362146
					],
					[
						16.868769,
						50.473974
					],
					[
						16.719476,
						50.215747
					],
					[
						16.176253,
						50.422607
					],
					[
						16.238627,
						50.697733
					],
					[
						15.490972,
						50.78473
					],
					[
						15.016996,
						51.106674
					]
				]
			]
		},
		id: "POL",
		id2: "PL",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Portugal"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-9.034818,
						41.880571
					],
					[
						-8.671946,
						42.134689
					],
					[
						-8.263857,
						42.280469
					],
					[
						-8.013175,
						41.790886
					],
					[
						-7.422513,
						41.792075
					],
					[
						-7.251309,
						41.918346
					],
					[
						-6.668606,
						41.883387
					],
					[
						-6.389088,
						41.381815
					],
					[
						-6.851127,
						41.111083
					],
					[
						-6.86402,
						40.330872
					],
					[
						-7.026413,
						40.184524
					],
					[
						-7.066592,
						39.711892
					],
					[
						-7.498632,
						39.629571
					],
					[
						-7.098037,
						39.030073
					],
					[
						-7.374092,
						38.373059
					],
					[
						-7.029281,
						38.075764
					],
					[
						-7.166508,
						37.803894
					],
					[
						-7.537105,
						37.428904
					],
					[
						-7.453726,
						37.097788
					],
					[
						-7.855613,
						36.838269
					],
					[
						-8.382816,
						36.97888
					],
					[
						-8.898857,
						36.868809
					],
					[
						-8.746101,
						37.651346
					],
					[
						-8.839998,
						38.266243
					],
					[
						-9.287464,
						38.358486
					],
					[
						-9.526571,
						38.737429
					],
					[
						-9.446989,
						39.392066
					],
					[
						-9.048305,
						39.755093
					],
					[
						-8.977353,
						40.159306
					],
					[
						-8.768684,
						40.760639
					],
					[
						-8.790853,
						41.184334
					],
					[
						-8.990789,
						41.543459
					],
					[
						-9.034818,
						41.880571
					]
				]
			]
		},
		id: "PRT",
		id2: "PT",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Puerto Rico"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-66.282434,
						18.514762
					],
					[
						-65.771303,
						18.426679
					],
					[
						-65.591004,
						18.228035
					],
					[
						-65.847164,
						17.975906
					],
					[
						-66.599934,
						17.981823
					],
					[
						-67.184162,
						17.946553
					],
					[
						-67.242428,
						18.37446
					],
					[
						-67.100679,
						18.520601
					],
					[
						-66.282434,
						18.514762
					]
				]
			]
		},
		id: "PRI",
		id2: "PR",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Qatar"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						50.810108,
						24.754743
					],
					[
						50.743911,
						25.482424
					],
					[
						51.013352,
						26.006992
					],
					[
						51.286462,
						26.114582
					],
					[
						51.589079,
						25.801113
					],
					[
						51.6067,
						25.21567
					],
					[
						51.389608,
						24.627386
					],
					[
						51.112415,
						24.556331
					],
					[
						50.810108,
						24.754743
					]
				]
			]
		},
		id: "QAT",
		id2: "QA",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Macedonia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						20.59023,
						41.85541
					],
					[
						20.71731,
						41.84711
					],
					[
						20.76216,
						42.05186
					],
					[
						21.3527,
						42.2068
					],
					[
						21.576636,
						42.245224
					],
					[
						21.91708,
						42.30364
					],
					[
						22.380526,
						42.32026
					],
					[
						22.881374,
						41.999297
					],
					[
						22.952377,
						41.337994
					],
					[
						22.76177,
						41.3048
					],
					[
						22.597308,
						41.130487
					],
					[
						22.055378,
						41.149866
					],
					[
						21.674161,
						40.931275
					],
					[
						21.02004,
						40.842727
					],
					[
						20.60518,
						41.08622
					],
					[
						20.46315,
						41.51509
					],
					[
						20.59023,
						41.85541
					]
				]
			]
		},
		id: "MKD",
		id2: "MK",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Romania"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						22.710531,
						47.882194
					],
					[
						23.142236,
						48.096341
					],
					[
						23.760958,
						47.985598
					],
					[
						24.402056,
						47.981878
					],
					[
						24.866317,
						47.737526
					],
					[
						25.207743,
						47.891056
					],
					[
						25.945941,
						47.987149
					],
					[
						26.19745,
						48.220881
					],
					[
						26.619337,
						48.220726
					],
					[
						26.924176,
						48.123264
					],
					[
						27.233873,
						47.826771
					],
					[
						27.551166,
						47.405117
					],
					[
						28.12803,
						46.810476
					],
					[
						28.160018,
						46.371563
					],
					[
						28.054443,
						45.944586
					],
					[
						28.233554,
						45.488283
					],
					[
						28.679779,
						45.304031
					],
					[
						29.149725,
						45.464925
					],
					[
						29.603289,
						45.293308
					],
					[
						29.626543,
						45.035391
					],
					[
						29.141612,
						44.82021
					],
					[
						28.837858,
						44.913874
					],
					[
						28.558081,
						43.707462
					],
					[
						27.970107,
						43.812468
					],
					[
						27.2424,
						44.175986
					],
					[
						26.065159,
						43.943494
					],
					[
						25.569272,
						43.688445
					],
					[
						24.100679,
						43.741051
					],
					[
						23.332302,
						43.897011
					],
					[
						22.944832,
						43.823785
					],
					[
						22.65715,
						44.234923
					],
					[
						22.474008,
						44.409228
					],
					[
						22.705726,
						44.578003
					],
					[
						22.459022,
						44.702517
					],
					[
						22.145088,
						44.478422
					],
					[
						21.562023,
						44.768947
					],
					[
						21.483526,
						45.18117
					],
					[
						20.874313,
						45.416375
					],
					[
						20.762175,
						45.734573
					],
					[
						20.220192,
						46.127469
					],
					[
						21.021952,
						46.316088
					],
					[
						21.626515,
						46.994238
					],
					[
						22.099768,
						47.672439
					],
					[
						22.710531,
						47.882194
					]
				]
			]
		},
		id: "ROU",
		id2: "RO",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Russia"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							143.648007,
							50.7476
						],
						[
							144.654148,
							48.976391
						],
						[
							143.173928,
							49.306551
						],
						[
							142.558668,
							47.861575
						],
						[
							143.533492,
							46.836728
						],
						[
							143.505277,
							46.137908
						],
						[
							142.747701,
							46.740765
						],
						[
							142.09203,
							45.966755
						],
						[
							141.906925,
							46.805929
						],
						[
							142.018443,
							47.780133
						],
						[
							141.904445,
							48.859189
						],
						[
							142.1358,
							49.615163
						],
						[
							142.179983,
							50.952342
						],
						[
							141.594076,
							51.935435
						],
						[
							141.682546,
							53.301966
						],
						[
							142.606934,
							53.762145
						],
						[
							142.209749,
							54.225476
						],
						[
							142.654786,
							54.365881
						],
						[
							142.914616,
							53.704578
						],
						[
							143.260848,
							52.74076
						],
						[
							143.235268,
							51.75666
						],
						[
							143.648007,
							50.7476
						]
					]
				],
				[
					[
						[
							22.731099,
							54.327537
						],
						[
							20.892245,
							54.312525
						],
						[
							19.66064,
							54.426084
						],
						[
							19.888481,
							54.86616
						],
						[
							21.268449,
							55.190482
						],
						[
							22.315724,
							55.015299
						],
						[
							22.757764,
							54.856574
						],
						[
							22.651052,
							54.582741
						],
						[
							22.731099,
							54.327537
						]
					]
				],
				[
					[
						[
							-175.01425,
							66.58435
						],
						[
							-174.33983,
							66.33556
						],
						[
							-174.57182,
							67.06219
						],
						[
							-171.85731,
							66.91308
						],
						[
							-169.89958,
							65.97724
						],
						[
							-170.89107,
							65.54139
						],
						[
							-172.53025,
							65.43791
						],
						[
							-172.555,
							64.46079
						],
						[
							-172.95533,
							64.25269
						],
						[
							-173.89184,
							64.2826
						],
						[
							-174.65392,
							64.63125
						],
						[
							-175.98353,
							64.92288
						],
						[
							-176.20716,
							65.35667
						],
						[
							-177.22266,
							65.52024
						],
						[
							-178.35993,
							65.39052
						],
						[
							-178.90332,
							65.74044
						],
						[
							-178.68611,
							66.11211
						],
						[
							-179.88377,
							65.87456
						],
						[
							-179.43268,
							65.40411
						],
						[
							-180,
							64.979709
						],
						[
							-180,
							68.963636
						],
						[
							-177.55,
							68.2
						],
						[
							-174.92825,
							67.20589
						],
						[
							-175.01425,
							66.58435
						]
					]
				],
				[
					[
						[
							180,
							70.832199
						],
						[
							178.903425,
							70.78114
						],
						[
							178.7253,
							71.0988
						],
						[
							180,
							71.515714
						],
						[
							180,
							70.832199
						]
					]
				],
				[
					[
						[
							-178.69378,
							70.89302
						],
						[
							-180,
							70.832199
						],
						[
							-180,
							71.515714
						],
						[
							-179.871875,
							71.55762
						],
						[
							-179.02433,
							71.55553
						],
						[
							-177.577945,
							71.26948
						],
						[
							-177.663575,
							71.13277
						],
						[
							-178.69378,
							70.89302
						]
					]
				],
				[
					[
						[
							143.60385,
							73.21244
						],
						[
							142.08763,
							73.20544
						],
						[
							140.038155,
							73.31692
						],
						[
							139.86312,
							73.36983
						],
						[
							140.81171,
							73.76506
						],
						[
							142.06207,
							73.85758
						],
						[
							143.48283,
							73.47525
						],
						[
							143.60385,
							73.21244
						]
					]
				],
				[
					[
						[
							150.73167,
							75.08406
						],
						[
							149.575925,
							74.68892
						],
						[
							147.977465,
							74.778355
						],
						[
							146.11919,
							75.17298
						],
						[
							146.358485,
							75.49682
						],
						[
							148.22223,
							75.345845
						],
						[
							150.73167,
							75.08406
						]
					]
				],
				[
					[
						[
							145.086285,
							75.562625
						],
						[
							144.3,
							74.82
						],
						[
							140.61381,
							74.84768
						],
						[
							138.95544,
							74.61148
						],
						[
							136.97439,
							75.26167
						],
						[
							137.51176,
							75.94917
						],
						[
							138.831075,
							76.13676
						],
						[
							141.471615,
							76.09289
						],
						[
							145.086285,
							75.562625
						]
					]
				],
				[
					[
						[
							57.535693,
							70.720464
						],
						[
							56.944979,
							70.632743
						],
						[
							53.677375,
							70.762658
						],
						[
							53.412017,
							71.206662
						],
						[
							51.601895,
							71.474759
						],
						[
							51.455754,
							72.014881
						],
						[
							52.478275,
							72.229442
						],
						[
							52.444169,
							72.774731
						],
						[
							54.427614,
							73.627548
						],
						[
							53.50829,
							73.749814
						],
						[
							55.902459,
							74.627486
						],
						[
							55.631933,
							75.081412
						],
						[
							57.868644,
							75.60939
						],
						[
							61.170044,
							76.251883
						],
						[
							64.498368,
							76.439055
						],
						[
							66.210977,
							76.809782
						],
						[
							68.15706,
							76.939697
						],
						[
							68.852211,
							76.544811
						],
						[
							68.180573,
							76.233642
						],
						[
							64.637326,
							75.737755
						],
						[
							61.583508,
							75.260885
						],
						[
							58.477082,
							74.309056
						],
						[
							56.986786,
							73.333044
						],
						[
							55.419336,
							72.371268
						],
						[
							55.622838,
							71.540595
						],
						[
							57.535693,
							70.720464
						]
					]
				],
				[
					[
						[
							106.97013,
							76.97419
						],
						[
							107.24,
							76.48
						],
						[
							108.1538,
							76.72335
						],
						[
							111.07726,
							76.71
						],
						[
							113.33151,
							76.22224
						],
						[
							114.13417,
							75.84764
						],
						[
							113.88539,
							75.32779
						],
						[
							112.77918,
							75.03186
						],
						[
							110.15125,
							74.47673
						],
						[
							109.4,
							74.18
						],
						[
							110.64,
							74.04
						],
						[
							112.11919,
							73.78774
						],
						[
							113.01954,
							73.97693
						],
						[
							113.52958,
							73.33505
						],
						[
							113.96881,
							73.59488
						],
						[
							115.56782,
							73.75285
						],
						[
							118.77633,
							73.58772
						],
						[
							119.02,
							73.12
						],
						[
							123.20066,
							72.97122
						],
						[
							123.25777,
							73.73503
						],
						[
							125.38,
							73.56
						],
						[
							126.97644,
							73.56549
						],
						[
							128.59126,
							73.03871
						],
						[
							129.05157,
							72.39872
						],
						[
							128.46,
							71.98
						],
						[
							129.71599,
							71.19304
						],
						[
							131.28858,
							70.78699
						],
						[
							132.2535,
							71.8363
						],
						[
							133.85766,
							71.38642
						],
						[
							135.56193,
							71.65525
						],
						[
							137.49755,
							71.34763
						],
						[
							138.23409,
							71.62803
						],
						[
							139.86983,
							71.48783
						],
						[
							139.14791,
							72.41619
						],
						[
							140.46817,
							72.84941
						],
						[
							149.5,
							72.2
						],
						[
							150.35118,
							71.60643
						],
						[
							152.9689,
							70.84222
						],
						[
							157.00688,
							71.03141
						],
						[
							158.99779,
							70.86672
						],
						[
							159.83031,
							70.45324
						],
						[
							159.70866,
							69.72198
						],
						[
							160.94053,
							69.43728
						],
						[
							162.27907,
							69.64204
						],
						[
							164.05248,
							69.66823
						],
						[
							165.94037,
							69.47199
						],
						[
							167.83567,
							69.58269
						],
						[
							169.57763,
							68.6938
						],
						[
							170.81688,
							69.01363
						],
						[
							170.0082,
							69.65276
						],
						[
							170.45345,
							70.09703
						],
						[
							173.64391,
							69.81743
						],
						[
							175.72403,
							69.87725
						],
						[
							178.6,
							69.4
						],
						[
							180,
							68.963636
						],
						[
							180,
							64.979709
						],
						[
							179.99281,
							64.97433
						],
						[
							178.7072,
							64.53493
						],
						[
							177.41128,
							64.60821
						],
						[
							178.313,
							64.07593
						],
						[
							178.90825,
							63.25197
						],
						[
							179.37034,
							62.98262
						],
						[
							179.48636,
							62.56894
						],
						[
							179.22825,
							62.3041
						],
						[
							177.3643,
							62.5219
						],
						[
							174.56929,
							61.76915
						],
						[
							173.68013,
							61.65261
						],
						[
							172.15,
							60.95
						],
						[
							170.6985,
							60.33618
						],
						[
							170.33085,
							59.88177
						],
						[
							168.90046,
							60.57355
						],
						[
							166.29498,
							59.78855
						],
						[
							165.84,
							60.16
						],
						[
							164.87674,
							59.7316
						],
						[
							163.53929,
							59.86871
						],
						[
							163.21711,
							59.21101
						],
						[
							162.01733,
							58.24328
						],
						[
							162.05297,
							57.83912
						],
						[
							163.19191,
							57.61503
						],
						[
							163.05794,
							56.15924
						],
						[
							162.12958,
							56.12219
						],
						[
							161.70146,
							55.28568
						],
						[
							162.11749,
							54.85514
						],
						[
							160.36877,
							54.34433
						],
						[
							160.02173,
							53.20257
						],
						[
							158.53094,
							52.95868
						],
						[
							158.23118,
							51.94269
						],
						[
							156.78979,
							51.01105
						],
						[
							156.42,
							51.7
						],
						[
							155.99182,
							53.15895
						],
						[
							155.43366,
							55.38103
						],
						[
							155.91442,
							56.76792
						],
						[
							156.75815,
							57.3647
						],
						[
							156.81035,
							57.83204
						],
						[
							158.36433,
							58.05575
						],
						[
							160.15064,
							59.31477
						],
						[
							161.87204,
							60.343
						],
						[
							163.66969,
							61.1409
						],
						[
							164.47355,
							62.55061
						],
						[
							163.25842,
							62.46627
						],
						[
							162.65791,
							61.6425
						],
						[
							160.12148,
							60.54423
						],
						[
							159.30232,
							61.77396
						],
						[
							156.72068,
							61.43442
						],
						[
							154.21806,
							59.75818
						],
						[
							155.04375,
							59.14495
						],
						[
							152.81185,
							58.88385
						],
						[
							151.26573,
							58.78089
						],
						[
							151.33815,
							59.50396
						],
						[
							149.78371,
							59.65573
						],
						[
							148.54481,
							59.16448
						],
						[
							145.48722,
							59.33637
						],
						[
							142.19782,
							59.03998
						],
						[
							138.95848,
							57.08805
						],
						[
							135.12619,
							54.72959
						],
						[
							136.70171,
							54.60355
						],
						[
							137.19342,
							53.97732
						],
						[
							138.1647,
							53.75501
						],
						[
							138.80463,
							54.25455
						],
						[
							139.90151,
							54.18968
						],
						[
							141.34531,
							53.08957
						],
						[
							141.37923,
							52.23877
						],
						[
							140.59742,
							51.23967
						],
						[
							140.51308,
							50.04553
						],
						[
							140.06193,
							48.44671
						],
						[
							138.55472,
							46.99965
						],
						[
							138.21971,
							46.30795
						],
						[
							136.86232,
							45.1435
						],
						[
							135.51535,
							43.989
						],
						[
							134.86939,
							43.39821
						],
						[
							133.53687,
							42.81147
						],
						[
							132.90627,
							42.79849
						],
						[
							132.27807,
							43.28456
						],
						[
							130.93587,
							42.55274
						],
						[
							130.78,
							42.22
						],
						[
							130.64,
							42.395
						],
						[
							130.633866,
							42.903015
						],
						[
							131.144688,
							42.92999
						],
						[
							131.288555,
							44.11152
						],
						[
							131.02519,
							44.96796
						],
						[
							131.883454,
							45.321162
						],
						[
							133.09712,
							45.14409
						],
						[
							133.769644,
							46.116927
						],
						[
							134.11235,
							47.21248
						],
						[
							134.50081,
							47.57845
						],
						[
							135.026311,
							48.47823
						],
						[
							133.373596,
							48.183442
						],
						[
							132.50669,
							47.78896
						],
						[
							130.98726,
							47.79013
						],
						[
							130.582293,
							48.729687
						],
						[
							129.397818,
							49.4406
						],
						[
							127.6574,
							49.76027
						],
						[
							127.287456,
							50.739797
						],
						[
							126.939157,
							51.353894
						],
						[
							126.564399,
							51.784255
						],
						[
							125.946349,
							52.792799
						],
						[
							125.068211,
							53.161045
						],
						[
							123.57147,
							53.4588
						],
						[
							122.245748,
							53.431726
						],
						[
							121.003085,
							53.251401
						],
						[
							120.177089,
							52.753886
						],
						[
							120.725789,
							52.516226
						],
						[
							120.7382,
							51.96411
						],
						[
							120.18208,
							51.64355
						],
						[
							119.27939,
							50.58292
						],
						[
							119.288461,
							50.142883
						],
						[
							117.879244,
							49.510983
						],
						[
							116.678801,
							49.888531
						],
						[
							115.485695,
							49.805177
						],
						[
							114.96211,
							50.140247
						],
						[
							114.362456,
							50.248303
						],
						[
							112.89774,
							49.543565
						],
						[
							111.581231,
							49.377968
						],
						[
							110.662011,
							49.130128
						],
						[
							109.402449,
							49.292961
						],
						[
							108.475167,
							49.282548
						],
						[
							107.868176,
							49.793705
						],
						[
							106.888804,
							50.274296
						],
						[
							105.886591,
							50.406019
						],
						[
							104.62158,
							50.27532
						],
						[
							103.676545,
							50.089966
						],
						[
							102.25589,
							50.51056
						],
						[
							102.06521,
							51.25991
						],
						[
							100.88948,
							51.516856
						],
						[
							99.981732,
							51.634006
						],
						[
							98.861491,
							52.047366
						],
						[
							97.82574,
							51.010995
						],
						[
							98.231762,
							50.422401
						],
						[
							97.25976,
							49.72605
						],
						[
							95.81402,
							49.97746
						],
						[
							94.815949,
							50.013433
						],
						[
							94.147566,
							50.480537
						],
						[
							93.10421,
							50.49529
						],
						[
							92.234712,
							50.802171
						],
						[
							90.713667,
							50.331812
						],
						[
							88.805567,
							49.470521
						],
						[
							87.751264,
							49.297198
						],
						[
							87.35997,
							49.214981
						],
						[
							86.829357,
							49.826675
						],
						[
							85.54127,
							49.692859
						],
						[
							85.11556,
							50.117303
						],
						[
							84.416377,
							50.3114
						],
						[
							83.935115,
							50.889246
						],
						[
							83.383004,
							51.069183
						],
						[
							81.945986,
							50.812196
						],
						[
							80.568447,
							51.388336
						],
						[
							80.03556,
							50.864751
						],
						[
							77.800916,
							53.404415
						],
						[
							76.525179,
							54.177003
						],
						[
							76.8911,
							54.490524
						],
						[
							74.38482,
							53.54685
						],
						[
							73.425679,
							53.48981
						],
						[
							73.508516,
							54.035617
						],
						[
							72.22415,
							54.376655
						],
						[
							71.180131,
							54.133285
						],
						[
							70.865267,
							55.169734
						],
						[
							69.068167,
							55.38525
						],
						[
							68.1691,
							54.970392
						],
						[
							65.66687,
							54.60125
						],
						[
							65.178534,
							54.354228
						],
						[
							61.4366,
							54.00625
						],
						[
							60.978066,
							53.664993
						],
						[
							61.699986,
							52.979996
						],
						[
							60.739993,
							52.719986
						],
						[
							60.927269,
							52.447548
						],
						[
							59.967534,
							51.96042
						],
						[
							61.588003,
							51.272659
						],
						[
							61.337424,
							50.79907
						],
						[
							59.932807,
							50.842194
						],
						[
							59.642282,
							50.545442
						],
						[
							58.36332,
							51.06364
						],
						[
							56.77798,
							51.04355
						],
						[
							55.71694,
							50.62171
						],
						[
							54.532878,
							51.02624
						],
						[
							52.328724,
							51.718652
						],
						[
							50.766648,
							51.692762
						],
						[
							48.702382,
							50.605128
						],
						[
							48.577841,
							49.87476
						],
						[
							47.54948,
							50.454698
						],
						[
							46.751596,
							49.356006
						],
						[
							47.043672,
							49.152039
						],
						[
							46.466446,
							48.394152
						],
						[
							47.31524,
							47.71585
						],
						[
							48.05725,
							47.74377
						],
						[
							48.694734,
							47.075628
						],
						[
							48.59325,
							46.56104
						],
						[
							49.10116,
							46.39933
						],
						[
							48.64541,
							45.80629
						],
						[
							47.67591,
							45.64149
						],
						[
							46.68201,
							44.6092
						],
						[
							47.59094,
							43.66016
						],
						[
							47.49252,
							42.98658
						],
						[
							48.58437,
							41.80888
						],
						[
							47.987283,
							41.405819
						],
						[
							47.815666,
							41.151416
						],
						[
							47.373315,
							41.219732
						],
						[
							46.686071,
							41.827137
						],
						[
							46.404951,
							41.860675
						],
						[
							45.7764,
							42.09244
						],
						[
							45.470279,
							42.502781
						],
						[
							44.537623,
							42.711993
						],
						[
							43.93121,
							42.55496
						],
						[
							43.75599,
							42.74083
						],
						[
							42.3944,
							43.2203
						],
						[
							40.92219,
							43.38215
						],
						[
							40.076965,
							43.553104
						],
						[
							39.955009,
							43.434998
						],
						[
							38.68,
							44.28
						],
						[
							37.53912,
							44.65721
						],
						[
							36.67546,
							45.24469
						],
						[
							37.40317,
							45.40451
						],
						[
							38.23295,
							46.24087
						],
						[
							37.67372,
							46.63657
						],
						[
							39.14767,
							47.04475
						],
						[
							39.1212,
							47.26336
						],
						[
							38.223538,
							47.10219
						],
						[
							38.255112,
							47.5464
						],
						[
							38.77057,
							47.82562
						],
						[
							39.738278,
							47.898937
						],
						[
							39.89562,
							48.23241
						],
						[
							39.67465,
							48.78382
						],
						[
							40.080789,
							49.30743
						],
						[
							40.06904,
							49.60105
						],
						[
							38.594988,
							49.926462
						],
						[
							38.010631,
							49.915662
						],
						[
							37.39346,
							50.383953
						],
						[
							36.626168,
							50.225591
						],
						[
							35.356116,
							50.577197
						],
						[
							35.37791,
							50.77394
						],
						[
							35.022183,
							51.207572
						],
						[
							34.224816,
							51.255993
						],
						[
							34.141978,
							51.566413
						],
						[
							34.391731,
							51.768882
						],
						[
							33.7527,
							52.335075
						],
						[
							32.715761,
							52.238465
						],
						[
							32.412058,
							52.288695
						],
						[
							32.15944,
							52.06125
						],
						[
							31.78597,
							52.10168
						],
						[
							31.540018,
							52.742052
						],
						[
							31.305201,
							53.073996
						],
						[
							31.49764,
							53.16743
						],
						[
							32.304519,
							53.132726
						],
						[
							32.693643,
							53.351421
						],
						[
							32.405599,
							53.618045
						],
						[
							31.731273,
							53.794029
						],
						[
							31.791424,
							53.974639
						],
						[
							31.384472,
							54.157056
						],
						[
							30.757534,
							54.811771
						],
						[
							30.971836,
							55.081548
						],
						[
							30.873909,
							55.550976
						],
						[
							29.896294,
							55.789463
						],
						[
							29.371572,
							55.670091
						],
						[
							29.229513,
							55.918344
						],
						[
							28.176709,
							56.16913
						],
						[
							27.855282,
							56.759326
						],
						[
							27.770016,
							57.244258
						],
						[
							27.288185,
							57.474528
						],
						[
							27.716686,
							57.791899
						],
						[
							27.42015,
							58.72457
						],
						[
							28.131699,
							59.300825
						],
						[
							27.98112,
							59.47537
						],
						[
							29.1177,
							60.02805
						],
						[
							28.07,
							60.50352
						],
						[
							30.211107,
							61.780028
						],
						[
							31.139991,
							62.357693
						],
						[
							31.516092,
							62.867687
						],
						[
							30.035872,
							63.552814
						],
						[
							30.444685,
							64.204453
						],
						[
							29.54443,
							64.948672
						],
						[
							30.21765,
							65.80598
						],
						[
							29.054589,
							66.944286
						],
						[
							29.977426,
							67.698297
						],
						[
							28.445944,
							68.364613
						],
						[
							28.59193,
							69.064777
						],
						[
							29.39955,
							69.15692
						],
						[
							31.10108,
							69.55811
						],
						[
							32.13272,
							69.90595
						],
						[
							33.77547,
							69.30142
						],
						[
							36.51396,
							69.06342
						],
						[
							40.29234,
							67.9324
						],
						[
							41.05987,
							67.45713
						],
						[
							41.12595,
							66.79158
						],
						[
							40.01583,
							66.26618
						],
						[
							38.38295,
							65.99953
						],
						[
							33.91871,
							66.75961
						],
						[
							33.18444,
							66.63253
						],
						[
							34.81477,
							65.90015
						],
						[
							34.878574,
							65.436213
						],
						[
							34.94391,
							64.41437
						],
						[
							36.23129,
							64.10945
						],
						[
							37.01273,
							63.84983
						],
						[
							37.14197,
							64.33471
						],
						[
							36.539579,
							64.76446
						],
						[
							37.17604,
							65.14322
						],
						[
							39.59345,
							64.52079
						],
						[
							40.4356,
							64.76446
						],
						[
							39.7626,
							65.49682
						],
						[
							42.09309,
							66.47623
						],
						[
							43.01604,
							66.41858
						],
						[
							43.94975,
							66.06908
						],
						[
							44.53226,
							66.75634
						],
						[
							43.69839,
							67.35245
						],
						[
							44.18795,
							67.95051
						],
						[
							43.45282,
							68.57079
						],
						[
							46.25,
							68.25
						],
						[
							46.82134,
							67.68997
						],
						[
							45.55517,
							67.56652
						],
						[
							45.56202,
							67.01005
						],
						[
							46.34915,
							66.66767
						],
						[
							47.89416,
							66.88455
						],
						[
							48.13876,
							67.52238
						],
						[
							50.22766,
							67.99867
						],
						[
							53.71743,
							68.85738
						],
						[
							54.47171,
							68.80815
						],
						[
							53.48582,
							68.20131
						],
						[
							54.72628,
							68.09702
						],
						[
							55.44268,
							68.43866
						],
						[
							57.31702,
							68.46628
						],
						[
							58.802,
							68.88082
						],
						[
							59.94142,
							68.27844
						],
						[
							61.07784,
							68.94069
						],
						[
							60.03,
							69.52
						],
						[
							60.55,
							69.85
						],
						[
							63.504,
							69.54739
						],
						[
							64.888115,
							69.234835
						],
						[
							68.51216,
							68.09233
						],
						[
							69.18068,
							68.61563
						],
						[
							68.16444,
							69.14436
						],
						[
							68.13522,
							69.35649
						],
						[
							66.93008,
							69.45461
						],
						[
							67.25976,
							69.92873
						],
						[
							66.72492,
							70.70889
						],
						[
							66.69466,
							71.02897
						],
						[
							68.54006,
							71.9345
						],
						[
							69.19636,
							72.84336
						],
						[
							69.94,
							73.04
						],
						[
							72.58754,
							72.77629
						],
						[
							72.79603,
							72.22006
						],
						[
							71.84811,
							71.40898
						],
						[
							72.47011,
							71.09019
						],
						[
							72.79188,
							70.39114
						],
						[
							72.5647,
							69.02085
						],
						[
							73.66787,
							68.4079
						],
						[
							73.2387,
							67.7404
						],
						[
							71.28,
							66.32
						],
						[
							72.42301,
							66.17267
						],
						[
							72.82077,
							66.53267
						],
						[
							73.92099,
							66.78946
						],
						[
							74.18651,
							67.28429
						],
						[
							75.052,
							67.76047
						],
						[
							74.46926,
							68.32899
						],
						[
							74.93584,
							68.98918
						],
						[
							73.84236,
							69.07146
						],
						[
							73.60187,
							69.62763
						],
						[
							74.3998,
							70.63175
						],
						[
							73.1011,
							71.44717
						],
						[
							74.89082,
							72.12119
						],
						[
							74.65926,
							72.83227
						],
						[
							75.15801,
							72.85497
						],
						[
							75.68351,
							72.30056
						],
						[
							75.28898,
							71.33556
						],
						[
							76.35911,
							71.15287
						],
						[
							75.90313,
							71.87401
						],
						[
							77.57665,
							72.26717
						],
						[
							79.65202,
							72.32011
						],
						[
							81.5,
							71.75
						],
						[
							80.61071,
							72.58285
						],
						[
							80.51109,
							73.6482
						],
						[
							82.25,
							73.85
						],
						[
							84.65526,
							73.80591
						],
						[
							86.8223,
							73.93688
						],
						[
							86.00956,
							74.45967
						],
						[
							87.16682,
							75.11643
						],
						[
							88.31571,
							75.14393
						],
						[
							90.26,
							75.64
						],
						[
							92.90058,
							75.77333
						],
						[
							93.23421,
							76.0472
						],
						[
							95.86,
							76.14
						],
						[
							96.67821,
							75.91548
						],
						[
							98.92254,
							76.44689
						],
						[
							100.75967,
							76.43028
						],
						[
							101.03532,
							76.86189
						],
						[
							101.99084,
							77.28754
						],
						[
							104.3516,
							77.69792
						],
						[
							106.06664,
							77.37389
						],
						[
							104.705,
							77.1274
						],
						[
							106.97013,
							76.97419
						]
					]
				],
				[
					[
						[
							105.07547,
							78.30689
						],
						[
							99.43814,
							77.921
						],
						[
							101.2649,
							79.23399
						],
						[
							102.08635,
							79.34641
						],
						[
							102.837815,
							79.28129
						],
						[
							105.37243,
							78.71334
						],
						[
							105.07547,
							78.30689
						]
					]
				],
				[
					[
						[
							51.136187,
							80.54728
						],
						[
							49.793685,
							80.415428
						],
						[
							48.894411,
							80.339567
						],
						[
							48.754937,
							80.175468
						],
						[
							47.586119,
							80.010181
						],
						[
							46.502826,
							80.247247
						],
						[
							47.072455,
							80.559424
						],
						[
							44.846958,
							80.58981
						],
						[
							46.799139,
							80.771918
						],
						[
							48.318477,
							80.78401
						],
						[
							48.522806,
							80.514569
						],
						[
							49.09719,
							80.753986
						],
						[
							50.039768,
							80.918885
						],
						[
							51.522933,
							80.699726
						],
						[
							51.136187,
							80.54728
						]
					]
				],
				[
					[
						[
							99.93976,
							78.88094
						],
						[
							97.75794,
							78.7562
						],
						[
							94.97259,
							79.044745
						],
						[
							93.31288,
							79.4265
						],
						[
							92.5454,
							80.14379
						],
						[
							91.18107,
							80.34146
						],
						[
							93.77766,
							81.0246
						],
						[
							95.940895,
							81.2504
						],
						[
							97.88385,
							80.746975
						],
						[
							100.186655,
							79.780135
						],
						[
							99.93976,
							78.88094
						]
					]
				]
			]
		},
		id: "RUS",
		id2: "RU",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Rwanda"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						30.419105,
						-1.134659
					],
					[
						30.816135,
						-1.698914
					],
					[
						30.758309,
						-2.28725
					],
					[
						30.469696,
						-2.413858
					],
					[
						29.938359,
						-2.348487
					],
					[
						29.632176,
						-2.917858
					],
					[
						29.024926,
						-2.839258
					],
					[
						29.117479,
						-2.292211
					],
					[
						29.254835,
						-2.21511
					],
					[
						29.291887,
						-1.620056
					],
					[
						29.579466,
						-1.341313
					],
					[
						29.821519,
						-1.443322
					],
					[
						30.419105,
						-1.134659
					]
				]
			]
		},
		id: "RWA",
		id2: "RW",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							55.71,
							-21
						],
						[
							55.67,
							-21.37
						],
						[
							55.22,
							-21.03
						],
						[
							55.71,
							-21
						]
					]
				]
			]
		},
		properties: {
			name: "Reunion"
		},
		id2: "RE",
		id: "REU",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-63.03,
							18.02
						],
						[
							-63.14,
							18.06
						],
						[
							-63.01,
							18.07
						],
						[
							-63.03,
							18.02
						]
					]
				]
			]
		},
		properties: {
			name: "Saint Barthelemy"
		},
		id2: "BL",
		id: "BLM",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-5.66,
							-15.99
						],
						[
							-5.79,
							-15.99
						],
						[
							-5.7,
							-15.9
						],
						[
							-5.66,
							-15.99
						]
					]
				]
			]
		},
		properties: {
			name: "Saint Helena"
		},
		id2: "SH",
		id: "SHN",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-62.55,
							17.09
						],
						[
							-62.62,
							17.11
						],
						[
							-62.6,
							17.2
						],
						[
							-62.55,
							17.09
						]
					]
				],
				[
					[
						[
							-62.7,
							17.34
						],
						[
							-62.63,
							17.22
						],
						[
							-62.86,
							17.37
						],
						[
							-62.7,
							17.34
						]
					]
				]
			]
		},
		properties: {
			name: "Saint Kitts and Nevis"
		},
		id2: "KN",
		id: "KNA",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-60.95,
							13.71
						],
						[
							-61.08,
							13.88
						],
						[
							-60.93,
							14.11
						],
						[
							-60.95,
							13.71
						]
					]
				]
			]
		},
		properties: {
			name: "Saint Lucia"
		},
		id2: "LC",
		id: "LCA",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-63.01,
							18.08
						],
						[
							-63.01,
							18.07
						],
						[
							-63.14,
							18.06
						],
						[
							-63.01,
							18.08
						]
					]
				]
			]
		},
		properties: {
			name: "Saint Martin"
		},
		id2: "MF",
		id: "MAF",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-56.15,
							46.76
						],
						[
							-56.24,
							46.76
						],
						[
							-56.17,
							46.81
						],
						[
							-56.15,
							46.76
						]
					]
				],
				[
					[
						[
							-56.27,
							46.99
						],
						[
							-56.37,
							46.78
						],
						[
							-56.39,
							47.12
						],
						[
							-56.27,
							46.99
						]
					]
				]
			]
		},
		properties: {
			name: "Saint Pierre and Miquelon"
		},
		id2: "PM",
		id: "SPM",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-61.17,
							13.13
						],
						[
							-61.28,
							13.21
						],
						[
							-61.18,
							13.38
						],
						[
							-61.17,
							13.13
						]
					]
				]
			]
		},
		properties: {
			name: "Saint Vincent and the Grenadines"
		},
		id2: "VC",
		id: "VCT",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-171.43,
							-14.02
						],
						[
							-172.06,
							-13.87
						],
						[
							-171.82,
							-13.81
						],
						[
							-171.43,
							-14.02
						]
					]
				],
				[
					[
						[
							-172.29,
							-13.49
						],
						[
							-172.21,
							-13.81
						],
						[
							-172.78,
							-13.53
						],
						[
							-172.29,
							-13.49
						]
					]
				]
			]
		},
		properties: {
			name: "Samoa"
		},
		id2: "WS",
		id: "WSM",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							12.42,
							43.96
						],
						[
							12.51,
							43.99
						],
						[
							12.46,
							43.9
						],
						[
							12.42,
							43.96
						]
					]
				]
			]
		},
		properties: {
			name: "San Marino"
		},
		id2: "SM",
		id: "SMR",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							6.52,
							0.02
						],
						[
							6.47,
							0.26
						],
						[
							6.69,
							0.4
						],
						[
							6.52,
							0.02
						]
					]
				],
				[
					[
						[
							7.42,
							1.56
						],
						[
							7.33,
							1.61
						],
						[
							7.41,
							1.7
						],
						[
							7.42,
							1.56
						]
					]
				]
			]
		},
		properties: {
			name: "Sao Tome and Principe"
		},
		id2: "ST",
		id: "STP",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Saudi Arabia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						42.779332,
						16.347891
					],
					[
						42.649573,
						16.774635
					],
					[
						42.347989,
						17.075806
					],
					[
						42.270888,
						17.474722
					],
					[
						41.754382,
						17.833046
					],
					[
						41.221391,
						18.6716
					],
					[
						40.939341,
						19.486485
					],
					[
						40.247652,
						20.174635
					],
					[
						39.801685,
						20.338862
					],
					[
						39.139399,
						21.291905
					],
					[
						39.023696,
						21.986875
					],
					[
						39.066329,
						22.579656
					],
					[
						38.492772,
						23.688451
					],
					[
						38.02386,
						24.078686
					],
					[
						37.483635,
						24.285495
					],
					[
						37.154818,
						24.858483
					],
					[
						37.209491,
						25.084542
					],
					[
						36.931627,
						25.602959
					],
					[
						36.639604,
						25.826228
					],
					[
						36.249137,
						26.570136
					],
					[
						35.640182,
						27.37652
					],
					[
						35.130187,
						28.063352
					],
					[
						34.632336,
						28.058546
					],
					[
						34.787779,
						28.607427
					],
					[
						34.83222,
						28.957483
					],
					[
						34.956037,
						29.356555
					],
					[
						36.068941,
						29.197495
					],
					[
						36.501214,
						29.505254
					],
					[
						36.740528,
						29.865283
					],
					[
						37.503582,
						30.003776
					],
					[
						37.66812,
						30.338665
					],
					[
						37.998849,
						30.5085
					],
					[
						37.002166,
						31.508413
					],
					[
						39.004886,
						32.010217
					],
					[
						39.195468,
						32.161009
					],
					[
						40.399994,
						31.889992
					],
					[
						41.889981,
						31.190009
					],
					[
						44.709499,
						29.178891
					],
					[
						46.568713,
						29.099025
					],
					[
						47.459822,
						29.002519
					],
					[
						47.708851,
						28.526063
					],
					[
						48.416094,
						28.552004
					],
					[
						48.807595,
						27.689628
					],
					[
						49.299554,
						27.461218
					],
					[
						49.470914,
						27.109999
					],
					[
						50.152422,
						26.689663
					],
					[
						50.212935,
						26.277027
					],
					[
						50.113303,
						25.943972
					],
					[
						50.239859,
						25.60805
					],
					[
						50.527387,
						25.327808
					],
					[
						50.660557,
						24.999896
					],
					[
						50.810108,
						24.754743
					],
					[
						51.112415,
						24.556331
					],
					[
						51.389608,
						24.627386
					],
					[
						51.579519,
						24.245497
					],
					[
						51.617708,
						24.014219
					],
					[
						52.000733,
						23.001154
					],
					[
						55.006803,
						22.496948
					],
					[
						55.208341,
						22.70833
					],
					[
						55.666659,
						22.000001
					],
					[
						54.999982,
						19.999994
					],
					[
						52.00001,
						19.000003
					],
					[
						49.116672,
						18.616668
					],
					[
						48.183344,
						18.166669
					],
					[
						47.466695,
						17.116682
					],
					[
						47.000005,
						16.949999
					],
					[
						46.749994,
						17.283338
					],
					[
						46.366659,
						17.233315
					],
					[
						45.399999,
						17.333335
					],
					[
						45.216651,
						17.433329
					],
					[
						44.062613,
						17.410359
					],
					[
						43.791519,
						17.319977
					],
					[
						43.380794,
						17.579987
					],
					[
						43.115798,
						17.08844
					],
					[
						43.218375,
						16.66689
					],
					[
						42.779332,
						16.347891
					]
				]
			]
		},
		id: "SAU",
		id2: "SA",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Senegal"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-16.713729,
						13.594959
					],
					[
						-17.126107,
						14.373516
					],
					[
						-17.625043,
						14.729541
					],
					[
						-17.185173,
						14.919477
					],
					[
						-16.700706,
						15.621527
					],
					[
						-16.463098,
						16.135036
					],
					[
						-16.12069,
						16.455663
					],
					[
						-15.623666,
						16.369337
					],
					[
						-15.135737,
						16.587282
					],
					[
						-14.577348,
						16.598264
					],
					[
						-14.099521,
						16.304302
					],
					[
						-13.435738,
						16.039383
					],
					[
						-12.830658,
						15.303692
					],
					[
						-12.17075,
						14.616834
					],
					[
						-12.124887,
						13.994727
					],
					[
						-11.927716,
						13.422075
					],
					[
						-11.553398,
						13.141214
					],
					[
						-11.467899,
						12.754519
					],
					[
						-11.513943,
						12.442988
					],
					[
						-11.658301,
						12.386583
					],
					[
						-12.203565,
						12.465648
					],
					[
						-12.278599,
						12.35444
					],
					[
						-12.499051,
						12.33209
					],
					[
						-13.217818,
						12.575874
					],
					[
						-13.700476,
						12.586183
					],
					[
						-15.548477,
						12.62817
					],
					[
						-15.816574,
						12.515567
					],
					[
						-16.147717,
						12.547762
					],
					[
						-16.677452,
						12.384852
					],
					[
						-16.841525,
						13.151394
					],
					[
						-15.931296,
						13.130284
					],
					[
						-15.691001,
						13.270353
					],
					[
						-15.511813,
						13.27857
					],
					[
						-15.141163,
						13.509512
					],
					[
						-14.712197,
						13.298207
					],
					[
						-14.277702,
						13.280585
					],
					[
						-13.844963,
						13.505042
					],
					[
						-14.046992,
						13.794068
					],
					[
						-14.376714,
						13.62568
					],
					[
						-14.687031,
						13.630357
					],
					[
						-15.081735,
						13.876492
					],
					[
						-15.39877,
						13.860369
					],
					[
						-15.624596,
						13.623587
					],
					[
						-16.713729,
						13.594959
					]
				]
			]
		},
		id: "SEN",
		id2: "SN",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Republic of Serbia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						20.874313,
						45.416375
					],
					[
						21.483526,
						45.18117
					],
					[
						21.562023,
						44.768947
					],
					[
						22.145088,
						44.478422
					],
					[
						22.459022,
						44.702517
					],
					[
						22.705726,
						44.578003
					],
					[
						22.474008,
						44.409228
					],
					[
						22.65715,
						44.234923
					],
					[
						22.410446,
						44.008063
					],
					[
						22.500157,
						43.642814
					],
					[
						22.986019,
						43.211161
					],
					[
						22.604801,
						42.898519
					],
					[
						22.436595,
						42.580321
					],
					[
						22.545012,
						42.461362
					],
					[
						22.380526,
						42.32026
					],
					[
						21.91708,
						42.30364
					],
					[
						21.576636,
						42.245224
					],
					[
						21.54332,
						42.32025
					],
					[
						21.66292,
						42.43922
					],
					[
						21.77505,
						42.6827
					],
					[
						21.63302,
						42.67717
					],
					[
						21.43866,
						42.86255
					],
					[
						21.27421,
						42.90959
					],
					[
						21.143395,
						43.068685
					],
					[
						20.95651,
						43.13094
					],
					[
						20.81448,
						43.27205
					],
					[
						20.63508,
						43.21671
					],
					[
						20.49679,
						42.88469
					],
					[
						20.25758,
						42.81275
					],
					[
						20.3398,
						42.89852
					],
					[
						19.95857,
						43.10604
					],
					[
						19.63,
						43.21378
					],
					[
						19.48389,
						43.35229
					],
					[
						19.21852,
						43.52384
					],
					[
						19.454,
						43.5681
					],
					[
						19.59976,
						44.03847
					],
					[
						19.11761,
						44.42307
					],
					[
						19.36803,
						44.863
					],
					[
						19.00548,
						44.86023
					],
					[
						19.390476,
						45.236516
					],
					[
						19.072769,
						45.521511
					],
					[
						18.82982,
						45.90888
					],
					[
						19.596045,
						46.17173
					],
					[
						20.220192,
						46.127469
					],
					[
						20.762175,
						45.734573
					],
					[
						20.874313,
						45.416375
					]
				],
				[
					[
						20.76216,
						42.05186
					],
					[
						20.71731,
						41.84711
					],
					[
						20.59023,
						41.85541
					],
					[
						20.52295,
						42.21787
					],
					[
						20.28374,
						42.32025
					],
					[
						20.0707,
						42.58863
					],
					[
						20.25758,
						42.81275
					],
					[
						20.49679,
						42.88469
					],
					[
						20.63508,
						43.21671
					],
					[
						20.81448,
						43.27205
					],
					[
						20.95651,
						43.13094
					],
					[
						21.143395,
						43.068685
					],
					[
						21.27421,
						42.90959
					],
					[
						21.43866,
						42.86255
					],
					[
						21.63302,
						42.67717
					],
					[
						21.77505,
						42.6827
					],
					[
						21.66292,
						42.43922
					],
					[
						21.54332,
						42.32025
					],
					[
						21.576636,
						42.245224
					],
					[
						21.3527,
						42.2068
					],
					[
						20.76216,
						42.05186
					]
				]
			]
		},
		id: "SRB",
		id2: "RS",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							55.54,
							-4.76
						],
						[
							55.38,
							-4.63
						],
						[
							55.46,
							-4.55
						],
						[
							55.54,
							-4.76
						]
					]
				]
			]
		},
		properties: {
			name: "Seychelles"
		},
		id2: "SC",
		id: "SYC",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Sierra Leone"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-11.438779,
						6.785917
					],
					[
						-11.708195,
						6.860098
					],
					[
						-12.428099,
						7.262942
					],
					[
						-12.949049,
						7.798646
					],
					[
						-13.124025,
						8.163946
					],
					[
						-13.24655,
						8.903049
					],
					[
						-12.711958,
						9.342712
					],
					[
						-12.596719,
						9.620188
					],
					[
						-12.425929,
						9.835834
					],
					[
						-12.150338,
						9.858572
					],
					[
						-11.917277,
						10.046984
					],
					[
						-11.117481,
						10.045873
					],
					[
						-10.839152,
						9.688246
					],
					[
						-10.622395,
						9.26791
					],
					[
						-10.65477,
						8.977178
					],
					[
						-10.494315,
						8.715541
					],
					[
						-10.505477,
						8.348896
					],
					[
						-10.230094,
						8.406206
					],
					[
						-10.695595,
						7.939464
					],
					[
						-11.146704,
						7.396706
					],
					[
						-11.199802,
						7.105846
					],
					[
						-11.438779,
						6.785917
					]
				]
			]
		},
		id: "SLE",
		id2: "SL",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Singapore"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						103.99,
						1.38
					],
					[
						103.64,
						1.32
					],
					[
						103.71,
						1.43
					],
					[
						103.99,
						1.38
					]
				]
			]
		},
		id: "SGP",
		id2: "SG",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Sint Maarten (Dutch part)"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-63.01,
						18.08
					],
					[
						-63.01,
						18.07
					],
					[
						-63.14,
						18.06
					],
					[
						-63.01,
						18.08
					]
				]
			]
		},
		id: "SXM",
		id2: "SX",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Slovakia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						18.853144,
						49.49623
					],
					[
						18.909575,
						49.435846
					],
					[
						19.320713,
						49.571574
					],
					[
						19.825023,
						49.217125
					],
					[
						20.415839,
						49.431453
					],
					[
						20.887955,
						49.328772
					],
					[
						21.607808,
						49.470107
					],
					[
						22.558138,
						49.085738
					],
					[
						22.280842,
						48.825392
					],
					[
						22.085608,
						48.422264
					],
					[
						21.872236,
						48.319971
					],
					[
						20.801294,
						48.623854
					],
					[
						20.473562,
						48.56285
					],
					[
						20.239054,
						48.327567
					],
					[
						19.769471,
						48.202691
					],
					[
						19.661364,
						48.266615
					],
					[
						19.174365,
						48.111379
					],
					[
						18.777025,
						48.081768
					],
					[
						18.696513,
						47.880954
					],
					[
						17.857133,
						47.758429
					],
					[
						17.488473,
						47.867466
					],
					[
						16.979667,
						48.123497
					],
					[
						16.879983,
						48.470013
					],
					[
						16.960288,
						48.596982
					],
					[
						17.101985,
						48.816969
					],
					[
						17.545007,
						48.800019
					],
					[
						17.886485,
						48.903475
					],
					[
						17.913512,
						48.996493
					],
					[
						18.104973,
						49.043983
					],
					[
						18.170498,
						49.271515
					],
					[
						18.399994,
						49.315001
					],
					[
						18.554971,
						49.495015
					],
					[
						18.853144,
						49.49623
					]
				]
			]
		},
		id: "SVK",
		id2: "SK",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Slovenia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						13.806475,
						46.509306
					],
					[
						14.632472,
						46.431817
					],
					[
						15.137092,
						46.658703
					],
					[
						16.011664,
						46.683611
					],
					[
						16.202298,
						46.852386
					],
					[
						16.370505,
						46.841327
					],
					[
						16.564808,
						46.503751
					],
					[
						15.768733,
						46.238108
					],
					[
						15.67153,
						45.834154
					],
					[
						15.323954,
						45.731783
					],
					[
						15.327675,
						45.452316
					],
					[
						14.935244,
						45.471695
					],
					[
						14.595109,
						45.634941
					],
					[
						14.411968,
						45.466166
					],
					[
						13.71506,
						45.500324
					],
					[
						13.93763,
						45.591016
					],
					[
						13.69811,
						46.016778
					],
					[
						13.806475,
						46.509306
					]
				]
			]
		},
		id: "SVN",
		id2: "SI",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Solomon Islands"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							162.119025,
							-10.482719
						],
						[
							162.398646,
							-10.826367
						],
						[
							161.700032,
							-10.820011
						],
						[
							161.319797,
							-10.204751
						],
						[
							161.917383,
							-10.446701
						],
						[
							162.119025,
							-10.482719
						]
					]
				],
				[
					[
						[
							160.852229,
							-9.872937
						],
						[
							160.462588,
							-9.89521
						],
						[
							159.849447,
							-9.794027
						],
						[
							159.640003,
							-9.63998
						],
						[
							159.702945,
							-9.24295
						],
						[
							160.362956,
							-9.400304
						],
						[
							160.688518,
							-9.610162
						],
						[
							160.852229,
							-9.872937
						]
					]
				],
				[
					[
						[
							161.679982,
							-9.599982
						],
						[
							161.529397,
							-9.784312
						],
						[
							160.788253,
							-8.917543
						],
						[
							160.579997,
							-8.320009
						],
						[
							160.920028,
							-8.320009
						],
						[
							161.280006,
							-9.120011
						],
						[
							161.679982,
							-9.599982
						]
					]
				],
				[
					[
						[
							159.875027,
							-8.33732
						],
						[
							159.917402,
							-8.53829
						],
						[
							159.133677,
							-8.114181
						],
						[
							158.586114,
							-7.754824
						],
						[
							158.21115,
							-7.421872
						],
						[
							158.359978,
							-7.320018
						],
						[
							158.820001,
							-7.560003
						],
						[
							159.640003,
							-8.020027
						],
						[
							159.875027,
							-8.33732
						]
					]
				],
				[
					[
						[
							157.538426,
							-7.34782
						],
						[
							157.33942,
							-7.404767
						],
						[
							156.90203,
							-7.176874
						],
						[
							156.491358,
							-6.765943
						],
						[
							156.542828,
							-6.599338
						],
						[
							157.14,
							-7.021638
						],
						[
							157.538426,
							-7.34782
						]
					]
				]
			]
		},
		id: "SLB",
		id2: "SB",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Somalia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						49.72862,
						11.5789
					],
					[
						50.25878,
						11.67957
					],
					[
						50.73202,
						12.0219
					],
					[
						51.1112,
						12.02464
					],
					[
						51.13387,
						11.74815
					],
					[
						51.04153,
						11.16651
					],
					[
						51.04531,
						10.6409
					],
					[
						50.83418,
						10.27972
					],
					[
						50.55239,
						9.19874
					],
					[
						50.07092,
						8.08173
					],
					[
						49.4527,
						6.80466
					],
					[
						48.59455,
						5.33911
					],
					[
						47.74079,
						4.2194
					],
					[
						46.56476,
						2.85529
					],
					[
						45.56399,
						2.04576
					],
					[
						44.06815,
						1.05283
					],
					[
						43.13597,
						0.2922
					],
					[
						42.04157,
						-0.91916
					],
					[
						41.81095,
						-1.44647
					],
					[
						41.58513,
						-1.68325
					],
					[
						40.993,
						-0.85829
					],
					[
						40.98105,
						2.78452
					],
					[
						41.855083,
						3.918912
					],
					[
						42.12861,
						4.23413
					],
					[
						42.76967,
						4.25259
					],
					[
						43.66087,
						4.95755
					],
					[
						44.9636,
						5.00162
					],
					[
						47.78942,
						8.003
					],
					[
						48.486736,
						8.837626
					],
					[
						48.93813,
						9.451749
					],
					[
						48.938233,
						9.9735
					],
					[
						48.938491,
						10.982327
					],
					[
						48.942005,
						11.394266
					],
					[
						48.948205,
						11.410617
					],
					[
						49.26776,
						11.43033
					],
					[
						49.72862,
						11.5789
					]
				],
				[
					[
						48.93813,
						9.451749
					],
					[
						48.486736,
						8.837626
					],
					[
						47.78942,
						8.003
					],
					[
						46.948328,
						7.996877
					],
					[
						43.67875,
						9.18358
					],
					[
						43.296975,
						9.540477
					],
					[
						42.92812,
						10.02194
					],
					[
						42.55876,
						10.57258
					],
					[
						42.776852,
						10.926879
					],
					[
						43.145305,
						11.46204
					],
					[
						43.47066,
						11.27771
					],
					[
						43.666668,
						10.864169
					],
					[
						44.117804,
						10.445538
					],
					[
						44.614259,
						10.442205
					],
					[
						45.556941,
						10.698029
					],
					[
						46.645401,
						10.816549
					],
					[
						47.525658,
						11.127228
					],
					[
						48.021596,
						11.193064
					],
					[
						48.378784,
						11.375482
					],
					[
						48.948206,
						11.410622
					],
					[
						48.942005,
						11.394266
					],
					[
						48.938491,
						10.982327
					],
					[
						48.938233,
						9.9735
					],
					[
						48.93813,
						9.451749
					]
				]
			]
		},
		id: "SOM",
		id2: "SO",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "South Africa"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						31.521001,
						-29.257387
					],
					[
						31.325561,
						-29.401978
					],
					[
						30.901763,
						-29.909957
					],
					[
						30.622813,
						-30.423776
					],
					[
						30.055716,
						-31.140269
					],
					[
						28.925553,
						-32.172041
					],
					[
						28.219756,
						-32.771953
					],
					[
						27.464608,
						-33.226964
					],
					[
						26.419452,
						-33.61495
					],
					[
						25.909664,
						-33.66704
					],
					[
						25.780628,
						-33.944646
					],
					[
						25.172862,
						-33.796851
					],
					[
						24.677853,
						-33.987176
					],
					[
						23.594043,
						-33.794474
					],
					[
						22.988189,
						-33.916431
					],
					[
						22.574157,
						-33.864083
					],
					[
						21.542799,
						-34.258839
					],
					[
						20.689053,
						-34.417175
					],
					[
						20.071261,
						-34.795137
					],
					[
						19.616405,
						-34.819166
					],
					[
						19.193278,
						-34.462599
					],
					[
						18.855315,
						-34.444306
					],
					[
						18.424643,
						-33.997873
					],
					[
						18.377411,
						-34.136521
					],
					[
						18.244499,
						-33.867752
					],
					[
						18.25008,
						-33.281431
					],
					[
						17.92519,
						-32.611291
					],
					[
						18.24791,
						-32.429131
					],
					[
						18.221762,
						-31.661633
					],
					[
						17.566918,
						-30.725721
					],
					[
						17.064416,
						-29.878641
					],
					[
						17.062918,
						-29.875954
					],
					[
						16.344977,
						-28.576705
					],
					[
						16.824017,
						-28.082162
					],
					[
						17.218929,
						-28.355943
					],
					[
						17.387497,
						-28.783514
					],
					[
						17.836152,
						-28.856378
					],
					[
						18.464899,
						-29.045462
					],
					[
						19.002127,
						-28.972443
					],
					[
						19.894734,
						-28.461105
					],
					[
						19.895768,
						-24.76779
					],
					[
						20.165726,
						-24.917962
					],
					[
						20.758609,
						-25.868136
					],
					[
						20.66647,
						-26.477453
					],
					[
						20.889609,
						-26.828543
					],
					[
						21.605896,
						-26.726534
					],
					[
						22.105969,
						-26.280256
					],
					[
						22.579532,
						-25.979448
					],
					[
						22.824271,
						-25.500459
					],
					[
						23.312097,
						-25.26869
					],
					[
						23.73357,
						-25.390129
					],
					[
						24.211267,
						-25.670216
					],
					[
						25.025171,
						-25.71967
					],
					[
						25.664666,
						-25.486816
					],
					[
						25.765849,
						-25.174845
					],
					[
						25.941652,
						-24.696373
					],
					[
						26.485753,
						-24.616327
					],
					[
						26.786407,
						-24.240691
					],
					[
						27.11941,
						-23.574323
					],
					[
						28.017236,
						-22.827754
					],
					[
						29.432188,
						-22.091313
					],
					[
						29.839037,
						-22.102216
					],
					[
						30.322883,
						-22.271612
					],
					[
						30.659865,
						-22.151567
					],
					[
						31.191409,
						-22.25151
					],
					[
						31.670398,
						-23.658969
					],
					[
						31.930589,
						-24.369417
					],
					[
						31.752408,
						-25.484284
					],
					[
						31.837778,
						-25.843332
					],
					[
						31.333158,
						-25.660191
					],
					[
						31.04408,
						-25.731452
					],
					[
						30.949667,
						-26.022649
					],
					[
						30.676609,
						-26.398078
					],
					[
						30.685962,
						-26.743845
					],
					[
						31.282773,
						-27.285879
					],
					[
						31.86806,
						-27.177927
					],
					[
						32.071665,
						-26.73382
					],
					[
						32.83012,
						-26.742192
					],
					[
						32.580265,
						-27.470158
					],
					[
						32.462133,
						-28.301011
					],
					[
						32.203389,
						-28.752405
					],
					[
						31.521001,
						-29.257387
					]
				],
				[
					[
						28.978263,
						-28.955597
					],
					[
						28.5417,
						-28.647502
					],
					[
						28.074338,
						-28.851469
					],
					[
						27.532511,
						-29.242711
					],
					[
						26.999262,
						-29.875954
					],
					[
						27.749397,
						-30.645106
					],
					[
						28.107205,
						-30.545732
					],
					[
						28.291069,
						-30.226217
					],
					[
						28.8484,
						-30.070051
					],
					[
						29.018415,
						-29.743766
					],
					[
						29.325166,
						-29.257387
					],
					[
						28.978263,
						-28.955597
					]
				]
			]
		},
		id: "ZAF",
		id2: "ZA",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-37.5,
							-54.01
						],
						[
							-35.78,
							-54.77
						],
						[
							-38.03,
							-54.05
						],
						[
							-37.5,
							-54.01
						]
					]
				]
			]
		},
		properties: {
			name: "South Georgia South Sandwich Islands"
		},
		id2: "GS",
		id: "SGS",
		continent: "AN",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "South Sudan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						33.963393,
						9.464285
					],
					[
						33.97498,
						8.68456
					],
					[
						33.8255,
						8.37916
					],
					[
						33.2948,
						8.35458
					],
					[
						32.95418,
						7.78497
					],
					[
						33.56829,
						7.71334
					],
					[
						34.0751,
						7.22595
					],
					[
						34.25032,
						6.82607
					],
					[
						34.70702,
						6.59422
					],
					[
						35.298007,
						5.506
					],
					[
						34.620196,
						4.847123
					],
					[
						34.005,
						4.249885
					],
					[
						33.39,
						3.79
					],
					[
						32.68642,
						3.79232
					],
					[
						31.88145,
						3.55827
					],
					[
						31.24556,
						3.7819
					],
					[
						30.83385,
						3.50917
					],
					[
						29.95349,
						4.1737
					],
					[
						29.715995,
						4.600805
					],
					[
						29.159078,
						4.389267
					],
					[
						28.696678,
						4.455077
					],
					[
						28.428994,
						4.287155
					],
					[
						27.979977,
						4.408413
					],
					[
						27.374226,
						5.233944
					],
					[
						27.213409,
						5.550953
					],
					[
						26.465909,
						5.946717
					],
					[
						26.213418,
						6.546603
					],
					[
						25.796648,
						6.979316
					],
					[
						25.124131,
						7.500085
					],
					[
						25.114932,
						7.825104
					],
					[
						24.567369,
						8.229188
					],
					[
						23.88698,
						8.61973
					],
					[
						24.194068,
						8.728696
					],
					[
						24.537415,
						8.917538
					],
					[
						24.794926,
						9.810241
					],
					[
						25.069604,
						10.27376
					],
					[
						25.790633,
						10.411099
					],
					[
						25.962307,
						10.136421
					],
					[
						26.477328,
						9.55273
					],
					[
						26.752006,
						9.466893
					],
					[
						27.112521,
						9.638567
					],
					[
						27.833551,
						9.604232
					],
					[
						27.97089,
						9.398224
					],
					[
						28.966597,
						9.398224
					],
					[
						29.000932,
						9.604232
					],
					[
						29.515953,
						9.793074
					],
					[
						29.618957,
						10.084919
					],
					[
						29.996639,
						10.290927
					],
					[
						30.837841,
						9.707237
					],
					[
						31.352862,
						9.810241
					],
					[
						31.850716,
						10.531271
					],
					[
						32.400072,
						11.080626
					],
					[
						32.314235,
						11.681484
					],
					[
						32.073892,
						11.97333
					],
					[
						32.67475,
						12.024832
					],
					[
						32.743419,
						12.248008
					],
					[
						33.206938,
						12.179338
					],
					[
						33.086766,
						11.441141
					],
					[
						33.206938,
						10.720112
					],
					[
						33.721959,
						10.325262
					],
					[
						33.842131,
						9.981915
					],
					[
						33.824963,
						9.484061
					],
					[
						33.963393,
						9.464285
					]
				]
			]
		},
		id: "SDS",
		id2: "SS",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Spain"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-9.034818,
						41.880571
					],
					[
						-8.984433,
						42.592775
					],
					[
						-9.392884,
						43.026625
					],
					[
						-7.97819,
						43.748338
					],
					[
						-6.754492,
						43.567909
					],
					[
						-5.411886,
						43.57424
					],
					[
						-4.347843,
						43.403449
					],
					[
						-3.517532,
						43.455901
					],
					[
						-1.901351,
						43.422802
					],
					[
						-1.502771,
						43.034014
					],
					[
						0.338047,
						42.579546
					],
					[
						0.701591,
						42.795734
					],
					[
						1.826793,
						42.343385
					],
					[
						2.985999,
						42.473015
					],
					[
						3.039484,
						41.89212
					],
					[
						2.091842,
						41.226089
					],
					[
						0.810525,
						41.014732
					],
					[
						0.721331,
						40.678318
					],
					[
						0.106692,
						40.123934
					],
					[
						-0.278711,
						39.309978
					],
					[
						0.111291,
						38.738514
					],
					[
						-0.467124,
						38.292366
					],
					[
						-0.683389,
						37.642354
					],
					[
						-1.438382,
						37.443064
					],
					[
						-2.146453,
						36.674144
					],
					[
						-3.415781,
						36.6589
					],
					[
						-4.368901,
						36.677839
					],
					[
						-4.995219,
						36.324708
					],
					[
						-5.37716,
						35.94685
					],
					[
						-5.866432,
						36.029817
					],
					[
						-6.236694,
						36.367677
					],
					[
						-6.520191,
						36.942913
					],
					[
						-7.453726,
						37.097788
					],
					[
						-7.537105,
						37.428904
					],
					[
						-7.166508,
						37.803894
					],
					[
						-7.029281,
						38.075764
					],
					[
						-7.374092,
						38.373059
					],
					[
						-7.098037,
						39.030073
					],
					[
						-7.498632,
						39.629571
					],
					[
						-7.066592,
						39.711892
					],
					[
						-7.026413,
						40.184524
					],
					[
						-6.86402,
						40.330872
					],
					[
						-6.851127,
						41.111083
					],
					[
						-6.389088,
						41.381815
					],
					[
						-6.668606,
						41.883387
					],
					[
						-7.251309,
						41.918346
					],
					[
						-7.422513,
						41.792075
					],
					[
						-8.013175,
						41.790886
					],
					[
						-8.263857,
						42.280469
					],
					[
						-8.671946,
						42.134689
					],
					[
						-9.034818,
						41.880571
					]
				]
			]
		},
		id: "ESP",
		id2: "ES",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Sri Lanka"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						81.787959,
						7.523055
					],
					[
						81.637322,
						6.481775
					],
					[
						81.21802,
						6.197141
					],
					[
						80.348357,
						5.96837
					],
					[
						79.872469,
						6.763463
					],
					[
						79.695167,
						8.200843
					],
					[
						80.147801,
						9.824078
					],
					[
						80.838818,
						9.268427
					],
					[
						81.304319,
						8.564206
					],
					[
						81.787959,
						7.523055
					]
				]
			]
		},
		id: "LKA",
		id2: "LK",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Sudan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						33.963393,
						9.464285
					],
					[
						33.824963,
						9.484061
					],
					[
						33.842131,
						9.981915
					],
					[
						33.721959,
						10.325262
					],
					[
						33.206938,
						10.720112
					],
					[
						33.086766,
						11.441141
					],
					[
						33.206938,
						12.179338
					],
					[
						32.743419,
						12.248008
					],
					[
						32.67475,
						12.024832
					],
					[
						32.073892,
						11.97333
					],
					[
						32.314235,
						11.681484
					],
					[
						32.400072,
						11.080626
					],
					[
						31.850716,
						10.531271
					],
					[
						31.352862,
						9.810241
					],
					[
						30.837841,
						9.707237
					],
					[
						29.996639,
						10.290927
					],
					[
						29.618957,
						10.084919
					],
					[
						29.515953,
						9.793074
					],
					[
						29.000932,
						9.604232
					],
					[
						28.966597,
						9.398224
					],
					[
						27.97089,
						9.398224
					],
					[
						27.833551,
						9.604232
					],
					[
						27.112521,
						9.638567
					],
					[
						26.752006,
						9.466893
					],
					[
						26.477328,
						9.55273
					],
					[
						25.962307,
						10.136421
					],
					[
						25.790633,
						10.411099
					],
					[
						25.069604,
						10.27376
					],
					[
						24.794926,
						9.810241
					],
					[
						24.537415,
						8.917538
					],
					[
						24.194068,
						8.728696
					],
					[
						23.88698,
						8.61973
					],
					[
						23.805813,
						8.666319
					],
					[
						23.459013,
						8.954286
					],
					[
						23.394779,
						9.265068
					],
					[
						23.55725,
						9.681218
					],
					[
						23.554304,
						10.089255
					],
					[
						22.977544,
						10.714463
					],
					[
						22.864165,
						11.142395
					],
					[
						22.87622,
						11.38461
					],
					[
						22.50869,
						11.67936
					],
					[
						22.49762,
						12.26024
					],
					[
						22.28801,
						12.64605
					],
					[
						21.93681,
						12.58818
					],
					[
						22.03759,
						12.95546
					],
					[
						22.29658,
						13.37232
					],
					[
						22.18329,
						13.78648
					],
					[
						22.51202,
						14.09318
					],
					[
						22.30351,
						14.32682
					],
					[
						22.56795,
						14.94429
					],
					[
						23.02459,
						15.68072
					],
					[
						23.88689,
						15.61084
					],
					[
						23.83766,
						19.58047
					],
					[
						23.85,
						20
					],
					[
						25,
						20.00304
					],
					[
						25,
						22
					],
					[
						29.02,
						22
					],
					[
						32.9,
						22
					],
					[
						36.86623,
						22
					],
					[
						37.18872,
						21.01885
					],
					[
						36.96941,
						20.83744
					],
					[
						37.1147,
						19.80796
					],
					[
						37.48179,
						18.61409
					],
					[
						37.86276,
						18.36786
					],
					[
						38.41009,
						17.998307
					],
					[
						37.904,
						17.42754
					],
					[
						37.16747,
						17.26314
					],
					[
						36.85253,
						16.95655
					],
					[
						36.75389,
						16.29186
					],
					[
						36.32322,
						14.82249
					],
					[
						36.42951,
						14.42211
					],
					[
						36.27022,
						13.56333
					],
					[
						35.86363,
						12.57828
					],
					[
						35.26049,
						12.08286
					],
					[
						34.83163,
						11.31896
					],
					[
						34.73115,
						10.91017
					],
					[
						34.25745,
						10.63009
					],
					[
						33.96162,
						9.58358
					],
					[
						33.963393,
						9.464285
					]
				]
			]
		},
		id: "SDN",
		id2: "SD",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Suriname"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-57.147436,
						5.97315
					],
					[
						-55.949318,
						5.772878
					],
					[
						-55.84178,
						5.953125
					],
					[
						-55.03325,
						6.025291
					],
					[
						-53.958045,
						5.756548
					],
					[
						-54.478633,
						4.896756
					],
					[
						-54.399542,
						4.212611
					],
					[
						-54.006931,
						3.620038
					],
					[
						-54.181726,
						3.18978
					],
					[
						-54.269705,
						2.732392
					],
					[
						-54.524754,
						2.311849
					],
					[
						-55.097587,
						2.523748
					],
					[
						-55.569755,
						2.421506
					],
					[
						-55.973322,
						2.510364
					],
					[
						-56.073342,
						2.220795
					],
					[
						-55.9056,
						2.021996
					],
					[
						-55.995698,
						1.817667
					],
					[
						-56.539386,
						1.899523
					],
					[
						-57.150098,
						2.768927
					],
					[
						-57.281433,
						3.333492
					],
					[
						-57.601569,
						3.334655
					],
					[
						-58.044694,
						4.060864
					],
					[
						-57.86021,
						4.576801
					],
					[
						-57.914289,
						4.812626
					],
					[
						-57.307246,
						5.073567
					],
					[
						-57.147436,
						5.97315
					]
				]
			]
		},
		id: "SUR",
		id2: "SR",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							24.72412,
							77.85385
						],
						[
							22.49032,
							77.44493
						],
						[
							20.72601,
							77.67704
						],
						[
							21.41611,
							77.93504
						],
						[
							20.8119,
							78.25463
						],
						[
							22.88426,
							78.45494
						],
						[
							23.28134,
							78.07954
						],
						[
							24.72412,
							77.85385
						]
					]
				],
				[
					[
						[
							18.25183,
							79.70175
						],
						[
							21.54383,
							78.95611
						],
						[
							19.02737,
							78.5626
						],
						[
							18.47172,
							77.82669
						],
						[
							17.59441,
							77.63796
						],
						[
							17.1182,
							76.80941
						],
						[
							15.91315,
							76.77045
						],
						[
							13.76259,
							77.38035
						],
						[
							14.66956,
							77.73565
						],
						[
							13.1706,
							78.02493
						],
						[
							11.22231,
							78.8693
						],
						[
							10.44453,
							79.65239
						],
						[
							13.17077,
							80.01046
						],
						[
							13.71852,
							79.66039
						],
						[
							15.14282,
							79.67431
						],
						[
							15.52255,
							80.01608
						],
						[
							16.99085,
							80.05086
						],
						[
							18.25183,
							79.70175
						]
					]
				],
				[
					[
						[
							25.447625,
							80.40734
						],
						[
							27.407506,
							80.056406
						],
						[
							25.924651,
							79.517834
						],
						[
							23.024466,
							79.400012
						],
						[
							20.075188,
							79.566823
						],
						[
							19.897266,
							79.842362
						],
						[
							18.462264,
							79.85988
						],
						[
							17.368015,
							80.318896
						],
						[
							20.455992,
							80.598156
						],
						[
							21.907945,
							80.357679
						],
						[
							22.919253,
							80.657144
						],
						[
							25.447625,
							80.40734
						]
					]
				]
			]
		},
		properties: {
			name: "Svalbard"
		},
		id2: "SJ",
		id: "SJM",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Sweden"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						22.183173,
						65.723741
					],
					[
						21.213517,
						65.026005
					],
					[
						21.369631,
						64.413588
					],
					[
						19.778876,
						63.609554
					],
					[
						17.847779,
						62.7494
					],
					[
						17.119555,
						61.341166
					],
					[
						17.831346,
						60.636583
					],
					[
						18.787722,
						60.081914
					],
					[
						17.869225,
						58.953766
					],
					[
						16.829185,
						58.719827
					],
					[
						16.44771,
						57.041118
					],
					[
						15.879786,
						56.104302
					],
					[
						14.666681,
						56.200885
					],
					[
						14.100721,
						55.407781
					],
					[
						12.942911,
						55.361737
					],
					[
						12.625101,
						56.30708
					],
					[
						11.787942,
						57.441817
					],
					[
						11.027369,
						58.856149
					],
					[
						11.468272,
						59.432393
					],
					[
						12.300366,
						60.117933
					],
					[
						12.631147,
						61.293572
					],
					[
						11.992064,
						61.800362
					],
					[
						11.930569,
						63.128318
					],
					[
						12.579935,
						64.066219
					],
					[
						13.571916,
						64.049114
					],
					[
						13.919905,
						64.445421
					],
					[
						13.55569,
						64.787028
					],
					[
						15.108411,
						66.193867
					],
					[
						16.108712,
						67.302456
					],
					[
						16.768879,
						68.013937
					],
					[
						17.729182,
						68.010552
					],
					[
						17.993868,
						68.567391
					],
					[
						19.87856,
						68.407194
					],
					[
						20.025269,
						69.065139
					],
					[
						20.645593,
						69.106247
					],
					[
						21.978535,
						68.616846
					],
					[
						23.539473,
						67.936009
					],
					[
						23.56588,
						66.396051
					],
					[
						23.903379,
						66.006927
					],
					[
						22.183173,
						65.723741
					]
				]
			]
		},
		id: "SWE",
		id2: "SE",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Switzerland"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						9.594226,
						47.525058
					],
					[
						9.632932,
						47.347601
					],
					[
						9.47997,
						47.10281
					],
					[
						9.932448,
						46.920728
					],
					[
						10.442701,
						46.893546
					],
					[
						10.363378,
						46.483571
					],
					[
						9.922837,
						46.314899
					],
					[
						9.182882,
						46.440215
					],
					[
						8.966306,
						46.036932
					],
					[
						8.489952,
						46.005151
					],
					[
						8.31663,
						46.163642
					],
					[
						7.755992,
						45.82449
					],
					[
						7.273851,
						45.776948
					],
					[
						6.843593,
						45.991147
					],
					[
						6.5001,
						46.429673
					],
					[
						6.022609,
						46.27299
					],
					[
						6.037389,
						46.725779
					],
					[
						6.768714,
						47.287708
					],
					[
						6.736571,
						47.541801
					],
					[
						7.192202,
						47.449766
					],
					[
						7.466759,
						47.620582
					],
					[
						8.317301,
						47.61358
					],
					[
						8.522612,
						47.830828
					],
					[
						9.594226,
						47.525058
					]
				]
			]
		},
		id: "CHE",
		id2: "CH",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Syria"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						38.792341,
						33.378686
					],
					[
						36.834062,
						32.312938
					],
					[
						35.719918,
						32.709192
					],
					[
						35.700798,
						32.716014
					],
					[
						35.836397,
						32.868123
					],
					[
						35.821101,
						33.277426
					],
					[
						36.06646,
						33.824912
					],
					[
						36.61175,
						34.201789
					],
					[
						36.448194,
						34.593935
					],
					[
						35.998403,
						34.644914
					],
					[
						35.905023,
						35.410009
					],
					[
						36.149763,
						35.821535
					],
					[
						36.41755,
						36.040617
					],
					[
						36.685389,
						36.259699
					],
					[
						36.739494,
						36.81752
					],
					[
						37.066761,
						36.623036
					],
					[
						38.167727,
						36.90121
					],
					[
						38.699891,
						36.712927
					],
					[
						39.52258,
						36.716054
					],
					[
						40.673259,
						37.091276
					],
					[
						41.212089,
						37.074352
					],
					[
						42.349591,
						37.229873
					],
					[
						41.837064,
						36.605854
					],
					[
						41.289707,
						36.358815
					],
					[
						41.383965,
						35.628317
					],
					[
						41.006159,
						34.419372
					],
					[
						38.792341,
						33.378686
					]
				]
			]
		},
		id: "SYR",
		id2: "SY",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Tajikistan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						71.014198,
						40.244366
					],
					[
						70.648019,
						39.935754
					],
					[
						69.55961,
						40.103211
					],
					[
						69.464887,
						39.526683
					],
					[
						70.549162,
						39.604198
					],
					[
						71.784694,
						39.279463
					],
					[
						73.675379,
						39.431237
					],
					[
						73.928852,
						38.505815
					],
					[
						74.257514,
						38.606507
					],
					[
						74.864816,
						38.378846
					],
					[
						74.829986,
						37.990007
					],
					[
						74.980002,
						37.41999
					],
					[
						73.948696,
						37.421566
					],
					[
						73.260056,
						37.495257
					],
					[
						72.63689,
						37.047558
					],
					[
						72.193041,
						36.948288
					],
					[
						71.844638,
						36.738171
					],
					[
						71.448693,
						37.065645
					],
					[
						71.541918,
						37.905774
					],
					[
						71.239404,
						37.953265
					],
					[
						71.348131,
						38.258905
					],
					[
						70.806821,
						38.486282
					],
					[
						70.376304,
						38.138396
					],
					[
						70.270574,
						37.735165
					],
					[
						70.116578,
						37.588223
					],
					[
						69.518785,
						37.608997
					],
					[
						69.196273,
						37.151144
					],
					[
						68.859446,
						37.344336
					],
					[
						68.135562,
						37.023115
					],
					[
						67.83,
						37.144994
					],
					[
						68.392033,
						38.157025
					],
					[
						68.176025,
						38.901553
					],
					[
						67.44222,
						39.140144
					],
					[
						67.701429,
						39.580478
					],
					[
						68.536416,
						39.533453
					],
					[
						69.011633,
						40.086158
					],
					[
						69.329495,
						40.727824
					],
					[
						70.666622,
						40.960213
					],
					[
						70.45816,
						40.496495
					],
					[
						70.601407,
						40.218527
					],
					[
						71.014198,
						40.244366
					]
				]
			]
		},
		id: "TJK",
		id2: "TJ",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "United Republic of Tanzania"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						33.903711,
						-0.95
					],
					[
						34.07262,
						-1.05982
					],
					[
						37.69869,
						-3.09699
					],
					[
						37.7669,
						-3.67712
					],
					[
						39.20222,
						-4.67677
					],
					[
						38.74054,
						-5.90895
					],
					[
						38.79977,
						-6.47566
					],
					[
						39.44,
						-6.84
					],
					[
						39.47,
						-7.1
					],
					[
						39.19469,
						-7.7039
					],
					[
						39.25203,
						-8.00781
					],
					[
						39.18652,
						-8.48551
					],
					[
						39.53574,
						-9.11237
					],
					[
						39.9496,
						-10.0984
					],
					[
						40.31659,
						-10.3171
					],
					[
						39.521,
						-10.89688
					],
					[
						38.427557,
						-11.285202
					],
					[
						37.82764,
						-11.26879
					],
					[
						37.47129,
						-11.56876
					],
					[
						36.775151,
						-11.594537
					],
					[
						36.514082,
						-11.720938
					],
					[
						35.312398,
						-11.439146
					],
					[
						34.559989,
						-11.52002
					],
					[
						34.28,
						-10.16
					],
					[
						33.940838,
						-9.693674
					],
					[
						33.73972,
						-9.41715
					],
					[
						32.759375,
						-9.230599
					],
					[
						32.191865,
						-8.930359
					],
					[
						31.556348,
						-8.762049
					],
					[
						31.157751,
						-8.594579
					],
					[
						30.74,
						-8.34
					],
					[
						30.2,
						-7.08
					],
					[
						29.62,
						-6.52
					],
					[
						29.419993,
						-5.939999
					],
					[
						29.519987,
						-5.419979
					],
					[
						29.339998,
						-4.499983
					],
					[
						29.753512,
						-4.452389
					],
					[
						30.11632,
						-4.09012
					],
					[
						30.50554,
						-3.56858
					],
					[
						30.75224,
						-3.35931
					],
					[
						30.74301,
						-3.03431
					],
					[
						30.52766,
						-2.80762
					],
					[
						30.46967,
						-2.41383
					],
					[
						30.758309,
						-2.28725
					],
					[
						30.816135,
						-1.698914
					],
					[
						30.419105,
						-1.134659
					],
					[
						30.76986,
						-1.01455
					],
					[
						31.86617,
						-1.02736
					],
					[
						33.903711,
						-0.95
					]
				]
			]
		},
		id: "TZA",
		id2: "TZ",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Thailand"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						102.584932,
						12.186595
					],
					[
						101.687158,
						12.64574
					],
					[
						100.83181,
						12.627085
					],
					[
						100.978467,
						13.412722
					],
					[
						100.097797,
						13.406856
					],
					[
						100.018733,
						12.307001
					],
					[
						99.478921,
						10.846367
					],
					[
						99.153772,
						9.963061
					],
					[
						99.222399,
						9.239255
					],
					[
						99.873832,
						9.207862
					],
					[
						100.279647,
						8.295153
					],
					[
						100.459274,
						7.429573
					],
					[
						101.017328,
						6.856869
					],
					[
						101.623079,
						6.740622
					],
					[
						102.141187,
						6.221636
					],
					[
						101.814282,
						5.810808
					],
					[
						101.154219,
						5.691384
					],
					[
						101.075516,
						6.204867
					],
					[
						100.259596,
						6.642825
					],
					[
						100.085757,
						6.464489
					],
					[
						99.690691,
						6.848213
					],
					[
						99.519642,
						7.343454
					],
					[
						98.988253,
						7.907993
					],
					[
						98.503786,
						8.382305
					],
					[
						98.339662,
						7.794512
					],
					[
						98.150009,
						8.350007
					],
					[
						98.25915,
						8.973923
					],
					[
						98.553551,
						9.93296
					],
					[
						99.038121,
						10.960546
					],
					[
						99.587286,
						11.892763
					],
					[
						99.196354,
						12.804748
					],
					[
						99.212012,
						13.269294
					],
					[
						99.097755,
						13.827503
					],
					[
						98.430819,
						14.622028
					],
					[
						98.192074,
						15.123703
					],
					[
						98.537376,
						15.308497
					],
					[
						98.903348,
						16.177824
					],
					[
						98.493761,
						16.837836
					],
					[
						97.859123,
						17.567946
					],
					[
						97.375896,
						18.445438
					],
					[
						97.797783,
						18.62708
					],
					[
						98.253724,
						19.708203
					],
					[
						98.959676,
						19.752981
					],
					[
						99.543309,
						20.186598
					],
					[
						100.115988,
						20.41785
					],
					[
						100.548881,
						20.109238
					],
					[
						100.606294,
						19.508344
					],
					[
						101.282015,
						19.462585
					],
					[
						101.035931,
						18.408928
					],
					[
						101.059548,
						17.512497
					],
					[
						102.113592,
						18.109102
					],
					[
						102.413005,
						17.932782
					],
					[
						102.998706,
						17.961695
					],
					[
						103.200192,
						18.309632
					],
					[
						103.956477,
						18.240954
					],
					[
						104.716947,
						17.428859
					],
					[
						104.779321,
						16.441865
					],
					[
						105.589039,
						15.570316
					],
					[
						105.544338,
						14.723934
					],
					[
						105.218777,
						14.273212
					],
					[
						104.281418,
						14.416743
					],
					[
						102.988422,
						14.225721
					],
					[
						102.348099,
						13.394247
					],
					[
						102.584932,
						12.186595
					]
				]
			]
		},
		id: "THA",
		id2: "TH",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "East Timor"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						124.968682,
						-8.89279
					],
					[
						125.086246,
						-8.656887
					],
					[
						125.947072,
						-8.432095
					],
					[
						126.644704,
						-8.398247
					],
					[
						126.957243,
						-8.273345
					],
					[
						127.335928,
						-8.397317
					],
					[
						126.967992,
						-8.668256
					],
					[
						125.925885,
						-9.106007
					],
					[
						125.08852,
						-9.393173
					],
					[
						125.07002,
						-9.089987
					],
					[
						124.968682,
						-8.89279
					]
				]
			]
		},
		id: "TLS",
		id2: "TL",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Togo"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						1.865241,
						6.142158
					],
					[
						1.060122,
						5.928837
					],
					[
						0.836931,
						6.279979
					],
					[
						0.570384,
						6.914359
					],
					[
						0.490957,
						7.411744
					],
					[
						0.712029,
						8.312465
					],
					[
						0.461192,
						8.677223
					],
					[
						0.365901,
						9.465004
					],
					[
						0.36758,
						10.191213
					],
					[
						-0.049785,
						10.706918
					],
					[
						0.023803,
						11.018682
					],
					[
						0.899563,
						10.997339
					],
					[
						0.772336,
						10.470808
					],
					[
						1.077795,
						10.175607
					],
					[
						1.425061,
						9.825395
					],
					[
						1.463043,
						9.334624
					],
					[
						1.664478,
						9.12859
					],
					[
						1.618951,
						6.832038
					],
					[
						1.865241,
						6.142158
					]
				]
			]
		},
		id: "TGO",
		id2: "TG",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-171.84,
							-9.21
						],
						[
							-171.86,
							-9.21
						],
						[
							-171.85,
							-9.17
						],
						[
							-171.84,
							-9.21
						]
					]
				]
			]
		},
		properties: {
			name: "Tokelau"
		},
		id2: "TK",
		id: "TKL",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-175.15,
							-21.18
						],
						[
							-175.36,
							-21.1
						],
						[
							-175.05,
							-21.14
						],
						[
							-175.15,
							-21.18
						]
					]
				]
			]
		},
		properties: {
			name: "Tonga"
		},
		id2: "TO",
		id: "TON",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Trinidad and Tobago"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-61.68,
						10.76
					],
					[
						-61.105,
						10.89
					],
					[
						-60.895,
						10.855
					],
					[
						-60.935,
						10.11
					],
					[
						-61.77,
						10
					],
					[
						-61.95,
						10.09
					],
					[
						-61.66,
						10.365
					],
					[
						-61.68,
						10.76
					]
				]
			]
		},
		id: "TTO",
		id2: "TT",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Tunisia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						9.48214,
						30.307556
					],
					[
						9.055603,
						32.102692
					],
					[
						8.439103,
						32.506285
					],
					[
						8.430473,
						32.748337
					],
					[
						7.612642,
						33.344115
					],
					[
						7.524482,
						34.097376
					],
					[
						8.140981,
						34.655146
					],
					[
						8.376368,
						35.479876
					],
					[
						8.217824,
						36.433177
					],
					[
						8.420964,
						36.946427
					],
					[
						9.509994,
						37.349994
					],
					[
						10.210002,
						37.230002
					],
					[
						10.18065,
						36.724038
					],
					[
						11.028867,
						37.092103
					],
					[
						11.100026,
						36.899996
					],
					[
						10.600005,
						36.41
					],
					[
						10.593287,
						35.947444
					],
					[
						10.939519,
						35.698984
					],
					[
						10.807847,
						34.833507
					],
					[
						10.149593,
						34.330773
					],
					[
						10.339659,
						33.785742
					],
					[
						10.856836,
						33.76874
					],
					[
						11.108501,
						33.293343
					],
					[
						11.488787,
						33.136996
					],
					[
						11.432253,
						32.368903
					],
					[
						10.94479,
						32.081815
					],
					[
						10.636901,
						31.761421
					],
					[
						9.950225,
						31.37607
					],
					[
						10.056575,
						30.961831
					],
					[
						9.970017,
						30.539325
					],
					[
						9.48214,
						30.307556
					]
				]
			]
		},
		id: "TUN",
		id2: "TN",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Turkey"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							36.913127,
							41.335358
						],
						[
							38.347665,
							40.948586
						],
						[
							39.512607,
							41.102763
						],
						[
							40.373433,
							41.013673
						],
						[
							41.554084,
							41.535656
						],
						[
							42.619549,
							41.583173
						],
						[
							43.582746,
							41.092143
						],
						[
							43.752658,
							40.740201
						],
						[
							43.656436,
							40.253564
						],
						[
							44.400009,
							40.005
						],
						[
							44.79399,
							39.713003
						],
						[
							44.109225,
							39.428136
						],
						[
							44.421403,
							38.281281
						],
						[
							44.225756,
							37.971584
						],
						[
							44.772699,
							37.170445
						],
						[
							44.293452,
							37.001514
						],
						[
							43.942259,
							37.256228
						],
						[
							42.779126,
							37.385264
						],
						[
							42.349591,
							37.229873
						],
						[
							41.212089,
							37.074352
						],
						[
							40.673259,
							37.091276
						],
						[
							39.52258,
							36.716054
						],
						[
							38.699891,
							36.712927
						],
						[
							38.167727,
							36.90121
						],
						[
							37.066761,
							36.623036
						],
						[
							36.739494,
							36.81752
						],
						[
							36.685389,
							36.259699
						],
						[
							36.41755,
							36.040617
						],
						[
							36.149763,
							35.821535
						],
						[
							35.782085,
							36.274995
						],
						[
							36.160822,
							36.650606
						],
						[
							35.550936,
							36.565443
						],
						[
							34.714553,
							36.795532
						],
						[
							34.026895,
							36.21996
						],
						[
							32.509158,
							36.107564
						],
						[
							31.699595,
							36.644275
						],
						[
							30.621625,
							36.677865
						],
						[
							30.391096,
							36.262981
						],
						[
							29.699976,
							36.144357
						],
						[
							28.732903,
							36.676831
						],
						[
							27.641187,
							36.658822
						],
						[
							27.048768,
							37.653361
						],
						[
							26.318218,
							38.208133
						],
						[
							26.8047,
							38.98576
						],
						[
							26.170785,
							39.463612
						],
						[
							27.28002,
							40.420014
						],
						[
							28.819978,
							40.460011
						],
						[
							29.240004,
							41.219991
						],
						[
							31.145934,
							41.087622
						],
						[
							32.347979,
							41.736264
						],
						[
							33.513283,
							42.01896
						],
						[
							35.167704,
							42.040225
						],
						[
							36.913127,
							41.335358
						]
					]
				],
				[
					[
						[
							27.192377,
							40.690566
						],
						[
							26.358009,
							40.151994
						],
						[
							26.043351,
							40.617754
						],
						[
							26.056942,
							40.824123
						],
						[
							26.294602,
							40.936261
						],
						[
							26.604196,
							41.562115
						],
						[
							26.117042,
							41.826905
						],
						[
							27.135739,
							42.141485
						],
						[
							27.99672,
							42.007359
						],
						[
							28.115525,
							41.622886
						],
						[
							28.988443,
							41.299934
						],
						[
							28.806438,
							41.054962
						],
						[
							27.619017,
							40.999823
						],
						[
							27.192377,
							40.690566
						]
					]
				]
			]
		},
		id: "TUR",
		id2: "TR",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Turkmenistan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						61.210817,
						35.650072
					],
					[
						61.123071,
						36.491597
					],
					[
						60.377638,
						36.527383
					],
					[
						59.234762,
						37.412988
					],
					[
						58.436154,
						37.522309
					],
					[
						57.330434,
						38.029229
					],
					[
						56.619366,
						38.121394
					],
					[
						56.180375,
						37.935127
					],
					[
						55.511578,
						37.964117
					],
					[
						54.800304,
						37.392421
					],
					[
						53.921598,
						37.198918
					],
					[
						53.735511,
						37.906136
					],
					[
						53.880929,
						38.952093
					],
					[
						53.101028,
						39.290574
					],
					[
						53.357808,
						39.975286
					],
					[
						52.693973,
						40.033629
					],
					[
						52.915251,
						40.876523
					],
					[
						53.858139,
						40.631034
					],
					[
						54.736845,
						40.951015
					],
					[
						54.008311,
						41.551211
					],
					[
						53.721713,
						42.123191
					],
					[
						52.91675,
						41.868117
					],
					[
						52.814689,
						41.135371
					],
					[
						52.50246,
						41.783316
					],
					[
						52.944293,
						42.116034
					],
					[
						54.079418,
						42.324109
					],
					[
						54.755345,
						42.043971
					],
					[
						55.455251,
						41.259859
					],
					[
						55.968191,
						41.308642
					],
					[
						57.096391,
						41.32231
					],
					[
						56.932215,
						41.826026
					],
					[
						57.78653,
						42.170553
					],
					[
						58.629011,
						42.751551
					],
					[
						59.976422,
						42.223082
					],
					[
						60.083341,
						41.425146
					],
					[
						60.465953,
						41.220327
					],
					[
						61.547179,
						41.26637
					],
					[
						61.882714,
						41.084857
					],
					[
						62.37426,
						40.053886
					],
					[
						63.518015,
						39.363257
					],
					[
						64.170223,
						38.892407
					],
					[
						65.215999,
						38.402695
					],
					[
						66.54615,
						37.974685
					],
					[
						66.518607,
						37.362784
					],
					[
						66.217385,
						37.39379
					],
					[
						65.745631,
						37.661164
					],
					[
						65.588948,
						37.305217
					],
					[
						64.746105,
						37.111818
					],
					[
						64.546479,
						36.312073
					],
					[
						63.982896,
						36.007957
					],
					[
						63.193538,
						35.857166
					],
					[
						62.984662,
						35.404041
					],
					[
						62.230651,
						35.270664
					],
					[
						61.210817,
						35.650072
					]
				]
			]
		},
		id: "TKM",
		id2: "TM",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-71.66,
							21.82
						],
						[
							-71.66,
							21.74
						],
						[
							-71.85,
							21.85
						],
						[
							-71.66,
							21.82
						]
					]
				],
				[
					[
						[
							-71.88,
							21.85
						],
						[
							-72.03,
							21.94
						],
						[
							-71.91,
							21.94
						],
						[
							-71.88,
							21.85
						]
					]
				]
			]
		},
		properties: {
			name: "Turks and Caicos Islands"
		},
		id2: "TC",
		id: "TCA",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							179.22,
							-8.55
						],
						[
							179.2,
							-8.46
						],
						[
							179.23,
							-8.5
						],
						[
							179.22,
							-8.55
						]
					]
				]
			]
		},
		properties: {
			name: "Tuvalu"
		},
		id2: "TV",
		id: "TUV",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Uganda"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						31.86617,
						-1.02736
					],
					[
						30.76986,
						-1.01455
					],
					[
						30.419105,
						-1.134659
					],
					[
						29.821519,
						-1.443322
					],
					[
						29.579466,
						-1.341313
					],
					[
						29.587838,
						-0.587406
					],
					[
						29.8195,
						-0.2053
					],
					[
						29.875779,
						0.59738
					],
					[
						30.086154,
						1.062313
					],
					[
						30.468508,
						1.583805
					],
					[
						30.85267,
						1.849396
					],
					[
						31.174149,
						2.204465
					],
					[
						30.77332,
						2.33989
					],
					[
						30.83385,
						3.50917
					],
					[
						31.24556,
						3.7819
					],
					[
						31.88145,
						3.55827
					],
					[
						32.68642,
						3.79232
					],
					[
						33.39,
						3.79
					],
					[
						34.005,
						4.249885
					],
					[
						34.47913,
						3.5556
					],
					[
						34.59607,
						3.05374
					],
					[
						35.03599,
						1.90584
					],
					[
						34.6721,
						1.17694
					],
					[
						34.18,
						0.515
					],
					[
						33.893569,
						0.109814
					],
					[
						33.903711,
						-0.95
					],
					[
						31.86617,
						-1.02736
					]
				]
			]
		},
		id: "UGA",
		id2: "UG",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Ukraine"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						31.785998,
						52.101678
					],
					[
						32.159412,
						52.061267
					],
					[
						32.412058,
						52.288695
					],
					[
						32.715761,
						52.238465
					],
					[
						33.7527,
						52.335075
					],
					[
						34.391731,
						51.768882
					],
					[
						34.141978,
						51.566413
					],
					[
						34.224816,
						51.255993
					],
					[
						35.022183,
						51.207572
					],
					[
						35.377924,
						50.773955
					],
					[
						35.356116,
						50.577197
					],
					[
						36.626168,
						50.225591
					],
					[
						37.39346,
						50.383953
					],
					[
						38.010631,
						49.915662
					],
					[
						38.594988,
						49.926462
					],
					[
						40.069058,
						49.601055
					],
					[
						40.080789,
						49.30743
					],
					[
						39.674664,
						48.783818
					],
					[
						39.895632,
						48.232405
					],
					[
						39.738278,
						47.898937
					],
					[
						38.770585,
						47.825608
					],
					[
						38.255112,
						47.5464
					],
					[
						38.223538,
						47.10219
					],
					[
						37.425137,
						47.022221
					],
					[
						36.759855,
						46.6987
					],
					[
						35.823685,
						46.645964
					],
					[
						34.962342,
						46.273197
					],
					[
						35.020788,
						45.651219
					],
					[
						35.510009,
						45.409993
					],
					[
						36.529998,
						45.46999
					],
					[
						36.334713,
						45.113216
					],
					[
						35.239999,
						44.939996
					],
					[
						33.882511,
						44.361479
					],
					[
						33.326421,
						44.564877
					],
					[
						33.546924,
						45.034771
					],
					[
						32.454174,
						45.327466
					],
					[
						32.630804,
						45.519186
					],
					[
						33.588162,
						45.851569
					],
					[
						33.298567,
						46.080598
					],
					[
						31.74414,
						46.333348
					],
					[
						31.675307,
						46.706245
					],
					[
						30.748749,
						46.5831
					],
					[
						30.377609,
						46.03241
					],
					[
						29.603289,
						45.293308
					],
					[
						29.149725,
						45.464925
					],
					[
						28.679779,
						45.304031
					],
					[
						28.233554,
						45.488283
					],
					[
						28.485269,
						45.596907
					],
					[
						28.659987,
						45.939987
					],
					[
						28.933717,
						46.25883
					],
					[
						28.862972,
						46.437889
					],
					[
						29.072107,
						46.517678
					],
					[
						29.170654,
						46.379262
					],
					[
						29.759972,
						46.349988
					],
					[
						30.024659,
						46.423937
					],
					[
						29.83821,
						46.525326
					],
					[
						29.908852,
						46.674361
					],
					[
						29.559674,
						46.928583
					],
					[
						29.415135,
						47.346645
					],
					[
						29.050868,
						47.510227
					],
					[
						29.122698,
						47.849095
					],
					[
						28.670891,
						48.118149
					],
					[
						28.259547,
						48.155562
					],
					[
						27.522537,
						48.467119
					],
					[
						26.857824,
						48.368211
					],
					[
						26.619337,
						48.220726
					],
					[
						26.19745,
						48.220881
					],
					[
						25.945941,
						47.987149
					],
					[
						25.207743,
						47.891056
					],
					[
						24.866317,
						47.737526
					],
					[
						24.402056,
						47.981878
					],
					[
						23.760958,
						47.985598
					],
					[
						23.142236,
						48.096341
					],
					[
						22.710531,
						47.882194
					],
					[
						22.64082,
						48.15024
					],
					[
						22.085608,
						48.422264
					],
					[
						22.280842,
						48.825392
					],
					[
						22.558138,
						49.085738
					],
					[
						22.776419,
						49.027395
					],
					[
						22.51845,
						49.476774
					],
					[
						23.426508,
						50.308506
					],
					[
						23.922757,
						50.424881
					],
					[
						24.029986,
						50.705407
					],
					[
						23.527071,
						51.578454
					],
					[
						24.005078,
						51.617444
					],
					[
						24.553106,
						51.888461
					],
					[
						25.327788,
						51.910656
					],
					[
						26.337959,
						51.832289
					],
					[
						27.454066,
						51.592303
					],
					[
						28.241615,
						51.572227
					],
					[
						28.617613,
						51.427714
					],
					[
						28.992835,
						51.602044
					],
					[
						29.254938,
						51.368234
					],
					[
						30.157364,
						51.416138
					],
					[
						30.555117,
						51.319503
					],
					[
						30.619454,
						51.822806
					],
					[
						30.927549,
						52.042353
					],
					[
						31.785998,
						52.101678
					]
				]
			]
		},
		id: "UKR",
		id2: "UA",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "United Arab Emirates"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						51.579519,
						24.245497
					],
					[
						51.757441,
						24.294073
					],
					[
						51.794389,
						24.019826
					],
					[
						52.577081,
						24.177439
					],
					[
						53.404007,
						24.151317
					],
					[
						54.008001,
						24.121758
					],
					[
						54.693024,
						24.797892
					],
					[
						55.439025,
						25.439145
					],
					[
						56.070821,
						26.055464
					],
					[
						56.261042,
						25.714606
					],
					[
						56.396847,
						24.924732
					],
					[
						55.886233,
						24.920831
					],
					[
						55.804119,
						24.269604
					],
					[
						55.981214,
						24.130543
					],
					[
						55.528632,
						23.933604
					],
					[
						55.525841,
						23.524869
					],
					[
						55.234489,
						23.110993
					],
					[
						55.208341,
						22.70833
					],
					[
						55.006803,
						22.496948
					],
					[
						52.000733,
						23.001154
					],
					[
						51.617708,
						24.014219
					],
					[
						51.579519,
						24.245497
					]
				]
			]
		},
		id: "ARE",
		id2: "AE",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "England"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-5.661949,
							54.554603
						],
						[
							-6.197885,
							53.867565
						],
						[
							-6.95373,
							54.073702
						],
						[
							-7.572168,
							54.059956
						],
						[
							-7.366031,
							54.595841
						],
						[
							-7.572168,
							55.131622
						],
						[
							-6.733847,
							55.17286
						],
						[
							-5.661949,
							54.554603
						]
					]
				],
				[
					[
						[
							-3.005005,
							58.635
						],
						[
							-4.073828,
							57.553025
						],
						[
							-3.055002,
							57.690019
						],
						[
							-1.959281,
							57.6848
						],
						[
							-2.219988,
							56.870017
						],
						[
							-3.119003,
							55.973793
						],
						[
							-2.085009,
							55.909998
						],
						[
							-2.005676,
							55.804903
						],
						[
							-1.114991,
							54.624986
						],
						[
							-0.430485,
							54.464376
						],
						[
							0.184981,
							53.325014
						],
						[
							0.469977,
							52.929999
						],
						[
							1.681531,
							52.73952
						],
						[
							1.559988,
							52.099998
						],
						[
							1.050562,
							51.806761
						],
						[
							1.449865,
							51.289428
						],
						[
							0.550334,
							50.765739
						],
						[
							-0.787517,
							50.774989
						],
						[
							-2.489998,
							50.500019
						],
						[
							-2.956274,
							50.69688
						],
						[
							-3.617448,
							50.228356
						],
						[
							-4.542508,
							50.341837
						],
						[
							-5.245023,
							49.96
						],
						[
							-5.776567,
							50.159678
						],
						[
							-4.30999,
							51.210001
						],
						[
							-3.414851,
							51.426009
						],
						[
							-3.422719,
							51.426848
						],
						[
							-4.984367,
							51.593466
						],
						[
							-5.267296,
							51.9914
						],
						[
							-4.222347,
							52.301356
						],
						[
							-4.770013,
							52.840005
						],
						[
							-4.579999,
							53.495004
						],
						[
							-3.093831,
							53.404547
						],
						[
							-3.09208,
							53.404441
						],
						[
							-2.945009,
							53.985
						],
						[
							-3.614701,
							54.600937
						],
						[
							-3.630005,
							54.615013
						],
						[
							-4.844169,
							54.790971
						],
						[
							-5.082527,
							55.061601
						],
						[
							-4.719112,
							55.508473
						],
						[
							-5.047981,
							55.783986
						],
						[
							-5.586398,
							55.311146
						],
						[
							-5.644999,
							56.275015
						],
						[
							-6.149981,
							56.78501
						],
						[
							-5.786825,
							57.818848
						],
						[
							-5.009999,
							58.630013
						],
						[
							-4.211495,
							58.550845
						],
						[
							-3.005005,
							58.635
						]
					]
				]
			]
		},
		id: "GBR",
		id2: "GB",
		continent: "EU",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "United States Minor Outlying Islands"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						166.647,
						19.2823
					],
					[
						166.647,
						19.2923
					],
					[
						166.657,
						19.2923
					],
					[
						166.657,
						19.2823
					],
					[
						166.647,
						19.2823
					]
				]
			]
		},
		id: "UMI",
		id2: "UM",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "United States of America"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-155.54211,
							19.08348
						],
						[
							-155.68817,
							18.91619
						],
						[
							-155.93665,
							19.05939
						],
						[
							-155.90806,
							19.33888
						],
						[
							-156.07347,
							19.70294
						],
						[
							-156.02368,
							19.81422
						],
						[
							-155.85008,
							19.97729
						],
						[
							-155.91907,
							20.17395
						],
						[
							-155.86108,
							20.26721
						],
						[
							-155.78505,
							20.2487
						],
						[
							-155.40214,
							20.07975
						],
						[
							-155.22452,
							19.99302
						],
						[
							-155.06226,
							19.8591
						],
						[
							-154.80741,
							19.50871
						],
						[
							-154.83147,
							19.45328
						],
						[
							-155.22217,
							19.23972
						],
						[
							-155.54211,
							19.08348
						]
					]
				],
				[
					[
						[
							-156.07926,
							20.64397
						],
						[
							-156.41445,
							20.57241
						],
						[
							-156.58673,
							20.783
						],
						[
							-156.70167,
							20.8643
						],
						[
							-156.71055,
							20.92676
						],
						[
							-156.61258,
							21.01249
						],
						[
							-156.25711,
							20.91745
						],
						[
							-155.99566,
							20.76404
						],
						[
							-156.07926,
							20.64397
						]
					]
				],
				[
					[
						[
							-156.75824,
							21.17684
						],
						[
							-156.78933,
							21.06873
						],
						[
							-157.32521,
							21.09777
						],
						[
							-157.25027,
							21.21958
						],
						[
							-156.75824,
							21.17684
						]
					]
				],
				[
					[
						[
							-157.65283,
							21.32217
						],
						[
							-157.70703,
							21.26442
						],
						[
							-157.7786,
							21.27729
						],
						[
							-158.12667,
							21.31244
						],
						[
							-158.2538,
							21.53919
						],
						[
							-158.29265,
							21.57912
						],
						[
							-158.0252,
							21.71696
						],
						[
							-157.94161,
							21.65272
						],
						[
							-157.65283,
							21.32217
						]
					]
				],
				[
					[
						[
							-159.34512,
							21.982
						],
						[
							-159.46372,
							21.88299
						],
						[
							-159.80051,
							22.06533
						],
						[
							-159.74877,
							22.1382
						],
						[
							-159.5962,
							22.23618
						],
						[
							-159.36569,
							22.21494
						],
						[
							-159.34512,
							21.982
						]
					]
				],
				[
					[
						[
							-94.81758,
							49.38905
						],
						[
							-94.64,
							48.84
						],
						[
							-94.32914,
							48.67074
						],
						[
							-93.63087,
							48.60926
						],
						[
							-92.61,
							48.45
						],
						[
							-91.64,
							48.14
						],
						[
							-90.83,
							48.27
						],
						[
							-89.6,
							48.01
						],
						[
							-89.272917,
							48.019808
						],
						[
							-88.378114,
							48.302918
						],
						[
							-87.439793,
							47.94
						],
						[
							-86.461991,
							47.553338
						],
						[
							-85.652363,
							47.220219
						],
						[
							-84.87608,
							46.900083
						],
						[
							-84.779238,
							46.637102
						],
						[
							-84.543749,
							46.538684
						],
						[
							-84.6049,
							46.4396
						],
						[
							-84.3367,
							46.40877
						],
						[
							-84.14212,
							46.512226
						],
						[
							-84.091851,
							46.275419
						],
						[
							-83.890765,
							46.116927
						],
						[
							-83.616131,
							46.116927
						],
						[
							-83.469551,
							45.994686
						],
						[
							-83.592851,
							45.816894
						],
						[
							-82.550925,
							45.347517
						],
						[
							-82.337763,
							44.44
						],
						[
							-82.137642,
							43.571088
						],
						[
							-82.43,
							42.98
						],
						[
							-82.9,
							42.43
						],
						[
							-83.12,
							42.08
						],
						[
							-83.142,
							41.975681
						],
						[
							-83.02981,
							41.832796
						],
						[
							-82.690089,
							41.675105
						],
						[
							-82.439278,
							41.675105
						],
						[
							-81.277747,
							42.209026
						],
						[
							-80.247448,
							42.3662
						],
						[
							-78.939362,
							42.863611
						],
						[
							-78.92,
							42.965
						],
						[
							-79.01,
							43.27
						],
						[
							-79.171674,
							43.466339
						],
						[
							-78.72028,
							43.625089
						],
						[
							-77.737885,
							43.629056
						],
						[
							-76.820034,
							43.628784
						],
						[
							-76.5,
							44.018459
						],
						[
							-76.375,
							44.09631
						],
						[
							-75.31821,
							44.81645
						],
						[
							-74.867,
							45.00048
						],
						[
							-73.34783,
							45.00738
						],
						[
							-71.50506,
							45.0082
						],
						[
							-71.405,
							45.255
						],
						[
							-71.08482,
							45.30524
						],
						[
							-70.66,
							45.46
						],
						[
							-70.305,
							45.915
						],
						[
							-69.99997,
							46.69307
						],
						[
							-69.237216,
							47.447781
						],
						[
							-68.905,
							47.185
						],
						[
							-68.23444,
							47.35486
						],
						[
							-67.79046,
							47.06636
						],
						[
							-67.79134,
							45.70281
						],
						[
							-67.13741,
							45.13753
						],
						[
							-66.96466,
							44.8097
						],
						[
							-68.03252,
							44.3252
						],
						[
							-69.06,
							43.98
						],
						[
							-70.11617,
							43.68405
						],
						[
							-70.645476,
							43.090238
						],
						[
							-70.81489,
							42.8653
						],
						[
							-70.825,
							42.335
						],
						[
							-70.495,
							41.805
						],
						[
							-70.08,
							41.78
						],
						[
							-70.185,
							42.145
						],
						[
							-69.88497,
							41.92283
						],
						[
							-69.96503,
							41.63717
						],
						[
							-70.64,
							41.475
						],
						[
							-71.12039,
							41.49445
						],
						[
							-71.86,
							41.32
						],
						[
							-72.295,
							41.27
						],
						[
							-72.87643,
							41.22065
						],
						[
							-73.71,
							40.931102
						],
						[
							-72.24126,
							41.11948
						],
						[
							-71.945,
							40.93
						],
						[
							-73.345,
							40.63
						],
						[
							-73.982,
							40.628
						],
						[
							-73.952325,
							40.75075
						],
						[
							-74.25671,
							40.47351
						],
						[
							-73.96244,
							40.42763
						],
						[
							-74.17838,
							39.70926
						],
						[
							-74.90604,
							38.93954
						],
						[
							-74.98041,
							39.1964
						],
						[
							-75.20002,
							39.24845
						],
						[
							-75.52805,
							39.4985
						],
						[
							-75.32,
							38.96
						],
						[
							-75.071835,
							38.782032
						],
						[
							-75.05673,
							38.40412
						],
						[
							-75.37747,
							38.01551
						],
						[
							-75.94023,
							37.21689
						],
						[
							-76.03127,
							37.2566
						],
						[
							-75.72205,
							37.93705
						],
						[
							-76.23287,
							38.319215
						],
						[
							-76.35,
							39.15
						],
						[
							-76.542725,
							38.717615
						],
						[
							-76.32933,
							38.08326
						],
						[
							-76.989998,
							38.239992
						],
						[
							-76.30162,
							37.917945
						],
						[
							-76.25874,
							36.9664
						],
						[
							-75.9718,
							36.89726
						],
						[
							-75.86804,
							36.55125
						],
						[
							-75.72749,
							35.55074
						],
						[
							-76.36318,
							34.80854
						],
						[
							-77.397635,
							34.51201
						],
						[
							-78.05496,
							33.92547
						],
						[
							-78.55435,
							33.86133
						],
						[
							-79.06067,
							33.49395
						],
						[
							-79.20357,
							33.15839
						],
						[
							-80.301325,
							32.509355
						],
						[
							-80.86498,
							32.0333
						],
						[
							-81.33629,
							31.44049
						],
						[
							-81.49042,
							30.72999
						],
						[
							-81.31371,
							30.03552
						],
						[
							-80.98,
							29.18
						],
						[
							-80.535585,
							28.47213
						],
						[
							-80.53,
							28.04
						],
						[
							-80.056539,
							26.88
						],
						[
							-80.088015,
							26.205765
						],
						[
							-80.13156,
							25.816775
						],
						[
							-80.38103,
							25.20616
						],
						[
							-80.68,
							25.08
						],
						[
							-81.17213,
							25.20126
						],
						[
							-81.33,
							25.64
						],
						[
							-81.71,
							25.87
						],
						[
							-82.24,
							26.73
						],
						[
							-82.70515,
							27.49504
						],
						[
							-82.85526,
							27.88624
						],
						[
							-82.65,
							28.55
						],
						[
							-82.93,
							29.1
						],
						[
							-83.70959,
							29.93656
						],
						[
							-84.1,
							30.09
						],
						[
							-85.10882,
							29.63615
						],
						[
							-85.28784,
							29.68612
						],
						[
							-85.7731,
							30.15261
						],
						[
							-86.4,
							30.4
						],
						[
							-87.53036,
							30.27433
						],
						[
							-88.41782,
							30.3849
						],
						[
							-89.18049,
							30.31598
						],
						[
							-89.593831,
							30.159994
						],
						[
							-89.413735,
							29.89419
						],
						[
							-89.43,
							29.48864
						],
						[
							-89.21767,
							29.29108
						],
						[
							-89.40823,
							29.15961
						],
						[
							-89.77928,
							29.30714
						],
						[
							-90.15463,
							29.11743
						],
						[
							-90.880225,
							29.148535
						],
						[
							-91.626785,
							29.677
						],
						[
							-92.49906,
							29.5523
						],
						[
							-93.22637,
							29.78375
						],
						[
							-93.84842,
							29.71363
						],
						[
							-94.69,
							29.48
						],
						[
							-95.60026,
							28.73863
						],
						[
							-96.59404,
							28.30748
						],
						[
							-97.14,
							27.83
						],
						[
							-97.37,
							27.38
						],
						[
							-97.38,
							26.69
						],
						[
							-97.33,
							26.21
						],
						[
							-97.14,
							25.87
						],
						[
							-97.53,
							25.84
						],
						[
							-98.24,
							26.06
						],
						[
							-99.02,
							26.37
						],
						[
							-99.3,
							26.84
						],
						[
							-99.52,
							27.54
						],
						[
							-100.11,
							28.11
						],
						[
							-100.45584,
							28.69612
						],
						[
							-100.9576,
							29.38071
						],
						[
							-101.6624,
							29.7793
						],
						[
							-102.48,
							29.76
						],
						[
							-103.11,
							28.97
						],
						[
							-103.94,
							29.27
						],
						[
							-104.45697,
							29.57196
						],
						[
							-104.70575,
							30.12173
						],
						[
							-105.03737,
							30.64402
						],
						[
							-105.63159,
							31.08383
						],
						[
							-106.1429,
							31.39995
						],
						[
							-106.50759,
							31.75452
						],
						[
							-108.24,
							31.754854
						],
						[
							-108.24194,
							31.34222
						],
						[
							-109.035,
							31.34194
						],
						[
							-111.02361,
							31.33472
						],
						[
							-113.30498,
							32.03914
						],
						[
							-114.815,
							32.52528
						],
						[
							-114.72139,
							32.72083
						],
						[
							-115.99135,
							32.61239
						],
						[
							-117.12776,
							32.53534
						],
						[
							-117.295938,
							33.046225
						],
						[
							-117.944,
							33.621236
						],
						[
							-118.410602,
							33.740909
						],
						[
							-118.519895,
							34.027782
						],
						[
							-119.081,
							34.078
						],
						[
							-119.438841,
							34.348477
						],
						[
							-120.36778,
							34.44711
						],
						[
							-120.62286,
							34.60855
						],
						[
							-120.74433,
							35.15686
						],
						[
							-121.71457,
							36.16153
						],
						[
							-122.54747,
							37.55176
						],
						[
							-122.51201,
							37.78339
						],
						[
							-122.95319,
							38.11371
						],
						[
							-123.7272,
							38.95166
						],
						[
							-123.86517,
							39.76699
						],
						[
							-124.39807,
							40.3132
						],
						[
							-124.17886,
							41.14202
						],
						[
							-124.2137,
							41.99964
						],
						[
							-124.53284,
							42.76599
						],
						[
							-124.14214,
							43.70838
						],
						[
							-124.020535,
							44.615895
						],
						[
							-123.89893,
							45.52341
						],
						[
							-124.079635,
							46.86475
						],
						[
							-124.39567,
							47.72017
						],
						[
							-124.68721,
							48.184433
						],
						[
							-124.566101,
							48.379715
						],
						[
							-123.12,
							48.04
						],
						[
							-122.58736,
							47.096
						],
						[
							-122.34,
							47.36
						],
						[
							-122.5,
							48.18
						],
						[
							-122.84,
							49
						],
						[
							-120,
							49
						],
						[
							-117.03121,
							49
						],
						[
							-116.04818,
							49
						],
						[
							-113,
							49
						],
						[
							-110.05,
							49
						],
						[
							-107.05,
							49
						],
						[
							-104.04826,
							48.99986
						],
						[
							-100.65,
							49
						],
						[
							-97.22872,
							49.0007
						],
						[
							-95.15907,
							49
						],
						[
							-95.15609,
							49.38425
						],
						[
							-94.81758,
							49.38905
						]
					]
				],
				[
					[
						[
							-153.006314,
							57.115842
						],
						[
							-154.00509,
							56.734677
						],
						[
							-154.516403,
							56.992749
						],
						[
							-154.670993,
							57.461196
						],
						[
							-153.76278,
							57.816575
						],
						[
							-153.228729,
							57.968968
						],
						[
							-152.564791,
							57.901427
						],
						[
							-152.141147,
							57.591059
						],
						[
							-153.006314,
							57.115842
						]
					]
				],
				[
					[
						[
							-165.579164,
							59.909987
						],
						[
							-166.19277,
							59.754441
						],
						[
							-166.848337,
							59.941406
						],
						[
							-167.455277,
							60.213069
						],
						[
							-166.467792,
							60.38417
						],
						[
							-165.67443,
							60.293607
						],
						[
							-165.579164,
							59.909987
						]
					]
				],
				[
					[
						[
							-171.731657,
							63.782515
						],
						[
							-171.114434,
							63.592191
						],
						[
							-170.491112,
							63.694975
						],
						[
							-169.682505,
							63.431116
						],
						[
							-168.689439,
							63.297506
						],
						[
							-168.771941,
							63.188598
						],
						[
							-169.52944,
							62.976931
						],
						[
							-170.290556,
							63.194438
						],
						[
							-170.671386,
							63.375822
						],
						[
							-171.553063,
							63.317789
						],
						[
							-171.791111,
							63.405846
						],
						[
							-171.731657,
							63.782515
						]
					]
				],
				[
					[
						[
							-155.06779,
							71.147776
						],
						[
							-154.344165,
							70.696409
						],
						[
							-153.900006,
							70.889989
						],
						[
							-152.210006,
							70.829992
						],
						[
							-152.270002,
							70.600006
						],
						[
							-150.739992,
							70.430017
						],
						[
							-149.720003,
							70.53001
						],
						[
							-147.613362,
							70.214035
						],
						[
							-145.68999,
							70.12001
						],
						[
							-144.920011,
							69.989992
						],
						[
							-143.589446,
							70.152514
						],
						[
							-142.07251,
							69.851938
						],
						[
							-140.985988,
							69.711998
						],
						[
							-140.985988,
							69.711998
						],
						[
							-140.992499,
							66.000029
						],
						[
							-140.99777,
							60.306397
						],
						[
							-140.012998,
							60.276838
						],
						[
							-139.039,
							60.000007
						],
						[
							-138.34089,
							59.56211
						],
						[
							-137.4525,
							58.905
						],
						[
							-136.47972,
							59.46389
						],
						[
							-135.47583,
							59.78778
						],
						[
							-134.945,
							59.27056
						],
						[
							-134.27111,
							58.86111
						],
						[
							-133.355549,
							58.410285
						],
						[
							-132.73042,
							57.69289
						],
						[
							-131.70781,
							56.55212
						],
						[
							-130.00778,
							55.91583
						],
						[
							-129.979994,
							55.284998
						],
						[
							-130.53611,
							54.802753
						],
						[
							-131.085818,
							55.178906
						],
						[
							-131.967211,
							55.497776
						],
						[
							-132.250011,
							56.369996
						],
						[
							-133.539181,
							57.178887
						],
						[
							-134.078063,
							58.123068
						],
						[
							-135.038211,
							58.187715
						],
						[
							-136.628062,
							58.212209
						],
						[
							-137.800006,
							58.499995
						],
						[
							-139.867787,
							59.537762
						],
						[
							-140.825274,
							59.727517
						],
						[
							-142.574444,
							60.084447
						],
						[
							-143.958881,
							59.99918
						],
						[
							-145.925557,
							60.45861
						],
						[
							-147.114374,
							60.884656
						],
						[
							-148.224306,
							60.672989
						],
						[
							-148.018066,
							59.978329
						],
						[
							-148.570823,
							59.914173
						],
						[
							-149.727858,
							59.705658
						],
						[
							-150.608243,
							59.368211
						],
						[
							-151.716393,
							59.155821
						],
						[
							-151.859433,
							59.744984
						],
						[
							-151.409719,
							60.725803
						],
						[
							-150.346941,
							61.033588
						],
						[
							-150.621111,
							61.284425
						],
						[
							-151.895839,
							60.727198
						],
						[
							-152.57833,
							60.061657
						],
						[
							-154.019172,
							59.350279
						],
						[
							-153.287511,
							58.864728
						],
						[
							-154.232492,
							58.146374
						],
						[
							-155.307491,
							57.727795
						],
						[
							-156.308335,
							57.422774
						],
						[
							-156.556097,
							56.979985
						],
						[
							-158.117217,
							56.463608
						],
						[
							-158.433321,
							55.994154
						],
						[
							-159.603327,
							55.566686
						],
						[
							-160.28972,
							55.643581
						],
						[
							-161.223048,
							55.364735
						],
						[
							-162.237766,
							55.024187
						],
						[
							-163.069447,
							54.689737
						],
						[
							-164.785569,
							54.404173
						],
						[
							-164.942226,
							54.572225
						],
						[
							-163.84834,
							55.039431
						],
						[
							-162.870001,
							55.348043
						],
						[
							-161.804175,
							55.894986
						],
						[
							-160.563605,
							56.008055
						],
						[
							-160.07056,
							56.418055
						],
						[
							-158.684443,
							57.016675
						],
						[
							-158.461097,
							57.216921
						],
						[
							-157.72277,
							57.570001
						],
						[
							-157.550274,
							58.328326
						],
						[
							-157.041675,
							58.918885
						],
						[
							-158.194731,
							58.615802
						],
						[
							-158.517218,
							58.787781
						],
						[
							-159.058606,
							58.424186
						],
						[
							-159.711667,
							58.93139
						],
						[
							-159.981289,
							58.572549
						],
						[
							-160.355271,
							59.071123
						],
						[
							-161.355003,
							58.670838
						],
						[
							-161.968894,
							58.671665
						],
						[
							-162.054987,
							59.266925
						],
						[
							-161.874171,
							59.633621
						],
						[
							-162.518059,
							59.989724
						],
						[
							-163.818341,
							59.798056
						],
						[
							-164.662218,
							60.267484
						],
						[
							-165.346388,
							60.507496
						],
						[
							-165.350832,
							61.073895
						],
						[
							-166.121379,
							61.500019
						],
						[
							-165.734452,
							62.074997
						],
						[
							-164.919179,
							62.633076
						],
						[
							-164.562508,
							63.146378
						],
						[
							-163.753332,
							63.219449
						],
						[
							-163.067224,
							63.059459
						],
						[
							-162.260555,
							63.541936
						],
						[
							-161.53445,
							63.455817
						],
						[
							-160.772507,
							63.766108
						],
						[
							-160.958335,
							64.222799
						],
						[
							-161.518068,
							64.402788
						],
						[
							-160.777778,
							64.788604
						],
						[
							-161.391926,
							64.777235
						],
						[
							-162.45305,
							64.559445
						],
						[
							-162.757786,
							64.338605
						],
						[
							-163.546394,
							64.55916
						],
						[
							-164.96083,
							64.446945
						],
						[
							-166.425288,
							64.686672
						],
						[
							-166.845004,
							65.088896
						],
						[
							-168.11056,
							65.669997
						],
						[
							-166.705271,
							66.088318
						],
						[
							-164.47471,
							66.57666
						],
						[
							-163.652512,
							66.57666
						],
						[
							-163.788602,
							66.077207
						],
						[
							-161.677774,
							66.11612
						],
						[
							-162.489715,
							66.735565
						],
						[
							-163.719717,
							67.116395
						],
						[
							-164.430991,
							67.616338
						],
						[
							-165.390287,
							68.042772
						],
						[
							-166.764441,
							68.358877
						],
						[
							-166.204707,
							68.883031
						],
						[
							-164.430811,
							68.915535
						],
						[
							-163.168614,
							69.371115
						],
						[
							-162.930566,
							69.858062
						],
						[
							-161.908897,
							70.33333
						],
						[
							-160.934797,
							70.44769
						],
						[
							-159.039176,
							70.891642
						],
						[
							-158.119723,
							70.824721
						],
						[
							-156.580825,
							71.357764
						],
						[
							-155.06779,
							71.147776
						]
					]
				]
			]
		},
		id: "USA",
		id2: "US",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Uruguay"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-57.625133,
						-30.216295
					],
					[
						-56.976026,
						-30.109686
					],
					[
						-55.973245,
						-30.883076
					],
					[
						-55.60151,
						-30.853879
					],
					[
						-54.572452,
						-31.494511
					],
					[
						-53.787952,
						-32.047243
					],
					[
						-53.209589,
						-32.727666
					],
					[
						-53.650544,
						-33.202004
					],
					[
						-53.373662,
						-33.768378
					],
					[
						-53.806426,
						-34.396815
					],
					[
						-54.935866,
						-34.952647
					],
					[
						-55.67409,
						-34.752659
					],
					[
						-56.215297,
						-34.859836
					],
					[
						-57.139685,
						-34.430456
					],
					[
						-57.817861,
						-34.462547
					],
					[
						-58.427074,
						-33.909454
					],
					[
						-58.349611,
						-33.263189
					],
					[
						-58.132648,
						-33.040567
					],
					[
						-58.14244,
						-32.044504
					],
					[
						-57.874937,
						-31.016556
					],
					[
						-57.625133,
						-30.216295
					]
				]
			]
		},
		id: "URY",
		id2: "UY",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Uzbekistan"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						66.518607,
						37.362784
					],
					[
						66.54615,
						37.974685
					],
					[
						65.215999,
						38.402695
					],
					[
						64.170223,
						38.892407
					],
					[
						63.518015,
						39.363257
					],
					[
						62.37426,
						40.053886
					],
					[
						61.882714,
						41.084857
					],
					[
						61.547179,
						41.26637
					],
					[
						60.465953,
						41.220327
					],
					[
						60.083341,
						41.425146
					],
					[
						59.976422,
						42.223082
					],
					[
						58.629011,
						42.751551
					],
					[
						57.78653,
						42.170553
					],
					[
						56.932215,
						41.826026
					],
					[
						57.096391,
						41.32231
					],
					[
						55.968191,
						41.308642
					],
					[
						55.928917,
						44.995858
					],
					[
						58.503127,
						45.586804
					],
					[
						58.689989,
						45.500014
					],
					[
						60.239972,
						44.784037
					],
					[
						61.05832,
						44.405817
					],
					[
						62.0133,
						43.504477
					],
					[
						63.185787,
						43.650075
					],
					[
						64.900824,
						43.728081
					],
					[
						66.098012,
						42.99766
					],
					[
						66.023392,
						41.994646
					],
					[
						66.510649,
						41.987644
					],
					[
						66.714047,
						41.168444
					],
					[
						67.985856,
						41.135991
					],
					[
						68.259896,
						40.662325
					],
					[
						68.632483,
						40.668681
					],
					[
						69.070027,
						41.384244
					],
					[
						70.388965,
						42.081308
					],
					[
						70.962315,
						42.266154
					],
					[
						71.259248,
						42.167711
					],
					[
						70.420022,
						41.519998
					],
					[
						71.157859,
						41.143587
					],
					[
						71.870115,
						41.3929
					],
					[
						73.055417,
						40.866033
					],
					[
						71.774875,
						40.145844
					],
					[
						71.014198,
						40.244366
					],
					[
						70.601407,
						40.218527
					],
					[
						70.45816,
						40.496495
					],
					[
						70.666622,
						40.960213
					],
					[
						69.329495,
						40.727824
					],
					[
						69.011633,
						40.086158
					],
					[
						68.536416,
						39.533453
					],
					[
						67.701429,
						39.580478
					],
					[
						67.44222,
						39.140144
					],
					[
						68.176025,
						38.901553
					],
					[
						68.392033,
						38.157025
					],
					[
						67.83,
						37.144994
					],
					[
						67.075782,
						37.356144
					],
					[
						66.518607,
						37.362784
					]
				]
			]
		},
		id: "UZB",
		id2: "UZ",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Vanuatu"
		},
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							167.844877,
							-16.466333
						],
						[
							167.515181,
							-16.59785
						],
						[
							167.180008,
							-16.159995
						],
						[
							167.216801,
							-15.891846
						],
						[
							167.844877,
							-16.466333
						]
					]
				],
				[
					[
						[
							167.107712,
							-14.93392
						],
						[
							167.270028,
							-15.740021
						],
						[
							167.001207,
							-15.614602
						],
						[
							166.793158,
							-15.668811
						],
						[
							166.649859,
							-15.392704
						],
						[
							166.629137,
							-14.626497
						],
						[
							167.107712,
							-14.93392
						]
					]
				]
			]
		},
		id: "VUT",
		id2: "VU",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Venezuela"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-71.331584,
						11.776284
					],
					[
						-71.360006,
						11.539994
					],
					[
						-71.94705,
						11.423282
					],
					[
						-71.620868,
						10.96946
					],
					[
						-71.633064,
						10.446494
					],
					[
						-72.074174,
						9.865651
					],
					[
						-71.695644,
						9.072263
					],
					[
						-71.264559,
						9.137195
					],
					[
						-71.039999,
						9.859993
					],
					[
						-71.350084,
						10.211935
					],
					[
						-71.400623,
						10.968969
					],
					[
						-70.155299,
						11.375482
					],
					[
						-70.293843,
						11.846822
					],
					[
						-69.943245,
						12.162307
					],
					[
						-69.5843,
						11.459611
					],
					[
						-68.882999,
						11.443385
					],
					[
						-68.233271,
						10.885744
					],
					[
						-68.194127,
						10.554653
					],
					[
						-67.296249,
						10.545868
					],
					[
						-66.227864,
						10.648627
					],
					[
						-65.655238,
						10.200799
					],
					[
						-64.890452,
						10.077215
					],
					[
						-64.329479,
						10.389599
					],
					[
						-64.318007,
						10.641418
					],
					[
						-63.079322,
						10.701724
					],
					[
						-61.880946,
						10.715625
					],
					[
						-62.730119,
						10.420269
					],
					[
						-62.388512,
						9.948204
					],
					[
						-61.588767,
						9.873067
					],
					[
						-60.830597,
						9.38134
					],
					[
						-60.671252,
						8.580174
					],
					[
						-60.150096,
						8.602757
					],
					[
						-59.758285,
						8.367035
					],
					[
						-60.550588,
						7.779603
					],
					[
						-60.637973,
						7.415
					],
					[
						-60.295668,
						7.043911
					],
					[
						-60.543999,
						6.856584
					],
					[
						-61.159336,
						6.696077
					],
					[
						-61.139415,
						6.234297
					],
					[
						-61.410303,
						5.959068
					],
					[
						-60.733574,
						5.200277
					],
					[
						-60.601179,
						4.918098
					],
					[
						-60.966893,
						4.536468
					],
					[
						-62.08543,
						4.162124
					],
					[
						-62.804533,
						4.006965
					],
					[
						-63.093198,
						3.770571
					],
					[
						-63.888343,
						4.02053
					],
					[
						-64.628659,
						4.148481
					],
					[
						-64.816064,
						4.056445
					],
					[
						-64.368494,
						3.79721
					],
					[
						-64.408828,
						3.126786
					],
					[
						-64.269999,
						2.497006
					],
					[
						-63.422867,
						2.411068
					],
					[
						-63.368788,
						2.2009
					],
					[
						-64.083085,
						1.916369
					],
					[
						-64.199306,
						1.492855
					],
					[
						-64.611012,
						1.328731
					],
					[
						-65.354713,
						1.095282
					],
					[
						-65.548267,
						0.789254
					],
					[
						-66.325765,
						0.724452
					],
					[
						-66.876326,
						1.253361
					],
					[
						-67.181294,
						2.250638
					],
					[
						-67.447092,
						2.600281
					],
					[
						-67.809938,
						2.820655
					],
					[
						-67.303173,
						3.318454
					],
					[
						-67.337564,
						3.542342
					],
					[
						-67.621836,
						3.839482
					],
					[
						-67.823012,
						4.503937
					],
					[
						-67.744697,
						5.221129
					],
					[
						-67.521532,
						5.55687
					],
					[
						-67.34144,
						6.095468
					],
					[
						-67.695087,
						6.267318
					],
					[
						-68.265052,
						6.153268
					],
					[
						-68.985319,
						6.206805
					],
					[
						-69.38948,
						6.099861
					],
					[
						-70.093313,
						6.960376
					],
					[
						-70.674234,
						7.087785
					],
					[
						-71.960176,
						6.991615
					],
					[
						-72.198352,
						7.340431
					],
					[
						-72.444487,
						7.423785
					],
					[
						-72.479679,
						7.632506
					],
					[
						-72.360901,
						8.002638
					],
					[
						-72.439862,
						8.405275
					],
					[
						-72.660495,
						8.625288
					],
					[
						-72.78873,
						9.085027
					],
					[
						-73.304952,
						9.152
					],
					[
						-73.027604,
						9.73677
					],
					[
						-72.905286,
						10.450344
					],
					[
						-72.614658,
						10.821975
					],
					[
						-72.227575,
						11.108702
					],
					[
						-71.973922,
						11.608672
					],
					[
						-71.331584,
						11.776284
					]
				]
			]
		},
		id: "VEN",
		id2: "VE",
		continent: "SA",
		region: "AMER"
	},
	{
		type: "Feature",
		properties: {
			name: "Vietnam"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						108.05018,
						21.55238
					],
					[
						106.715068,
						20.696851
					],
					[
						105.881682,
						19.75205
					],
					[
						105.662006,
						19.058165
					],
					[
						106.426817,
						18.004121
					],
					[
						107.361954,
						16.697457
					],
					[
						108.269495,
						16.079742
					],
					[
						108.877107,
						15.276691
					],
					[
						109.33527,
						13.426028
					],
					[
						109.200136,
						11.666859
					],
					[
						108.36613,
						11.008321
					],
					[
						107.220929,
						10.364484
					],
					[
						106.405113,
						9.53084
					],
					[
						105.158264,
						8.59976
					],
					[
						104.795185,
						9.241038
					],
					[
						105.076202,
						9.918491
					],
					[
						104.334335,
						10.486544
					],
					[
						105.199915,
						10.88931
					],
					[
						106.24967,
						10.961812
					],
					[
						105.810524,
						11.567615
					],
					[
						107.491403,
						12.337206
					],
					[
						107.614548,
						13.535531
					],
					[
						107.382727,
						14.202441
					],
					[
						107.564525,
						15.202173
					],
					[
						107.312706,
						15.908538
					],
					[
						106.556008,
						16.604284
					],
					[
						105.925762,
						17.485315
					],
					[
						105.094598,
						18.666975
					],
					[
						103.896532,
						19.265181
					],
					[
						104.183388,
						19.624668
					],
					[
						104.822574,
						19.886642
					],
					[
						104.435,
						20.758733
					],
					[
						103.203861,
						20.766562
					],
					[
						102.754896,
						21.675137
					],
					[
						102.170436,
						22.464753
					],
					[
						102.706992,
						22.708795
					],
					[
						103.504515,
						22.703757
					],
					[
						104.476858,
						22.81915
					],
					[
						105.329209,
						23.352063
					],
					[
						105.811247,
						22.976892
					],
					[
						106.725403,
						22.794268
					],
					[
						106.567273,
						22.218205
					],
					[
						107.04342,
						21.811899
					],
					[
						108.05018,
						21.55238
					]
				]
			]
		},
		id: "VNM",
		id2: "VN",
		continent: "AS",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "British Virgin Islands"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-64.4,
						18.2
					],
					[
						-64.6,
						18.2
					],
					[
						-64.6,
						18.4
					],
					[
						-64.4,
						18.4
					],
					[
						-64.6,
						18.2
					]
				]
			]
		},
		id: "VGB",
		id2: "VG",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-64.76,
							17.77
						],
						[
							-64.56,
							17.75
						],
						[
							-64.9,
							17.68
						],
						[
							-64.76,
							17.77
						]
					]
				]
			]
		},
		properties: {
			name: "Virgin Islands"
		},
		id2: "VI",
		id: "VIR",
		continent: "NA",
		region: "AMER"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							-178.04,
							-14.32
						],
						[
							-178.14,
							-14.32
						],
						[
							-178.19,
							-14.24
						],
						[
							-178.04,
							-14.32
						]
					]
				],
				[
					[
						[
							-176.16,
							-13.35
						],
						[
							-176.16,
							-13.21
						],
						[
							-176.12,
							-13.26
						],
						[
							-176.16,
							-13.35
						]
					]
				]
			]
		},
		properties: {
			name: "Wallis and Futuna"
		},
		id2: "WF",
		id: "WLF",
		continent: "OC",
		region: "APAC"
	},
	{
		type: "Feature",
		properties: {
			name: "Western Sahara"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						-8.794884,
						27.120696
					],
					[
						-8.817828,
						27.656426
					],
					[
						-8.66559,
						27.656426
					],
					[
						-8.665124,
						27.589479
					],
					[
						-8.6844,
						27.395744
					],
					[
						-8.687294,
						25.881056
					],
					[
						-11.969419,
						25.933353
					],
					[
						-11.937224,
						23.374594
					],
					[
						-12.874222,
						23.284832
					],
					[
						-13.118754,
						22.77122
					],
					[
						-12.929102,
						21.327071
					],
					[
						-16.845194,
						21.333323
					],
					[
						-17.063423,
						20.999752
					],
					[
						-17.020428,
						21.42231
					],
					[
						-17.002962,
						21.420734
					],
					[
						-14.750955,
						21.5006
					],
					[
						-14.630833,
						21.86094
					],
					[
						-14.221168,
						22.310163
					],
					[
						-13.89111,
						23.691009
					],
					[
						-12.500963,
						24.770116
					],
					[
						-12.030759,
						26.030866
					],
					[
						-11.71822,
						26.104092
					],
					[
						-11.392555,
						26.883424
					],
					[
						-10.551263,
						26.990808
					],
					[
						-10.189424,
						26.860945
					],
					[
						-9.735343,
						26.860945
					],
					[
						-9.413037,
						27.088476
					],
					[
						-8.794884,
						27.120696
					]
				]
			]
		},
		id: "ESH",
		id2: "EH",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Yemen"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						53.108573,
						16.651051
					],
					[
						52.385206,
						16.382411
					],
					[
						52.191729,
						15.938433
					],
					[
						52.168165,
						15.59742
					],
					[
						51.172515,
						15.17525
					],
					[
						49.574576,
						14.708767
					],
					[
						48.679231,
						14.003202
					],
					[
						48.238947,
						13.94809
					],
					[
						47.938914,
						14.007233
					],
					[
						47.354454,
						13.59222
					],
					[
						46.717076,
						13.399699
					],
					[
						45.877593,
						13.347764
					],
					[
						45.62505,
						13.290946
					],
					[
						45.406459,
						13.026905
					],
					[
						45.144356,
						12.953938
					],
					[
						44.989533,
						12.699587
					],
					[
						44.494576,
						12.721653
					],
					[
						44.175113,
						12.58595
					],
					[
						43.482959,
						12.6368
					],
					[
						43.222871,
						13.22095
					],
					[
						43.251448,
						13.767584
					],
					[
						43.087944,
						14.06263
					],
					[
						42.892245,
						14.802249
					],
					[
						42.604873,
						15.213335
					],
					[
						42.805015,
						15.261963
					],
					[
						42.702438,
						15.718886
					],
					[
						42.823671,
						15.911742
					],
					[
						42.779332,
						16.347891
					],
					[
						43.218375,
						16.66689
					],
					[
						43.115798,
						17.08844
					],
					[
						43.380794,
						17.579987
					],
					[
						43.791519,
						17.319977
					],
					[
						44.062613,
						17.410359
					],
					[
						45.216651,
						17.433329
					],
					[
						45.399999,
						17.333335
					],
					[
						46.366659,
						17.233315
					],
					[
						46.749994,
						17.283338
					],
					[
						47.000005,
						16.949999
					],
					[
						47.466695,
						17.116682
					],
					[
						48.183344,
						18.166669
					],
					[
						49.116672,
						18.616668
					],
					[
						52.00001,
						19.000003
					],
					[
						52.782184,
						17.349742
					],
					[
						53.108573,
						16.651051
					]
				]
			]
		},
		id: "YEM",
		id2: "YE",
		continent: "AS",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Zambia"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						32.759375,
						-9.230599
					],
					[
						33.231388,
						-9.676722
					],
					[
						33.485688,
						-10.525559
					],
					[
						33.31531,
						-10.79655
					],
					[
						33.114289,
						-11.607198
					],
					[
						33.306422,
						-12.435778
					],
					[
						32.991764,
						-12.783871
					],
					[
						32.688165,
						-13.712858
					],
					[
						33.214025,
						-13.97186
					],
					[
						30.179481,
						-14.796099
					],
					[
						30.274256,
						-15.507787
					],
					[
						29.516834,
						-15.644678
					],
					[
						28.947463,
						-16.043051
					],
					[
						28.825869,
						-16.389749
					],
					[
						28.467906,
						-16.4684
					],
					[
						27.598243,
						-17.290831
					],
					[
						27.044427,
						-17.938026
					],
					[
						26.706773,
						-17.961229
					],
					[
						26.381935,
						-17.846042
					],
					[
						25.264226,
						-17.73654
					],
					[
						25.084443,
						-17.661816
					],
					[
						25.07695,
						-17.578823
					],
					[
						24.682349,
						-17.353411
					],
					[
						24.033862,
						-17.295843
					],
					[
						23.215048,
						-17.523116
					],
					[
						22.562478,
						-16.898451
					],
					[
						21.887843,
						-16.08031
					],
					[
						21.933886,
						-12.898437
					],
					[
						24.016137,
						-12.911046
					],
					[
						23.930922,
						-12.565848
					],
					[
						24.079905,
						-12.191297
					],
					[
						23.904154,
						-11.722282
					],
					[
						24.017894,
						-11.237298
					],
					[
						23.912215,
						-10.926826
					],
					[
						24.257155,
						-10.951993
					],
					[
						24.314516,
						-11.262826
					],
					[
						24.78317,
						-11.238694
					],
					[
						25.418118,
						-11.330936
					],
					[
						25.75231,
						-11.784965
					],
					[
						26.553088,
						-11.92444
					],
					[
						27.16442,
						-11.608748
					],
					[
						27.388799,
						-12.132747
					],
					[
						28.155109,
						-12.272481
					],
					[
						28.523562,
						-12.698604
					],
					[
						28.934286,
						-13.248958
					],
					[
						29.699614,
						-13.257227
					],
					[
						29.616001,
						-12.178895
					],
					[
						29.341548,
						-12.360744
					],
					[
						28.642417,
						-11.971569
					],
					[
						28.372253,
						-11.793647
					],
					[
						28.49607,
						-10.789884
					],
					[
						28.673682,
						-9.605925
					],
					[
						28.449871,
						-9.164918
					],
					[
						28.734867,
						-8.526559
					],
					[
						29.002912,
						-8.407032
					],
					[
						30.346086,
						-8.238257
					],
					[
						30.740015,
						-8.340007
					],
					[
						31.157751,
						-8.594579
					],
					[
						31.556348,
						-8.762049
					],
					[
						32.191865,
						-8.930359
					],
					[
						32.759375,
						-9.230599
					]
				]
			]
		},
		id: "ZMB",
		id2: "ZM",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		properties: {
			name: "Zimbabwe"
		},
		geometry: {
			type: "Polygon",
			coordinates: [
				[
					[
						31.191409,
						-22.25151
					],
					[
						30.659865,
						-22.151567
					],
					[
						30.322883,
						-22.271612
					],
					[
						29.839037,
						-22.102216
					],
					[
						29.432188,
						-22.091313
					],
					[
						28.794656,
						-21.639454
					],
					[
						28.02137,
						-21.485975
					],
					[
						27.727228,
						-20.851802
					],
					[
						27.724747,
						-20.499059
					],
					[
						27.296505,
						-20.39152
					],
					[
						26.164791,
						-19.293086
					],
					[
						25.850391,
						-18.714413
					],
					[
						25.649163,
						-18.536026
					],
					[
						25.264226,
						-17.73654
					],
					[
						26.381935,
						-17.846042
					],
					[
						26.706773,
						-17.961229
					],
					[
						27.044427,
						-17.938026
					],
					[
						27.598243,
						-17.290831
					],
					[
						28.467906,
						-16.4684
					],
					[
						28.825869,
						-16.389749
					],
					[
						28.947463,
						-16.043051
					],
					[
						29.516834,
						-15.644678
					],
					[
						30.274256,
						-15.507787
					],
					[
						30.338955,
						-15.880839
					],
					[
						31.173064,
						-15.860944
					],
					[
						31.636498,
						-16.07199
					],
					[
						31.852041,
						-16.319417
					],
					[
						32.328239,
						-16.392074
					],
					[
						32.847639,
						-16.713398
					],
					[
						32.849861,
						-17.979057
					],
					[
						32.654886,
						-18.67209
					],
					[
						32.611994,
						-19.419383
					],
					[
						32.772708,
						-19.715592
					],
					[
						32.659743,
						-20.30429
					],
					[
						32.508693,
						-20.395292
					],
					[
						32.244988,
						-21.116489
					],
					[
						31.191409,
						-22.25151
					]
				]
			]
		},
		id: "ZWE",
		id2: "ZW",
		continent: "AF",
		region: "EMEA"
	},
	{
		type: "Feature",
		geometry: {
			type: "MultiPolygon",
			coordinates: [
				[
					[
						[
							20.08,
							60.35
						],
						[
							19.94,
							60.04
						],
						[
							19.65,
							60.26
						],
						[
							20.08,
							60.35
						]
					]
				]
			]
		},
		properties: {
			name: "Aland Islands"
		},
		id2: "AX",
		id: "ALA",
		continent: "EU",
		region: "EMEA"
	}
];
var world = {
	type: type$1,
	features: features$1
};

var DNBChoroplethMap = function DNBChoroplethMap(_ref) {
  var map = _ref.map,
    data = _ref.data,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? theme.colors.ColorChartCategory1 : _ref$color,
    _ref$adjustScale = _ref.adjustScale,
    adjustScale = _ref$adjustScale === void 0 ? 0 : _ref$adjustScale,
    _ref$regionLabel = _ref.regionLabel,
    regionLabel = _ref$regionLabel === void 0 ? '' : _ref$regionLabel,
    _ref$dataLabel = _ref.dataLabel,
    dataLabel = _ref$dataLabel === void 0 ? '' : _ref$dataLabel,
    _ref$noDataLabel = _ref.noDataLabel,
    noDataLabel = _ref$noDataLabel === void 0 ? 'No Data' : _ref$noDataLabel,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? true : _ref$tooltip,
    onRegionClick = _ref.onRegionClick;
  var regions = map === 'world' ? world : us;
  var projection = map === 'world' ? mercator().rotate([-10, 0]) : albersUsa();
  var _useState = useState(function () {
      return index(projection);
    }),
    path = _useState[0],
    setPath = _useState[1];
  var _useState2 = useState(500),
    width = _useState2[0],
    setWidth = _useState2[1];
  var adjustScaleNum = adjustScale === 'min' ? Math.min.apply(Math, data.map(function (d) {
    return d.data;
  })) : adjustScale;
  var maxData = Math.max.apply(Math, data.map(function (d) {
    return d.data;
  })) || 100;
  var abbreviate = function abbreviate(n) {
    return Intl.NumberFormat(undefined, {
      notation: 'compact',
      maximumFractionDigits: 1
    }).format(n);
  };
  var UnstyledPath = React__default.forwardRef(function (props, ref) {
    return React__default.createElement("path", Object.assign({
      ref: ref
    }, props));
  });
  UnstyledPath.displayName = 'UnstyledPath';
  var StyledDNBTooltip = styled(DNBTooltip)(function (_ref2) {
    var _ref3;
    var theme = _ref2.theme;
    return _ref3 = {}, _ref3["& ." + tooltipClasses$1.tooltip] = {
      backgroundColor: theme.colors.ColorBackgroundWhite,
      padding: '8px',
      borderRadius: '4px',
      color: theme.colors.ColorGrayPrimary,
      borderColor: theme.colors.ColorGrayIncidental,
      borderSize: theme.borders.BorderThin,
      boxShadow: theme.boxShadows.ShadowPlus1
    }, _ref3;
  });
  var elementRef = useRef(null);
  var observer = React__default.useRef(new ResizeObserver(function (entries) {
    setWidth(entries[0].contentRect.width);
  }));
  var _useState3 = useState(''),
    hoveredRegion = _useState3[0],
    sethoveredRegion = _useState3[1];
  React__default.useEffect(function () {
    if (elementRef.current) {
      observer.current.observe(elementRef.current);
    }
    return function () {
      if (elementRef.current) observer.current.unobserve(elementRef.current);
    };
  }, [elementRef, observer]);
  useEffect(function () {
    setPath(function () {
      return index(projection.fitWidth(width, regions));
    });
  }, [width]);
  return React__default.createElement("div", {
    ref: elementRef
  }, React__default.createElement("svg", {
    style: {
      width: width + 'px',
      height: width * 0.65 + 'px'
    }
  }, regions.features.map(function (region) {
    var regionEntry = data.find(function (c) {
      return c.id === region.id2;
    });
    var regionData = (regionEntry === null || regionEntry === void 0 ? void 0 : regionEntry.data) || 0;
    var percent = (regionData - adjustScaleNum) / (maxData - adjustScaleNum);
    var opacity = regionData === 0 ? 0.1 : percent < 0.15 ? 0.15 : percent;
    var StyledPath = styled(UnstyledPath)(function (_ref4) {
      var theme = _ref4.theme;
      return {
        fillOpacity: opacity,
        fill: color,
        stroke: theme.colors.ColorGrayIncidental,
        strokeWidth: '1px',
        cursor: onRegionClick ? 'pointer' : undefined,
        ':hover': onRegionClick ? {
          strokeWidth: '4px',
          fillOpacity: 1
        } : undefined,
        ':focus': onRegionClick || tooltip ? {
          outline: 'none',
          strokeWidth: '2px',
          fillOpacity: 1
        } : undefined
      };
    });
    var pathElement = React__default.createElement(StyledPath, {
      key: region.id2,
      d: path(region) || undefined,
      onClick: function onClick() {
        if (onRegionClick) onRegionClick(region.id2);
      }
    });
    return tooltip && (noDataLabel || regionData) ? React__default.createElement(StyledDNBTooltip, {
      key: region.id2,
      placement: "top-start",
      tabIndex: 0,
      followCursor: hoveredRegion === region.id2,
      onMouseEnter: function onMouseEnter() {
        sethoveredRegion(region.id2);
      },
      onMouseLeave: function onMouseLeave() {
        sethoveredRegion('');
      },
      content: React__default.createElement(DNBTypography, {
        noWrap: true,
        variant: "caption"
      }, regionEntry ? React__default.createElement(React__default.Fragment, null, regionLabel, regionLabel ? ': ' : '', React__default.createElement(DNBTypography, {
        noWrap: true,
        variant: "caption-bold"
      }, regionEntry.label), React__default.createElement("br", null), dataLabel, dataLabel ? ': ' : '', React__default.createElement(DNBTypography, {
        noWrap: true,
        variant: "caption-bold"
      }, abbreviate(regionData))) : noDataLabel)
    }, pathElement) : pathElement;
  })));
};

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function r$2(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r$2(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx$1() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r$2(e)) && (n && (n += " "), n += t);
  return n;
}

function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }
  return array.indexOf(itemOrItems) !== -1;
}
var onSpaceOrEnter = function onSpaceOrEnter(innerFn, onFocus) {
  return function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      innerFn();
      event.preventDefault();
      event.stopPropagation();
    }
    if (onFocus) {
      onFocus(event);
    }
  };
};

var _excluded$x = ["disabled", "onSelect", "selected", "value"];
var classes = generateUtilityClasses$1('PrivatePickersMonth', ['root', 'selected']);
var PickersMonthRoot = styled(Typography)(function (_ref) {
  var _extends2;
  var theme = _ref.theme;
  return _extends$2({
    flex: '1 0 33.33%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'unset',
    backgroundColor: 'transparent',
    border: 0,
    outline: 0
  }, theme.typography.subtitle1, (_extends2 = {
    margin: '8px 0',
    height: 36,
    borderRadius: 18,
    cursor: 'pointer',
    '&:focus, &:hover': {
      backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
    },
    '&:disabled': {
      pointerEvents: 'none',
      color: theme.palette.text.secondary
    }
  }, _extends2["&." + classes.selected] = {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }, _extends2));
});
var PickersMonth = function PickersMonth(props) {
  var disabled = props.disabled,
    onSelect = props.onSelect,
    selected = props.selected,
    value = props.value,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$x);
  var handleSelection = function handleSelection() {
    onSelect(value);
  };
  return /*#__PURE__*/jsx(PickersMonthRoot, _extends$2({
    component: "button",
    type: "button",
    className: clsx$1(classes.root, selected && classes.selected),
    tabIndex: disabled ? -1 : 0,
    onClick: handleSelection,
    onKeyDown: onSpaceOrEnter(handleSelection),
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    disabled: disabled
  }, other));
};

var getPickersLocalization = function getPickersLocalization(pickersTranslations) {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: _extends$2({}, pickersTranslations)
        }
      }
    }
  };
};

var enUSPickers = {
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  openPreviousView: 'open previous view',
  openNextView: 'open next view',
  calendarViewSwitchingButtonAriaLabel: function calendarViewSwitchingButtonAriaLabel(view) {
    return view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view';
  },
  start: 'Start',
  end: 'End',
  cancelButtonLabel: 'Cancel',
  clearButtonLabel: 'Clear',
  okButtonLabel: 'OK',
  todayButtonLabel: 'Today',
  clockLabelText: function clockLabelText(view, time, adapter) {
    return "Select " + view + ". " + (time === null ? 'No time selected' : "Selected time is " + adapter.format(time, 'fullTime'));
  },
  hoursClockNumberText: function hoursClockNumberText(hours) {
    return hours + " hours";
  },
  minutesClockNumberText: function minutesClockNumberText(minutes) {
    return minutes + " minutes";
  },
  secondsClockNumberText: function secondsClockNumberText(seconds) {
    return seconds + " seconds";
  },
  openDatePickerDialogue: function openDatePickerDialogue(rawValue, utils) {
    return rawValue && utils.isValid(utils.date(rawValue)) ? "Choose date, selected date is " + utils.format(utils.date(rawValue), 'fullDate') : 'Choose date';
  },
  openTimePickerDialogue: function openTimePickerDialogue(rawValue, utils) {
    return rawValue && utils.isValid(utils.date(rawValue)) ? "Choose time, selected time is " + utils.format(utils.date(rawValue), 'fullTime') : 'Choose time';
  },
  timeTableLabel: 'pick time',
  dateTableLabel: 'pick date'
};
var DEFAULT_LOCALE = enUSPickers;
var enUS = getPickersLocalization(enUSPickers);

var MuiPickersAdapterContext = /*#__PURE__*/createContext(null);
if (process.env.NODE_ENV !== 'production') {
  MuiPickersAdapterContext.displayName = 'MuiPickersAdapterContext';
}
var warnedOnce = false;
function LocalizationProvider(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiLocalizationProvider'
  });
  var children = props.children,
    Utils = props.dateAdapter,
    dateFormats = props.dateFormats,
    dateLibInstance = props.dateLibInstance,
    locale = props.locale,
    adapterLocale = props.adapterLocale,
    localeText = props.localeText;
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnce && locale !== undefined) {
      warnedOnce = true;
      console.warn("LocalizationProvider's prop `locale` is deprecated and replaced by `adapterLocale`");
    }
  }
  var utils = useMemo(function () {
    return new Utils({
      locale: adapterLocale != null ? adapterLocale : locale,
      formats: dateFormats,
      instance: dateLibInstance
    });
  }, [Utils, locale, adapterLocale, dateFormats, dateLibInstance]);
  var defaultDates = useMemo(function () {
    return {
      minDate: utils.date('1900-01-01T00:00:00.000'),
      maxDate: utils.date('2099-12-31T00:00:00.000')
    };
  }, [utils]);
  var contextValue = useMemo(function () {
    return {
      utils: utils,
      defaultDates: defaultDates,
      localeText: _extends$2({}, DEFAULT_LOCALE, localeText != null ? localeText : {})
    };
  }, [defaultDates, utils, localeText]);
  return /*#__PURE__*/jsx(MuiPickersAdapterContext.Provider, {
    value: contextValue,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? LocalizationProvider.propTypes = {
  adapterLocale: propTypes.oneOfType([propTypes.object, propTypes.string]),
  children: propTypes.node,
  dateAdapter: propTypes.func.isRequired,
  dateFormats: propTypes.shape({
    dayOfMonth: propTypes.string,
    fullDate: propTypes.string,
    fullDateTime: propTypes.string,
    fullDateTime12h: propTypes.string,
    fullDateTime24h: propTypes.string,
    fullDateWithWeekday: propTypes.string,
    fullTime: propTypes.string,
    fullTime12h: propTypes.string,
    fullTime24h: propTypes.string,
    hours12h: propTypes.string,
    hours24h: propTypes.string,
    keyboardDate: propTypes.string,
    keyboardDateTime: propTypes.string,
    keyboardDateTime12h: propTypes.string,
    keyboardDateTime24h: propTypes.string,
    minutes: propTypes.string,
    month: propTypes.string,
    monthAndDate: propTypes.string,
    monthAndYear: propTypes.string,
    monthShort: propTypes.string,
    normalDate: propTypes.string,
    normalDateWithWeekday: propTypes.string,
    seconds: propTypes.string,
    shortDate: propTypes.string,
    weekday: propTypes.string,
    weekdayShort: propTypes.string,
    year: propTypes.string
  }),
  dateLibInstance: propTypes.any,
  locale: propTypes.oneOfType([propTypes.object, propTypes.string]),
  localeText: propTypes.object
} : void 0;

var useLocalizationContext = function useLocalizationContext() {
  var localization = useContext(MuiPickersAdapterContext);
  if (localization === null) {
    throw new Error('MUI: Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly.');
  }
  return localization;
};
var useUtils = function useUtils() {
  return useLocalizationContext().utils;
};
var useDefaultDates = function useDefaultDates() {
  return useLocalizationContext().defaultDates;
};
var useLocaleText = function useLocaleText() {
  return useLocalizationContext().localeText;
};
var useNow = function useNow() {
  var utils = useUtils();
  var now = useRef(utils.date());
  return now.current;
};

function getMonthPickerUtilityClass(slot) {
  return generateUtilityClass$1('MuiMonthPicker', slot);
}
var monthPickerClasses = generateUtilityClasses$1('MuiMonthPicker', ['root']);

var _excluded$y = ["className", "date", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly"];
var useUtilityClasses$3 = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes;
  var slots = {
    root: ['root']
  };
  return unstable_composeClasses(slots, getMonthPickerUtilityClass, classes);
};
var MonthPickerRoot = styled('div', {
  name: 'MuiMonthPicker',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({
  width: 310,
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'stretch',
  margin: '0 4px'
});
var MonthPicker = /*#__PURE__*/forwardRef(function MonthPicker(inProps, ref) {
  var utils = useUtils();
  var now = useNow();
  var defaultDates = useDefaultDates();
  var props = useThemeProps({
    props: inProps,
    name: 'MuiMonthPicker'
  });
  var className = props.className,
    propDate = props.date,
    disabled = props.disabled,
    disableFuture = props.disableFuture,
    disablePast = props.disablePast,
    _props$maxDate = props.maxDate,
    maxDate = _props$maxDate === void 0 ? defaultDates.maxDate : _props$maxDate,
    _props$minDate = props.minDate,
    minDate = _props$minDate === void 0 ? defaultDates.minDate : _props$minDate,
    onChange = props.onChange,
    shouldDisableMonth = props.shouldDisableMonth,
    readOnly = props.readOnly,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$y);
  var ownerState = props;
  var classes = useUtilityClasses$3(ownerState);
  var currentDate = propDate != null ? propDate : now;
  var currentMonth = utils.getMonth(currentDate);
  var isMonthDisabled = function isMonthDisabled(month) {
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    if (utils.isBefore(month, firstEnabledMonth)) {
      return true;
    }
    if (utils.isAfter(month, lastEnabledMonth)) {
      return true;
    }
    if (!shouldDisableMonth) {
      return false;
    }
    return shouldDisableMonth(month);
  };
  var onMonthSelect = function onMonthSelect(month) {
    if (readOnly) {
      return;
    }
    var newDate = utils.setMonth(currentDate, month);
    onChange(newDate, 'finish');
  };
  return /*#__PURE__*/jsx(MonthPickerRoot, _extends$2({
    ref: ref,
    className: clsx$1(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: utils.getMonthArray(currentDate).map(function (month) {
      var monthNumber = utils.getMonth(month);
      var monthText = utils.format(month, 'monthShort');
      return /*#__PURE__*/jsx(PickersMonth, {
        value: monthNumber,
        selected: monthNumber === currentMonth,
        onSelect: onMonthSelect,
        disabled: disabled || isMonthDisabled(month),
        children: monthText
      }, monthText);
    })
  }));
});
process.env.NODE_ENV !== "production" ? MonthPicker.propTypes = {
  classes: propTypes.object,
  className: propTypes.string,
  date: propTypes.any,
  disabled: propTypes.bool,
  disableFuture: propTypes.bool,
  disablePast: propTypes.bool,
  maxDate: propTypes.any,
  minDate: propTypes.any,
  onChange: propTypes.func.isRequired,
  readOnly: propTypes.bool,
  shouldDisableMonth: propTypes.func,
  sx: propTypes.oneOfType([propTypes.arrayOf(propTypes.oneOfType([propTypes.func, propTypes.object, propTypes.bool])), propTypes.func, propTypes.object])
} : void 0;

function useValidation(props, validate, isSameError) {
  var value = props.value,
    onError = props.onError;
  var adapter = useLocalizationContext();
  var previousValidationErrorRef = useRef(null);
  var validationError = validate({
    adapter: adapter,
    value: value,
    props: props
  });
  useEffect(function () {
    if (onError && !isSameError(validationError, previousValidationErrorRef.current)) {
      onError(validationError, value);
    }
    previousValidationErrorRef.current = validationError;
  }, [isSameError, onError, previousValidationErrorRef, validationError, value]);
  return validationError;
}

var validateDate = function validateDate(_ref) {
  var props = _ref.props,
    value = _ref.value,
    adapter = _ref.adapter;
  var now = adapter.utils.date();
  var date = adapter.utils.date(value);
  var shouldDisableDate = props.shouldDisableDate,
    _props$minDate = props.minDate,
    minDate = _props$minDate === void 0 ? adapter.defaultDates.minDate : _props$minDate,
    _props$maxDate = props.maxDate,
    maxDate = _props$maxDate === void 0 ? adapter.defaultDates.maxDate : _props$maxDate,
    disableFuture = props.disableFuture,
    disablePast = props.disablePast;
  if (date === null) {
    return null;
  }
  switch (true) {
    case !adapter.utils.isValid(value):
      return 'invalidDate';
    case Boolean(shouldDisableDate && shouldDisableDate(date)):
      return 'shouldDisableDate';
    case Boolean(disableFuture && adapter.utils.isAfterDay(date, now)):
      return 'disableFuture';
    case Boolean(disablePast && adapter.utils.isBeforeDay(date, now)):
      return 'disablePast';
    case Boolean(minDate && adapter.utils.isBeforeDay(date, minDate)):
      return 'minDate';
    case Boolean(maxDate && adapter.utils.isAfterDay(date, maxDate)):
      return 'maxDate';
    default:
      return null;
  }
};
var useIsDayDisabled = function useIsDayDisabled(_ref2) {
  var shouldDisableDate = _ref2.shouldDisableDate,
    minDate = _ref2.minDate,
    maxDate = _ref2.maxDate,
    disableFuture = _ref2.disableFuture,
    disablePast = _ref2.disablePast;
  var adapter = useLocalizationContext();
  return useCallback(function (day) {
    return validateDate({
      adapter: adapter,
      value: day,
      props: {
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast
      }
    }) !== null;
  }, [adapter, shouldDisableDate, minDate, maxDate, disableFuture, disablePast]);
};
var isSameDateError = function isSameDateError(a, b) {
  return a === b;
};
var useDateValidation = function useDateValidation(props) {
  return useValidation(props, validateDate, isSameDateError);
};

var createCalendarStateReducer = function createCalendarStateReducer(reduceAnimations, disableSwitchToMonthOnDayFocus, utils) {
  return function (state, action) {
    switch (action.type) {
      case 'changeMonth':
        return _extends$2({}, state, {
          slideDirection: action.direction,
          currentMonth: action.newMonth,
          isMonthSwitchingAnimating: !reduceAnimations
        });
      case 'finishMonthSwitchingAnimation':
        return _extends$2({}, state, {
          isMonthSwitchingAnimating: false
        });
      case 'changeFocusedDay':
        {
          if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) {
            return state;
          }
          var needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
          return _extends$2({}, state, {
            focusedDay: action.focusedDay,
            isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations,
            currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
            slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
          });
        }
      default:
        throw new Error('missing support');
    }
  };
};
var useCalendarState = function useCalendarState(_ref2) {
  var date = _ref2.date,
    defaultCalendarMonth = _ref2.defaultCalendarMonth,
    disableFuture = _ref2.disableFuture,
    disablePast = _ref2.disablePast,
    _ref2$disableSwitchTo = _ref2.disableSwitchToMonthOnDayFocus,
    disableSwitchToMonthOnDayFocus = _ref2$disableSwitchTo === void 0 ? false : _ref2$disableSwitchTo,
    maxDate = _ref2.maxDate,
    minDate = _ref2.minDate,
    onMonthChange = _ref2.onMonthChange,
    reduceAnimations = _ref2.reduceAnimations,
    shouldDisableDate = _ref2.shouldDisableDate;
  var _ref;
  var now = useNow();
  var utils = useUtils();
  var reducerFn = useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
  var _React$useReducer = useReducer(reducerFn, {
      isMonthSwitchingAnimating: false,
      focusedDay: date || now,
      currentMonth: utils.startOfMonth((_ref = date != null ? date : defaultCalendarMonth) != null ? _ref : now),
      slideDirection: 'left'
    }),
    calendarState = _React$useReducer[0],
    dispatch = _React$useReducer[1];
  var handleChangeMonth = useCallback(function (payload) {
    dispatch(_extends$2({
      type: 'changeMonth'
    }, payload));
    if (onMonthChange) {
      onMonthChange(payload.newMonth);
    }
  }, [onMonthChange]);
  var changeMonth = useCallback(function (newDate) {
    var newDateRequested = newDate != null ? newDate : now;
    if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) {
      return;
    }
    handleChangeMonth({
      newMonth: utils.startOfMonth(newDateRequested),
      direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
    });
  }, [calendarState.currentMonth, handleChangeMonth, now, utils]);
  var isDateDisabled = useIsDayDisabled({
    shouldDisableDate: shouldDisableDate,
    minDate: minDate,
    maxDate: maxDate,
    disableFuture: disableFuture,
    disablePast: disablePast
  });
  var onMonthSwitchingAnimationEnd = useCallback(function () {
    dispatch({
      type: 'finishMonthSwitchingAnimation'
    });
  }, []);
  var changeFocusedDay = useCallback(function (newFocusedDate) {
    if (!isDateDisabled(newFocusedDate)) {
      dispatch({
        type: 'changeFocusedDay',
        focusedDay: newFocusedDate
      });
    }
  }, [isDateDisabled]);
  return {
    calendarState: calendarState,
    changeMonth: changeMonth,
    changeFocusedDay: changeFocusedDay,
    isDateDisabled: isDateDisabled,
    onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
    handleChangeMonth: handleChangeMonth
  };
};

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.number, propTypes.shape({
  enter: propTypes.number,
  exit: propTypes.number,
  appear: propTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.string, propTypes.shape({
  enter: propTypes.string,
  exit: propTypes.string,
  active: propTypes.string
}), propTypes.shape({
  enter: propTypes.string,
  enterDone: propTypes.string,
  enterActive: propTypes.string,
  exit: propTypes.string,
  exitDone: propTypes.string,
  exitActive: propTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(Transition, _React$Component);
  function Transition(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;
    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }
    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function () {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props,
      children = _this$props.children,
      childProps = _objectWithoutPropertiesLoose$3(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: null
    }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps));
  };
  return Transition;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  nodeRef: propTypes.shape({
    current: typeof Element === 'undefined' ? propTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return propTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  children: propTypes.oneOfType([propTypes.func.isRequired, propTypes.element.isRequired]).isRequired,
  in: propTypes.bool,
  mountOnEnter: propTypes.bool,
  unmountOnExit: propTypes.bool,
  appear: propTypes.bool,
  enter: propTypes.bool,
  exit: propTypes.bool,
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  addEndListener: propTypes.func,
  onEnter: propTypes.func,
  onEntering: propTypes.func,
  onEntered: propTypes.func,
  onExit: propTypes.func,
  onExiting: propTypes.func,
  onExited: propTypes.func
} : {};
function noop$2() {}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$2,
  onEntering: noop$2,
  onEntered: noop$2,
  onExit: noop$2,
  onExiting: noop$2,
  onExited: noop$2
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};
var removeClass$1 = function removeClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass(node, c);
  });
};
var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(CSSTransition, _React$Component);
  function CSSTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument[0],
        appearing = _this$resolveArgument[1];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument2[0],
        appearing = _this$resolveArgument2[1];
      var type = appearing ? 'appear' : 'enter';
      _this.addClass(node, type, 'active');
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument3[0],
        appearing = _this$resolveArgument3[1];
      var type = appearing ? 'appear' : 'enter';
      _this.removeClasses(node, type);
      _this.addClass(node, type, 'done');
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument4[0];
      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      _this.addClass(node, 'exit', 'base');
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument5[0];
      _this.addClass(node, 'exit', 'active');
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument6[0];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, 'exit', 'done');
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition.prototype;
  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames('enter'),
      doneClassName = _this$getClassNames.doneClassName;
    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node, className);
    }
  };
  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
      baseClassName = _this$appliedClasses$.base,
      activeClassName = _this$appliedClasses$.active,
      doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }
    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }
    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      props = _objectWithoutPropertiesLoose$3(_this$props, ["classNames"]);
    return /*#__PURE__*/React__default.createElement(Transition, _extends$3({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition;
}(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$3({}, Transition.propTypes, {
  classNames: classNamesShape,
  onEnter: propTypes.func,
  onEntering: propTypes.func,
  onEntered: propTypes.func,
  onExit: propTypes.func,
  onExiting: propTypes.func,
  onExited: propTypes.func
}) : {};

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    result[child.key] = mapper(child);
  });
  return result;
}
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }
  var nextKeysPending = Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in;
    if (hasNext && (!hasPrev || isLeaving)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(TransitionGroup, _React$Component);
  function TransitionGroup(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
      handleExited = _ref.handleExited,
      firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };
  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$3({}, state.children);
        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      Component = _this$props.component,
      childFactory = _this$props.childFactory,
      props = _objectWithoutPropertiesLoose$3(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };
  return TransitionGroup;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  component: propTypes.any,
  children: propTypes.node,
  appear: propTypes.bool,
  enter: propTypes.bool,
  exit: propTypes.bool,
  childFactory: propTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var classes$1 = generateUtilityClasses$1('PrivatePickersFadeTransitionGroup', ['root']);
var animationDuration = 500;
var PickersFadeTransitionGroupRoot = styled(TransitionGroup)({
  display: 'block',
  position: 'relative'
});
var PickersFadeTransitionGroup = function PickersFadeTransitionGroup(_ref) {
  var children = _ref.children,
    className = _ref.className,
    reduceAnimations = _ref.reduceAnimations,
    transKey = _ref.transKey;
  if (reduceAnimations) {
    return children;
  }
  return /*#__PURE__*/jsx(PickersFadeTransitionGroupRoot, {
    className: clsx$1(classes$1.root, className),
    children: /*#__PURE__*/jsx(Fade, {
      appear: false,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        appear: animationDuration,
        enter: animationDuration / 2,
        exit: 0
      },
      children: children
    }, transKey)
  });
};

var useEnhancedEffect$1 = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

var globalId$1 = 0;
function useGlobalId$1(idOverride) {
  var _React$useState = useState(idOverride),
    defaultId = _React$useState[0],
    setDefaultId = _React$useState[1];
  var id = idOverride || defaultId;
  useEffect(function () {
    if (defaultId == null) {
      globalId$1 += 1;
      setDefaultId("mui-" + globalId$1);
    }
  }, [defaultId]);
  return id;
}
var maybeReactUseId$1 = React['useId' + ''];
function useId$1(idOverride) {
  if (maybeReactUseId$1 !== undefined) {
    var reactId = maybeReactUseId$1();
    return idOverride != null ? idOverride : reactId;
  }
  return useGlobalId$1(idOverride);
}

var DAY_SIZE = 36;
var DAY_MARGIN = 2;
var DIALOG_WIDTH = 320;
var VIEW_HEIGHT = 358;

function getPickersDayUtilityClass(slot) {
  return generateUtilityClass$1('MuiPickersDay', slot);
}
var pickersDayClasses = generateUtilityClasses$1('MuiPickersDay', ['root', 'dayWithMargin', 'dayOutsideMonth', 'hiddenDaySpacingFiller', 'today', 'selected', 'disabled']);

var _excluded$z = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDayFocus", "onDaySelect", "onFocus", "onKeyDown", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today"];
var useUtilityClasses$4 = function useUtilityClasses(ownerState) {
  var selected = ownerState.selected,
    disableMargin = ownerState.disableMargin,
    disableHighlightToday = ownerState.disableHighlightToday,
    today = ownerState.today,
    outsideCurrentMonth = ownerState.outsideCurrentMonth,
    showDaysOutsideCurrentMonth = ownerState.showDaysOutsideCurrentMonth,
    classes = ownerState.classes;
  var slots = {
    root: ['root', selected && 'selected', !disableMargin && 'dayWithMargin', !disableHighlightToday && today && 'today', outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth'],
    hiddenDaySpacingFiller: ['hiddenDaySpacingFiller']
  };
  return unstable_composeClasses(slots, getPickersDayUtilityClass, classes);
};
var styleArg = function styleArg(_ref) {
  var _focus, _extends2, _ref2;
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$2({}, theme.typography.caption, (_extends2 = {
    width: DAY_SIZE,
    height: DAY_SIZE,
    borderRadius: '50%',
    padding: 0,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
    },
    '&:focus': (_focus = {
      backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
    }, _focus["&." + pickersDayClasses.selected] = {
      willChange: 'background-color',
      backgroundColor: theme.palette.primary.dark
    }, _focus)
  }, _extends2["&." + pickersDayClasses.selected] = {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.short
    }),
    '&:hover': {
      willChange: 'background-color',
      backgroundColor: theme.palette.primary.dark
    }
  }, _extends2["&." + pickersDayClasses.disabled] = {
    color: theme.palette.text.disabled
  }, _extends2), !ownerState.disableMargin && {
    margin: "0 " + DAY_MARGIN + "px"
  }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
    color: theme.palette.text.secondary
  }, !ownerState.disableHighlightToday && ownerState.today && (_ref2 = {}, _ref2["&:not(." + pickersDayClasses.selected + ")"] = {
    border: "1px solid " + theme.palette.text.secondary
  }, _ref2));
};
var overridesResolver = function overridesResolver(props, styles) {
  var ownerState = props.ownerState;
  return [styles.root, !ownerState.disableMargin && styles.dayWithMargin, !ownerState.disableHighlightToday && ownerState.today && styles.today, !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth, ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller];
};
var PickersDayRoot = styled(ButtonBase, {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver: overridesResolver
})(styleArg);
var PickersDayFiller = styled('div', {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver: overridesResolver
})(function (_ref3) {
  var theme = _ref3.theme,
    ownerState = _ref3.ownerState;
  return _extends$2({}, styleArg({
    theme: theme,
    ownerState: ownerState
  }), {
    visibility: 'hidden'
  });
});
var noop$3 = function noop() {};
var PickersDayRaw = /*#__PURE__*/forwardRef(function PickersDay(inProps, forwardedRef) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiPickersDay'
  });
  var _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    className = props.className,
    day = props.day,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$disableHighlig = props.disableHighlightToday,
    disableHighlightToday = _props$disableHighlig === void 0 ? false : _props$disableHighlig,
    _props$disableMargin = props.disableMargin,
    disableMargin = _props$disableMargin === void 0 ? false : _props$disableMargin,
    isAnimating = props.isAnimating,
    onClick = props.onClick,
    _props$onDayFocus = props.onDayFocus,
    onDayFocus = _props$onDayFocus === void 0 ? noop$3 : _props$onDayFocus,
    onDaySelect = props.onDaySelect,
    onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    outsideCurrentMonth = props.outsideCurrentMonth,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    _props$showDaysOutsid = props.showDaysOutsideCurrentMonth,
    showDaysOutsideCurrentMonth = _props$showDaysOutsid === void 0 ? false : _props$showDaysOutsid,
    children = props.children,
    _props$today = props.today,
    isToday = _props$today === void 0 ? false : _props$today,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$z);
  var ownerState = _extends$2({}, props, {
    autoFocus: autoFocus,
    disabled: disabled,
    disableHighlightToday: disableHighlightToday,
    disableMargin: disableMargin,
    selected: selected,
    showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
    today: isToday
  });
  var classes = useUtilityClasses$4(ownerState);
  var utils = useUtils();
  var ref = useRef(null);
  var handleRef = useForkRef$1(ref, forwardedRef);
  useEnhancedEffect$1(function () {
    if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) {
      ref.current.focus();
    }
  }, [autoFocus, disabled, isAnimating, outsideCurrentMonth]);
  var handleFocus = function handleFocus(event) {
    if (onDayFocus) {
      onDayFocus(day);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  var handleClick = function handleClick(event) {
    if (!disabled) {
      onDaySelect(day, 'finish');
    }
    if (onClick) {
      onClick(event);
    }
  };
  var theme = useTheme();
  function handleKeyDown(event) {
    if (onKeyDown !== undefined) {
      onKeyDown(event);
    }
    switch (event.key) {
      case 'ArrowUp':
        onDayFocus(utils.addDays(day, -7));
        event.preventDefault();
        break;
      case 'ArrowDown':
        onDayFocus(utils.addDays(day, 7));
        event.preventDefault();
        break;
      case 'ArrowLeft':
        onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? -1 : 1));
        event.preventDefault();
        break;
      case 'ArrowRight':
        onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? 1 : -1));
        event.preventDefault();
        break;
      case 'Home':
        onDayFocus(utils.startOfWeek(day));
        event.preventDefault();
        break;
      case 'End':
        onDayFocus(utils.endOfWeek(day));
        event.preventDefault();
        break;
      case 'PageUp':
        onDayFocus(utils.getNextMonth(day));
        event.preventDefault();
        break;
      case 'PageDown':
        onDayFocus(utils.getPreviousMonth(day));
        event.preventDefault();
        break;
    }
  }
  if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) {
    return /*#__PURE__*/jsx(PickersDayFiller, {
      className: clsx$1(classes.root, classes.hiddenDaySpacingFiller, className),
      ownerState: ownerState
    });
  }
  return /*#__PURE__*/jsx(PickersDayRoot, _extends$2({
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    ref: handleRef,
    centerRipple: true,
    disabled: disabled,
    "aria-label": !children ? utils.format(day, 'fullDate') : undefined,
    tabIndex: selected ? 0 : -1,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onClick: handleClick
  }, other, {
    children: !children ? utils.format(day, 'dayOfMonth') : children
  }));
});
var areDayPropsEqual = function areDayPropsEqual(prevProps, nextProps) {
  return prevProps.autoFocus === nextProps.autoFocus && prevProps.isAnimating === nextProps.isAnimating && prevProps.today === nextProps.today && prevProps.disabled === nextProps.disabled && prevProps.selected === nextProps.selected && prevProps.disableMargin === nextProps.disableMargin && prevProps.showDaysOutsideCurrentMonth === nextProps.showDaysOutsideCurrentMonth && prevProps.disableHighlightToday === nextProps.disableHighlightToday && prevProps.className === nextProps.className && prevProps.outsideCurrentMonth === nextProps.outsideCurrentMonth && prevProps.onDayFocus === nextProps.onDayFocus && prevProps.onDaySelect === nextProps.onDaySelect;
};
process.env.NODE_ENV !== "production" ? PickersDayRaw.propTypes = {
  classes: propTypes.object,
  day: propTypes.any.isRequired,
  disabled: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disableMargin: propTypes.bool,
  isAnimating: propTypes.bool,
  onDayFocus: propTypes.func,
  onDaySelect: propTypes.func.isRequired,
  outsideCurrentMonth: propTypes.bool.isRequired,
  selected: propTypes.bool,
  showDaysOutsideCurrentMonth: propTypes.bool,
  sx: propTypes.oneOfType([propTypes.arrayOf(propTypes.oneOfType([propTypes.func, propTypes.object, propTypes.bool])), propTypes.func, propTypes.object]),
  today: propTypes.bool
} : void 0;
var PickersDay = /*#__PURE__*/memo(PickersDayRaw, areDayPropsEqual);

var _excluded$A = ["children", "className", "reduceAnimations", "slideDirection", "transKey"];
var classes$2 = generateUtilityClasses$1('PrivatePickersSlideTransition', ['root', 'slideEnter-left', 'slideEnter-right', 'slideEnterActive', 'slideEnterActive', 'slideExit', 'slideExitActiveLeft-left', 'slideExitActiveLeft-right']);
var slideAnimationDuration = 350;
var PickersSlideTransitionRoot = styled(TransitionGroup)(function (_ref2) {
  var _ref3;
  var theme = _ref2.theme;
  var slideTransition = theme.transitions.create('transform', {
    duration: slideAnimationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return _ref3 = {
    display: 'block',
    position: 'relative',
    overflowX: 'hidden',
    '& > *': {
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0
    }
  }, _ref3["& ." + classes$2['slideEnter-left']] = {
    willChange: 'transform',
    transform: 'translate(100%)',
    zIndex: 1
  }, _ref3["& ." + classes$2['slideEnter-right']] = {
    willChange: 'transform',
    transform: 'translate(-100%)',
    zIndex: 1
  }, _ref3["& ." + classes$2.slideEnterActive] = {
    transform: 'translate(0%)',
    transition: slideTransition
  }, _ref3["& ." + classes$2.slideExit] = {
    transform: 'translate(0%)'
  }, _ref3["& ." + classes$2['slideExitActiveLeft-left']] = {
    willChange: 'transform',
    transform: 'translate(-100%)',
    transition: slideTransition,
    zIndex: 0
  }, _ref3["& ." + classes$2['slideExitActiveLeft-right']] = {
    willChange: 'transform',
    transform: 'translate(100%)',
    transition: slideTransition,
    zIndex: 0
  }, _ref3;
});
var PickersSlideTransition = function PickersSlideTransition(_ref) {
  var children = _ref.children,
    className = _ref.className,
    reduceAnimations = _ref.reduceAnimations,
    slideDirection = _ref.slideDirection,
    transKey = _ref.transKey,
    other = _objectWithoutPropertiesLoose$2(_ref, _excluded$A);
  if (reduceAnimations) {
    return /*#__PURE__*/jsx("div", {
      className: clsx$1(classes$2.root, className),
      children: children
    });
  }
  var transitionClasses = {
    exit: classes$2.slideExit,
    enterActive: classes$2.slideEnterActive,
    enter: classes$2["slideEnter-" + slideDirection],
    exitActive: classes$2["slideExitActiveLeft-" + slideDirection]
  };
  return /*#__PURE__*/jsx(PickersSlideTransitionRoot, {
    className: clsx$1(classes$2.root, className),
    childFactory: function childFactory(element) {
      return /*#__PURE__*/cloneElement(element, {
        classNames: transitionClasses
      });
    },
    children: /*#__PURE__*/jsx(CSSTransition, _extends$2({
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: slideAnimationDuration,
      classNames: transitionClasses
    }, other, {
      children: children
    }), transKey)
  });
};

var weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 2) * 6;
var PickersCalendarDayHeader = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
var PickersCalendarWeekDayLabel = styled(Typography)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: 36,
    height: 40,
    margin: '0 2px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.text.secondary
  };
});
var PickersCalendarLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: weeksContainerHeight
});
var PickersCalendarSlideTransition = styled(PickersSlideTransition)({
  minHeight: weeksContainerHeight
});
var PickersCalendarWeekContainer = styled('div')({
  overflow: 'hidden'
});
var PickersCalendarWeek = styled('div')({
  margin: DAY_MARGIN + "px 0",
  display: 'flex',
  justifyContent: 'center'
});
function DayPicker(props) {
  var now = useNow();
  var utils = useUtils();
  var autoFocus = props.autoFocus,
    onFocusedDayChange = props.onFocusedDayChange,
    className = props.className,
    currentMonth = props.currentMonth,
    selectedDays = props.selectedDays,
    disabled = props.disabled,
    disableHighlightToday = props.disableHighlightToday,
    focusedDay = props.focusedDay,
    isMonthSwitchingAnimating = props.isMonthSwitchingAnimating,
    loading = props.loading,
    onSelectedDaysChange = props.onSelectedDaysChange,
    onMonthSwitchingAnimationEnd = props.onMonthSwitchingAnimationEnd,
    readOnly = props.readOnly,
    reduceAnimations = props.reduceAnimations,
    renderDay = props.renderDay,
    _props$renderLoading = props.renderLoading,
    renderLoading = _props$renderLoading === void 0 ? function () {
      return /*#__PURE__*/jsx("span", {
        children: "..."
      });
    } : _props$renderLoading,
    showDaysOutsideCurrentMonth = props.showDaysOutsideCurrentMonth,
    slideDirection = props.slideDirection,
    TransitionProps = props.TransitionProps,
    disablePast = props.disablePast,
    disableFuture = props.disableFuture,
    minDate = props.minDate,
    maxDate = props.maxDate,
    shouldDisableDate = props.shouldDisableDate;
  var isDateDisabled = useIsDayDisabled({
    shouldDisableDate: shouldDisableDate,
    minDate: minDate,
    maxDate: maxDate,
    disablePast: disablePast,
    disableFuture: disableFuture
  });
  var handleDaySelect = useCallback(function (day, isFinish) {
    if (isFinish === void 0) {
      isFinish = 'finish';
    }
    if (readOnly) {
      return;
    }
    onSelectedDaysChange(day, isFinish);
  }, [onSelectedDaysChange, readOnly]);
  var currentMonthNumber = utils.getMonth(currentMonth);
  var validSelectedDays = selectedDays.filter(function (day) {
    return !!day;
  }).map(function (day) {
    return utils.startOfDay(day);
  });
  var transitionKey = currentMonthNumber;
  var slideNodeRef = useMemo(function () {
    return /*#__PURE__*/createRef();
  }, [transitionKey]);
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(PickersCalendarDayHeader, {
      children: utils.getWeekdays().map(function (day, i) {
        return /*#__PURE__*/jsx(PickersCalendarWeekDayLabel, {
          "aria-hidden": true,
          variant: "caption",
          children: day.charAt(0).toUpperCase()
        }, day + i.toString());
      })
    }), loading ? /*#__PURE__*/jsx(PickersCalendarLoadingContainer, {
      children: renderLoading()
    }) : /*#__PURE__*/jsx(PickersCalendarSlideTransition, _extends$2({
      transKey: transitionKey,
      onExited: onMonthSwitchingAnimationEnd,
      reduceAnimations: reduceAnimations,
      slideDirection: slideDirection,
      className: className
    }, TransitionProps, {
      nodeRef: slideNodeRef,
      children: /*#__PURE__*/jsx(PickersCalendarWeekContainer, {
        ref: slideNodeRef,
        role: "grid",
        children: utils.getWeekArray(currentMonth).map(function (week) {
          return /*#__PURE__*/jsx(PickersCalendarWeek, {
            role: "row",
            children: week.map(function (day) {
              var pickersDayProps = {
                key: day == null ? void 0 : day.toString(),
                day: day,
                isAnimating: isMonthSwitchingAnimating,
                disabled: disabled || isDateDisabled(day),
                autoFocus: autoFocus && focusedDay !== null && utils.isSameDay(day, focusedDay),
                today: utils.isSameDay(day, now),
                outsideCurrentMonth: utils.getMonth(day) !== currentMonthNumber,
                selected: validSelectedDays.some(function (selectedDay) {
                  return utils.isSameDay(selectedDay, day);
                }),
                disableHighlightToday: disableHighlightToday,
                showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                onDayFocus: onFocusedDayChange,
                onDaySelect: handleDaySelect
              };
              return renderDay ? renderDay(day, validSelectedDays, pickersDayProps) : /*#__PURE__*/jsx("div", {
                role: "cell",
                children: /*#__PURE__*/jsx(PickersDay, _extends$2({}, pickersDayProps))
              }, pickersDayProps.key);
            })
          }, "week-" + week[0]);
        })
      })
    }))]
  });
}

function useViews(_ref) {
  var onChange = _ref.onChange,
    onViewChange = _ref.onViewChange,
    openTo = _ref.openTo,
    view = _ref.view,
    views = _ref.views;
  var _views, _views2;
  var _useControlled = useControlled({
      name: 'Picker',
      state: 'view',
      controlled: view,
      default: openTo && arrayIncludes(views, openTo) ? openTo : views[0]
    }),
    openView = _useControlled[0],
    setOpenView = _useControlled[1];
  var previousView = (_views = views[views.indexOf(openView) - 1]) != null ? _views : null;
  var nextView = (_views2 = views[views.indexOf(openView) + 1]) != null ? _views2 : null;
  var changeView = useCallback(function (newView) {
    setOpenView(newView);
    if (onViewChange) {
      onViewChange(newView);
    }
  }, [setOpenView, onViewChange]);
  var openNext = useCallback(function () {
    if (nextView) {
      changeView(nextView);
    }
  }, [nextView, changeView]);
  var handleChangeAndOpenNext = useCallback(function (date, currentViewSelectionState) {
    var isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
    var globalSelectionState = isSelectionFinishedOnCurrentView && Boolean(nextView) ? 'partial' : currentViewSelectionState;
    onChange(date, globalSelectionState);
    if (isSelectionFinishedOnCurrentView) {
      openNext();
    }
  }, [nextView, onChange, openNext]);
  return {
    handleChangeAndOpenNext: handleChangeAndOpenNext,
    nextView: nextView,
    previousView: previousView,
    openNext: openNext,
    openView: openView,
    setOpenView: changeView
  };
}

var ArrowDropDown = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
var ArrowLeft = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
var ArrowRight = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
var Calendar = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
var Clock = createSvgIcon( /*#__PURE__*/jsxs(Fragment$1, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Clock');
var DateRange = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
var Pen = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Pen');
var Time = createSvgIcon( /*#__PURE__*/jsxs(Fragment$1, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Time');

var _excluded$B = ["children", "className", "components", "componentsProps", "isLeftDisabled", "isLeftHidden", "isRightDisabled", "isRightHidden", "leftArrowButtonText", "onLeftClick", "onRightClick", "rightArrowButtonText"];
var classes$3 = generateUtilityClasses$1('MuiPickersArrowSwitcher', ['root', 'spacer', 'button']);
var PickersArrowSwitcherRoot = styled('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({
  display: 'flex'
});
var PickersArrowSwitcherSpacer = styled('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Spacer',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.spacer;
  }
})(function (_ref) {
  var theme = _ref.theme;
  return {
    width: theme.spacing(3)
  };
});
var PickersArrowSwitcherButton = styled(IconButton, {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Button',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.button;
  }
})(function (_ref2) {
  var ownerState = _ref2.ownerState;
  return _extends$2({}, ownerState.hidden && {
    visibility: 'hidden'
  });
});
var PickersArrowSwitcher = /*#__PURE__*/forwardRef(function PickersArrowSwitcher(props, ref) {
  var children = props.children,
    className = props.className,
    components = props.components,
    componentsProps = props.componentsProps,
    isLeftDisabled = props.isLeftDisabled,
    isLeftHidden = props.isLeftHidden,
    isRightDisabled = props.isRightDisabled,
    isRightHidden = props.isRightHidden,
    leftArrowButtonText = props.leftArrowButtonText,
    onLeftClick = props.onLeftClick,
    onRightClick = props.onRightClick,
    rightArrowButtonText = props.rightArrowButtonText,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$B);
  var theme = useTheme();
  var isRtl = theme.direction === 'rtl';
  var leftArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.leftArrowButton) || {};
  var LeftArrowIcon = (components == null ? void 0 : components.LeftArrowIcon) || ArrowLeft;
  var rightArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.rightArrowButton) || {};
  var RightArrowIcon = (components == null ? void 0 : components.RightArrowIcon) || ArrowRight;
  var ownerState = props;
  return /*#__PURE__*/jsxs(PickersArrowSwitcherRoot, _extends$2({
    ref: ref,
    className: clsx$1(classes$3.root, className),
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/jsx(PickersArrowSwitcherButton, _extends$2({
      as: components == null ? void 0 : components.LeftArrowButton,
      size: "small",
      "aria-label": leftArrowButtonText,
      title: leftArrowButtonText,
      disabled: isLeftDisabled,
      edge: "end",
      onClick: onLeftClick
    }, leftArrowButtonProps, {
      className: clsx$1(classes$3.button, leftArrowButtonProps.className),
      ownerState: _extends$2({}, ownerState, leftArrowButtonProps, {
        hidden: isLeftHidden
      }),
      children: isRtl ? /*#__PURE__*/jsx(RightArrowIcon, {}) : /*#__PURE__*/jsx(LeftArrowIcon, {})
    })), children ? /*#__PURE__*/jsx(Typography, {
      variant: "subtitle1",
      component: "span",
      children: children
    }) : /*#__PURE__*/jsx(PickersArrowSwitcherSpacer, {
      className: classes$3.spacer,
      ownerState: ownerState
    }), /*#__PURE__*/jsx(PickersArrowSwitcherButton, _extends$2({
      as: components == null ? void 0 : components.RightArrowButton,
      size: "small",
      "aria-label": rightArrowButtonText,
      title: rightArrowButtonText,
      edge: "start",
      disabled: isRightDisabled,
      onClick: onRightClick
    }, rightArrowButtonProps, {
      className: clsx$1(classes$3.button, rightArrowButtonProps.className),
      ownerState: _extends$2({}, ownerState, rightArrowButtonProps, {
        hidden: isRightHidden
      }),
      children: isRtl ? /*#__PURE__*/jsx(LeftArrowIcon, {}) : /*#__PURE__*/jsx(RightArrowIcon, {})
    }))]
  }));
});

var getMeridiem = function getMeridiem(date, utils) {
  if (!date) {
    return null;
  }
  return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var convertValueToMeridiem = function convertValueToMeridiem(value, meridiem, ampm) {
  if (ampm) {
    var currentMeridiem = value >= 12 ? 'pm' : 'am';
    if (currentMeridiem !== meridiem) {
      return meridiem === 'am' ? value - 12 : value + 12;
    }
  }
  return value;
};
var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm, utils) {
  var newHoursAmount = convertValueToMeridiem(utils.getHours(time), meridiem, ampm);
  return utils.setHours(time, newHoursAmount);
};
var getSecondsInDay = function getSecondsInDay(date, utils) {
  return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
var createIsAfterIgnoreDatePart = function createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, utils) {
  if (disableIgnoringDatePartForTimeValidation === void 0) {
    disableIgnoringDatePartForTimeValidation = false;
  }
  return function (dateLeft, dateRight) {
    if (disableIgnoringDatePartForTimeValidation) {
      return utils.isAfter(dateLeft, dateRight);
    }
    return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
  };
};

function useNextMonthDisabled(month, _ref) {
  var disableFuture = _ref.disableFuture,
    maxDate = _ref.maxDate;
  var utils = useUtils();
  return useMemo(function () {
    var now = utils.date();
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    return !utils.isAfter(lastEnabledMonth, month);
  }, [disableFuture, maxDate, month, utils]);
}
function usePreviousMonthDisabled(month, _ref2) {
  var disablePast = _ref2.disablePast,
    minDate = _ref2.minDate;
  var utils = useUtils();
  return useMemo(function () {
    var now = utils.date();
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    return !utils.isBefore(firstEnabledMonth, month);
  }, [disablePast, minDate, month, utils]);
}
function useMeridiemMode(date, ampm, onChange) {
  var utils = useUtils();
  var meridiemMode = getMeridiem(date, utils);
  var handleMeridiemChange = useCallback(function (mode) {
    var timeWithMeridiem = date == null ? null : convertToMeridiem(date, mode, Boolean(ampm), utils);
    onChange(timeWithMeridiem, 'partial');
  }, [ampm, date, onChange, utils]);
  return {
    meridiemMode: meridiemMode,
    handleMeridiemChange: handleMeridiemChange
  };
}

var buildDeprecatedPropsWarning = function buildDeprecatedPropsWarning(message) {
  var alreadyWarned = false;
  if (process.env.NODE_ENV === 'production') {
    return function () {};
  }
  var cleanMessage = Array.isArray(message) ? message.join('\n') : message;
  return function (deprecatedProps) {
    var deprecatedKeys = Object.entries(deprecatedProps).filter(function (_ref) {
      var value = _ref[1];
      return value !== undefined;
    }).map(function (_ref2) {
      var key = _ref2[0];
      return "- " + key;
    });
    if (!alreadyWarned && deprecatedKeys.length > 0) {
      alreadyWarned = true;
      console.warn([cleanMessage, 'deprecated props observed:'].concat(deprecatedKeys).join('\n'));
    }
  };
};

var PickersCalendarHeaderRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  maxHeight: 30,
  minHeight: 30
});
var PickersCalendarHeaderLabel = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _extends$2({
    display: 'flex',
    maxHeight: 30,
    overflow: 'hidden',
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: 'auto'
  }, theme.typography.body1, {
    fontWeight: theme.typography.fontWeightMedium
  });
});
var PickersCalendarHeaderLabelItem = styled('div')({
  marginRight: 6
});
var PickersCalendarHeaderSwitchViewButton = styled(IconButton)({
  marginRight: 'auto'
});
var PickersCalendarHeaderSwitchView = styled(ArrowDropDown)(function (_ref2) {
  var theme = _ref2.theme,
    ownerState = _ref2.ownerState;
  return _extends$2({
    willChange: 'transform',
    transition: theme.transitions.create('transform'),
    transform: 'rotate(0deg)'
  }, ownerState.openView === 'year' && {
    transform: 'rotate(180deg)'
  });
});
var deprecatedPropsWarning = buildDeprecatedPropsWarning('Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.');
function PickersCalendarHeader(props) {
  var _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    _props$componentsProp = props.componentsProps,
    componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
    month = props.currentMonth,
    disabled = props.disabled,
    disableFuture = props.disableFuture,
    disablePast = props.disablePast,
    getViewSwitchingButtonTextProp = props.getViewSwitchingButtonText,
    leftArrowButtonTextProp = props.leftArrowButtonText,
    maxDate = props.maxDate,
    minDate = props.minDate,
    onMonthChange = props.onMonthChange,
    onViewChange = props.onViewChange,
    currentView = props.openView,
    reduceAnimations = props.reduceAnimations,
    rightArrowButtonTextProp = props.rightArrowButtonText,
    views = props.views;
  deprecatedPropsWarning({
    leftArrowButtonText: leftArrowButtonTextProp,
    rightArrowButtonText: rightArrowButtonTextProp,
    getViewSwitchingButtonText: getViewSwitchingButtonTextProp
  });
  var localeText = useLocaleText();
  var leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.previousMonth;
  var rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.nextMonth;
  var getViewSwitchingButtonText = getViewSwitchingButtonTextProp != null ? getViewSwitchingButtonTextProp : localeText.calendarViewSwitchingButtonAriaLabel;
  var utils = useUtils();
  var switchViewButtonProps = componentsProps.switchViewButton || {};
  var selectNextMonth = function selectNextMonth() {
    return onMonthChange(utils.getNextMonth(month), 'left');
  };
  var selectPreviousMonth = function selectPreviousMonth() {
    return onMonthChange(utils.getPreviousMonth(month), 'right');
  };
  var isNextMonthDisabled = useNextMonthDisabled(month, {
    disableFuture: disableFuture,
    maxDate: maxDate
  });
  var isPreviousMonthDisabled = usePreviousMonthDisabled(month, {
    disablePast: disablePast,
    minDate: minDate
  });
  var handleToggleView = function handleToggleView() {
    if (views.length === 1 || !onViewChange || disabled) {
      return;
    }
    if (views.length === 2) {
      onViewChange(views.find(function (view) {
        return view !== currentView;
      }) || views[0]);
    } else {
      var nextIndexToOpen = views.indexOf(currentView) !== 0 ? 0 : 1;
      onViewChange(views[nextIndexToOpen]);
    }
  };
  if (views.length === 1 && views[0] === 'year') {
    return null;
  }
  var ownerState = props;
  return /*#__PURE__*/jsxs(PickersCalendarHeaderRoot, {
    ownerState: ownerState,
    children: [/*#__PURE__*/jsxs(PickersCalendarHeaderLabel, {
      role: "presentation",
      onClick: handleToggleView,
      ownerState: ownerState,
      children: [/*#__PURE__*/jsx(PickersFadeTransitionGroup, {
        reduceAnimations: reduceAnimations,
        transKey: utils.format(month, 'monthAndYear'),
        children: /*#__PURE__*/jsx(PickersCalendarHeaderLabelItem, {
          "aria-live": "polite",
          ownerState: ownerState,
          children: utils.format(month, 'monthAndYear')
        })
      }), views.length > 1 && !disabled && /*#__PURE__*/jsx(PickersCalendarHeaderSwitchViewButton, _extends$2({
        size: "small",
        as: components.SwitchViewButton,
        "aria-label": getViewSwitchingButtonText(currentView)
      }, switchViewButtonProps, {
        children: /*#__PURE__*/jsx(PickersCalendarHeaderSwitchView, {
          as: components.SwitchViewIcon,
          ownerState: ownerState
        })
      }))]
    }), /*#__PURE__*/jsx(Fade, {
      in: currentView === 'day',
      children: /*#__PURE__*/jsx(PickersArrowSwitcher, {
        leftArrowButtonText: leftArrowButtonText,
        rightArrowButtonText: rightArrowButtonText,
        components: components,
        componentsProps: componentsProps,
        onLeftClick: selectPreviousMonth,
        onRightClick: selectNextMonth,
        isLeftDisabled: isPreviousMonthDisabled,
        isRightDisabled: isNextMonthDisabled
      })
    })]
  });
}

var WrapperVariantContext = /*#__PURE__*/createContext(null);

function getPickersYearUtilityClass(slot) {
  return generateUtilityClass$1('PrivatePickersYear', slot);
}
var pickersYearClasses = generateUtilityClasses$1('PrivatePickersYear', ['root', 'modeMobile', 'modeDesktop', 'yearButton', 'disabled', 'selected']);
var useUtilityClasses$5 = function useUtilityClasses(ownerState) {
  var wrapperVariant = ownerState.wrapperVariant,
    disabled = ownerState.disabled,
    selected = ownerState.selected,
    classes = ownerState.classes;
  var slots = {
    root: ['root', wrapperVariant && "mode" + capitalize(wrapperVariant)],
    yearButton: ['yearButton', disabled && 'disabled', selected && 'selected']
  };
  return unstable_composeClasses(slots, getPickersYearUtilityClass, classes);
};
var PickersYearRoot = styled('div')(function (_ref) {
  var ownerState = _ref.ownerState;
  return _extends$2({
    flexBasis: '33.3%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }, (ownerState == null ? void 0 : ownerState.wrapperVariant) === 'desktop' && {
    flexBasis: '25%'
  });
});
var PickersYearButton = styled('button')(function (_ref2) {
  var _extends2;
  var theme = _ref2.theme;
  return _extends$2({
    color: 'unset',
    backgroundColor: 'transparent',
    border: 0,
    outline: 0
  }, theme.typography.subtitle1, (_extends2 = {
    margin: '8px 0',
    height: 36,
    width: 72,
    borderRadius: 18,
    cursor: 'pointer',
    '&:focus, &:hover': {
      backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
    }
  }, _extends2["&." + pickersYearClasses.disabled] = {
    color: theme.palette.text.secondary
  }, _extends2["&." + pickersYearClasses.selected] = {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }, _extends2));
});
var PickersYear = /*#__PURE__*/forwardRef(function PickersYear(props, forwardedRef) {
  var autoFocus = props.autoFocus,
    className = props.className,
    children = props.children,
    disabled = props.disabled,
    _onClick = props.onClick,
    _onKeyDown = props.onKeyDown,
    selected = props.selected,
    value = props.value;
  var ref = useRef(null);
  var refHandle = useForkRef$1(ref, forwardedRef);
  var wrapperVariant = useContext(WrapperVariantContext);
  var ownerState = _extends$2({}, props, {
    wrapperVariant: wrapperVariant
  });
  var classes = useUtilityClasses$5(ownerState);
  useEffect(function () {
    if (autoFocus) {
      ref.current.focus();
    }
  }, [autoFocus]);
  return /*#__PURE__*/jsx(PickersYearRoot, {
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    children: /*#__PURE__*/jsx(PickersYearButton, {
      ref: refHandle,
      disabled: disabled,
      type: "button",
      tabIndex: selected ? 0 : -1,
      onClick: function onClick(event) {
        return _onClick(event, value);
      },
      onKeyDown: function onKeyDown(event) {
        return _onKeyDown(event, value);
      },
      className: classes.yearButton,
      ownerState: ownerState,
      children: children
    })
  });
});

function getYearPickerUtilityClass(slot) {
  return generateUtilityClass$1('MuiYearPicker', slot);
}
var yearPickerClasses = generateUtilityClasses$1('MuiYearPicker', ['root']);

var useUtilityClasses$6 = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes;
  var slots = {
    root: ['root']
  };
  return unstable_composeClasses(slots, getYearPickerUtilityClass, classes);
};
var YearPickerRoot = styled('div', {
  name: 'MuiYearPicker',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  overflowY: 'auto',
  height: '100%',
  margin: '0 4px'
});
var YearPicker = /*#__PURE__*/forwardRef(function YearPicker(inProps, ref) {
  var now = useNow();
  var theme = useTheme();
  var utils = useUtils();
  var defaultProps = useDefaultDates();
  var props = useThemeProps({
    props: inProps,
    name: 'MuiYearPicker'
  });
  var autoFocus = props.autoFocus,
    className = props.className,
    date = props.date,
    disabled = props.disabled,
    disableFuture = props.disableFuture,
    disablePast = props.disablePast,
    _props$maxDate = props.maxDate,
    maxDate = _props$maxDate === void 0 ? defaultProps.maxDate : _props$maxDate,
    _props$minDate = props.minDate,
    minDate = _props$minDate === void 0 ? defaultProps.minDate : _props$minDate,
    onChange = props.onChange,
    readOnly = props.readOnly,
    shouldDisableYear = props.shouldDisableYear;
  var ownerState = props;
  var classes = useUtilityClasses$6(ownerState);
  var selectedDate = date || now;
  var currentYear = utils.getYear(selectedDate);
  var wrapperVariant = useContext(WrapperVariantContext);
  var selectedYearRef = useRef(null);
  var _React$useState = useState(currentYear),
    focusedYear = _React$useState[0],
    setFocusedYear = _React$useState[1];
  var isYearDisabled = useCallback(function (dateToValidate) {
    if (disablePast && utils.isBeforeYear(dateToValidate, now)) {
      return true;
    }
    if (disableFuture && utils.isAfterYear(dateToValidate, now)) {
      return true;
    }
    if (minDate && utils.isBeforeYear(dateToValidate, minDate)) {
      return true;
    }
    if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) {
      return true;
    }
    if (shouldDisableYear && shouldDisableYear(dateToValidate)) {
      return true;
    }
    return false;
  }, [disableFuture, disablePast, maxDate, minDate, now, shouldDisableYear, utils]);
  var handleYearSelection = function handleYearSelection(event, year, isFinish) {
    if (isFinish === void 0) {
      isFinish = 'finish';
    }
    if (readOnly) {
      return;
    }
    var newDate = utils.setYear(selectedDate, year);
    onChange(newDate, isFinish);
  };
  var focusYear = useCallback(function (year) {
    if (!isYearDisabled(utils.setYear(selectedDate, year))) {
      setFocusedYear(year);
    }
  }, [selectedDate, isYearDisabled, utils]);
  var yearsInRow = wrapperVariant === 'desktop' ? 4 : 3;
  var handleKeyDown = function handleKeyDown(event, year) {
    switch (event.key) {
      case 'ArrowUp':
        focusYear(year - yearsInRow);
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusYear(year + yearsInRow);
        event.preventDefault();
        break;
      case 'ArrowLeft':
        focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
        event.preventDefault();
        break;
      case 'ArrowRight':
        focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
        event.preventDefault();
        break;
    }
  };
  return /*#__PURE__*/jsx(YearPickerRoot, {
    ref: ref,
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    children: utils.getYearRange(minDate, maxDate).map(function (year) {
      var yearNumber = utils.getYear(year);
      var selected = yearNumber === currentYear;
      return /*#__PURE__*/jsx(PickersYear, {
        selected: selected,
        value: yearNumber,
        onClick: handleYearSelection,
        onKeyDown: handleKeyDown,
        autoFocus: autoFocus && yearNumber === focusedYear,
        ref: selected ? selectedYearRef : undefined,
        disabled: disabled || isYearDisabled(year),
        children: utils.format(year, 'year')
      }, utils.format(year, 'year'));
    })
  });
});
process.env.NODE_ENV !== "production" ? YearPicker.propTypes = {
  autoFocus: propTypes.bool,
  classes: propTypes.object,
  className: propTypes.string,
  date: propTypes.any,
  disabled: propTypes.bool,
  disableFuture: propTypes.bool,
  disablePast: propTypes.bool,
  maxDate: propTypes.any,
  minDate: propTypes.any,
  onChange: propTypes.func.isRequired,
  onFocusedDayChange: propTypes.func,
  readOnly: propTypes.bool,
  shouldDisableYear: propTypes.func
} : void 0;

var findClosestEnabledDate = function findClosestEnabledDate(_ref) {
  var date = _ref.date,
    disableFuture = _ref.disableFuture,
    disablePast = _ref.disablePast,
    maxDate = _ref.maxDate,
    minDate = _ref.minDate,
    isDateDisabled = _ref.isDateDisabled,
    utils = _ref.utils;
  var today = utils.startOfDay(utils.date());
  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }
  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }
  var forward = date;
  var backward = date;
  if (utils.isBefore(date, minDate)) {
    forward = utils.date(minDate);
    backward = null;
  }
  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = utils.date(maxDate);
    }
    forward = null;
  }
  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }
    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }
    if (forward) {
      if (!isDateDisabled(forward)) {
        return forward;
      }
      forward = utils.addDays(forward, 1);
    }
    if (backward) {
      if (!isDateDisabled(backward)) {
        return backward;
      }
      backward = utils.addDays(backward, -1);
    }
  }
  return null;
};
var parsePickerInputValue = function parsePickerInputValue(utils, value) {
  var parsedValue = utils.date(value);
  return utils.isValid(parsedValue) ? parsedValue : null;
};

var PickerViewRoot = styled('div')({
  overflowX: 'hidden',
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto'
});

var defaultReduceAnimations = typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent);

var getCalendarPickerUtilityClass = function getCalendarPickerUtilityClass(slot) {
  return generateUtilityClass$1('MuiCalendarPicker', slot);
};
var calendarPickerClasses = generateUtilityClasses$1('MuiCalendarPicker', ['root', 'viewTransitionContainer']);

var _excluded$C = ["autoFocus", "onViewChange", "date", "disableFuture", "disablePast", "defaultCalendarMonth", "loading", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "renderLoading", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate"];
var useUtilityClasses$7 = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes;
  var slots = {
    root: ['root'],
    viewTransitionContainer: ['viewTransitionContainer']
  };
  return unstable_composeClasses(slots, getCalendarPickerUtilityClass, classes);
};
var CalendarPickerRoot = styled(PickerViewRoot, {
  name: 'MuiCalendarPicker',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({
  display: 'flex',
  flexDirection: 'column'
});
var CalendarPickerViewTransitionContainer = styled(PickersFadeTransitionGroup, {
  name: 'MuiCalendarPicker',
  slot: 'ViewTransitionContainer',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.viewTransitionContainer;
  }
})({
  overflowY: 'auto'
});
var CalendarPicker = /*#__PURE__*/forwardRef(function CalendarPicker(inProps, ref) {
  var utils = useUtils();
  var defaultDates = useDefaultDates();
  var props = useThemeProps({
    props: inProps,
    name: 'MuiCalendarPicker'
  });
  var autoFocus = props.autoFocus,
    onViewChange = props.onViewChange,
    date = props.date,
    disableFuture = props.disableFuture,
    disablePast = props.disablePast,
    defaultCalendarMonth = props.defaultCalendarMonth,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    onChange = props.onChange,
    onYearChange = props.onYearChange,
    onMonthChange = props.onMonthChange,
    _props$reduceAnimatio = props.reduceAnimations,
    reduceAnimations = _props$reduceAnimatio === void 0 ? defaultReduceAnimations : _props$reduceAnimatio,
    _props$renderLoading = props.renderLoading,
    renderLoading = _props$renderLoading === void 0 ? function () {
      return /*#__PURE__*/jsx("span", {
        children: "..."
      });
    } : _props$renderLoading,
    shouldDisableDate = props.shouldDisableDate,
    shouldDisableMonth = props.shouldDisableMonth,
    shouldDisableYear = props.shouldDisableYear,
    view = props.view,
    _props$views = props.views,
    views = _props$views === void 0 ? ['year', 'day'] : _props$views,
    _props$openTo = props.openTo,
    openTo = _props$openTo === void 0 ? 'day' : _props$openTo,
    className = props.className,
    disabled = props.disabled,
    readOnly = props.readOnly,
    _props$minDate = props.minDate,
    minDate = _props$minDate === void 0 ? defaultDates.minDate : _props$minDate,
    _props$maxDate = props.maxDate,
    maxDate = _props$maxDate === void 0 ? defaultDates.maxDate : _props$maxDate,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$C);
  var _useViews = useViews({
      view: view,
      views: views,
      openTo: openTo,
      onChange: onChange,
      onViewChange: onViewChange
    }),
    openView = _useViews.openView,
    setOpenView = _useViews.setOpenView,
    openNext = _useViews.openNext;
  var _useCalendarState = useCalendarState({
      date: date,
      defaultCalendarMonth: defaultCalendarMonth,
      reduceAnimations: reduceAnimations,
      onMonthChange: onMonthChange,
      minDate: minDate,
      maxDate: maxDate,
      shouldDisableDate: shouldDisableDate,
      disablePast: disablePast,
      disableFuture: disableFuture
    }),
    calendarState = _useCalendarState.calendarState,
    changeFocusedDay = _useCalendarState.changeFocusedDay,
    changeMonth = _useCalendarState.changeMonth,
    handleChangeMonth = _useCalendarState.handleChangeMonth,
    isDateDisabled = _useCalendarState.isDateDisabled,
    onMonthSwitchingAnimationEnd = _useCalendarState.onMonthSwitchingAnimationEnd;
  var handleDateMonthChange = useCallback(function (newDate, selectionState) {
    var startOfMonth = utils.startOfMonth(newDate);
    var endOfMonth = utils.endOfMonth(newDate);
    var closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      utils: utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
      maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
      disablePast: disablePast,
      disableFuture: disableFuture,
      isDateDisabled: isDateDisabled
    }) : newDate;
    if (closestEnabledDate) {
      onChange(closestEnabledDate, selectionState);
      onMonthChange == null ? void 0 : onMonthChange(startOfMonth);
    } else {
      openNext();
      changeMonth(startOfMonth);
    }
    changeFocusedDay(closestEnabledDate);
  }, [changeFocusedDay, disableFuture, disablePast, isDateDisabled, maxDate, minDate, onChange, onMonthChange, changeMonth, openNext, utils]);
  var handleDateYearChange = useCallback(function (newDate, selectionState) {
    var startOfYear = utils.startOfYear(newDate);
    var endOfYear = utils.endOfYear(newDate);
    var closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      utils: utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
      maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
      disablePast: disablePast,
      disableFuture: disableFuture,
      isDateDisabled: isDateDisabled
    }) : newDate;
    if (closestEnabledDate) {
      onChange(closestEnabledDate, selectionState);
      onYearChange == null ? void 0 : onYearChange(closestEnabledDate);
    } else {
      openNext();
      changeMonth(startOfYear);
    }
    changeFocusedDay(closestEnabledDate);
  }, [changeFocusedDay, disableFuture, disablePast, isDateDisabled, maxDate, minDate, onChange, onYearChange, openNext, utils, changeMonth]);
  var onSelectedDayChange = useCallback(function (day, isFinish) {
    if (date && day) {
      return onChange(utils.mergeDateAndTime(day, date), isFinish);
    }
    return onChange(day, isFinish);
  }, [utils, date, onChange]);
  useEffect(function () {
    if (date && isDateDisabled(date)) {
      var closestEnabledDate = findClosestEnabledDate({
        utils: utils,
        date: date,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        isDateDisabled: isDateDisabled
      });
      onChange(closestEnabledDate, 'partial');
    }
  }, []);
  useEffect(function () {
    if (date) {
      changeMonth(date);
    }
  }, [date]);
  var ownerState = props;
  var classes = useUtilityClasses$7(ownerState);
  var baseDateValidationProps = {
    disablePast: disablePast,
    disableFuture: disableFuture,
    maxDate: maxDate,
    minDate: minDate
  };
  var minDateWithDisabled = disabled && date || minDate;
  var maxDateWithDisabled = disabled && date || maxDate;
  return /*#__PURE__*/jsxs(CalendarPickerRoot, {
    ref: ref,
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    children: [/*#__PURE__*/jsx(PickersCalendarHeader, _extends$2({}, other, {
      views: views,
      openView: openView,
      currentMonth: calendarState.currentMonth,
      onViewChange: setOpenView,
      onMonthChange: function onMonthChange(newMonth, direction) {
        return handleChangeMonth({
          newMonth: newMonth,
          direction: direction
        });
      },
      minDate: minDateWithDisabled,
      maxDate: maxDateWithDisabled,
      disabled: disabled,
      disablePast: disablePast,
      disableFuture: disableFuture,
      reduceAnimations: reduceAnimations
    })), /*#__PURE__*/jsx(CalendarPickerViewTransitionContainer, {
      reduceAnimations: reduceAnimations,
      className: classes.viewTransitionContainer,
      transKey: openView,
      ownerState: ownerState,
      children: /*#__PURE__*/jsxs("div", {
        children: [openView === 'year' && /*#__PURE__*/jsx(YearPicker, _extends$2({}, other, baseDateValidationProps, {
          autoFocus: autoFocus,
          date: date,
          onChange: handleDateYearChange,
          shouldDisableYear: shouldDisableYear,
          disabled: disabled,
          readOnly: readOnly
        })), openView === 'month' && /*#__PURE__*/jsx(MonthPicker, _extends$2({}, baseDateValidationProps, {
          className: className,
          date: date,
          onChange: handleDateMonthChange,
          disabled: disabled,
          readOnly: readOnly,
          shouldDisableMonth: shouldDisableMonth
        })), openView === 'day' && /*#__PURE__*/jsx(DayPicker, _extends$2({}, other, calendarState, baseDateValidationProps, {
          autoFocus: autoFocus,
          onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
          onFocusedDayChange: changeFocusedDay,
          reduceAnimations: reduceAnimations,
          selectedDays: [date],
          onSelectedDaysChange: onSelectedDayChange,
          loading: loading,
          renderLoading: renderLoading,
          disabled: disabled,
          readOnly: readOnly,
          shouldDisableDate: shouldDisableDate
        }))]
      })
    })]
  });
});
process.env.NODE_ENV !== "production" ? CalendarPicker.propTypes = {
  autoFocus: propTypes.bool,
  classes: propTypes.object,
  className: propTypes.string,
  components: propTypes.object,
  componentsProps: propTypes.object,
  date: propTypes.any,
  defaultCalendarMonth: propTypes.any,
  disabled: propTypes.bool,
  disableFuture: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disablePast: propTypes.bool,
  getViewSwitchingButtonText: propTypes.func,
  leftArrowButtonText: propTypes.string,
  loading: propTypes.bool,
  maxDate: propTypes.any,
  minDate: propTypes.any,
  onChange: propTypes.func.isRequired,
  onMonthChange: propTypes.func,
  onViewChange: propTypes.func,
  onYearChange: propTypes.func,
  openTo: propTypes.oneOf(['day', 'month', 'year']),
  readOnly: propTypes.bool,
  reduceAnimations: propTypes.bool,
  renderDay: propTypes.func,
  renderLoading: propTypes.func,
  rightArrowButtonText: propTypes.string,
  shouldDisableDate: propTypes.func,
  shouldDisableMonth: propTypes.func,
  shouldDisableYear: propTypes.func,
  showDaysOutsideCurrentMonth: propTypes.bool,
  view: propTypes.oneOf(['day', 'month', 'year']),
  views: propTypes.arrayOf(propTypes.oneOf(['day', 'month', 'year']).isRequired)
} : void 0;

var CLOCK_WIDTH = 220;
var CLOCK_HOUR_WIDTH = 36;
var clockCenter = {
  x: CLOCK_WIDTH / 2,
  y: CLOCK_WIDTH / 2
};
var baseClockPoint = {
  x: clockCenter.x,
  y: 0
};
var cx = baseClockPoint.x - clockCenter.x;
var cy = baseClockPoint.y - clockCenter.y;
var rad2deg = function rad2deg(rad) {
  return rad * (180 / Math.PI);
};
var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
  var x = offsetX - clockCenter.x;
  var y = offsetY - clockCenter.y;
  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
  var deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  var value = Math.floor(deg / step) || 0;
  var delta = Math.pow(x, 2) + Math.pow(y, 2);
  var distance = Math.sqrt(delta);
  return {
    value: value,
    distance: distance
  };
};
var getMinutes = function getMinutes(offsetX, offsetY, step) {
  if (step === void 0) {
    step = 1;
  }
  var angleStep = step * 6;
  var _getAngleValue = getAngleValue(angleStep, offsetX, offsetY),
    value = _getAngleValue.value;
  value = value * step % 60;
  return value;
};
var getHours = function getHours(offsetX, offsetY, ampm) {
  var _getAngleValue2 = getAngleValue(30, offsetX, offsetY),
    value = _getAngleValue2.value,
    distance = _getAngleValue2.distance;
  var hour = value || 12;
  if (!ampm) {
    if (distance < CLOCK_WIDTH / 2 - CLOCK_HOUR_WIDTH) {
      hour += 12;
      hour %= 24;
    }
  } else {
    hour %= 12;
  }
  return hour;
};

var _excluded$D = ["className", "hasSelected", "isInner", "type", "value"];
var ClockPointerRoot = styled('div')(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$2({
    width: 2,
    backgroundColor: theme.palette.primary.main,
    position: 'absolute',
    left: 'calc(50% - 1px)',
    bottom: '50%',
    transformOrigin: 'center bottom 0px'
  }, ownerState.toAnimateTransform && {
    transition: theme.transitions.create(['transform', 'height'])
  });
});
var ClockPointerThumb = styled('div')(function (_ref2) {
  var theme = _ref2.theme,
    ownerState = _ref2.ownerState;
  return _extends$2({
    width: 4,
    height: 4,
    backgroundColor: theme.palette.primary.contrastText,
    borderRadius: '50%',
    position: 'absolute',
    top: -21,
    left: "calc(50% - " + CLOCK_HOUR_WIDTH / 2 + "px)",
    border: (CLOCK_HOUR_WIDTH - 4) / 2 + "px solid " + theme.palette.primary.main,
    boxSizing: 'content-box'
  }, ownerState.hasSelected && {
    backgroundColor: theme.palette.primary.main
  });
});
var ClockPointer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ClockPointer, _React$Component);
  function ClockPointer() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      toAnimateTransform: false,
      previousType: undefined
    };
    return _this;
  }
  var _proto = ClockPointer.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      isInner = _this$props.isInner,
      type = _this$props.type,
      value = _this$props.value,
      other = _objectWithoutPropertiesLoose$2(_this$props, _excluded$D);
    var ownerState = _extends$2({}, this.props, this.state);
    var getAngleStyle = function getAngleStyle() {
      var max = type === 'hours' ? 12 : 60;
      var angle = 360 / max * value;
      if (type === 'hours' && value > 12) {
        angle -= 360;
      }
      return {
        height: Math.round((isInner ? 0.26 : 0.4) * CLOCK_WIDTH),
        transform: "rotateZ(" + angle + "deg)"
      };
    };
    return /*#__PURE__*/jsx(ClockPointerRoot, _extends$2({
      style: getAngleStyle(),
      className: className,
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsx(ClockPointerThumb, {
        ownerState: ownerState
      })
    }));
  };
  return ClockPointer;
}(Component);
ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
  if (nextProps.type !== state.previousType) {
    return {
      toAnimateTransform: true,
      previousType: nextProps.type
    };
  }
  return {
    toAnimateTransform: false,
    previousType: nextProps.type
  };
};

var ClockRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(2)
  };
});
var ClockClock = styled('div')({
  backgroundColor: 'rgba(0,0,0,.07)',
  borderRadius: '50%',
  height: 220,
  width: 220,
  flexShrink: 0,
  position: 'relative',
  pointerEvents: 'none'
});
var ClockSquareMask = styled('div')(function (_ref2) {
  var ownerState = _ref2.ownerState;
  return _extends$2({
    width: '100%',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    outline: 0,
    touchAction: 'none',
    userSelect: 'none'
  }, ownerState.disabled ? {} : {
    '@media (pointer: fine)': {
      cursor: 'pointer',
      borderRadius: '50%'
    },
    '&:active': {
      cursor: 'move'
    }
  });
});
var ClockPin = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
});
var ClockAmButton = styled(IconButton)(function (_ref4) {
  var theme = _ref4.theme,
    ownerState = _ref4.ownerState;
  return _extends$2({
    zIndex: 1,
    position: 'absolute',
    bottom: ownerState.ampmInClock ? 64 : 8,
    left: 8
  }, ownerState.meridiemMode === 'am' && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    }
  });
});
var ClockPmButton = styled(IconButton)(function (_ref5) {
  var theme = _ref5.theme,
    ownerState = _ref5.ownerState;
  return _extends$2({
    zIndex: 1,
    position: 'absolute',
    bottom: ownerState.ampmInClock ? 64 : 8,
    right: 8
  }, ownerState.meridiemMode === 'pm' && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    }
  });
});
function Clock$1(props) {
  var ampm = props.ampm,
    ampmInClock = props.ampmInClock,
    autoFocus = props.autoFocus,
    children = props.children,
    date = props.date,
    getClockLabelText = props.getClockLabelText,
    handleMeridiemChange = props.handleMeridiemChange,
    isTimeDisabled = props.isTimeDisabled,
    meridiemMode = props.meridiemMode,
    _props$minutesStep = props.minutesStep,
    minutesStep = _props$minutesStep === void 0 ? 1 : _props$minutesStep,
    onChange = props.onChange,
    selectedId = props.selectedId,
    type = props.type,
    value = props.value,
    disabled = props.disabled,
    readOnly = props.readOnly;
  var ownerState = props;
  var utils = useUtils();
  var wrapperVariant = useContext(WrapperVariantContext);
  var isMoving = useRef(false);
  var isSelectedTimeDisabled = isTimeDisabled(value, type);
  var isPointerInner = !ampm && type === 'hours' && (value < 1 || value > 12);
  var handleValueChange = function handleValueChange(newValue, isFinish) {
    if (disabled || readOnly) {
      return;
    }
    if (isTimeDisabled(newValue, type)) {
      return;
    }
    onChange(newValue, isFinish);
  };
  var setTime = function setTime(event, isFinish) {
    var offsetX = event.offsetX,
      offsetY = event.offsetY;
    if (offsetX === undefined) {
      var rect = event.target.getBoundingClientRect();
      offsetX = event.changedTouches[0].clientX - rect.left;
      offsetY = event.changedTouches[0].clientY - rect.top;
    }
    var newSelectedValue = type === 'seconds' || type === 'minutes' ? getMinutes(offsetX, offsetY, minutesStep) : getHours(offsetX, offsetY, Boolean(ampm));
    handleValueChange(newSelectedValue, isFinish);
  };
  var handleTouchMove = function handleTouchMove(event) {
    isMoving.current = true;
    setTime(event, 'shallow');
  };
  var handleTouchEnd = function handleTouchEnd(event) {
    if (isMoving.current) {
      setTime(event, 'finish');
      isMoving.current = false;
    }
  };
  var handleMouseMove = function handleMouseMove(event) {
    if (event.buttons > 0) {
      setTime(event.nativeEvent, 'shallow');
    }
  };
  var handleMouseUp = function handleMouseUp(event) {
    if (isMoving.current) {
      isMoving.current = false;
    }
    setTime(event.nativeEvent, 'finish');
  };
  var hasSelected = useMemo(function () {
    if (type === 'hours') {
      return true;
    }
    return value % 5 === 0;
  }, [type, value]);
  var keyboardControlStep = type === 'minutes' ? minutesStep : 1;
  var listboxRef = useRef(null);
  useEnhancedEffect$1(function () {
    if (autoFocus) {
      listboxRef.current.focus();
    }
  }, [autoFocus]);
  var handleKeyDown = function handleKeyDown(event) {
    if (isMoving.current) {
      return;
    }
    switch (event.key) {
      case 'Home':
        handleValueChange(0, 'partial');
        event.preventDefault();
        break;
      case 'End':
        handleValueChange(type === 'minutes' ? 59 : 23, 'partial');
        event.preventDefault();
        break;
      case 'ArrowUp':
        handleValueChange(value + keyboardControlStep, 'partial');
        event.preventDefault();
        break;
      case 'ArrowDown':
        handleValueChange(value - keyboardControlStep, 'partial');
        event.preventDefault();
        break;
    }
  };
  return /*#__PURE__*/jsxs(ClockRoot, {
    children: [/*#__PURE__*/jsxs(ClockClock, {
      children: [/*#__PURE__*/jsx(ClockSquareMask, {
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
        onMouseUp: handleMouseUp,
        onMouseMove: handleMouseMove,
        ownerState: {
          disabled: disabled
        }
      }), !isSelectedTimeDisabled && /*#__PURE__*/jsxs(Fragment$1, {
        children: [/*#__PURE__*/jsx(ClockPin, {}), date && /*#__PURE__*/jsx(ClockPointer, {
          type: type,
          value: value,
          isInner: isPointerInner,
          hasSelected: hasSelected
        })]
      }), /*#__PURE__*/jsx("div", {
        "aria-activedescendant": selectedId,
        "aria-label": getClockLabelText(type, date, utils),
        ref: listboxRef,
        role: "listbox",
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        children: children
      })]
    }), ampm && (wrapperVariant === 'desktop' || ampmInClock) && /*#__PURE__*/jsxs(Fragment$1, {
      children: [/*#__PURE__*/jsx(ClockAmButton, {
        onClick: readOnly ? undefined : function () {
          return handleMeridiemChange('am');
        },
        disabled: disabled || meridiemMode === null,
        ownerState: ownerState,
        children: /*#__PURE__*/jsx(Typography, {
          variant: "caption",
          children: "AM"
        })
      }), /*#__PURE__*/jsx(ClockPmButton, {
        disabled: disabled || meridiemMode === null,
        onClick: readOnly ? undefined : function () {
          return handleMeridiemChange('pm');
        },
        ownerState: ownerState,
        children: /*#__PURE__*/jsx(Typography, {
          variant: "caption",
          children: "PM"
        })
      })]
    })]
  });
}

var _excluded$E = ["className", "disabled", "index", "inner", "label", "selected"];
var classes$4 = generateUtilityClasses$1('PrivateClockNumber', ['selected', 'disabled']);
var ClockNumberRoot = styled('span')(function (_ref) {
  var _extends2;
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$2((_extends2 = {
    height: CLOCK_HOUR_WIDTH,
    width: CLOCK_HOUR_WIDTH,
    position: 'absolute',
    left: "calc((100% - " + CLOCK_HOUR_WIDTH + "px) / 2)",
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    '&:focused': {
      backgroundColor: theme.palette.background.paper
    }
  }, _extends2["&." + classes$4.selected] = {
    color: theme.palette.primary.contrastText
  }, _extends2["&." + classes$4.disabled] = {
    pointerEvents: 'none',
    color: theme.palette.text.disabled
  }, _extends2), ownerState.inner && _extends$2({}, theme.typography.body2, {
    color: theme.palette.text.secondary
  }));
});
function ClockNumber(props) {
  var className = props.className,
    disabled = props.disabled,
    index = props.index,
    inner = props.inner,
    label = props.label,
    selected = props.selected,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$E);
  var ownerState = props;
  var angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
  var length = (CLOCK_WIDTH - CLOCK_HOUR_WIDTH - 2) / 2 * (inner ? 0.65 : 1);
  var x = Math.round(Math.cos(angle) * length);
  var y = Math.round(Math.sin(angle) * length);
  return /*#__PURE__*/jsx(ClockNumberRoot, _extends$2({
    className: clsx$1(className, selected && classes$4.selected, disabled && classes$4.disabled),
    "aria-disabled": disabled ? true : undefined,
    "aria-selected": selected ? true : undefined,
    role: "option",
    style: {
      transform: "translate(" + x + "px, " + (y + (CLOCK_WIDTH - CLOCK_HOUR_WIDTH) / 2) + "px"
    },
    ownerState: ownerState
  }, other, {
    children: label
  }));
}

var getHourNumbers = function getHourNumbers(_ref) {
  var ampm = _ref.ampm,
    date = _ref.date,
    getClockNumberText = _ref.getClockNumberText,
    isDisabled = _ref.isDisabled,
    selectedId = _ref.selectedId,
    utils = _ref.utils;
  var currentHours = date ? utils.getHours(date) : null;
  var hourNumbers = [];
  var startHour = ampm ? 1 : 0;
  var endHour = ampm ? 12 : 23;
  var isSelected = function isSelected(hour) {
    if (currentHours === null) {
      return false;
    }
    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }
      return currentHours === hour || currentHours - 12 === hour;
    }
    return currentHours === hour;
  };
  for (var hour = startHour; hour <= endHour; hour += 1) {
    var label = hour.toString();
    if (hour === 0) {
      label = '00';
    }
    var inner = !ampm && (hour === 0 || hour > 12);
    label = utils.formatNumber(label);
    var selected = isSelected(hour);
    hourNumbers.push( /*#__PURE__*/jsx(ClockNumber, {
      id: selected ? selectedId : undefined,
      index: hour,
      inner: inner,
      selected: selected,
      disabled: isDisabled(hour),
      label: label,
      "aria-label": getClockNumberText(label)
    }, hour));
  }
  return hourNumbers;
};
var getMinutesNumbers = function getMinutesNumbers(_ref2) {
  var utils = _ref2.utils,
    value = _ref2.value,
    isDisabled = _ref2.isDisabled,
    getClockNumberText = _ref2.getClockNumberText,
    selectedId = _ref2.selectedId;
  var f = utils.formatNumber;
  return [[5, f('05')], [10, f('10')], [15, f('15')], [20, f('20')], [25, f('25')], [30, f('30')], [35, f('35')], [40, f('40')], [45, f('45')], [50, f('50')], [55, f('55')], [0, f('00')]].map(function (_ref3, index) {
    var numberValue = _ref3[0],
      label = _ref3[1];
    var selected = numberValue === value;
    return /*#__PURE__*/jsx(ClockNumber, {
      label: label,
      id: selected ? selectedId : undefined,
      index: index + 1,
      inner: false,
      disabled: isDisabled(numberValue),
      selected: selected,
      "aria-label": getClockNumberText(label)
    }, numberValue);
  });
};

function getClockPickerUtilityClass(slot) {
  return generateUtilityClass$1('MuiClockPicker', slot);
}
var clockPickerClasses = generateUtilityClasses$1('MuiClockPicker', ['root', 'arrowSwitcher']);

var useUtilityClasses$8 = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes;
  var slots = {
    root: ['root'],
    arrowSwitcher: ['arrowSwitcher']
  };
  return unstable_composeClasses(slots, getClockPickerUtilityClass, classes);
};
var ClockPickerRoot = styled(PickerViewRoot, {
  name: 'MuiClockPicker',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({
  display: 'flex',
  flexDirection: 'column'
});
var ClockPickerArrowSwitcher = styled(PickersArrowSwitcher, {
  name: 'MuiClockPicker',
  slot: 'ArrowSwitcher',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.arrowSwitcher;
  }
})({
  position: 'absolute',
  right: 12,
  top: 15
});
var deprecatedPropsWarning$1 = buildDeprecatedPropsWarning('Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.');
var ClockPicker = /*#__PURE__*/forwardRef(function ClockPicker(inProps, ref) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiClockPicker'
  });
  var _props$ampm = props.ampm,
    ampm = _props$ampm === void 0 ? false : _props$ampm,
    _props$ampmInClock = props.ampmInClock,
    ampmInClock = _props$ampmInClock === void 0 ? false : _props$ampmInClock,
    autoFocus = props.autoFocus,
    components = props.components,
    componentsProps = props.componentsProps,
    date = props.date,
    disableIgnoringDatePartForTimeValidation = props.disableIgnoringDatePartForTimeValidation,
    getClockLabelTextProp = props.getClockLabelText,
    getHoursClockNumberTextProp = props.getHoursClockNumberText,
    getMinutesClockNumberTextProp = props.getMinutesClockNumberText,
    getSecondsClockNumberTextProp = props.getSecondsClockNumberText,
    leftArrowButtonTextProp = props.leftArrowButtonText,
    maxTime = props.maxTime,
    minTime = props.minTime,
    _props$minutesStep = props.minutesStep,
    minutesStep = _props$minutesStep === void 0 ? 1 : _props$minutesStep,
    rightArrowButtonTextProp = props.rightArrowButtonText,
    shouldDisableTime = props.shouldDisableTime,
    showViewSwitcher = props.showViewSwitcher,
    onChange = props.onChange,
    view = props.view,
    _props$views = props.views,
    views = _props$views === void 0 ? ['hours', 'minutes'] : _props$views,
    openTo = props.openTo,
    onViewChange = props.onViewChange,
    className = props.className,
    disabled = props.disabled,
    readOnly = props.readOnly;
  deprecatedPropsWarning$1({
    leftArrowButtonText: leftArrowButtonTextProp,
    rightArrowButtonText: rightArrowButtonTextProp,
    getClockLabelText: getClockLabelTextProp,
    getHoursClockNumberText: getHoursClockNumberTextProp,
    getMinutesClockNumberText: getMinutesClockNumberTextProp,
    getSecondsClockNumberText: getSecondsClockNumberTextProp
  });
  var localeText = useLocaleText();
  var leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.openPreviousView;
  var rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.openNextView;
  var getClockLabelText = getClockLabelTextProp != null ? getClockLabelTextProp : localeText.clockLabelText;
  var getHoursClockNumberText = getHoursClockNumberTextProp != null ? getHoursClockNumberTextProp : localeText.hoursClockNumberText;
  var getMinutesClockNumberText = getMinutesClockNumberTextProp != null ? getMinutesClockNumberTextProp : localeText.minutesClockNumberText;
  var getSecondsClockNumberText = getSecondsClockNumberTextProp != null ? getSecondsClockNumberTextProp : localeText.secondsClockNumberText;
  var _useViews = useViews({
      view: view,
      views: views,
      openTo: openTo,
      onViewChange: onViewChange,
      onChange: onChange
    }),
    openView = _useViews.openView,
    setOpenView = _useViews.setOpenView,
    nextView = _useViews.nextView,
    previousView = _useViews.previousView,
    handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
  var now = useNow();
  var utils = useUtils();
  var dateOrMidnight = useMemo(function () {
    return date || utils.setSeconds(utils.setMinutes(utils.setHours(now, 0), 0), 0);
  }, [date, now, utils]);
  var _useMeridiemMode = useMeridiemMode(dateOrMidnight, ampm, handleChangeAndOpenNext),
    meridiemMode = _useMeridiemMode.meridiemMode,
    handleMeridiemChange = _useMeridiemMode.handleMeridiemChange;
  var isTimeDisabled = useCallback(function (rawValue, viewType) {
    var isAfter = createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, utils);
    var containsValidTime = function containsValidTime(_ref) {
      var start = _ref.start,
        end = _ref.end;
      if (minTime && isAfter(minTime, end)) {
        return false;
      }
      if (maxTime && isAfter(start, maxTime)) {
        return false;
      }
      return true;
    };
    var isValidValue = function isValidValue(value, step) {
      if (step === void 0) {
        step = 1;
      }
      if (value % step !== 0) {
        return false;
      }
      if (shouldDisableTime) {
        return !shouldDisableTime(value, viewType);
      }
      return true;
    };
    switch (viewType) {
      case 'hours':
        {
          var value = convertValueToMeridiem(rawValue, meridiemMode, ampm);
          var dateWithNewHours = utils.setHours(dateOrMidnight, value);
          var start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
          var end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
          return !containsValidTime({
            start: start,
            end: end
          }) || !isValidValue(value);
        }
      case 'minutes':
        {
          var dateWithNewMinutes = utils.setMinutes(dateOrMidnight, rawValue);
          var _start = utils.setSeconds(dateWithNewMinutes, 0);
          var _end = utils.setSeconds(dateWithNewMinutes, 59);
          return !containsValidTime({
            start: _start,
            end: _end
          }) || !isValidValue(rawValue, minutesStep);
        }
      case 'seconds':
        {
          var dateWithNewSeconds = utils.setSeconds(dateOrMidnight, rawValue);
          var _start2 = dateWithNewSeconds;
          var _end2 = dateWithNewSeconds;
          return !containsValidTime({
            start: _start2,
            end: _end2
          }) || !isValidValue(rawValue);
        }
      default:
        throw new Error('not supported');
    }
  }, [ampm, dateOrMidnight, disableIgnoringDatePartForTimeValidation, maxTime, meridiemMode, minTime, minutesStep, shouldDisableTime, utils]);
  var selectedId = useId$1();
  var viewProps = useMemo(function () {
    switch (openView) {
      case 'hours':
        {
          var handleHoursChange = function handleHoursChange(value, isFinish) {
            var valueWithMeridiem = convertValueToMeridiem(value, meridiemMode, ampm);
            handleChangeAndOpenNext(utils.setHours(dateOrMidnight, valueWithMeridiem), isFinish);
          };
          return {
            onChange: handleHoursChange,
            value: utils.getHours(dateOrMidnight),
            children: getHourNumbers({
              date: date,
              utils: utils,
              ampm: ampm,
              onChange: handleHoursChange,
              getClockNumberText: getHoursClockNumberText,
              isDisabled: function isDisabled(value) {
                return disabled || isTimeDisabled(value, 'hours');
              },
              selectedId: selectedId
            })
          };
        }
      case 'minutes':
        {
          var minutesValue = utils.getMinutes(dateOrMidnight);
          var handleMinutesChange = function handleMinutesChange(value, isFinish) {
            handleChangeAndOpenNext(utils.setMinutes(dateOrMidnight, value), isFinish);
          };
          return {
            value: minutesValue,
            onChange: handleMinutesChange,
            children: getMinutesNumbers({
              utils: utils,
              value: minutesValue,
              onChange: handleMinutesChange,
              getClockNumberText: getMinutesClockNumberText,
              isDisabled: function isDisabled(value) {
                return disabled || isTimeDisabled(value, 'minutes');
              },
              selectedId: selectedId
            })
          };
        }
      case 'seconds':
        {
          var secondsValue = utils.getSeconds(dateOrMidnight);
          var handleSecondsChange = function handleSecondsChange(value, isFinish) {
            handleChangeAndOpenNext(utils.setSeconds(dateOrMidnight, value), isFinish);
          };
          return {
            value: secondsValue,
            onChange: handleSecondsChange,
            children: getMinutesNumbers({
              utils: utils,
              value: secondsValue,
              onChange: handleSecondsChange,
              getClockNumberText: getSecondsClockNumberText,
              isDisabled: function isDisabled(value) {
                return disabled || isTimeDisabled(value, 'seconds');
              },
              selectedId: selectedId
            })
          };
        }
      default:
        throw new Error('You must provide the type for ClockView');
    }
  }, [openView, utils, date, ampm, getHoursClockNumberText, getMinutesClockNumberText, getSecondsClockNumberText, meridiemMode, handleChangeAndOpenNext, dateOrMidnight, isTimeDisabled, selectedId, disabled]);
  var ownerState = props;
  var classes = useUtilityClasses$8(ownerState);
  return /*#__PURE__*/jsxs(ClockPickerRoot, {
    ref: ref,
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    children: [showViewSwitcher && /*#__PURE__*/jsx(ClockPickerArrowSwitcher, {
      className: classes.arrowSwitcher,
      leftArrowButtonText: leftArrowButtonText,
      rightArrowButtonText: rightArrowButtonText,
      components: components,
      componentsProps: componentsProps,
      onLeftClick: function onLeftClick() {
        return setOpenView(previousView);
      },
      onRightClick: function onRightClick() {
        return setOpenView(nextView);
      },
      isLeftDisabled: !previousView,
      isRightDisabled: !nextView,
      ownerState: ownerState
    }), /*#__PURE__*/jsx(Clock$1, _extends$2({
      autoFocus: autoFocus,
      date: date,
      ampmInClock: ampmInClock,
      type: openView,
      ampm: ampm,
      getClockLabelText: getClockLabelText,
      minutesStep: minutesStep,
      isTimeDisabled: isTimeDisabled,
      meridiemMode: meridiemMode,
      handleMeridiemChange: handleMeridiemChange,
      selectedId: selectedId,
      disabled: disabled,
      readOnly: readOnly
    }, viewProps))]
  });
});
process.env.NODE_ENV !== "production" ? ClockPicker.propTypes = {
  ampm: propTypes.bool,
  ampmInClock: propTypes.bool,
  autoFocus: propTypes.bool,
  classes: propTypes.object,
  className: propTypes.string,
  components: propTypes.object,
  componentsProps: propTypes.object,
  date: propTypes.any,
  disabled: propTypes.bool,
  disableIgnoringDatePartForTimeValidation: propTypes.bool,
  getClockLabelText: propTypes.func,
  getHoursClockNumberText: propTypes.func,
  getMinutesClockNumberText: propTypes.func,
  getSecondsClockNumberText: propTypes.func,
  leftArrowButtonText: propTypes.string,
  maxTime: propTypes.any,
  minTime: propTypes.any,
  minutesStep: propTypes.number,
  onChange: propTypes.func.isRequired,
  onViewChange: propTypes.func,
  openTo: propTypes.oneOf(['hours', 'minutes', 'seconds']),
  readOnly: propTypes.bool,
  rightArrowButtonText: propTypes.string,
  shouldDisableTime: propTypes.func,
  showViewSwitcher: propTypes.bool,
  view: propTypes.oneOf(['hours', 'minutes', 'seconds']),
  views: propTypes.arrayOf(propTypes.oneOf(['hours', 'minutes', 'seconds']).isRequired)
} : void 0;

var isYearOnlyView = function isYearOnlyView(views) {
  return views.length === 1 && views[0] === 'year';
};
var isYearAndMonthViews = function isYearAndMonthViews(views) {
  return views.length === 2 && views.indexOf('month') !== -1 && views.indexOf('year') !== -1;
};
var getFormatAndMaskByViews = function getFormatAndMaskByViews(views, utils) {
  if (isYearOnlyView(views)) {
    return {
      inputFormat: utils.formats.year
    };
  }
  if (isYearAndMonthViews(views)) {
    return {
      disableMaskedInput: true,
      inputFormat: utils.formats.monthAndYear
    };
  }
  return {
    inputFormat: utils.formats.keyboardDate
  };
};
function useDatePickerDefaultizedProps(props, name) {
  var _themeProps$views;
  var utils = useUtils();
  var defaultDates = useDefaultDates();
  var themeProps = useThemeProps({
    props: props,
    name: name
  });
  var views = (_themeProps$views = themeProps.views) != null ? _themeProps$views : ['year', 'day'];
  return _extends$2({
    openTo: 'day',
    minDate: defaultDates.minDate,
    maxDate: defaultDates.maxDate
  }, getFormatAndMaskByViews(views, utils), themeProps, {
    views: views
  });
}
var datePickerValueManager = {
  emptyValue: null,
  getTodayValue: function getTodayValue(utils) {
    return utils.date();
  },
  parseInput: parsePickerInputValue,
  areValuesEqual: function areValuesEqual(utils, a, b) {
    return utils.isEqual(a, b);
  }
};

var pickersToolbarClasses = generateUtilityClasses$1('MuiPickersToolbar', ['root', 'content', 'penIconButton', 'penIconButtonLandscape']);
var PickersToolbarRoot = styled('div', {
  name: 'MuiPickersToolbar',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$2({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3)
  }, ownerState.isLandscape && {
    height: 'auto',
    maxWidth: 160,
    padding: 16,
    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  });
});
var PickersToolbarContent = styled(Grid, {
  name: 'MuiPickersToolbar',
  slot: 'Content',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.content;
  }
})({
  flex: 1
});
var PickersToolbarPenIconButton = styled(IconButton, {
  name: 'MuiPickersToolbar',
  slot: 'PenIconButton',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.penIconButton;
  }
})({});
var getViewTypeIcon = function getViewTypeIcon(viewType) {
  return viewType === 'clock' ? /*#__PURE__*/jsx(Clock, {
    color: "inherit"
  }) : /*#__PURE__*/jsx(Calendar, {
    color: "inherit"
  });
};
function defaultGetKeyboardInputSwitchingButtonText(isKeyboardInputOpen, viewType) {
  return isKeyboardInputOpen ? "text input view is open, go to " + viewType + " view" : viewType + " view is open, go to text input view";
}
var PickersToolbar = /*#__PURE__*/forwardRef(function PickersToolbar(props, ref) {
  var children = props.children,
    className = props.className,
    _props$getMobileKeybo = props.getMobileKeyboardInputViewButtonText,
    getMobileKeyboardInputViewButtonText = _props$getMobileKeybo === void 0 ? defaultGetKeyboardInputSwitchingButtonText : _props$getMobileKeybo,
    isLandscape = props.isLandscape,
    isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
    _props$landscapeDirec = props.landscapeDirection,
    landscapeDirection = _props$landscapeDirec === void 0 ? 'column' : _props$landscapeDirec,
    toggleMobileKeyboardView = props.toggleMobileKeyboardView,
    toolbarTitle = props.toolbarTitle,
    _props$viewType = props.viewType,
    viewType = _props$viewType === void 0 ? 'calendar' : _props$viewType;
  var ownerState = props;
  return /*#__PURE__*/jsxs(PickersToolbarRoot, {
    ref: ref,
    className: clsx$1(pickersToolbarClasses.root, className),
    ownerState: ownerState,
    children: [/*#__PURE__*/jsx(Typography, {
      color: "text.secondary",
      variant: "overline",
      children: toolbarTitle
    }), /*#__PURE__*/jsxs(PickersToolbarContent, {
      container: true,
      justifyContent: "space-between",
      className: pickersToolbarClasses.content,
      ownerState: ownerState,
      direction: isLandscape ? landscapeDirection : 'row',
      alignItems: isLandscape ? 'flex-start' : 'flex-end',
      children: [children, /*#__PURE__*/jsx(PickersToolbarPenIconButton, {
        onClick: toggleMobileKeyboardView,
        className: clsx$1(pickersToolbarClasses.penIconButton, isLandscape && pickersToolbarClasses.penIconButtonLandscape),
        ownerState: ownerState,
        color: "inherit",
        "aria-label": getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen, viewType),
        children: isMobileKeyboardViewOpen ? getViewTypeIcon(viewType) : /*#__PURE__*/jsx(Pen, {
          color: "inherit"
        })
      })]
    })]
  });
});

var _styled;
var _excluded$F = ["parsedValue", "isLandscape", "isMobileKeyboardViewOpen", "onChange", "toggleMobileKeyboardView", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"];
var datePickerToolbarClasses = generateUtilityClasses$1('MuiDatePickerToolbar', ['root', 'title']);
var DatePickerToolbarRoot = styled(PickersToolbar, {
  name: 'MuiDatePickerToolbar',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})((_styled = {}, _styled["& ." + pickersToolbarClasses.penIconButton] = {
  position: 'relative',
  top: 4
}, _styled));
var DatePickerToolbarTitle = styled(Typography, {
  name: 'MuiDatePickerToolbar',
  slot: 'Title',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.title;
  }
})(function (_ref) {
  var ownerState = _ref.ownerState;
  return _extends$2({}, ownerState.isLandscape && {
    margin: 'auto 16px auto auto'
  });
});
var DatePickerToolbar = /*#__PURE__*/forwardRef(function DatePickerToolbar(props, ref) {
  var parsedValue = props.parsedValue,
    isLandscape = props.isLandscape,
    isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
    toggleMobileKeyboardView = props.toggleMobileKeyboardView,
    toolbarFormat = props.toolbarFormat,
    _props$toolbarPlaceho = props.toolbarPlaceholder,
    toolbarPlaceholder = _props$toolbarPlaceho === void 0 ? '––' : _props$toolbarPlaceho,
    _props$toolbarTitle = props.toolbarTitle,
    toolbarTitle = _props$toolbarTitle === void 0 ? 'Select date' : _props$toolbarTitle,
    views = props.views,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$F);
  var utils = useUtils();
  var dateText = useMemo(function () {
    if (!parsedValue) {
      return toolbarPlaceholder;
    }
    if (toolbarFormat) {
      return utils.formatByString(parsedValue, toolbarFormat);
    }
    if (isYearOnlyView(views)) {
      return utils.format(parsedValue, 'year');
    }
    if (isYearAndMonthViews(views)) {
      return utils.format(parsedValue, 'month');
    }
    return /en/.test(utils.getCurrentLocaleCode()) ? utils.format(parsedValue, 'normalDateWithWeekday') : utils.format(parsedValue, 'normalDate');
  }, [parsedValue, toolbarFormat, toolbarPlaceholder, utils, views]);
  var ownerState = props;
  return /*#__PURE__*/jsx(DatePickerToolbarRoot, _extends$2({
    ref: ref,
    toolbarTitle: toolbarTitle,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView,
    isLandscape: isLandscape,
    ownerState: ownerState,
    className: datePickerToolbarClasses.root
  }, other, {
    children: /*#__PURE__*/jsx(DatePickerToolbarTitle, {
      variant: "h4",
      align: isLandscape ? 'left' : 'center',
      ownerState: ownerState,
      className: datePickerToolbarClasses.title,
      children: dateText
    })
  }));
});

var PickersActionBar = function PickersActionBar(props) {
  var onAccept = props.onAccept,
    onClear = props.onClear,
    onCancel = props.onCancel,
    onSetToday = props.onSetToday,
    actions = props.actions;
  var wrapperVariant = useContext(WrapperVariantContext);
  var localeText = useLocaleText();
  var actionsArray = typeof actions === 'function' ? actions(wrapperVariant) : actions;
  if (actionsArray == null || actionsArray.length === 0) {
    return null;
  }
  var buttons = actionsArray == null ? void 0 : actionsArray.map(function (actionType) {
    switch (actionType) {
      case 'clear':
        return /*#__PURE__*/jsx(Button, {
          onClick: onClear,
          children: localeText.clearButtonLabel
        }, actionType);
      case 'cancel':
        return /*#__PURE__*/jsx(Button, {
          onClick: onCancel,
          children: localeText.cancelButtonLabel
        }, actionType);
      case 'accept':
        return /*#__PURE__*/jsx(Button, {
          onClick: onAccept,
          children: localeText.okButtonLabel
        }, actionType);
      case 'today':
        return /*#__PURE__*/jsx(Button, {
          onClick: onSetToday,
          children: localeText.todayButtonLabel
        }, actionType);
      default:
        return null;
    }
  });
  return /*#__PURE__*/jsx(DialogActions, {
    children: buttons
  });
};

var _excluded$G = ["onClick", "onTouchStart"];
var PickersPopperRoot = styled(Popper$1)(function (_ref) {
  var theme = _ref.theme;
  return {
    zIndex: theme.zIndex.modal
  };
});
var PickersPopperPaper = styled(Paper)(function (_ref2) {
  var ownerState = _ref2.ownerState;
  return _extends$2({
    transformOrigin: 'top center',
    outline: 0
  }, ownerState.placement === 'top' && {
    transformOrigin: 'bottom center'
  });
});
function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
function useClickAwayListener(active, onClickAway) {
  var movedRef = useRef(false);
  var syntheticEventRef = useRef(false);
  var nodeRef = useRef(null);
  var activatedRef = useRef(false);
  useEffect(function () {
    if (!active) {
      return undefined;
    }
    function armClickAwayListener() {
      activatedRef.current = true;
    }
    document.addEventListener('mousedown', armClickAwayListener, true);
    document.addEventListener('touchstart', armClickAwayListener, true);
    return function () {
      document.removeEventListener('mousedown', armClickAwayListener, true);
      document.removeEventListener('touchstart', armClickAwayListener, true);
      activatedRef.current = false;
    };
  }, [active]);
  var handleClickAway = useEventCallback(function (event) {
    if (!activatedRef.current) {
      return;
    }
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    var doc = ownerDocument$1(nodeRef.current);
    if (!nodeRef.current || 'clientX' in event && clickedRootScrollbar(event, doc)) {
      return;
    }
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    var insideDOM;
    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }
    if (!insideDOM && !insideReactTree) {
      onClickAway(event);
    }
  });
  var handleSynthetic = function handleSynthetic() {
    syntheticEventRef.current = true;
  };
  useEffect(function () {
    if (active) {
      var doc = ownerDocument$1(nodeRef.current);
      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };
      doc.addEventListener('touchstart', handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener('touchstart', handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }
    return undefined;
  }, [active, handleClickAway]);
  useEffect(function () {
    if (active) {
      var doc = ownerDocument$1(nodeRef.current);
      doc.addEventListener('click', handleClickAway);
      return function () {
        doc.removeEventListener('click', handleClickAway);
        syntheticEventRef.current = false;
      };
    }
    return undefined;
  }, [active, handleClickAway]);
  return [nodeRef, handleSynthetic, handleSynthetic];
}
var PickersPopper = function PickersPopper(props) {
  var _components$ActionBar;
  var anchorEl = props.anchorEl,
    _children = props.children,
    _props$containerRef = props.containerRef,
    containerRef = _props$containerRef === void 0 ? null : _props$containerRef,
    onBlur = props.onBlur,
    onClose = props.onClose,
    onClear = props.onClear,
    onAccept = props.onAccept,
    onCancel = props.onCancel,
    onSetToday = props.onSetToday,
    open = props.open,
    PopperProps = props.PopperProps,
    role = props.role,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Grow : _props$TransitionComp,
    TrapFocusProps = props.TrapFocusProps,
    _props$PaperProps = props.PaperProps,
    PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    components = props.components,
    componentsProps = props.componentsProps;
  useEffect(function () {
    function handleKeyDown(nativeEvent) {
      if (open && (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc')) {
        onClose();
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, open]);
  var lastFocusedElementRef = useRef(null);
  useEffect(function () {
    if (role === 'tooltip') {
      return;
    }
    if (open) {
      lastFocusedElementRef.current = document.activeElement;
    } else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) {
      lastFocusedElementRef.current.focus();
    }
  }, [open, role]);
  var _useClickAwayListener = useClickAwayListener(open, onBlur != null ? onBlur : onClose),
    clickAwayRef = _useClickAwayListener[0],
    onPaperClick = _useClickAwayListener[1],
    onPaperTouchStart = _useClickAwayListener[2];
  var paperRef = useRef(null);
  var handleRef = useForkRef$1(paperRef, containerRef);
  var handlePaperRef = useForkRef$1(handleRef, clickAwayRef);
  var ownerState = props;
  var onPaperClickProp = PaperProps.onClick,
    onPaperTouchStartProp = PaperProps.onTouchStart,
    otherPaperProps = _objectWithoutPropertiesLoose$2(PaperProps, _excluded$G);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape') {
      event.stopPropagation();
      onClose();
    }
  };
  var ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : PickersActionBar;
  return /*#__PURE__*/jsx(PickersPopperRoot, _extends$2({
    transition: true,
    role: role,
    open: open,
    anchorEl: anchorEl,
    ownerState: ownerState,
    onKeyDown: handleKeyDown
  }, PopperProps, {
    children: function children(_ref3) {
      var TransitionProps = _ref3.TransitionProps,
        placement = _ref3.placement;
      return /*#__PURE__*/jsx(TrapFocus, _extends$2({
        open: open,
        disableAutoFocus: true,
        disableEnforceFocus: role === 'tooltip',
        isEnabled: function isEnabled() {
          return true;
        }
      }, TrapFocusProps, {
        children: /*#__PURE__*/jsx(TransitionComponent, _extends$2({}, TransitionProps, {
          children: /*#__PURE__*/jsxs(PickersPopperPaper, _extends$2({
            tabIndex: -1,
            elevation: 8,
            ref: handlePaperRef,
            onClick: function onClick(event) {
              onPaperClick(event);
              if (onPaperClickProp) {
                onPaperClickProp(event);
              }
            },
            onTouchStart: function onTouchStart(event) {
              onPaperTouchStart(event);
              if (onPaperTouchStartProp) {
                onPaperTouchStartProp(event);
              }
            },
            ownerState: _extends$2({}, ownerState, {
              placement: placement
            })
          }, otherPaperProps, {
            children: [_children, /*#__PURE__*/jsx(ActionBar, _extends$2({
              onAccept: onAccept,
              onClear: onClear,
              onCancel: onCancel,
              onSetToday: onSetToday,
              actions: []
            }, componentsProps == null ? void 0 : componentsProps.actionBar))]
          }))
        }))
      }));
    }
  }));
};

function DesktopWrapper(props) {
  var children = props.children,
    DateInputProps = props.DateInputProps,
    KeyboardDateInputComponent = props.KeyboardDateInputComponent,
    onClear = props.onClear,
    onDismiss = props.onDismiss,
    onCancel = props.onCancel,
    onAccept = props.onAccept,
    onSetToday = props.onSetToday,
    open = props.open,
    PopperProps = props.PopperProps,
    PaperProps = props.PaperProps,
    TransitionComponent = props.TransitionComponent,
    components = props.components,
    componentsProps = props.componentsProps;
  var ownInputRef = useRef(null);
  var inputRef = useForkRef$1(DateInputProps.inputRef, ownInputRef);
  return /*#__PURE__*/jsxs(WrapperVariantContext.Provider, {
    value: "desktop",
    children: [/*#__PURE__*/jsx(KeyboardDateInputComponent, _extends$2({}, DateInputProps, {
      inputRef: inputRef
    })), /*#__PURE__*/jsx(PickersPopper, {
      role: "dialog",
      open: open,
      anchorEl: ownInputRef.current,
      TransitionComponent: TransitionComponent,
      PopperProps: PopperProps,
      PaperProps: PaperProps,
      onClose: onDismiss,
      onCancel: onCancel,
      onClear: onClear,
      onAccept: onAccept,
      onSetToday: onSetToday,
      components: components,
      componentsProps: componentsProps,
      children: children
    })]
  });
}

var useRifm = function useRifm(props) {
  var _useReducer = useReducer(function (c) {
      return c + 1;
    }, 0),
    refresh = _useReducer[1];
  var valueRef = useRef(null);
  var replace = props.replace,
    append = props.append;
  var userValue = replace ? replace(props.format(props.value)) : props.format(props.value);
  var isDeleleteButtonDownRef = useRef(false);
  var onChange = function onChange(evt) {
    if (process.env.NODE_ENV !== 'production') {
      if (evt.target.type === 'number') {
        console.error('Rifm does not support input type=number, use type=tel instead.');
        return;
      }
      if (evt.target.type === 'date') {
        console.error('Rifm does not support input type=date.');
        return;
      }
    }
    var eventValue = evt.target.value;
    valueRef.current = [eventValue, evt.target, eventValue.length > userValue.length, isDeleleteButtonDownRef.current, userValue === props.format(eventValue)];
    if (process.env.NODE_ENV !== 'production') {
      var formattedEventValue = props.format(eventValue);
      if (eventValue !== formattedEventValue && eventValue.toLowerCase() === formattedEventValue.toLowerCase()) {
        console.warn('Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead');
      }
    }
    refresh();
  };
  if (process.env.NODE_ENV === 'production' || typeof window !== 'undefined') {
    useLayoutEffect(function () {
      if (valueRef.current == null) return;
      var _valueRef$current = valueRef.current,
        eventValue = _valueRef$current[0],
        input = _valueRef$current[1],
        isSizeIncreaseOperation = _valueRef$current[2],
        isDeleleteButtonDown = _valueRef$current[3],
        isNoOperation = _valueRef$current[4];
      valueRef.current = null;
      var deleteWasNoOp = isDeleleteButtonDown && isNoOperation;
      var valueAfterSelectionStart = eventValue.slice(input.selectionStart);
      var acceptedCharIndexAfterDelete = valueAfterSelectionStart.search(props.accept || /\d/g);
      var charsToSkipAfterDelete = acceptedCharIndexAfterDelete !== -1 ? acceptedCharIndexAfterDelete : 0;
      var clean = function clean(str) {
        return (str.match(props.accept || /\d/g) || []).join('');
      };
      var valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart));
      var getCursorPosition = function getCursorPosition(val) {
        var start = 0;
        var cleanPos = 0;
        for (var i = 0; i !== valueBeforeSelectionStart.length; ++i) {
          var newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
          var newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1;
          if (newCleanPos - cleanPos > 1) {
            newPos = start;
            newCleanPos = cleanPos;
          }
          cleanPos = Math.max(newCleanPos, cleanPos);
          start = Math.max(start, newPos);
        }
        return start;
      };
      if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
        var start = getCursorPosition(eventValue);
        var c = clean(eventValue.substr(start))[0];
        start = eventValue.indexOf(c, start);
        eventValue = "" + eventValue.substr(0, start) + eventValue.substr(start + 1);
      }
      var formattedValue = props.format(eventValue);
      if (append != null && input.selectionStart === eventValue.length && !isNoOperation) {
        if (isSizeIncreaseOperation) {
          formattedValue = append(formattedValue);
        } else {
          if (clean(formattedValue.slice(-1)) === '') {
            formattedValue = formattedValue.slice(0, -1);
          }
        }
      }
      var replacedValue = replace ? replace(formattedValue) : formattedValue;
      if (userValue === replacedValue) {
        refresh();
      } else {
        props.onChange(replacedValue);
      }
      return function () {
        var start = getCursorPosition(formattedValue);
        if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) {
          while (formattedValue[start] && clean(formattedValue[start]) === '') {
            start += 1;
          }
        }
        input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 + charsToSkipAfterDelete : 0);
      };
    });
  }
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(evt) {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = true;
      }
    };
    var handleKeyUp = function handleKeyUp(evt) {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = false;
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);
  return {
    value: valueRef.current != null ? valueRef.current[0] : userValue,
    onChange: onChange
  };
};

var getDisplayDate = function getDisplayDate(utils, rawValue, inputFormat) {
  var date = utils.date(rawValue);
  var isEmpty = rawValue === null;
  if (isEmpty) {
    return '';
  }
  return utils.isValid(date) ? utils.formatByString(date, inputFormat) : '';
};
var MASK_USER_INPUT_SYMBOL = '_';
var staticDateWith2DigitTokens = '2019-11-21T22:30:00.000';
var staticDateWith1DigitTokens = '2019-01-01T09:00:00.000';
function getMaskFromCurrentFormat(mask, format, acceptRegex, utils) {
  if (mask) {
    return mask;
  }
  var formattedDateWith1Digit = utils.formatByString(utils.date(staticDateWith1DigitTokens), format);
  var inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, MASK_USER_INPUT_SYMBOL);
  var inferredFormatPatternWith2Digits = utils.formatByString(utils.date(staticDateWith2DigitTokens), format).replace(acceptRegex, '_');
  if (inferredFormatPatternWith1Digits === inferredFormatPatternWith2Digits) {
    return inferredFormatPatternWith1Digits;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.warn(["Mask does not support numbers with variable length such as 'M'.", "Either use numbers with fix length or disable mask feature with 'disableMaskedInput' prop", "Falling down to uncontrolled no-mask input."].join('\n'));
  }
  return '';
}
function checkMaskIsValidForCurrentFormat(mask, format, acceptRegex, utils) {
  if (!mask) {
    return false;
  }
  var formattedDateWith1Digit = utils.formatByString(utils.date(staticDateWith1DigitTokens), format);
  var inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, MASK_USER_INPUT_SYMBOL);
  var inferredFormatPatternWith2Digits = utils.formatByString(utils.date(staticDateWith2DigitTokens), format).replace(acceptRegex, '_');
  var isMaskValid = inferredFormatPatternWith2Digits === inferredFormatPatternWith1Digits && mask === inferredFormatPatternWith2Digits;
  if (!isMaskValid && utils.lib !== 'luxon' && process.env.NODE_ENV !== 'production') {
    if (format.includes('MMM')) {
      console.warn(["Mask does not support literals such as 'MMM'.", "Either use numbers with fix length or disable mask feature with 'disableMaskedInput' prop", "Falling down to uncontrolled no-mask input."].join('\n'));
    } else if (inferredFormatPatternWith2Digits && inferredFormatPatternWith2Digits !== inferredFormatPatternWith1Digits) {
      console.warn(["Mask does not support numbers with variable length such as 'M'.", "Either use numbers with fix length or disable mask feature with 'disableMaskedInput' prop", "Falling down to uncontrolled no-mask input."].join('\n'));
    } else if (mask) {
      console.warn(["The mask \"" + mask + "\" you passed is not valid for the format used " + format + ".", "Falling down to uncontrolled no-mask input."].join('\n'));
    }
  }
  return isMaskValid;
}
var maskedDateFormatter = function maskedDateFormatter(mask, acceptRegexp) {
  return function (value) {
    var outputCharIndex = 0;
    return value.split('').map(function (char, inputCharIndex) {
      acceptRegexp.lastIndex = 0;
      if (outputCharIndex > mask.length - 1) {
        return '';
      }
      var maskChar = mask[outputCharIndex];
      var nextMaskChar = mask[outputCharIndex + 1];
      var acceptedChar = acceptRegexp.test(char) ? char : '';
      var formattedChar = maskChar === MASK_USER_INPUT_SYMBOL ? acceptedChar : maskChar + acceptedChar;
      outputCharIndex += formattedChar.length;
      var isLastCharacter = inputCharIndex === value.length - 1;
      if (isLastCharacter && nextMaskChar && nextMaskChar !== MASK_USER_INPUT_SYMBOL) {
        return formattedChar ? formattedChar + nextMaskChar : '';
      }
      return formattedChar;
    }).join('');
  };
};

var useMaskedInput = function useMaskedInput(_ref) {
  var _ref$acceptRegex = _ref.acceptRegex,
    acceptRegex = _ref$acceptRegex === void 0 ? /[\d]/gi : _ref$acceptRegex,
    disabled = _ref.disabled,
    disableMaskedInput = _ref.disableMaskedInput,
    ignoreInvalidInputs = _ref.ignoreInvalidInputs,
    inputFormat = _ref.inputFormat,
    inputProps = _ref.inputProps,
    label = _ref.label,
    mask = _ref.mask,
    onChange = _ref.onChange,
    rawValue = _ref.rawValue,
    readOnly = _ref.readOnly,
    rifmFormatter = _ref.rifmFormatter,
    TextFieldProps = _ref.TextFieldProps,
    validationError = _ref.validationError;
  var utils = useUtils();
  var formatHelperText = utils.getFormatHelperText(inputFormat);
  var _React$useMemo = useMemo(function () {
      if (disableMaskedInput) {
        return {
          shouldUseMaskedInput: false,
          maskToUse: ''
        };
      }
      var computedMaskToUse = getMaskFromCurrentFormat(mask, inputFormat, acceptRegex, utils);
      return {
        shouldUseMaskedInput: checkMaskIsValidForCurrentFormat(computedMaskToUse, inputFormat, acceptRegex, utils),
        maskToUse: computedMaskToUse
      };
    }, [acceptRegex, disableMaskedInput, inputFormat, mask, utils]),
    shouldUseMaskedInput = _React$useMemo.shouldUseMaskedInput,
    maskToUse = _React$useMemo.maskToUse;
  var formatter = useMemo(function () {
    return shouldUseMaskedInput && maskToUse ? maskedDateFormatter(maskToUse, acceptRegex) : function (st) {
      return st;
    };
  }, [acceptRegex, maskToUse, shouldUseMaskedInput]);
  var parsedValue = rawValue === null ? null : utils.date(rawValue);
  var _React$useState = useState(parsedValue),
    innerInputValue = _React$useState[0],
    setInnerInputValue = _React$useState[1];
  var _React$useState2 = useState(getDisplayDate(utils, rawValue, inputFormat)),
    innerDisplayedInputValue = _React$useState2[0],
    setInnerDisplayedInputValue = _React$useState2[1];
  var prevRawValue = useRef();
  useEffect(function () {
    var rawValueChange = rawValue !== prevRawValue.current;
    prevRawValue.current = rawValue;
    if (!rawValueChange) {
      return;
    }
    var newParsedValue = rawValue === null ? null : utils.date(rawValue);
    var isAcceptedValue = rawValue === null || utils.isValid(newParsedValue);
    if (!isAcceptedValue || utils.isEqual(innerInputValue, newParsedValue)) {
      return;
    }
    var newDisplayDate = getDisplayDate(utils, rawValue, inputFormat);
    setInnerInputValue(newParsedValue);
    setInnerDisplayedInputValue(newDisplayDate);
  }, [utils, rawValue, inputFormat, innerInputValue]);
  var handleChange = function handleChange(text) {
    var finalString = text === '' || text === mask ? '' : text;
    setInnerDisplayedInputValue(finalString);
    var date = finalString === null ? null : utils.parse(finalString, inputFormat);
    if (ignoreInvalidInputs && !utils.isValid(date)) {
      return;
    }
    setInnerInputValue(date);
    onChange(date, finalString || undefined);
  };
  var rifmProps = useRifm({
    value: innerDisplayedInputValue,
    onChange: handleChange,
    format: rifmFormatter || formatter
  });
  var inputStateArgs = shouldUseMaskedInput ? rifmProps : {
    value: innerDisplayedInputValue,
    onChange: function onChange(event) {
      handleChange(event.currentTarget.value);
    }
  };
  return _extends$2({
    label: label,
    disabled: disabled,
    error: validationError,
    inputProps: _extends$2({}, inputStateArgs, {
      disabled: disabled,
      placeholder: formatHelperText,
      readOnly: readOnly,
      type: shouldUseMaskedInput ? 'tel' : 'text'
    }, inputProps)
  }, TextFieldProps);
};

var _excluded$H = ["components", "disableOpenPicker", "getOpenDialogAriaText", "InputAdornmentProps", "InputProps", "inputRef", "openPicker", "OpenPickerButtonProps", "renderInput"];
var KeyboardDateInput = /*#__PURE__*/forwardRef(function KeyboardDateInput(props, ref) {
  var _extends2;
  var _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    disableOpenPicker = props.disableOpenPicker,
    getOpenDialogAriaTextProp = props.getOpenDialogAriaText,
    InputAdornmentProps = props.InputAdornmentProps,
    InputProps = props.InputProps,
    inputRef = props.inputRef,
    openPicker = props.openPicker,
    OpenPickerButtonProps = props.OpenPickerButtonProps,
    renderInput = props.renderInput,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$H);
  var localeText = useLocaleText();
  var getOpenDialogAriaText = getOpenDialogAriaTextProp != null ? getOpenDialogAriaTextProp : localeText.openDatePickerDialogue;
  var utils = useUtils();
  var textFieldProps = useMaskedInput(other);
  var adornmentPosition = (InputAdornmentProps == null ? void 0 : InputAdornmentProps.position) || 'end';
  var OpenPickerIcon = components.OpenPickerIcon || Calendar;
  return renderInput(_extends$2({
    ref: ref,
    inputRef: inputRef
  }, textFieldProps, {
    InputProps: _extends$2({}, InputProps, (_extends2 = {}, _extends2[adornmentPosition + "Adornment"] = disableOpenPicker ? undefined : /*#__PURE__*/jsx(InputAdornment, _extends$2({
      position: adornmentPosition
    }, InputAdornmentProps, {
      children: /*#__PURE__*/jsx(IconButton, _extends$2({
        edge: adornmentPosition,
        disabled: other.disabled || other.readOnly,
        "aria-label": getOpenDialogAriaText(other.rawValue, utils)
      }, OpenPickerButtonProps, {
        onClick: openPicker,
        children: /*#__PURE__*/jsx(OpenPickerIcon, {})
      }))
    })), _extends2))
  }));
});

function getOrientation() {
  if (typeof window === 'undefined') {
    return 'portrait';
  }
  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
  }
  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
  }
  return 'portrait';
}
var useIsLandscape = function useIsLandscape(views, customOrientation) {
  var _React$useState = useState(getOrientation),
    orientation = _React$useState[0],
    setOrientation = _React$useState[1];
  useEnhancedEffect$1(function () {
    var eventHandler = function eventHandler() {
      setOrientation(getOrientation());
    };
    window.addEventListener('orientationchange', eventHandler);
    return function () {
      window.removeEventListener('orientationchange', eventHandler);
    };
  }, []);
  if (arrayIncludes(views, ['hours', 'minutes', 'seconds'])) {
    return false;
  }
  var orientationToUse = customOrientation || orientation;
  return orientationToUse === 'landscape';
};

var _excluded$I = ["autoFocus", "className", "parsedValue", "DateInputProps", "isMobileKeyboardViewOpen", "onDateChange", "onViewChange", "openTo", "orientation", "showToolbar", "toggleMobileKeyboardView", "ToolbarComponent", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"];
var MobileKeyboardInputView = styled('div')({
  padding: '16px 24px'
});
var PickerRoot = styled('div')(function (_ref) {
  var ownerState = _ref.ownerState;
  return _extends$2({
    display: 'flex',
    flexDirection: 'column'
  }, ownerState.isLandscape && {
    flexDirection: 'row'
  });
});
var MobileKeyboardTextFieldProps = {
  fullWidth: true
};
var isDatePickerView = function isDatePickerView(view) {
  return view === 'year' || view === 'month' || view === 'day';
};
var isTimePickerView = function isTimePickerView(view) {
  return view === 'hours' || view === 'minutes' || view === 'seconds';
};
function CalendarOrClockPicker(props) {
  var autoFocus = props.autoFocus,
    parsedValue = props.parsedValue,
    DateInputProps = props.DateInputProps,
    isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
    onDateChange = props.onDateChange,
    onViewChange = props.onViewChange,
    openTo = props.openTo,
    orientation = props.orientation,
    showToolbar = props.showToolbar,
    toggleMobileKeyboardView = props.toggleMobileKeyboardView,
    _props$ToolbarCompone = props.ToolbarComponent,
    ToolbarComponent = _props$ToolbarCompone === void 0 ? function () {
      return null;
    } : _props$ToolbarCompone,
    toolbarFormat = props.toolbarFormat,
    toolbarPlaceholder = props.toolbarPlaceholder,
    toolbarTitle = props.toolbarTitle,
    views = props.views,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$I);
  var isLandscape = useIsLandscape(views, orientation);
  var wrapperVariant = useContext(WrapperVariantContext);
  var toShowToolbar = showToolbar != null ? showToolbar : wrapperVariant !== 'desktop';
  var handleDateChange = useCallback(function (newDate, selectionState) {
    onDateChange(newDate, wrapperVariant, selectionState);
  }, [onDateChange, wrapperVariant]);
  var handleViewChange = useCallback(function (newView) {
    if (isMobileKeyboardViewOpen) {
      toggleMobileKeyboardView();
    }
    if (onViewChange) {
      onViewChange(newView);
    }
  }, [isMobileKeyboardViewOpen, onViewChange, toggleMobileKeyboardView]);
  var _useViews = useViews({
      view: undefined,
      views: views,
      openTo: openTo,
      onChange: handleDateChange,
      onViewChange: handleViewChange
    }),
    openView = _useViews.openView,
    setOpenView = _useViews.setOpenView,
    handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
  return /*#__PURE__*/jsxs(PickerRoot, {
    ownerState: {
      isLandscape: isLandscape
    },
    children: [toShowToolbar && /*#__PURE__*/jsx(ToolbarComponent, _extends$2({}, other, {
      views: views,
      isLandscape: isLandscape,
      parsedValue: parsedValue,
      onChange: handleDateChange,
      setOpenView: setOpenView,
      openView: openView,
      toolbarTitle: toolbarTitle,
      toolbarFormat: toolbarFormat,
      toolbarPlaceholder: toolbarPlaceholder,
      isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
      toggleMobileKeyboardView: toggleMobileKeyboardView
    })), /*#__PURE__*/jsx(PickerViewRoot, {
      children: isMobileKeyboardViewOpen ? /*#__PURE__*/jsx(MobileKeyboardInputView, {
        children: /*#__PURE__*/jsx(KeyboardDateInput, _extends$2({}, DateInputProps, {
          ignoreInvalidInputs: true,
          disableOpenPicker: true,
          TextFieldProps: MobileKeyboardTextFieldProps
        }))
      }) : /*#__PURE__*/jsxs(Fragment$1, {
        children: [isDatePickerView(openView) && /*#__PURE__*/jsx(CalendarPicker, _extends$2({
          autoFocus: autoFocus,
          date: parsedValue,
          onViewChange: setOpenView,
          onChange: handleChangeAndOpenNext,
          view: openView,
          views: views.filter(isDatePickerView)
        }, other)), isTimePickerView(openView) && /*#__PURE__*/jsx(ClockPicker, _extends$2({}, other, {
          autoFocus: autoFocus,
          date: parsedValue,
          view: openView,
          views: views.filter(isTimePickerView),
          onChange: handleChangeAndOpenNext,
          onViewChange: setOpenView,
          showViewSwitcher: wrapperVariant === 'desktop'
        }))]
      })
    })]
  });
}

var useOpenState = function useOpenState(_ref) {
  var open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose;
  var isControllingOpenProp = useRef(typeof open === 'boolean').current;
  var _React$useState = useState(false),
    openState = _React$useState[0],
    setIsOpenState = _React$useState[1];
  useEffect(function () {
    if (isControllingOpenProp) {
      if (typeof open !== 'boolean') {
        throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
      }
      setIsOpenState(open);
    }
  }, [isControllingOpenProp, open]);
  var setIsOpen = useCallback(function (newIsOpen) {
    if (!isControllingOpenProp) {
      setIsOpenState(newIsOpen);
    }
    if (newIsOpen && onOpen) {
      onOpen();
    }
    if (!newIsOpen && onClose) {
      onClose();
    }
  }, [isControllingOpenProp, onOpen, onClose]);
  return {
    isOpen: openState,
    setIsOpen: setIsOpen
  };
};

var usePickerState = function usePickerState(props, valueManager) {
  var onAccept = props.onAccept,
    onChange = props.onChange,
    value = props.value,
    closeOnSelect = props.closeOnSelect;
  var utils = useUtils();
  var _useOpenState = useOpenState(props),
    isOpen = _useOpenState.isOpen,
    setIsOpen = _useOpenState.setIsOpen;
  var parsedDateValue = useMemo(function () {
    return valueManager.parseInput(utils, value);
  }, [valueManager, utils, value]);
  var _React$useState = useState(parsedDateValue),
    lastValidDateValue = _React$useState[0],
    setLastValidDateValue = _React$useState[1];
  var _React$useState2 = useState(function () {
      return {
        committed: parsedDateValue,
        draft: parsedDateValue,
        resetFallback: parsedDateValue
      };
    }),
    dateState = _React$useState2[0],
    setDateState = _React$useState2[1];
  var setDate = useCallback(function (params) {
    setDateState(function (prev) {
      switch (params.action) {
        case 'setAll':
        case 'acceptAndClose':
          {
            return {
              draft: params.value,
              committed: params.value,
              resetFallback: params.value
            };
          }
        case 'setCommitted':
          {
            return _extends$2({}, prev, {
              draft: params.value,
              committed: params.value
            });
          }
        case 'setDraft':
          {
            return _extends$2({}, prev, {
              draft: params.value
            });
          }
        default:
          {
            return prev;
          }
      }
    });
    if (!params.skipOnChangeCall && !valueManager.areValuesEqual(utils, dateState.committed, params.value)) {
      onChange(params.value);
    }
    if (params.action === 'acceptAndClose') {
      setIsOpen(false);
      if (onAccept && !valueManager.areValuesEqual(utils, dateState.resetFallback, params.value)) {
        onAccept(params.value);
      }
    }
  }, [onAccept, onChange, setIsOpen, dateState, utils, valueManager]);
  useEffect(function () {
    if (utils.isValid(parsedDateValue)) {
      setLastValidDateValue(parsedDateValue);
    }
  }, [utils, parsedDateValue]);
  useEffect(function () {
    if (isOpen) {
      setDate({
        action: 'setAll',
        value: parsedDateValue,
        skipOnChangeCall: true
      });
    }
  }, [isOpen]);
  if (!valueManager.areValuesEqual(utils, dateState.committed, parsedDateValue)) {
    setDate({
      action: 'setCommitted',
      value: parsedDateValue,
      skipOnChangeCall: true
    });
  }
  var wrapperProps = useMemo(function () {
    return {
      open: isOpen,
      onClear: function onClear() {
        setDate({
          value: valueManager.emptyValue,
          action: 'acceptAndClose'
        });
      },
      onAccept: function onAccept() {
        setDate({
          value: dateState.draft,
          action: 'acceptAndClose'
        });
      },
      onDismiss: function onDismiss() {
        setDate({
          value: dateState.committed,
          action: 'acceptAndClose'
        });
      },
      onCancel: function onCancel() {
        setDate({
          value: dateState.resetFallback,
          action: 'acceptAndClose'
        });
      },
      onSetToday: function onSetToday() {
        setDate({
          value: valueManager.getTodayValue(utils),
          action: 'acceptAndClose'
        });
      }
    };
  }, [setDate, isOpen, utils, dateState, valueManager]);
  var _React$useState3 = useState(false),
    isMobileKeyboardViewOpen = _React$useState3[0],
    setMobileKeyboardViewOpen = _React$useState3[1];
  var pickerProps = useMemo(function () {
    return {
      parsedValue: dateState.draft,
      isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
      toggleMobileKeyboardView: function toggleMobileKeyboardView() {
        return setMobileKeyboardViewOpen(!isMobileKeyboardViewOpen);
      },
      onDateChange: function onDateChange(newDate, wrapperVariant, selectionState) {
        if (selectionState === void 0) {
          selectionState = 'partial';
        }
        switch (selectionState) {
          case 'shallow':
            {
              return setDate({
                action: 'setDraft',
                value: newDate,
                skipOnChangeCall: true
              });
            }
          case 'partial':
            {
              return setDate({
                action: 'setDraft',
                value: newDate
              });
            }
          case 'finish':
            {
              if (closeOnSelect != null ? closeOnSelect : wrapperVariant === 'desktop') {
                return setDate({
                  value: newDate,
                  action: 'acceptAndClose'
                });
              }
              return setDate({
                value: newDate,
                action: 'setCommitted'
              });
            }
          default:
            {
              throw new Error('MUI: Invalid selectionState passed to `onDateChange`');
            }
        }
      }
    };
  }, [setDate, isMobileKeyboardViewOpen, dateState.draft, closeOnSelect]);
  var handleInputChange = useCallback(function (newParsedValue, keyboardInputValue) {
    var cleanParsedValue = valueManager.valueReducer ? valueManager.valueReducer(utils, lastValidDateValue, newParsedValue) : newParsedValue;
    onChange(cleanParsedValue, keyboardInputValue);
  }, [onChange, valueManager, lastValidDateValue, utils]);
  var inputProps = useMemo(function () {
    return {
      onChange: handleInputChange,
      open: isOpen,
      rawValue: value,
      openPicker: function openPicker() {
        return setIsOpen(true);
      }
    };
  }, [handleInputChange, isOpen, value, setIsOpen]);
  var pickerState = {
    pickerProps: pickerProps,
    inputProps: inputProps,
    wrapperProps: wrapperProps
  };
  useDebugValue(pickerState, function () {
    return {
      MuiPickerState: {
        dateState: dateState,
        other: pickerState
      }
    };
  });
  return pickerState;
};

var _excluded$J = ["onChange", "PopperProps", "PaperProps", "ToolbarComponent", "TransitionComponent", "value", "components", "componentsProps"];
var DesktopDatePicker = /*#__PURE__*/forwardRef(function DesktopDatePicker(inProps, ref) {
  var props = useDatePickerDefaultizedProps(inProps, 'MuiDesktopDatePicker');
  var validationError = useDateValidation(props) !== null;
  var _usePickerState = usePickerState(props, datePickerValueManager),
    pickerProps = _usePickerState.pickerProps,
    inputProps = _usePickerState.inputProps,
    wrapperProps = _usePickerState.wrapperProps;
  var PopperProps = props.PopperProps,
    PaperProps = props.PaperProps,
    _props$ToolbarCompone = props.ToolbarComponent,
    ToolbarComponent = _props$ToolbarCompone === void 0 ? DatePickerToolbar : _props$ToolbarCompone,
    TransitionComponent = props.TransitionComponent,
    components = props.components,
    componentsProps = props.componentsProps,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$J);
  var AllDateInputProps = _extends$2({}, inputProps, other, {
    components: components,
    componentsProps: componentsProps,
    ref: ref,
    validationError: validationError
  });
  return /*#__PURE__*/jsx(DesktopWrapper, _extends$2({}, wrapperProps, {
    DateInputProps: AllDateInputProps,
    KeyboardDateInputComponent: KeyboardDateInput,
    PopperProps: PopperProps,
    PaperProps: PaperProps,
    TransitionComponent: TransitionComponent,
    components: components,
    componentsProps: componentsProps,
    children: /*#__PURE__*/jsx(CalendarOrClockPicker, _extends$2({}, pickerProps, {
      autoFocus: true,
      toolbarTitle: props.label || props.toolbarTitle,
      ToolbarComponent: ToolbarComponent,
      DateInputProps: AllDateInputProps,
      components: components,
      componentsProps: componentsProps
    }, other))
  }));
});
process.env.NODE_ENV !== "production" ? DesktopDatePicker.propTypes = {
  acceptRegex: propTypes.instanceOf(RegExp),
  autoFocus: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string,
  closeOnSelect: propTypes.bool,
  components: propTypes.object,
  componentsProps: propTypes.object,
  defaultCalendarMonth: propTypes.any,
  disabled: propTypes.bool,
  disableFuture: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disableMaskedInput: propTypes.bool,
  disableOpenPicker: propTypes.bool,
  disablePast: propTypes.bool,
  getOpenDialogAriaText: propTypes.func,
  getViewSwitchingButtonText: propTypes.func,
  ignoreInvalidInputs: propTypes.bool,
  InputAdornmentProps: propTypes.object,
  inputFormat: propTypes.string,
  InputProps: propTypes.object,
  inputRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.object
  })]),
  label: propTypes.node,
  leftArrowButtonText: propTypes.string,
  loading: propTypes.bool,
  mask: propTypes.string,
  maxDate: propTypes.any,
  minDate: propTypes.any,
  onAccept: propTypes.func,
  onChange: propTypes.func.isRequired,
  onClose: propTypes.func,
  onError: propTypes.func,
  onMonthChange: propTypes.func,
  onOpen: propTypes.func,
  onViewChange: propTypes.func,
  onYearChange: propTypes.func,
  open: propTypes.bool,
  OpenPickerButtonProps: propTypes.object,
  openTo: propTypes.oneOf(['day', 'month', 'year']),
  orientation: propTypes.oneOf(['landscape', 'portrait']),
  PaperProps: propTypes.object,
  PopperProps: propTypes.object,
  readOnly: propTypes.bool,
  reduceAnimations: propTypes.bool,
  renderDay: propTypes.func,
  renderInput: propTypes.func.isRequired,
  renderLoading: propTypes.func,
  rifmFormatter: propTypes.func,
  rightArrowButtonText: propTypes.string,
  shouldDisableDate: propTypes.func,
  shouldDisableMonth: propTypes.func,
  shouldDisableYear: propTypes.func,
  showDaysOutsideCurrentMonth: propTypes.bool,
  showToolbar: propTypes.bool,
  ToolbarComponent: propTypes.elementType,
  toolbarFormat: propTypes.string,
  toolbarPlaceholder: propTypes.node,
  toolbarTitle: propTypes.node,
  TransitionComponent: propTypes.elementType,
  value: propTypes.any,
  views: propTypes.arrayOf(propTypes.oneOf(['day', 'month', 'year']).isRequired)
} : void 0;

var _styled$1;
var PickersModalDialogRoot = styled(Dialog)((_styled$1 = {}, _styled$1["& ." + dialogClasses.container] = {
  outline: 0
}, _styled$1["& ." + dialogClasses.paper] = {
  outline: 0,
  minWidth: DIALOG_WIDTH
}, _styled$1));
var PickersModalDialogContent = styled(DialogContent)({
  '&:first-of-type': {
    padding: 0
  }
});
var PickersModalDialog = function PickersModalDialog(props) {
  var _components$ActionBar;
  var children = props.children,
    _props$DialogProps = props.DialogProps,
    DialogProps = _props$DialogProps === void 0 ? {} : _props$DialogProps,
    onAccept = props.onAccept,
    onClear = props.onClear,
    onDismiss = props.onDismiss,
    onCancel = props.onCancel,
    onSetToday = props.onSetToday,
    open = props.open,
    components = props.components,
    componentsProps = props.componentsProps;
  var ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : PickersActionBar;
  return /*#__PURE__*/jsxs(PickersModalDialogRoot, _extends$2({
    open: open,
    onClose: onDismiss
  }, DialogProps, {
    children: [/*#__PURE__*/jsx(PickersModalDialogContent, {
      children: children
    }), /*#__PURE__*/jsx(ActionBar, _extends$2({
      onAccept: onAccept,
      onClear: onClear,
      onCancel: onCancel,
      onSetToday: onSetToday,
      actions: ['cancel', 'accept']
    }, componentsProps == null ? void 0 : componentsProps.actionBar))]
  }));
};

var _excluded$K = ["children", "DateInputProps", "DialogProps", "onAccept", "onClear", "onDismiss", "onCancel", "onSetToday", "open", "PureDateInputComponent", "components", "componentsProps"];
function MobileWrapper(props) {
  var children = props.children,
    DateInputProps = props.DateInputProps,
    DialogProps = props.DialogProps,
    onAccept = props.onAccept,
    onClear = props.onClear,
    onDismiss = props.onDismiss,
    onCancel = props.onCancel,
    onSetToday = props.onSetToday,
    open = props.open,
    PureDateInputComponent = props.PureDateInputComponent,
    components = props.components,
    componentsProps = props.componentsProps,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$K);
  return /*#__PURE__*/jsxs(WrapperVariantContext.Provider, {
    value: "mobile",
    children: [/*#__PURE__*/jsx(PureDateInputComponent, _extends$2({
      components: components
    }, other, DateInputProps)), /*#__PURE__*/jsx(PickersModalDialog, {
      DialogProps: DialogProps,
      onAccept: onAccept,
      onClear: onClear,
      onDismiss: onDismiss,
      onCancel: onCancel,
      onSetToday: onSetToday,
      open: open,
      components: components,
      componentsProps: componentsProps,
      children: children
    })]
  });
}

var PureDateInput = /*#__PURE__*/forwardRef(function PureDateInput(props, ref) {
  var disabled = props.disabled,
    getOpenDialogAriaTextProp = props.getOpenDialogAriaText,
    inputFormat = props.inputFormat,
    InputProps = props.InputProps,
    inputRef = props.inputRef,
    label = props.label,
    onOpen = props.openPicker,
    rawValue = props.rawValue,
    renderInput = props.renderInput,
    _props$TextFieldProps = props.TextFieldProps,
    TextFieldProps = _props$TextFieldProps === void 0 ? {} : _props$TextFieldProps,
    validationError = props.validationError;
  var localeText = useLocaleText();
  var getOpenDialogAriaText = getOpenDialogAriaTextProp != null ? getOpenDialogAriaTextProp : localeText.openDatePickerDialogue;
  var utils = useUtils();
  var PureDateInputProps = useMemo(function () {
    return _extends$2({}, InputProps, {
      readOnly: true
    });
  }, [InputProps]);
  var inputValue = getDisplayDate(utils, rawValue, inputFormat);
  return renderInput(_extends$2({
    label: label,
    disabled: disabled,
    ref: ref,
    inputRef: inputRef,
    error: validationError,
    InputProps: PureDateInputProps,
    inputProps: _extends$2({
      disabled: disabled,
      readOnly: true,
      'aria-readonly': true,
      'aria-label': getOpenDialogAriaText(rawValue, utils),
      value: inputValue
    }, !props.readOnly && {
      onClick: onOpen
    }, {
      onKeyDown: onSpaceOrEnter(onOpen)
    })
  }, TextFieldProps));
});

var _excluded$L = ["ToolbarComponent", "value", "onChange", "components", "componentsProps"];
var MobileDatePicker = /*#__PURE__*/forwardRef(function MobileDatePicker(inProps, ref) {
  var props = useDatePickerDefaultizedProps(inProps, 'MuiMobileDatePicker');
  var validationError = useDateValidation(props) !== null;
  var _usePickerState = usePickerState(props, datePickerValueManager),
    pickerProps = _usePickerState.pickerProps,
    inputProps = _usePickerState.inputProps,
    wrapperProps = _usePickerState.wrapperProps;
  var _props$ToolbarCompone = props.ToolbarComponent,
    ToolbarComponent = _props$ToolbarCompone === void 0 ? DatePickerToolbar : _props$ToolbarCompone,
    components = props.components,
    componentsProps = props.componentsProps,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$L);
  var DateInputProps = _extends$2({}, inputProps, other, {
    components: components,
    componentsProps: componentsProps,
    ref: ref,
    validationError: validationError
  });
  return /*#__PURE__*/jsx(MobileWrapper, _extends$2({}, other, wrapperProps, {
    DateInputProps: DateInputProps,
    PureDateInputComponent: PureDateInput,
    components: components,
    componentsProps: componentsProps,
    children: /*#__PURE__*/jsx(CalendarOrClockPicker, _extends$2({}, pickerProps, {
      autoFocus: true,
      toolbarTitle: props.label || props.toolbarTitle,
      ToolbarComponent: ToolbarComponent,
      DateInputProps: DateInputProps,
      components: components,
      componentsProps: componentsProps
    }, other))
  }));
});
process.env.NODE_ENV !== "production" ? MobileDatePicker.propTypes = {
  acceptRegex: propTypes.instanceOf(RegExp),
  autoFocus: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string,
  closeOnSelect: propTypes.bool,
  components: propTypes.object,
  componentsProps: propTypes.object,
  defaultCalendarMonth: propTypes.any,
  DialogProps: propTypes.object,
  disabled: propTypes.bool,
  disableFuture: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disableMaskedInput: propTypes.bool,
  disableOpenPicker: propTypes.bool,
  disablePast: propTypes.bool,
  getOpenDialogAriaText: propTypes.func,
  getViewSwitchingButtonText: propTypes.func,
  ignoreInvalidInputs: propTypes.bool,
  InputAdornmentProps: propTypes.object,
  inputFormat: propTypes.string,
  InputProps: propTypes.object,
  inputRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.object
  })]),
  label: propTypes.node,
  leftArrowButtonText: propTypes.string,
  loading: propTypes.bool,
  mask: propTypes.string,
  maxDate: propTypes.any,
  minDate: propTypes.any,
  onAccept: propTypes.func,
  onChange: propTypes.func.isRequired,
  onClose: propTypes.func,
  onError: propTypes.func,
  onMonthChange: propTypes.func,
  onOpen: propTypes.func,
  onViewChange: propTypes.func,
  onYearChange: propTypes.func,
  open: propTypes.bool,
  OpenPickerButtonProps: propTypes.object,
  openTo: propTypes.oneOf(['day', 'month', 'year']),
  orientation: propTypes.oneOf(['landscape', 'portrait']),
  readOnly: propTypes.bool,
  reduceAnimations: propTypes.bool,
  renderDay: propTypes.func,
  renderInput: propTypes.func.isRequired,
  renderLoading: propTypes.func,
  rifmFormatter: propTypes.func,
  rightArrowButtonText: propTypes.string,
  shouldDisableDate: propTypes.func,
  shouldDisableMonth: propTypes.func,
  shouldDisableYear: propTypes.func,
  showDaysOutsideCurrentMonth: propTypes.bool,
  showToolbar: propTypes.bool,
  ToolbarComponent: propTypes.elementType,
  toolbarFormat: propTypes.string,
  toolbarPlaceholder: propTypes.node,
  toolbarTitle: propTypes.node,
  value: propTypes.any,
  views: propTypes.arrayOf(propTypes.oneOf(['day', 'month', 'year']).isRequired)
} : void 0;

var _excluded$M = ["desktopModeMediaQuery", "DialogProps", "PopperProps", "TransitionComponent"];
var DatePicker = /*#__PURE__*/forwardRef(function DatePicker(inProps, ref) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiDatePicker'
  });
  var _props$desktopModeMed = props.desktopModeMediaQuery,
    desktopModeMediaQuery = _props$desktopModeMed === void 0 ? '@media (pointer: fine)' : _props$desktopModeMed,
    DialogProps = props.DialogProps,
    PopperProps = props.PopperProps,
    TransitionComponent = props.TransitionComponent,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$M);
  var isDesktop = useMediaQuery(desktopModeMediaQuery);
  if (isDesktop) {
    return /*#__PURE__*/jsx(DesktopDatePicker, _extends$2({
      ref: ref,
      PopperProps: PopperProps,
      TransitionComponent: TransitionComponent
    }, other));
  }
  return /*#__PURE__*/jsx(MobileDatePicker, _extends$2({
    ref: ref,
    DialogProps: DialogProps
  }, other));
});
process.env.NODE_ENV !== "production" ? DatePicker.propTypes = {
  acceptRegex: propTypes.instanceOf(RegExp),
  autoFocus: propTypes.bool,
  children: propTypes.node,
  className: propTypes.string,
  closeOnSelect: propTypes.bool,
  components: propTypes.object,
  componentsProps: propTypes.object,
  defaultCalendarMonth: propTypes.any,
  desktopModeMediaQuery: propTypes.string,
  DialogProps: propTypes.object,
  disabled: propTypes.bool,
  disableFuture: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disableMaskedInput: propTypes.bool,
  disableOpenPicker: propTypes.bool,
  disablePast: propTypes.bool,
  getOpenDialogAriaText: propTypes.func,
  getViewSwitchingButtonText: propTypes.func,
  ignoreInvalidInputs: propTypes.bool,
  InputAdornmentProps: propTypes.object,
  inputFormat: propTypes.string,
  InputProps: propTypes.object,
  inputRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.object
  })]),
  label: propTypes.node,
  leftArrowButtonText: propTypes.string,
  loading: propTypes.bool,
  mask: propTypes.string,
  maxDate: propTypes.any,
  minDate: propTypes.any,
  onAccept: propTypes.func,
  onChange: propTypes.func.isRequired,
  onClose: propTypes.func,
  onError: propTypes.func,
  onMonthChange: propTypes.func,
  onOpen: propTypes.func,
  onViewChange: propTypes.func,
  onYearChange: propTypes.func,
  open: propTypes.bool,
  OpenPickerButtonProps: propTypes.object,
  openTo: propTypes.oneOf(['day', 'month', 'year']),
  orientation: propTypes.oneOf(['landscape', 'portrait']),
  PaperProps: propTypes.object,
  PopperProps: propTypes.object,
  readOnly: propTypes.bool,
  reduceAnimations: propTypes.bool,
  renderDay: propTypes.func,
  renderInput: propTypes.func.isRequired,
  renderLoading: propTypes.func,
  rifmFormatter: propTypes.func,
  rightArrowButtonText: propTypes.string,
  shouldDisableDate: propTypes.func,
  shouldDisableMonth: propTypes.func,
  shouldDisableYear: propTypes.func,
  showDaysOutsideCurrentMonth: propTypes.bool,
  showToolbar: propTypes.bool,
  ToolbarComponent: propTypes.elementType,
  toolbarFormat: propTypes.string,
  toolbarPlaceholder: propTypes.node,
  toolbarTitle: propTypes.node,
  TransitionComponent: propTypes.elementType,
  value: propTypes.any,
  views: propTypes.arrayOf(propTypes.oneOf(['day', 'month', 'year']).isRequired)
} : void 0;

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

function addSeconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * 1000);
}

var MILLISECONDS_IN_MINUTE = 60000;
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

var MILLISECONDS_IN_HOUR = 3600000;
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}

function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull));
  return result === 0 ? 0 : result;
}

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign;
    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  }
};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

function differenceInQuarters(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMonths(dateLeft, dateRight) / 3;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}

function differenceInWeeks(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInDays(dateLeft, dateRight) / 7;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;

function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

function eachDayOfInterval(dirtyInterval, options) {
  var _options$step;
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime();
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }
  return dates;
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY$1 = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

var formatters = {
  y: function y(date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
var formatters$1 = {
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  y: function y(date, token, localize) {
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters.y(date, token);
  },
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'Q':
        return String(quarter);
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'q':
        return String(quarter);
      case 'qq':
        return addLeadingZeros(quarter, 2);
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'L':
        return String(month + 1);
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters.d(date, token);
  },
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'e':
        return String(localDayOfWeek);
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'c':
        return String(localDayOfWeek);
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case 'i':
        return String(isoDayOfWeek);
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters.h(date, token);
  },
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters.H(date, token);
  },
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters.m(date, token);
  },
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters.s(date, token);
  },
  S: function S(date, token) {
    return formatters.S(date, token);
  },
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'XXXX':
      case 'XX':
        return formatTimezone(timezoneOffset);
      case 'XXXXX':
      case 'XXX':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'xxxx':
      case 'xx':
        return formatTimezone(timezoneOffset);
      case 'xxxxx':
      case 'xxx':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

function getHours$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}

function isSameHour(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target[property] = object[property];
    }
  }
  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$2(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", 0);
  }
  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);
  var _super = _createSuper(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter);
  function DateToSystemTimezoneSetter() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty(_assertThisInitialized$1(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter;
}(Setter);

var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
    _defineProperty(this, "incompatibleTokens", void 0);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", void 0);
  }
  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();

var EraParser = /*#__PURE__*/function (_Parser) {
  _inherits(EraParser, _Parser);
  var _super = _createSuper(EraParser);
  function EraParser() {
    var _this;
    _classCallCheck(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 140);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  _createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(Parser);

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  date: /^(3[0-1]|[0-2]?\d)/,
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  week: /^(5[0-3]|[0-4]?\d)/,
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  hour11h: /^(1[0-1]|0?\d)/,
  hour12h: /^(1[0-2]|0?\d)/,
  minute: /^[0-5]?\d/,
  second: /^[0-5]?\d/,
  singleDigit: /^\d/,
  twoDigits: /^\d{1,2}/,
  threeDigits: /^\d{1,3}/,
  fourDigits: /^\d{1,4}/,
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  twoDigitsSigned: /^-?\d{1,2}/,
  threeDigitsSigned: /^-?\d{1,3}/,
  fourDigitsSigned: /^-?\d{1,4}/
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

var YearParser = /*#__PURE__*/function (_Parser) {
  _inherits(YearParser, _Parser);
  var _super = _createSuper(YearParser);
  function YearParser() {
    var _this;
    _classCallCheck(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(Parser);

var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekYearParser, _Parser);
  var _super = _createSuper(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(Parser);

var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekYearParser, _Parser);
  var _super = _createSuper(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(Parser);

var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ExtendedYearParser, _Parser);
  var _super = _createSuper(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    _classCallCheck(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(Parser);

var QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(QuarterParser, _Parser);
  var _super = _createSuper(QuarterParser);
  function QuarterParser() {
    var _this;
    _classCallCheck(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'Q':
        case 'QQ':
          return parseNDigits(token.length, dateString);
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(Parser);

var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneQuarterParser, _Parser);
  var _super = _createSuper(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'q':
        case 'qq':
          return parseNDigits(token.length, dateString);
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(Parser);

var MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(MonthParser, _Parser);
  var _super = _createSuper(MonthParser);
  function MonthParser() {
    var _this;
    _classCallCheck(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    _defineProperty(_assertThisInitialized$1(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(Parser);

var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneMonthParser, _Parser);
  var _super = _createSuper(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 110);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(Parser);

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekParser, _Parser);
  var _super = _createSuper(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    _classCallCheck(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(Parser);

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekParser, _Parser);
  var _super = _createSuper(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    _classCallCheck(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value));
    }
  }]);
  return ISOWeekParser;
}(Parser);

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DateParser = /*#__PURE__*/function (_Parser) {
  _inherits(DateParser, _Parser);
  var _super = _createSuper(DateParser);
  function DateParser() {
    var _this;
    _classCallCheck(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "subPriority", 1);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(Parser);

var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayOfYearParser, _Parser);
  var _super = _createSuper(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    _classCallCheck(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "subpriority", 1);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(Parser);

function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

var DayParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayParser, _Parser);
  var _super = _createSuper(DayParser);
  function DayParser() {
    var _this;
    _classCallCheck(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(Parser);

var LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalDayParser, _Parser);
  var _super = _createSuper(LocalDayParser);
  function LocalDayParser() {
    var _this;
    _classCallCheck(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  _createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        case 'e':
        case 'ee':
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(Parser);

var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        case 'c':
        case 'cc':
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(Parser);

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

var ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISODayParser, _Parser);
  var _super = _createSuper(ISODayParser);
  function ISODayParser() {
    var _this;
    _classCallCheck(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        case 'i':
        case 'ii':
          return parseNDigits(token.length, dateString);
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(Parser);

var AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMParser, _Parser);
  var _super = _createSuper(AMPMParser);
  function AMPMParser() {
    var _this;
    _classCallCheck(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(Parser);

var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);
  var _super = _createSuper(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(Parser);

var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayPeriodParser, _Parser);
  var _super = _createSuper(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    _classCallCheck(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  _createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(Parser);

var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1to12Parser, _Parser);
  var _super = _createSuper(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    _classCallCheck(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(Parser);

var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0to23Parser, _Parser);
  var _super = _createSuper(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    _classCallCheck(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(Parser);

var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0To11Parser, _Parser);
  var _super = _createSuper(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    _classCallCheck(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(Parser);

var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1To24Parser, _Parser);
  var _super = _createSuper(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    _classCallCheck(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  _createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(Parser);

var MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits(MinuteParser, _Parser);
  var _super = _createSuper(MinuteParser);
  function MinuteParser() {
    var _this;
    _classCallCheck(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 60);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(Parser);

var SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(SecondParser, _Parser);
  var _super = _createSuper(SecondParser);
  function SecondParser() {
    var _this;
    _classCallCheck(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 50);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(Parser);

var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(FractionOfSecondParser, _Parser);
  var _super = _createSuper(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 30);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(Parser);

var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(Parser);

var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneParser, _Parser);
  var _super = _createSuper(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  _createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(Parser);

var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);
  var _super = _createSuper(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 40);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(Parser);

var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 20);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(Parser);

var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = getDefaultOptions();
  var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale;
  if (!locale$1.match) {
    throw new RangeError('locale must contain match property');
  }
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1
  };
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp$1);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens),
    _step;
  try {
    var _loop = function _loop() {
      var token = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale$1.match, subFnOptions);
        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }
        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString$1(token);
        }
        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign(flags, result[1]);
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear);
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate$1(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN;
  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate$1(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex$1(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex$1(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

function formatISO(date, options) {
  var _options$format, _options$representati;
  requiredArgs(1, arguments);
  var originalDate = toDate(date);
  if (isNaN(originalDate.getTime())) {
    throw new RangeError('Invalid time value');
  }
  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }
  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }
  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : '';
  if (representation !== 'time') {
    var day = addLeadingZeros(originalDate.getDate(), 2);
    var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
    var year = addLeadingZeros(originalDate.getFullYear(), 4);
    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  }
  if (representation !== 'date') {
    var offset = originalDate.getTimezoneOffset();
    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = addLeadingZeros(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }
    var hour = addLeadingZeros(originalDate.getHours(), 2);
    var minute = addLeadingZeros(originalDate.getMinutes(), 2);
    var second = addLeadingZeros(originalDate.getSeconds(), 2);
    var separator = result === '' ? '' : 'T';
    var time = [hour, minute, second].join(timeDelimiter);
    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }
  return result;
}

function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime();
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  return time >= startTime && time <= endTime;
}

var longFormatters_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch (pattern) {
      case 'P':
        return formatLong.date({
          width: 'short'
        });
      case 'PP':
        return formatLong.date({
          width: 'medium'
        });
      case 'PPP':
        return formatLong.date({
          width: 'long'
        });
      case 'PPPP':
      default:
        return formatLong.date({
          width: 'full'
        });
    }
  };
  var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch (pattern) {
      case 'p':
        return formatLong.time({
          width: 'short'
        });
      case 'pp':
        return formatLong.time({
          width: 'medium'
        });
      case 'ppp':
        return formatLong.time({
          width: 'long'
        });
      case 'pppp':
      default:
        return formatLong.time({
          width: 'full'
        });
    }
  };
  var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) {
      return dateLongFormatter(pattern, formatLong);
    }
    var dateTimeFormat;
    switch (datePattern) {
      case 'P':
        dateTimeFormat = formatLong.dateTime({
          width: 'short'
        });
        break;
      case 'PP':
        dateTimeFormat = formatLong.dateTime({
          width: 'medium'
        });
        break;
      case 'PPP':
        dateTimeFormat = formatLong.dateTime({
          width: 'long'
        });
        break;
      case 'PPPP':
      default:
        dateTimeFormat = formatLong.dateTime({
          width: 'full'
        });
        break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
  };
  var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
  };
  var _default = longFormatters;
  exports.default = _default;
  module.exports = exports.default;
});
var longFormatters$1 = unwrapExports(longFormatters_1);

var defaultFormats = {
  dayOfMonth: "d",
  fullDate: "PP",
  fullDateWithWeekday: "PPPP",
  fullDateTime: "PP p",
  fullDateTime12h: "PP hh:mm aaa",
  fullDateTime24h: "PP HH:mm",
  fullTime: "p",
  fullTime12h: "hh:mm aaa",
  fullTime24h: "HH:mm",
  hours12h: "hh",
  hours24h: "HH",
  keyboardDate: "P",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aaa",
  keyboardDateTime24h: "P HH:mm",
  minutes: "mm",
  month: "LLLL",
  monthAndDate: "MMMM d",
  monthAndYear: "LLLL yyyy",
  monthShort: "MMM",
  weekday: "EEEE",
  weekdayShort: "EEE",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  seconds: "ss",
  shortDate: "MMM d",
  year: "yyyy"
};
var DateFnsUtils = function () {
  function DateFnsUtils(_a) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a,
      locale$1 = _b.locale,
      formats = _b.formats;
    this.lib = "date-fns";
    this.is12HourCycleInCurrentLocale = function () {
      if (_this.locale) {
        return /a/.test(_this.locale.formatLong.time());
      }
      return true;
    };
    this.getFormatHelperText = function (format) {
      var longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      var locale$1 = _this.locale || locale;
      return format.match(longFormatRegexp).map(function (token) {
        var firstCharacter = token[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
          var longFormatter = longFormatters$1[firstCharacter];
          return longFormatter(token, locale$1.formatLong, {});
        }
        return token;
      }).join("").replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase();
    };
    this.parseISO = function (isoString) {
      return parseISO(isoString);
    };
    this.toISO = function (value) {
      return formatISO(value, {
        format: "extended"
      });
    };
    this.getCurrentLocaleCode = function () {
      var _a;
      return ((_a = _this.locale) === null || _a === void 0 ? void 0 : _a.code) || "en-US";
    };
    this.addSeconds = function (value, count) {
      return addSeconds(value, count);
    };
    this.addMinutes = function (value, count) {
      return addMinutes(value, count);
    };
    this.addHours = function (value, count) {
      return addHours(value, count);
    };
    this.addDays = function (value, count) {
      return addDays(value, count);
    };
    this.addWeeks = function (value, count) {
      return addWeeks(value, count);
    };
    this.addMonths = function (value, count) {
      return addMonths(value, count);
    };
    this.isValid = function (value) {
      return isValid(_this.date(value));
    };
    this.getDiff = function (value, comparing, unit) {
      switch (unit) {
        case "years":
          return differenceInYears(value, _this.date(comparing));
        case "quarters":
          return differenceInQuarters(value, _this.date(comparing));
        case "months":
          return differenceInMonths(value, _this.date(comparing));
        case "weeks":
          return differenceInWeeks(value, _this.date(comparing));
        case "days":
          return differenceInDays(value, _this.date(comparing));
        case "hours":
          return differenceInHours(value, _this.date(comparing));
        case "minutes":
          return differenceInMinutes(value, _this.date(comparing));
        case "seconds":
          return differenceInSeconds(value, _this.date(comparing));
        default:
          {
            return differenceInMilliseconds(value, _this.date(comparing));
          }
      }
    };
    this.isAfter = function (value, comparing) {
      return isAfter(value, comparing);
    };
    this.isBefore = function (value, comparing) {
      return isBefore(value, comparing);
    };
    this.startOfDay = function (value) {
      return startOfDay(value);
    };
    this.endOfDay = function (value) {
      return endOfDay(value);
    };
    this.getHours = function (value) {
      return getHours$1(value);
    };
    this.setHours = function (value, count) {
      return setHours(value, count);
    };
    this.setMinutes = function (value, count) {
      return setMinutes(value, count);
    };
    this.getSeconds = function (value) {
      return getSeconds(value);
    };
    this.setSeconds = function (value, count) {
      return setSeconds(value, count);
    };
    this.isSameDay = function (value, comparing) {
      return isSameDay(value, comparing);
    };
    this.isSameMonth = function (value, comparing) {
      return isSameMonth(value, comparing);
    };
    this.isSameYear = function (value, comparing) {
      return isSameYear(value, comparing);
    };
    this.isSameHour = function (value, comparing) {
      return isSameHour(value, comparing);
    };
    this.startOfYear = function (value) {
      return startOfYear(value);
    };
    this.endOfYear = function (value) {
      return endOfYear(value);
    };
    this.startOfMonth = function (value) {
      return startOfMonth(value);
    };
    this.endOfMonth = function (value) {
      return endOfMonth(value);
    };
    this.startOfWeek = function (value) {
      return startOfWeek(value, {
        locale: _this.locale
      });
    };
    this.endOfWeek = function (value) {
      return endOfWeek(value, {
        locale: _this.locale
      });
    };
    this.getYear = function (value) {
      return getYear(value);
    };
    this.setYear = function (value, count) {
      return setYear(value, count);
    };
    this.date = function (value) {
      if (typeof value === "undefined") {
        return new Date();
      }
      if (value === null) {
        return null;
      }
      return new Date(value);
    };
    this.toJsDate = function (value) {
      return value;
    };
    this.parse = function (value, formatString) {
      if (value === "") {
        return null;
      }
      return parse(value, formatString, new Date(), {
        locale: _this.locale
      });
    };
    this.format = function (date, formatKey) {
      return _this.formatByString(date, _this.formats[formatKey]);
    };
    this.formatByString = function (date, formatString) {
      return format(date, formatString, {
        locale: _this.locale
      });
    };
    this.isEqual = function (date, comparing) {
      if (date === null && comparing === null) {
        return true;
      }
      return isEqual(date, comparing);
    };
    this.isNull = function (date) {
      return date === null;
    };
    this.isAfterDay = function (date, value) {
      return isAfter(date, endOfDay(value));
    };
    this.isBeforeDay = function (date, value) {
      return isBefore(date, startOfDay(value));
    };
    this.isBeforeYear = function (date, value) {
      return isBefore(date, startOfYear(value));
    };
    this.isAfterYear = function (date, value) {
      return isAfter(date, endOfYear(value));
    };
    this.isWithinRange = function (date, _a) {
      var start = _a[0],
        end = _a[1];
      return isWithinInterval(date, {
        start: start,
        end: end
      });
    };
    this.formatNumber = function (numberToFormat) {
      return numberToFormat;
    };
    this.getMinutes = function (date) {
      return date.getMinutes();
    };
    this.getMonth = function (date) {
      return date.getMonth();
    };
    this.getDaysInMonth = function (date) {
      return getDaysInMonth(date);
    };
    this.setMonth = function (date, count) {
      return setMonth(date, count);
    };
    this.getMeridiemText = function (ampm) {
      return ampm === "am" ? "AM" : "PM";
    };
    this.getNextMonth = function (date) {
      return addMonths(date, 1);
    };
    this.getPreviousMonth = function (date) {
      return addMonths(date, -1);
    };
    this.getMonthArray = function (date) {
      var firstMonth = startOfYear(date);
      var monthArray = [firstMonth];
      while (monthArray.length < 12) {
        var prevMonth = monthArray[monthArray.length - 1];
        monthArray.push(_this.getNextMonth(prevMonth));
      }
      return monthArray;
    };
    this.mergeDateAndTime = function (date, time) {
      return _this.setSeconds(_this.setMinutes(_this.setHours(date, _this.getHours(time)), _this.getMinutes(time)), _this.getSeconds(time));
    };
    this.getWeekdays = function () {
      var now = new Date();
      return eachDayOfInterval({
        start: startOfWeek(now, {
          locale: _this.locale
        }),
        end: endOfWeek(now, {
          locale: _this.locale
        })
      }).map(function (day) {
        return _this.formatByString(day, "EEEEEE");
      });
    };
    this.getWeekArray = function (date) {
      var start = startOfWeek(startOfMonth(date), {
        locale: _this.locale
      });
      var end = endOfWeek(endOfMonth(date), {
        locale: _this.locale
      });
      var count = 0;
      var current = start;
      var nestedWeeks = [];
      var lastDay = null;
      while (isBefore(current, end)) {
        var weekNumber = Math.floor(count / 7);
        nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
        var day = getDay(current);
        if (lastDay !== day) {
          lastDay = day;
          nestedWeeks[weekNumber].push(current);
          count += 1;
        }
        current = addDays(current, 1);
      }
      return nestedWeeks;
    };
    this.getYearRange = function (start, end) {
      var startDate = startOfYear(start);
      var endDate = endOfYear(end);
      var years = [];
      var current = startDate;
      while (isBefore(current, endDate)) {
        years.push(current);
        current = addYears(current, 1);
      }
      return years;
    };
    this.locale = locale$1;
    this.formats = Object.assign({}, defaultFormats, formats);
  }
  return DateFnsUtils;
}();

var DNBDatePickerStyleProps = function DNBDatePickerStyleProps(size) {
  if (size === void 0) {
    size = 'default';
  }
  var baseSize = theme.spacing(size === 'compact' ? 8 : 10);
  var padSize = theme.spacing(size === 'compact' ? 2 : 3);
  var DNBPopperProps = {
    placement: 'bottom-start',
    sx: {
      '& .MuiPaper-root': {
        backgroundColor: theme.colors.ColorBackgroundWhite,
        boxShadow: theme.boxShadows.ShadowPlus2,
        border: theme.borders.BorderThin + " " + theme.colors.ColorGrayIncidental,
        padding: padSize,
        '>div>div': {
          width: 'auto',
          height: 'auto'
        }
      },
      '.MuiCalendarPicker-root': {
        width: 'auto',
        maxWidth: '346px',
        'button.Mui-selected': {
          backgroundColor: theme.colors.ColorPrimaryBlueInteractive
        },
        marginLeft: 0,
        marginRight: 0
      },
      '.MuiTypography-caption': {
        width: baseSize,
        height: baseSize,
        color: theme.colors.ColorGraySecondary
      },
      '.MuiPickersDay-root': {
        width: baseSize,
        height: baseSize,
        '&.Mui-selected': {
          backgroundColor: theme.colors.ColorPrimaryBlueInteractive,
          color: theme.colors.ColorBackgroundWhite,
          '&:focus': {
            backgroundColor: theme.colors.ColorPrimaryBlueInteractive
          }
        }
      },
      '.MuiPickersDay-today': {
        border: theme.borders.BorderThin + " " + theme.colors.ColorGraySecondary
      },
      '.PrivatePickersYear-root > button': {
        borderRadius: theme.borders.BorderRadiusDefault,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.FontSizeBody
      },
      '.MuiDialogActions-root .MuiButton-root': {
        textTransform: 'unset'
      },
      '.MuiButtonBase-root': {
        width: theme.spacing(7),
        height: theme.spacing(7),
        '&.MuiPickersArrowSwitcher-button,&.MuiPickersDay-root': {
          width: baseSize,
          height: baseSize
        }
      },
      '.MuiPickersArrowSwitcher-spacer': {
        height: baseSize,
        width: padSize
      },
      '.PrivatePickersSlideTransition-root': {
        minHeight: size === 'compact' ? '205px;' : '255px'
      },
      '.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
        backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha1,
        '.MuiDateRangePickerDay-dayInsideRangeInterval': {
          color: theme.colors.ColorGrayPrimary
        }
      },
      '.MuiDateRangePickerDay-rangeIntervalDayPreview': {
        border: "2px solid " + theme.colors.ColorGrayPrimaryAlpha1,
        backgroundClip: 'padding-box',
        backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
      },
      '.MuiDateRangePickerDay-rangeIntervalDayPreviewEnd > button': {
        border: 'none',
        backgroundColor: 'transparent'
      }
    }
  };
  var DNBInputAdornmentProps = {
    sx: {
      '.MuiInputAdornment-root': {
        margin: "0 0 0 -" + theme.spacing(3),
        '.MuiButtonBase-root': {
          margin: 0
        }
      }
    }
  };
  return [DNBPopperProps, DNBInputAdornmentProps];
};

var _excluded$N = ["showToday", "size", "onOpen", "onClose"],
  _excluded2$3 = ["InputProps", "inputRef"];
var DNBDatePicker = function DNBDatePicker(_ref) {
  var _ref$showToday = _ref.showToday,
    showToday = _ref$showToday === void 0 ? false : _ref$showToday,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    _onOpen = _ref.onOpen,
    _onClose = _ref.onClose,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$N);
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _DNBDatePickerStylePr = DNBDatePickerStyleProps(size),
    DNBPopperProps = _DNBDatePickerStylePr[0],
    DNBInputAdornmentProps = _DNBDatePickerStylePr[1];
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(LocalizationProvider, {
    dateAdapter: DateFnsUtils
  }, React__default.createElement(DatePicker, Object.assign({}, props, {
    open: open,
    onOpen: function onOpen() {
      setOpen(true);
      if (_onOpen) _onOpen();
    },
    onClose: function onClose() {
      setOpen(false);
      if (_onClose) _onClose();
    },
    renderInput: function renderInput(_ref2) {
      var inputRef = _ref2.inputRef,
        params = _objectWithoutPropertiesLoose(_ref2, _excluded2$3);
      return React__default.createElement(DNBTextField, Object.assign({}, params, {
        InputProps: _extends({}, DNBInputAdornmentProps, {
          startAdornment: React__default.createElement(InputAdornment, {
            position: "start"
          }, React__default.createElement(IconButton, {
            "aria-label": "Choose date"
          }, React__default.createElement(DateRangeOutlinedIcon, {
            fontSize: "small"
          })))
        }),
        onClick: function onClick() {
          return setOpen(true);
        },
        size: size,
        variant: "outlined",
        ref: inputRef
      }));
    }
  }, showToday && {
    componentsProps: {
      actionBar: {
        actions: ['today']
      }
    }
  }, {
    PopperProps: DNBPopperProps
  }))));
};

function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var onSpaceOrEnter$1 = function onSpaceOrEnter(innerFn, onFocus) {
  return function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      innerFn();
      event.preventDefault();
      event.stopPropagation();
    }
    if (onFocus) {
      onFocus(event);
    }
  };
};
var executeInTheNextEventLoopTick = function executeInTheNextEventLoopTick(fn) {
  setTimeout(fn, 0);
};

var getPickersLocalization$1 = function getPickersLocalization(pickersTranslations) {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: _extends$4({}, pickersTranslations)
        }
      }
    }
  };
};

var enUSPickers$1 = {
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  openPreviousView: 'open previous view',
  openNextView: 'open next view',
  calendarViewSwitchingButtonAriaLabel: function calendarViewSwitchingButtonAriaLabel(view) {
    return view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view';
  },
  start: 'Start',
  end: 'End',
  cancelButtonLabel: 'Cancel',
  clearButtonLabel: 'Clear',
  okButtonLabel: 'OK',
  todayButtonLabel: 'Today',
  clockLabelText: function clockLabelText(view, time, adapter) {
    return "Select " + view + ". " + (time === null ? 'No time selected' : "Selected time is " + adapter.format(time, 'fullTime'));
  },
  hoursClockNumberText: function hoursClockNumberText(hours) {
    return hours + " hours";
  },
  minutesClockNumberText: function minutesClockNumberText(minutes) {
    return minutes + " minutes";
  },
  secondsClockNumberText: function secondsClockNumberText(seconds) {
    return seconds + " seconds";
  },
  openDatePickerDialogue: function openDatePickerDialogue(rawValue, utils) {
    return rawValue && utils.isValid(utils.date(rawValue)) ? "Choose date, selected date is " + utils.format(utils.date(rawValue), 'fullDate') : 'Choose date';
  },
  openTimePickerDialogue: function openTimePickerDialogue(rawValue, utils) {
    return rawValue && utils.isValid(utils.date(rawValue)) ? "Choose time, selected time is " + utils.format(utils.date(rawValue), 'fullTime') : 'Choose time';
  },
  timeTableLabel: 'pick time',
  dateTableLabel: 'pick date'
};
var DEFAULT_LOCALE$1 = enUSPickers$1;
var enUS$1 = getPickersLocalization$1(enUSPickers$1);

var MuiPickersAdapterContext$1 = /*#__PURE__*/createContext(null);
if (process.env.NODE_ENV !== 'production') {
  MuiPickersAdapterContext$1.displayName = 'MuiPickersAdapterContext';
}
var warnedOnce$1 = false;
function LocalizationProvider$1(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiLocalizationProvider'
  });
  var children = props.children,
    Utils = props.dateAdapter,
    dateFormats = props.dateFormats,
    dateLibInstance = props.dateLibInstance,
    locale = props.locale,
    adapterLocale = props.adapterLocale,
    localeText = props.localeText;
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnce$1 && locale !== undefined) {
      warnedOnce$1 = true;
      console.warn("LocalizationProvider's prop `locale` is deprecated and replaced by `adapterLocale`");
    }
  }
  var utils = useMemo(function () {
    return new Utils({
      locale: adapterLocale != null ? adapterLocale : locale,
      formats: dateFormats,
      instance: dateLibInstance
    });
  }, [Utils, locale, adapterLocale, dateFormats, dateLibInstance]);
  var defaultDates = useMemo(function () {
    return {
      minDate: utils.date('1900-01-01T00:00:00.000'),
      maxDate: utils.date('2099-12-31T00:00:00.000')
    };
  }, [utils]);
  var contextValue = useMemo(function () {
    return {
      utils: utils,
      defaultDates: defaultDates,
      localeText: _extends$4({}, DEFAULT_LOCALE$1, localeText != null ? localeText : {})
    };
  }, [defaultDates, utils, localeText]);
  return /*#__PURE__*/jsx(MuiPickersAdapterContext$1.Provider, {
    value: contextValue,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? LocalizationProvider$1.propTypes = {
  adapterLocale: propTypes.oneOfType([propTypes.object, propTypes.string]),
  children: propTypes.node,
  dateAdapter: propTypes.func.isRequired,
  dateFormats: propTypes.shape({
    dayOfMonth: propTypes.string,
    fullDate: propTypes.string,
    fullDateTime: propTypes.string,
    fullDateTime12h: propTypes.string,
    fullDateTime24h: propTypes.string,
    fullDateWithWeekday: propTypes.string,
    fullTime: propTypes.string,
    fullTime12h: propTypes.string,
    fullTime24h: propTypes.string,
    hours12h: propTypes.string,
    hours24h: propTypes.string,
    keyboardDate: propTypes.string,
    keyboardDateTime: propTypes.string,
    keyboardDateTime12h: propTypes.string,
    keyboardDateTime24h: propTypes.string,
    minutes: propTypes.string,
    month: propTypes.string,
    monthAndDate: propTypes.string,
    monthAndYear: propTypes.string,
    monthShort: propTypes.string,
    normalDate: propTypes.string,
    normalDateWithWeekday: propTypes.string,
    seconds: propTypes.string,
    shortDate: propTypes.string,
    weekday: propTypes.string,
    weekdayShort: propTypes.string,
    year: propTypes.string
  }),
  dateLibInstance: propTypes.any,
  locale: propTypes.oneOfType([propTypes.object, propTypes.string]),
  localeText: propTypes.object
} : void 0;

var useLocalizationContext$1 = function useLocalizationContext() {
  var localization = useContext(MuiPickersAdapterContext$1);
  if (localization === null) {
    throw new Error('MUI: Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly.');
  }
  return localization;
};
var useUtils$1 = function useUtils() {
  return useLocalizationContext$1().utils;
};
var useDefaultDates$1 = function useDefaultDates() {
  return useLocalizationContext$1().defaultDates;
};
var useLocaleText$1 = function useLocaleText() {
  return useLocalizationContext$1().localeText;
};
var useNow$1 = function useNow() {
  var utils = useUtils$1();
  var now = useRef(utils.date());
  return now.current;
};

function useValidation$1(props, validate, isSameError) {
  var value = props.value,
    onError = props.onError;
  var adapter = useLocalizationContext$1();
  var previousValidationErrorRef = useRef(null);
  var validationError = validate({
    adapter: adapter,
    value: value,
    props: props
  });
  useEffect(function () {
    if (onError && !isSameError(validationError, previousValidationErrorRef.current)) {
      onError(validationError, value);
    }
    previousValidationErrorRef.current = validationError;
  }, [isSameError, onError, previousValidationErrorRef, validationError, value]);
  return validationError;
}

var validateDate$2 = function validateDate(_ref) {
  var props = _ref.props,
    value = _ref.value,
    adapter = _ref.adapter;
  var now = adapter.utils.date();
  var date = adapter.utils.date(value);
  var shouldDisableDate = props.shouldDisableDate,
    _props$minDate = props.minDate,
    minDate = _props$minDate === void 0 ? adapter.defaultDates.minDate : _props$minDate,
    _props$maxDate = props.maxDate,
    maxDate = _props$maxDate === void 0 ? adapter.defaultDates.maxDate : _props$maxDate,
    disableFuture = props.disableFuture,
    disablePast = props.disablePast;
  if (date === null) {
    return null;
  }
  switch (true) {
    case !adapter.utils.isValid(value):
      return 'invalidDate';
    case Boolean(shouldDisableDate && shouldDisableDate(date)):
      return 'shouldDisableDate';
    case Boolean(disableFuture && adapter.utils.isAfterDay(date, now)):
      return 'disableFuture';
    case Boolean(disablePast && adapter.utils.isBeforeDay(date, now)):
      return 'disablePast';
    case Boolean(minDate && adapter.utils.isBeforeDay(date, minDate)):
      return 'minDate';
    case Boolean(maxDate && adapter.utils.isAfterDay(date, maxDate)):
      return 'maxDate';
    default:
      return null;
  }
};
var useIsDayDisabled$1 = function useIsDayDisabled(_ref2) {
  var shouldDisableDate = _ref2.shouldDisableDate,
    minDate = _ref2.minDate,
    maxDate = _ref2.maxDate,
    disableFuture = _ref2.disableFuture,
    disablePast = _ref2.disablePast;
  var adapter = useLocalizationContext$1();
  return useCallback(function (day) {
    return validateDate$2({
      adapter: adapter,
      value: day,
      props: {
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast
      }
    }) !== null;
  }, [adapter, shouldDisableDate, minDate, maxDate, disableFuture, disablePast]);
};

var createCalendarStateReducer$1 = function createCalendarStateReducer(reduceAnimations, disableSwitchToMonthOnDayFocus, utils) {
  return function (state, action) {
    switch (action.type) {
      case 'changeMonth':
        return _extends$4({}, state, {
          slideDirection: action.direction,
          currentMonth: action.newMonth,
          isMonthSwitchingAnimating: !reduceAnimations
        });
      case 'finishMonthSwitchingAnimation':
        return _extends$4({}, state, {
          isMonthSwitchingAnimating: false
        });
      case 'changeFocusedDay':
        {
          if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) {
            return state;
          }
          var needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
          return _extends$4({}, state, {
            focusedDay: action.focusedDay,
            isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations,
            currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
            slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
          });
        }
      default:
        throw new Error('missing support');
    }
  };
};
var useCalendarState$1 = function useCalendarState(_ref2) {
  var date = _ref2.date,
    defaultCalendarMonth = _ref2.defaultCalendarMonth,
    disableFuture = _ref2.disableFuture,
    disablePast = _ref2.disablePast,
    _ref2$disableSwitchTo = _ref2.disableSwitchToMonthOnDayFocus,
    disableSwitchToMonthOnDayFocus = _ref2$disableSwitchTo === void 0 ? false : _ref2$disableSwitchTo,
    maxDate = _ref2.maxDate,
    minDate = _ref2.minDate,
    onMonthChange = _ref2.onMonthChange,
    reduceAnimations = _ref2.reduceAnimations,
    shouldDisableDate = _ref2.shouldDisableDate;
  var _ref;
  var now = useNow$1();
  var utils = useUtils$1();
  var reducerFn = useRef(createCalendarStateReducer$1(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
  var _React$useReducer = useReducer(reducerFn, {
      isMonthSwitchingAnimating: false,
      focusedDay: date || now,
      currentMonth: utils.startOfMonth((_ref = date != null ? date : defaultCalendarMonth) != null ? _ref : now),
      slideDirection: 'left'
    }),
    calendarState = _React$useReducer[0],
    dispatch = _React$useReducer[1];
  var handleChangeMonth = useCallback(function (payload) {
    dispatch(_extends$4({
      type: 'changeMonth'
    }, payload));
    if (onMonthChange) {
      onMonthChange(payload.newMonth);
    }
  }, [onMonthChange]);
  var changeMonth = useCallback(function (newDate) {
    var newDateRequested = newDate != null ? newDate : now;
    if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) {
      return;
    }
    handleChangeMonth({
      newMonth: utils.startOfMonth(newDateRequested),
      direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
    });
  }, [calendarState.currentMonth, handleChangeMonth, now, utils]);
  var isDateDisabled = useIsDayDisabled$1({
    shouldDisableDate: shouldDisableDate,
    minDate: minDate,
    maxDate: maxDate,
    disableFuture: disableFuture,
    disablePast: disablePast
  });
  var onMonthSwitchingAnimationEnd = useCallback(function () {
    dispatch({
      type: 'finishMonthSwitchingAnimation'
    });
  }, []);
  var changeFocusedDay = useCallback(function (newFocusedDate) {
    if (!isDateDisabled(newFocusedDate)) {
      dispatch({
        type: 'changeFocusedDay',
        focusedDay: newFocusedDate
      });
    }
  }, [isDateDisabled]);
  return {
    calendarState: calendarState,
    changeMonth: changeMonth,
    changeFocusedDay: changeFocusedDay,
    isDateDisabled: isDateDisabled,
    onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
    handleChangeMonth: handleChangeMonth
  };
};

var classes$5 = generateUtilityClasses$1('PrivatePickersFadeTransitionGroup', ['root']);
var animationDuration$1 = 500;
var PickersFadeTransitionGroupRoot$1 = styled(TransitionGroup)({
  display: 'block',
  position: 'relative'
});
var PickersFadeTransitionGroup$1 = function PickersFadeTransitionGroup(_ref) {
  var children = _ref.children,
    className = _ref.className,
    reduceAnimations = _ref.reduceAnimations,
    transKey = _ref.transKey;
  if (reduceAnimations) {
    return children;
  }
  return /*#__PURE__*/jsx(PickersFadeTransitionGroupRoot$1, {
    className: clsx$1(classes$5.root, className),
    children: /*#__PURE__*/jsx(Fade, {
      appear: false,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        appear: animationDuration$1,
        enter: animationDuration$1 / 2,
        exit: 0
      },
      children: children
    }, transKey)
  });
};

var useEnhancedEffect$2 = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

var DAY_SIZE$1 = 36;
var DAY_MARGIN$1 = 2;
var DIALOG_WIDTH$1 = 320;

function getPickersDayUtilityClass$1(slot) {
  return generateUtilityClass$1('MuiPickersDay', slot);
}
var pickersDayClasses$1 = generateUtilityClasses$1('MuiPickersDay', ['root', 'dayWithMargin', 'dayOutsideMonth', 'hiddenDaySpacingFiller', 'today', 'selected', 'disabled']);

var _excluded$O = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDayFocus", "onDaySelect", "onFocus", "onKeyDown", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today"];
var useUtilityClasses$9 = function useUtilityClasses(ownerState) {
  var selected = ownerState.selected,
    disableMargin = ownerState.disableMargin,
    disableHighlightToday = ownerState.disableHighlightToday,
    today = ownerState.today,
    outsideCurrentMonth = ownerState.outsideCurrentMonth,
    showDaysOutsideCurrentMonth = ownerState.showDaysOutsideCurrentMonth,
    classes = ownerState.classes;
  var slots = {
    root: ['root', selected && 'selected', !disableMargin && 'dayWithMargin', !disableHighlightToday && today && 'today', outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth'],
    hiddenDaySpacingFiller: ['hiddenDaySpacingFiller']
  };
  return unstable_composeClasses(slots, getPickersDayUtilityClass$1, classes);
};
var styleArg$1 = function styleArg(_ref) {
  var _focus, _extends2, _ref2;
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$4({}, theme.typography.caption, (_extends2 = {
    width: DAY_SIZE$1,
    height: DAY_SIZE$1,
    borderRadius: '50%',
    padding: 0,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
    },
    '&:focus': (_focus = {
      backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
    }, _focus["&." + pickersDayClasses$1.selected] = {
      willChange: 'background-color',
      backgroundColor: theme.palette.primary.dark
    }, _focus)
  }, _extends2["&." + pickersDayClasses$1.selected] = {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.short
    }),
    '&:hover': {
      willChange: 'background-color',
      backgroundColor: theme.palette.primary.dark
    }
  }, _extends2["&." + pickersDayClasses$1.disabled] = {
    color: theme.palette.text.disabled
  }, _extends2), !ownerState.disableMargin && {
    margin: "0 " + DAY_MARGIN$1 + "px"
  }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
    color: theme.palette.text.secondary
  }, !ownerState.disableHighlightToday && ownerState.today && (_ref2 = {}, _ref2["&:not(." + pickersDayClasses$1.selected + ")"] = {
    border: "1px solid " + theme.palette.text.secondary
  }, _ref2));
};
var overridesResolver$1 = function overridesResolver(props, styles) {
  var ownerState = props.ownerState;
  return [styles.root, !ownerState.disableMargin && styles.dayWithMargin, !ownerState.disableHighlightToday && ownerState.today && styles.today, !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth, ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller];
};
var PickersDayRoot$1 = styled(ButtonBase, {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver: overridesResolver$1
})(styleArg$1);
var PickersDayFiller$1 = styled('div', {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver: overridesResolver$1
})(function (_ref3) {
  var theme = _ref3.theme,
    ownerState = _ref3.ownerState;
  return _extends$4({}, styleArg$1({
    theme: theme,
    ownerState: ownerState
  }), {
    visibility: 'hidden'
  });
});
var noop$4 = function noop() {};
var PickersDayRaw$1 = /*#__PURE__*/forwardRef(function PickersDay(inProps, forwardedRef) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiPickersDay'
  });
  var _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    className = props.className,
    day = props.day,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$disableHighlig = props.disableHighlightToday,
    disableHighlightToday = _props$disableHighlig === void 0 ? false : _props$disableHighlig,
    _props$disableMargin = props.disableMargin,
    disableMargin = _props$disableMargin === void 0 ? false : _props$disableMargin,
    isAnimating = props.isAnimating,
    onClick = props.onClick,
    _props$onDayFocus = props.onDayFocus,
    onDayFocus = _props$onDayFocus === void 0 ? noop$4 : _props$onDayFocus,
    onDaySelect = props.onDaySelect,
    onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    outsideCurrentMonth = props.outsideCurrentMonth,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    _props$showDaysOutsid = props.showDaysOutsideCurrentMonth,
    showDaysOutsideCurrentMonth = _props$showDaysOutsid === void 0 ? false : _props$showDaysOutsid,
    children = props.children,
    _props$today = props.today,
    isToday = _props$today === void 0 ? false : _props$today,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$O);
  var ownerState = _extends$4({}, props, {
    autoFocus: autoFocus,
    disabled: disabled,
    disableHighlightToday: disableHighlightToday,
    disableMargin: disableMargin,
    selected: selected,
    showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
    today: isToday
  });
  var classes = useUtilityClasses$9(ownerState);
  var utils = useUtils$1();
  var ref = useRef(null);
  var handleRef = useForkRef$1(ref, forwardedRef);
  useEnhancedEffect$2(function () {
    if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) {
      ref.current.focus();
    }
  }, [autoFocus, disabled, isAnimating, outsideCurrentMonth]);
  var handleFocus = function handleFocus(event) {
    if (onDayFocus) {
      onDayFocus(day);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  var handleClick = function handleClick(event) {
    if (!disabled) {
      onDaySelect(day, 'finish');
    }
    if (onClick) {
      onClick(event);
    }
  };
  var theme = useTheme();
  function handleKeyDown(event) {
    if (onKeyDown !== undefined) {
      onKeyDown(event);
    }
    switch (event.key) {
      case 'ArrowUp':
        onDayFocus(utils.addDays(day, -7));
        event.preventDefault();
        break;
      case 'ArrowDown':
        onDayFocus(utils.addDays(day, 7));
        event.preventDefault();
        break;
      case 'ArrowLeft':
        onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? -1 : 1));
        event.preventDefault();
        break;
      case 'ArrowRight':
        onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? 1 : -1));
        event.preventDefault();
        break;
      case 'Home':
        onDayFocus(utils.startOfWeek(day));
        event.preventDefault();
        break;
      case 'End':
        onDayFocus(utils.endOfWeek(day));
        event.preventDefault();
        break;
      case 'PageUp':
        onDayFocus(utils.getNextMonth(day));
        event.preventDefault();
        break;
      case 'PageDown':
        onDayFocus(utils.getPreviousMonth(day));
        event.preventDefault();
        break;
    }
  }
  if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) {
    return /*#__PURE__*/jsx(PickersDayFiller$1, {
      className: clsx$1(classes.root, classes.hiddenDaySpacingFiller, className),
      ownerState: ownerState
    });
  }
  return /*#__PURE__*/jsx(PickersDayRoot$1, _extends$4({
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    ref: handleRef,
    centerRipple: true,
    disabled: disabled,
    "aria-label": !children ? utils.format(day, 'fullDate') : undefined,
    tabIndex: selected ? 0 : -1,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onClick: handleClick
  }, other, {
    children: !children ? utils.format(day, 'dayOfMonth') : children
  }));
});
var areDayPropsEqual$1 = function areDayPropsEqual(prevProps, nextProps) {
  return prevProps.autoFocus === nextProps.autoFocus && prevProps.isAnimating === nextProps.isAnimating && prevProps.today === nextProps.today && prevProps.disabled === nextProps.disabled && prevProps.selected === nextProps.selected && prevProps.disableMargin === nextProps.disableMargin && prevProps.showDaysOutsideCurrentMonth === nextProps.showDaysOutsideCurrentMonth && prevProps.disableHighlightToday === nextProps.disableHighlightToday && prevProps.className === nextProps.className && prevProps.outsideCurrentMonth === nextProps.outsideCurrentMonth && prevProps.onDayFocus === nextProps.onDayFocus && prevProps.onDaySelect === nextProps.onDaySelect;
};
process.env.NODE_ENV !== "production" ? PickersDayRaw$1.propTypes = {
  classes: propTypes.object,
  day: propTypes.any.isRequired,
  disabled: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disableMargin: propTypes.bool,
  isAnimating: propTypes.bool,
  onDayFocus: propTypes.func,
  onDaySelect: propTypes.func.isRequired,
  outsideCurrentMonth: propTypes.bool.isRequired,
  selected: propTypes.bool,
  showDaysOutsideCurrentMonth: propTypes.bool,
  sx: propTypes.oneOfType([propTypes.arrayOf(propTypes.oneOfType([propTypes.func, propTypes.object, propTypes.bool])), propTypes.func, propTypes.object]),
  today: propTypes.bool
} : void 0;
var PickersDay$1 = /*#__PURE__*/memo(PickersDayRaw$1, areDayPropsEqual$1);

var _excluded$P = ["children", "className", "reduceAnimations", "slideDirection", "transKey"];
var classes$6 = generateUtilityClasses$1('PrivatePickersSlideTransition', ['root', 'slideEnter-left', 'slideEnter-right', 'slideEnterActive', 'slideEnterActive', 'slideExit', 'slideExitActiveLeft-left', 'slideExitActiveLeft-right']);
var slideAnimationDuration$1 = 350;
var PickersSlideTransitionRoot$1 = styled(TransitionGroup)(function (_ref2) {
  var _ref3;
  var theme = _ref2.theme;
  var slideTransition = theme.transitions.create('transform', {
    duration: slideAnimationDuration$1,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return _ref3 = {
    display: 'block',
    position: 'relative',
    overflowX: 'hidden',
    '& > *': {
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0
    }
  }, _ref3["& ." + classes$6['slideEnter-left']] = {
    willChange: 'transform',
    transform: 'translate(100%)',
    zIndex: 1
  }, _ref3["& ." + classes$6['slideEnter-right']] = {
    willChange: 'transform',
    transform: 'translate(-100%)',
    zIndex: 1
  }, _ref3["& ." + classes$6.slideEnterActive] = {
    transform: 'translate(0%)',
    transition: slideTransition
  }, _ref3["& ." + classes$6.slideExit] = {
    transform: 'translate(0%)'
  }, _ref3["& ." + classes$6['slideExitActiveLeft-left']] = {
    willChange: 'transform',
    transform: 'translate(-100%)',
    transition: slideTransition,
    zIndex: 0
  }, _ref3["& ." + classes$6['slideExitActiveLeft-right']] = {
    willChange: 'transform',
    transform: 'translate(100%)',
    transition: slideTransition,
    zIndex: 0
  }, _ref3;
});
var PickersSlideTransition$1 = function PickersSlideTransition(_ref) {
  var children = _ref.children,
    className = _ref.className,
    reduceAnimations = _ref.reduceAnimations,
    slideDirection = _ref.slideDirection,
    transKey = _ref.transKey,
    other = _objectWithoutPropertiesLoose$4(_ref, _excluded$P);
  if (reduceAnimations) {
    return /*#__PURE__*/jsx("div", {
      className: clsx$1(classes$6.root, className),
      children: children
    });
  }
  var transitionClasses = {
    exit: classes$6.slideExit,
    enterActive: classes$6.slideEnterActive,
    enter: classes$6["slideEnter-" + slideDirection],
    exitActive: classes$6["slideExitActiveLeft-" + slideDirection]
  };
  return /*#__PURE__*/jsx(PickersSlideTransitionRoot$1, {
    className: clsx$1(classes$6.root, className),
    childFactory: function childFactory(element) {
      return /*#__PURE__*/cloneElement(element, {
        classNames: transitionClasses
      });
    },
    children: /*#__PURE__*/jsx(CSSTransition, _extends$4({
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: slideAnimationDuration$1,
      classNames: transitionClasses
    }, other, {
      children: children
    }), transKey)
  });
};

var defaultDayOfWeekFormatter = function defaultDayOfWeekFormatter(day) {
  return day.charAt(0).toUpperCase();
};
var weeksContainerHeight$1 = (DAY_SIZE$1 + DAY_MARGIN$1 * 2) * 6;
var PickersCalendarDayHeader$1 = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
var PickersCalendarWeekDayLabel$1 = styled(Typography)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: 36,
    height: 40,
    margin: '0 2px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.text.secondary
  };
});
var PickersCalendarLoadingContainer$1 = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: weeksContainerHeight$1
});
var PickersCalendarSlideTransition$1 = styled(PickersSlideTransition$1)({
  minHeight: weeksContainerHeight$1
});
var PickersCalendarWeekContainer$1 = styled('div')({
  overflow: 'hidden'
});
var PickersCalendarWeek$1 = styled('div')({
  margin: DAY_MARGIN$1 + "px 0",
  display: 'flex',
  justifyContent: 'center'
});
function DayPicker$1(props) {
  var now = useNow$1();
  var utils = useUtils$1();
  var autoFocus = props.autoFocus,
    onFocusedDayChange = props.onFocusedDayChange,
    className = props.className,
    currentMonth = props.currentMonth,
    selectedDays = props.selectedDays,
    disabled = props.disabled,
    disableHighlightToday = props.disableHighlightToday,
    focusedDay = props.focusedDay,
    isMonthSwitchingAnimating = props.isMonthSwitchingAnimating,
    loading = props.loading,
    onSelectedDaysChange = props.onSelectedDaysChange,
    onMonthSwitchingAnimationEnd = props.onMonthSwitchingAnimationEnd,
    readOnly = props.readOnly,
    reduceAnimations = props.reduceAnimations,
    renderDay = props.renderDay,
    _props$renderLoading = props.renderLoading,
    renderLoading = _props$renderLoading === void 0 ? function () {
      return /*#__PURE__*/jsx("span", {
        children: "..."
      });
    } : _props$renderLoading,
    showDaysOutsideCurrentMonth = props.showDaysOutsideCurrentMonth,
    slideDirection = props.slideDirection,
    TransitionProps = props.TransitionProps,
    disablePast = props.disablePast,
    disableFuture = props.disableFuture,
    minDate = props.minDate,
    maxDate = props.maxDate,
    shouldDisableDate = props.shouldDisableDate,
    _props$dayOfWeekForma = props.dayOfWeekFormatter,
    dayOfWeekFormatter = _props$dayOfWeekForma === void 0 ? defaultDayOfWeekFormatter : _props$dayOfWeekForma;
  var isDateDisabled = useIsDayDisabled$1({
    shouldDisableDate: shouldDisableDate,
    minDate: minDate,
    maxDate: maxDate,
    disablePast: disablePast,
    disableFuture: disableFuture
  });
  var handleDaySelect = useCallback(function (day, isFinish) {
    if (isFinish === void 0) {
      isFinish = 'finish';
    }
    if (readOnly) {
      return;
    }
    onSelectedDaysChange(day, isFinish);
  }, [onSelectedDaysChange, readOnly]);
  var currentMonthNumber = utils.getMonth(currentMonth);
  var validSelectedDays = selectedDays.filter(function (day) {
    return !!day;
  }).map(function (day) {
    return utils.startOfDay(day);
  });
  var transitionKey = currentMonthNumber;
  var slideNodeRef = useMemo(function () {
    return /*#__PURE__*/createRef();
  }, [transitionKey]);
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(PickersCalendarDayHeader$1, {
      children: utils.getWeekdays().map(function (day, i) {
        var _dayOfWeekFormatter;
        return /*#__PURE__*/jsx(PickersCalendarWeekDayLabel$1, {
          "aria-hidden": true,
          variant: "caption",
          children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day)) != null ? _dayOfWeekFormatter : day
        }, day + i.toString());
      })
    }), loading ? /*#__PURE__*/jsx(PickersCalendarLoadingContainer$1, {
      children: renderLoading()
    }) : /*#__PURE__*/jsx(PickersCalendarSlideTransition$1, _extends$4({
      transKey: transitionKey,
      onExited: onMonthSwitchingAnimationEnd,
      reduceAnimations: reduceAnimations,
      slideDirection: slideDirection,
      className: className
    }, TransitionProps, {
      nodeRef: slideNodeRef,
      children: /*#__PURE__*/jsx(PickersCalendarWeekContainer$1, {
        ref: slideNodeRef,
        role: "grid",
        children: utils.getWeekArray(currentMonth).map(function (week) {
          return /*#__PURE__*/jsx(PickersCalendarWeek$1, {
            role: "row",
            children: week.map(function (day) {
              var pickersDayProps = {
                key: day == null ? void 0 : day.toString(),
                day: day,
                isAnimating: isMonthSwitchingAnimating,
                disabled: disabled || isDateDisabled(day),
                autoFocus: autoFocus && focusedDay !== null && utils.isSameDay(day, focusedDay),
                today: utils.isSameDay(day, now),
                outsideCurrentMonth: utils.getMonth(day) !== currentMonthNumber,
                selected: validSelectedDays.some(function (selectedDay) {
                  return utils.isSameDay(selectedDay, day);
                }),
                disableHighlightToday: disableHighlightToday,
                showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                onDayFocus: onFocusedDayChange,
                onDaySelect: handleDaySelect
              };
              return renderDay ? renderDay(day, validSelectedDays, pickersDayProps) : /*#__PURE__*/jsx("div", {
                role: "cell",
                children: /*#__PURE__*/jsx(PickersDay$1, _extends$4({}, pickersDayProps))
              }, pickersDayProps.key);
            })
          }, "week-" + week[0]);
        })
      })
    }))]
  });
}

var ArrowDropDown$1 = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
var ArrowLeft$1 = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
var ArrowRight$1 = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
var Calendar$1 = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
var Clock$2 = createSvgIcon( /*#__PURE__*/jsxs(Fragment$1, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Clock');
var DateRange$1 = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
var Pen$1 = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Pen');
var Time$1 = createSvgIcon( /*#__PURE__*/jsxs(Fragment$1, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Time');

var _excluded$Q = ["children", "className", "components", "componentsProps", "isLeftDisabled", "isLeftHidden", "isRightDisabled", "isRightHidden", "leftArrowButtonText", "onLeftClick", "onRightClick", "rightArrowButtonText"];
var classes$7 = generateUtilityClasses$1('MuiPickersArrowSwitcher', ['root', 'spacer', 'button']);
var PickersArrowSwitcherRoot$1 = styled('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({
  display: 'flex'
});
var PickersArrowSwitcherSpacer$1 = styled('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Spacer',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.spacer;
  }
})(function (_ref) {
  var theme = _ref.theme;
  return {
    width: theme.spacing(3)
  };
});
var PickersArrowSwitcherButton$1 = styled(IconButton, {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Button',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.button;
  }
})(function (_ref2) {
  var ownerState = _ref2.ownerState;
  return _extends$4({}, ownerState.hidden && {
    visibility: 'hidden'
  });
});
var PickersArrowSwitcher$1 = /*#__PURE__*/forwardRef(function PickersArrowSwitcher(props, ref) {
  var children = props.children,
    className = props.className,
    components = props.components,
    componentsProps = props.componentsProps,
    isLeftDisabled = props.isLeftDisabled,
    isLeftHidden = props.isLeftHidden,
    isRightDisabled = props.isRightDisabled,
    isRightHidden = props.isRightHidden,
    leftArrowButtonText = props.leftArrowButtonText,
    onLeftClick = props.onLeftClick,
    onRightClick = props.onRightClick,
    rightArrowButtonText = props.rightArrowButtonText,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$Q);
  var theme = useTheme();
  var isRtl = theme.direction === 'rtl';
  var leftArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.leftArrowButton) || {};
  var LeftArrowIcon = (components == null ? void 0 : components.LeftArrowIcon) || ArrowLeft$1;
  var rightArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.rightArrowButton) || {};
  var RightArrowIcon = (components == null ? void 0 : components.RightArrowIcon) || ArrowRight$1;
  var ownerState = props;
  return /*#__PURE__*/jsxs(PickersArrowSwitcherRoot$1, _extends$4({
    ref: ref,
    className: clsx$1(classes$7.root, className),
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/jsx(PickersArrowSwitcherButton$1, _extends$4({
      as: components == null ? void 0 : components.LeftArrowButton,
      size: "small",
      "aria-label": leftArrowButtonText,
      title: leftArrowButtonText,
      disabled: isLeftDisabled,
      edge: "end",
      onClick: onLeftClick
    }, leftArrowButtonProps, {
      className: clsx$1(classes$7.button, leftArrowButtonProps.className),
      ownerState: _extends$4({}, ownerState, leftArrowButtonProps, {
        hidden: isLeftHidden
      }),
      children: isRtl ? /*#__PURE__*/jsx(RightArrowIcon, {}) : /*#__PURE__*/jsx(LeftArrowIcon, {})
    })), children ? /*#__PURE__*/jsx(Typography, {
      variant: "subtitle1",
      component: "span",
      children: children
    }) : /*#__PURE__*/jsx(PickersArrowSwitcherSpacer$1, {
      className: classes$7.spacer,
      ownerState: ownerState
    }), /*#__PURE__*/jsx(PickersArrowSwitcherButton$1, _extends$4({
      as: components == null ? void 0 : components.RightArrowButton,
      size: "small",
      "aria-label": rightArrowButtonText,
      title: rightArrowButtonText,
      edge: "start",
      disabled: isRightDisabled,
      onClick: onRightClick
    }, rightArrowButtonProps, {
      className: clsx$1(classes$7.button, rightArrowButtonProps.className),
      ownerState: _extends$4({}, ownerState, rightArrowButtonProps, {
        hidden: isRightHidden
      }),
      children: isRtl ? /*#__PURE__*/jsx(LeftArrowIcon, {}) : /*#__PURE__*/jsx(RightArrowIcon, {})
    }))]
  }));
});

function useNextMonthDisabled$1(month, _ref) {
  var disableFuture = _ref.disableFuture,
    maxDate = _ref.maxDate;
  var utils = useUtils$1();
  return useMemo(function () {
    var now = utils.date();
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    return !utils.isAfter(lastEnabledMonth, month);
  }, [disableFuture, maxDate, month, utils]);
}
function usePreviousMonthDisabled$1(month, _ref2) {
  var disablePast = _ref2.disablePast,
    minDate = _ref2.minDate;
  var utils = useUtils$1();
  return useMemo(function () {
    var now = utils.date();
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    return !utils.isBefore(firstEnabledMonth, month);
  }, [disablePast, minDate, month, utils]);
}

var buildDeprecatedPropsWarning$1 = function buildDeprecatedPropsWarning(message) {
  var alreadyWarned = false;
  if (process.env.NODE_ENV === 'production') {
    return function () {};
  }
  var cleanMessage = Array.isArray(message) ? message.join('\n') : message;
  return function (deprecatedProps) {
    var deprecatedKeys = Object.entries(deprecatedProps).filter(function (_ref) {
      var value = _ref[1];
      return value !== undefined;
    }).map(function (_ref2) {
      var key = _ref2[0];
      return "- " + key;
    });
    if (!alreadyWarned && deprecatedKeys.length > 0) {
      alreadyWarned = true;
      console.warn([cleanMessage, 'deprecated props observed:'].concat(deprecatedKeys).join('\n'));
    }
  };
};

var PickersCalendarHeaderRoot$1 = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  maxHeight: 30,
  minHeight: 30
});
var PickersCalendarHeaderLabel$1 = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _extends$4({
    display: 'flex',
    maxHeight: 30,
    overflow: 'hidden',
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: 'auto'
  }, theme.typography.body1, {
    fontWeight: theme.typography.fontWeightMedium
  });
});
var PickersCalendarHeaderLabelItem$1 = styled('div')({
  marginRight: 6
});
var PickersCalendarHeaderSwitchViewButton$1 = styled(IconButton)({
  marginRight: 'auto'
});
var PickersCalendarHeaderSwitchView$1 = styled(ArrowDropDown$1)(function (_ref2) {
  var theme = _ref2.theme,
    ownerState = _ref2.ownerState;
  return _extends$4({
    willChange: 'transform',
    transition: theme.transitions.create('transform'),
    transform: 'rotate(0deg)'
  }, ownerState.openView === 'year' && {
    transform: 'rotate(180deg)'
  });
});
var deprecatedPropsWarning$2 = buildDeprecatedPropsWarning$1('Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.');
function PickersCalendarHeader$1(props) {
  var _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    _props$componentsProp = props.componentsProps,
    componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
    month = props.currentMonth,
    disabled = props.disabled,
    disableFuture = props.disableFuture,
    disablePast = props.disablePast,
    getViewSwitchingButtonTextProp = props.getViewSwitchingButtonText,
    leftArrowButtonTextProp = props.leftArrowButtonText,
    maxDate = props.maxDate,
    minDate = props.minDate,
    onMonthChange = props.onMonthChange,
    onViewChange = props.onViewChange,
    currentView = props.openView,
    reduceAnimations = props.reduceAnimations,
    rightArrowButtonTextProp = props.rightArrowButtonText,
    views = props.views;
  deprecatedPropsWarning$2({
    leftArrowButtonText: leftArrowButtonTextProp,
    rightArrowButtonText: rightArrowButtonTextProp,
    getViewSwitchingButtonText: getViewSwitchingButtonTextProp
  });
  var localeText = useLocaleText$1();
  var leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.previousMonth;
  var rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.nextMonth;
  var getViewSwitchingButtonText = getViewSwitchingButtonTextProp != null ? getViewSwitchingButtonTextProp : localeText.calendarViewSwitchingButtonAriaLabel;
  var utils = useUtils$1();
  var switchViewButtonProps = componentsProps.switchViewButton || {};
  var selectNextMonth = function selectNextMonth() {
    return onMonthChange(utils.getNextMonth(month), 'left');
  };
  var selectPreviousMonth = function selectPreviousMonth() {
    return onMonthChange(utils.getPreviousMonth(month), 'right');
  };
  var isNextMonthDisabled = useNextMonthDisabled$1(month, {
    disableFuture: disableFuture,
    maxDate: maxDate
  });
  var isPreviousMonthDisabled = usePreviousMonthDisabled$1(month, {
    disablePast: disablePast,
    minDate: minDate
  });
  var handleToggleView = function handleToggleView() {
    if (views.length === 1 || !onViewChange || disabled) {
      return;
    }
    if (views.length === 2) {
      onViewChange(views.find(function (view) {
        return view !== currentView;
      }) || views[0]);
    } else {
      var nextIndexToOpen = views.indexOf(currentView) !== 0 ? 0 : 1;
      onViewChange(views[nextIndexToOpen]);
    }
  };
  if (views.length === 1 && views[0] === 'year') {
    return null;
  }
  var ownerState = props;
  return /*#__PURE__*/jsxs(PickersCalendarHeaderRoot$1, {
    ownerState: ownerState,
    children: [/*#__PURE__*/jsxs(PickersCalendarHeaderLabel$1, {
      role: "presentation",
      onClick: handleToggleView,
      ownerState: ownerState,
      children: [/*#__PURE__*/jsx(PickersFadeTransitionGroup$1, {
        reduceAnimations: reduceAnimations,
        transKey: utils.format(month, 'monthAndYear'),
        children: /*#__PURE__*/jsx(PickersCalendarHeaderLabelItem$1, {
          "aria-live": "polite",
          ownerState: ownerState,
          children: utils.format(month, 'monthAndYear')
        })
      }), views.length > 1 && !disabled && /*#__PURE__*/jsx(PickersCalendarHeaderSwitchViewButton$1, _extends$4({
        size: "small",
        as: components.SwitchViewButton,
        "aria-label": getViewSwitchingButtonText(currentView)
      }, switchViewButtonProps, {
        children: /*#__PURE__*/jsx(PickersCalendarHeaderSwitchView$1, {
          as: components.SwitchViewIcon,
          ownerState: ownerState
        })
      }))]
    }), /*#__PURE__*/jsx(Fade, {
      in: currentView === 'day',
      children: /*#__PURE__*/jsx(PickersArrowSwitcher$1, {
        leftArrowButtonText: leftArrowButtonText,
        rightArrowButtonText: rightArrowButtonText,
        components: components,
        componentsProps: componentsProps,
        onLeftClick: selectPreviousMonth,
        onRightClick: selectNextMonth,
        isLeftDisabled: isPreviousMonthDisabled,
        isRightDisabled: isNextMonthDisabled
      })
    })]
  });
}

var WrapperVariantContext$1 = /*#__PURE__*/createContext(null);

var defaultReduceAnimations$1 = typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent);

var pickersToolbarClasses$1 = generateUtilityClasses$1('MuiPickersToolbar', ['root', 'content', 'penIconButton', 'penIconButtonLandscape']);
var PickersToolbarRoot$1 = styled('div', {
  name: 'MuiPickersToolbar',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$4({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3)
  }, ownerState.isLandscape && {
    height: 'auto',
    maxWidth: 160,
    padding: 16,
    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  });
});
var PickersToolbarContent$1 = styled(Grid, {
  name: 'MuiPickersToolbar',
  slot: 'Content',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.content;
  }
})({
  flex: 1
});
var PickersToolbarPenIconButton$1 = styled(IconButton, {
  name: 'MuiPickersToolbar',
  slot: 'PenIconButton',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.penIconButton;
  }
})({});
var getViewTypeIcon$1 = function getViewTypeIcon(viewType) {
  return viewType === 'clock' ? /*#__PURE__*/jsx(Clock$2, {
    color: "inherit"
  }) : /*#__PURE__*/jsx(Calendar$1, {
    color: "inherit"
  });
};
function defaultGetKeyboardInputSwitchingButtonText$1(isKeyboardInputOpen, viewType) {
  return isKeyboardInputOpen ? "text input view is open, go to " + viewType + " view" : viewType + " view is open, go to text input view";
}
var PickersToolbar$1 = /*#__PURE__*/forwardRef(function PickersToolbar(props, ref) {
  var children = props.children,
    className = props.className,
    _props$getMobileKeybo = props.getMobileKeyboardInputViewButtonText,
    getMobileKeyboardInputViewButtonText = _props$getMobileKeybo === void 0 ? defaultGetKeyboardInputSwitchingButtonText$1 : _props$getMobileKeybo,
    isLandscape = props.isLandscape,
    isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
    _props$landscapeDirec = props.landscapeDirection,
    landscapeDirection = _props$landscapeDirec === void 0 ? 'column' : _props$landscapeDirec,
    toggleMobileKeyboardView = props.toggleMobileKeyboardView,
    toolbarTitle = props.toolbarTitle,
    _props$viewType = props.viewType,
    viewType = _props$viewType === void 0 ? 'calendar' : _props$viewType;
  var ownerState = props;
  return /*#__PURE__*/jsxs(PickersToolbarRoot$1, {
    ref: ref,
    className: clsx$1(pickersToolbarClasses$1.root, className),
    ownerState: ownerState,
    children: [/*#__PURE__*/jsx(Typography, {
      color: "text.secondary",
      variant: "overline",
      children: toolbarTitle
    }), /*#__PURE__*/jsxs(PickersToolbarContent$1, {
      container: true,
      justifyContent: "space-between",
      className: pickersToolbarClasses$1.content,
      ownerState: ownerState,
      direction: isLandscape ? landscapeDirection : 'row',
      alignItems: isLandscape ? 'flex-start' : 'flex-end',
      children: [children, /*#__PURE__*/jsx(PickersToolbarPenIconButton$1, {
        onClick: toggleMobileKeyboardView,
        className: clsx$1(pickersToolbarClasses$1.penIconButton, isLandscape && pickersToolbarClasses$1.penIconButtonLandscape),
        ownerState: ownerState,
        color: "inherit",
        "aria-label": getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen, viewType),
        children: isMobileKeyboardViewOpen ? getViewTypeIcon$1(viewType) : /*#__PURE__*/jsx(Pen$1, {
          color: "inherit"
        })
      })]
    })]
  });
});

var PickersActionBar$1 = function PickersActionBar(props) {
  var onAccept = props.onAccept,
    onClear = props.onClear,
    onCancel = props.onCancel,
    onSetToday = props.onSetToday,
    actions = props.actions;
  var wrapperVariant = useContext(WrapperVariantContext$1);
  var localeText = useLocaleText$1();
  var actionsArray = typeof actions === 'function' ? actions(wrapperVariant) : actions;
  if (actionsArray == null || actionsArray.length === 0) {
    return null;
  }
  var buttons = actionsArray == null ? void 0 : actionsArray.map(function (actionType) {
    switch (actionType) {
      case 'clear':
        return /*#__PURE__*/jsx(Button, {
          onClick: onClear,
          children: localeText.clearButtonLabel
        }, actionType);
      case 'cancel':
        return /*#__PURE__*/jsx(Button, {
          onClick: onCancel,
          children: localeText.cancelButtonLabel
        }, actionType);
      case 'accept':
        return /*#__PURE__*/jsx(Button, {
          onClick: onAccept,
          children: localeText.okButtonLabel
        }, actionType);
      case 'today':
        return /*#__PURE__*/jsx(Button, {
          onClick: onSetToday,
          children: localeText.todayButtonLabel
        }, actionType);
      default:
        return null;
    }
  });
  return /*#__PURE__*/jsx(DialogActions, {
    children: buttons
  });
};

var _excluded$R = ["onClick", "onTouchStart"];
var PickersPopperRoot$1 = styled(Popper$1)(function (_ref) {
  var theme = _ref.theme;
  return {
    zIndex: theme.zIndex.modal
  };
});
var PickersPopperPaper$1 = styled(Paper)(function (_ref2) {
  var ownerState = _ref2.ownerState;
  return _extends$4({
    transformOrigin: 'top center',
    outline: 0
  }, ownerState.placement === 'top' && {
    transformOrigin: 'bottom center'
  });
});
function clickedRootScrollbar$1(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
function useClickAwayListener$1(active, onClickAway) {
  var movedRef = useRef(false);
  var syntheticEventRef = useRef(false);
  var nodeRef = useRef(null);
  var activatedRef = useRef(false);
  useEffect(function () {
    if (!active) {
      return undefined;
    }
    function armClickAwayListener() {
      activatedRef.current = true;
    }
    document.addEventListener('mousedown', armClickAwayListener, true);
    document.addEventListener('touchstart', armClickAwayListener, true);
    return function () {
      document.removeEventListener('mousedown', armClickAwayListener, true);
      document.removeEventListener('touchstart', armClickAwayListener, true);
      activatedRef.current = false;
    };
  }, [active]);
  var handleClickAway = useEventCallback(function (event) {
    if (!activatedRef.current) {
      return;
    }
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    var doc = ownerDocument$1(nodeRef.current);
    if (!nodeRef.current || 'clientX' in event && clickedRootScrollbar$1(event, doc)) {
      return;
    }
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    var insideDOM;
    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }
    if (!insideDOM && !insideReactTree) {
      onClickAway(event);
    }
  });
  var handleSynthetic = function handleSynthetic() {
    syntheticEventRef.current = true;
  };
  useEffect(function () {
    if (active) {
      var doc = ownerDocument$1(nodeRef.current);
      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };
      doc.addEventListener('touchstart', handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener('touchstart', handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }
    return undefined;
  }, [active, handleClickAway]);
  useEffect(function () {
    if (active) {
      var doc = ownerDocument$1(nodeRef.current);
      doc.addEventListener('click', handleClickAway);
      return function () {
        doc.removeEventListener('click', handleClickAway);
        syntheticEventRef.current = false;
      };
    }
    return undefined;
  }, [active, handleClickAway]);
  return [nodeRef, handleSynthetic, handleSynthetic];
}
var PickersPopper$1 = function PickersPopper(props) {
  var _components$ActionBar;
  var anchorEl = props.anchorEl,
    _children = props.children,
    _props$containerRef = props.containerRef,
    containerRef = _props$containerRef === void 0 ? null : _props$containerRef,
    onBlur = props.onBlur,
    onClose = props.onClose,
    onClear = props.onClear,
    onAccept = props.onAccept,
    onCancel = props.onCancel,
    onSetToday = props.onSetToday,
    open = props.open,
    PopperProps = props.PopperProps,
    role = props.role,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Grow : _props$TransitionComp,
    TrapFocusProps = props.TrapFocusProps,
    _props$PaperProps = props.PaperProps,
    PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    components = props.components,
    componentsProps = props.componentsProps;
  useEffect(function () {
    function handleKeyDown(nativeEvent) {
      if (open && (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc')) {
        onClose();
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, open]);
  var lastFocusedElementRef = useRef(null);
  useEffect(function () {
    if (role === 'tooltip') {
      return;
    }
    if (open) {
      lastFocusedElementRef.current = document.activeElement;
    } else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) {
      lastFocusedElementRef.current.focus();
    }
  }, [open, role]);
  var _useClickAwayListener = useClickAwayListener$1(open, onBlur != null ? onBlur : onClose),
    clickAwayRef = _useClickAwayListener[0],
    onPaperClick = _useClickAwayListener[1],
    onPaperTouchStart = _useClickAwayListener[2];
  var paperRef = useRef(null);
  var handleRef = useForkRef$1(paperRef, containerRef);
  var handlePaperRef = useForkRef$1(handleRef, clickAwayRef);
  var ownerState = props;
  var onPaperClickProp = PaperProps.onClick,
    onPaperTouchStartProp = PaperProps.onTouchStart,
    otherPaperProps = _objectWithoutPropertiesLoose$4(PaperProps, _excluded$R);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape') {
      event.stopPropagation();
      onClose();
    }
  };
  var ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : PickersActionBar$1;
  return /*#__PURE__*/jsx(PickersPopperRoot$1, _extends$4({
    transition: true,
    role: role,
    open: open,
    anchorEl: anchorEl,
    ownerState: ownerState,
    onKeyDown: handleKeyDown
  }, PopperProps, {
    children: function children(_ref3) {
      var TransitionProps = _ref3.TransitionProps,
        placement = _ref3.placement;
      return /*#__PURE__*/jsx(TrapFocus, _extends$4({
        open: open,
        disableAutoFocus: true,
        disableEnforceFocus: role === 'tooltip',
        isEnabled: function isEnabled() {
          return true;
        }
      }, TrapFocusProps, {
        children: /*#__PURE__*/jsx(TransitionComponent, _extends$4({}, TransitionProps, {
          children: /*#__PURE__*/jsxs(PickersPopperPaper$1, _extends$4({
            tabIndex: -1,
            elevation: 8,
            ref: handlePaperRef,
            onClick: function onClick(event) {
              onPaperClick(event);
              if (onPaperClickProp) {
                onPaperClickProp(event);
              }
            },
            onTouchStart: function onTouchStart(event) {
              onPaperTouchStart(event);
              if (onPaperTouchStartProp) {
                onPaperTouchStartProp(event);
              }
            },
            ownerState: _extends$4({}, ownerState, {
              placement: placement
            })
          }, otherPaperProps, {
            children: [_children, /*#__PURE__*/jsx(ActionBar, _extends$4({
              onAccept: onAccept,
              onClear: onClear,
              onCancel: onCancel,
              onSetToday: onSetToday,
              actions: []
            }, componentsProps == null ? void 0 : componentsProps.actionBar))]
          }))
        }))
      }));
    }
  }));
};

var getDisplayDate$1 = function getDisplayDate(utils, rawValue, inputFormat) {
  var date = utils.date(rawValue);
  var isEmpty = rawValue === null;
  if (isEmpty) {
    return '';
  }
  return utils.isValid(date) ? utils.formatByString(date, inputFormat) : '';
};
var MASK_USER_INPUT_SYMBOL$1 = '_';
var staticDateWith2DigitTokens$1 = '2019-11-21T22:30:00.000';
var staticDateWith1DigitTokens$1 = '2019-01-01T09:00:00.000';
function getMaskFromCurrentFormat$1(mask, format, acceptRegex, utils) {
  if (mask) {
    return mask;
  }
  var formattedDateWith1Digit = utils.formatByString(utils.date(staticDateWith1DigitTokens$1), format);
  var inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, MASK_USER_INPUT_SYMBOL$1);
  var inferredFormatPatternWith2Digits = utils.formatByString(utils.date(staticDateWith2DigitTokens$1), format).replace(acceptRegex, '_');
  if (inferredFormatPatternWith1Digits === inferredFormatPatternWith2Digits) {
    return inferredFormatPatternWith1Digits;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.warn(["Mask does not support numbers with variable length such as 'M'.", "Either use numbers with fix length or disable mask feature with 'disableMaskedInput' prop", "Falling down to uncontrolled no-mask input."].join('\n'));
  }
  return '';
}
function checkMaskIsValidForCurrentFormat$1(mask, format, acceptRegex, utils) {
  if (!mask) {
    return false;
  }
  var formattedDateWith1Digit = utils.formatByString(utils.date(staticDateWith1DigitTokens$1), format);
  var inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, MASK_USER_INPUT_SYMBOL$1);
  var inferredFormatPatternWith2Digits = utils.formatByString(utils.date(staticDateWith2DigitTokens$1), format).replace(acceptRegex, '_');
  var isMaskValid = inferredFormatPatternWith2Digits === inferredFormatPatternWith1Digits && mask === inferredFormatPatternWith2Digits;
  if (!isMaskValid && utils.lib !== 'luxon' && process.env.NODE_ENV !== 'production') {
    if (format.includes('MMM')) {
      console.warn(["Mask does not support literals such as 'MMM'.", "Either use numbers with fix length or disable mask feature with 'disableMaskedInput' prop", "Falling down to uncontrolled no-mask input."].join('\n'));
    } else if (inferredFormatPatternWith2Digits && inferredFormatPatternWith2Digits !== inferredFormatPatternWith1Digits) {
      console.warn(["Mask does not support numbers with variable length such as 'M'.", "Either use numbers with fix length or disable mask feature with 'disableMaskedInput' prop", "Falling down to uncontrolled no-mask input."].join('\n'));
    } else if (mask) {
      console.warn(["The mask \"" + mask + "\" you passed is not valid for the format used " + format + ".", "Falling down to uncontrolled no-mask input."].join('\n'));
    }
  }
  return isMaskValid;
}
var maskedDateFormatter$1 = function maskedDateFormatter(mask, acceptRegexp) {
  return function (value) {
    var outputCharIndex = 0;
    return value.split('').map(function (char, inputCharIndex) {
      acceptRegexp.lastIndex = 0;
      if (outputCharIndex > mask.length - 1) {
        return '';
      }
      var maskChar = mask[outputCharIndex];
      var nextMaskChar = mask[outputCharIndex + 1];
      var acceptedChar = acceptRegexp.test(char) ? char : '';
      var formattedChar = maskChar === MASK_USER_INPUT_SYMBOL$1 ? acceptedChar : maskChar + acceptedChar;
      outputCharIndex += formattedChar.length;
      var isLastCharacter = inputCharIndex === value.length - 1;
      if (isLastCharacter && nextMaskChar && nextMaskChar !== MASK_USER_INPUT_SYMBOL$1) {
        return formattedChar ? formattedChar + nextMaskChar : '';
      }
      return formattedChar;
    }).join('');
  };
};

var useMaskedInput$1 = function useMaskedInput(_ref) {
  var _ref$acceptRegex = _ref.acceptRegex,
    acceptRegex = _ref$acceptRegex === void 0 ? /[\d]/gi : _ref$acceptRegex,
    disabled = _ref.disabled,
    disableMaskedInput = _ref.disableMaskedInput,
    ignoreInvalidInputs = _ref.ignoreInvalidInputs,
    inputFormat = _ref.inputFormat,
    inputProps = _ref.inputProps,
    label = _ref.label,
    mask = _ref.mask,
    onChange = _ref.onChange,
    rawValue = _ref.rawValue,
    readOnly = _ref.readOnly,
    rifmFormatter = _ref.rifmFormatter,
    TextFieldProps = _ref.TextFieldProps,
    validationError = _ref.validationError;
  var utils = useUtils$1();
  var formatHelperText = utils.getFormatHelperText(inputFormat);
  var _React$useMemo = useMemo(function () {
      if (disableMaskedInput) {
        return {
          shouldUseMaskedInput: false,
          maskToUse: ''
        };
      }
      var computedMaskToUse = getMaskFromCurrentFormat$1(mask, inputFormat, acceptRegex, utils);
      return {
        shouldUseMaskedInput: checkMaskIsValidForCurrentFormat$1(computedMaskToUse, inputFormat, acceptRegex, utils),
        maskToUse: computedMaskToUse
      };
    }, [acceptRegex, disableMaskedInput, inputFormat, mask, utils]),
    shouldUseMaskedInput = _React$useMemo.shouldUseMaskedInput,
    maskToUse = _React$useMemo.maskToUse;
  var formatter = useMemo(function () {
    return shouldUseMaskedInput && maskToUse ? maskedDateFormatter$1(maskToUse, acceptRegex) : function (st) {
      return st;
    };
  }, [acceptRegex, maskToUse, shouldUseMaskedInput]);
  var parsedValue = rawValue === null ? null : utils.date(rawValue);
  var _React$useState = useState(parsedValue),
    innerInputValue = _React$useState[0],
    setInnerInputValue = _React$useState[1];
  var _React$useState2 = useState(getDisplayDate$1(utils, rawValue, inputFormat)),
    innerDisplayedInputValue = _React$useState2[0],
    setInnerDisplayedInputValue = _React$useState2[1];
  var prevRawValue = useRef();
  var prevLocale = useRef(utils.locale);
  useEffect(function () {
    var rawValueHasChanged = rawValue !== prevRawValue.current;
    var localeHasChanged = utils.locale !== prevLocale.current;
    prevRawValue.current = rawValue;
    prevLocale.current = utils.locale;
    if (!rawValueHasChanged && !localeHasChanged) {
      return;
    }
    var newParsedValue = rawValue === null ? null : utils.date(rawValue);
    var isAcceptedValue = rawValue === null || utils.isValid(newParsedValue);
    if (!localeHasChanged && (!isAcceptedValue || utils.isEqual(innerInputValue, newParsedValue))) {
      return;
    }
    var newDisplayDate = getDisplayDate$1(utils, rawValue, inputFormat);
    setInnerInputValue(newParsedValue);
    setInnerDisplayedInputValue(newDisplayDate);
  }, [utils, rawValue, inputFormat, innerInputValue]);
  var handleChange = function handleChange(text) {
    var finalString = text === '' || text === mask ? '' : text;
    setInnerDisplayedInputValue(finalString);
    var date = finalString === null ? null : utils.parse(finalString, inputFormat);
    if (ignoreInvalidInputs && !utils.isValid(date)) {
      return;
    }
    setInnerInputValue(date);
    onChange(date, finalString || undefined);
  };
  var rifmProps = useRifm({
    value: innerDisplayedInputValue,
    onChange: handleChange,
    format: rifmFormatter || formatter
  });
  var inputStateArgs = shouldUseMaskedInput ? rifmProps : {
    value: innerDisplayedInputValue,
    onChange: function onChange(event) {
      handleChange(event.currentTarget.value);
    }
  };
  return _extends$4({
    label: label,
    disabled: disabled,
    error: validationError,
    inputProps: _extends$4({}, inputStateArgs, {
      disabled: disabled,
      placeholder: formatHelperText,
      readOnly: readOnly,
      type: shouldUseMaskedInput ? 'tel' : 'text'
    }, inputProps)
  }, TextFieldProps);
};

var MobileKeyboardInputView$1 = styled('div')({
  padding: '16px 24px'
});
var PickerRoot$1 = styled('div')(function (_ref) {
  var ownerState = _ref.ownerState;
  return _extends$4({
    display: 'flex',
    flexDirection: 'column'
  }, ownerState.isLandscape && {
    flexDirection: 'row'
  });
});

var useOpenState$1 = function useOpenState(_ref) {
  var open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose;
  var isControllingOpenProp = useRef(typeof open === 'boolean').current;
  var _React$useState = useState(false),
    openState = _React$useState[0],
    setIsOpenState = _React$useState[1];
  useEffect(function () {
    if (isControllingOpenProp) {
      if (typeof open !== 'boolean') {
        throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
      }
      setIsOpenState(open);
    }
  }, [isControllingOpenProp, open]);
  var setIsOpen = useCallback(function (newIsOpen) {
    if (!isControllingOpenProp) {
      setIsOpenState(newIsOpen);
    }
    if (newIsOpen && onOpen) {
      onOpen();
    }
    if (!newIsOpen && onClose) {
      onClose();
    }
  }, [isControllingOpenProp, onOpen, onClose]);
  return {
    isOpen: openState,
    setIsOpen: setIsOpen
  };
};

var usePickerState$1 = function usePickerState(props, valueManager) {
  var onAccept = props.onAccept,
    onChange = props.onChange,
    value = props.value,
    closeOnSelect = props.closeOnSelect;
  var utils = useUtils$1();
  var _useOpenState = useOpenState$1(props),
    isOpen = _useOpenState.isOpen,
    setIsOpen = _useOpenState.setIsOpen;
  var parsedDateValue = useMemo(function () {
    return valueManager.parseInput(utils, value);
  }, [valueManager, utils, value]);
  var _React$useState = useState(parsedDateValue),
    lastValidDateValue = _React$useState[0],
    setLastValidDateValue = _React$useState[1];
  var _React$useState2 = useState(function () {
      return {
        committed: parsedDateValue,
        draft: parsedDateValue,
        resetFallback: parsedDateValue
      };
    }),
    dateState = _React$useState2[0],
    setDateState = _React$useState2[1];
  var setDate = useCallback(function (params) {
    setDateState(function (prev) {
      switch (params.action) {
        case 'setAll':
        case 'acceptAndClose':
          {
            return {
              draft: params.value,
              committed: params.value,
              resetFallback: params.value
            };
          }
        case 'setCommitted':
          {
            return _extends$4({}, prev, {
              draft: params.value,
              committed: params.value
            });
          }
        case 'setDraft':
          {
            return _extends$4({}, prev, {
              draft: params.value
            });
          }
        default:
          {
            return prev;
          }
      }
    });
    if (params.forceOnChangeCall || !params.skipOnChangeCall && !valueManager.areValuesEqual(utils, dateState.committed, params.value)) {
      onChange(params.value);
    }
    if (params.action === 'acceptAndClose') {
      setIsOpen(false);
      if (onAccept && !valueManager.areValuesEqual(utils, dateState.resetFallback, params.value)) {
        onAccept(params.value);
      }
    }
  }, [onAccept, onChange, setIsOpen, dateState, utils, valueManager]);
  useEffect(function () {
    if (utils.isValid(parsedDateValue)) {
      setLastValidDateValue(parsedDateValue);
    }
  }, [utils, parsedDateValue]);
  useEffect(function () {
    if (isOpen) {
      setDate({
        action: 'setAll',
        value: parsedDateValue,
        skipOnChangeCall: true
      });
    }
  }, [isOpen]);
  if (!valueManager.areValuesEqual(utils, dateState.committed, parsedDateValue)) {
    setDate({
      action: 'setCommitted',
      value: parsedDateValue,
      skipOnChangeCall: true
    });
  }
  var wrapperProps = useMemo(function () {
    return {
      open: isOpen,
      onClear: function onClear() {
        setDate({
          value: valueManager.emptyValue,
          action: 'acceptAndClose',
          forceOnChangeCall: !valueManager.areValuesEqual(utils, value, valueManager.emptyValue)
        });
      },
      onAccept: function onAccept() {
        setDate({
          value: dateState.draft,
          action: 'acceptAndClose',
          forceOnChangeCall: !valueManager.areValuesEqual(utils, value, parsedDateValue)
        });
      },
      onDismiss: function onDismiss() {
        setDate({
          value: dateState.committed,
          action: 'acceptAndClose'
        });
      },
      onCancel: function onCancel() {
        setDate({
          value: dateState.resetFallback,
          action: 'acceptAndClose'
        });
      },
      onSetToday: function onSetToday() {
        setDate({
          value: valueManager.getTodayValue(utils),
          action: 'acceptAndClose'
        });
      }
    };
  }, [setDate, isOpen, utils, dateState, valueManager, value, parsedDateValue]);
  var _React$useState3 = useState(false),
    isMobileKeyboardViewOpen = _React$useState3[0],
    setMobileKeyboardViewOpen = _React$useState3[1];
  var pickerProps = useMemo(function () {
    return {
      parsedValue: dateState.draft,
      isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
      toggleMobileKeyboardView: function toggleMobileKeyboardView() {
        return setMobileKeyboardViewOpen(!isMobileKeyboardViewOpen);
      },
      onDateChange: function onDateChange(newDate, wrapperVariant, selectionState) {
        if (selectionState === void 0) {
          selectionState = 'partial';
        }
        switch (selectionState) {
          case 'shallow':
            {
              return setDate({
                action: 'setDraft',
                value: newDate,
                skipOnChangeCall: true
              });
            }
          case 'partial':
            {
              return setDate({
                action: 'setDraft',
                value: newDate
              });
            }
          case 'finish':
            {
              if (closeOnSelect != null ? closeOnSelect : wrapperVariant === 'desktop') {
                return setDate({
                  value: newDate,
                  action: 'acceptAndClose'
                });
              }
              return setDate({
                value: newDate,
                action: 'setCommitted'
              });
            }
          default:
            {
              throw new Error('MUI: Invalid selectionState passed to `onDateChange`');
            }
        }
      }
    };
  }, [setDate, isMobileKeyboardViewOpen, dateState.draft, closeOnSelect]);
  var handleInputChange = useCallback(function (newParsedValue, keyboardInputValue) {
    var cleanParsedValue = valueManager.valueReducer ? valueManager.valueReducer(utils, lastValidDateValue, newParsedValue) : newParsedValue;
    onChange(cleanParsedValue, keyboardInputValue);
  }, [onChange, valueManager, lastValidDateValue, utils]);
  var inputProps = useMemo(function () {
    return {
      onChange: handleInputChange,
      open: isOpen,
      rawValue: value,
      openPicker: function openPicker() {
        return setIsOpen(true);
      }
    };
  }, [handleInputChange, isOpen, value, setIsOpen]);
  var pickerState = {
    pickerProps: pickerProps,
    inputProps: inputProps,
    wrapperProps: wrapperProps
  };
  useDebugValue(pickerState, function () {
    return {
      MuiPickerState: {
        dateState: dateState,
        other: pickerState
      }
    };
  });
  return pickerState;
};

var _styled$2;
var PickersModalDialogRoot$1 = styled(Dialog)((_styled$2 = {}, _styled$2["& ." + dialogClasses.container] = {
  outline: 0
}, _styled$2["& ." + dialogClasses.paper] = {
  outline: 0,
  minWidth: DIALOG_WIDTH$1
}, _styled$2));
var PickersModalDialogContent$1 = styled(DialogContent)({
  '&:first-of-type': {
    padding: 0
  }
});
var PickersModalDialog$1 = function PickersModalDialog(props) {
  var _components$ActionBar;
  var children = props.children,
    _props$DialogProps = props.DialogProps,
    DialogProps = _props$DialogProps === void 0 ? {} : _props$DialogProps,
    onAccept = props.onAccept,
    onClear = props.onClear,
    onDismiss = props.onDismiss,
    onCancel = props.onCancel,
    onSetToday = props.onSetToday,
    open = props.open,
    components = props.components,
    componentsProps = props.componentsProps;
  var ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : PickersActionBar$1;
  return /*#__PURE__*/jsxs(PickersModalDialogRoot$1, _extends$4({
    open: open,
    onClose: onDismiss
  }, DialogProps, {
    children: [/*#__PURE__*/jsx(PickersModalDialogContent$1, {
      children: children
    }), /*#__PURE__*/jsx(ActionBar, _extends$4({
      onAccept: onAccept,
      onClear: onClear,
      onCancel: onCancel,
      onSetToday: onSetToday,
      actions: ['cancel', 'accept']
    }, componentsProps == null ? void 0 : componentsProps.actionBar))]
  }));
};

var _excluded$S = ["children", "DateInputProps", "DialogProps", "onAccept", "onClear", "onDismiss", "onCancel", "onSetToday", "open", "PureDateInputComponent", "components", "componentsProps"];
function MobileWrapper$1(props) {
  var children = props.children,
    DateInputProps = props.DateInputProps,
    DialogProps = props.DialogProps,
    onAccept = props.onAccept,
    onClear = props.onClear,
    onDismiss = props.onDismiss,
    onCancel = props.onCancel,
    onSetToday = props.onSetToday,
    open = props.open,
    PureDateInputComponent = props.PureDateInputComponent,
    components = props.components,
    componentsProps = props.componentsProps,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$S);
  return /*#__PURE__*/jsxs(WrapperVariantContext$1.Provider, {
    value: "mobile",
    children: [/*#__PURE__*/jsx(PureDateInputComponent, _extends$4({
      components: components
    }, other, DateInputProps)), /*#__PURE__*/jsx(PickersModalDialog$1, {
      DialogProps: DialogProps,
      onAccept: onAccept,
      onClear: onClear,
      onDismiss: onDismiss,
      onCancel: onCancel,
      onSetToday: onSetToday,
      open: open,
      components: components,
      componentsProps: componentsProps,
      children: children
    })]
  });
}

var _excluded$T = ["className", "selected", "value"];
var classes$8 = generateUtilityClasses$1('PrivatePickersToolbarText', ['selected']);
var PickersToolbarTextRoot = styled(Typography)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {
    transition: theme.transitions.create('color'),
    color: theme.palette.text.secondary
  }, _ref2["&." + classes$8.selected] = {
    color: theme.palette.text.primary
  }, _ref2;
});
var PickersToolbarText = /*#__PURE__*/forwardRef(function PickersToolbarText(props, ref) {
  var className = props.className,
    selected = props.selected,
    value = props.value,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$T);
  return /*#__PURE__*/jsx(PickersToolbarTextRoot, _extends$4({
    ref: ref,
    className: clsx$1(className, selected && classes$8.selected),
    component: "span"
  }, other, {
    children: value
  }));
});

var _excluded$U = ["align", "className", "selected", "typographyClassName", "value", "variant"];
var PickersToolbarButtonRoot = styled(Button)({
  padding: 0,
  minWidth: 16,
  textTransform: 'none'
});
var PickersToolbarButton = /*#__PURE__*/forwardRef(function PickersToolbarButton(props, ref) {
  var align = props.align,
    className = props.className,
    selected = props.selected,
    typographyClassName = props.typographyClassName,
    value = props.value,
    variant = props.variant,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$U);
  return /*#__PURE__*/jsx(PickersToolbarButtonRoot, _extends$4({
    variant: "text",
    ref: ref,
    className: className
  }, other, {
    children: /*#__PURE__*/jsx(PickersToolbarText, {
      align: align,
      className: typographyClassName,
      variant: variant,
      value: value,
      selected: selected
    })
  }));
});

var getReleaseInfo = function getReleaseInfo() {
  var releaseInfo = "MTY2MDE2NTIwMDAwMA==";
  if (process.env.NODE_ENV !== 'production') ;
  return releaseInfo;
};

function DesktopTooltipWrapper(props) {
  var children = props.children,
    DateInputProps = props.DateInputProps,
    KeyboardDateInputComponent = props.KeyboardDateInputComponent,
    open = props.open,
    PopperProps = props.PopperProps,
    TransitionComponent = props.TransitionComponent,
    onClear = props.onClear,
    onDismiss = props.onDismiss,
    onCancel = props.onCancel,
    onAccept = props.onAccept,
    onSetToday = props.onSetToday,
    components = props.components,
    componentsProps = props.componentsProps;
  var inputContainerRef = useRef(null);
  var popperRef = useRef(null);
  var handleBlur = function handleBlur() {
    executeInTheNextEventLoopTick(function () {
      var _inputContainerRef$cu, _popperRef$current;
      if ((_inputContainerRef$cu = inputContainerRef.current) != null && _inputContainerRef$cu.contains(document.activeElement) || (_popperRef$current = popperRef.current) != null && _popperRef$current.contains(document.activeElement)) {
        return;
      }
      onDismiss();
    });
  };
  var inputComponentRef = useForkRef$1(DateInputProps.ref, inputContainerRef);
  return /*#__PURE__*/jsxs(WrapperVariantContext$1.Provider, {
    value: "desktop",
    children: [/*#__PURE__*/jsx(KeyboardDateInputComponent, _extends$4({}, DateInputProps, {
      ref: inputComponentRef,
      onBlur: handleBlur
    })), /*#__PURE__*/jsx(PickersPopper$1, {
      role: "tooltip",
      open: open,
      containerRef: popperRef,
      anchorEl: inputContainerRef.current,
      TransitionComponent: TransitionComponent,
      PopperProps: PopperProps,
      onBlur: handleBlur,
      onClose: onDismiss,
      onClear: onClear,
      onCancel: onCancel,
      onAccept: onAccept,
      onSetToday: onSetToday,
      components: components,
      componentsProps: componentsProps,
      children: children
    })]
  });
}

var parseRangeInputValue = function parseRangeInputValue(utils, value) {
  if (value === void 0) {
    value = [null, null];
  }
  return value.map(function (date) {
    if (date === null || !utils.isValid(date)) {
      return null;
    }
    return utils.startOfDay(utils.date(date));
  });
};
var isRangeValid = function isRangeValid(utils, range) {
  return Boolean(range && range[0] && range[1] && !utils.isBefore(range[1], range[0]));
};
var isWithinRange = function isWithinRange(utils, day, range) {
  return isRangeValid(utils, range) && utils.isWithinRange(day, range);
};
var isStartOfRange = function isStartOfRange(utils, day, range) {
  return isRangeValid(utils, range) && utils.isSameDay(day, range[0]);
};
var isEndOfRange = function isEndOfRange(utils, day, range) {
  return isRangeValid(utils, range) && utils.isSameDay(day, range[1]);
};

function calculateRangeChange(_ref) {
  var utils = _ref.utils,
    range = _ref.range,
    selectedDate = _ref.newDate,
    currentlySelectingRangeEnd = _ref.currentlySelectingRangeEnd;
  var start = range[0],
    end = range[1];
  if (currentlySelectingRangeEnd === 'start') {
    return Boolean(end) && utils.isAfter(selectedDate, end) ? {
      nextSelection: 'end',
      newRange: [selectedDate, null]
    } : {
      nextSelection: 'end',
      newRange: [selectedDate, end]
    };
  }
  return Boolean(start) && utils.isBefore(selectedDate, start) ? {
    nextSelection: 'end',
    newRange: [selectedDate, null]
  } : {
    nextSelection: 'start',
    newRange: [start, selectedDate]
  };
}
function calculateRangePreview(options) {
  if (!options.newDate) {
    return [null, null];
  }
  var _options$range = options.range,
    start = _options$range[0],
    end = _options$range[1];
  var _calculateRangeChange = calculateRangeChange(options),
    newRange = _calculateRangeChange.newRange;
  if (!start || !end) {
    return newRange;
  }
  var previewStart = newRange[0],
    previewEnd = newRange[1];
  return options.currentlySelectingRangeEnd === 'end' ? [end, previewEnd] : [previewStart, start];
}

var _styled$3;
var dateRangePickerToolbarClasses = generateUtilityClasses$1('MuiDateRangePickerToolbar', ['root']);
var DateRangePickerToolbarRoot = styled(PickersToolbar$1, {
  name: 'MuiDateRangePickerToolbar',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})((_styled$3 = {}, _styled$3["& ." + pickersToolbarClasses$1.penIconButton] = {
  position: 'relative',
  top: 4
}, _styled$3));
var DateRangePickerToolbarContainer = styled('div')({
  display: 'flex'
});
var DateRangePickerToolbar = function DateRangePickerToolbar(props) {
  var utils = useUtils$1();
  var currentlySelectingRangeEnd = props.currentlySelectingRangeEnd,
    _props$parsedValue = props.parsedValue,
    start = _props$parsedValue[0],
    end = _props$parsedValue[1],
    endText = props.endText,
    isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
    setCurrentlySelectingRangeEnd = props.setCurrentlySelectingRangeEnd,
    startText = props.startText,
    toggleMobileKeyboardView = props.toggleMobileKeyboardView,
    toolbarFormat = props.toolbarFormat,
    _props$toolbarTitle = props.toolbarTitle,
    toolbarTitle = _props$toolbarTitle === void 0 ? 'Select date range' : _props$toolbarTitle;
  var startDateValue = start ? utils.formatByString(start, toolbarFormat || utils.formats.shortDate) : startText;
  var endDateValue = end ? utils.formatByString(end, toolbarFormat || utils.formats.shortDate) : endText;
  var ownerState = props;
  return /*#__PURE__*/jsx(DateRangePickerToolbarRoot, {
    toolbarTitle: toolbarTitle,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView,
    isLandscape: false,
    className: dateRangePickerToolbarClasses.root,
    ownerState: ownerState,
    children: /*#__PURE__*/jsxs(DateRangePickerToolbarContainer, {
      children: [/*#__PURE__*/jsx(PickersToolbarButton, {
        variant: start !== null ? 'h5' : 'h6',
        value: startDateValue,
        selected: currentlySelectingRangeEnd === 'start',
        onClick: function onClick() {
          return setCurrentlySelectingRangeEnd('start');
        }
      }), /*#__PURE__*/jsxs(Typography, {
        variant: "h5",
        children: ["\xA0", '–', "\xA0"]
      }), /*#__PURE__*/jsx(PickersToolbarButton, {
        variant: end !== null ? 'h5' : 'h6',
        value: endDateValue,
        selected: currentlySelectingRangeEnd === 'end',
        onClick: function onClick() {
          return setCurrentlySelectingRangeEnd('end');
        }
      })]
    })
  });
};

var doNothing = function doNothing() {};

function getDateRangePickerDayUtilityClass(slot) {
  return generateUtilityClass$1('MuiDateRangePickerDay', slot);
}
var dateRangePickerDayClasses = generateUtilityClasses$1('MuiDateRangePickerDay', ['root', 'rangeIntervalDayHighlight', 'rangeIntervalDayHighlightStart', 'rangeIntervalDayHighlightEnd', 'rangeIntervalPreview', 'rangeIntervalDayPreview', 'rangeIntervalDayPreviewStart', 'rangeIntervalDayPreviewEnd', 'day', 'dayOutsideRangeInterval', 'dayInsideRangeInterval', 'notSelectedDate']);

var _excluded$V = ["className", "day", "outsideCurrentMonth", "isEndOfHighlighting", "isEndOfPreviewing", "isHighlighting", "isPreviewing", "isStartOfHighlighting", "isStartOfPreviewing", "selected"];
var releaseInfo = getReleaseInfo();
var useUtilityClasses$a = function useUtilityClasses(ownerState) {
  var isHighlighting = ownerState.isHighlighting,
    outsideCurrentMonth = ownerState.outsideCurrentMonth,
    isStartOfHighlighting = ownerState.isStartOfHighlighting,
    isStartOfMonth = ownerState.isStartOfMonth,
    isEndOfHighlighting = ownerState.isEndOfHighlighting,
    isEndOfMonth = ownerState.isEndOfMonth,
    isPreviewing = ownerState.isPreviewing,
    isStartOfPreviewing = ownerState.isStartOfPreviewing,
    isEndOfPreviewing = ownerState.isEndOfPreviewing,
    selected = ownerState.selected,
    classes = ownerState.classes;
  var slots = {
    root: ['root', isHighlighting && !outsideCurrentMonth && 'rangeIntervalDayHighlight', (isStartOfHighlighting || isStartOfMonth) && 'rangeIntervalDayHighlightStart', (isEndOfHighlighting || isEndOfMonth) && 'rangeIntervalDayHighlightEnd'],
    rangeIntervalPreview: ['rangeIntervalPreview', isPreviewing && !outsideCurrentMonth && 'rangeIntervalDayPreview', (isStartOfPreviewing || isStartOfMonth) && 'rangeIntervalDayPreviewStart', (isEndOfPreviewing || isEndOfMonth) && 'rangeIntervalDayPreviewEnd'],
    day: ['day', !selected && 'notSelectedDate', !isHighlighting && 'dayOutsideRangeInterval', !selected && isHighlighting && 'dayInsideRangeInterval']
  };
  return unstable_composeClasses(slots, getDateRangePickerDayUtilityClass, classes);
};
var endBorderStyle = {
  borderTopRightRadius: '50%',
  borderBottomRightRadius: '50%'
};
var startBorderStyle = {
  borderTopLeftRadius: '50%',
  borderBottomLeftRadius: '50%'
};
var DateRangePickerDayRoot = styled('div', {
  name: 'MuiDateRangePickerDay',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})(function (_ref) {
  var _extends2;
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _extends$4((_extends2 = {}, _extends2["&:first-of-type ." + dateRangePickerDayClasses.rangeIntervalDayPreview] = _extends$4({}, startBorderStyle, {
    borderLeftColor: theme.palette.divider
  }), _extends2["&:last-of-type ." + dateRangePickerDayClasses.rangeIntervalDayPreview] = _extends$4({}, endBorderStyle, {
    borderRightColor: theme.palette.divider
  }), _extends2), ownerState.isHighlighting && !ownerState.outsideCurrentMonth && {
    borderRadius: 0,
    color: theme.palette.primary.contrastText,
    backgroundColor: alpha(theme.palette.primary.light, 0.6),
    '&:first-of-type': startBorderStyle,
    '&:last-of-type': endBorderStyle
  }, (ownerState.isStartOfHighlighting || ownerState.isStartOfMonth) && _extends$4({}, startBorderStyle, {
    paddingLeft: 0,
    marginLeft: DAY_MARGIN$1 / 2
  }), (ownerState.isEndOfHighlighting || ownerState.isEndOfMonth) && _extends$4({}, endBorderStyle, {
    paddingRight: 0,
    marginRight: DAY_MARGIN$1 / 2
  }));
});
DateRangePickerDayRoot.propTypes = {
  ownerState: propTypes.object.isRequired
};
var DateRangePickerDayRangeIntervalPreview = styled('div', {
  name: 'MuiDateRangePickerDay',
  slot: 'RangeIntervalPreview'
})(function (_ref2) {
  var theme = _ref2.theme,
    ownerState = _ref2.ownerState;
  return _extends$4({
    border: '2px solid transparent'
  }, ownerState.isPreviewing && !ownerState.outsideCurrentMonth && _extends$4({
    borderRadius: 0,
    border: "2px dashed " + theme.palette.divider,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent'
  }, (ownerState.isStartOfPreviewing || ownerState.isStartOfMonth) && _extends$4({
    borderLeftColor: theme.palette.divider
  }, startBorderStyle), (ownerState.isEndOfPreviewing || ownerState.isEndOfMonth) && _extends$4({
    borderRightColor: theme.palette.divider
  }, endBorderStyle)));
});
DateRangePickerDayRangeIntervalPreview.propTypes = {
  ownerState: propTypes.object.isRequired
};
var DateRangePickerDayDay = styled(PickersDay$1, {
  name: 'MuiDateRangePickerDay',
  slot: 'Day'
})(function (_ref3) {
  var theme = _ref3.theme,
    ownerState = _ref3.ownerState;
  return _extends$4({
    transform: 'scale(1.1)',
    '& > *': {
      transform: 'scale(0.9)'
    }
  }, !ownerState.selected && {
    backgroundColor: 'transparent'
  }, !ownerState.isHighlighting && {
    '&:hover': {
      border: "1px solid " + theme.palette.grey[500]
    }
  }, !ownerState.selected && ownerState.isHighlighting && {
    color: theme.palette.getContrastText(alpha(theme.palette.primary.light, 0.6))
  });
});
var DateRangePickerDayRaw = /*#__PURE__*/forwardRef(function DateRangePickerDay(props, ref) {
  var className = props.className,
    day = props.day,
    outsideCurrentMonth = props.outsideCurrentMonth,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$V);
  useLicenseVerifier('x-date-pickers-pro', releaseInfo);
  var utils = useUtils$1();
  var isEndOfMonth = utils.isSameDay(day, utils.endOfMonth(day));
  var isStartOfMonth = utils.isSameDay(day, utils.startOfMonth(day));
  var ownerState = _extends$4({}, props, {
    selected: selected,
    isStartOfMonth: isStartOfMonth,
    isEndOfMonth: isEndOfMonth
  });
  var classes = useUtilityClasses$a(ownerState);
  return /*#__PURE__*/jsx(DateRangePickerDayRoot, {
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    children: /*#__PURE__*/jsx(DateRangePickerDayRangeIntervalPreview, {
      role: "cell",
      className: classes.rangeIntervalPreview,
      ownerState: ownerState,
      children: /*#__PURE__*/jsx(DateRangePickerDayDay, _extends$4({}, other, {
        ref: ref,
        disableMargin: true,
        day: day,
        selected: selected,
        outsideCurrentMonth: outsideCurrentMonth,
        className: classes.day,
        ownerState: ownerState
      }))
    })
  });
});
process.env.NODE_ENV !== "production" ? DateRangePickerDayRaw.propTypes = {
  classes: propTypes.object,
  day: propTypes.any.isRequired,
  disabled: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disableMargin: propTypes.bool,
  isAnimating: propTypes.bool,
  isEndOfHighlighting: propTypes.bool.isRequired,
  isEndOfPreviewing: propTypes.bool.isRequired,
  isHighlighting: propTypes.bool.isRequired,
  isPreviewing: propTypes.bool.isRequired,
  isStartOfHighlighting: propTypes.bool.isRequired,
  isStartOfPreviewing: propTypes.bool.isRequired,
  onDayFocus: propTypes.func,
  onDaySelect: propTypes.func.isRequired,
  outsideCurrentMonth: propTypes.bool.isRequired,
  selected: propTypes.bool,
  showDaysOutsideCurrentMonth: propTypes.bool,
  sx: propTypes.oneOfType([propTypes.arrayOf(propTypes.oneOfType([propTypes.func, propTypes.object, propTypes.bool])), propTypes.func, propTypes.object]),
  today: propTypes.bool
} : void 0;
var propsAreEqual = function propsAreEqual(prevProps, nextProps) {
  return prevProps.isHighlighting === nextProps.isHighlighting && prevProps.isEndOfHighlighting === nextProps.isEndOfHighlighting && prevProps.isStartOfHighlighting === nextProps.isStartOfHighlighting && prevProps.isPreviewing === nextProps.isPreviewing && prevProps.isEndOfPreviewing === nextProps.isEndOfPreviewing && prevProps.isStartOfPreviewing === nextProps.isStartOfPreviewing && areDayPropsEqual$1(prevProps, nextProps);
};
var DateRangePickerDay = /*#__PURE__*/memo(DateRangePickerDayRaw, propsAreEqual);

var _excluded$W = ["changeMonth", "components", "componentsProps", "parsedValue", "leftArrowButtonText", "maxDate", "minDate", "onSelectedDaysChange", "renderDay", "rightArrowButtonText", "disabled", "readOnly"];
var onlyDayView = ['day'];
function DateRangePickerViewMobile(props) {
  var changeMonth = props.changeMonth,
    components = props.components,
    componentsProps = props.componentsProps,
    parsedValue = props.parsedValue,
    leftArrowButtonText = props.leftArrowButtonText,
    maxDateProp = props.maxDate,
    minDateProp = props.minDate,
    onSelectedDaysChange = props.onSelectedDaysChange,
    _props$renderDay = props.renderDay,
    _renderDay = _props$renderDay === void 0 ? function (_, dayProps) {
      return /*#__PURE__*/jsx(DateRangePickerDay, _extends$4({}, dayProps));
    } : _props$renderDay,
    rightArrowButtonText = props.rightArrowButtonText,
    disabled = props.disabled,
    readOnly = props.readOnly,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$W);
  var utils = useUtils$1();
  var defaultDates = useDefaultDates$1();
  var minDate = minDateProp != null ? minDateProp : defaultDates.minDate;
  var maxDate = maxDateProp != null ? maxDateProp : defaultDates.maxDate;
  var start = parsedValue[0],
    end = parsedValue[1];
  var minDateWithDisabled = disabled && start || minDate;
  var maxDateWithDisabled = disabled && end || maxDate;
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(PickersCalendarHeader$1, _extends$4({
      components: components,
      componentsProps: componentsProps,
      leftArrowButtonText: leftArrowButtonText,
      maxDate: maxDateWithDisabled,
      minDate: minDateWithDisabled,
      onMonthChange: changeMonth,
      openView: "day",
      rightArrowButtonText: rightArrowButtonText,
      views: onlyDayView,
      disabled: disabled
    }, other)), /*#__PURE__*/jsx(DayPicker$1, _extends$4({}, other, {
      minDate: minDate,
      maxDate: maxDate,
      disabled: disabled,
      readOnly: readOnly,
      selectedDays: parsedValue,
      onSelectedDaysChange: onSelectedDaysChange,
      onFocusedDayChange: doNothing,
      renderDay: function renderDay(day, _, DayProps) {
        return _renderDay(day, _extends$4({
          isPreviewing: false,
          isStartOfPreviewing: false,
          isEndOfPreviewing: false,
          isHighlighting: isWithinRange(utils, day, parsedValue),
          isStartOfHighlighting: isStartOfRange(utils, day, parsedValue),
          isEndOfHighlighting: isEndOfRange(utils, day, parsedValue)
        }, DayProps));
      }
    }))]
  });
}

var _excluded$X = ["currentlySelectingRangeEnd", "disableOpenPicker", "endText", "onBlur", "onChange", "open", "openPicker", "rawValue", "rawValue", "readOnly", "renderInput", "setCurrentlySelectingRangeEnd", "startText", "TextFieldProps", "validationError"];
var DateRangePickerInputRoot = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {
    display: 'flex',
    alignItems: 'baseline'
  }, _ref2[theme.breakpoints.down('xs')] = {
    flexDirection: 'column',
    alignItems: 'center'
  }, _ref2;
});
var DateRangePickerInput = /*#__PURE__*/forwardRef(function DateRangePickerInput(props, ref) {
  var currentlySelectingRangeEnd = props.currentlySelectingRangeEnd,
    disableOpenPicker = props.disableOpenPicker,
    endText = props.endText,
    onBlur = props.onBlur,
    onChange = props.onChange,
    open = props.open,
    openPicker = props.openPicker,
    _props$rawValue = props.rawValue,
    start = _props$rawValue[0],
    end = _props$rawValue[1],
    readOnly = props.readOnly,
    renderInput = props.renderInput,
    setCurrentlySelectingRangeEnd = props.setCurrentlySelectingRangeEnd,
    startText = props.startText,
    TextFieldProps = props.TextFieldProps,
    _props$validationErro = props.validationError,
    startValidationError = _props$validationErro[0],
    endValidationError = _props$validationErro[1],
    other = _objectWithoutPropertiesLoose$4(props, _excluded$X);
  var utils = useUtils$1();
  var startRef = useRef(null);
  var endRef = useRef(null);
  useEffect(function () {
    if (!open) {
      return;
    }
    if (currentlySelectingRangeEnd === 'start') {
      var _startRef$current;
      (_startRef$current = startRef.current) == null ? void 0 : _startRef$current.focus();
    } else if (currentlySelectingRangeEnd === 'end') {
      var _endRef$current;
      (_endRef$current = endRef.current) == null ? void 0 : _endRef$current.focus();
    }
  }, [currentlySelectingRangeEnd, open]);
  var lazyHandleChangeCallback = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return executeInTheNextEventLoopTick(function () {
      return onChange.apply(void 0, args);
    });
  }, [onChange]);
  var handleStartChange = function handleStartChange(date, inputString) {
    lazyHandleChangeCallback([date, utils.date(end)], inputString);
  };
  var handleEndChange = function handleEndChange(date, inputString) {
    lazyHandleChangeCallback([utils.date(start), date], inputString);
  };
  var openRangeStartSelection = function openRangeStartSelection() {
    if (setCurrentlySelectingRangeEnd) {
      setCurrentlySelectingRangeEnd('start');
    }
    if (!readOnly && !disableOpenPicker) {
      openPicker();
    }
  };
  var openRangeEndSelection = function openRangeEndSelection() {
    if (setCurrentlySelectingRangeEnd) {
      setCurrentlySelectingRangeEnd('end');
    }
    if (!readOnly && !disableOpenPicker) {
      openPicker();
    }
  };
  var focusOnRangeEnd = function focusOnRangeEnd() {
    if (open && setCurrentlySelectingRangeEnd) {
      setCurrentlySelectingRangeEnd('end');
    }
  };
  var focusOnRangeStart = function focusOnRangeStart() {
    if (open && setCurrentlySelectingRangeEnd) {
      setCurrentlySelectingRangeEnd('start');
    }
  };
  var startInputProps = useMaskedInput$1(_extends$4({}, other, {
    readOnly: readOnly,
    rawValue: start,
    onChange: handleStartChange,
    label: startText,
    validationError: startValidationError !== null,
    TextFieldProps: _extends$4({}, TextFieldProps, {
      ref: startRef,
      focused: open && currentlySelectingRangeEnd === 'start'
    }),
    inputProps: {
      onClick: openRangeStartSelection,
      onKeyDown: onSpaceOrEnter$1(openRangeStartSelection),
      onFocus: focusOnRangeStart
    }
  }));
  var endInputProps = useMaskedInput$1(_extends$4({}, other, {
    readOnly: readOnly,
    label: endText,
    rawValue: end,
    onChange: handleEndChange,
    validationError: endValidationError !== null,
    TextFieldProps: _extends$4({}, TextFieldProps, {
      ref: endRef,
      focused: open && currentlySelectingRangeEnd === 'end'
    }),
    inputProps: {
      onClick: openRangeEndSelection,
      onKeyDown: onSpaceOrEnter$1(openRangeEndSelection),
      onFocus: focusOnRangeEnd
    }
  }));
  return /*#__PURE__*/jsx(DateRangePickerInputRoot, {
    onBlur: onBlur,
    ref: ref,
    children: renderInput(startInputProps, endInputProps)
  });
});

var _excluded$Y = ["calendars", "changeMonth", "components", "componentsProps", "currentlySelectingRangeEnd", "currentMonth", "parsedValue", "disableFuture", "disablePast", "leftArrowButtonText", "maxDate", "minDate", "onSelectedDaysChange", "renderDay", "rightArrowButtonText"];
var DateRangePickerViewDesktopRoot = styled('div')({
  display: 'flex',
  flexDirection: 'row'
});
var DateRangePickerViewDesktopContainer = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    '&:not(:last-of-type)': {
      borderRight: "2px solid " + theme.palette.divider
    }
  };
});
var DAY_RANGE_SIZE = 40;
var weeksContainerHeight$2 = (DAY_RANGE_SIZE + DAY_MARGIN$1 * 2) * 6;
var DateRangePickerViewDesktopCalendar = styled(DayPicker$1)({
  minWidth: 312,
  minHeight: weeksContainerHeight$2
});
var DateRangePickerViewDesktopArrowSwitcher = styled(PickersArrowSwitcher$1)({
  padding: '16px 16px 8px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
});
function getCalendarsArray(calendars) {
  switch (calendars) {
    case 1:
      return [0];
    case 2:
      return [0, 0];
    case 3:
      return [0, 0, 0];
    default:
      return new Array(calendars).fill(0);
  }
}
var deprecatedPropsWarning$3 = buildDeprecatedPropsWarning$1('Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.');
function DateRangePickerViewDesktop(props) {
  var calendars = props.calendars,
    changeMonth = props.changeMonth,
    components = props.components,
    componentsProps = props.componentsProps,
    currentlySelectingRangeEnd = props.currentlySelectingRangeEnd,
    currentMonth = props.currentMonth,
    parsedValue = props.parsedValue,
    disableFuture = props.disableFuture,
    disablePast = props.disablePast,
    leftArrowButtonTextProp = props.leftArrowButtonText,
    maxDateProp = props.maxDate,
    minDateProp = props.minDate,
    onSelectedDaysChange = props.onSelectedDaysChange,
    _props$renderDay = props.renderDay,
    _renderDay = _props$renderDay === void 0 ? function (_, dateRangeProps) {
      return /*#__PURE__*/jsx(DateRangePickerDay, _extends$4({}, dateRangeProps));
    } : _props$renderDay,
    rightArrowButtonTextProp = props.rightArrowButtonText,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$Y);
  deprecatedPropsWarning$3({
    leftArrowButtonText: leftArrowButtonTextProp,
    rightArrowButtonText: rightArrowButtonTextProp
  });
  var localeText = useLocaleText$1();
  var leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.previousMonth;
  var rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.nextMonth;
  var utils = useUtils$1();
  var defaultDates = useDefaultDates$1();
  var minDate = minDateProp != null ? minDateProp : defaultDates.minDate;
  var maxDate = maxDateProp != null ? maxDateProp : defaultDates.maxDate;
  var _React$useState = useState(null),
    rangePreviewDay = _React$useState[0],
    setRangePreviewDay = _React$useState[1];
  var isNextMonthDisabled = useNextMonthDisabled$1(currentMonth, {
    disableFuture: disableFuture,
    maxDate: maxDate
  });
  var isPreviousMonthDisabled = usePreviousMonthDisabled$1(currentMonth, {
    disablePast: disablePast,
    minDate: minDate
  });
  var previewingRange = calculateRangePreview({
    utils: utils,
    range: parsedValue,
    newDate: rangePreviewDay,
    currentlySelectingRangeEnd: currentlySelectingRangeEnd
  });
  var handleSelectedDayChange = useCallback(function (day) {
    setRangePreviewDay(null);
    onSelectedDaysChange(day);
  }, [onSelectedDaysChange]);
  var handlePreviewDayChange = function handlePreviewDayChange(newPreviewRequest) {
    if (!isWithinRange(utils, newPreviewRequest, parsedValue)) {
      setRangePreviewDay(newPreviewRequest);
    } else {
      setRangePreviewDay(null);
    }
  };
  var CalendarTransitionProps = useMemo(function () {
    return {
      onMouseLeave: function onMouseLeave() {
        return setRangePreviewDay(null);
      }
    };
  }, []);
  var selectNextMonth = useCallback(function () {
    changeMonth(utils.getNextMonth(currentMonth));
  }, [changeMonth, currentMonth, utils]);
  var selectPreviousMonth = useCallback(function () {
    changeMonth(utils.getPreviousMonth(currentMonth));
  }, [changeMonth, currentMonth, utils]);
  return /*#__PURE__*/jsx(DateRangePickerViewDesktopRoot, {
    children: getCalendarsArray(calendars).map(function (_, index) {
      var monthOnIteration = utils.setMonth(currentMonth, utils.getMonth(currentMonth) + index);
      return /*#__PURE__*/jsxs(DateRangePickerViewDesktopContainer, {
        children: [/*#__PURE__*/jsx(DateRangePickerViewDesktopArrowSwitcher, {
          onLeftClick: selectPreviousMonth,
          onRightClick: selectNextMonth,
          isLeftHidden: index !== 0,
          isRightHidden: index !== calendars - 1,
          isLeftDisabled: isPreviousMonthDisabled,
          isRightDisabled: isNextMonthDisabled,
          leftArrowButtonText: leftArrowButtonText,
          components: components,
          componentsProps: componentsProps,
          rightArrowButtonText: rightArrowButtonText,
          children: utils.format(monthOnIteration, 'monthAndYear')
        }), /*#__PURE__*/createElement(DateRangePickerViewDesktopCalendar, _extends$4({}, other, {
          minDate: minDate,
          maxDate: maxDate,
          disablePast: disablePast,
          disableFuture: disableFuture,
          key: index,
          selectedDays: parsedValue,
          onFocusedDayChange: doNothing,
          onSelectedDaysChange: handleSelectedDayChange,
          currentMonth: monthOnIteration,
          TransitionProps: CalendarTransitionProps,
          renderDay: function renderDay(day, __, DayProps) {
            return _renderDay(day, _extends$4({
              isPreviewing: isWithinRange(utils, day, previewingRange),
              isStartOfPreviewing: isStartOfRange(utils, day, previewingRange),
              isEndOfPreviewing: isEndOfRange(utils, day, previewingRange),
              isHighlighting: isWithinRange(utils, day, parsedValue),
              isStartOfHighlighting: isStartOfRange(utils, day, parsedValue),
              isEndOfHighlighting: isEndOfRange(utils, day, parsedValue),
              onMouseEnter: function onMouseEnter() {
                return handlePreviewDayChange(day);
              }
            }, DayProps));
          }
        }))]
      }, index);
    })
  });
}

var _excluded$Z = ["calendars", "className", "currentlySelectingRangeEnd", "parsedValue", "DateInputProps", "defaultCalendarMonth", "disableAutoMonthSwitching", "disableFuture", "disableHighlightToday", "disablePast", "endText", "isMobileKeyboardViewOpen", "maxDate", "minDate", "onDateChange", "onMonthChange", "open", "reduceAnimations", "setCurrentlySelectingRangeEnd", "shouldDisableDate", "showToolbar", "startText", "toggleMobileKeyboardView", "toolbarFormat", "toolbarTitle"];
var releaseInfo$1 = getReleaseInfo();
function DateRangePickerViewRaw(props) {
  var calendars = props.calendars,
    className = props.className,
    currentlySelectingRangeEnd = props.currentlySelectingRangeEnd,
    parsedValue = props.parsedValue,
    DateInputProps = props.DateInputProps,
    defaultCalendarMonth = props.defaultCalendarMonth,
    _props$disableAutoMon = props.disableAutoMonthSwitching,
    disableAutoMonthSwitching = _props$disableAutoMon === void 0 ? false : _props$disableAutoMon,
    disableFuture = props.disableFuture,
    disableHighlightToday = props.disableHighlightToday,
    disablePast = props.disablePast,
    endText = props.endText,
    isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
    maxDate = props.maxDate,
    minDate = props.minDate,
    onDateChange = props.onDateChange,
    onMonthChange = props.onMonthChange,
    open = props.open,
    _props$reduceAnimatio = props.reduceAnimations,
    reduceAnimations = _props$reduceAnimatio === void 0 ? defaultReduceAnimations$1 : _props$reduceAnimatio,
    setCurrentlySelectingRangeEnd = props.setCurrentlySelectingRangeEnd,
    shouldDisableDate = props.shouldDisableDate,
    showToolbar = props.showToolbar,
    startText = props.startText,
    toggleMobileKeyboardView = props.toggleMobileKeyboardView,
    toolbarFormat = props.toolbarFormat,
    toolbarTitle = props.toolbarTitle,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$Z);
  var utils = useUtils$1();
  var wrapperVariant = useContext(WrapperVariantContext$1);
  var start = parsedValue[0],
    end = parsedValue[1];
  var _useCalendarState = useCalendarState$1({
      date: start || end,
      defaultCalendarMonth: defaultCalendarMonth,
      disableFuture: disableFuture,
      disablePast: disablePast,
      disableSwitchToMonthOnDayFocus: true,
      maxDate: maxDate,
      minDate: minDate,
      onMonthChange: onMonthChange,
      reduceAnimations: reduceAnimations,
      shouldDisableDate: shouldDisableDate
    }),
    changeMonth = _useCalendarState.changeMonth,
    calendarState = _useCalendarState.calendarState,
    isDateDisabled = _useCalendarState.isDateDisabled,
    onMonthSwitchingAnimationEnd = _useCalendarState.onMonthSwitchingAnimationEnd,
    changeFocusedDay = _useCalendarState.changeFocusedDay;
  var toShowToolbar = showToolbar != null ? showToolbar : wrapperVariant !== 'desktop';
  var scrollToDayIfNeeded = function scrollToDayIfNeeded(day) {
    if (!day || !utils.isValid(day) || isDateDisabled(day)) {
      return;
    }
    var currentlySelectedDate = currentlySelectingRangeEnd === 'start' ? start : end;
    if (currentlySelectedDate === null) {
      return;
    }
    var displayingMonthRange = wrapperVariant === 'mobile' ? 0 : calendars - 1;
    var currentMonthNumber = utils.getMonth(calendarState.currentMonth);
    var requestedMonthNumber = utils.getMonth(day);
    if (!utils.isSameYear(calendarState.currentMonth, day) || requestedMonthNumber < currentMonthNumber || requestedMonthNumber > currentMonthNumber + displayingMonthRange) {
      var newMonth = currentlySelectingRangeEnd === 'start' ? currentlySelectedDate : utils.addMonths(currentlySelectedDate, -displayingMonthRange);
      changeMonth(newMonth);
    }
  };
  useEffect(function () {
    if (disableAutoMonthSwitching || !open) {
      return;
    }
    scrollToDayIfNeeded(currentlySelectingRangeEnd === 'start' ? start : end);
  }, [currentlySelectingRangeEnd, parsedValue]);
  var handleSelectedDayChange = useCallback(function (newDate) {
    var _calculateRangeChange = calculateRangeChange({
        newDate: newDate,
        utils: utils,
        range: parsedValue,
        currentlySelectingRangeEnd: currentlySelectingRangeEnd
      }),
      nextSelection = _calculateRangeChange.nextSelection,
      newRange = _calculateRangeChange.newRange;
    setCurrentlySelectingRangeEnd(nextSelection);
    var isFullRangeSelected = currentlySelectingRangeEnd === 'end' && isRangeValid(utils, newRange);
    onDateChange(newRange, wrapperVariant, isFullRangeSelected ? 'finish' : 'partial');
  }, [currentlySelectingRangeEnd, parsedValue, onDateChange, setCurrentlySelectingRangeEnd, utils, wrapperVariant]);
  var renderView = function renderView() {
    var sharedCalendarProps = _extends$4({
      parsedValue: parsedValue,
      changeFocusedDay: changeFocusedDay,
      onSelectedDaysChange: handleSelectedDayChange,
      reduceAnimations: reduceAnimations,
      disableHighlightToday: disableHighlightToday,
      onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
      changeMonth: changeMonth,
      currentlySelectingRangeEnd: currentlySelectingRangeEnd,
      disableFuture: disableFuture,
      disablePast: disablePast,
      minDate: minDate,
      maxDate: maxDate,
      shouldDisableDate: shouldDisableDate
    }, calendarState, other);
    switch (wrapperVariant) {
      case 'desktop':
        {
          return /*#__PURE__*/jsx(DateRangePickerViewDesktop, _extends$4({
            calendars: calendars
          }, sharedCalendarProps));
        }
      default:
        {
          return /*#__PURE__*/jsx(DateRangePickerViewMobile, _extends$4({}, sharedCalendarProps));
        }
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: className,
    children: [/*#__PURE__*/jsx(Watermark, {
      packageName: "x-date-pickers-pro",
      releaseInfo: releaseInfo$1
    }), toShowToolbar && /*#__PURE__*/jsx(DateRangePickerToolbar, {
      parsedValue: parsedValue,
      isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
      toggleMobileKeyboardView: toggleMobileKeyboardView,
      currentlySelectingRangeEnd: currentlySelectingRangeEnd,
      setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd,
      startText: startText,
      endText: endText,
      toolbarTitle: toolbarTitle,
      toolbarFormat: toolbarFormat
    }), isMobileKeyboardViewOpen ? /*#__PURE__*/jsx(MobileKeyboardInputView$1, {
      children: /*#__PURE__*/jsx(DateRangePickerInput, _extends$4({
        disableOpenPicker: true,
        ignoreInvalidInputs: true
      }, DateInputProps))
    }) : renderView()]
  });
}
var DateRangePickerView = DateRangePickerViewRaw;
process.env.NODE_ENV !== "production" ? DateRangePickerViewRaw.propTypes = {
  calendars: propTypes.oneOf([1, 2, 3]),
  disableAutoMonthSwitching: propTypes.bool
} : void 0;

var validateDateRange = function validateDateRange(_ref) {
  var props = _ref.props,
    value = _ref.value,
    adapter = _ref.adapter;
  var start = value[0],
    end = value[1];
  if (start === null || end === null) {
    return [null, null];
  }
  var dateValidations = [validateDate$2({
    adapter: adapter,
    value: start,
    props: props
  }), validateDate$2({
    adapter: adapter,
    value: end,
    props: props
  })];
  if (dateValidations[0] || dateValidations[1]) {
    return dateValidations;
  }
  if (!isRangeValid(adapter.utils, parseRangeInputValue(adapter.utils, value))) {
    return ['invalidRange', 'invalidRange'];
  }
  return [null, null];
};
var isSameDateRangeError = function isSameDateRangeError(a, b) {
  return b !== null && a[1] === b[1] && a[0] === b[0];
};
var useDateRangeValidation = function useDateRangeValidation(props) {
  return useValidation$1(props, validateDateRange, isSameDateRangeError);
};

var deprecatedPropsWarning$4 = buildDeprecatedPropsWarning$1('Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.');
function useDateRangePickerDefaultizedProps(props, name) {
  var _themeProps$startText, _themeProps$endText;
  var utils = useUtils$1();
  var defaultDates = useDefaultDates$1();
  var themeProps = useThemeProps({
    props: props,
    name: name
  });
  deprecatedPropsWarning$4({
    startText: themeProps.startText,
    endText: themeProps.endText
  });
  var localeText = useLocaleText$1();
  var startText = (_themeProps$startText = themeProps.startText) != null ? _themeProps$startText : localeText.start;
  var endText = (_themeProps$endText = themeProps.endText) != null ? _themeProps$endText : localeText.end;
  return _extends$4({
    calendars: 2,
    inputFormat: utils.formats.keyboardDate,
    minDate: defaultDates.minDate,
    maxDate: defaultDates.maxDate
  }, themeProps, {
    endText: endText,
    startText: startText
  });
}
var dateRangePickerValueManager = {
  emptyValue: [null, null],
  getTodayValue: function getTodayValue(utils) {
    return [utils.date(), utils.date()];
  },
  parseInput: parseRangeInputValue,
  areValuesEqual: function areValuesEqual(utils, a, b) {
    return utils.isEqual(a[0], b[0]) && utils.isEqual(a[1], b[1]);
  }
};

var _excluded$_ = ["value", "onChange", "PopperProps", "TransitionComponent", "components", "componentsProps"];
var releaseInfo$2 = getReleaseInfo();
var KeyboardDateInputComponent = DateRangePickerInput;
var DesktopDateRangePicker = /*#__PURE__*/forwardRef(function DesktopDateRangePicker(inProps, ref) {
  useLicenseVerifier('x-date-pickers-pro', releaseInfo$2);
  var props = useDateRangePickerDefaultizedProps(inProps, 'MuiDesktopDateRangePicker');
  var _React$useState = useState('start'),
    currentlySelectingRangeEnd = _React$useState[0],
    setCurrentlySelectingRangeEnd = _React$useState[1];
  var validationError = useDateRangeValidation(props);
  var _usePickerState = usePickerState$1(props, dateRangePickerValueManager),
    pickerProps = _usePickerState.pickerProps,
    inputProps = _usePickerState.inputProps,
    wrapperProps = _usePickerState.wrapperProps;
  var PopperProps = props.PopperProps,
    TransitionComponent = props.TransitionComponent,
    components = props.components,
    componentsProps = props.componentsProps,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$_);
  var DateInputProps = _extends$4({}, inputProps, other, {
    components: components,
    componentsProps: componentsProps,
    currentlySelectingRangeEnd: currentlySelectingRangeEnd,
    setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd,
    validationError: validationError,
    ref: ref
  });
  return /*#__PURE__*/jsx(DesktopTooltipWrapper, _extends$4({}, wrapperProps, {
    DateInputProps: DateInputProps,
    KeyboardDateInputComponent: KeyboardDateInputComponent,
    PopperProps: PopperProps,
    TransitionComponent: TransitionComponent,
    components: components,
    componentsProps: componentsProps,
    children: /*#__PURE__*/jsx(DateRangePickerView, _extends$4({
      open: wrapperProps.open,
      DateInputProps: DateInputProps,
      currentlySelectingRangeEnd: currentlySelectingRangeEnd,
      setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd
    }, pickerProps, {
      components: components,
      componentsProps: componentsProps
    }, other))
  }));
});
process.env.NODE_ENV !== "production" ? DesktopDateRangePicker.propTypes = {
  acceptRegex: propTypes.instanceOf(RegExp),
  autoFocus: propTypes.bool,
  calendars: propTypes.oneOf([1, 2, 3]),
  children: propTypes.node,
  className: propTypes.string,
  closeOnSelect: propTypes.bool,
  components: propTypes.object,
  componentsProps: propTypes.object,
  dayOfWeekFormatter: propTypes.func,
  defaultCalendarMonth: propTypes.any,
  disableAutoMonthSwitching: propTypes.bool,
  disabled: propTypes.bool,
  disableFuture: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disableMaskedInput: propTypes.bool,
  disableOpenPicker: propTypes.bool,
  disablePast: propTypes.bool,
  endText: propTypes.node,
  getOpenDialogAriaText: propTypes.func,
  getViewSwitchingButtonText: propTypes.func,
  ignoreInvalidInputs: propTypes.bool,
  InputAdornmentProps: propTypes.object,
  inputFormat: propTypes.string,
  InputProps: propTypes.object,
  inputRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.object
  })]),
  label: propTypes.node,
  leftArrowButtonText: propTypes.string,
  loading: propTypes.bool,
  mask: propTypes.string,
  maxDate: propTypes.any,
  minDate: propTypes.any,
  onAccept: propTypes.func,
  onChange: propTypes.func.isRequired,
  onClose: propTypes.func,
  onError: propTypes.func,
  onMonthChange: propTypes.func,
  onOpen: propTypes.func,
  onViewChange: propTypes.func,
  open: propTypes.bool,
  OpenPickerButtonProps: propTypes.object,
  PaperProps: propTypes.object,
  PopperProps: propTypes.object,
  readOnly: propTypes.bool,
  reduceAnimations: propTypes.bool,
  renderDay: propTypes.func,
  renderInput: propTypes.func.isRequired,
  renderLoading: propTypes.func,
  rifmFormatter: propTypes.func,
  rightArrowButtonText: propTypes.string,
  shouldDisableDate: propTypes.func,
  shouldDisableMonth: propTypes.func,
  shouldDisableYear: propTypes.func,
  showDaysOutsideCurrentMonth: propTypes.bool,
  showToolbar: propTypes.bool,
  startText: propTypes.node,
  toolbarFormat: propTypes.string,
  toolbarTitle: propTypes.node,
  TransitionComponent: propTypes.elementType,
  value: propTypes.arrayOf(propTypes.any).isRequired
} : void 0;

var _excluded$$ = ["value", "onChange", "components", "componentsProps"];
var releaseInfo$3 = getReleaseInfo();
var PureDateInputComponent = DateRangePickerInput;
var MobileDateRangePicker = /*#__PURE__*/forwardRef(function MobileDateRangePicker(inProps, ref) {
  useLicenseVerifier('x-date-pickers-pro', releaseInfo$3);
  var props = useDateRangePickerDefaultizedProps(inProps, 'MuiMobileDateRangePicker');
  var value = props.value,
    onChange = props.onChange,
    components = props.components,
    componentsProps = props.componentsProps,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$$);
  var _React$useState = useState('start'),
    currentlySelectingRangeEnd = _React$useState[0],
    setCurrentlySelectingRangeEnd = _React$useState[1];
  var pickerStateProps = _extends$4({}, other, {
    value: value,
    onChange: onChange
  });
  var _usePickerState = usePickerState$1(pickerStateProps, dateRangePickerValueManager),
    pickerProps = _usePickerState.pickerProps,
    inputProps = _usePickerState.inputProps,
    wrapperProps = _usePickerState.wrapperProps;
  var validationError = useDateRangeValidation(props);
  var DateInputProps = _extends$4({}, inputProps, other, {
    components: components,
    componentsProps: componentsProps,
    currentlySelectingRangeEnd: currentlySelectingRangeEnd,
    setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd,
    validationError: validationError,
    ref: ref
  });
  return /*#__PURE__*/jsx(MobileWrapper$1, _extends$4({}, other, wrapperProps, {
    DateInputProps: DateInputProps,
    PureDateInputComponent: PureDateInputComponent,
    components: components,
    componentsProps: componentsProps,
    children: /*#__PURE__*/jsx(DateRangePickerView, _extends$4({
      open: wrapperProps.open,
      DateInputProps: DateInputProps,
      currentlySelectingRangeEnd: currentlySelectingRangeEnd,
      setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd
    }, pickerProps, {
      components: components,
      componentsProps: componentsProps
    }, other))
  }));
});
process.env.NODE_ENV !== "production" ? MobileDateRangePicker.propTypes = {
  acceptRegex: propTypes.instanceOf(RegExp),
  autoFocus: propTypes.bool,
  calendars: propTypes.oneOf([1, 2, 3]),
  children: propTypes.node,
  className: propTypes.string,
  closeOnSelect: propTypes.bool,
  components: propTypes.object,
  componentsProps: propTypes.object,
  dayOfWeekFormatter: propTypes.func,
  defaultCalendarMonth: propTypes.any,
  DialogProps: propTypes.object,
  disableAutoMonthSwitching: propTypes.bool,
  disabled: propTypes.bool,
  disableFuture: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disableMaskedInput: propTypes.bool,
  disableOpenPicker: propTypes.bool,
  disablePast: propTypes.bool,
  endText: propTypes.node,
  getOpenDialogAriaText: propTypes.func,
  getViewSwitchingButtonText: propTypes.func,
  ignoreInvalidInputs: propTypes.bool,
  InputAdornmentProps: propTypes.object,
  inputFormat: propTypes.string,
  InputProps: propTypes.object,
  inputRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.object
  })]),
  label: propTypes.node,
  leftArrowButtonText: propTypes.string,
  loading: propTypes.bool,
  mask: propTypes.string,
  maxDate: propTypes.any,
  minDate: propTypes.any,
  onAccept: propTypes.func,
  onChange: propTypes.func.isRequired,
  onClose: propTypes.func,
  onError: propTypes.func,
  onMonthChange: propTypes.func,
  onOpen: propTypes.func,
  onViewChange: propTypes.func,
  open: propTypes.bool,
  OpenPickerButtonProps: propTypes.object,
  readOnly: propTypes.bool,
  reduceAnimations: propTypes.bool,
  renderDay: propTypes.func,
  renderInput: propTypes.func.isRequired,
  renderLoading: propTypes.func,
  rifmFormatter: propTypes.func,
  rightArrowButtonText: propTypes.string,
  shouldDisableDate: propTypes.func,
  shouldDisableMonth: propTypes.func,
  shouldDisableYear: propTypes.func,
  showDaysOutsideCurrentMonth: propTypes.bool,
  showToolbar: propTypes.bool,
  startText: propTypes.node,
  toolbarFormat: propTypes.string,
  toolbarTitle: propTypes.node,
  value: propTypes.arrayOf(propTypes.any).isRequired
} : void 0;

var _excluded$10 = ["desktopModeMediaQuery", "DialogProps", "PopperProps", "TransitionComponent"];
var releaseInfo$4 = getReleaseInfo();
var DateRangePicker = /*#__PURE__*/forwardRef(function DateRangePicker(inProps, ref) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiDateRangePicker'
  });
  useLicenseVerifier('x-date-pickers-pro', releaseInfo$4);
  var _props$desktopModeMed = props.desktopModeMediaQuery,
    desktopModeMediaQuery = _props$desktopModeMed === void 0 ? '@media (pointer: fine)' : _props$desktopModeMed,
    DialogProps = props.DialogProps,
    PopperProps = props.PopperProps,
    TransitionComponent = props.TransitionComponent,
    other = _objectWithoutPropertiesLoose$4(props, _excluded$10);
  var isDesktop = useMediaQuery(desktopModeMediaQuery, {
    defaultMatches: true
  });
  if (isDesktop) {
    return /*#__PURE__*/jsx(DesktopDateRangePicker, _extends$4({
      ref: ref,
      PopperProps: PopperProps,
      TransitionComponent: TransitionComponent
    }, other));
  }
  return /*#__PURE__*/jsx(MobileDateRangePicker, _extends$4({
    ref: ref,
    DialogProps: DialogProps
  }, other));
});
process.env.NODE_ENV !== "production" ? DateRangePicker.propTypes = {
  acceptRegex: propTypes.instanceOf(RegExp),
  autoFocus: propTypes.bool,
  calendars: propTypes.oneOf([1, 2, 3]),
  children: propTypes.node,
  className: propTypes.string,
  closeOnSelect: propTypes.bool,
  components: propTypes.object,
  componentsProps: propTypes.object,
  dayOfWeekFormatter: propTypes.func,
  defaultCalendarMonth: propTypes.any,
  desktopModeMediaQuery: propTypes.string,
  DialogProps: propTypes.object,
  disableAutoMonthSwitching: propTypes.bool,
  disabled: propTypes.bool,
  disableFuture: propTypes.bool,
  disableHighlightToday: propTypes.bool,
  disableMaskedInput: propTypes.bool,
  disableOpenPicker: propTypes.bool,
  disablePast: propTypes.bool,
  endText: propTypes.node,
  getOpenDialogAriaText: propTypes.func,
  getViewSwitchingButtonText: propTypes.func,
  ignoreInvalidInputs: propTypes.bool,
  InputAdornmentProps: propTypes.object,
  inputFormat: propTypes.string,
  InputProps: propTypes.object,
  inputRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.object
  })]),
  label: propTypes.node,
  leftArrowButtonText: propTypes.string,
  loading: propTypes.bool,
  mask: propTypes.string,
  maxDate: propTypes.any,
  minDate: propTypes.any,
  onAccept: propTypes.func,
  onChange: propTypes.func.isRequired,
  onClose: propTypes.func,
  onError: propTypes.func,
  onMonthChange: propTypes.func,
  onOpen: propTypes.func,
  onViewChange: propTypes.func,
  open: propTypes.bool,
  OpenPickerButtonProps: propTypes.object,
  PaperProps: propTypes.object,
  PopperProps: propTypes.object,
  readOnly: propTypes.bool,
  reduceAnimations: propTypes.bool,
  renderDay: propTypes.func,
  renderInput: propTypes.func.isRequired,
  renderLoading: propTypes.func,
  rifmFormatter: propTypes.func,
  rightArrowButtonText: propTypes.string,
  shouldDisableDate: propTypes.func,
  shouldDisableMonth: propTypes.func,
  shouldDisableYear: propTypes.func,
  showDaysOutsideCurrentMonth: propTypes.bool,
  showToolbar: propTypes.bool,
  startText: propTypes.node,
  toolbarFormat: propTypes.string,
  toolbarTitle: propTypes.node,
  TransitionComponent: propTypes.elementType,
  value: propTypes.arrayOf(propTypes.any).isRequired
} : void 0;

var _excluded$11 = ["showToday", "size", "onStartChange", "onEndChange", "onChange", "onOpen", "onClose", "startValue", "endValue", "value", "label", "variant", "separatorText"],
  _excluded2$4 = ["inputProps", "InputProps"];
var DNBDateRangePicker = function DNBDateRangePicker(_ref) {
  var _ref$showToday = _ref.showToday,
    showToday = _ref$showToday === void 0 ? false : _ref$showToday,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    onStartChange = _ref.onStartChange,
    onEndChange = _ref.onEndChange,
    onChange = _ref.onChange,
    _onOpen = _ref.onOpen,
    _onClose = _ref.onClose,
    startValue = _ref.startValue,
    endValue = _ref.endValue,
    value = _ref.value,
    label = _ref.label,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'single' : _ref$variant,
    _ref$separatorText = _ref.separatorText,
    separatorText = _ref$separatorText === void 0 ? 'to' : _ref$separatorText,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$11);
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _DNBDatePickerStylePr = DNBDatePickerStyleProps(size),
    DNBPopperProps = _DNBDatePickerStylePr[0],
    DNBInputAdornmentProps = _DNBDatePickerStylePr[1];
  var _useState2 = useState([startValue, endValue]),
    dateRange = _useState2[0],
    setDateRange = _useState2[1];
  var dnbDateRangePickerInputProps = _extends({
    startAdornment: React__default.createElement(InputAdornment, {
      position: "start"
    }, React__default.createElement(IconButton, {
      "aria-label": "Choose Date",
      onClick: function onClick() {
        return setOpen(true);
      }
    }, React__default.createElement(DateRangeOutlinedIcon, {
      fontSize: "small"
    })))
  }, DNBInputAdornmentProps);
  var handleChangeWhenOpen = function handleChangeWhenOpen(newRange) {
    if (!value) {
      if (dateRange[0] !== newRange[0]) onStartChange === null || onStartChange === void 0 ? void 0 : onStartChange(newRange[0]);
      if (dateRange[1] !== newRange[1]) onEndChange === null || onEndChange === void 0 ? void 0 : onEndChange(newRange[1]);
      setDateRange(newRange);
    } else {
      onChange === null || onChange === void 0 ? void 0 : onChange(newRange[0], newRange[1]);
      setDateRange(value);
    }
  };
  return React__default.createElement(Fragment$1, null, React__default.createElement(LocalizationProvider$1, {
    dateAdapter: DateFnsUtils
  }, React__default.createElement("label", {
    style: {
      display: 'block'
    }
  }, label), React__default.createElement(DateRangePicker, Object.assign({}, props, {
    value: value ? value : dateRange,
    onChange: handleChangeWhenOpen,
    open: open,
    onOpen: function onOpen() {
      setOpen(true);
      if (_onOpen) _onOpen();
    },
    onClose: function onClose() {
      setOpen(false);
      if (_onClose) _onClose();
    },
    renderInput: function renderInput(startProps, endProps) {
      startProps.label = '';
      endProps.label = '';
      if (variant === 'single') {
        var _endProps$inputProps, _endProps$inputProps2;
        var _startProps = _extends({}, startProps),
          inputProps = _startProps.inputProps,
          startRestProps = _objectWithoutPropertiesLoose(_startProps, _excluded2$4);
        var _startValue = inputProps === null || inputProps === void 0 ? void 0 : inputProps.value;
        inputProps === null || inputProps === void 0 ? true : delete inputProps.value;
        return React__default.createElement(DNBTextField, Object.assign({}, startRestProps, {
          InputProps: dnbDateRangePickerInputProps,
          inputProps: inputProps,
          size: size,
          variant: "outlined",
          value: _startValue || (_endProps$inputProps = endProps.inputProps) !== null && _endProps$inputProps !== void 0 && _endProps$inputProps.value ? _startValue + " " + separatorText + " " + ((_endProps$inputProps2 = endProps.inputProps) === null || _endProps$inputProps2 === void 0 ? void 0 : _endProps$inputProps2.value) : '',
          sx: {
            minWidth: '300px'
          }
        }));
      } else {
        return React__default.createElement(Fragment$1, null, React__default.createElement(DNBTextField, Object.assign({}, startProps, {
          InputProps: dnbDateRangePickerInputProps,
          onChange: function onChange(v) {
            onStartChange === null || onStartChange === void 0 ? void 0 : onStartChange(new Date(v.currentTarget.value));
          },
          size: size,
          variant: "outlined"
        })), React__default.createElement(Box, {
          sx: {
            mx: 2
          }
        }, separatorText), React__default.createElement(DNBTextField, Object.assign({}, endProps, {
          InputProps: dnbDateRangePickerInputProps,
          onChange: function onChange(v) {
            onEndChange === null || onEndChange === void 0 ? void 0 : onEndChange(new Date(v.currentTarget.value));
          },
          size: size,
          variant: "outlined"
        })));
      }
    }
  }, showToday && {
    componentsProps: {
      actionBar: {
        actions: ['today']
      }
    }
  }, {
    PopperProps: DNBPopperProps
  }))));
};

var getDNBDialogSizes = function getDNBDialogSizes(size, hasStickyFooter) {
  switch (size) {
    case 'compact':
      return {
        width: '382px',
        height: 'auto',
        maxHeight: hasStickyFooter ? '397px' : 'inherit',
        margin: hasStickyFooter ? null : 'inherit',
        fontWeight: function fontWeight(theme) {
          return theme.typography.FontWeightAvenirRoman;
        },
        fontSize: function fontSize(theme) {
          return theme.typography.FontSizeHeadline6;
        },
        lineHeight: function lineHeight(theme) {
          return theme.typography.FontLineHeightHeadline6;
        }
      };
    case 'full':
      return {
        width: '100%',
        height: '100%',
        maxHeight: 'inherit',
        margin: 0,
        fontWeight: function fontWeight(theme) {
          return theme.typography.FontWeightAvenirRoman;
        },
        fontSize: function fontSize(theme) {
          return theme.typography.FontSizeHeadline4;
        },
        lineHeight: function lineHeight(theme) {
          return theme.typography.FontLineHeightHeadline4;
        }
      };
    case 'full-scroll':
      return {
        width: '100%',
        margin: '145px 20px',
        fontWeight: function fontWeight(theme) {
          return theme.typography.FontWeightAvenirRoman;
        },
        fontSize: function fontSize(theme) {
          return theme.typography.FontSizeHeadline4;
        },
        lineHeight: function lineHeight(theme) {
          return theme.typography.FontLineHeightHeadline4;
        }
      };
    default:
      return {
        width: '586px',
        height: 'auto',
        maxHeight: hasStickyFooter ? '437px' : 'inherit',
        margin: hasStickyFooter ? null : 'inherit',
        fontWeight: function fontWeight(theme) {
          return theme.typography.FontWeightAvenirRoman;
        },
        fontSize: function fontSize(theme) {
          return theme.typography.FontSizeHeadline4;
        },
        lineHeight: function lineHeight(theme) {
          return theme.typography.FontLineHeightHeadline4;
        }
      };
  }
};

var StyledDialogTitle = styled(DialogTitle)(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0',
    '& .MuiSvgIcon-root': {
      color: theme.colors.ColorGraySecondary,
      '&:hover': {
        cursor: 'pointer'
      }
    }
  };
});
var StyledDialogTitleDestructive = styled(DialogTitle)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    textAlign: 'center',
    color: theme.colors.ColorNotificationError
  };
});
var DNBDialogTitle = function DNBDialogTitle(_ref3) {
  var title = _ref3.title,
    onClose = _ref3.onClose,
    hasCloseButton = _ref3.hasCloseButton,
    size = _ref3.size,
    variant = _ref3.variant;
  var hideDialogTitle = (title === undefined || title.length === 0) && !hasCloseButton && variant !== 'destructive';
  if (hideDialogTitle) {
    return null;
  }
  return variant === 'default' ? React__default.createElement(DNBDefaultDialogTitle, {
    title: title,
    onClose: onClose,
    hasCloseButton: hasCloseButton,
    size: size
  }) : React__default.createElement(DNBDestructiveDialogTitle, {
    title: title,
    size: size
  });
};
var DNBDefaultDialogTitle = function DNBDefaultDialogTitle(_ref4) {
  var title = _ref4.title,
    onClose = _ref4.onClose,
    hasCloseButton = _ref4.hasCloseButton,
    size = _ref4.size;
  var isCompact = size === 'compact';
  var closePosition = isCompact ? '8px' : '12px';
  return React__default.createElement(StyledDialogTitle, null, title && React__default.createElement(DNBTypography, {
    sx: {
      p: isCompact ? 6 : 8,
      fontWeight: getDNBDialogSizes(size).fontWeight,
      fontSize: getDNBDialogSizes(size).fontSize,
      lineHeight: getDNBDialogSizes(size).lineHeight
    },
    variant: "h4",
    component: "span"
  }, title), hasCloseButton && typeof onClose === 'function' && React__default.createElement(DialogActions, {
    sx: {
      height: isCompact ? '36px' : '44px'
    }
  }, React__default.createElement(IconButton, {
    onClick: function onClick() {
      return onClose();
    },
    sx: {
      position: 'absolute',
      top: closePosition,
      right: closePosition
    }
  }, React__default.createElement(CloseIcon, {
    sx: {
      width: '20px',
      height: '20px'
    }
  }))));
};
var DNBDestructiveDialogTitle = function DNBDestructiveDialogTitle(_ref5) {
  var title = _ref5.title,
    size = _ref5.size;
  var isCompact = size === 'compact';
  return React__default.createElement(StyledDialogTitleDestructive, Object.assign({}, {
    component: 'div'
  }), React__default.createElement(InfoIcon, {
    sx: {
      fontSize: isCompact ? '28px' : '44px',
      mt: isCompact ? '26px' : '34px'
    }
  }), title && React__default.createElement(DNBTypography, {
    variant: "h4",
    sx: {
      fontWeight: getDNBDialogSizes(size).fontWeight,
      fontSize: getDNBDialogSizes(size).fontSize,
      lineHeight: getDNBDialogSizes(size).lineHeight
    }
  }, title));
};

var _excluded$12 = ["open", "title", "children", "onClose", "primaryCTA", "primaryCTALabel", "disabledPrimaryCTA", "secondaryCTA", "secondaryCTALabel", "disabledSecondaryCTA", "hasCloseButton", "tertiaryCTA", "tertiaryCTALabel", "disabledTertiaryCTA", "size", "variant", "hasStickyFooter", "scrim", "scroll", "primaryButtonMargin"];
var StyledDNBDialog = styled(Dialog, {
  shouldForwardProp: function shouldForwardProp(prop) {
    var skipProp = ['size', 'hasStickyFooter', 'scrim'];
    return !skipProp.includes(prop);
  }
})(function (_ref) {
  var theme = _ref.theme,
    size = _ref.size,
    hasStickyFooter = _ref.hasStickyFooter,
    scrim = _ref.scrim;
  return {
    '.MuiDialog-paper': {
      width: getDNBDialogSizes(size, hasStickyFooter).width,
      height: getDNBDialogSizes(size, hasStickyFooter).height,
      maxHeight: getDNBDialogSizes(size, hasStickyFooter).maxHeight,
      margin: getDNBDialogSizes(size, hasStickyFooter).margin,
      boxShadow: theme.boxShadows.ShadowPlus2,
      position: 'relative'
    },
    '.MuiBackdrop-root': {
      backgroundColor: scrim ? undefined : 'transparent'
    }
  };
});
var StyledDialogContent = styled(DialogContent, {
  shouldForwardProp: function shouldForwardProp(prop) {
    var skipProp = ['hasStickyFooter', 'isCompact'];
    return !skipProp.includes(prop);
  }
})(function (_ref2) {
  var theme = _ref2.theme,
    hasStickyFooter = _ref2.hasStickyFooter,
    isCompact = _ref2.isCompact;
  return {
    padding: theme.spacing(0) + " " + theme.spacing(isCompact ? 6 : 8) + " " + theme.spacing(isCompact ? 6 : 8) + " " + theme.spacing(isCompact ? 6 : 8),
    height: 'inherit',
    overflowY: hasStickyFooter ? 'auto' : 'hidden',
    borderBottom: 'none',
    borderTop: 'none'
  };
});
var StyledFooter = styled(DialogContent, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'hasStickyFooter';
  }
})(function (_ref3) {
  var theme = _ref3.theme,
    hasStickyFooter = _ref3.hasStickyFooter;
  return {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'unset',
    boxShadow: hasStickyFooter ? "0px -2px 4px " + theme.colors.ColorGrayPrimaryAlpha2 : 'none'
  };
});
var CTAFooter = styled(MuiBox)(function () {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };
});
var DNBDialog = function DNBDialog(_ref4) {
  var open = _ref4.open,
    title = _ref4.title,
    children = _ref4.children,
    onClose = _ref4.onClose,
    primaryCTA = _ref4.primaryCTA,
    primaryCTALabel = _ref4.primaryCTALabel,
    _ref4$disabledPrimary = _ref4.disabledPrimaryCTA,
    disabledPrimaryCTA = _ref4$disabledPrimary === void 0 ? false : _ref4$disabledPrimary,
    secondaryCTA = _ref4.secondaryCTA,
    _ref4$secondaryCTALab = _ref4.secondaryCTALabel,
    secondaryCTALabel = _ref4$secondaryCTALab === void 0 ? 'Cancel' : _ref4$secondaryCTALab,
    _ref4$disabledSeconda = _ref4.disabledSecondaryCTA,
    disabledSecondaryCTA = _ref4$disabledSeconda === void 0 ? false : _ref4$disabledSeconda,
    hasCloseButton = _ref4.hasCloseButton,
    tertiaryCTA = _ref4.tertiaryCTA,
    tertiaryCTALabel = _ref4.tertiaryCTALabel,
    _ref4$disabledTertiar = _ref4.disabledTertiaryCTA,
    disabledTertiaryCTA = _ref4$disabledTertiar === void 0 ? false : _ref4$disabledTertiar,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'default' : _ref4$size,
    _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? 'default' : _ref4$variant,
    _ref4$hasStickyFooter = _ref4.hasStickyFooter,
    hasStickyFooter = _ref4$hasStickyFooter === void 0 ? true : _ref4$hasStickyFooter,
    _ref4$scrim = _ref4.scrim,
    scrim = _ref4$scrim === void 0 ? true : _ref4$scrim,
    _ref4$scroll = _ref4.scroll,
    scroll = _ref4$scroll === void 0 ? 'paper' : _ref4$scroll,
    _ref4$primaryButtonMa = _ref4.primaryButtonMargin,
    primaryButtonMargin = _ref4$primaryButtonMa === void 0 ? '' : _ref4$primaryButtonMa,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded$12);
  var _useState = useState(false),
    hasScroll = _useState[0],
    setHasScroll = _useState[1];
  var isCompact = size === 'compact';
  var handleDialogContentRef = function handleDialogContentRef(dialogContentRoot) {
    var contentScrollHeight = (dialogContentRoot === null || dialogContentRoot === void 0 ? void 0 : dialogContentRoot.scrollHeight) || 0;
    var contentHeight = (dialogContentRoot === null || dialogContentRoot === void 0 ? void 0 : dialogContentRoot.offsetHeight) || 0;
    setHasScroll(contentScrollHeight > contentHeight);
  };
  return React__default.createElement(StyledDNBDialog, Object.assign({
    fullScreen: size === 'full',
    hasStickyFooter: hasStickyFooter,
    maxWidth: false,
    onClose: onClose,
    open: open,
    scrim: scrim,
    scroll: scroll,
    size: size
  }, rest), React__default.createElement(DNBDialogTitle, {
    title: title,
    onClose: onClose,
    hasCloseButton: hasCloseButton,
    size: size,
    variant: variant
  }), React__default.createElement(StyledDialogContent, {
    dividers: scroll === 'paper',
    ref: handleDialogContentRef,
    hasStickyFooter: hasStickyFooter,
    isCompact: isCompact
  }, children), primaryCTALabel && React__default.createElement(StyledFooter, {
    dividers: true,
    hasStickyFooter: hasStickyFooter && hasScroll
  }, React__default.createElement(CTAFooter, null, React__default.createElement(DialogActions, null, typeof tertiaryCTA === 'function' && React__default.createElement(DNBButton, {
    variant: "text",
    size: isCompact ? 'small' : 'default',
    onClick: function onClick() {
      return tertiaryCTA();
    },
    disabled: disabledTertiaryCTA
  }, tertiaryCTALabel)), React__default.createElement(DialogActions, null, typeof secondaryCTA === 'function' && React__default.createElement(DNBButton, {
    variant: "secondary",
    size: isCompact ? 'small' : 'default',
    onClick: secondaryCTA,
    disabled: disabledSecondaryCTA
  }, secondaryCTALabel), typeof primaryCTA === 'function' && React__default.createElement(DNBButton, {
    variant: variant === 'destructive' ? variant : 'primary',
    size: isCompact ? 'small' : 'default',
    onClick: function onClick() {
      return primaryCTA();
    },
    disabled: disabledPrimaryCTA,
    sx: {
      margin: primaryButtonMargin
    }
  }, primaryCTALabel)))));
};

var _excluded$13 = ["children", "external", "disabled", "size", "variant"];
var StyledLink = styled(Link, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'size';
  }
})(function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return _extends({
    color: theme.colors.ColorPrimaryBlueInteractive,
    '&:hover': {
      color: theme.colors.ColorPrimaryBlue
    },
    '&.disabled': {
      opacity: '.4',
      cursor: 'not-allowed',
      '&:hover': {
        color: theme.colors.ColorPrimaryBlueInteractive
      }
    },
    '.link-icon': {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'center'
    }
  }, size === 'compact' && {
    font: theme.typography.FontSizeCompact,
    ' .link-icon': {
      width: '16px'
    }
  }, size === 'default' && {
    font: theme.typography.FontSizeBody,
    ' .link-icon': {
      width: '24px'
    }
  }, size === 'large' && {
    font: theme.typography.FontSizeHeadline5,
    ' .link-icon': {
      width: '32px'
    }
  });
});
var DNBLink = function DNBLink(_ref2) {
  var children = _ref2.children,
    _ref2$external = _ref2.external,
    external = _ref2$external === void 0 ? false : _ref2$external,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'default' : _ref2$size,
    variant = _ref2.variant,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$13);
  switch (variant) {
    case 'inline':
      return React__default.createElement(StyledLink, Object.assign({
        size: size,
        variant: "inherit"
      }, rest, {
        underline: "always",
        className: disabled ? 'disabled' : ''
      }), children, external ? React__default.createElement("span", {
        className: "link-icon"
      }, React__default.createElement(LaunchOutlinedIcon, {
        fontSize: "inherit"
      })) : '');
    case 'standalone':
      return React__default.createElement(StyledLink, Object.assign({
        size: size,
        variant: "inherit"
      }, rest, {
        className: disabled ? 'disabled' : '',
        underline: "none"
      }), children, ' ', external ? React__default.createElement("span", {
        className: "link-icon"
      }, React__default.createElement(LaunchOutlinedIcon, {
        fontSize: "inherit"
      })) : React__default.createElement("span", {
        className: "link-icon"
      }, React__default.createElement(ArrowForwardIosIcon, {
        fontSize: "inherit"
      })));
    default:
      return React__default.createElement(StyledLink, Object.assign({
        size: size,
        variant: variant
      }, rest, {
        className: disabled ? 'disabled' : ''
      }), children);
  }
};

var GlobalLoader = {
  animation: {
    v: '4.8.0',
    meta: {
      g: 'LottieFiles AE 2.0.4',
      a: '',
      k: '',
      d: '',
      tc: ''
    },
    fr: 23.9759979248047,
    ip: 0,
    op: 167.999985459092,
    w: 600,
    h: 600,
    nm: 'Main Comp',
    ddd: 0,
    assets: [],
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Sharp Edge 2',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [300.625, 300.75, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0]],
              v: [[-125.5, -130.5], [-126.688, -74.938], [-99.25, -101.5]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0, 0.317647058824, 0.447058823529, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 1,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: [0, 0.317647058824, 0.447058823529, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Shape 1',
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 83,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 84,
            s: [23.3]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 85,
            s: [40.6]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 85.5,
            s: [42]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 86.5,
            s: [44.2]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 87.5,
            s: [56.4]
          }, {
            t: 87.9999923833338,
            s: [50]
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 83,
            s: [100]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 84.5,
            s: [100]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 85,
            s: [81.2]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 85.5,
            s: [69]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 87,
            s: [61.6]
          }, {
            t: 87.9999923833338,
            s: [50]
          }],
          ix: 2
        },
        o: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 83,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 85.5,
            s: [167]
          }, {
            t: 87.9999923833338,
            s: [167]
          }],
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: 62.9999945471595,
      op: 198.999982775948,
      st: 62.9999945471595,
      bm: 0
    }, {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Sharp Edge',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [300.625, 300.75, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0]],
              v: [[-125.5, -130.5], [-126.688, -74.938], [-99.25, -101.5]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0, 0.317647058824, 0.447058823529, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 1,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: [0, 0.317647058824, 0.447058823529, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Shape 1',
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 43,
            s: [50]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 43.5,
            s: [56.4]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 44.5,
            s: [44.2]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 45.5,
            s: [42]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 46,
            s: [40.6]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 47,
            s: [23.3]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 48,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 95,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 96,
            s: [23.3]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 97,
            s: [40.6]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 97.5,
            s: [42]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 98.5,
            s: [44.2]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 99.5,
            s: [56.4]
          }, {
            t: 99.9999913446975,
            s: [50]
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 43,
            s: [50]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 44,
            s: [61.6]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 45.5,
            s: [69]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 46,
            s: [81.2]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 46.5,
            s: [100]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 48,
            s: [100]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 95,
            s: [100]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 96.5,
            s: [100]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 97,
            s: [81.2]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 97.5,
            s: [69]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 99,
            s: [61.6]
          }, {
            t: 99.9999913446975,
            s: [50]
          }],
          ix: 2
        },
        o: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 43,
            s: [167]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 45.5,
            s: [167]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 48,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 95,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 97.5,
            s: [167]
          }, {
            t: 99.9999913446975,
            s: [167]
          }],
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: 0,
      op: 198.999982775948,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: 'Middle Bar',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [300, 300, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [97.404, 96.187, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[-116.5, -91.5], [123, 154]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0, 0.317647058824, 0.447058823529, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 41,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: [0, 0.317647058824, 0.447058823529, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [0, 1],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [99.188, 100.315],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Shape 1',
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 46,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 56,
            s: [100]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 86,
            s: [100]
          }, {
            t: 95.9999916909097,
            s: [0]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: 0,
      op: 198.999982775948,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: 'DNB_Animation 1 of 4 Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [300, 300, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [396, 306, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [1.763, 31.178], [1.226, 3.111], [22.475, 10.443], [8.458, -2.492], [4.488, -4.42], [6.492, -5.964]],
              o: [[0, 0], [2.942, -2.602], [-0.534, -9.444], [-2.175, -5.52], [-18.683, -8.682], [-14.103, 4.157], [-6.087, 6.399], [0, 0]],
              v: [[23.164, 68.034], [41.129, 50.953], [64.373, -3.006], [59.808, -22.813], [27.05, -59.352], [-17.851, -62.177], [-45.719, -45.666], [-66.136, -24.266]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.204975711598, 0.60886888691, 0.809883267272, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 40,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 10,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [354.154, 197.504],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 10,
            s: [100]
          }, {
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            t: 22,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 121,
            s: [0]
          }, {
            t: 132.999988488448,
            s: [100]
          }],
          ix: 1
        },
        e: {
          a: 0,
          k: 100,
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: 0,
      op: 198.999982775948,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: 'DNB_Animation 2 of 4 Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [300, 300, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [396, 306, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [4.511, -26.732], [-0.272, -1.78], [-4.898, -4.259], [-35.933, 4.666], [-21.707, 17.171], [-8.041, 8.183]],
              o: [[0, 0], [-10.123, 12.283], [-1.282, 7.595], [3.689, 24.168], [3.484, 3.029], [16.204, -2.104], [15.871, -12.554], [0, 0]],
              v: [[-34.088, -85.353], [-67.58, -52.777], [-86.4, -9.221], [-86.363, 10.216], [-62.668, 56.449], [-0.253, 80.686], [41.935, 61.565], [87.682, 17]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0, 0.317647058824, 0.447058823529, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 40,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 10,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [361.306, 398.491],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [0.104]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 22,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            t: 34,
            s: [100]
          }, {
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            t: 98,
            s: [100]
          }, {
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 109,
            s: [100]
          }, {
            t: 120.999989527084,
            s: [0]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: 0,
      op: 198.999982775948,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: 'DNB_Animation 3 of 4 Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [300, 300, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [396, 306, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [-11.474, -7.097], [-1.638, -6.244], [4.019, -8.65], [5.366, -5.549]],
              o: [[0, 0], [22.177, 13.717], [7.221, 27.521], [-5.92, 12.742], [0, 0]],
              v: [[-31.652, -67.548], [-5.678, -60.228], [24.431, -21.664], [19.412, 34.549], [-4.747, 67.549]],
              c: false
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'st',
          c: {
            a: 0,
            k: [0.204975711598, 0.60886888691, 0.809883267272, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 40,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 10,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [489.706, 302.39],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 34,
            s: [100]
          }, {
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0]
            },
            t: 45,
            s: [0]
          }, {
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 98,
            s: [0]
          }, {
            t: 108.99999056572,
            s: [100]
          }],
          ix: 1
        },
        e: {
          a: 0,
          k: 100,
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }],
      ip: 0,
      op: 198.999982775948,
      st: 0,
      bm: 0
    }],
    markers: []
  }
};

var _excluded$14 = ["open", "onClick", "message"];
var StyledMuiBackdrop = styled(MuiBackdrop)(function (_ref) {
  var theme = _ref.theme;
  return {
    backdropFilter: 'blur(5px)',
    backgroundColor: theme.colors.ColorBackgroundWhiteAlpha1,
    display: 'flex',
    flexDirection: 'column',
    zIndex: theme.zIndex.modal + 1
  };
});
var StyledMuiBox$1 = styled(MuiBox)(function () {
  return {
    width: 150
  };
});
var DNBLoader = function DNBLoader(_ref2) {
  var open = _ref2.open,
    onClick = _ref2.onClick,
    message = _ref2.message,
    backdropProps = _objectWithoutPropertiesLoose(_ref2, _excluded$14);
  var isMessageEmpty = message === undefined || message === '';
  return React__default.createElement(StyledMuiBackdrop, Object.assign({
    open: open,
    onClick: onClick
  }, backdropProps), React__default.createElement(StyledMuiBox$1, null, React__default.createElement(Lottie, {
    animationData: GlobalLoader.animation,
    loop: true
  })), !isMessageEmpty && React__default.createElement(DNBTypography, {
    variant: "h5",
    component: "div"
  }, message));
};

var _excluded$15 = ["whiteBackground"];
var StyledSkeleton = styled(Skeleton, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'whiteBackground';
  }
})(function (_ref) {
  var theme = _ref.theme,
    whiteBackground = _ref.whiteBackground;
  return {
    backgroundColor: whiteBackground ? theme.colors.ColorBackgroundWhite : theme.colors.ColorGrayIncidentalAlpha4
  };
});
var DNBSkeleton = function DNBSkeleton(_ref2) {
  var _ref2$whiteBackground = _ref2.whiteBackground,
    whiteBackground = _ref2$whiteBackground === void 0 ? false : _ref2$whiteBackground,
    dnbSkeletonProps = _objectWithoutPropertiesLoose(_ref2, _excluded$15);
  return React__default.createElement(StyledSkeleton, Object.assign({
    whiteBackground: whiteBackground
  }, dnbSkeletonProps, {
    animation: "pulse"
  }));
};

var _excluded$16 = ["onClick", "icon", "trailingIcon", "isDisabled", "text", "listItemIconProps", "listItemTextProps", "trailingIconProps"];
var StyledMenuItem = styled(MuiMenuItem)(function (_ref) {
  var theme = _ref.theme;
  return _extends({
    background: theme.colors.ColorBackgroundWhite,
    borderRadius: theme.borders.BorderRadiusDefault,
    padding: theme.spacing(2),
    height: theme.spacing(11),
    maxWidth: '368px',
    minWidth: '112px'
  }, theme.typography.body1, {
    '&:hover': {
      background: theme.colors.ColorGrayPrimaryAlpha1
    },
    '&:active': {
      background: theme.colors.ColorGrayPrimaryAlpha2
    },
    '&:disabled': {
      opacity: theme.opacity.OpacityDisabled
    }
  });
});
var DNBMenuItem = function DNBMenuItem(_ref2) {
  var onClick = _ref2.onClick,
    icon = _ref2.icon,
    trailingIcon = _ref2.trailingIcon,
    isDisabled = _ref2.isDisabled,
    text = _ref2.text,
    listItemIconProps = _ref2.listItemIconProps,
    listItemTextProps = _ref2.listItemTextProps,
    trailingIconProps = _ref2.trailingIconProps,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$16);
  return React__default.createElement(StyledMenuItem, Object.assign({}, props, {
    "data-testid": "" + text,
    disabled: isDisabled,
    onClick: onClick
  }), icon && React__default.createElement(MuiListItemIcon, Object.assign({}, listItemIconProps), icon), React__default.createElement(MuiListItemText, Object.assign({
    "data-testid": text + "-text"
  }, listItemTextProps), text), trailingIcon && React__default.createElement(MuiListItemIcon, Object.assign({}, trailingIconProps), trailingIcon));
};

var _excluded$17 = ["listItemIconProps", "listItemTextProps", "menuItems", "menuItemProps", "onClose", "children"];
var StyledMenuList = styled$1(MenuList)(function (_ref) {
  var theme = _ref.theme;
  return {
    background: theme.colors.ColorBackgroundWhite,
    borderColor: theme.colors.ColorGrayIncidental,
    maxWidth: '368px',
    minWidth: '112px',
    padding: theme.spacing(2)
  };
});
var DNBMenu = function DNBMenu(_ref2) {
  var listItemIconProps = _ref2.listItemIconProps,
    listItemTextProps = _ref2.listItemTextProps,
    _ref2$menuItems = _ref2.menuItems,
    menuItems = _ref2$menuItems === void 0 ? [] : _ref2$menuItems,
    menuItemProps = _ref2.menuItemProps,
    onClose = _ref2.onClose,
    children = _ref2.children,
    dnbMenuProps = _objectWithoutPropertiesLoose(_ref2, _excluded$17);
  var hasDeprecatedOptions = menuItems.length > 0;
  var handleMouseLeave = function handleMouseLeave(event) {
    if (typeof onClose === 'function') {
      onClose(event, 'backdropClick');
    }
  };
  var handleOnClose = function handleOnClose(event, reason) {
    if (typeof onClose === 'function') {
      onClose(event, reason);
    }
  };
  return React__default.createElement(Menu, Object.assign({
    onClose: function onClose(event, reason) {
      return handleOnClose(event, reason);
    }
  }, dnbMenuProps), React__default.createElement(StyledMenuList, {
    onMouseLeave: function onMouseLeave(event) {
      return handleMouseLeave(event);
    }
  }, hasDeprecatedOptions ? menuItems.map(function (_ref3, index) {
    var onClick = _ref3.onClick,
      icon = _ref3.icon,
      isDisabled = _ref3.isDisabled,
      text = _ref3.text;
    return React__default.createElement(DNBMenuItem, Object.assign({}, menuItemProps, {
      key: text + "-" + index,
      onClick: onClick,
      icon: icon,
      isDisabled: isDisabled,
      text: text,
      listItemIconProps: listItemIconProps,
      listItemTextProps: listItemTextProps
    }));
  }) : children));
};

var _excluded$18 = ["checkboxProps", "listItemTextProps", "menuItems", "menuItemProps", "onClose"];
var StyledMenuList$1 = styled$1(MenuList)(function (_ref) {
  var theme = _ref.theme;
  return {
    background: theme.colors.ColorBackgroundWhite,
    padding: theme.spacing(2)
  };
});
var StyledMenuItem$1 = styled$1(MuiMenuItem)(function (_ref2) {
  var theme = _ref2.theme;
  return _extends({
    background: theme.colors.ColorBackgroundWhite,
    borderRadius: theme.borders.BorderRadiusDefault,
    padding: theme.spacing(2),
    height: theme.spacing(11)
  }, theme.typography.body1, {
    '&:hover': {
      background: theme.colors.ColorGrayPrimaryAlpha1
    },
    '&:active': {
      background: theme.colors.ColorGrayPrimaryAlpha2
    },
    '&:disabled': {
      opacity: theme.opacity.OpacityDisabled
    }
  });
});
var DNBMultiSelectMenu = function DNBMultiSelectMenu(_ref3) {
  var checkboxProps = _ref3.checkboxProps,
    menuItems = _ref3.menuItems,
    menuItemProps = _ref3.menuItemProps,
    onClose = _ref3.onClose,
    dnbMultiSelectMenuProps = _objectWithoutPropertiesLoose(_ref3, _excluded$18);
  var handleMouseLeave = function handleMouseLeave(event) {
    if (typeof onClose === 'function') {
      onClose(event, 'backdropClick');
    }
  };
  var handleOnClose = function handleOnClose(event, reason) {
    if (typeof onClose === 'function') {
      onClose(event, reason);
    }
  };
  return React__default.createElement(Menu, Object.assign({
    onClose: function onClose(event, reason) {
      return handleOnClose(event, reason);
    }
  }, dnbMultiSelectMenuProps), React__default.createElement(StyledMenuList$1, {
    onMouseLeave: function onMouseLeave(event) {
      return handleMouseLeave(event);
    }
  }, menuItems.map(function (item, index) {
    return React__default.createElement(StyledMenuItem$1, Object.assign({
      disabled: item.isDisabled,
      key: index
    }, menuItemProps), React__default.createElement(DNBCheckbox, Object.assign({}, checkboxProps, {
      checked: item.checked,
      label: item.label,
      value: item.value,
      onChange: item.onChange,
      excludeHoverEffect: true,
      "data-testid": "" + item.label,
      "aria-label": item.ariaLabel,
      containerProps: {
        sx: {
          width: '100%'
        }
      },
      labelProps: {
        sx: {
          width: '100%'
        }
      }
    })));
  })));
};

var StyledDrawer = styled(Drawer, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'border' && prop !== 'relative';
  }
})(function (_ref) {
  var border = _ref.border,
    relative = _ref.relative,
    open = _ref.open,
    anchor = _ref.anchor;
  return {
    '& .MuiDrawer-paper': {
      boxSizing: 'border-box',
      minWidth: '20rem',
      maxWidth: anchor === 'left' || anchor === 'right' ? '28.8rem' : undefined,
      overflowY: 'visible',
      border: border ? undefined : 'none',
      position: relative ? 'relative' : undefined,
      width: open ? undefined : '0'
    },
    width: open ? undefined : '0'
  };
});
var StyledDrawerHeaderDiv = styled('div')(function (_ref2) {
  var _ref3;
  var theme = _ref2.theme,
    anchor = _ref2.anchor;
  return _ref3 = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: anchor === 'left' ? 'flex-end' : undefined
  }, _ref3[theme.breakpoints.down('sm')] = {
    justifyContent: 'flex-end'
  }, _ref3.padding = theme.spacing(2) + " " + theme.spacing(4), _ref3.minHeight = theme.spacing(8), _ref3;
});
var StyledToggleIconButton = styled(IconButton)(function (_ref4) {
  var _ref5;
  var theme = _ref4.theme;
  return _ref5 = {}, _ref5[theme.breakpoints.down('sm')] = {
    display: 'none'
  }, _ref5.backgroundColor = theme.colors.ColorBackgroundWhite, _ref5.boxShadow = theme.shadows[1], _ref5.width = theme.spacing(8), _ref5.height = theme.spacing(8), _ref5[':hover'] = {
    backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
  }, _ref5['& .MuiSvgIcon-root'] = {
    width: theme.spacing(6),
    height: theme.spacing(6)
  }, _ref5;
});

var _excluded$19 = ["children", "anchor", "border", "relative", "onToggle"];
var DNBDrawer = function DNBDrawer(_ref) {
  var children = _ref.children,
    _ref$anchor = _ref.anchor,
    anchor = _ref$anchor === void 0 ? 'left' : _ref$anchor,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? false : _ref$border,
    _ref$relative = _ref.relative,
    relative = _ref$relative === void 0 ? false : _ref$relative,
    onToggle = _ref.onToggle,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$19);
  var drawerRef = useRef(null);
  var isPersistent = props.variant === 'persistent';
  var isAnchorLeft = anchor === 'left';
  return React__default.createElement(Fragment$1, null, isPersistent && !props.open && React__default.createElement(StyledToggleIconButton, {
    sx: {
      position: 'relative',
      top: function top(theme) {
        return theme.spacing(2);
      },
      left: function left(theme) {
        return "" + (isAnchorLeft ? '' : '-') + theme.spacing(4);
      },
      zIndex: function zIndex(theme) {
        return theme.zIndex.drawer;
      }
    },
    onClick: function onClick() {
      if (relative && drawerRef.current) {
        drawerRef.current.style.display = '';
      }
      onToggle === null || onToggle === void 0 ? void 0 : onToggle();
    },
    "aria-label": "open-drawer"
  }, isAnchorLeft ? React__default.createElement(KeyboardDoubleArrowRightRounded, null) : React__default.createElement(Tune, null)), React__default.createElement(StyledDrawer, Object.assign({
    border: border,
    relative: relative,
    anchor: anchor
  }, props, {
    ModalProps: {
      keepMounted: true
    },
    ref: drawerRef,
    onTransitionEnd: function onTransitionEnd() {
      if (drawerRef.current && relative && !props.open) {
        drawerRef.current.style.display = 'none';
      }
    },
    "data-testid": "drawer"
  }), React__default.createElement(StyledDrawerHeaderDiv, {
    anchor: anchor
  }, isPersistent && React__default.createElement(Fragment$1, null, React__default.createElement(StyledToggleIconButton, {
    sx: {
      position: 'relative',
      right: function right(theme) {
        return isAnchorLeft ? "-" + theme.spacing(8) : undefined;
      },
      left: function left(theme) {
        return anchor === 'right' ? "-" + theme.spacing(8) : undefined;
      }
    },
    onClick: function onClick() {
      return onToggle === null || onToggle === void 0 ? void 0 : onToggle();
    },
    "aria-label": "close-drawer"
  }, isAnchorLeft ? React__default.createElement(KeyboardDoubleArrowLeftRounded, null) : React__default.createElement(KeyboardDoubleArrowRightRounded, null)), React__default.createElement(IconButton, {
    sx: {
      display: {
        xs: 'inline-flex',
        sm: 'none'
      }
    },
    size: "small",
    onClick: function onClick() {
      return onToggle === null || onToggle === void 0 ? void 0 : onToggle();
    },
    "aria-label": "close-drawer"
  }, React__default.createElement(Clear, {
    fontSize: "small"
  })))), React__default.createElement(MuiBox, null, React__default.createElement(MuiList, null, children))));
};

var StyledListItemButton = styled(ListItemButton)(function (_ref) {
  var theme = _ref.theme;
  return {
    borderLeft: "3px solid transparent",
    borderRadius: "0 " + theme.borders.BorderRadiusDefault + " " + theme.borders.BorderRadiusDefault + " 0",
    padding: 0,
    '& .MuiListItemText-root': {
      margin: "0 0 0 6px",
      padding: theme.spacing(2) + " " + theme.spacing(2) + " " + theme.spacing(2) + " " + theme.spacing(4)
    },
    '&.Mui-selected': {
      borderLeftColor: theme.palette.primary.main,
      background: theme.colors.ColorPrimaryBlueInteractiveAlpha1,
      color: theme.palette.primary.main,
      '&:hover': {
        background: theme.colors.ColorPrimaryBlueInteractiveAlpha1
      }
    },
    ':hover, :focus-visible': {
      background: 'none'
    },
    ':not(.Mui-selected)&:hover .MuiListItemText-root, :not(.Mui-selected)&:focus .MuiListItemText-root': {
      background: theme.colors.ColorGrayPrimaryAlpha1,
      borderRadius: theme.borders.BorderRadiusDefault
    },
    fontSize: theme.typography.FontSizeCompact
  };
});

var _excluded$1a = ["open", "toggle", "listItems", "selectedListItem", "listItemClicked"];
var StyledList = styled(MuiList)(function (_ref) {
  var theme = _ref.theme;
  return {
    paddingTop: theme.spacing(8),
    marginRight: theme.spacing(4),
    minWidth: theme.spacing(50)
  };
});
var StyledSubMenuList = styled(ListItem)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8)
  };
});
var StyledIconButton$1 = styled(IconButton)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.colors.ColorGraySecondary,
    marginLeft: 'auto',
    marginRight: theme.spacing(6),
    padding: theme.spacing(1),
    '&:focus': {
      background: theme.colors.ColorGraySecondaryAlpha1
    },
    '&:hover': {
      background: theme.colors.ColorGraySecondaryAlpha1
    }
  };
});
var StyledCloseIcon = styled(CloseIcon)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    fontSize: theme.spacing(6)
  };
});
var ListItemLabelText = styled(MuiListItemText)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    padding: "" + theme.spacing(2),
    '& .MuiListItemText-root': {
      margin: "0 0 0 6px",
      padding: theme.spacing(2) + " " + theme.spacing(2) + " " + theme.spacing(2) + " " + theme.spacing(4)
    },
    ':not(.Mui-selected)&:hover .MuiListItemText-root, :not(.Mui-selected)&:focus .MuiListItemText-root': {
      background: theme.colors.ColorGrayPrimaryAlpha1,
      borderRadius: theme.borders.BorderRadiusDefault
    },
    fontSize: theme.typography.FontSizeCompact
  };
});
var DNBMobileDrawer = function DNBMobileDrawer(props) {
  var open = props.open,
    toggle = props.toggle,
    _props$listItems = props.listItems,
    listItems = _props$listItems === void 0 ? [] : _props$listItems,
    selectedListItem = props.selectedListItem,
    listItemClicked = props.listItemClicked,
    rest = _objectWithoutPropertiesLoose(props, _excluded$1a);
  return React__default.createElement(Drawer, Object.assign({
    anchor: "right",
    open: open,
    onClose: function onClose() {
      return toggle(false);
    }
  }, rest), React__default.createElement(MuiBox, {
    display: "flex",
    mt: 6
  }, React__default.createElement(StyledIconButton$1, {
    "aria-label": "close",
    onClick: function onClick() {
      return toggle(false);
    }
  }, React__default.createElement(StyledCloseIcon, null))), React__default.createElement(StyledList, null, listItems.map(function (item) {
    return React__default.createElement(Fragment$1, {
      key: item.label
    }, item !== null && item !== void 0 && item.subMenu ? React__default.createElement(Fragment$1, null, React__default.createElement(ListItem, {
      key: item.label
    }, React__default.createElement(ListItemLabelText, {
      disableTypography: true,
      primary: item.label
    })), item === null || item === void 0 ? void 0 : item.subMenu.map(function (menu) {
      return React__default.createElement(StyledSubMenuList, {
        disablePadding: true,
        key: menu.label
      }, React__default.createElement(StyledListItemButton, {
        selected: menu.label === selectedListItem,
        onClick: function onClick() {
          return listItemClicked(menu.label);
        }
      }, React__default.createElement(MuiListItemText, {
        disableTypography: true,
        primary: menu.label
      })));
    })) : React__default.createElement(ListItem, {
      disablePadding: true,
      key: item.label
    }, React__default.createElement(StyledListItemButton, {
      selected: item.label === selectedListItem,
      onClick: function onClick() {
        return listItemClicked(item.label);
      }
    }, React__default.createElement(MuiListItemText, {
      disableTypography: true,
      primary: item.label
    }))));
  })));
};

var _excluded$1b = ["navigationItems", "productLogo", "selectedNavigationItem", "systemFunctions", "position", "navigationItemChanged", "systemFunctionClicked", "isMobile", "mobileLogo", "mobileMenuClicked", "mobileSystemFunctions", "mobileSystemFunctionClicked", "systemFunctionLabels"];
var StyledToolbar = styled(Toolbar, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isMobile';
  }
})(function (_ref) {
  var theme = _ref.theme,
    isMobile = _ref.isMobile;
  return {
    alignItems: 'stretch',
    minHeight: theme.spacing(16),
    paddingLeft: isMobile ? theme.spacing(2) : theme.spacing(6)
  };
});
var StyledAppBar = styled(AppBar)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    boxShadow: "inset 0px -1px 0px " + theme.colors.ColorGrayIncidental
  };
});
var LogoContainer = styled(MuiBox)(function () {
  return {
    alignItems: 'center',
    display: 'flex',
    alignSelf: 'center'
  };
});
var StyledNavigationContainer = styled(MuiBox)(function () {
  return {
    display: 'flex',
    width: '100%',
    alignItems: 'stretch'
  };
});
var StyledTab = styled(Tab)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.palette.text.primary,
    fontSize: theme.typography.FontSizeCompact,
    textTransform: 'none',
    padding: 0,
    margin: theme.spacing(2),
    '&:hover': {
      borderRadius: theme.spacing(2),
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha1
    },
    '&:focus-visible': {
      backgroundColor: theme.palette.background.default,
      border: "2px solid " + theme.colors.ColorPrimaryBlueInteractive,
      borderRadius: theme.spacing(2)
    },
    '&:active': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha2
    }
  };
});
var StyledSystemFunctionContainer = styled(MuiBox)(function () {
  return {
    marginLeft: 'auto',
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center'
  };
});
var StyledTabs = styled(Tabs, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isMobile';
  }
})(function (_ref4) {
  var isMobile = _ref4.isMobile,
    theme = _ref4.theme;
  return {
    marginLeft: isMobile ? theme.spacing(4) : theme.spacing(24),
    '& .MuiTabs-flexContainer': {
      height: '100%'
    }
  };
});
var StyledSystemFunctionIcon = styled(IconButton)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    marginRight: theme.spacing(2),
    '&:first-of-type': {
      marginLeft: theme.spacing(2)
    },
    color: theme.colors.ColorGraySecondary,
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      width: theme.spacing(5),
      height: theme.spacing(5)
    },
    '&:focus-visible': {
      background: theme.colors.ColorGraySecondaryAlpha1
    },
    '&:hover': {
      background: theme.colors.ColorGraySecondaryAlpha1
    }
  };
});
var a11yProps = function a11yProps(index) {
  return {
    id: "navigation-tab-" + index,
    'aria-controls': "navigation-tab-" + index,
    tabIndex: 0
  };
};
var DNBTopNavigationBar = function DNBTopNavigationBar(props) {
  var _props$productLogo$wi, _props$productLogo, _props$productLogo$he, _props$productLogo2, _props$mobileLogo$wid, _props$mobileLogo, _props$mobileLogo$hei, _props$mobileLogo2;
  var _props$navigationItem = props.navigationItems,
    navigationItems = _props$navigationItem === void 0 ? [] : _props$navigationItem,
    productLogo = props.productLogo,
    selectedNavigationItem = props.selectedNavigationItem,
    _props$systemFunction = props.systemFunctions,
    systemFunctions = _props$systemFunction === void 0 ? [] : _props$systemFunction,
    _props$position = props.position,
    position = _props$position === void 0 ? 'sticky' : _props$position,
    navigationItemChanged = props.navigationItemChanged,
    systemFunctionClicked = props.systemFunctionClicked,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    mobileLogo = props.mobileLogo,
    mobileMenuClicked = props.mobileMenuClicked,
    mobileSystemFunctions = props.mobileSystemFunctions,
    mobileSystemFunctionClicked = props.mobileSystemFunctionClicked,
    _props$systemFunction2 = props.systemFunctionLabels,
    systemFunctionLabels = _props$systemFunction2 === void 0 ? [] : _props$systemFunction2,
    rest = _objectWithoutPropertiesLoose(props, _excluded$1b);
  return React__default.createElement(StyledAppBar, Object.assign({
    position: position
  }, rest), React__default.createElement(StyledToolbar, {
    variant: "dense",
    isMobile: isMobile,
    disableGutters: true
  }, !isMobile && productLogo && React__default.createElement(LogoContainer, null, React__default.createElement("img", {
    src: productLogo.url,
    alt: productLogo.alt,
    width: (_props$productLogo$wi = (_props$productLogo = props.productLogo) === null || _props$productLogo === void 0 ? void 0 : _props$productLogo.width) != null ? _props$productLogo$wi : '188px',
    height: (_props$productLogo$he = (_props$productLogo2 = props.productLogo) === null || _props$productLogo2 === void 0 ? void 0 : _props$productLogo2.height) != null ? _props$productLogo$he : '48px'
  })), isMobile && mobileLogo && React__default.createElement(LogoContainer, null, React__default.createElement("img", {
    src: mobileLogo.url,
    alt: mobileLogo.alt,
    width: (_props$mobileLogo$wid = (_props$mobileLogo = props.mobileLogo) === null || _props$mobileLogo === void 0 ? void 0 : _props$mobileLogo.width) != null ? _props$mobileLogo$wid : '188px',
    height: (_props$mobileLogo$hei = (_props$mobileLogo2 = props.mobileLogo) === null || _props$mobileLogo2 === void 0 ? void 0 : _props$mobileLogo2.height) != null ? _props$mobileLogo$hei : '48px'
  })), React__default.createElement(StyledNavigationContainer, null, React__default.createElement(StyledTabs, {
    isMobile: isMobile,
    value: selectedNavigationItem,
    variant: "scrollable",
    scrollButtons: "auto",
    onChange: function onChange(_, newValue) {
      return navigationItemChanged && newValue && navigationItemChanged(newValue);
    }
  }, navigationItems.map(function (item, index) {
    return React__default.createElement(StyledTab, Object.assign({
      key: item,
      label: item,
      value: item
    }, a11yProps(index)));
  })), React__default.createElement(StyledSystemFunctionContainer, null, !isMobile && (systemFunctions === null || systemFunctions === void 0 ? void 0 : systemFunctions.map(function (icon, index) {
    return React__default.createElement(StyledSystemFunctionIcon, {
      "aria-label": systemFunctionLabels[index] || 'system function',
      key: systemFunctionLabels[index] || index,
      onClick: function onClick() {
        return systemFunctionClicked ? systemFunctionClicked(index) : undefined;
      }
    }, icon);
  })), isMobile && mobileSystemFunctions && (mobileSystemFunctions === null || mobileSystemFunctions === void 0 ? void 0 : mobileSystemFunctions.map(function (icon, index) {
    return React__default.createElement(StyledSystemFunctionIcon, {
      "aria-label": systemFunctionLabels[index] || 'mobile system function',
      key: systemFunctionLabels[index] || index,
      onClick: function onClick() {
        return mobileSystemFunctionClicked ? mobileSystemFunctionClicked(index) : undefined;
      }
    }, icon);
  })), isMobile && React__default.createElement(StyledSystemFunctionIcon, {
    "aria-label": "menu",
    onClick: function onClick() {
      return mobileMenuClicked ? mobileMenuClicked() : undefined;
    }
  }, React__default.createElement(MenuIcon, null))))));
};

var _excluded$1c = ["position"];
var StyledToolbar$1 = styled(Toolbar)(function (_ref) {
  var theme = _ref.theme;
  return {
    alignItems: 'stretch',
    minHeight: theme.spacing(16)
  };
});
var StyledAppBar$1 = styled(AppBar)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    boxShadow: "inset 0px -1px 0px " + theme.colors.ColorGrayIncidental
  };
});
var DNBAppBar = function DNBAppBar(props) {
  var _props$position = props.position,
    position = _props$position === void 0 ? 'sticky' : _props$position,
    appBarProps = _objectWithoutPropertiesLoose(props, _excluded$1c);
  return React__default.createElement(StyledAppBar$1, Object.assign({
    position: position
  }, appBarProps), React__default.createElement(StyledToolbar$1, {
    variant: "dense",
    disableGutters: true
  }, props.children));
};

var DNBAppBarLogoContainer = styled(MuiBox)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {
    alignItems: 'center',
    display: 'flex',
    alignSelf: 'center',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }, _ref2[theme.breakpoints.up('md')] = {
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6)
  }, _ref2;
});

var DNBAppBarSystemFunctions = styled(MuiBox)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {
    marginLeft: 'auto',
    marginRight: theme.spacing(2)
  }, _ref2[theme.breakpoints.up('md')] = {
    marginRight: theme.spacing(4)
  }, _ref2.textAlign = 'right', _ref2.display = 'flex', _ref2.alignItems = 'center', _ref2.alignSelf = 'center', _ref2.gap = theme.spacing(1), _ref2;
});

var _excluded$1d = ["tabItems", "selectedTabItems", "tabItemChanged", "allowScrollButtonsMobile"];
var DNBTab = styled(Tab)(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.text.primary,
    fontSize: theme.typography.FontSizeCompact,
    textTransform: 'none',
    padding: "calc(" + theme.spacing(3) + " - 2px) " + theme.spacing(4),
    minHeight: '36px',
    lineHeight: '24px',
    marginBottom: theme.spacing(1.5),
    '&:hover': {
      borderRadius: theme.spacing(2),
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha1
    },
    '&:focus-visible': {
      backgroundColor: theme.palette.background.default,
      border: theme.borders.BorderMedium + " " + theme.colors.ColorPrimaryBlueInteractive,
      borderRadius: theme.spacing(2)
    },
    '&:active': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha2
    }
  };
});
var StyledMuiTabs = styled(Tabs)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    marginLeft: 'auto',
    '& .MuiTabs-flexContainer': {
      borderBottom: theme.borders.BorderThin + " " + theme.colors.ColorGrayIncidental,
      height: '100%',
      width: 'fit-content'
    }
  };
});
var a11yProps$1 = function a11yProps(value) {
  return {
    id: "navigation-tab-" + value,
    'aria-controls': "navigation-tab-" + value,
    tabIndex: 0
  };
};
var DNBTabs = function DNBTabs(props) {
  var tabItems = props.tabItems,
    selectedTabItems = props.selectedTabItems,
    tabItemChanged = props.tabItemChanged,
    _props$allowScrollBut = props.allowScrollButtonsMobile,
    allowScrollButtonsMobile = _props$allowScrollBut === void 0 ? true : _props$allowScrollBut,
    rest = _objectWithoutPropertiesLoose(props, _excluded$1d);
  var hasHrefs = (tabItems || []).some(function (item) {
    return !!item.href;
  });
  return React__default.createElement(StyledMuiTabs, Object.assign({
    value: tabItems !== undefined ? selectedTabItems : props.value,
    variant: "scrollable",
    scrollButtons: "auto",
    allowScrollButtonsMobile: allowScrollButtonsMobile,
    onChange: function onChange(_, newValue) {
      return tabItems !== undefined && tabItemChanged && newValue ? tabItemChanged(newValue) : props.onChange;
    }
  }, rest), tabItems ? tabItems.map(function (_ref3) {
    var label = _ref3.label,
      value = _ref3.value,
      href = _ref3.href;
    return React__default.createElement(DNBTab, Object.assign({
      key: value,
      label: label,
      value: value,
      component: hasHrefs ? 'a' : 'button',
      href: href,
      onClick: hasHrefs ? function (e) {
        return e.preventDefault();
      } : undefined
    }, a11yProps$1(value)));
  }) : props.children);
};

var TabsContainer = styled(MuiBox)(function (_ref) {
  var _MuiTabsRoot;
  var theme = _ref.theme;
  return {
    display: 'flex',
    width: '100%',
    alignItems: 'stretch',
    '& .MuiTabs-root': (_MuiTabsRoot = {
      paddingTop: theme.spacing(1.5),
      marginLeft: 'auto'
    }, _MuiTabsRoot[theme.breakpoints.up('md')] = {
      marginLeft: theme.spacing(8)
    }, _MuiTabsRoot.marginRight = 'auto', _MuiTabsRoot)
  };
});
var DNBAppBarTabs = function DNBAppBarTabs(props) {
  return React__default.createElement(TabsContainer, null, React__default.createElement(DNBTabs, Object.assign({}, props), props.children));
};

var StyledListItem = styled(ListItem, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isSubItem' && prop !== 'disabled';
  }
})(function (_ref) {
  var theme = _ref.theme,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    disabled = _ref.disabled,
    isSubItem = _ref.isSubItem;
  return {
    cursor: disabled ? 'not-allowed' : 'pointer',
    height: theme.spacing(9),
    opacity: disabled ? theme.opacity.OpacityDisabled : undefined,
    paddingLeft: selected && !isSubItem ? 0 : theme.spacing(2),
    paddingRight: selected && !isSubItem ? theme.spacing(4) : theme.spacing(1),
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    '& .MuiListItemText-root': {
      marginLeft: theme.spacing(1)
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      paddingLeft: isSubItem ? theme.spacing(7) : 0,
      paddingRight: isSubItem ? theme.spacing(7) : theme.spacing(4)
    }
  };
});
var StyledListItemButton$1 = styled(ListItemButton, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isSubItem';
  }
})(function (_ref2) {
  var theme = _ref2.theme,
    isSubItem = _ref2.isSubItem,
    disabled = _ref2.disabled;
  return {
    borderLeft: theme.borders.BorderMedium,
    borderLeftColor: 'transparent',
    borderRadius: theme.borders.BorderRadiusDefault,
    cursor: disabled ? 'not-allowed' : 'pointer',
    height: 'inherit',
    paddingLeft: isSubItem ? theme.spacing(8) : theme.spacing(4),
    ':hover': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
    },
    '&.Mui-selected': {
      borderLeft: theme.borders.BorderMedium,
      borderLeftColor: theme.colors.ColorPrimaryBlueInteractive,
      borderRadius: "0 " + theme.borders.BorderRadiusDefault + " " + theme.borders.BorderRadiusDefault + " 0",
      background: theme.colors.ColorPrimaryBlueInteractiveAlpha1,
      color: theme.colors.ColorPrimaryBlueInteractive,
      paddingLeft: isSubItem ? theme.spacing(3) : theme.spacing(6),
      '&:hover': {
        background: theme.colors.ColorPrimaryBlueInteractiveAlpha1
      }
    }
  };
});
var StyledListItemIcon = styled(MuiListItemIcon)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    minWidth: 'unset',
    '& .MuiSvgIcon-root': {
      width: theme.spacing(5),
      height: theme.spacing(5)
    }
  };
});
var ExpandMenuButton = function ExpandMenuButton() {
  return React__default.createElement(StyledListItemIcon, null, React__default.createElement(ArrowForwardIosRoundedIcon, null));
};
var DNBDrawerSideNavigationItem = function DNBDrawerSideNavigationItem(_ref4) {
  var selectedOption = _ref4.selectedOption,
    item = _ref4.item,
    _onClick = _ref4.onClick,
    _ref4$isSubItem = _ref4.isSubItem,
    isSubItem = _ref4$isSubItem === void 0 ? false : _ref4$isSubItem;
  var _item$disabled = item.disabled,
    disabled = _item$disabled === void 0 ? false : _item$disabled,
    _item$expanded = item.expanded,
    expanded = _item$expanded === void 0 ? false : _item$expanded,
    icon = item.icon,
    id = item.id,
    label = item.label,
    value = item.value,
    _item$subMenu = item.subMenu,
    subMenu = _item$subMenu === void 0 ? [] : _item$subMenu;
  var hasSubMenu = subMenu && subMenu.length > 0;
  var selected = selectedOption === value;
  var _useState = useState(expanded),
    isSubMenuExpanded = _useState[0],
    setIsSubMenuExpanded = _useState[1];
  var handleOnItemClick = function handleOnItemClick() {
    if (hasSubMenu) {
      setIsSubMenuExpanded(!isSubMenuExpanded);
    } else {
      _onClick(item);
    }
  };
  return React__default.createElement(Fragment$1, null, React__default.createElement(StyledListItem, {
    disabled: disabled,
    disablePadding: true,
    isSubItem: isSubItem,
    key: id + "-item",
    selected: selected
  }, React__default.createElement(StyledListItemButton$1, {
    "aria-label": label != null ? label : id + " divider",
    disabled: disabled,
    isSubItem: isSubItem,
    key: id + "-item-button",
    onClick: function onClick() {
      return handleOnItemClick();
    },
    selected: selected
  }, icon && React__default.createElement(StyledListItemIcon, null, icon), label ? React__default.createElement(MuiListItemText, {
    primary: label,
    primaryTypographyProps: {
      variant: 'caption'
    }
  }) : null, hasSubMenu && React__default.createElement(ExpandMenuButton, null))), hasSubMenu && React__default.createElement(MuiCollapse, {
    in: isSubMenuExpanded,
    unmountOnExit: true,
    key: id + "-subMenu-collapse"
  }, React__default.createElement(MuiList, {
    component: "div",
    disablePadding: true,
    key: id + "-subMenu-list"
  }, subMenu.map(function (subItem) {
    var subItemId = subItem.id;
    return React__default.createElement(DNBDrawerSideNavigationItem, {
      key: subItemId,
      selectedOption: selectedOption,
      item: subItem,
      onClick: function onClick(selectedItem) {
        return _onClick(selectedItem);
      },
      isSubItem: true
    });
  }))));
};

var _excluded$1e = ["id", "value", "subMenu"];
var StyledList$1 = styled(MuiList)(function (_ref) {
  var theme = _ref.theme,
    variant = _ref.variant;
  return {
    paddingTop: variant === 'permanent' ? theme.spacing(6) : 0,
    marginRight: theme.spacing(1)
  };
});
var DividerContainer = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    padding: theme.spacing(4, 2)
  };
});
var DNBDrawerSideNavigationBody = function DNBDrawerSideNavigationBody(_ref3) {
  var dnbDrawerProps = _ref3.dnbDrawerProps;
  var listItems = dnbDrawerProps.listItems,
    onListItemClick = dnbDrawerProps.onListItemClick,
    selectedListItem = dnbDrawerProps.selectedListItem,
    variant = dnbDrawerProps.variant;
  var handleOnItemClick = function handleOnItemClick(value) {
    onListItemClick(value);
  };
  return React__default.createElement(StyledList$1, {
    variant: variant,
    key: 'drawer-items-list'
  }, listItems.map(function (_ref4) {
    var id = _ref4.id,
      value = _ref4.value,
      subMenu = _ref4.subMenu,
      item = _objectWithoutPropertiesLoose(_ref4, _excluded$1e);
    if (value === 'divider') {
      return React__default.createElement("li", {
        key: "divider-item"
      }, React__default.createElement(DividerContainer, {
        key: "divider-container"
      }, React__default.createElement(MuiDivider, null)));
    } else {
      return React__default.createElement(DNBDrawerSideNavigationItem, {
        item: _extends({
          id: id,
          value: value,
          subMenu: subMenu
        }, item),
        onClick: function onClick(selectedOption) {
          return handleOnItemClick(selectedOption.value);
        },
        selectedOption: selectedListItem,
        key: id + "-item"
      });
    }
  }));
};

var _excluded$1f = ["listItems", "onListItemClick", "onButtonClick", "open", "position", "selectedListItem", "variant", "border"];
var getDrawerWidth = function getDrawerWidth(_ref) {
  var variant = _ref.variant,
    open = _ref.open,
    theme = _ref.theme;
  if (open) {
    return {
      minWidth: '20rem',
      maxWidth: '28.8rem'
    };
  } else if (variant === 'persistent') {
    return {
      width: theme.spacing(7)
    };
  } else {
    return {
      width: 0
    };
  }
};
var StyledDrawer$1 = styled(Drawer)(function (_ref2) {
  var theme = _ref2.theme,
    position = _ref2.position,
    variant = _ref2.variant,
    open = _ref2.open,
    border = _ref2.border;
  return {
    '& .MuiDrawer-paper': _extends({
      borderRight: border ? theme.borders.BorderThin + " " + theme.colors.ColorGrayIncidental : 'none',
      overflowY: 'visible',
      position: position === 'relative' ? 'relative' : undefined,
      zIndex: theme.zIndex.drawer
    }, getDrawerWidth({
      variant: variant,
      open: open,
      theme: theme
    })),
    '& .MuiListItem-root': {
      visibility: open ? 'visible' : 'hidden'
    }
  };
});
var DrawerHeader = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1)
  };
});
var StyledIconButtonClose = styled(IconButton)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    backgroundColor: theme.colors.ColorBackgroundWhite,
    boxShadow: theme.shadows[1],
    width: theme.spacing(8),
    height: theme.spacing(8),
    transform: 'translateX(50%)',
    ':hover': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
    },
    '& .MuiSvgIcon-root': {
      width: theme.spacing(6),
      height: theme.spacing(6)
    }
  };
});
var StyledIconButtonOpen = styled(IconButton)(function (_ref5) {
  var theme = _ref5.theme,
    position = _ref5.position;
  return _extends({
    backgroundColor: theme.colors.ColorBackgroundWhite,
    boxShadow: theme.shadows[1],
    left: position === 'absolute' ? theme.spacing(1) : undefined,
    right: position === 'absolute' ? theme.spacing(2) : undefined,
    width: theme.spacing(8),
    height: theme.spacing(8)
  }, position === 'absolute' ? {
    left: theme.spacing(1),
    right: theme.spacing(2)
  } : undefined, {
    position: 'absolute',
    ':hover': {
      backgroundColor: theme.colors.ColorGrayPrimaryAlpha1
    },
    '& .MuiSvgIcon-root': {
      width: theme.spacing(6),
      height: theme.spacing(6)
    }
  });
});
var DNBDrawerSideNavigation = function DNBDrawerSideNavigation(_ref6) {
  var listItems = _ref6.listItems,
    onListItemClick = _ref6.onListItemClick,
    onButtonClick = _ref6.onButtonClick,
    _ref6$open = _ref6.open,
    open = _ref6$open === void 0 ? true : _ref6$open,
    _ref6$position = _ref6.position,
    position = _ref6$position === void 0 ? 'absolute' : _ref6$position,
    selectedListItem = _ref6.selectedListItem,
    variant = _ref6.variant,
    border = _ref6.border,
    sideNavigationProps = _objectWithoutPropertiesLoose(_ref6, _excluded$1f);
  var _useState = useState(open),
    isDrawerOpen = _useState[0],
    setIsDrawerOpen = _useState[1];
  var dnbDrawerProps = _extends({
    listItems: listItems,
    onListItemClick: onListItemClick,
    onButtonClick: onButtonClick,
    open: open,
    position: position,
    selectedListItem: selectedListItem,
    variant: variant
  }, sideNavigationProps);
  var handleOnButtonClick = function handleOnButtonClick() {
    toggleDrawer();
    if (typeof onButtonClick === 'function') {
      onButtonClick();
    }
  };
  var toggleDrawer = function toggleDrawer() {
    setIsDrawerOpen(!isDrawerOpen);
  };
  useEffect(function () {
    setIsDrawerOpen(open);
  }, [open]);
  return React__default.createElement(Fragment$1, null, variant === 'persistent' && !isDrawerOpen && React__default.createElement(StyledIconButtonOpen, {
    onClick: function onClick() {
      return handleOnButtonClick();
    },
    position: position
  }, React__default.createElement(KeyboardDoubleArrowRightRoundedIcon, null)), React__default.createElement(StyledDrawer$1, Object.assign({}, sideNavigationProps, {
    anchor: "left",
    variant: variant,
    position: position,
    ModalProps: {
      keepMounted: true
    },
    open: isDrawerOpen,
    border: border
  }), variant === 'persistent' && React__default.createElement(DrawerHeader, {
    key: "drawer-header"
  }, React__default.createElement(StyledIconButtonClose, {
    "aria-label": "close drawer",
    onClick: function onClick() {
      return handleOnButtonClick();
    }
  }, React__default.createElement(KeyboardDoubleArrowLeftRoundedIcon, null))), open && React__default.createElement(DNBDrawerSideNavigationBody, {
    dnbDrawerProps: dnbDrawerProps
  })));
};

var _excluded$1g = ["open", "anchorEl", "placement", "hasArrow", "hasCloseButton", "closeButtonOnClick", "children"];
var StyledMuiPopover = styled(Popper$1)(function (_ref) {
  var theme = _ref.theme;
  return {
    '.MuiSvgIcon-root': {
      color: theme.colors.ColorGraySecondary,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    '.MuiPaper-root': {
      padding: '15px 15px 1px 15px',
      borderRadius: '8px',
      boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 2px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
    },
    zIndex: 1,
    '& > div': {
      position: 'relative'
    },
    '&[data-popper-placement*="bottom"]': {
      '& > div': {
        marginTop: '20px'
      },
      '& .MuiPopper-arrow': {
        top: 0,
        left: 0,
        marginTop: '-0.9em',
        width: '3em',
        height: '1em',
        '&::before': {
          borderWidth: '0 10px 10px 10px',
          borderColor: 'transparent transparent rgb(0 0 0 / 14%) transparent',
          marginTop: '-4px'
        },
        '&::after': {
          borderWidth: '0 10px 10px 10px',
          borderColor: "transparent transparent " + theme.palette.background.paper + " transparent",
          marginTop: '-9px'
        }
      }
    },
    '&[data-popper-placement*="top"]': {
      '& > div': {
        marginBottom: '20px'
      },
      '& .MuiPopper-arrow': {
        bottom: 0,
        left: 0,
        marginBottom: '-0.9em',
        width: '3em',
        height: '1em',
        '&::before': {
          borderWidth: '10px 10px 0 10px',
          borderColor: 'rgb(0 0 0 / 14%) transparent transparent transparent',
          marginTop: '1px'
        },
        '&::after': {
          borderWidth: '10px 10px 0 10px',
          borderColor: theme.palette.background.paper + " transparent transparent transparent",
          marginTop: '-13px'
        }
      }
    },
    '&[data-popper-placement*="right"]': {
      '& > div': {
        marginLeft: '20px'
      },
      '& .MuiPopper-arrow': {
        left: 0,
        marginLeft: '-10px',
        height: '3em',
        width: '1em',
        '&::before': {
          borderWidth: '10px 10px 10px 0',
          borderColor: 'transparent rgb(0 0 0 / 14%) transparent transparent',
          marginTop: '1px'
        },
        '&::after': {
          borderWidth: '10px 10px 10px 0',
          borderColor: "transparent " + theme.palette.background.paper + " transparent transparent",
          marginTop: '-20px',
          marginLeft: '3px'
        }
      }
    },
    '&[data-popper-placement*="left"]': {
      '& > div': {
        marginRight: '20px'
      },
      '& .MuiPopper-arrow': {
        right: 0,
        marginRight: '-8px',
        height: '3em',
        width: '1em',
        '&::before': {
          borderWidth: '10px 0 10px 10px',
          borderColor: 'transparent transparent transparent rgb(0 0 0 / 14%)'
        },
        '&::after': {
          borderWidth: '10px 0 10px 10px',
          borderColor: "transparent transparent transparent " + theme.palette.background.paper,
          marginLeft: '-2px',
          marginTop: '-20px'
        }
      }
    }
  };
});
var Arrow = styled('div')({
  position: 'absolute',
  fontSize: 7,
  width: '3em',
  height: '3em',
  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    borderStyle: 'solid'
  },
  '&::after': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    borderStyle: 'solid'
  }
});
var DNBPopover = function DNBPopover(props) {
  var open = props.open,
    anchorEl = props.anchorEl,
    placement = props.placement,
    hasArrow = props.hasArrow,
    hasCloseButton = props.hasCloseButton,
    closeButtonOnClick = props.closeButtonOnClick,
    children = props.children,
    rest = _objectWithoutPropertiesLoose(props, _excluded$1g);
  var keydown = function keydown(e) {
    if (e.key === 'Escape' && closeButtonOnClick) {
      closeButtonOnClick();
    }
  };
  useEffect(function () {
    window.addEventListener('keydown', keydown);
    return function () {
      return window.removeEventListener('keydown', keydown);
    };
  }, []);
  var _useState = useState(null),
    arrowRef = _useState[0],
    setArrowRef = _useState[1];
  var arrowModifiers = hasArrow ? [{
    name: 'arrow',
    enabled: hasArrow,
    options: {
      element: arrowRef
    }
  }] : [];
  return placement === 'full-screen' ? React__default.createElement(DNBDialog, {
    open: open,
    onClose: function onClose() {
      return closeButtonOnClick === null || closeButtonOnClick === void 0 ? void 0 : closeButtonOnClick();
    },
    hasCloseButton: true,
    size: "full"
  }, children) : React__default.createElement(StyledMuiPopover, Object.assign({
    className: "DNBPopover-root",
    open: open,
    placement: placement,
    anchorEl: anchorEl,
    modifiers: arrowModifiers
  }, rest), React__default.createElement(ClickAwayListener$1, {
    onClickAway: function onClickAway() {
      if (open && closeButtonOnClick) {
        closeButtonOnClick();
      }
    }
  }, React__default.createElement("div", {
    className: "DNBPopover-paper-container"
  }, hasArrow ? React__default.createElement(Arrow, {
    ref: setArrowRef,
    className: "MuiPopper-arrow"
  }) : null, React__default.createElement(Paper, {
    sx: {
      maxWidth: 432,
      overflow: 'auto'
    }
  }, hasCloseButton ? React__default.createElement("span", {
    onClick: function onClick() {
      return closeButtonOnClick ? closeButtonOnClick() : null;
    }
  }, React__default.createElement(CloseIcon, {
    sx: {
      width: '20px',
      height: '20px',
      float: 'right'
    }
  })) : '', children))));
};

var _excluded$1h = ["children"],
  _excluded2$5 = ["disabled", "label", "isLoading", "marks", "size", "startIcon", "endIcon"];
var excludedProps$3 = {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'dnbSize' && prop !== 'hasMarks' && prop !== 'hasStartIcon' && prop !== 'hasEndIcon';
  }
};
var getDNBSliderSizes = function getDNBSliderSizes(size) {
  switch (size) {
    case 'default':
      return {
        rootHeight: theme.spacing(11),
        thumbShadowRadius: theme.spacing(3),
        markLabelTopPosition: "-" + theme.spacing(4)
      };
    case 'compact':
      return {
        rootHeight: theme.spacing(9),
        thumbShadowRadius: theme.spacing(2),
        markLabelTopPosition: "-" + theme.spacing(3)
      };
    case 'small':
      return {
        rootHeight: theme.spacing(8),
        thumbShadowRadius: '0.6rem',
        markLabelTopPosition: "-1rem"
      };
  }
};
var StyledDNBTypography = styled(DNBTypography)(function (_ref) {
  var theme = _ref.theme,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return {
    opacity: disabled ? theme.opacity.OpacityDisabled : 1
  };
});
var StyledMuiSlider = styled(MuiSlider, excludedProps$3)(function (_ref2) {
  var theme = _ref2.theme,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    dnbSize = _ref2.dnbSize,
    hasMarks = _ref2.hasMarks,
    hasStartIcon = _ref2.hasStartIcon,
    hasEndIcon = _ref2.hasEndIcon;
  return {
    color: theme.colors.ColorPrimaryBlueInteractive,
    height: getDNBSliderSizes(dnbSize).rootHeight,
    opacity: disabled ? theme.opacity.OpacityDisabled : 1,
    paddingTop: hasMarks ? theme.spacing(6) : 0,
    marginLeft: hasStartIcon ? "calc(" + getDNBSliderSizes(dnbSize).thumbShadowRadius + " + 1rem)" : '1rem',
    marginRight: hasEndIcon ? "calc(" + getDNBSliderSizes(dnbSize).thumbShadowRadius + " + 1rem)" : 0,
    '& .Mui-focusVisible': {
      boxShadow: "0 0 0 " + getDNBSliderSizes(dnbSize).thumbShadowRadius + " " + theme.colors.ColorGraySecondaryAlpha1
    },
    '& .MuiSlider-rail': {
      border: theme.borders.BorderThin,
      borderColor: theme.colors.ColorGraySecondary,
      color: theme.colors.ColorGrayIncidental,
      height: '0.6rem',
      opacity: 1
    },
    '& .MuiSlider-thumb': {
      backgroundColor: theme.colors.ColorBackgroundWhite,
      border: theme.borders.BorderThin,
      borderColor: theme.colors.ColorGraySecondary,
      height: theme.spacing(5),
      width: theme.spacing(5),
      '&:hover, &:active, &.Mui-focusVisible': {
        boxShadow: "0 0 0 " + getDNBSliderSizes(dnbSize).thumbShadowRadius + " " + theme.colors.ColorGraySecondaryAlpha1
      }
    },
    '& .MuiSlider-track': {
      borderRadius: theme.sizing.SizingBorderRadiusDefault,
      height: '0.6rem'
    },
    '& .MuiSlider': {
      '&-markLabel': _extends({
        color: disabled ? theme.colors.ColorGrayPrimary : theme.colors.ColorGraySecondary
      }, theme.typography['caption'], {
        top: 0
      }),
      '&-markLabelActive': {
        color: disabled ? theme.colors.ColorGrayPrimary : theme.colors.ColorGraySecondary
      }
    },
    '& .MuiSlider-valueLabel': {
      backgroundColor: theme.colors.ColorGrayPrimary,
      borderRadius: theme.borders.BorderRadiusDefault,
      boxShadow: theme.boxShadows.ShadowPlus1,
      color: theme.colors.ColorBackgroundWhite
    },
    '& .MuiSlider-mark': {
      visibility: 'hidden'
    }
  };
});
var StyledDivWrapper = styled('div')(function () {
  return {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row'
  };
});
var DNBSliderThumbLoading = function DNBSliderThumbLoading(_ref3) {
  var children = _ref3.children,
    dnbSliderThumbLoadingProps = _objectWithoutPropertiesLoose(_ref3, _excluded$1h);
  return React__default.createElement(SliderThumb, Object.assign({}, dnbSliderThumbLoadingProps), children, React__default.createElement(CircularProgress, {
    "aria-label": "circular progress bar",
    variant: 'indeterminate',
    size: 12
  }));
};
var DNBSlider = function DNBSlider(_ref4) {
  var _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
    label = _ref4.label,
    _ref4$isLoading = _ref4.isLoading,
    isLoading = _ref4$isLoading === void 0 ? false : _ref4$isLoading,
    marks = _ref4.marks,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'default' : _ref4$size,
    startIcon = _ref4.startIcon,
    endIcon = _ref4.endIcon,
    dnbSliderProps = _objectWithoutPropertiesLoose(_ref4, _excluded2$5);
  return React__default.createElement(Fragment$1, null, React__default.createElement(StyledDNBTypography, {
    component: 'span',
    disabled: disabled,
    variant: size === 'default' ? 'subtitle2' : 'compact-medium'
  }, label), React__default.createElement(StyledDivWrapper, {
    className: "SliderContainer"
  }, startIcon != null ? startIcon : null, React__default.createElement(StyledMuiSlider, Object.assign({
    disabled: disabled,
    valueLabelDisplay: "auto",
    "aria-label": label != null ? label : 'DNBSlider',
    slots: {
      thumb: isLoading ? DNBSliderThumbLoading : SliderThumb
    }
  }, dnbSliderProps, {
    marks: marks,
    orientation: "horizontal",
    dnbSize: size,
    hasMarks: marks === true || marks !== undefined && Object.entries(marks).length > 0,
    hasStartIcon: !!startIcon,
    hasEndIcon: !!endIcon
  })), endIcon != null ? endIcon : null));
};

var _excluded$1i = ["variant", "isWrapped", "snackbarText", "isOpen", "handleClose", "hasCloseIcon", "duration", "labelCTA", "loadingCTA", "disabledCTA", "onClickCTA", "labelCTA2", "loadingCTA2", "disabledCTA2", "onClickCTA2", "sx"];
var SlideTransition = function SlideTransition(props) {
  return React__default.createElement(Slide, Object.assign({}, props, {
    direction: "up"
  }));
};
var StyledButton = styled(DNBButton)(function (_ref) {
  var theme = _ref.theme;
  return {
    outline: 'none !important',
    fontSize: '14px',
    textDecoration: 'underline',
    '&.Mui-disabled': {
      color: theme.colors.ColorGrayPrimary
    }
  };
});
var CTAButtons = function CTAButtons(_ref2) {
  var labelCTA = _ref2.labelCTA,
    loadingCTA = _ref2.loadingCTA,
    disabledCTA = _ref2.disabledCTA,
    onClickCTA = _ref2.onClickCTA,
    labelCTA2 = _ref2.labelCTA2,
    loadingCTA2 = _ref2.loadingCTA2,
    disabledCTA2 = _ref2.disabledCTA2,
    onClickCTA2 = _ref2.onClickCTA2;
  if (labelCTA && labelCTA2) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(StyledButton, {
      variant: "text",
      color: "inherit",
      size: "small",
      onClick: !loadingCTA ? onClickCTA : function () {
        return null;
      },
      disabled: disabledCTA
    }, labelCTA && loadingCTA ? React__default.createElement(CircularProgress, {
      size: 16
    }) : labelCTA), React__default.createElement(StyledButton, {
      variant: "text",
      color: "inherit",
      size: "small",
      onClick: !loadingCTA2 ? onClickCTA2 : function () {
        return null;
      },
      disabled: disabledCTA2
    }, loadingCTA2 ? React__default.createElement(CircularProgress, {
      size: 16
    }) : labelCTA2));
  }
  if (labelCTA) {
    return React__default.createElement(StyledButton, {
      variant: "text",
      color: "inherit",
      size: "small",
      onClick: !loadingCTA ? onClickCTA : function () {
        return null;
      },
      disabled: disabledCTA
    }, loadingCTA ? React__default.createElement(CircularProgress, {
      size: 16
    }) : labelCTA);
  }
  return null;
};
var CTAWrapper = styled(MuiBox, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isWrapped' && prop !== 'hasCloseIcon';
  }
})(function (_ref3) {
  var theme = _ref3.theme,
    isWrapped = _ref3.isWrapped,
    hasCloseIcon = _ref3.hasCloseIcon;
  return {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginRight: isWrapped && hasCloseIcon ? '-24px' : undefined,
    marginTop: isWrapped ? theme.spacing(4) : undefined
  };
});
var Alert = React__default.forwardRef(function Alert(props, ref) {
  return React__default.createElement(MuiAlert, Object.assign({
    elevation: 6,
    ref: ref,
    variant: "outlined"
  }, props));
});
var StyledAlert = styled(Alert, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isWrapped';
  }
})(function (_ref4) {
  var isWrapped = _ref4.isWrapped;
  return {
    width: '328px',
    alignItems: isWrapped ? undefined : 'center',
    minHeight: isWrapped ? '104px' : undefined,
    '& .MuiAlert-action': {
      marginBottom: isWrapped ? 14 : undefined
    }
  };
});
var DNBSnackbar = function DNBSnackbar(props) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'success' : _props$variant,
    _props$isWrapped = props.isWrapped,
    isWrapped = _props$isWrapped === void 0 ? false : _props$isWrapped,
    snackbarText = props.snackbarText,
    _props$isOpen = props.isOpen,
    isOpen = _props$isOpen === void 0 ? false : _props$isOpen,
    handleClose = props.handleClose,
    _props$hasCloseIcon = props.hasCloseIcon,
    hasCloseIcon = _props$hasCloseIcon === void 0 ? true : _props$hasCloseIcon,
    duration = props.duration,
    labelCTA = props.labelCTA,
    _props$loadingCTA = props.loadingCTA,
    loadingCTA = _props$loadingCTA === void 0 ? false : _props$loadingCTA,
    _props$disabledCTA = props.disabledCTA,
    disabledCTA = _props$disabledCTA === void 0 ? false : _props$disabledCTA,
    onClickCTA = props.onClickCTA,
    labelCTA2 = props.labelCTA2,
    _props$loadingCTA2 = props.loadingCTA2,
    loadingCTA2 = _props$loadingCTA2 === void 0 ? false : _props$loadingCTA2,
    _props$disabledCTA2 = props.disabledCTA2,
    disabledCTA2 = _props$disabledCTA2 === void 0 ? false : _props$disabledCTA2,
    onClickCTA2 = props.onClickCTA2,
    sx = props.sx,
    rest = _objectWithoutPropertiesLoose(props, _excluded$1i);
  var combinedSX = _extends({
    '& .MuiAlert-outlinedSuccess': {
      boxShadow: function boxShadow(theme) {
        return "0px 4px 8px " + theme.colors.ColorGrayPrimaryAlpha4;
      },
      backgroundColor: function backgroundColor(theme) {
        return theme.colors.ColorNotificationSuccessAlpha1;
      },
      border: function border(theme) {
        return "1px solid " + theme.colors.ColorNotificationSuccess;
      },
      borderRadius: 2,
      alignItems: isWrapped ? '' : 'center'
    },
    '& .MuiAlert-outlinedError': {
      boxShadow: function boxShadow(theme) {
        return "0px 4px 8px " + theme.colors.ColorGrayPrimaryAlpha4;
      },
      backgroundColor: function backgroundColor(theme) {
        return theme.colors.ColorNotificationErrorAlpha1;
      },
      border: function border(theme) {
        return "1px solid " + theme.colors.ColorNotificationError;
      },
      borderRadius: 2,
      alignItems: isWrapped ? '' : 'center'
    },
    '& .MuiAlert-outlinedWarning': {
      boxShadow: function boxShadow(theme) {
        return "0px 4px 8px " + theme.colors.ColorGrayPrimaryAlpha4;
      },
      backgroundColor: function backgroundColor(theme) {
        return theme.colors.ColorNotificationWarningAlpha1;
      },
      border: function border(theme) {
        return "1px solid " + theme.colors.ColorNotificationWarning;
      },
      borderRadius: 2,
      alignItems: isWrapped ? '' : 'center'
    },
    '& .MuiAlert-outlinedInfo': {
      boxShadow: function boxShadow(theme) {
        return "0px 4px 8px " + theme.colors.ColorGrayPrimaryAlpha4;
      },
      backgroundColor: function backgroundColor(theme) {
        return theme.colors.ColorPrimaryBlueAlpha1;
      },
      border: function border(theme) {
        return "1px solid " + theme.colors.ColorNotificationInfo;
      },
      borderRadius: 2,
      alignItems: isWrapped ? '' : 'center'
    },
    '& .MuiAlert-action': {
      paddingTop: '1px',
      paddingLeft: '0'
    },
    '& .MuiAlert-message': {
      width: 'inherit',
      display: isWrapped ? '' : 'flex',
      justifyContent: isWrapped ? '' : 'space-between'
    },
    '& .MuiButton-root': {
      color: 'inherit',
      textDecoration: 'underline'
    }
  }, sx);
  return React__default.createElement(Stack, {
    spacing: 2,
    sx: {
      width: '100%'
    }
  }, React__default.createElement(Snackbar, Object.assign({
    open: isOpen,
    autoHideDuration: isWrapped || labelCTA ? null : duration || 6000,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    TransitionComponent: SlideTransition,
    sx: combinedSX
  }, rest), React__default.createElement(MuiBox, {
    sx: {
      bgcolor: 'background.paper',
      borderRadius: 2
    }
  }, React__default.createElement(StyledAlert, {
    isWrapped: isWrapped,
    onClose: hasCloseIcon && handleClose ? handleClose : undefined,
    severity: variant,
    iconMapping: {
      success: React__default.createElement(CheckCircleOutlineIcon, {
        fontSize: "inherit"
      })
    }
  }, React__default.createElement(DNBTypography, {
    alignSelf: "center",
    variant: "compact-medium"
  }, snackbarText), React__default.createElement(CTAWrapper, {
    isWrapped: isWrapped,
    hasCloseIcon: hasCloseIcon
  }, React__default.createElement(CTAButtons, {
    labelCTA: labelCTA,
    loadingCTA: loadingCTA,
    disabledCTA: disabledCTA,
    onClickCTA: onClickCTA,
    labelCTA2: labelCTA2,
    loadingCTA2: loadingCTA2,
    disabledCTA2: disabledCTA2,
    onClickCTA2: onClickCTA2
  }))))));
};

var _excluded$1j = ["steps", "activeStep", "type"];
var StyledMuiStepper = styled(MuiStepper)(function () {
  var _ref;
  return _ref = {}, _ref["&." + stepperClasses.horizontal] = {
    alignItems: 'flex-start'
  }, _ref;
});
var StyledMuiStepConnector = styled(MuiStepConnector, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isSimpleStepper';
  }
})(function (_ref2) {
  var _ref3;
  var isSimpleStepper = _ref2.isSimpleStepper,
    theme = _ref2.theme;
  return _ref3 = {}, _ref3["&." + stepConnectorClasses.horizontal] = _extends({
    paddingTop: isSimpleStepper ? 'unset' : theme.spacing(5)
  }, isSimpleStepper && {
    top: theme.spacing(5),
    left: "calc(-50% + " + theme.spacing(5) + ")",
    right: "calc(50% + " + theme.spacing(6) + ")"
  }), _ref3["&." + stepConnectorClasses.vertical] = {
    marginLeft: theme.spacing(5)
  }, _ref3["& ." + stepConnectorClasses.line] = {
    borderColor: theme.colors.ColorGrayIncidental
  }, _ref3;
});
var StyledMuiStep = styled(MuiStep, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isSimpleStepper';
  }
})(function (_ref4) {
  var isSimpleStepper = _ref4.isSimpleStepper;
  return {
    alignItems: isSimpleStepper ? 'center' : 'flex-start',
    display: isSimpleStepper ? 'flex' : 'block',
    justifyContent: isSimpleStepper ? 'center' : 'unset'
  };
});
var StyledMuiErrorOutlineIcon = styled(MuiErrorOutlineIcon)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.colors.ColorNotificationError,
    fontSize: theme.typography.FontSizeHeadline5,
    zIndex: 1
  };
});
var StyledMuiCheckIcon = styled(CheckIcon$1)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    color: theme.colors.ColorPrimaryBlueInteractive,
    fontSize: theme.typography.FontSizeHeadline6,
    height: theme.spacing(6),
    zIndex: 1
  };
});
var StyledStepIconDiv = styled('div', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isActive';
  }
})(function (_ref7) {
  var isActive = _ref7.isActive,
    theme = _ref7.theme;
  return _extends({}, theme.typography['body'], {
    alignItems: 'center',
    backgroundColor: isActive ? theme.colors.ColorPrimaryBlueInteractive : theme.colors.ColorGraySecondaryAlpha1,
    borderRadius: theme.borders.BorderRadiusFull,
    color: isActive ? theme.colors.ColorBackgroundWhite : theme.colors.ColorGraySecondary,
    display: 'flex',
    fontWeight: theme.typography.FontWeightAvenirMedium,
    height: theme.spacing(6),
    justifyContent: 'center',
    width: theme.spacing(6)
  });
});
var StyledMuiStepLabel = styled(MuiStepLabel, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isSimpleStepper';
  }
})(function (_ref8) {
  var _extends2, _ref9, _ref10;
  var theme = _ref8.theme,
    isSimpleStepper = _ref8.isSimpleStepper;
  return _ref10 = {
    alignItems: !isSimpleStepper ? 'flex-start' : undefined,
    lineHeight: theme.typography.FontLetterSpacingCaption,
    maxWidth: '216px',
    padding: theme.spacing(2),
    width: isSimpleStepper ? 'fit-content' : 'auto'
  }, _ref10["&." + stepLabelClasses.disabled] = {
    opacity: theme.opacity.OpacityDisabled
  }, _ref10["&." + stepLabelClasses.horizontal] = {
    gap: isSimpleStepper ? theme.spacing(1) : theme.spacing(3)
  }, _ref10["& ." + stepLabelClasses.horizontal] = {
    paddingRight: theme.spacing(1)
  }, _ref10["& ." + stepLabelClasses.labelContainer] = (_ref9 = {}, _ref9["& ." + stepLabelClasses.label] = _extends({}, theme.typography['body'], (_extends2 = {
    color: theme.colors.ColorGrayPrimary,
    display: isSimpleStepper ? 'block' : '-webkit-box',
    lineClamp: 3,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3
  }, _extends2["&." + stepLabelClasses.active] = {
    color: theme.colors.ColorPrimaryBlueInteractive
  }, _extends2)), _ref9), _ref10["&." + stepLabelClasses.root + ":not(." + stepLabelClasses.disabled + "):hover"] = {
    backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha1,
    borderRadius: theme.borders.BorderRadiusDefault
  }, _ref10["&:active, &." + stepLabelClasses.active] = {
    backgroundColor: theme.colors.ColorPrimaryBlueInteractiveAlpha2
  }, _ref10['&:focus'] = {
    border: theme.borders.BorderThin + " " + theme.colors.ColorPrimaryBlueInteractive
  }, _ref10;
});
var StyledMuiStepContent = styled(MuiStepContent)(function (_ref11) {
  var theme = _ref11.theme;
  return {
    marginLeft: theme.spacing(5),
    paddingTop: theme.spacing(8)
  };
});
var StyledDNBTypography$1 = styled(DNBTypography, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'hasError';
  }
})(function (_ref12) {
  var theme = _ref12.theme,
    hasError = _ref12.hasError;
  return {
    color: hasError ? theme.colors.ColorNotificationError : theme.colors.ColorGraySecondary
  };
});
var DNBStepIcon = function DNBStepIcon(_ref13) {
  var active = _ref13.active,
    completed = _ref13.completed,
    error = _ref13.error,
    icon = _ref13.icon;
  if (error) {
    return React__default.createElement(StyledMuiErrorOutlineIcon, null);
  }
  return completed ? React__default.createElement(StyledMuiCheckIcon, null) : React__default.createElement(StyledStepIconDiv, {
    isActive: active
  }, icon);
};
var getStepIcon = function getStepIcon(props) {
  return React__default.createElement(DNBStepIcon, Object.assign({}, props));
};
var DNBStepper = function DNBStepper(_ref14) {
  var steps = _ref14.steps,
    _ref14$activeStep = _ref14.activeStep,
    activeStep = _ref14$activeStep === void 0 ? 1 : _ref14$activeStep,
    _ref14$type = _ref14.type,
    type = _ref14$type === void 0 ? 'horizontal' : _ref14$type,
    stepperProps = _objectWithoutPropertiesLoose(_ref14, _excluded$1j);
  var isSimpleStepper = type === 'simple';
  var orientation = type === 'vertical' ? 'vertical' : 'horizontal';
  return React__default.createElement(StyledMuiStepper, Object.assign({
    activeStep: activeStep,
    alternativeLabel: isSimpleStepper,
    connector: React__default.createElement(StyledMuiStepConnector, {
      isSimpleStepper: isSimpleStepper
    }),
    orientation: orientation
  }, stepperProps), steps.map(function (_ref15, index) {
    var children = _ref15.children,
      _ref15$disabled = _ref15.disabled,
      disabled = _ref15$disabled === void 0 ? false : _ref15$disabled,
      errorMessage = _ref15.errorMessage,
      helperText = _ref15.helperText,
      isLoading = _ref15.isLoading,
      isOptional = _ref15.isOptional,
      key = _ref15.key,
      label = _ref15.label;
    var stepNumber = index + 1;
    var hasHelperText = helperText !== undefined && helperText.length > 0;
    var hasError = errorMessage !== undefined && errorMessage.length > 0;
    var stepLabel = isOptional && !hasError ? label + " (optional)" : label;
    var supportText = hasError ? errorMessage : helperText;
    var helperLabel = isOptional && !hasHelperText && !hasError ? '(optional)' : supportText;
    return React__default.createElement(StyledMuiStep, {
      key: stepLabel,
      disabled: disabled,
      isSimpleStepper: isSimpleStepper
    }, React__default.createElement(StyledMuiStepLabel, {
      error: hasError,
      icon: isLoading ? React__default.createElement(CircularProgress, {
        "aria-label": "circular progress bar",
        color: "inherit",
        size: 16
      }) : null,
      isSimpleStepper: isSimpleStepper,
      optional: isSimpleStepper ? null : React__default.createElement(StyledDNBTypography$1, {
        variant: "caption",
        "data-testid": key ? key + "-support-text" : stepNumber + "-support-text",
        hasError: hasError
      }, helperLabel),
      StepIconComponent: function StepIconComponent(props) {
        return getStepIcon(props);
      },
      title: stepLabel
    }, stepLabel), children && type === 'vertical' && React__default.createElement(StyledMuiStepContent, null, children));
  }));
};

var _excluded$1k = ["leadingIcon", "type", "label", "selected", "className", "onDelete", "isLoading", "loadingProgress"];
var themeColors = theme.colors;
var tagStyleByType = {
  default: {
    color: themeColors.ColorGraySecondary,
    backgroundColor: themeColors.ColorGraySecondaryAlpha1
  },
  'type-2': {
    color: themeColors.ColorPrimaryBlue,
    backgroundColor: themeColors.ColorPrimaryBlueAlpha1
  },
  'type-3': {
    color: themeColors.ColorSecondaryPurpleLight,
    backgroundColor: themeColors.ColorSecondaryPurpleLightAlpha1
  },
  'type-4': {
    color: themeColors.ColorSecondaryTealDark,
    backgroundColor: themeColors.ColorSecondaryTealDarkAlpha1
  },
  'type-5': {
    color: themeColors.ColorSecondaryPurpleDark,
    backgroundColor: themeColors.ColorSecondaryPurpleDarkAlpha1
  },
  'type-6': {
    color: themeColors.ColorSecondaryPinkDark,
    backgroundColor: themeColors.ColorSecondaryPinkDarkAlpha1
  },
  'type-7': {
    color: themeColors.ColorSecondaryVioletDark,
    backgroundColor: themeColors.ColorSecondaryVioletDarkAlpha1
  },
  'type-8': {
    color: themeColors.ColorGrayPrimary,
    backgroundColor: themeColors.ColorGrayPrimaryAlpha1
  },
  positive: {
    color: themeColors.ColorNotificationSuccess,
    backgroundColor: themeColors.ColorNotificationSuccessAlpha1
  },
  negative: {
    color: themeColors.ColorNotificationError,
    backgroundColor: themeColors.ColorNotificationErrorAlpha1
  },
  caution: {
    color: themeColors.ColorNotificationWarning,
    backgroundColor: themeColors.ColorNotificationWarningAlpha1
  },
  'low-scale': {
    color: themeColors.ColorBackgroundWhite,
    backgroundColor: themeColors.ColorScaleLow
  },
  'mild-scale': {
    color: themeColors.ColorBackgroundWhite,
    backgroundColor: themeColors.ColorScaleMild
  },
  'moderate-scale': {
    color: themeColors.ColorGrayPrimary,
    backgroundColor: themeColors.ColorScaleModerate
  },
  'elevated-scale': {
    color: themeColors.ColorGrayPrimary,
    backgroundColor: themeColors.ColorScaleElevated
  },
  'high-scale': {
    color: themeColors.ColorBackgroundWhite,
    backgroundColor: themeColors.ColorScaleHigh
  },
  'severe-scale': {
    color: themeColors.ColorBackgroundWhite,
    backgroundColor: themeColors.ColorScaleSevere
  },
  interactive: {
    color: themeColors.ColorGraySecondary,
    backgroundColor: 'transparent',
    border: "1px solid " + themeColors.ColorGraySecondary
  },
  error: {
    color: themeColors.ColorNotificationError,
    backgroundColor: themeColors.ColorNotificationErrorAlpha1
  }
};
var StyledMuiChip = styled(MuiChip, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['type', 'selected', 'loading'].includes(prop);
  }
})(function (_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type;
  return _extends({}, tagStyleByType[type], {
    '.MuiChip-icon': {
      marginLeft: 0,
      marginRight: theme.spacing(1),
      width: '20px',
      height: '20px',
      fill: tagStyleByType[type].color
    },
    '&:focus': {
      outline: "2px solid " + themeColors.ColorPrimaryBlueInteractive,
      backgroundColor: tagStyleByType[type].backgroundColor
    },
    '&.selected': {
      color: themeColors.ColorBackgroundWhite,
      backgroundColor: themeColors.ColorPrimaryBlueInteractive,
      borderColor: themeColors.ColorPrimaryBlueInteractive,
      '&:hover': {
        backgroundColor: themeColors.ColorPrimaryBlue
      },
      '.MuiChip-icon': {
        fill: themeColors.ColorBackgroundWhite
      }
    },
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    height: '24px',
    fontSize: theme.typography.FontSizeCompact,
    '.MuiChip-label': {
      paddingLeft: 0,
      paddingRight: 0
    },
    '.MuiChip-deleteIcon': {
      width: '20px',
      height: '20px',
      marginLeft: '4px',
      marginRight: 0,
      fill: tagStyleByType[type].color
    }
  });
});
var DNBTag = function DNBTag(_ref2) {
  var leadingIcon = _ref2.leadingIcon,
    type = _ref2.type,
    label = _ref2.label,
    selected = _ref2.selected,
    className = _ref2.className,
    onDelete = _ref2.onDelete,
    isLoading = _ref2.isLoading,
    loadingProgress = _ref2.loadingProgress,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$1k);
  var newLabel = label;
  if (type === 'interactive' && selected) {
    newLabel = React__default.createElement(React__default.Fragment, null, label, ' ', React__default.createElement(Check, {
      sx: {
        width: '20px',
        height: '20px',
        color: themeColors.ColorBackgroundWhite,
        verticalAlign: 'middle'
      }
    }));
  } else if (isLoading) {
    newLabel = React__default.createElement(React__default.Fragment, null, label, ' ', React__default.createElement(CircularProgress$1, {
      "aria-label": label,
      variant: loadingProgress !== undefined ? 'determinate' : 'indeterminate',
      value: loadingProgress,
      size: 14,
      sx: {
        verticalAlign: 'middle',
        marginTop: '-3px'
      }
    }));
  }
  return React__default.createElement(StyledMuiChip, Object.assign({
    className: className + " " + (selected ? 'selected' : ''),
    icon: leadingIcon,
    label: newLabel,
    type: type,
    deleteIcon: React__default.createElement(Close, {
      sx: {
        width: '20px',
        height: '20px'
      }
    })
  }, rest, {
    onKeyDown: function onKeyDown(e) {
      if (e.key === ' ' || e.key === 'Enter') {
        if (onDelete) onDelete();
      }
    },
    onDelete: onDelete
  }));
};

var _excluded$1l = ["children", "expanded", "hideBranches", "id", "onNodeToggle"];
var DNBTreeViewContext = createContext({
  hideBranches: false,
  treeStructure: null
});
var DNBTreeView = function DNBTreeView(_ref) {
  var children = _ref.children,
    expanded = _ref.expanded,
    _ref$hideBranches = _ref.hideBranches,
    hideBranches = _ref$hideBranches === void 0 ? false : _ref$hideBranches,
    id = _ref.id,
    onNodeToggle = _ref.onNodeToggle,
    treeViewProps = _objectWithoutPropertiesLoose(_ref, _excluded$1l);
  var _useState = useState(expanded != null ? expanded : []),
    expandedNodes = _useState[0],
    setExpandedNodes = _useState[1];
  var generateTreeStructure = function generateTreeStructure(children, parentId) {
    var treeNode = Children.map(children, function (child) {
      var nodeId = child.props.nodeId;
      var node = {
        nodeId: nodeId,
        parentId: parentId != null ? parentId : null,
        expanded: expandedNodes.includes(nodeId)
      };
      if (isValidElement(child) && child.props.children) {
        node.children = generateTreeStructure(child.props.children, nodeId);
      }
      return node;
    });
    return treeNode != null ? treeNode : [];
  };
  var treeStructure = generateTreeStructure(children);
  var value = useMemo(function () {
    return {
      hideBranches: hideBranches,
      treeStructure: treeStructure
    };
  }, [hideBranches, expandedNodes, treeStructure]);
  var handleNodeToggle = function handleNodeToggle(event, nodeIds) {
    setExpandedNodes(nodeIds);
    if (onNodeToggle) {
      onNodeToggle(event, nodeIds);
    }
  };
  return React__default.createElement(DNBTreeViewContext.Provider, {
    value: value
  }, React__default.createElement(TreeView, Object.assign({
    defaultCollapseIcon: React__default.createElement(KeyboardArrowUpRounded, {
      fontSize: "medium"
    }),
    defaultExpandIcon: React__default.createElement(KeyboardArrowDownRounded, {
      fontSize: "medium"
    }),
    expanded: expanded,
    id: id
  }, treeViewProps, {
    onNodeToggle: handleNodeToggle
  }), children));
};

var _excluded$1m = ["children", "labelIcon", "labelText", "nodeId", "tagProps"];
var getBracketLength = function getBracketLength(childCount) {
  if (childCount === 1) {
    return theme.spacing(5);
  } else if (childCount > 1) {
    return "calc(" + theme.spacing(10) + " * " + (childCount - 1) + " + " + theme.spacing(5) + ")";
  } else {
    return '0';
  }
};
var StyledTreeItem = styled(TreeItem, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'childCount' && prop !== 'expanded' && prop !== 'hideBranches' && prop !== 'isTopItem';
  }
})(function (_ref) {
  var theme = _ref.theme,
    _ref$childCount = _ref.childCount,
    childCount = _ref$childCount === void 0 ? 0 : _ref$childCount,
    _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? false : _ref$expanded,
    _ref$hideBranches = _ref.hideBranches,
    hideBranches = _ref$hideBranches === void 0 ? false : _ref$hideBranches;
  return {
    position: 'relative',
    '::before': {
      borderBottom: theme.borders.BorderThin,
      borderBottomColor: theme.colors.ColorGrayIncidental,
      content: '""',
      left: '-29px',
      top: theme.spacing(1),
      width: theme.spacing(6),
      height: theme.spacing(4),
      position: 'absolute',
      visibility: hideBranches ? 'hidden' : 'visible'
    },
    '&::after': {
      borderLeft: theme.borders.BorderThin,
      borderLeftColor: theme.colors.ColorGrayIncidental,
      content: '""',
      left: theme.spacing(4),
      top: theme.spacing(10),
      width: 0,
      minHeight: 0,
      height: expanded ? getBracketLength(childCount) : 0,
      position: 'absolute',
      transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      visibility: hideBranches ? 'hidden' : 'visible'
    },
    '& .MuiTreeItem-content': {
      height: theme.spacing(9),
      paddingLeft: 0,
      position: 'relative',
      marginBottom: theme.spacing(1),
      '.DNBTreeItem-topItem::before': {
        visibility: 'hidden'
      },
      '&:hover': {
        backgroundColor: 'unset',
        '& .MuiTreeItem-iconContainer': {
          backgroundColor: theme.colors.ColorGraySecondaryAlpha1
        }
      },
      '&.Mui-selected, &.Mui-selected.Mui-focused': {
        backgroundColor: 'unset',
        '& .MuiTreeItem-iconContainer': {
          backgroundColor: theme.colors.ColorGrayPrimaryAlpha2
        }
      },
      '& .MuiTreeItem-iconContainer': {
        alignItems: 'center',
        height: theme.spacing(9),
        width: theme.spacing(9),
        borderRadius: '50%',
        '& svg': {
          fontSize: theme.typography.FontSizeHeadline5
        }
      },
      '& .MuiTreeItem-label': _extends({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      }, theme.typography['compact-body'], {
        '& .MuiChip-root': {
          margin: 0
        },
        span: {
          marginLeft: theme.spacing(1)
        }
      })
    },
    '&.DNBTreeItem-topItem::before': {
      visibility: 'hidden'
    },
    '&.DNBTreeItem-noChild .MuiTreeItem-iconContainer': {
      height: '0px !important',
      width: '0px !important'
    },
    '& .MuiTreeItem-group': {
      marginLeft: 18,
      paddingLeft: theme.spacing(7)
    }
  };
});
var DNBTreeItem = function DNBTreeItem(_ref2) {
  var _currentNode$expanded;
  var children = _ref2.children,
    labelIcon = _ref2.labelIcon,
    labelText = _ref2.labelText,
    nodeId = _ref2.nodeId,
    treeItemProps = _objectWithoutPropertiesLoose(_ref2, _excluded$1m);
  var _useContext = useContext(DNBTreeViewContext),
    hideBranches = _useContext.hideBranches,
    treeStructure = _useContext.treeStructure;
  var _useState = useState(false),
    isTopItem = _useState[0],
    setIsTopItem = _useState[1];
  var _useState2 = useState(0),
    expandedChildren = _useState2[0],
    setExpandedChildren = _useState2[1];
  var itemRef = useRef(null);
  var childCount = Children.count(children);
  useEffect(function () {
    var _itemRef$current, _itemRef$current$pare;
    var parentId = (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 ? void 0 : (_itemRef$current$pare = _itemRef$current.parentElement) === null || _itemRef$current$pare === void 0 ? void 0 : _itemRef$current$pare.id;
    setIsTopItem(parentId !== '');
  }, []);
  useEffect(function () {
    if (currentNode) {
      setExpandedChildren(countExpandedNodes(currentNode));
    }
  }, [treeStructure]);
  var findNode = function findNode(tree, nodeId) {
    if (tree) {
      for (var _iterator = _createForOfIteratorHelperLoose(tree), _step; !(_step = _iterator()).done;) {
        var node = _step.value;
        if (node.nodeId === nodeId) {
          return node;
        }
        if (node.children) {
          var foundNode = findNode(node.children, nodeId);
          if (foundNode) {
            return foundNode;
          }
        }
      }
    }
    return null;
  };
  var countExpandedNodes = function countExpandedNodes(node) {
    var expanded = node.expanded,
      children = node.children;
    var count = 0;
    if (node) {
      if (expanded && children) {
        count = count + children.length;
      }
      if (children) {
        for (var _iterator2 = _createForOfIteratorHelperLoose(children.entries()), _step2; !(_step2 = _iterator2()).done;) {
          var _step2$value = _step2.value,
            index = _step2$value[0],
            child = _step2$value[1];
          if (index !== children.length - 1) {
            count += countExpandedNodes(child);
          }
        }
      }
      return count;
    }
    return 0;
  };
  var currentNode = findNode(treeStructure, nodeId);
  return React__default.createElement(StyledTreeItem, Object.assign({
    nodeId: nodeId,
    childCount: expandedChildren,
    className: (isTopItem ? 'DNBTreeItem-topItem' : '') + " " + (childCount === 0 ? 'DNBTreeItem-noChild' : ''),
    expanded: (_currentNode$expanded = currentNode === null || currentNode === void 0 ? void 0 : currentNode.expanded) != null ? _currentNode$expanded : false,
    hideBranches: hideBranches,
    isTopItem: isTopItem,
    label: React__default.createElement(Fragment$1, null, labelIcon, React__default.createElement("span", null, labelText))
  }, treeItemProps, {
    ref: itemRef
  }), children);
};

LicenseInfo.setLicenseKey('55ffcac6fba84330fdd94774eab50c40Tz05MzE1NCxFPTE3NTA5NDc5NzMwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y');
var DNBThemeProvider = function DNBThemeProvider(_ref) {
  var children = _ref.children;
  return React__default.createElement(ThemeProvider, {
    theme: theme
  }, React__default.createElement(CssBaseline, null), children);
};

export { DNBAccordion, DNBAppBar, DNBAppBarLogoContainer, DNBAppBarSystemFunctions, DNBAppBarTabs, DNBAutocomplete, DNBBadge, DNBBanner, DNBBreadcrumbs, DNBButton, DNBButtonGroup, DNBCard, DNBCheckbox, DNBCheckboxGroup, DNBChoroplethMap, DNBColumnChooser, DNBColumnMenu, DNBDataTable, DNBDataTableCheckbox, DNBDataTablePanel, DNBDataTableToolbar, DNBDatePicker, DNBDateRangePicker, DNBDialog, DNBDialogTitle, DNBDivider, DNBDrawer, DNBIconButton, DNBInputLabel, DNBLink, DNBLoader, DNBMenu, DNBMenuItem, DNBMobileDrawer, DNBMultiSelect, DNBMultiSelectMenu, DNBPopover, DNBRadio, DNBRadioGroup, DNBSelect, DNBSelectOption, DNBDrawerSideNavigation as DNBSideNavigationDrawer, DNBDrawerSideNavigationBody as DNBSideNavigationDrawerBody, DNBDrawerSideNavigationItem as DNBSideNavigationDrawerItem, DNBSkeleton, DNBSlider, DNBSnackbar, DNBStepper, DNBTab, DNBTablePagination, DNBTabs, DNBTag, DNBTextField, DNBThemeProvider, DNBToggle, DNBToggleButton, DNBToggleButtonGroup, DNBTooltip, DNBTopNavigationBar, DNBTreeItem, DNBTreeView, DNBTreeViewContext, DNBTypography, SortIndeterminateIcon, getDNBDialogSizes, getHeaderLabels, theme, truncateCount };
//# sourceMappingURL=index.modern.js.map
